import { __decorate, __metadata, __values, __param, __read, __extends, __assign, __spread } from 'tslib';
import { ElementRef, Renderer2, Input, HostBinding, Directive, NgModule, TemplateRef, InjectionToken, Injector, ChangeDetectorRef, Injectable, ContentChildren, QueryList, Component, ChangeDetectionStrategy, ViewEncapsulation, ViewChild, ViewContainerRef, HostListener, Host, Inject, forwardRef, ContentChild, EventEmitter, NgZone, Optional, PLATFORM_ID, Output, isDevMode, ɵɵdefineInjectable, ɵɵinject, LOCALE_ID, Self, Attribute, Pipe, SkipSelf, ɵivyEnabled, ApplicationRef, ComponentFactoryResolver, INJECTOR } from '@angular/core';
import { CommonModule, isPlatformBrowser, getLocaleDayNames, FormStyle, TranslationWidth, getLocaleMonthNames, getLocaleFirstDayOfWeek, getLocaleDayPeriods, formatDate } from '@angular/common';
import { isObservable, Subject, EMPTY as EMPTY$1, defer, Observable, merge, of, combineLatest, fromEvent, BehaviorSubject, ReplaySubject, Subscription } from 'rxjs';
import { trigger, transition, query, animateChild, style, animate, group, state, keyframes } from '@angular/animations';
import { createPopper } from '@popperjs/core';
import { NG_VALUE_ACCESSOR, FormsModule, NgControl, NG_VALIDATORS, NgModel } from '@angular/forms';
import { map, skip, distinctUntilChanged, debounceTime, startWith, sampleTime, pairwise, filter, switchMap, auditTime, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/router';
import * as ɵngcc3 from '@angular/forms';
import * as ɵngcc4 from '@angular/platform-browser';

function BreadcrumbsComponent_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 10);
    ɵngcc0.ɵɵelementContainer(2, 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 8);
    ɵngcc0.ɵɵtext(4, "/");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var breadcrumb_r6 = ctx.$implicit;
    var index_r7 = ctx.index;
    var ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cdsBreadcrumbObserve", ctx_r4.intersection);
    ɵngcc0.ɵɵattribute("data-index", index_r7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", breadcrumb_r6.template);
} }
function BreadcrumbsComponent_div_1_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 7);
    ɵngcc0.ɵɵelementContainer(1, 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r5.firstBreadcrumb.template);
} }
function BreadcrumbsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵtemplate(1, BreadcrumbsComponent_div_1_ng_container_1_Template, 5, 3, "ng-container", 5);
    ɵngcc0.ɵɵelementStart(2, "span", 7);
    ɵngcc0.ɵɵtext(3, "...");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "span", 8);
    ɵngcc0.ɵɵtext(5, "/");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, BreadcrumbsComponent_div_1_span_6_Template, 2, 1, "span", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.restBreadcrumbs);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.firstBreadcrumb);
} }
function BreadcrumbsComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 12);
    ɵngcc0.ɵɵelementContainer(1, 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.firstBreadcrumb.template);
} }
function BreadcrumbsComponent_ng_container_4_cds_dropdown_7_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementContainer(1, 11);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var breadcrumb_r11 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", breadcrumb_r11.template);
} }
function BreadcrumbsComponent_ng_container_4_cds_dropdown_7_Template(rf, ctx) { if (rf & 1) {
    var _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "cds-dropdown", 17);
    ɵngcc0.ɵɵlistener("dismiss", function BreadcrumbsComponent_ng_container_4_cds_dropdown_7_Template_cds_dropdown_dismiss_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); var ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.changeDropdown(false); });
    ɵngcc0.ɵɵelementStart(1, "span", 18);
    ɵngcc0.ɵɵlistener("click", function BreadcrumbsComponent_ng_container_4_cds_dropdown_7_Template_span_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r13); var ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.changeDropdown(false); });
    ɵngcc0.ɵɵtemplate(2, BreadcrumbsComponent_ng_container_4_cds_dropdown_7_ng_container_2_Template, 2, 1, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    var _r8 = ɵngcc0.ɵɵreference(5);
    var ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("anchor", _r8);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("id", ctx_r9.dropdownId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r9.collapsedBreadcrumbs);
} }
function BreadcrumbsComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    var _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 13);
    ɵngcc0.ɵɵtext(2, "/");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 7);
    ɵngcc0.ɵɵelementStart(4, "button", 14, 15);
    ɵngcc0.ɵɵlistener("click", function BreadcrumbsComponent_ng_container_4_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r16); var ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.changeDropdown(true); });
    ɵngcc0.ɵɵtext(6, "...");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, BreadcrumbsComponent_ng_container_4_cds_dropdown_7_Template, 3, 3, "cds-dropdown", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵattribute("aria-expanded", ctx_r2.isOpen ? "true" : "false")("aria-controls", ctx_r2.dropdownId)("aria-label", ctx_r2.translations.collapsedLinks);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.isOpen);
} }
function BreadcrumbsComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 13);
    ɵngcc0.ɵɵtext(2, "/");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 12);
    ɵngcc0.ɵɵelementContainer(4, 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var breadcrumb_r17 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", breadcrumb_r17.template);
} }
var _c0 = ["template"];
function PortalComponent_ng_template_0_Template(rf, ctx) { }
var _c1 = ["expand"];
var _c2 = ["*"];
var _c3 = [[["", "cdsButton", ""]]];
var _c4 = ["[cdsButton]"];
function CheckboxComponent__svg_path_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(0, "path", 8);
} }
function CheckboxComponent__svg_line_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(0, "line", 9);
} }
function CheckboxComponent_label_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementStart(0, "label");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("id", ctx_r2.labelId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.label);
} }
function ChipComponent_a_2_Template(rf, ctx) { if (rf & 1) {
    var _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 1);
    ɵngcc0.ɵɵlistener("click", function ChipComponent_a_2_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); var ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.onClose($event); });
    ɵngcc0.ɵɵelementEnd();
} }
var _c5 = ["input"];
function InputComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("id", !ctx_r0.ariaLabelledBy ? ctx_r0.labelId : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.labelValue);
} }
function InputComponent_a_7_Template(rf, ctx) { if (rf & 1) {
    var _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 9);
    ɵngcc0.ɵɵlistener("click", function InputComponent_a_7_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); var ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.clear(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("cds-input__reset--hidden", !ctx_r2.value && !ctx_r2.chip)("cds-input__reset--invisible", !ctx_r2.value && ctx_r2.chip);
} }
function InputComponent_button_9_Template(rf, ctx) { if (rf & 1) {
    var _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 10);
    ɵngcc0.ɵɵlistener("click", function InputComponent_button_9_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.submitSearch($event); })("mouseenter", function InputComponent_button_9_Template_button_mouseenter_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.preventHover = true; })("mouseleave", function InputComponent_button_9_Template_button_mouseleave_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.preventHover = false; })("focus", function InputComponent_button_9_Template_button_focus_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.isSearchIconFocused = true; })("blur", function InputComponent_button_9_Template_button_blur_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.isSearchIconFocused = false; });
    ɵngcc0.ɵɵelement(1, "i", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("aria-hidden", ctx_r3.searchButton === true || null)("aria-label", ctx_r3.searchButton !== true ? ctx_r3.searchButton : null);
} }
var _c6 = [[["i", 8, "cds-icon--placement-before"], ["a", 8, "cds-icon--placement-before"]], [["cds-chip"]], [["i", 9, "cds-icon--placement-before"], ["a", 9, "cds-icon--placement-before"]]];
var _c7 = ["i.cds-icon--placement-before,a.cds-icon--placement-before", "cds-chip", "i:not(.cds-icon--placement-before),a:not(.cds-icon--placement-before)"];
var _c8 = ["searchInline"];
var _c9 = ["searchInside"];
var _c10 = ["cdsComboItemAll", ""];
function ComboItemAllComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.translations.selectAll);
} }
function ComboItemAllComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.translations.unselectAll);
} }
var _c11 = ["checkbox"];
var _c12 = ["cdsComboCheckboxItem", ""];
var _c13 = ["cdsComboCheckboxItemAll", ""];
var _c14 = ["dropdown"];
function ComboMultiComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function ComboMultiComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 1);
} }
function ComboMultiComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.labelValue);
} }
function ComboMultiComponent_div_10_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ComboMultiComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵtemplate(2, ComboMultiComponent_div_10_ng_container_2_Template, 1, 0, "ng-container", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    var _r0 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
} }
function ComboMultiComponent_ng_template_11_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ComboMultiComponent_ng_template_11_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    var _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "cds-chip", 17);
    ɵngcc0.ɵɵlistener("remove", function ComboMultiComponent_ng_template_11_ng_container_0_Template_cds_chip_remove_1_listener() { ɵngcc0.ɵɵrestoreView(_r18); var ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.clear(); });
    ɵngcc0.ɵɵtemplate(2, ComboMultiComponent_ng_template_11_ng_container_0_ng_container_2_Template, 1, 0, "ng-container", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext(2);
    var _r3 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", true)("uncheckable", false)("removable", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ComboMultiComponent_ng_template_11_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ComboMultiComponent_ng_template_11_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵtemplate(1, ComboMultiComponent_ng_template_11_div_1_ng_container_1_Template, 1, 0, "ng-container", 13);
    ɵngcc0.ɵɵtext(2, "\u200B ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext(2);
    var _r3 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ComboMultiComponent_ng_template_11_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r14.placeholder, " ");
} }
function ComboMultiComponent_ng_template_11_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵprojection(1, 2);
    ɵngcc0.ɵɵtext(2, "\u200B ");
    ɵngcc0.ɵɵelementEnd();
} }
function ComboMultiComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, ComboMultiComponent_ng_template_11_ng_container_0_Template, 3, 4, "ng-container", 14);
    ɵngcc0.ɵɵtemplate(1, ComboMultiComponent_ng_template_11_div_1_Template, 3, 1, "div", 15);
    ɵngcc0.ɵɵtemplate(2, ComboMultiComponent_ng_template_11_div_2_Template, 2, 1, "div", 16);
    ɵngcc0.ɵɵtemplate(3, ComboMultiComponent_ng_template_11_div_3_Template, 3, 0, "div", 16);
} if (rf & 2) {
    var ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.chips && ctx_r8.selectedCount !== 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r8.chips && ctx_r8.selectedCount !== 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.placeholder && ctx_r8.selectedCount === 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r8.placeholder && ctx_r8.selectedCount === 0);
} }
function ComboMultiComponent_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    var _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "input", 20, 21);
    ɵngcc0.ɵɵlistener("ngModelChange", function ComboMultiComponent_ng_container_13_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); var ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.search$.next($event); })("keydown.enter", function ComboMultiComponent_ng_container_13_Template_input_keydown_enter_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); return $event.preventDefault(); })("blur", function ComboMultiComponent_ng_container_13_Template_input_blur_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); var ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.onSearchFieldBlur($event.relatedTarget); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r9.search);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r9.inputLabel || ctx_r9.translations.inputLabel);
} }
function ComboMultiComponent_cds_dropdown_14_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 3);
} }
function ComboMultiComponent_cds_dropdown_14_ng_template_4_div_0_Template(rf, ctx) { if (rf & 1) {
    var _r35 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 27);
    ɵngcc0.ɵɵelementStart(1, "cds-input", 28, 29);
    ɵngcc0.ɵɵlistener("ngModelChange", function ComboMultiComponent_cds_dropdown_14_ng_template_4_div_0_Template_cds_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r35); var ctx_r34 = ɵngcc0.ɵɵnextContext(3); return ctx_r34.search$.next($event); })("keydown.enter", function ComboMultiComponent_cds_dropdown_14_ng_template_4_div_0_Template_cds_input_keydown_enter_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r35); return $event.preventDefault(); })("blur", function ComboMultiComponent_cds_dropdown_14_ng_template_4_div_0_Template_cds_input_blur_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r35); var ctx_r37 = ɵngcc0.ɵɵnextContext(3); return ctx_r37.onSearchFieldBlur($event.detail.relatedTarget); });
    ɵngcc0.ɵɵelement(3, "i", 30);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r31 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("cdsDropdownDisableKeydown", ctx_r31.disableKeydown);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("resettable", true)("ngModel", ctx_r31.search)("ariaLabel", ctx_r31.inputLabel || ctx_r31.translations.inputLabel);
} }
function ComboMultiComponent_cds_dropdown_14_ng_template_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ComboMultiComponent_cds_dropdown_14_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, ComboMultiComponent_cds_dropdown_14_ng_template_4_div_0_Template, 4, 4, "div", 26);
    ɵngcc0.ɵɵtemplate(1, ComboMultiComponent_cds_dropdown_14_ng_template_4_ng_container_1_Template, 1, 0, "ng-container", 13);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    var _r26 = ɵngcc0.ɵɵreference(3);
    var ctx_r29 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r29.withSearchInside);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r26);
} }
function ComboMultiComponent_cds_dropdown_14_ng_container_6_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ComboMultiComponent_cds_dropdown_14_ng_container_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    var _r41 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 31);
    ɵngcc0.ɵɵtemplate(2, ComboMultiComponent_cds_dropdown_14_ng_container_6_ng_container_1_ng_container_2_Template, 1, 0, "ng-container", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 32);
    ɵngcc0.ɵɵelementStart(4, "button", 33);
    ɵngcc0.ɵɵlistener("click", function ComboMultiComponent_cds_dropdown_14_ng_container_6_ng_container_1_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r41); var ctx_r40 = ɵngcc0.ɵɵnextContext(3); return ctx_r40.resetChanges(); });
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "button", 33);
    ɵngcc0.ɵɵlistener("click", function ComboMultiComponent_cds_dropdown_14_ng_container_6_ng_container_1_Template_button_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r41); var ctx_r42 = ɵngcc0.ɵɵnextContext(3); return ctx_r42.confirmChanges(); });
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext(2);
    var _r28 = ɵngcc0.ɵɵreference(5);
    var ctx_r38 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r28);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r38.translations.reset);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r38.translations.confirm);
} }
function ComboMultiComponent_cds_dropdown_14_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ComboMultiComponent_cds_dropdown_14_ng_container_6_ng_container_1_Template, 8, 3, "ng-container", 9);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    var _r28 = ɵngcc0.ɵɵreference(5);
    var ctx_r30 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r30.confirmButtons)("ngIfElse", _r28);
} }
var _c15 = function () { return ["li.active", "li"]; };
function ComboMultiComponent_cds_dropdown_14_Template(rf, ctx) { if (rf & 1) {
    var _r44 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "cds-dropdown", 22, 23);
    ɵngcc0.ɵɵlistener("dismiss", function ComboMultiComponent_cds_dropdown_14_Template_cds_dropdown_dismiss_0_listener() { ɵngcc0.ɵɵrestoreView(_r44); var ctx_r43 = ɵngcc0.ɵɵnextContext(); return ctx_r43.onOpenChange(false); })("click", function ComboMultiComponent_cds_dropdown_14_Template_cds_dropdown_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r44); var ctx_r45 = ɵngcc0.ɵɵnextContext(); return ctx_r45.onDropdownClick($event); })("keydown", function ComboMultiComponent_cds_dropdown_14_Template_cds_dropdown_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r44); var ctx_r46 = ɵngcc0.ɵɵnextContext(); return ctx_r46.onDropdownKey($event); });
    ɵngcc0.ɵɵtemplate(2, ComboMultiComponent_cds_dropdown_14_ng_template_2_Template, 1, 0, "ng-template", null, 24, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(4, ComboMultiComponent_cds_dropdown_14_ng_template_4_Template, 2, 2, "ng-template", null, 25, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(6, ComboMultiComponent_cds_dropdown_14_ng_container_6_Template, 2, 2, "ng-container", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var _r26 = ɵngcc0.ɵɵreference(3);
    var ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("cds-dropdown--auto-height", ctx_r10.confirmButtons);
    ɵngcc0.ɵɵproperty("anchor", ctx_r10.elementRef)("initialFocus", !ctx_r10.withSearchInside && !ctx_r10.withSearchInline ? ctx_r10.focusActive ? ɵngcc0.ɵɵpureFunction0(6, _c15) : "li" : null);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r10.confirmButtons || ctx_r10.withSearchInside)("ngIfElse", _r26);
} }
var _c16 = [[["label", "title", ""]], [["label", 3, "default", "", 3, "title", ""]], [["label", "default", ""], ["label", "all", ""]], [["ul"]]];
var _c17 = ["label[title]", "label:not([default]):not([title])", "label[default],label[all]", "ul"];
var _c18 = ["cdsComboMultiSelectedLabel", ""];
function ComboMultiSelectedLabelComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 2);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.titleLabel);
} }
function ComboMultiSelectedLabelComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.allLabel);
} }
function ComboMultiSelectedLabelComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.combo.selectedLabel);
} }
function ComboMultiSelectedLabelComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate3("", ctx_r3.translations.selected, ": ", ctx_r3.combo.selectedCount, " / ", ctx_r3.combo.totalCount, "");
} }
function ComboComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function ComboComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 1);
} }
function ComboComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.labelValue);
} }
function ComboComponent_div_10_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ComboComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵtemplate(2, ComboComponent_div_10_ng_container_2_Template, 1, 0, "ng-container", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    var _r0 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0);
} }
function ComboComponent_ng_template_11_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ComboComponent_ng_template_11_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    var _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "cds-chip", 17);
    ɵngcc0.ɵɵlistener("remove", function ComboComponent_ng_template_11_ng_container_0_Template_cds_chip_remove_1_listener() { ɵngcc0.ɵɵrestoreView(_r18); var ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.clear(); });
    ɵngcc0.ɵɵtemplate(2, ComboComponent_ng_template_11_ng_container_0_ng_container_2_Template, 1, 0, "ng-container", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext(2);
    var _r3 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", true)("uncheckable", false)("removable", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ComboComponent_ng_template_11_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ComboComponent_ng_template_11_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵtemplate(1, ComboComponent_ng_template_11_div_1_ng_container_1_Template, 1, 0, "ng-container", 13);
    ɵngcc0.ɵɵtext(2, "\u200B ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext(2);
    var _r3 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ComboComponent_ng_template_11_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r14.placeholder, " ");
} }
function ComboComponent_ng_template_11_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵprojection(1, 2);
    ɵngcc0.ɵɵtext(2, "\u200B ");
    ɵngcc0.ɵɵelementEnd();
} }
function ComboComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, ComboComponent_ng_template_11_ng_container_0_Template, 3, 4, "ng-container", 14);
    ɵngcc0.ɵɵtemplate(1, ComboComponent_ng_template_11_div_1_Template, 3, 1, "div", 15);
    ɵngcc0.ɵɵtemplate(2, ComboComponent_ng_template_11_div_2_Template, 2, 1, "div", 16);
    ɵngcc0.ɵɵtemplate(3, ComboComponent_ng_template_11_div_3_Template, 3, 0, "div", 16);
} if (rf & 2) {
    var ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.chips && ctx_r8.selectedCount !== 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r8.chips && ctx_r8.selectedCount !== 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.placeholder && ctx_r8.selectedCount === 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r8.placeholder && ctx_r8.selectedCount === 0);
} }
function ComboComponent_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    var _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "input", 20, 21);
    ɵngcc0.ɵɵlistener("ngModelChange", function ComboComponent_ng_container_13_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); var ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.search$.next($event); })("keydown.enter", function ComboComponent_ng_container_13_Template_input_keydown_enter_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); return $event.preventDefault(); })("blur", function ComboComponent_ng_container_13_Template_input_blur_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); var ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.onSearchFieldBlur($event.relatedTarget); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r9.search);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r9.inputLabel || ctx_r9.translations.inputLabel);
} }
function ComboComponent_cds_dropdown_14_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 3);
} }
function ComboComponent_cds_dropdown_14_ng_template_4_div_0_Template(rf, ctx) { if (rf & 1) {
    var _r35 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 27);
    ɵngcc0.ɵɵelementStart(1, "cds-input", 28, 29);
    ɵngcc0.ɵɵlistener("ngModelChange", function ComboComponent_cds_dropdown_14_ng_template_4_div_0_Template_cds_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r35); var ctx_r34 = ɵngcc0.ɵɵnextContext(3); return ctx_r34.search$.next($event); })("keydown.enter", function ComboComponent_cds_dropdown_14_ng_template_4_div_0_Template_cds_input_keydown_enter_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r35); return $event.preventDefault(); })("blur", function ComboComponent_cds_dropdown_14_ng_template_4_div_0_Template_cds_input_blur_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r35); var ctx_r37 = ɵngcc0.ɵɵnextContext(3); return ctx_r37.onSearchFieldBlur($event.detail.relatedTarget); });
    ɵngcc0.ɵɵelement(3, "i", 30);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r31 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("cdsDropdownDisableKeydown", ctx_r31.disableKeydown);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("resettable", true)("ngModel", ctx_r31.search)("ariaLabel", ctx_r31.inputLabel || ctx_r31.translations.inputLabel);
} }
function ComboComponent_cds_dropdown_14_ng_template_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ComboComponent_cds_dropdown_14_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, ComboComponent_cds_dropdown_14_ng_template_4_div_0_Template, 4, 4, "div", 26);
    ɵngcc0.ɵɵtemplate(1, ComboComponent_cds_dropdown_14_ng_template_4_ng_container_1_Template, 1, 0, "ng-container", 13);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    var _r26 = ɵngcc0.ɵɵreference(3);
    var ctx_r29 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r29.withSearchInside);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r26);
} }
function ComboComponent_cds_dropdown_14_ng_container_6_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ComboComponent_cds_dropdown_14_ng_container_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    var _r41 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 31);
    ɵngcc0.ɵɵtemplate(2, ComboComponent_cds_dropdown_14_ng_container_6_ng_container_1_ng_container_2_Template, 1, 0, "ng-container", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 32);
    ɵngcc0.ɵɵelementStart(4, "button", 33);
    ɵngcc0.ɵɵlistener("click", function ComboComponent_cds_dropdown_14_ng_container_6_ng_container_1_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r41); var ctx_r40 = ɵngcc0.ɵɵnextContext(3); return ctx_r40.resetChanges(); });
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "button", 33);
    ɵngcc0.ɵɵlistener("click", function ComboComponent_cds_dropdown_14_ng_container_6_ng_container_1_Template_button_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r41); var ctx_r42 = ɵngcc0.ɵɵnextContext(3); return ctx_r42.confirmChanges(); });
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext(2);
    var _r28 = ɵngcc0.ɵɵreference(5);
    var ctx_r38 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r28);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r38.translations.reset);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r38.translations.confirm);
} }
function ComboComponent_cds_dropdown_14_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ComboComponent_cds_dropdown_14_ng_container_6_ng_container_1_Template, 8, 3, "ng-container", 9);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    var _r28 = ɵngcc0.ɵɵreference(5);
    var ctx_r30 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r30.confirmButtons)("ngIfElse", _r28);
} }
function ComboComponent_cds_dropdown_14_Template(rf, ctx) { if (rf & 1) {
    var _r44 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "cds-dropdown", 22, 23);
    ɵngcc0.ɵɵlistener("dismiss", function ComboComponent_cds_dropdown_14_Template_cds_dropdown_dismiss_0_listener() { ɵngcc0.ɵɵrestoreView(_r44); var ctx_r43 = ɵngcc0.ɵɵnextContext(); return ctx_r43.onOpenChange(false); })("click", function ComboComponent_cds_dropdown_14_Template_cds_dropdown_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r44); var ctx_r45 = ɵngcc0.ɵɵnextContext(); return ctx_r45.onDropdownClick($event); })("keydown", function ComboComponent_cds_dropdown_14_Template_cds_dropdown_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r44); var ctx_r46 = ɵngcc0.ɵɵnextContext(); return ctx_r46.onDropdownKey($event); });
    ɵngcc0.ɵɵtemplate(2, ComboComponent_cds_dropdown_14_ng_template_2_Template, 1, 0, "ng-template", null, 24, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(4, ComboComponent_cds_dropdown_14_ng_template_4_Template, 2, 2, "ng-template", null, 25, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(6, ComboComponent_cds_dropdown_14_ng_container_6_Template, 2, 2, "ng-container", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var _r26 = ɵngcc0.ɵɵreference(3);
    var ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("cds-dropdown--auto-height", ctx_r10.confirmButtons);
    ɵngcc0.ɵɵproperty("anchor", ctx_r10.elementRef)("initialFocus", !ctx_r10.withSearchInside && !ctx_r10.withSearchInline ? ctx_r10.focusActive ? ɵngcc0.ɵɵpureFunction0(6, _c15) : "li" : null);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r10.confirmButtons || ctx_r10.withSearchInside)("ngIfElse", _r26);
} }
function DialogComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    var _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 5);
    ɵngcc0.ɵɵlistener("click", function DialogComponent_ng_container_5_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r2); var ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.dialogClose.emit(); });
    ɵngcc0.ɵɵelement(2, "i", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.schema === "dark" ? "cds-button-icon-dark" : "cds-button-icon");
    ɵngcc0.ɵɵattribute("aria-label", ctx_r0.translations.close);
} }
var _c19 = [[["header"], ["cds-slot-title"]], [["", 5, "header", 5, "cds-slot-title"]]];
var _c20 = ["header,cds-slot-title", ":not(header):not(cds-slot-title)"];
var _c21 = ["messageWrapper"];
var _c22 = ["message"];
var _c23 = ["intersectionLeft"];
var _c24 = ["intersectionRight"];
function ErrorsComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.translations.dateInvalidMessage);
} }
function ErrorsComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "cdsErrorInterpolate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var error_r17 = ctx.$implicit;
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(2, 1, ctx_r4.translations.dateFromMessage, error_r17.from));
} }
function ErrorsComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "cdsErrorInterpolate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var error_r18 = ctx.$implicit;
    var ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(2, 1, ctx_r5.translations.dateToMessage, error_r18.to));
} }
function ErrorsComponent_span_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.translations.dateDisableWeekendsMessage);
} }
function ErrorsComponent_span_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.translations.dateAllowedDaysMessage);
} }
function ErrorsComponent_span_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r8.translations.dateTimeStepsMessage);
} }
function ErrorsComponent_span_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "cdsErrorInterpolate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var error_r22 = ctx.$implicit;
    var ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind3(2, 1, ctx_r9.translations.dateTimeRangeMessage, error_r22.from, error_r22.to));
} }
function ErrorsComponent_span_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r10.translations.dateTimeTimezoneMessage);
} }
function ErrorsComponent_ng_container_15_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var error_r24 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(error_r24.messageText);
} }
function ErrorsComponent_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ErrorsComponent_ng_container_15_span_1_Template, 2, 1, "span", 9);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var error_r24 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", error_r24.messageText);
} }
var _c25 = function (a0) { return { template: a0, placement: "right-start" }; };
function ErrorsComponent_button_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r13 = ɵngcc0.ɵɵnextContext();
    var _r14 = ɵngcc0.ɵɵreference(20);
    ɵngcc0.ɵɵclassProp("cds-errors__more--hidden", ctx_r13.moreButtonHidden);
    ɵngcc0.ɵɵproperty("cdsTooltipClick", ɵngcc0.ɵɵpureFunction1(5, _c25, _r14));
    ɵngcc0.ɵɵattribute("aria-describedby", ctx_r13.messageId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r13.translations.more, "\n");
} }
function ErrorsComponent_ng_template_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "cds-tooltip", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r15 = ɵngcc0.ɵɵnextContext();
    var _r1 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("arrow", true);
    ɵngcc0.ɵɵattribute("id", ctx_r15.messageId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", _r1.innerText, " ");
} }
var _c26 = ["hours"];
var _c27 = ["minutes"];
var _c28 = ["seconds"];
function TimePickerComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "number");
    ɵngcc0.ɵɵpipe(3, "number");
    ɵngcc0.ɵɵpipe(4, "number");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("id", ctx_r0.pickerId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate3("", ɵngcc0.ɵɵpipeBind2(2, 4, ctx_r0.selectedHour, "2.0-0"), ":", ɵngcc0.ɵɵpipeBind2(3, 7, ctx_r0.selectedMinute, "2.0-0"), ":", ɵngcc0.ɵɵpipeBind2(4, 10, ctx_r0.selectedSecond, "2.0-0"), "");
} }
function TimePickerComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    var _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 8);
    ɵngcc0.ɵɵlistener("click", function TimePickerComponent_span_7_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); var hour_r5 = ctx.$implicit; var ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.isDisabled(hour_r5, "hours") || ctx_r7.selectItem(hour_r5, "hours", hour_r5 > ctx_r7.selectedHour); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "number");
    ɵngcc0.ɵɵpipe(3, "cdsTimePickerDisplayHour");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var hour_r5 = ctx.$implicit;
    var index_r6 = ctx.index;
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("cds-time-picker__item--selected", index_r6 === 2 && ctx_r2.selectedHour === hour_r5)("cds-time-picker__item--disabled", ctx_r2.isDisabled(hour_r5, "hours"));
    ɵngcc0.ɵɵattribute("id", index_r6 === 2 && ctx_r2.selectedHour === hour_r5 ? ctx_r2.hourValueId : null)("aria-selected", index_r6 === 2 && ctx_r2.selectedHour === hour_r5)("aria-disabled", ctx_r2.isDisabled(hour_r5, "hours") ? "true" : null)("aria-hidden", hour_r5 === -1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(hour_r5 === -1 ? "--" : ɵngcc0.ɵɵpipeBind2(2, 9, ɵngcc0.ɵɵpipeBind2(3, 12, hour_r5, ctx_r2.useDayPeriod), "2.0-0"));
} }
function TimePickerComponent_ng_container_10_span_9_Template(rf, ctx) { if (rf & 1) {
    var _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 8);
    ɵngcc0.ɵɵlistener("click", function TimePickerComponent_ng_container_10_span_9_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); var minute_r11 = ctx.$implicit; var ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.isDisabled(minute_r11, "minutes") || ctx_r13.selectItem(minute_r11, "minutes", minute_r11 > ctx_r13.selectedMinute); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "number");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var minute_r11 = ctx.$implicit;
    var index_r12 = ctx.index;
    var ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("cds-time-picker__item--selected", index_r12 === 2 && ctx_r10.selectedMinute === minute_r11)("cds-time-picker__item--disabled", ctx_r10.isDisabled(minute_r11, "minutes"));
    ɵngcc0.ɵɵattribute("id", index_r12 === 2 && ctx_r10.selectedMinute === minute_r11 ? ctx_r10.minuteValueId : null)("aria-selected", index_r12 === 2 && ctx_r10.selectedMinute === minute_r11)("aria-disabled", ctx_r10.isDisabled(minute_r11, "minutes") ? "true" : null)("aria-hidden", minute_r11 === -1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(minute_r11 === -1 ? "--" : ɵngcc0.ɵɵpipeBind2(2, 9, minute_r11, "2.0-0"));
} }
function TimePickerComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    var _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵtext(2, ":");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 10, 11);
    ɵngcc0.ɵɵelementStart(5, "div", 3);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "span", 4);
    ɵngcc0.ɵɵlistener("click", function TimePickerComponent_ng_container_10_Template_span_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r16); var ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.prev("minutes"); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div");
    ɵngcc0.ɵɵtemplate(9, TimePickerComponent_ng_container_10_span_9_Template, 3, 12, "span", 5);
    ɵngcc0.ɵɵpipe(10, "cdsTimePicker");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "span", 6);
    ɵngcc0.ɵɵlistener("click", function TimePickerComponent_ng_container_10_Template_span_click_11_listener() { ɵngcc0.ɵɵrestoreView(_r16); var ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.next("minutes"); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵattribute("tabindex", ctx_r3.disabled ? "-1" : "0")("aria-disabled", ctx_r3.disabled ? "true" : null)("aria-labelledby", ctx_r3.pickerId + " " + ctx_r3.minuteLabelId);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("id", ctx_r3.minuteLabelId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.translations.selectMinute);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind3(10, 7, ctx_r3.minutesList, ctx_r3.selectedMinute, ctx_r3.constraints.timeFromMinute))("ngForTrackBy", ctx_r3.trackByIdentity);
} }
function TimePickerComponent_ng_container_11_span_9_Template(rf, ctx) { if (rf & 1) {
    var _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 8);
    ɵngcc0.ɵɵlistener("click", function TimePickerComponent_ng_container_11_span_9_Template_span_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r23); var second_r20 = ctx.$implicit; var ctx_r22 = ɵngcc0.ɵɵnextContext(2); return ctx_r22.isDisabled(second_r20, "seconds") || ctx_r22.selectItem(second_r20, "seconds", second_r20 > ctx_r22.selectedSecond); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "number");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var second_r20 = ctx.$implicit;
    var index_r21 = ctx.index;
    var ctx_r19 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("cds-time-picker__item--selected", index_r21 === 2 && ctx_r19.selectedSecond === second_r20)("cds-time-picker__item--disabled", ctx_r19.isDisabled(second_r20, "seconds"));
    ɵngcc0.ɵɵattribute("id", index_r21 === 2 && ctx_r19.selectedSecond === second_r20 ? ctx_r19.secondValueId : null)("aria-selected", index_r21 === 2 && ctx_r19.selectedSecond === second_r20)("aria-disabled", ctx_r19.isDisabled(second_r20, "seconds") ? "true" : null)("aria-hidden", second_r20 === -1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(second_r20 === -1 ? "--" : ɵngcc0.ɵɵpipeBind2(2, 9, second_r20, "2.0-0"));
} }
function TimePickerComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    var _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵtext(2, ":");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 12, 13);
    ɵngcc0.ɵɵelementStart(5, "div", 3);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "span", 4);
    ɵngcc0.ɵɵlistener("click", function TimePickerComponent_ng_container_11_Template_span_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r25); var ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.prev("seconds"); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div");
    ɵngcc0.ɵɵtemplate(9, TimePickerComponent_ng_container_11_span_9_Template, 3, 12, "span", 5);
    ɵngcc0.ɵɵpipe(10, "cdsTimePicker");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "span", 6);
    ɵngcc0.ɵɵlistener("click", function TimePickerComponent_ng_container_11_Template_span_click_11_listener() { ɵngcc0.ɵɵrestoreView(_r25); var ctx_r26 = ɵngcc0.ɵɵnextContext(); return ctx_r26.next("seconds"); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵattribute("tabindex", ctx_r4.disabled ? "-1" : "0")("aria-disabled", ctx_r4.disabled ? "true" : null)("aria-labelledby", ctx_r4.pickerId + " " + ctx_r4.secondLabelId);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("id", ctx_r4.secondLabelId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.translations.selectSecond);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind3(10, 7, ctx_r4.secondsList, ctx_r4.selectedSecond, ctx_r4.constraints.timeFromSecond))("ngForTrackBy", ctx_r4.trackByIdentity);
} }
function DateControlComponent_cds_dropdown_3_Template(rf, ctx) { if (rf & 1) {
    var _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "cds-dropdown", 3, 4);
    ɵngcc0.ɵɵlistener("dismiss", function DateControlComponent_cds_dropdown_3_Template_cds_dropdown_dismiss_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); var ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onOpenChange(false); });
    ɵngcc0.ɵɵelementStart(2, "div", 5);
    ɵngcc0.ɵɵelementStart(3, "div", 6);
    ɵngcc0.ɵɵelementStart(4, "cds-calendar-range", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function DateControlComponent_cds_dropdown_3_Template_cds_calendar_range_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); var ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.changeCalendarValue($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 8);
    ɵngcc0.ɵɵelementStart(6, "button", 9);
    ɵngcc0.ɵɵlistener("click", function DateControlComponent_cds_dropdown_3_Template_button_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r5); var ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.clearValue(); });
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "button", 10);
    ɵngcc0.ɵɵlistener("click", function DateControlComponent_cds_dropdown_3_Template_button_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r5); var ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.applyValue(); });
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    var _r0 = ɵngcc0.ɵɵreference(1);
    var _r1 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵproperty("anchor", _r0.elementRef);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("constraints", ctx_r2.constraints)("numberOfMonths", ctx_r2.numberOfMonths)("startRange", ctx_r2.rangeFrom || ctx_r2.rangeTo ? ctx_r2.rangeFrom || ctx_r2.calendarValue : null)("endRange", ctx_r2.rangeFrom || ctx_r2.rangeTo ? ctx_r2.rangeTo || ctx_r2.calendarValue : null)("padDaysInMonth", ctx_r2.padDaysInMonth)("ngModel", ctx_r2.calendarValue);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r2.translations.cancel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.translations.cancelButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", !_r1.valid);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r2.translations.apply);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.translations.applyButton);
} }
function DateRangeControlComponent_cds_dropdown_3_Template(rf, ctx) { if (rf & 1) {
    var _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "cds-dropdown", 3, 4);
    ɵngcc0.ɵɵlistener("dismiss", function DateRangeControlComponent_cds_dropdown_3_Template_cds_dropdown_dismiss_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); var ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onOpenChange(false); });
    ɵngcc0.ɵɵelementStart(2, "div", 5);
    ɵngcc0.ɵɵelementStart(3, "cds-calendar-range", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DateRangeControlComponent_cds_dropdown_3_Template_cds_calendar_range_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); var ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.changeCalendarValue($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 7);
    ɵngcc0.ɵɵelementStart(5, "button", 8);
    ɵngcc0.ɵɵlistener("click", function DateRangeControlComponent_cds_dropdown_3_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r5); var ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.clearValue(); });
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "button", 9);
    ɵngcc0.ɵɵlistener("click", function DateRangeControlComponent_cds_dropdown_3_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r5); var ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.applyValue(); });
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    var _r0 = ɵngcc0.ɵɵreference(1);
    var _r1 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵproperty("anchor", _r0.elementRef);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("focusable", false)("focusOn", ctx_r2.setRangeTo ? "to" : "from")("constraints", ctx_r2.constraints)("numberOfMonths", ctx_r2.numberOfMonths)("startRange", ctx_r2.inputValue == null ? null : ctx_r2.inputValue.from)("endRange", ctx_r2.inputValue == null ? null : ctx_r2.inputValue.to)("padDaysInMonth", ctx_r2.padDaysInMonth)("ngModel", ctx_r2.calendarValue);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r2.translations.cancel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.translations.cancelButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", !_r1.valid);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r2.translations.apply);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.translations.applyButton);
} }
var _c29 = ["inputFrom"];
var _c30 = ["inputTo"];
var _c31 = ["inputFromModel"];
var _c32 = ["inputToModel"];
function DateRangeDialogComponent_cds_errors_15_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.errorsTranslations.required);
} }
function DateRangeDialogComponent_cds_errors_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "cds-errors", 15);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2, "\u200B");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, DateRangeDialogComponent_cds_errors_15_span_3_Template, 2, 1, "span", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    var _r1 = ɵngcc0.ɵɵreference(9);
    ɵngcc0.ɵɵproperty("cdsErrors", _r1);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("cdsError", "required");
} }
function DateRangeDialogComponent_cds_errors_16_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.errorsTranslations.required);
} }
function DateRangeDialogComponent_cds_errors_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "cds-errors", 15);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2, "\u200B");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, DateRangeDialogComponent_cds_errors_16_span_3_Template, 2, 1, "span", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    var _r3 = ɵngcc0.ɵɵreference(13);
    ɵngcc0.ɵɵproperty("cdsErrors", _r3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("cdsError", "required");
} }
function DateRangeDropdownComponent_cds_dropdown_5_Template(rf, ctx) { if (rf & 1) {
    var _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "cds-dropdown", 5, 6);
    ɵngcc0.ɵɵlistener("dismiss", function DateRangeDropdownComponent_cds_dropdown_5_Template_cds_dropdown_dismiss_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); var ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onOpenChange(false); });
    ɵngcc0.ɵɵelementStart(2, "div", 7);
    ɵngcc0.ɵɵelementStart(3, "cds-calendar-range", 8);
    ɵngcc0.ɵɵlistener("clickValueChange", function DateRangeDropdownComponent_cds_dropdown_5_Template_cds_calendar_range_clickValueChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); var ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.changeCalendarValue($event); })("keyboardValueChange", function DateRangeDropdownComponent_cds_dropdown_5_Template_cds_calendar_range_keyboardValueChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); var ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.changeCalendarValue($event, true); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 9);
    ɵngcc0.ɵɵelementStart(5, "button", 10);
    ɵngcc0.ɵɵlistener("click", function DateRangeDropdownComponent_cds_dropdown_5_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r5); var ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.clearValue(); });
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "button", 11);
    ɵngcc0.ɵɵlistener("click", function DateRangeDropdownComponent_cds_dropdown_5_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r5); var ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.applyValue(); });
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    var _r0 = ɵngcc0.ɵɵreference(2);
    var _r1 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("anchor", _r0.elementRef);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("focusOn", ctx_r2.focusOn)("constraints", ctx_r2.constraints)("numberOfMonths", ctx_r2.numberOfMonths)("startRange", ctx_r2.value == null ? null : ctx_r2.value.from)("endRange", ctx_r2.value == null ? null : ctx_r2.value.to)("padDaysInMonth", ctx_r2.padDaysInMonth)("ngModel", ctx_r2.calendarValue)("yearSelectRange", ctx_r2.yearSelectRange);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r2.translations.clearButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.translations.clearButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", !_r1.valid);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r2.translations.apply);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.translations.applyButton);
} }
var _c33 = ["dialog"];
function DateRangeFormComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    var _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelementStart(2, "div", 5);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "cds-input", 6, 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function DateRangeFormComponent_div_0_Template_cds_input_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.updateFromValue($event); })("mousedown", function DateRangeFormComponent_div_0_Template_cds_input_mousedown_4_listener() { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onMouseDown("from"); })("blur", function DateRangeFormComponent_div_0_Template_cds_input_blur_4_listener() { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onBlur("from"); })("click", function DateRangeFormComponent_div_0_Template_cds_input_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r10 = ɵngcc0.ɵɵnextContext(); return !ctx_r10.inlineEdit && ctx_r10.openDialog("from"); })("keydown.enter", function DateRangeFormComponent_div_0_Template_cds_input_keydown_enter_4_listener() { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.openDialog("from"); });
    ɵngcc0.ɵɵelementStart(6, "a", 8);
    ɵngcc0.ɵɵlistener("click", function DateRangeFormComponent_div_0_Template_a_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.inlineEdit && ctx_r12.openDialog("from"); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 4);
    ɵngcc0.ɵɵelementStart(8, "cds-input", 6, 9);
    ɵngcc0.ɵɵlistener("ngModelChange", function DateRangeFormComponent_div_0_Template_cds_input_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.updateToValue($event); })("mousedown", function DateRangeFormComponent_div_0_Template_cds_input_mousedown_8_listener() { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onMouseDown("to"); })("blur", function DateRangeFormComponent_div_0_Template_cds_input_blur_8_listener() { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.onBlur("to"); })("click", function DateRangeFormComponent_div_0_Template_cds_input_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r16 = ɵngcc0.ɵɵnextContext(); return !ctx_r16.inlineEdit && ctx_r16.openDialog("to"); })("keydown.enter", function DateRangeFormComponent_div_0_Template_cds_input_keydown_enter_8_listener() { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.openDialog("to"); });
    ɵngcc0.ɵɵelementStart(10, "a", 8);
    ɵngcc0.ɵɵlistener("click", function DateRangeFormComponent_div_0_Template_a_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.inlineEdit && ctx_r18.openDialog("to"); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("id", ctx_r0.descriptionId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.translations.dateInputLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("cds-control--required", ctx_r0.isDateRequired("from"));
    ɵngcc0.ɵɵproperty("appearance", ctx_r0.appearance)("constraints", null)("format", ctx_r0.format)("selected", ctx_r0.keepFocus === "from")("ngModel", ctx_r0.value == null ? null : ctx_r0.value.from)("label", ctx_r0.labelFrom)("placeholder", ctx_r0.placeholder)("readonly", !ctx_r0.inlineEdit)("disabled", ctx_r0.disabled)("cdsInvalid", ctx_r0.errorsFrom != null)("ariaDescribedBy", ctx_r0.descriptionId);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵclassProp("cds-control--required", ctx_r0.isDateRequired("to"));
    ɵngcc0.ɵɵproperty("appearance", ctx_r0.appearance)("constraints", null)("format", ctx_r0.format)("selected", ctx_r0.keepFocus === "to")("ngModel", ctx_r0.value == null ? null : ctx_r0.value.to)("label", ctx_r0.labelTo)("placeholder", ctx_r0.placeholder)("readonly", !ctx_r0.inlineEdit)("disabled", ctx_r0.disabled)("cdsInvalid", ctx_r0.errorsTo != null)("ariaDescribedBy", ctx_r0.descriptionId);
} }
function DateRangeFormComponent_cds_date_range_dropdown_1_Template(rf, ctx) { if (rf & 1) {
    var _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "cds-date-range-dropdown", 10);
    ɵngcc0.ɵɵlistener("valueChange", function DateRangeFormComponent_cds_date_range_dropdown_1_Template_cds_date_range_dropdown_valueChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); var ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.updateValue($event); })("blur", function DateRangeFormComponent_cds_date_range_dropdown_1_Template_cds_date_range_dropdown_blur_0_listener() { ɵngcc0.ɵɵrestoreView(_r20); var ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.onBlur(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("appearance", ctx_r1.appearance)("focusOn", ctx_r1.focusOn)("format", ctx_r1.format)("placeholder", ctx_r1.placeholder)("label", ctx_r1.label)("disabled", ctx_r1.disabled)("value", ctx_r1.value)("constraints", ctx_r1.constraints)("numberOfMonths", ctx_r1.numberOfMonths)("dateRequired", ctx_r1.dateRequired)("inlineEdit", ctx_r1.inlineEdit)("padDaysInMonth", ctx_r1.padDaysInMonth)("yearSelectRange", ctx_r1.yearSelectRange);
} }
function DateRangeFormComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    var _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "cds-date-range-dialog", 11);
    ɵngcc0.ɵɵlistener("dialogClose", function DateRangeFormComponent_ng_template_2_Template_cds_date_range_dialog_dialogClose_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); var dialog_r22 = ctx.$implicit; return dialog_r22.resolve($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("focusOn", ctx_r3.focusOn)("format", ctx_r3.format)("placeholder", ctx_r3.placeholder)("labelFrom", ctx_r3.labelFrom)("labelTo", ctx_r3.labelTo)("showInputs", ctx_r3.showInputs)("value", ctx_r3.value)("constraints", ctx_r3.constraints)("numberOfMonths", ctx_r3.numberOfMonths)("dateRequired", ctx_r3.dateRequired)("padDaysInMonth", ctx_r3.padDaysInMonth)("yearSelectRange", ctx_r3.yearSelectRange);
} }
function DateDialogComponent_div_7_li_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 22);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var timezone_r9 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("cdsComboItem", timezone_r9.code)("labelValue", timezone_r9.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(timezone_r9.name);
} }
function DateDialogComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    var _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "cds-combo", 18, 19);
    ɵngcc0.ɵɵlistener("ngModelChange", function DateDialogComponent_div_7_Template_cds_combo_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); var ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.changeTimezoneValue($event); });
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "label", 20);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "ul");
    ɵngcc0.ɵɵtemplate(8, DateDialogComponent_div_7_li_8_Template, 2, 3, "li", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var _r7 = ɵngcc0.ɵɵreference(2);
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.timezoneValue);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(_r7.selectedLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.translations.timezoneLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.timezones);
} }
function DateDialogComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    var _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵelementStart(1, "cds-combo", 24, 25);
    ɵngcc0.ɵɵlistener("ngModelChange", function DateDialogComponent_div_12_Template_cds_combo_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); var ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.changeDayPeriodValue($event); });
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "label", 26);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "ul");
    ɵngcc0.ɵɵelementStart(8, "li", 22);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "li", 22);
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var _r12 = ɵngcc0.ɵɵreference(2);
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.dayPeriodValue);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(_r12.selectedLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.translations.dayPeriodLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("cdsComboItem", "AM")("labelValue", ctx_r4.dayPeriodsTranslation[0]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.dayPeriodsTranslation[0]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cdsComboItem", "PM")("labelValue", ctx_r4.dayPeriodsTranslation[1]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.dayPeriodsTranslation[1]);
} }
function DateDialogComponent_cds_errors_14_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r15.errorsTranslations.required);
} }
function DateDialogComponent_cds_errors_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "cds-errors", 27);
    ɵngcc0.ɵɵelementStart(1, "i");
    ɵngcc0.ɵɵtext(2, "\u200B");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, DateDialogComponent_cds_errors_14_span_3_Template, 2, 1, "span", 28);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    var _r3 = ɵngcc0.ɵɵreference(11);
    ɵngcc0.ɵɵproperty("cdsErrors", _r3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("cdsError", "required");
} }
function DateDialogComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    var _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 29);
    ɵngcc0.ɵɵelementStart(1, "div", 30);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "cds-time-picker", 31);
    ɵngcc0.ɵɵlistener("ngModelChange", function DateDialogComponent_div_17_Template_cds_time_picker_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); var ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.changeTimePickerValue($event); });
    ɵngcc0.ɵɵpipe(4, "cdsAdjustTimeConstraints");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.translations.timeLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("constraints", ɵngcc0.ɵɵpipeBind2(4, 6, ctx_r6.constraints, ctx_r6.inputValue))("format", ctx_r6.resolvedFormat)("useDayPeriod", ctx_r6.useDayPeriod)("disabled", !ctx_r6.calendarValue)("ngModel", ctx_r6.timePickerValue);
} }
function DateDropdownComponent_cds_dropdown_5_div_4_Template(rf, ctx) { if (rf & 1) {
    var _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelementStart(1, "div", 15);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "cds-time-picker", 16);
    ɵngcc0.ɵɵlistener("ngModelChange", function DateDropdownComponent_cds_dropdown_5_div_4_Template_cds_time_picker_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); var ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.changeTimePickerValue($event); });
    ɵngcc0.ɵɵpipe(4, "cdsAdjustTimeConstraints");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.translations.timeLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("constraints", ɵngcc0.ɵɵpipeBind2(4, 6, ctx_r4.constraints, ctx_r4.inputValue))("format", ctx_r4.resolvedFormat)("useDayPeriod", ctx_r4.useDayPeriod)("disabled", !ctx_r4.calendarValue)("ngModel", ctx_r4.timePickerValue);
} }
function DateDropdownComponent_cds_dropdown_5_div_5_Template(rf, ctx) { if (rf & 1) {
    var _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "cds-combo", 18, 19);
    ɵngcc0.ɵɵlistener("ngModelChange", function DateDropdownComponent_cds_dropdown_5_div_5_Template_cds_combo_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); var ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.changeDayPeriodValue($event); });
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "label", 20);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "ul");
    ɵngcc0.ɵɵelementStart(8, "li", 21);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "li", 21);
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var _r8 = ɵngcc0.ɵɵreference(2);
    var ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.dayPeriodValue);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(_r8.selectedLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.translations.dayPeriodLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("cdsComboItem", "AM")("labelValue", ctx_r5.dayPeriodsTranslation[0]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.dayPeriodsTranslation[0]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cdsComboItem", "PM")("labelValue", ctx_r5.dayPeriodsTranslation[1]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.dayPeriodsTranslation[1]);
} }
function DateDropdownComponent_cds_dropdown_5_Template(rf, ctx) { if (rf & 1) {
    var _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "cds-dropdown", 5, 6);
    ɵngcc0.ɵɵlistener("dismiss", function DateDropdownComponent_cds_dropdown_5_Template_cds_dropdown_dismiss_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); var ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.onOpenChange(false); });
    ɵngcc0.ɵɵelementStart(2, "div", 7);
    ɵngcc0.ɵɵelementStart(3, "cds-calendar-range", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DateDropdownComponent_cds_dropdown_5_Template_cds_calendar_range_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); var ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.changeCalendarValue($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, DateDropdownComponent_cds_dropdown_5_div_4_Template, 5, 9, "div", 9);
    ɵngcc0.ɵɵtemplate(5, DateDropdownComponent_cds_dropdown_5_div_5_Template, 12, 9, "div", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 11);
    ɵngcc0.ɵɵelementStart(7, "button", 12);
    ɵngcc0.ɵɵlistener("click", function DateDropdownComponent_cds_dropdown_5_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r12); var ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.clearValue(); });
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "button", 13);
    ɵngcc0.ɵɵlistener("click", function DateDropdownComponent_cds_dropdown_5_Template_button_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r12); var ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.applyValue(); });
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    var _r0 = ɵngcc0.ɵɵreference(2);
    var _r1 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("anchor", _r0.elementRef);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("constraints", ctx_r2.constraints)("padDaysInMonth", ctx_r2.padDaysInMonth)("numberOfMonths", ctx_r2.numberOfMonths)("startRange", ctx_r2.rangeFrom || ctx_r2.rangeTo ? ctx_r2.rangeFrom || ctx_r2.calendarValue : null)("endRange", ctx_r2.rangeFrom || ctx_r2.rangeTo ? ctx_r2.rangeTo || ctx_r2.calendarValue : null)("ngModel", ctx_r2.calendarValue)("yearSelectRange", ctx_r2.yearSelectRange);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.includesTime);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.includesTime && ctx_r2.useDayPeriod);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.translations.clearButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", !_r1.valid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.translations.applyButton);
} }
function DateFormComponent_div_0_div_7_cds_combo_1_Template(rf, ctx) { if (rf & 1) {
    var _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "cds-combo", 13, 14);
    ɵngcc0.ɵɵlistener("ngModelChange", function DateFormComponent_div_0_div_7_cds_combo_1_Template_cds_combo_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); var ctx_r9 = ɵngcc0.ɵɵnextContext(3); return ctx_r9.setDayPeriod($event); });
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "label", 15);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "ul");
    ɵngcc0.ɵɵelementStart(7, "li", 16);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "li", 16);
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var _r8 = ɵngcc0.ɵɵreference(1);
    var ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r7.dayPeriod)("disabled", ctx_r7.disabled);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(_r8.selectedLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.translations.dayPeriodLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("cdsComboItem", "AM")("labelValue", ctx_r7.dayPeriodsTranslation[0]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.dayPeriodsTranslation[0]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cdsComboItem", "PM")("labelValue", ctx_r7.dayPeriodsTranslation[1]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.dayPeriodsTranslation[1]);
} }
function DateFormComponent_div_0_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵtemplate(1, DateFormComponent_div_0_div_7_cds_combo_1_Template, 11, 10, "cds-combo", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.useDayPeriod);
} }
function DateFormComponent_div_0_div_8_cds_combo_1_li_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 16);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var timezone_r14 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("cdsComboItem", timezone_r14.code)("labelValue", timezone_r14.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(timezone_r14.name);
} }
function DateFormComponent_div_0_div_8_cds_combo_1_Template(rf, ctx) { if (rf & 1) {
    var _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "cds-combo", 19, 20);
    ɵngcc0.ɵɵlistener("ngModelChange", function DateFormComponent_div_0_div_8_cds_combo_1_Template_cds_combo_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); var ctx_r15 = ɵngcc0.ɵɵnextContext(3); return ctx_r15.setTimezone($event); });
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "label", 15);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "ul");
    ɵngcc0.ɵɵtemplate(7, DateFormComponent_div_0_div_8_cds_combo_1_li_7_Template, 2, 3, "li", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var _r12 = ɵngcc0.ɵɵreference(1);
    var ctx_r11 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r11.timezoneDirective.selected)("disabled", ctx_r11.disabled);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(_r12.selectedLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r11.translations.timezoneLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r11.timezones);
} }
function DateFormComponent_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtemplate(1, DateFormComponent_div_0_div_8_cds_combo_1_Template, 8, 5, "cds-combo", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.timezones);
} }
function DateFormComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    var _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelementStart(2, "div", 5);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "cds-input", 6, 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function DateFormComponent_div_0_Template_cds_input_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); var ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.updateValue($event); })("mousedown", function DateFormComponent_div_0_Template_cds_input_mousedown_4_listener() { ɵngcc0.ɵɵrestoreView(_r18); var ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.onMouseDown(); })("blur", function DateFormComponent_div_0_Template_cds_input_blur_4_listener() { ɵngcc0.ɵɵrestoreView(_r18); var ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.onBlur(); })("click", function DateFormComponent_div_0_Template_cds_input_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r18); var ctx_r21 = ɵngcc0.ɵɵnextContext(); return !ctx_r21.inlineEdit && ctx_r21.openDialog(); })("keydown.enter", function DateFormComponent_div_0_Template_cds_input_keydown_enter_4_listener() { ɵngcc0.ɵɵrestoreView(_r18); var ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.openDialog(); });
    ɵngcc0.ɵɵelementStart(6, "a", 8);
    ɵngcc0.ɵɵlistener("click", function DateFormComponent_div_0_Template_a_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r18); var ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.inlineEdit && ctx_r23.openDialog(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, DateFormComponent_div_0_div_7_Template, 2, 1, "div", 9);
    ɵngcc0.ɵɵtemplate(8, DateFormComponent_div_0_div_8_Template, 2, 1, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("cds-date-time-form__date-input--time", ctx_r0.includesTime);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("id", ctx_r0.descriptionId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.translations.dateInputLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("cds-control--required", ctx_r0.dateRequired);
    ɵngcc0.ɵɵproperty("appearance", ctx_r0.appearance)("constraints", null)("format", ctx_r0.format)("dayPeriod", ctx_r0.dayPeriod)("selected", ctx_r0.keepFocus)("ngModel", ctx_r0.value)("label", ctx_r0.label)("placeholder", ctx_r0.placeholder)("readonly", !ctx_r0.inlineEdit)("disabled", ctx_r0.disabled)("cdsInvalid", ctx_r0.errors != null)("ariaDescribedBy", ctx_r0.descriptionId);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.useDayPeriod);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.timezoneDirective);
} }
function DateFormComponent_cds_date_dropdown_1_Template(rf, ctx) { if (rf & 1) {
    var _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "cds-date-dropdown", 22);
    ɵngcc0.ɵɵlistener("valueChange", function DateFormComponent_cds_date_dropdown_1_Template_cds_date_dropdown_valueChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); var ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.updateValue($event); })("blur", function DateFormComponent_cds_date_dropdown_1_Template_cds_date_dropdown_blur_0_listener() { ɵngcc0.ɵɵrestoreView(_r25); var ctx_r26 = ɵngcc0.ɵɵnextContext(); return ctx_r26.onBlur(); })("dayPeriodChange", function DateFormComponent_cds_date_dropdown_1_Template_cds_date_dropdown_dayPeriodChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); var ctx_r27 = ɵngcc0.ɵɵnextContext(); return ctx_r27.updateDayPeriod($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("appearance", ctx_r1.appearance)("format", ctx_r1.format)("placeholder", ctx_r1.placeholder)("label", ctx_r1.label)("rangeFrom", ctx_r1.rangeFrom)("rangeTo", ctx_r1.rangeTo)("inputValue", ctx_r1.value)("timezoneValue", ctx_r1.timezoneDirective == null ? null : ctx_r1.timezoneDirective.selected)("constraints", ctx_r1.constraints)("dayPeriod", ctx_r1.dayPeriod)("padDaysInMonth", ctx_r1.padDaysInMonth)("dateRequired", ctx_r1.dateRequired)("inlineEdit", ctx_r1.inlineEdit)("numberOfMonths", ctx_r1.numberOfMonths)("timeValue", ctx_r1.timeValue)("yearSelectRange", ctx_r1.yearSelectRange)("disabled", ctx_r1.disabled);
} }
function DateFormComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    var _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "cds-date-dialog", 23);
    ɵngcc0.ɵɵlistener("dialogClose", function DateFormComponent_ng_template_2_Template_cds_date_dialog_dialogClose_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); var dialog_r28 = ctx.$implicit; return dialog_r28.resolve($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("format", ctx_r3.format)("placeholder", ctx_r3.placeholder)("label", ctx_r3.label)("showInputs", ctx_r3.showInputs)("dayPeriod", ctx_r3.dayPeriod)("value", ctx_r3.value)("timezone", ctx_r3.timezoneDirective)("constraints", ctx_r3.constraints)("padDaysInMonth", ctx_r3.padDaysInMonth)("dateRequired", ctx_r3.dateRequired)("yearSelectRange", ctx_r3.yearSelectRange);
} }
function TimeControlComponent_ng_container_0_cds_dropdown_4_div_5_Template(rf, ctx) { if (rf & 1) {
    var _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "cds-combo", 14, 15);
    ɵngcc0.ɵɵlistener("ngModelChange", function TimeControlComponent_ng_container_0_cds_dropdown_4_div_5_Template_cds_combo_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); var ctx_r8 = ɵngcc0.ɵɵnextContext(3); return ctx_r8.changeDayPeriodValue($event); });
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "ul");
    ɵngcc0.ɵɵelementStart(6, "li", 16);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "li", 16);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var _r7 = ɵngcc0.ɵɵreference(2);
    var ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("placeholder", ctx_r6.translations.dayPeriodLabel)("ngModel", ctx_r6.dayPeriodValue);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(_r7.selectedLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("cdsComboItem", "AM")("labelValue", ctx_r6.dayPeriodsTranslation[0]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.dayPeriodsTranslation[0]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cdsComboItem", "PM")("labelValue", ctx_r6.dayPeriodsTranslation[1]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.dayPeriodsTranslation[1]);
} }
function TimeControlComponent_ng_container_0_cds_dropdown_4_Template(rf, ctx) { if (rf & 1) {
    var _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "cds-dropdown", 4, 5);
    ɵngcc0.ɵɵlistener("dismiss", function TimeControlComponent_ng_container_0_cds_dropdown_4_Template_cds_dropdown_dismiss_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); var ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.onOpenChange(false); });
    ɵngcc0.ɵɵelementStart(2, "div", 6);
    ɵngcc0.ɵɵelementStart(3, "div", 7);
    ɵngcc0.ɵɵelementStart(4, "cds-time-picker", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function TimeControlComponent_ng_container_0_cds_dropdown_4_Template_cds_time_picker_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); var ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.changeTimePickerValue($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, TimeControlComponent_ng_container_0_cds_dropdown_4_div_5_Template, 10, 9, "div", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 10);
    ɵngcc0.ɵɵelementStart(7, "button", 11);
    ɵngcc0.ɵɵlistener("click", function TimeControlComponent_ng_container_0_cds_dropdown_4_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r11); var ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.clearValue(); });
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "button", 12);
    ɵngcc0.ɵɵlistener("click", function TimeControlComponent_ng_container_0_cds_dropdown_4_Template_button_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r11); var ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.applyValue(); });
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    var _r2 = ɵngcc0.ɵɵreference(2);
    var _r3 = ɵngcc0.ɵɵreference(3);
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("anchor", _r2.elementRef);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("constraints", ctx_r4.constraints)("format", ctx_r4.resolvedFormat)("useDayPeriod", ctx_r4.useDayPeriod)("ngModel", ctx_r4.timePickerValue);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.useDayPeriod);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r4.translations.cancel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.translations.cancelButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", !_r3.valid);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r4.translations.apply);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.translations.applyButton);
} }
function TimeControlComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    var _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "cds-input", 1, 2);
    ɵngcc0.ɵɵlistener("ngModelChange", function TimeControlComponent_ng_container_0_Template_cds_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); var ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.changeInputValue($event); })("focus", function TimeControlComponent_ng_container_0_Template_cds_input_focus_1_listener() { ɵngcc0.ɵɵrestoreView(_r16); var ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.onOpenChange(true); })("mousedown", function TimeControlComponent_ng_container_0_Template_cds_input_mousedown_1_listener() { ɵngcc0.ɵɵrestoreView(_r16); var ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.onMouseDown(); })("blur", function TimeControlComponent_ng_container_0_Template_cds_input_blur_1_listener() { ɵngcc0.ɵɵrestoreView(_r16); var ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.onBlur(); })("keydown.enter", function TimeControlComponent_ng_container_0_Template_cds_input_keydown_enter_1_listener() { ɵngcc0.ɵɵrestoreView(_r16); var _r3 = ɵngcc0.ɵɵreference(3); var ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.isOpen ? _r3.valid && ctx_r20.applyValue() : ctx_r20.onOpenChange(true); })("cdsOnEscape", function TimeControlComponent_ng_container_0_Template_cds_input_cdsOnEscape_1_listener() { ɵngcc0.ɵɵrestoreView(_r16); var ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.clearValue(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, TimeControlComponent_ng_container_0_cds_dropdown_4_Template, 11, 11, "cds-dropdown", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("cds-control--required", ctx_r0.dateRequired);
    ɵngcc0.ɵɵproperty("appearance", ctx_r0.appearance)("format", ctx_r0.format)("constraints", ctx_r0.isOpen ? ctx_r0.constraints : null)("dateValue", ctx_r0.dateValue)("selected", ctx_r0.keepFocus)("ngModel", ctx_r0.inputValue)("label", ctx_r0.label || ctx_r0.translations.selectTimeHeader)("placeholder", ctx_r0.placeholder)("readonly", !ctx_r0.inlineEdit)("disabled", ctx_r0.disabled)("cdsInvalid", ctx_r0.isOpen ? false : ctx_r0.errors != null);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isOpen);
} }
function TimeControlComponent_ng_container_1_li_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 16);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "cdsTimeControlDisplayHour");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var time_r24 = ctx.$implicit;
    var ctx_r23 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("cdsComboItem", time_r24)("labelValue", time_r24);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind4(2, 3, time_r24, ctx_r23.useDayPeriod, ctx_r23.format, ctx_r23.dayPeriodsTranslation));
} }
function TimeControlComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    var _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "cds-combo", 17, 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function TimeControlComponent_ng_container_1_Template_cds_combo_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); var ctx_r25 = ɵngcc0.ɵɵnextContext(); return ctx_r25.changeInputValue($event); });
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "cdsTimeControlDisplayHour");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "ul");
    ɵngcc0.ɵɵtemplate(7, TimeControlComponent_ng_container_1_li_7_Template, 3, 8, "li", 19);
    ɵngcc0.ɵɵpipe(8, "cdsTimeControlList");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var _r22 = ɵngcc0.ɵɵreference(2);
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("appearance", ctx_r1.appearance)("label", ctx_r1.label || ctx_r1.translations.selectTimeHeader)("ngModel", ctx_r1.inputValue)("cdsInvalid", ctx_r1.errors != null)("disabled", ctx_r1.disabled);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind4(5, 7, ctx_r1.inputValue, ctx_r1.useDayPeriod, ctx_r1.format, ctx_r1.dayPeriodsTranslation || _r22.selectedLabel));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind2(8, 12, ctx_r1.inputValue, ctx_r1.constraints));
} }
function TimeDialogComponent_div_7_li_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 24);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var timezone_r8 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("cdsComboItem", timezone_r8.code)("labelValue", timezone_r8.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(timezone_r8.name);
} }
function TimeDialogComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    var _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelementStart(1, "cds-combo", 20, 21);
    ɵngcc0.ɵɵlistener("ngModelChange", function TimeDialogComponent_div_7_Template_cds_combo_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); var ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.changeTimezoneValue($event); });
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "label", 22);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "ul");
    ɵngcc0.ɵɵtemplate(8, TimeDialogComponent_div_7_li_8_Template, 2, 3, "li", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var _r6 = ɵngcc0.ɵɵreference(2);
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.timezoneValue);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(_r6.selectedLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.translations.timezoneLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.timezones);
} }
function TimeDialogComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    var _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵelementStart(1, "cds-combo", 26, 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function TimeDialogComponent_div_12_Template_cds_combo_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); var ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.changeDayPeriodValue($event); });
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "label", 28);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "ul");
    ɵngcc0.ɵɵelementStart(8, "li", 24);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "li", 24);
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var _r11 = ɵngcc0.ɵɵreference(2);
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.dayPeriodValue);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(_r11.selectedLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.translations.dayPeriodLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("cdsComboItem", "AM")("labelValue", ctx_r4.dayPeriodsTranslation[0]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.dayPeriodsTranslation[0]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cdsComboItem", "PM")("labelValue", ctx_r4.dayPeriodsTranslation[1]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.dayPeriodsTranslation[1]);
} }
function TimeDialogComponent_span_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.errorsTranslations.required);
} }
function TimeFormComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    var _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "cds-combo", 11, 12);
    ɵngcc0.ɵɵlistener("ngModelChange", function TimeFormComponent_div_0_div_5_Template_cds_combo_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); var ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.setDayPeriod($event); });
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "label", 13);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "ul");
    ɵngcc0.ɵɵelementStart(8, "li", 14);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "li", 14);
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var _r7 = ɵngcc0.ɵɵreference(2);
    var ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.dayPeriod)("disabled", ctx_r5.disabled);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(_r7.selectedLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.translations.dayPeriodLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("cdsComboItem", "AM")("labelValue", ctx_r5.dayPeriodsTranslation[0]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.dayPeriodsTranslation[0]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cdsComboItem", "PM")("labelValue", ctx_r5.dayPeriodsTranslation[1]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.dayPeriodsTranslation[1]);
} }
function TimeFormComponent_div_0_div_6_cds_combo_1_li_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var timezone_r13 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("cdsComboItem", timezone_r13.code)("labelValue", timezone_r13.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(timezone_r13.name);
} }
function TimeFormComponent_div_0_div_6_cds_combo_1_Template(rf, ctx) { if (rf & 1) {
    var _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "cds-combo", 17, 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function TimeFormComponent_div_0_div_6_cds_combo_1_Template_cds_combo_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); var ctx_r14 = ɵngcc0.ɵɵnextContext(3); return ctx_r14.setTimezone($event); });
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "label", 13);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "ul");
    ɵngcc0.ɵɵtemplate(7, TimeFormComponent_div_0_div_6_cds_combo_1_li_7_Template, 2, 3, "li", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var _r11 = ɵngcc0.ɵɵreference(1);
    var ctx_r10 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r10.timezoneDirective.selected)("disabled", ctx_r10.disabled);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(_r11.selectedLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r10.translations.timezoneLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r10.timezones);
} }
function TimeFormComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵtemplate(1, TimeFormComponent_div_0_div_6_cds_combo_1_Template, 8, 5, "cds-combo", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.timezones);
} }
function TimeFormComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    var _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelementStart(2, "cds-input", 5, 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function TimeFormComponent_div_0_Template_cds_input_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); var ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.updateValue($event); })("mousedown", function TimeFormComponent_div_0_Template_cds_input_mousedown_2_listener() { ɵngcc0.ɵɵrestoreView(_r17); var ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.onMouseDown(); })("blur", function TimeFormComponent_div_0_Template_cds_input_blur_2_listener() { ɵngcc0.ɵɵrestoreView(_r17); var ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.onBlur(); })("click", function TimeFormComponent_div_0_Template_cds_input_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r17); var ctx_r20 = ɵngcc0.ɵɵnextContext(); return !ctx_r20.inlineEdit && ctx_r20.openDialog(); })("keydown.enter", function TimeFormComponent_div_0_Template_cds_input_keydown_enter_2_listener() { ɵngcc0.ɵɵrestoreView(_r17); var ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.openDialog(); });
    ɵngcc0.ɵɵelementStart(4, "a", 7);
    ɵngcc0.ɵɵlistener("click", function TimeFormComponent_div_0_Template_a_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r17); var ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.inlineEdit && ctx_r22.openDialog(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, TimeFormComponent_div_0_div_5_Template, 12, 10, "div", 8);
    ɵngcc0.ɵɵtemplate(6, TimeFormComponent_div_0_div_6_Template, 2, 1, "div", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("cds-date-time-form__time-input--seconds", ctx_r0.includesSeconds);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("cds-control--required", ctx_r0.dateRequired);
    ɵngcc0.ɵɵproperty("appearance", ctx_r0.appearance)("constraints", null)("format", ctx_r0.format)("dayPeriod", ctx_r0.dayPeriod)("selected", ctx_r0.keepFocus)("ngModel", ctx_r0.value)("label", ctx_r0.label)("placeholder", ctx_r0.placeholder)("readonly", !ctx_r0.inlineEdit)("disabled", ctx_r0.disabled)("cdsInvalid", ctx_r0.errors != null);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.useDayPeriod);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.timezoneDirective);
} }
function TimeFormComponent_cds_time_dropdown_1_Template(rf, ctx) { if (rf & 1) {
    var _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "cds-time-dropdown", 20, 21);
    ɵngcc0.ɵɵlistener("valueChange", function TimeFormComponent_cds_time_dropdown_1_Template_cds_time_dropdown_valueChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); var ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.updateValue($event); })("blur", function TimeFormComponent_cds_time_dropdown_1_Template_cds_time_dropdown_blur_0_listener() { ɵngcc0.ɵɵrestoreView(_r25); var ctx_r26 = ɵngcc0.ɵɵnextContext(); return ctx_r26.onBlur(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("appearance", ctx_r1.appearance)("format", ctx_r1.format)("placeholder", ctx_r1.placeholder)("label", ctx_r1.label)("timePicker", ctx_r1.timePicker)("disabled", ctx_r1.disabled)("inputValue", ctx_r1.value)("timezoneValue", ctx_r1.timezoneDirective == null ? null : ctx_r1.timezoneDirective.selected)("constraints", ctx_r1.constraints)("dayPeriod", ctx_r1.dayPeriod)("dateRequired", ctx_r1.dateRequired)("inlineEdit", ctx_r1.inlineEdit)("dateValue", ctx_r1.dateValue);
} }
function TimeFormComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    var _r29 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "cds-time-dialog", 22);
    ɵngcc0.ɵɵlistener("dialogClose", function TimeFormComponent_ng_template_2_Template_cds_time_dialog_dialogClose_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r29); var dialog_r27 = ctx.$implicit; return dialog_r27.resolve($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("format", ctx_r3.format)("placeholder", ctx_r3.placeholder)("label", ctx_r3.label)("dayPeriod", ctx_r3.dayPeriod)("value", ctx_r3.value)("timezone", ctx_r3.timezoneDirective)("constraints", ctx_r3.constraints)("dateRequired", ctx_r3.dateRequired);
} }
function TimezoneControlComponent_li_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var timezone_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("cdsComboItem", timezone_r2.code)("labelValue", timezone_r2.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(timezone_r2.name);
} }
function TimeDropdownComponent_ng_container_0_cds_dropdown_6_div_5_Template(rf, ctx) { if (rf & 1) {
    var _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵelementStart(1, "cds-combo", 16, 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function TimeDropdownComponent_ng_container_0_cds_dropdown_6_div_5_Template_cds_combo_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); var ctx_r8 = ɵngcc0.ɵɵnextContext(3); return ctx_r8.changeDayPeriodValue($event); });
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "ul");
    ɵngcc0.ɵɵelementStart(6, "li", 18);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "li", 18);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var _r7 = ɵngcc0.ɵɵreference(2);
    var ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("placeholder", ctx_r6.translations.dayPeriodLabel)("ngModel", ctx_r6.dayPeriodValue);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(_r7.selectedLabel);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("cdsComboItem", "AM")("labelValue", ctx_r6.dayPeriodsTranslation[0]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.dayPeriodsTranslation[0]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cdsComboItem", "PM")("labelValue", ctx_r6.dayPeriodsTranslation[1]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.dayPeriodsTranslation[1]);
} }
function TimeDropdownComponent_ng_container_0_cds_dropdown_6_Template(rf, ctx) { if (rf & 1) {
    var _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "cds-dropdown", 6, 7);
    ɵngcc0.ɵɵlistener("dismiss", function TimeDropdownComponent_ng_container_0_cds_dropdown_6_Template_cds_dropdown_dismiss_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); var ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.onOpenChange(false); });
    ɵngcc0.ɵɵelementStart(2, "div", 8);
    ɵngcc0.ɵɵelementStart(3, "div", 9);
    ɵngcc0.ɵɵelementStart(4, "cds-time-picker", 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function TimeDropdownComponent_ng_container_0_cds_dropdown_6_Template_cds_time_picker_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); var ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.changeTimePickerValue($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, TimeDropdownComponent_ng_container_0_cds_dropdown_6_div_5_Template, 10, 9, "div", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 12);
    ɵngcc0.ɵɵelementStart(7, "button", 13);
    ɵngcc0.ɵɵlistener("click", function TimeDropdownComponent_ng_container_0_cds_dropdown_6_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r11); var ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.clearValue(); });
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "button", 14);
    ɵngcc0.ɵɵlistener("click", function TimeDropdownComponent_ng_container_0_cds_dropdown_6_Template_button_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r11); var ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.applyValue(); });
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    var _r2 = ɵngcc0.ɵɵreference(3);
    var _r3 = ɵngcc0.ɵɵreference(4);
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("anchor", _r2.elementRef);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("constraints", ctx_r4.constraints)("format", ctx_r4.resolvedFormat)("useDayPeriod", ctx_r4.useDayPeriod)("ngModel", ctx_r4.timePickerValue);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.useDayPeriod);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r4.translations.clearButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.translations.clearButton);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", !_r3.valid);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r4.translations.apply);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.translations.applyButton);
} }
function TimeDropdownComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    var _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "cds-input", 2, 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function TimeDropdownComponent_ng_container_0_Template_cds_input_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); var ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.changeInputValue($event); })("mousedown", function TimeDropdownComponent_ng_container_0_Template_cds_input_mousedown_2_listener() { ɵngcc0.ɵɵrestoreView(_r16); var ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.onMouseDown(); })("blur", function TimeDropdownComponent_ng_container_0_Template_cds_input_blur_2_listener() { ɵngcc0.ɵɵrestoreView(_r16); var ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.onBlur(); })("click", function TimeDropdownComponent_ng_container_0_Template_cds_input_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r16); var ctx_r19 = ɵngcc0.ɵɵnextContext(); return !ctx_r19.inlineEdit && ctx_r19.onOpenChange(true); })("keydown.enter", function TimeDropdownComponent_ng_container_0_Template_cds_input_keydown_enter_2_listener() { ɵngcc0.ɵɵrestoreView(_r16); var _r3 = ɵngcc0.ɵɵreference(4); var ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.isOpen ? _r3.valid && ctx_r20.applyValue() : ctx_r20.onOpenChange(true); });
    ɵngcc0.ɵɵelementStart(5, "a", 4);
    ɵngcc0.ɵɵlistener("click", function TimeDropdownComponent_ng_container_0_Template_a_click_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); var ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.inlineEdit && ctx_r21.onOpenChange(true, $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, TimeDropdownComponent_ng_container_0_cds_dropdown_6_Template, 11, 11, "cds-dropdown", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("cds-control--required", ctx_r0.dateRequired);
    ɵngcc0.ɵɵproperty("appearance", ctx_r0.appearance)("constraints", ctx_r0.getConstraints())("format", ctx_r0.format)("dayPeriod", ctx_r0.dayPeriod)("dateValue", ctx_r0.dateValue)("selected", ctx_r0.keepFocus)("ngModel", ctx_r0.inputValue)("label", ctx_r0.label)("placeholder", ctx_r0.placeholder)("readonly", !ctx_r0.inlineEdit)("disabled", ctx_r0.disabled);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isOpen);
} }
function TimeDropdownComponent_ng_container_1_li_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 18);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "cdsTimeControlDisplayHour");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var time_r24 = ctx.$implicit;
    var ctx_r23 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("cdsComboItem", time_r24)("labelValue", time_r24);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind4(2, 3, time_r24, ctx_r23.useDayPeriod, ctx_r23.format, ctx_r23.dayPeriodsTranslation));
} }
function TimeDropdownComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    var _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 19);
    ɵngcc0.ɵɵelementStart(2, "cds-combo", 20, 21);
    ɵngcc0.ɵɵlistener("ngModelChange", function TimeDropdownComponent_ng_container_1_Template_cds_combo_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); var ctx_r25 = ɵngcc0.ɵɵnextContext(); return ctx_r25.changeInputValue($event); });
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "cdsTimeControlDisplayHour");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "ul");
    ɵngcc0.ɵɵtemplate(8, TimeDropdownComponent_ng_container_1_li_8_Template, 3, 8, "li", 22);
    ɵngcc0.ɵɵpipe(9, "cdsTimeControlList");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var _r22 = ɵngcc0.ɵɵreference(3);
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("cds-control--required", ctx_r1.dateRequired);
    ɵngcc0.ɵɵproperty("appearance", ctx_r1.appearance)("required", ctx_r1.dateRequired)("label", ctx_r1.label)("placeholder", ctx_r1.placeholder)("ngModel", ctx_r1.inputValue)("cdsInvalid", ctx_r1.errors != null)("disabled", ctx_r1.disabled);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind4(6, 11, ctx_r1.inputValue, ctx_r1.useDayPeriod, ctx_r1.format, ctx_r1.dayPeriodsTranslation || _r22.selectedLabel));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind2(9, 16, ctx_r1.inputValue, ctx_r1.constraints));
} }
var _c34 = ["cdsNavItem", ""];
function NavItemComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "span", 2);
    ɵngcc0.ɵɵelement(2, "span", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", (ctx_r0.context == null ? null : ctx_r0.context.rotateIcon) ? "cds-icon-angle-down" : "cds-icon-angle-right");
} }
var _c35 = ["brand"];
var _c36 = ["extra"];
var _c37 = ["footer"];
var _c38 = ["mega"];
var _c39 = ["container"];
var _c40 = ["wrapperElement"];
var _c41 = ["beforeElement"];
var _c42 = ["navElement"];
var _c43 = ["afterElement"];
function HeaderComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function HeaderComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    var _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵelementStart(1, "button", 17);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_div_7_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r15); var ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.toggleHamburger(); });
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(2, "svg", 18);
    ɵngcc0.ɵɵelement(3, "path", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r4.schema === "dark" ? "cds-button-icon-dark" : "cds-button-icon");
    ɵngcc0.ɵɵattribute("aria-expanded", ctx_r4.float && ctx_r4.toggle)("aria-controls", ctx_r4.sideId)("aria-label", ctx_r4.translations.openMenu);
} }
var _c44 = function (a1) { return { position: "top", device: a1 }; };
function HeaderComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 20, 21);
    ɵngcc0.ɵɵelementContainer(2, 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r7.extraRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c44, ctx_r7.device));
} }
var _c45 = function (a0) { return { $implicit: a0 }; };
function HeaderComponent_ng_template_13_nav_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "nav", 24, 25);
    ɵngcc0.ɵɵelementContainer(2, 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r17 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r17.navigation)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c45, ctx_r17.topContext));
} }
function HeaderComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵtemplate(1, HeaderComponent_ng_template_13_nav_1_Template, 3, 4, "nav", 23);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r9.float);
} }
function HeaderComponent_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementContainer(1, 26);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var template_r19 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", template_r19);
} }
function HeaderComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 27, 28);
    ɵngcc0.ɵɵelementContainer(2, 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("@mega", "visible");
    ɵngcc0.ɵɵattribute("id", ctx_r11.megaContext.id);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r11.megaContext.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(4, _c45, ctx_r11.megaContext));
} }
function HeaderComponent_cds_nav_overlay_18_Template(rf, ctx) { if (rf & 1) {
    var _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "cds-nav-overlay", 29);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_cds_nav_overlay_18_Template_cds_nav_overlay_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r22); var ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.toggleHamburger(); });
    ɵngcc0.ɵɵelementEnd();
} }
function HeaderComponent_div_19_div_2_Template(rf, ctx) { if (rf & 1) {
    var _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 39);
    ɵngcc0.ɵɵelementStart(1, "button", 40);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_div_19_div_2_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r27); var ctx_r26 = ɵngcc0.ɵɵnextContext(2); return ctx_r26.toggleHamburger(); });
    ɵngcc0.ɵɵelement(2, "i", 41);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r23 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-controls", ctx_r23.sideId)("aria-label", ctx_r23.translations.closeMenu);
} }
function HeaderComponent_div_19_div_9_Template(rf, ctx) { if (rf & 1) {
    var _r31 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 35);
    ɵngcc0.ɵɵlistener("@column.done", function HeaderComponent_div_19_div_9_Template_div_animation_column_done_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r31); var ctx_r30 = ɵngcc0.ɵɵnextContext(2); return ctx_r30.onColumnAnimation($event); });
    ɵngcc0.ɵɵelementStart(1, "div", 42);
    ɵngcc0.ɵɵelementStart(2, "button", 43);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_div_19_div_9_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r31); var ctx_r32 = ɵngcc0.ɵɵnextContext(2); return ctx_r32.back(); });
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(3, "svg", 44);
    ɵngcc0.ɵɵelement(4, "path", 45);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementStart(6, "div", 46);
    ɵngcc0.ɵɵelementContainer(7, 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var column_r28 = ctx.$implicit;
    var last_r29 = ctx.last;
    var ctx_r24 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("@column", last_r29 ? "visible" : "hidden");
    ɵngcc0.ɵɵattribute("id", column_r28.id);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("aria-controls", column_r28.id);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r24.translations.back, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", column_r28.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(6, _c45, column_r28));
} }
var _c46 = function (a1) { return { position: "side", device: a1 }; };
function HeaderComponent_div_19_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 47);
    ɵngcc0.ɵɵelementContainer(1, 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r25 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r25.footerRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c46, ctx_r25.device));
} }
function HeaderComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    var _r34 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 30);
    ɵngcc0.ɵɵlistener("@float.done", function HeaderComponent_div_19_Template_div_animation_float_done_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r34); var ctx_r33 = ɵngcc0.ɵɵnextContext(); return ctx_r33.onFloatAnimation($event); });
    ɵngcc0.ɵɵelementStart(1, "div", 31);
    ɵngcc0.ɵɵtemplate(2, HeaderComponent_div_19_div_2_Template, 3, 2, "div", 32);
    ɵngcc0.ɵɵelementStart(3, "div", 33);
    ɵngcc0.ɵɵelementContainer(4, 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 34);
    ɵngcc0.ɵɵelementStart(6, "div", 35);
    ɵngcc0.ɵɵlistener("@column.done", function HeaderComponent_div_19_Template_div_animation_column_done_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r34); var ctx_r35 = ɵngcc0.ɵɵnextContext(); return ctx_r35.onColumnAnimation($event); });
    ɵngcc0.ɵɵelementStart(7, "div", 36);
    ɵngcc0.ɵɵelementContainer(8, 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, HeaderComponent_div_19_div_9_Template, 8, 8, "div", 37);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(10, HeaderComponent_div_19_div_10_Template, 2, 4, "div", 38);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r13 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("@float", "visible");
    ɵngcc0.ɵɵattribute("id", ctx_r13.sideId);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r13.navigation);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r13.extraRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(10, _c46, ctx_r13.device));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("@column", ctx_r13.columns.length === 0 ? "visible-main" : "hidden");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r13.navigation)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(12, _c45, ctx_r13.sideContext));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r13.columns);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r13.footerRef);
} }
var _c47 = [[["after"]]];
var _c48 = function (a0, a1) { return [a0, a1]; };
var _c49 = ["after"];
function SidenavComponent_div_8_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    var _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵlistener("@column.done", function SidenavComponent_div_8_ng_container_4_ng_container_1_Template_div_animation_column_done_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); var ctx_r7 = ɵngcc0.ɵɵnextContext(3); return ctx_r7.onColumnAnimation($event); });
    ɵngcc0.ɵɵelementStart(2, "div", 16);
    ɵngcc0.ɵɵelementStart(3, "button", 17);
    ɵngcc0.ɵɵlistener("click", function SidenavComponent_div_8_ng_container_4_ng_container_1_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r8); var ctx_r9 = ɵngcc0.ɵɵnextContext(3); return ctx_r9.back(); });
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(4, "svg", 18);
    ɵngcc0.ɵɵelement(5, "path", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementStart(7, "div", 20);
    ɵngcc0.ɵɵelementContainer(8, 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var column_r5 = ctx.$implicit;
    var last_r6 = ctx.last;
    var ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("cds-nav-columns__column--active", last_r6);
    ɵngcc0.ɵɵproperty("@column", last_r6 ? "visible" : "hidden");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("aria-controls", column_r5.id);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.translations.back, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", column_r5.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(7, _c45, column_r5));
} }
function SidenavComponent_div_8_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, SidenavComponent_div_8_ng_container_4_ng_container_1_Template, 9, 9, "ng-container", 15);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.columns);
} }
function SidenavComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    var _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵlistener("@column.done", function SidenavComponent_div_8_Template_div_animation_column_done_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); var ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.onColumnAnimation($event); });
    ɵngcc0.ɵɵelementStart(2, "div", 13);
    ɵngcc0.ɵɵelementContainer(3, 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, SidenavComponent_div_8_ng_container_4_Template, 2, 1, "ng-container", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("id", ctx_r0.columnsId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("cds-nav-columns__column--active", ctx_r0.columns.length === 0);
    ɵngcc0.ɵɵproperty("@column", ctx_r0.columns.length === 0 || ctx_r0.float ? "visible-main" : "hidden");
    ɵngcc0.ɵɵattribute("id", ctx_r0.main.id);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.navigation)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(8, _c45, ctx_r0.main));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.float);
} }
function SidenavComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵelementContainer(1, 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.footerRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c46, ctx_r1.device));
} }
function SidenavComponent_div_10_div_2_Template(rf, ctx) { if (rf & 1) {
    var _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵlistener("@column.done", function SidenavComponent_div_10_div_2_Template_div_animation_column_done_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); var ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.onColumnAnimation($event); });
    ɵngcc0.ɵɵelementStart(1, "div", 16);
    ɵngcc0.ɵɵelementStart(2, "button", 17);
    ɵngcc0.ɵɵlistener("click", function SidenavComponent_div_10_div_2_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r16); var ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.back(); });
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(3, "svg", 18);
    ɵngcc0.ɵɵelement(4, "path", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementStart(6, "div", 20);
    ɵngcc0.ɵɵelementContainer(7, 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var column_r13 = ctx.$implicit;
    var last_r14 = ctx.last;
    var ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("@column", last_r14 ? "visible" : "hidden");
    ɵngcc0.ɵɵattribute("id", column_r13.id);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("aria-controls", column_r13.id);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r12.translations.back, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", column_r13.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(6, _c45, column_r13));
} }
function SidenavComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵtemplate(2, SidenavComponent_div_10_div_2_Template, 8, 8, "div", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("@float", "visible");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.columns);
} }
var _c50 = ["scrollable"];
function AppLayoutComponent_cds_nav_overlay_3_Template(rf, ctx) { if (rf & 1) {
    var _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "cds-nav-overlay", 8);
    ɵngcc0.ɵɵlistener("click", function AppLayoutComponent_cds_nav_overlay_3_Template_cds_nav_overlay_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); var ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.overlayClick(); });
    ɵngcc0.ɵɵelementEnd();
} }
var _c51 = [[["aside"], ["cds-sidenav"]], [["header"], ["cds-header"]], [["main"]], [["footer"]]];
var _c52 = ["aside,cds-sidenav", "header,cds-header", "main", "footer"];
var _c53 = ["expandRow"];
var _c54 = ["expand", ""];
function ListRowExpandComponent_ng_template_2_Template(rf, ctx) { }
var _c55 = [[["cds-slot-title"], ["header"]], [["", 5, "cds-slot-title", 5, "header"]]];
var _c56 = ["cds-slot-title,header", ":not(cds-slot-title):not(header)"];
var _c57 = [[["", "head", ""]], [["", 3, "head", ""]]];
var _c58 = ["[head]", ":not([head])"];
function NotificationComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 9);
} }
function NotificationComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.translations.alert);
} }
var _c59 = [[["meta"]], [["picture"], ["img"]], [["cds-slot-title"], ["header"]], [["cds-slot-content"], ["section"]], [["action"]]];
var _c60 = ["meta", "picture,img", "cds-slot-title,header", "cds-slot-content,section", "action"];
function PagerComponent_div_0_li_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 21);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var item_r9 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("cdsComboItem", item_r9);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r9);
} }
function PagerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    var _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵelementStart(1, "span", 17);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "cds-combo", 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function PagerComponent_div_0_Template_cds_combo_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); var ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.pageSize = $event; })("ngModelChange", function PagerComponent_div_0_Template_cds_combo_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r11); var ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.pageSizeChanged(); });
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "ul");
    ɵngcc0.ɵɵtemplate(7, PagerComponent_div_0_li_7_Template, 2, 2, "li", 19);
    ɵngcc0.ɵɵpipe(8, "cdsPagerSizes");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(9, " | ");
    ɵngcc0.ɵɵelementStart(10, "span", 20);
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵpipe(12, "cdsPagerInterpolate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r0.translations.itemsPerPage, ":");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("appearance", "inline")("ngModel", ctx_r0.pageSize);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r0.translations.itemsPerPage + ": " + ctx_r0.pageSize);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.pageSize);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind2(8, 7, ctx_r0.pageSizes, ctx_r0.pageSize));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind4(12, 10, ctx_r0.translations.visibleItems, ctx_r0.fromElement, ctx_r0.toElement, ctx_r0.totalElements));
} }
function PagerComponent_i_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 22);
} }
function PagerComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.translations.previous);
} }
function PagerComponent_div_11_ng_container_1_button_1_Template(rf, ctx) { if (rf & 1) {
    var _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 27);
    ɵngcc0.ɵɵlistener("click", function PagerComponent_div_11_ng_container_1_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r19); var page_r14 = ɵngcc0.ɵɵnextContext().$implicit; var ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.changePage(page_r14); });
    ɵngcc0.ɵɵpipe(1, "cdsPagerInterpolate");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var page_r14 = ɵngcc0.ɵɵnextContext().$implicit;
    var ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("cds-pager__current-number", page_r14 === ctx_r15.currentPage)("cds-pager__number", page_r14 !== ctx_r15.currentPage);
    ɵngcc0.ɵɵattribute("aria-current", page_r14 === ctx_r15.currentPage ? "page" : null)("aria-label", ɵngcc0.ɵɵpipeBind2(1, 7, ctx_r15.translations.pageNumber, page_r14) + (page_r14 === ctx_r15.currentPage ? ", " + ctx_r15.translations.currentPage : ""));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(page_r14);
} }
function PagerComponent_div_11_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 28);
    ɵngcc0.ɵɵtext(1, "...");
    ɵngcc0.ɵɵelementEnd();
} }
function PagerComponent_div_11_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, PagerComponent_div_11_ng_container_1_button_1_Template, 3, 10, "button", 25);
    ɵngcc0.ɵɵtemplate(2, PagerComponent_div_11_ng_container_1_div_2_Template, 2, 0, "div", 26);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var page_r14 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", page_r14);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !page_r14);
} }
function PagerComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵtemplate(1, PagerComponent_div_11_ng_container_1_Template, 3, 2, "ng-container", 24);
    ɵngcc0.ɵɵpipe(2, "cdsGeneratePages");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind2(2, 1, ctx_r4.totalPages, ctx_r4.currentPage));
} }
function PagerComponent_i_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 29);
} }
function PagerComponent_ng_template_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    var ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.translations.next);
} }
var _c61 = ["dropdownTemplate"];
var _c62 = ["arrow"];
function PopoverToolbarComponent_cds_dropdown_3_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
var _c63 = function () { return { "cds-dropdown--menu": false }; };
function PopoverToolbarComponent_cds_dropdown_3_Template(rf, ctx) { if (rf & 1) {
    var _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "cds-dropdown", 5, 6);
    ɵngcc0.ɵɵlistener("dismiss", function PopoverToolbarComponent_cds_dropdown_3_Template_cds_dropdown_dismiss_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); var ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.close(); });
    ɵngcc0.ɵɵelementStart(2, "div", 7);
    ɵngcc0.ɵɵtemplate(3, PopoverToolbarComponent_cds_dropdown_3_ng_container_3_Template, 1, 0, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    var _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction0(3, _c63))("anchor", _r0);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.template);
} }
function PopoverToolbarComponent_ng_template_4_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function PopoverToolbarComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    var _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "cds-dropdown", 5, 6);
    ɵngcc0.ɵɵlistener("dismiss", function PopoverToolbarComponent_ng_template_4_Template_cds_dropdown_dismiss_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); var ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.close(); });
    ɵngcc0.ɵɵelementStart(2, "div", 7);
    ɵngcc0.ɵɵtemplate(3, PopoverToolbarComponent_ng_template_4_ng_container_3_Template, 1, 0, "ng-container", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    var _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction0(4, _c63))("anchor", _r0);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r3.template)("ngTemplateOutletContext", ctx_r3.context);
} }
function PopoverToolbarComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10, 11);
    ɵngcc0.ɵɵelementStart(2, "div", 12);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(3, "svg", 13);
    ɵngcc0.ɵɵelement(4, "path", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("cds-popover-toolbar__arrow-transition", ctx_r4.transition);
    ɵngcc0.ɵɵproperty("@arrow", 1);
} }
var _c64 = [[["cds-slot-title"], ["header"]], [["header-action"]], [["cds-slot-content"], ["section"]], [["cds-slot-footer"], ["footer"]]];
var _c65 = ["cds-slot-title,header", "header-action", "cds-slot-content,section", "cds-slot-footer,footer"];
function RadioComponent_label_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("id", ctx_r0.labelId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.label);
} }
function StepperComponent_div_6_ng_container_2_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 14);
} }
function StepperComponent_div_6_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵelementStart(2, "div", 12);
    ɵngcc0.ɵɵtemplate(3, StepperComponent_div_6_ng_container_2_div_3_Template, 1, 0, "div", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var i_r6 = ctx.index;
    var ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("cds-stepper__step--hover", ctx_r4.isHover(i_r6) && i_r6 !== ctx_r4.activeIndex)("cds-stepper__step--focus", ctx_r4.isFocused(i_r6) && i_r6 !== ctx_r4.activeIndex)("cds-stepper__step--pending", ctx_r4.isPending(i_r6))("cds-stepper__step--filled", ctx_r4.isFilled(i_r6))("cds-stepper__step--filled-active", ctx_r4.isFilledActive(i_r6))("cds-stepper__step--filled-pending", ctx_r4.isFilledPending(i_r6))("cds-stepper__step--active", ctx_r4.isActive(i_r6))("cds-stepper__step--clickable", ctx_r4.isClickable(i_r6));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.isFilled(i_r6) || ctx_r4.isFilledActive(i_r6));
} }
function StepperComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵtemplate(2, StepperComponent_div_6_ng_container_2_Template, 4, 17, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("padding-left", ctx_r0.containerPadding, "px")("padding-right", ctx_r0.containerPadding, "px");
    ɵngcc0.ɵɵclassProp("cds-stepper__desktop-container", ctx_r0.device === "desktop");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.labels);
} }
var _c66 = function (a0) { return { message: a0, placement: "bottom" }; };
function StepperComponent_div_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    var _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 16);
    ɵngcc0.ɵɵlistener("mouseenter", function StepperComponent_div_7_ng_container_1_Template_div_mouseenter_1_listener() { ɵngcc0.ɵɵrestoreView(_r12); var i_r10 = ctx.index; var ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.hoverIndex = i_r10; })("mouseleave", function StepperComponent_div_7_ng_container_1_Template_div_mouseleave_1_listener() { ɵngcc0.ɵɵrestoreView(_r12); var ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.hoverIndex = null; })("focus", function StepperComponent_div_7_ng_container_1_Template_div_focus_1_listener() { ɵngcc0.ɵɵrestoreView(_r12); var i_r10 = ctx.index; var ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.focusIndex = i_r10; })("blur", function StepperComponent_div_7_ng_container_1_Template_div_blur_1_listener() { ɵngcc0.ɵɵrestoreView(_r12); var ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.focusIndex = null; })("keydown.Enter", function StepperComponent_div_7_ng_container_1_Template_div_keydown_Enter_1_listener() { ɵngcc0.ɵɵrestoreView(_r12); var i_r10 = ctx.index; var ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.device !== "desktop" && ctx_r16.onStepSelect(i_r10); })("click", function StepperComponent_div_7_ng_container_1_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r12); var i_r10 = ctx.index; var ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.onStepSelect(i_r10); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var label_r9 = ctx.$implicit;
    var i_r10 = ctx.index;
    var ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("cursor", ctx_r8.isClickable(i_r10) ? "pointer" : "auto");
    ɵngcc0.ɵɵproperty("cdsTooltipHover", i_r10 !== ctx_r8.activeIndex && ctx_r8.device === "tablet" ? ɵngcc0.ɵɵpureFunction1(4, _c66, label_r9) : null)("tabindex", ctx_r8.isClickable(i_r10) && ctx_r8.device !== "desktop" ? 0 : -1);
} }
function StepperComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵtemplate(1, StepperComponent_div_7_ng_container_1_Template, 2, 6, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.labels);
} }
function StepperComponent_div_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    var _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 18);
    ɵngcc0.ɵɵlistener("mouseenter", function StepperComponent_div_8_ng_container_1_Template_div_mouseenter_1_listener() { ɵngcc0.ɵɵrestoreView(_r22); var i_r20 = ctx.index; var ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ctx_r21.hoverIndex = i_r20; })("mouseleave", function StepperComponent_div_8_ng_container_1_Template_div_mouseleave_1_listener() { ɵngcc0.ɵɵrestoreView(_r22); var ctx_r23 = ɵngcc0.ɵɵnextContext(2); return ctx_r23.hoverIndex = null; })("focus", function StepperComponent_div_8_ng_container_1_Template_div_focus_1_listener() { ɵngcc0.ɵɵrestoreView(_r22); var i_r20 = ctx.index; var ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ctx_r24.focusIndex = i_r20; })("blur", function StepperComponent_div_8_ng_container_1_Template_div_blur_1_listener() { ɵngcc0.ɵɵrestoreView(_r22); var ctx_r25 = ɵngcc0.ɵɵnextContext(2); return ctx_r25.focusIndex = null; })("click", function StepperComponent_div_8_ng_container_1_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r22); var i_r20 = ctx.index; var ctx_r26 = ɵngcc0.ɵɵnextContext(2); return ctx_r26.onStepSelect(i_r20); })("keydown.Enter", function StepperComponent_div_8_ng_container_1_Template_div_keydown_Enter_1_listener() { ɵngcc0.ɵɵrestoreView(_r22); var i_r20 = ctx.index; var ctx_r27 = ɵngcc0.ɵɵnextContext(2); return ctx_r27.device === "desktop" && ctx_r27.onStepSelect(i_r20); });
    ɵngcc0.ɵɵelementStart(2, "span", 19);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var label_r19 = ctx.$implicit;
    var i_r20 = ctx.index;
    var ctx_r18 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("visibility", ctx_r18.getLabelVisibility(i_r20));
    ɵngcc0.ɵɵclassProp("cds-stepper__label--hover", ctx_r18.isHover(i_r20) && i_r20 !== ctx_r18.activeIndex)("cds-stepper__label--active", ctx_r18.isActive(i_r20) && i_r20 === ctx_r18.activeIndex || ctx_r18.isFilledActive(i_r20))("cds-stepper__label--clickable", ctx_r18.isClickable(i_r20))("cds-stepper__label-no-wrap", ctx_r18.device === "tablet");
    ɵngcc0.ɵɵproperty("tabindex", ctx_r18.isClickable(i_r20) && ctx_r18.device === "desktop" ? 0 : -1);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r18.showStepNumber ? i_r20 + 1 + ". " + label_r19 : label_r19);
} }
function StepperComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtemplate(1, StepperComponent_div_8_ng_container_1_Template, 4, 12, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.labels);
} }
function StepperComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵelementStart(1, "div", 19);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.shortStepperLabel, " ");
} }
function SwitchComponent_label_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("id", ctx_r0.labelId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.label);
} }
function TabComponent_i_4_Template(rf, ctx) { if (rf & 1) {
    var _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 6);
    ɵngcc0.ɵɵlistener("mousedown", function TabComponent_i_4_Template_i_mousedown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); return $event.preventDefault(); })("click", function TabComponent_i_4_Template_i_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); var ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onRemove($event, true); });
    ɵngcc0.ɵɵelementEnd();
} }
function TextareaComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.labelValue);
} }
function TextareaComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("cds-control__status--shift", ctx_r3.resize && ctx_r3.resize !== "none");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r3.value ? ctx_r3.value.length : "0", " / ", ctx_r3.limit, "");
} }
function TextareaComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 10);
} if (rf & 2) {
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    var _r1 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵproperty("cdsResize", ctx_r4.resize)("resizeVerticalElement", _r1)("resizeHorizontalElement", ctx_r4.elementRef.nativeElement);
} }
function ToastWrapperComponent_ng_template_0_Template(rf, ctx) { }
function ToastComponent_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 6);
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("cds-icon-status-", ctx_r0.status, " cds-icon--size-24 cds-toast__status-icon");
} }
function ToastComponent_i_5_Template(rf, ctx) { if (rf & 1) {
    var _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 7);
    ɵngcc0.ɵɵlistener("focus", function ToastComponent_i_5_Template_i_focus_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); var ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onCloseButtonFocus(); })("blur", function ToastComponent_i_5_Template_i_blur_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); var ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onCloseButtonBlur(); })("click", function ToastComponent_i_5_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); var ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.toastClose.emit(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("aria-hidden", !ctx_r1.isCloseButtonFocused ? "true" : null)("aria-label", ctx_r1.translations.close);
} }
var _c67 = [[["cds-slot-title"], ["header"]], [["cds-slot-content"], ["section"], ["cds-slot-footer"], ["footer"]]];
var _c68 = ["cds-slot-title,header", "cds-slot-content,section,cds-slot-footer,footer"];
var _c69 = ["fileInfo"];
var _c70 = ["filesWrapper"];
function UploadComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var file_r8 = ctx.file;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", file_r8.file.name, " ");
} }
function UploadComponent_ul_5_li_9_cds_progress_spinner_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "cds-progress-spinner", 30);
} if (rf & 2) {
    var file_r11 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("progress", file_r11.status.progress);
} }
function UploadComponent_ul_5_li_9_cds_progress_spinner_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "cds-progress-spinner", 30);
} if (rf & 2) {
    var file_r11 = ɵngcc0.ɵɵnextContext().$implicit;
    var ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("progress", 0);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r14.fileStates[file_r11.status.state]);
} }
function UploadComponent_ul_5_li_9_i_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 31);
} if (rf & 2) {
    var file_r11 = ɵngcc0.ɵɵnextContext().$implicit;
    var ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r15.fileStates[file_r11.status.state]);
} }
function UploadComponent_ul_5_li_9_i_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 32);
} if (rf & 2) {
    var file_r11 = ɵngcc0.ɵɵnextContext().$implicit;
    var ctx_r16 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵattribute("aria-label", file_r11.status.message ? file_r11.status.message : ctx_r16.fileStates[file_r11.status.state]);
} }
var _c71 = function (a0) { return { file: a0 }; };
function UploadComponent_ul_5_li_9_Template(rf, ctx) { if (rf & 1) {
    var _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 17);
    ɵngcc0.ɵɵlistener("@animation.start", function UploadComponent_ul_5_li_9_Template_li_animation_animation_start_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); ɵngcc0.ɵɵnextContext(); var _r9 = ɵngcc0.ɵɵreference(1); var ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.onAnimation($event, _r9); })("@animation.done", function UploadComponent_ul_5_li_9_Template_li_animation_animation_done_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); ɵngcc0.ɵɵnextContext(); var _r9 = ɵngcc0.ɵɵreference(1); var ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.onAnimation($event, _r9); });
    ɵngcc0.ɵɵelementStart(1, "span", 18);
    ɵngcc0.ɵɵelementContainer(2, 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 20);
    ɵngcc0.ɵɵelementStart(4, "span", 21);
    ɵngcc0.ɵɵelementStart(5, "span", 22);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerStart(7, 23);
    ɵngcc0.ɵɵtemplate(8, UploadComponent_ul_5_li_9_cds_progress_spinner_8_Template, 1, 1, "cds-progress-spinner", 24);
    ɵngcc0.ɵɵtemplate(9, UploadComponent_ul_5_li_9_cds_progress_spinner_9_Template, 1, 2, "cds-progress-spinner", 24);
    ɵngcc0.ɵɵtemplate(10, UploadComponent_ul_5_li_9_i_10_Template, 1, 1, "i", 25);
    ɵngcc0.ɵɵtemplate(11, UploadComponent_ul_5_li_9_i_11_Template, 1, 1, "i", 26);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "span", 27);
    ɵngcc0.ɵɵelementStart(13, "button", 28);
    ɵngcc0.ɵɵlistener("click", function UploadComponent_ul_5_li_9_Template_button_click_13_listener() { ɵngcc0.ɵɵrestoreView(_r22); var file_r11 = ctx.$implicit; var index_r12 = ctx.index; var ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ctx_r24.removeFile(file_r11, index_r12); });
    ɵngcc0.ɵɵelement(14, "i", 29);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var file_r11 = ctx.$implicit;
    var ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    var _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵclassProp("cds-upload__file--completed", file_r11.status.state === "COMPLETED")("cds-upload__file--error", file_r11.status.state === "ERROR");
    ɵngcc0.ɵɵproperty("@animation", ctx_r10.withAnimation);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r10.fileInfo || _r0)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(14, _c71, file_r11));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(file_r11.status.state === "ERROR" && file_r11.status.message ? file_r11.status.message : ctx_r10.fileStates[file_r11.status.state]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitch", file_r11.status.state);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "IN_PROGRESS");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "PENDING");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "COMPLETED");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "ERROR");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r10.translations.remove);
} }
function UploadComponent_ul_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 12, 13);
    ɵngcc0.ɵɵelementStart(2, "li", 14);
    ɵngcc0.ɵɵelementStart(3, "span", 15);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "span", 15);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "span", 15);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, UploadComponent_ul_5_li_9_Template, 15, 16, "li", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("aria-label", ctx_r3.ariaLabel);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.translations.srFileName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.translations.srUploadStatus);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.translations.srActions);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.filesList);
} }
function UploadComponent_div_6_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 36);
    ɵngcc0.ɵɵelementStart(1, "g", 37);
    ɵngcc0.ɵɵelementStart(2, "g", 38);
    ɵngcc0.ɵɵelement(3, "rect", 39);
    ɵngcc0.ɵɵelement(4, "path", 40);
    ɵngcc0.ɵɵelement(5, "ellipse", 41);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "rect", 42);
    ɵngcc0.ɵɵelement(7, "rect", 43);
    ɵngcc0.ɵɵelement(8, "ellipse", 44);
    ɵngcc0.ɵɵelement(9, "ellipse", 45);
    ɵngcc0.ɵɵelement(10, "ellipse", 46);
    ɵngcc0.ɵɵelement(11, "ellipse", 47);
    ɵngcc0.ɵɵelement(12, "path", 48);
    ɵngcc0.ɵɵelement(13, "path", 49);
    ɵngcc0.ɵɵelement(14, "path", 50);
    ɵngcc0.ɵɵelement(15, "ellipse", 51);
    ɵngcc0.ɵɵelement(16, "ellipse", 52);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function UploadComponent_div_6__svg_svg_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 53);
    ɵngcc0.ɵɵelement(1, "path", 54);
    ɵngcc0.ɵɵelement(2, "rect", 55);
    ɵngcc0.ɵɵelement(3, "path", 56);
    ɵngcc0.ɵɵelement(4, "circle", 57);
    ɵngcc0.ɵɵelementStart(5, "g", 58);
    ɵngcc0.ɵɵelement(6, "path", 59);
    ɵngcc0.ɵɵelement(7, "path", 60);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function UploadComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 33);
    ɵngcc0.ɵɵtemplate(1, UploadComponent_div_6_ng_template_1_Template, 17, 0, "ng-template", null, 34, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(3, UploadComponent_div_6__svg_svg_3_Template, 8, 0, "svg", 35);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var _r25 = ɵngcc0.ɵɵreference(2);
    var ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("@animation", ctx_r4.withAnimation);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.dragAndDropSupport)("ngIfElse", _r25);
} }
function UploadComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    var _r29 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 61);
    ɵngcc0.ɵɵlistener("click", function UploadComponent_ng_template_9_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r29); ɵngcc0.ɵɵnextContext(); var _r2 = ɵngcc0.ɵɵreference(4); return _r2.click(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("aria-describedby", ctx_r6.descriptionId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.translations.add);
} }
function UploadComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    var _r31 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 22);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 62);
    ɵngcc0.ɵɵlistener("click", function UploadComponent_ng_container_11_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r31); ɵngcc0.ɵɵnextContext(); var _r2 = ɵngcc0.ɵɵreference(4); return _r2.click(); });
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.translations.dragAndDrop);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-describedby", ctx_r7.descriptionId)("aria-label", ctx_r7.translations.add);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.translations.browse);
} }
function UploadToastComponent_li_18_cds_progress_spinner_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "cds-progress-spinner", 22);
} if (rf & 2) {
    var file_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("progress", file_r2.status.progress);
} }
function UploadToastComponent_li_18_cds_progress_spinner_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "cds-progress-spinner", 22);
} if (rf & 2) {
    var file_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    var ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("progress", 0);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r5.fileStates[file_r2.status.state]);
} }
function UploadToastComponent_li_18_i_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 23);
} if (rf & 2) {
    var file_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    var ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("aria-label", ctx_r6.fileStates[file_r2.status.state]);
} }
function UploadToastComponent_li_18_i_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 24);
} if (rf & 2) {
    var file_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    var ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("aria-label", file_r2.status.message ? file_r2.status.message : ctx_r7.fileStates[file_r2.status.state]);
} }
function UploadToastComponent_li_18_Template(rf, ctx) { if (rf & 1) {
    var _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 10);
    ɵngcc0.ɵɵlistener("@animationFile.start", function UploadToastComponent_li_18_Template_li_animation_animationFile_start_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); var ctx_r12 = ɵngcc0.ɵɵnextContext(); var _r0 = ɵngcc0.ɵɵreference(9); return ctx_r12.onAnimation($event, _r0); })("@animationFile.done", function UploadToastComponent_li_18_Template_li_animation_animationFile_done_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); var ctx_r14 = ɵngcc0.ɵɵnextContext(); var _r0 = ɵngcc0.ɵɵreference(9); return ctx_r14.onAnimation($event, _r0); });
    ɵngcc0.ɵɵelementStart(1, "span", 11);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 12);
    ɵngcc0.ɵɵelementStart(4, "span", 13);
    ɵngcc0.ɵɵelementStart(5, "span", 14);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerStart(7, 15);
    ɵngcc0.ɵɵtemplate(8, UploadToastComponent_li_18_cds_progress_spinner_8_Template, 1, 1, "cds-progress-spinner", 16);
    ɵngcc0.ɵɵtemplate(9, UploadToastComponent_li_18_cds_progress_spinner_9_Template, 1, 2, "cds-progress-spinner", 16);
    ɵngcc0.ɵɵtemplate(10, UploadToastComponent_li_18_i_10_Template, 1, 1, "i", 17);
    ɵngcc0.ɵɵtemplate(11, UploadToastComponent_li_18_i_11_Template, 1, 1, "i", 18);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "span", 19);
    ɵngcc0.ɵɵelementStart(13, "button", 20);
    ɵngcc0.ɵɵlistener("click", function UploadToastComponent_li_18_Template_button_click_13_listener() { ɵngcc0.ɵɵrestoreView(_r13); var file_r2 = ctx.$implicit; var index_r3 = ctx.index; var ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.removeFile(file_r2, index_r3); });
    ɵngcc0.ɵɵelement(14, "i", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var file_r2 = ctx.$implicit;
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("cds-upload-toast__file--completed", file_r2.status.state === "COMPLETED")("cds-upload-toast__file--error", file_r2.status.state === "ERROR");
    ɵngcc0.ɵɵproperty("@animationFile", ctx_r1.withAnimation);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(file_r2.file.name);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(file_r2.status.state === "ERROR" && file_r2.status.message ? file_r2.status.message : ctx_r1.fileStates[file_r2.status.state]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitch", file_r2.status.state);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "IN_PROGRESS");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "PENDING");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "COMPLETED");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "ERROR");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r1.translations.remove);
} }
var BadgeDirective = /** @class */ (function () {
    function BadgeDirective(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.isAbove = true;
        this.isAfter = true;
        this.hidden = false;
        this.position = 'above after';
        this.renderer.addClass(elementRef.nativeElement, 'cds-badge');
        this.renderer.insertBefore(this.elementRef.nativeElement, this.createBadgeElement(), null);
    }
    Object.defineProperty(BadgeDirective.prototype, "classAbove", {
        get: function () {
            return this.isAbove;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BadgeDirective.prototype, "classBelow", {
        get: function () {
            return !this.isAbove;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BadgeDirective.prototype, "classBefore", {
        get: function () {
            return !this.isAfter;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BadgeDirective.prototype, "classAfter", {
        get: function () {
            return this.isAfter;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BadgeDirective.prototype, "classHidden", {
        get: function () {
            return this.hidden || (!this.content && this.content !== 0);
        },
        enumerable: true,
        configurable: true
    });
    BadgeDirective.prototype.ngOnChanges = function (changes) {
        if ('position' in changes) {
            this.isAbove = this.position.indexOf('above') !== -1;
            this.isAfter = this.position.indexOf('after') !== -1;
        }
        if ('content' in changes) {
            this.renderer.setAttribute(this.badgeContentElement, 'title', "" + this.content);
        }
        if ('content' in changes || 'maxValue' in changes) {
            var content = this.maxValue && this.content > this.maxValue ? this.maxValue + "+" : "" + this.content;
            this.renderer.setProperty(this.badgeContentElement, 'textContent', content);
        }
    };
    BadgeDirective.prototype.createBadgeElement = function () {
        var badgeElement = this.renderer.createElement('span');
        this.renderer.addClass(badgeElement, 'cds-badge__wrapper');
        this.badgeContentElement = badgeElement;
        return badgeElement;
    };
    BadgeDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
    __decorate([
        Input('cdsBadge'),
        __metadata("design:type", Object)
    ], BadgeDirective.prototype, "content", void 0);
    __decorate([
        Input('badgeMaxValue'),
        __metadata("design:type", Number)
    ], BadgeDirective.prototype, "maxValue", void 0);
    __decorate([
        Input('badgeHidden'),
        __metadata("design:type", Boolean)
    ], BadgeDirective.prototype, "hidden", void 0);
    __decorate([
        Input('badgePosition'),
        __metadata("design:type", String)
    ], BadgeDirective.prototype, "position", void 0);
    __decorate([
        HostBinding('class.cds-badge--above'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], BadgeDirective.prototype, "classAbove", null);
    __decorate([
        HostBinding('class.cds-badge--below'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], BadgeDirective.prototype, "classBelow", null);
    __decorate([
        HostBinding('class.cds-badge--before'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], BadgeDirective.prototype, "classBefore", null);
    __decorate([
        HostBinding('class.cds-badge--after'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], BadgeDirective.prototype, "classAfter", null);
    __decorate([
        HostBinding('class.cds-badge--hidden'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], BadgeDirective.prototype, "classHidden", null);
    BadgeDirective = __decorate([ __metadata("design:paramtypes", [ElementRef, Renderer2])
    ], BadgeDirective);
BadgeDirective.ɵfac = function BadgeDirective_Factory(t) { return new (t || BadgeDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
BadgeDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BadgeDirective, selectors: [["", "cdsBadge", ""]], hostVars: 10, hostBindings: function BadgeDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("cds-badge--above", ctx.classAbove)("cds-badge--below", ctx.classBelow)("cds-badge--before", ctx.classBefore)("cds-badge--after", ctx.classAfter)("cds-badge--hidden", ctx.classHidden);
    } }, inputs: { hidden: ["badgeHidden", "hidden"], position: ["badgePosition", "position"], content: ["cdsBadge", "content"], maxValue: ["badgeMaxValue", "maxValue"] }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BadgeDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsBadge]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { hidden: [{
            type: Input,
            args: ['badgeHidden']
        }], position: [{
            type: Input,
            args: ['badgePosition']
        }], classAbove: [{
            type: HostBinding,
            args: ['class.cds-badge--above']
        }], classBelow: [{
            type: HostBinding,
            args: ['class.cds-badge--below']
        }], classBefore: [{
            type: HostBinding,
            args: ['class.cds-badge--before']
        }], classAfter: [{
            type: HostBinding,
            args: ['class.cds-badge--after']
        }], classHidden: [{
            type: HostBinding,
            args: ['class.cds-badge--hidden']
        }], content: [{
            type: Input,
            args: ['cdsBadge']
        }], maxValue: [{
            type: Input,
            args: ['badgeMaxValue']
        }] }); })();
    return BadgeDirective;
}());

var BadgeModule = /** @class */ (function () {
    function BadgeModule() {
    }
BadgeModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BadgeModule });
BadgeModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BadgeModule_Factory(t) { return new (t || BadgeModule)(); }, imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BadgeModule, { declarations: function () { return [BadgeDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BadgeDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BadgeModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                ],
                declarations: [
                    BadgeDirective,
                ],
                exports: [
                    BadgeDirective,
                ]
            }]
    }], function () { return []; }, null); })();
    return BadgeModule;
}());

var BreadcrumbDirective = /** @class */ (function () {
    function BreadcrumbDirective(template) {
        this.template = template;
    }
    BreadcrumbDirective.ctorParameters = function () { return [
        { type: TemplateRef }
    ]; };
    BreadcrumbDirective = __decorate([ __metadata("design:paramtypes", [TemplateRef])
    ], BreadcrumbDirective);
BreadcrumbDirective.ɵfac = function BreadcrumbDirective_Factory(t) { return new (t || BreadcrumbDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
BreadcrumbDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BreadcrumbDirective, selectors: [["", "cdsBreadcrumb", ""]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BreadcrumbDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsBreadcrumb]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
    return BreadcrumbDirective;
}());

var BREADCRUMBS_TRANSLATIONS_EN = {
    collapsedLinks: 'Collapsed links',
};
function breadcrumbsTranslationsFactory() {
    return BREADCRUMBS_TRANSLATIONS_EN;
}
var CDS_BREADCRUMBS_TRANSLATIONS = new InjectionToken('CDS_COMBO_TRANSLATIONS', { factory: breadcrumbsTranslationsFactory });

// @dynamic
var Unique = /** @class */ (function () {
    function Unique() {
    }
    Unique.next = function (prefix) {
        return prefix + ++Unique.sequence;
    };
    Unique.sequence = 0;
    return Unique;
}());

var DynamicTranslations = /** @class */ (function () {
    function DynamicTranslations(injector, cdRef) {
        this.injector = injector;
        this.cdRef = cdRef;
        this.subscriptions = [];
    }
    DynamicTranslations.prototype.use = function (token, factory, cb) {
        var _this = this;
        var obj = this.injector.get(token);
        if (isObservable(obj)) {
            cb(factory());
            this.subscriptions.push(obj.subscribe(function (value) {
                if (_this.cdRef) {
                    _this.cdRef.markForCheck();
                }
                cb(value);
            }));
        }
        else {
            cb(obj);
        }
    };
    DynamicTranslations.prototype.ngOnDestroy = function () {
        var e_1, _a;
        try {
            for (var _b = __values(this.subscriptions), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscription = _c.value;
                subscription.unsubscribe();
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    DynamicTranslations.ctorParameters = function () { return [
        { type: Injector },
        { type: ChangeDetectorRef }
    ]; };
    DynamicTranslations = __decorate([ __metadata("design:paramtypes", [Injector,
            ChangeDetectorRef])
    ], DynamicTranslations);
DynamicTranslations.ɵfac = function DynamicTranslations_Factory(t) { return new (t || DynamicTranslations)(ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(ɵngcc0.ChangeDetectorRef)); };
DynamicTranslations.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DynamicTranslations, factory: function (t) { return DynamicTranslations.ɵfac(t); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DynamicTranslations, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();
    return DynamicTranslations;
}());

var BreadcrumbsComponent = /** @class */ (function () {
    function BreadcrumbsComponent(cdRef, elementRef, renderer, componentTranslations) {
        var _this = this;
        this.cdRef = cdRef;
        this.dropdownId = Unique.next('cds-breadcrumbs__dropdown-');
        this.visible = {};
        this.isOpen = false;
        renderer.addClass(elementRef.nativeElement, 'cds-breadcrumbs');
        renderer.setAttribute(elementRef.nativeElement, 'role', 'navigation');
        componentTranslations.use(CDS_BREADCRUMBS_TRANSLATIONS, breadcrumbsTranslationsFactory, function (translations) {
            _this.translations = translations;
        });
        this.fallback = !window['IntersectionObserver'];
        if (!this.fallback) {
            this.intersection = new IntersectionObserver(function (entries) {
                var e_1, _a;
                try {
                    for (var entries_1 = __values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
                        var entry = entries_1_1.value;
                        var element = entry.target;
                        var index = element.dataset['index'];
                        _this.visible[index] = entry.boundingClientRect.width === entry.intersectionRect.width;
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                _this.updateBreadcrumbs(_this.breadcrumbs);
                _this.cdRef.detectChanges();
            }, { threshold: [1, 0.99, 0.98, 0.97, 0.96] });
        }
    }
    Object.defineProperty(BreadcrumbsComponent.prototype, "dark", {
        get: function () {
            return this.schema === 'dark';
        },
        enumerable: true,
        configurable: true
    });
    BreadcrumbsComponent.prototype.changeDropdown = function (open) {
        if (this.isOpen !== open) {
            this.isOpen = open;
            this.cdRef.detectChanges();
        }
    };
    BreadcrumbsComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.breadcrumbsList.changes.subscribe(function () {
            var breadcrumbs = _this.breadcrumbsList.toArray();
            _this.updateBreadcrumbs(breadcrumbs);
            _this.cdRef.detectChanges();
        });
        this.breadcrumbsList.notifyOnChanges();
    };
    BreadcrumbsComponent.prototype.updateBreadcrumbs = function (breadcrumbs) {
        this.breadcrumbs = breadcrumbs;
        this.restBreadcrumbs = breadcrumbs.slice();
        this.firstBreadcrumb = this.restBreadcrumbs.shift();
        var lastIndex = this.restBreadcrumbs.length - 1;
        this.visibleBreadcrumbs = [];
        this.collapsedBreadcrumbs = [];
        for (var i = 0; i <= lastIndex; ++i) {
            if (this.visible[i] || (i === lastIndex)) {
                this.visibleBreadcrumbs.push(this.restBreadcrumbs[i]);
            }
            else {
                this.collapsedBreadcrumbs.push(this.restBreadcrumbs[i]);
            }
        }
    };
    BreadcrumbsComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: Renderer2 },
        { type: DynamicTranslations }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], BreadcrumbsComponent.prototype, "schema", void 0);
    __decorate([
        HostBinding('class.cds-breadcrumbs--dark'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], BreadcrumbsComponent.prototype, "dark", null);
    __decorate([
        ContentChildren(BreadcrumbDirective),
        __metadata("design:type", QueryList)
    ], BreadcrumbsComponent.prototype, "breadcrumbsList", void 0);
    BreadcrumbsComponent = __decorate([ __metadata("design:paramtypes", [ChangeDetectorRef,
            ElementRef,
            Renderer2,
            DynamicTranslations])
    ], BreadcrumbsComponent);
BreadcrumbsComponent.ɵfac = function BreadcrumbsComponent_Factory(t) { return new (t || BreadcrumbsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations)); };
BreadcrumbsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BreadcrumbsComponent, selectors: [["cds-breadcrumbs"]], contentQueries: function BreadcrumbsComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, BreadcrumbDirective, false);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.breadcrumbsList = _t);
    } }, hostVars: 2, hostBindings: function BreadcrumbsComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("cds-breadcrumbs--dark", ctx.dark);
    } }, inputs: { schema: "schema" }, features: [ɵngcc0.ɵɵProvidersFeature([
            DynamicTranslations,
        ])], decls: 6, vars: 4, consts: [["aria-hidden", "true", 1, "cds-breadcrumbs__wrapper"], ["class", "cds-breadcrumbs__items cds-breadcrumbs__items--hidden", 4, "ngIf"], [1, "cds-breadcrumbs__items", "cds-breadcrumbs__items--visible", 3, "cds-breadcrumbs__items--single"], ["class", "cds-breadcrumbs__item cds-breadcrumbs__item--link", 4, "ngIf"], [4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "cds-breadcrumbs__items", "cds-breadcrumbs__items--hidden"], [1, "cds-breadcrumbs__item"], [1, "cds-breadcrumbs__separator"], ["class", "cds-breadcrumbs__item", 4, "ngIf"], [1, "cds-breadcrumbs__item", 3, "cdsBreadcrumbObserve"], [3, "ngTemplateOutlet"], [1, "cds-breadcrumbs__item", "cds-breadcrumbs__item--link"], ["aria-hidden", "true", 1, "cds-breadcrumbs__separator"], [3, "click"], ["anchor", ""], [3, "anchor", "dismiss", 4, "ngIf"], [3, "anchor", "dismiss"], [1, "dropdown-list", 3, "click"]], template: function BreadcrumbsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, BreadcrumbsComponent_div_1_Template, 7, 2, "div", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, BreadcrumbsComponent_span_3_Template, 2, 1, "span", 3);
        ɵngcc0.ɵɵtemplate(4, BreadcrumbsComponent_ng_container_4_Template, 8, 4, "ng-container", 4);
        ɵngcc0.ɵɵtemplate(5, BreadcrumbsComponent_ng_container_5_Template, 5, 1, "ng-container", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.fallback);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.firstBreadcrumb);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.collapsedBreadcrumbs.length !== 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.visibleBreadcrumbs);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc1.NgForOf, BreadcrumbObserveDirective, ɵngcc1.NgTemplateOutlet, DropdownComponent]; }, encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BreadcrumbsComponent, [{
        type: Component,
        args: [{
                selector: 'cds-breadcrumbs',
                template: "<div class=\"cds-breadcrumbs__wrapper\" aria-hidden=\"true\">\n\t<div class=\"cds-breadcrumbs__items cds-breadcrumbs__items--hidden\" *ngIf=\"!fallback\">\n\t\t<ng-container *ngFor=\"let breadcrumb of restBreadcrumbs; let index=index\">\n\t\t\t<span class=\"cds-breadcrumbs__item\" [cdsBreadcrumbObserve]=\"intersection\" [attr.data-index]=\"index\"><ng-container [ngTemplateOutlet]=\"breadcrumb.template\"></ng-container></span>\n\t\t\t<span class=\"cds-breadcrumbs__separator\">/</span>\n\t\t</ng-container>\n\t\t<span class=\"cds-breadcrumbs__item\">...</span>\n\t\t<span class=\"cds-breadcrumbs__separator\">/</span>\n\t\t<span class=\"cds-breadcrumbs__item\" *ngIf=\"firstBreadcrumb\"><ng-container [ngTemplateOutlet]=\"firstBreadcrumb.template\"></ng-container></span>\n\t</div>\n</div>\n<div class=\"cds-breadcrumbs__items cds-breadcrumbs__items--visible\" [class.cds-breadcrumbs__items--single]=\"\">\n\t<span class=\"cds-breadcrumbs__item cds-breadcrumbs__item--link\" *ngIf=\"firstBreadcrumb\"><ng-container [ngTemplateOutlet]=\"firstBreadcrumb.template\"></ng-container></span>\n\t<ng-container *ngIf=\"collapsedBreadcrumbs.length !== 0\" >\n\t\t<span class=\"cds-breadcrumbs__separator\" aria-hidden=\"true\">/</span>\n\t\t<span class=\"cds-breadcrumbs__item\">\n\t\t\t<button #anchor (click)=\"changeDropdown(true)\"\n\t\t\t        [attr.aria-expanded]=\"isOpen ? 'true' : 'false'\"\n\t\t\t        [attr.aria-controls]=\"dropdownId\"\n\t\t\t        [attr.aria-label]=\"translations.collapsedLinks\">...</button>\n\t\t\t<cds-dropdown *ngIf=\"isOpen\" [anchor]=\"anchor\" (dismiss)=\"changeDropdown(false)\">\n\t\t\t\t<span class=\"dropdown-list\" [attr.id]=\"dropdownId\" (click)=\"changeDropdown(false)\">\n\t\t\t\t\t<ng-container *ngFor=\"let breadcrumb of collapsedBreadcrumbs\">\n\t\t\t\t\t\t<ng-container [ngTemplateOutlet]=\"breadcrumb.template\"></ng-container>\n\t\t\t\t\t</ng-container>\n\t\t\t\t</span>\n\t\t\t</cds-dropdown>\n\t\t</span>\n\t</ng-container>\n\t<ng-container *ngFor=\"let breadcrumb of visibleBreadcrumbs\">\n\t\t<span class=\"cds-breadcrumbs__separator\" aria-hidden=\"true\">/</span>\n\t\t<span class=\"cds-breadcrumbs__item cds-breadcrumbs__item--link\"><ng-container [ngTemplateOutlet]=\"breadcrumb.template\"></ng-container></span>\n\t</ng-container>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                providers: [
                    DynamicTranslations,
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: DynamicTranslations }]; }, { dark: [{
            type: HostBinding,
            args: ['class.cds-breadcrumbs--dark']
        }], schema: [{
            type: Input
        }], breadcrumbsList: [{
            type: ContentChildren,
            args: [BreadcrumbDirective]
        }] }); })();
    return BreadcrumbsComponent;
}());

var PortalComponent = /** @class */ (function () {
    function PortalComponent() {
        this.animate = 1;
        this.leaveSubject$ = new Subject();
        this.leave$ = this.leaveSubject$.asObservable();
    }
    PortalComponent.prototype.onAnimateDone = function (event) {
        if (event.toState === 'void') {
            this.leaveSubject$.next();
            this.leaveSubject$.complete();
        }
    };
    __decorate([
        HostBinding('@animate'),
        __metadata("design:type", Number)
    ], PortalComponent.prototype, "animate", void 0);
    __decorate([
        ViewChild('template', { read: ViewContainerRef, static: true }),
        __metadata("design:type", ViewContainerRef)
    ], PortalComponent.prototype, "vcRef", void 0);
    __decorate([
        HostListener('@animate.done', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], PortalComponent.prototype, "onAnimateDone", null);
PortalComponent.ɵfac = function PortalComponent_Factory(t) { return new (t || PortalComponent)(); };
PortalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PortalComponent, selectors: [["cds-portal"]], viewQuery: function PortalComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c0, true, ViewContainerRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.vcRef = _t.first);
    } }, hostVars: 1, hostBindings: function PortalComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵsyntheticHostListener("@animate.done", function PortalComponent_animation_animate_done_HostBindingHandler($event) { return ctx.onAnimateDone($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵsyntheticHostProperty("@animate", ctx.animate);
    } }, decls: 2, vars: 0, consts: [["template", ""]], template: function PortalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, PortalComponent_ng_template_0_Template, 0, 0, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
    } }, encapsulation: 2, data: { animation: [
            trigger('animate', [
                transition(':leave', query(':leave', animateChild())),
            ]),
        ] } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PortalComponent, [{
        type: Component,
        args: [{
                selector: 'cds-portal',
                template: '<ng-template #template></ng-template>',
                animations: [
                    trigger('animate', [
                        transition(':leave', query(':leave', animateChild())),
                    ]),
                ]
            }]
    }], function () { return []; }, { animate: [{
            type: HostBinding,
            args: ['@animate']
        }], onAnimateDone: [{
            type: HostListener,
            args: ['@animate.done', ['$event']]
        }], vcRef: [{
            type: ViewChild,
            args: ['template', { read: ViewContainerRef, static: true }]
        }] }); })();
    return PortalComponent;
}());

var PortalModule = /** @class */ (function () {
    function PortalModule() {
    }
PortalModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: PortalModule });
PortalModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function PortalModule_Factory(t) { return new (t || PortalModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PortalModule, { declarations: [PortalComponent] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PortalModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    PortalComponent,
                ],
                entryComponents: [
                    PortalComponent,
                ]
            }]
    }], function () { return []; }, null); })();
    return PortalModule;
}());

/**
 * The directive blocks the propagation of the keydown event beyond the element on which it was placed.
 * Used in conjunction with the caDropdown directive, blocks page scrolling when switching between options.
 *
 * It is not possible to transfer the code to DropdownDirective due to TypeaheadComponent which use this directive.
 * Would block in the typeahead input element the possibility to go to the beginning and end of the text using the arrows on the keyboard.
 */
var DropdownDisableKeydownDirective = /** @class */ (function () {
    function DropdownDisableKeydownDirective() {
    }
    DropdownDisableKeydownDirective.prototype.onKeyDown = function (event) {
        if (this.allowedCodes.indexOf(event.keyCode) === -1) {
            event.stopPropagation();
        }
    };
    __decorate([
        Input('cdsDropdownDisableKeydown'),
        __metadata("design:type", Array)
    ], DropdownDisableKeydownDirective.prototype, "allowedCodes", void 0);
    __decorate([
        HostListener('keydown', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [KeyboardEvent]),
        __metadata("design:returntype", void 0)
    ], DropdownDisableKeydownDirective.prototype, "onKeyDown", null);
DropdownDisableKeydownDirective.ɵfac = function DropdownDisableKeydownDirective_Factory(t) { return new (t || DropdownDisableKeydownDirective)(); };
DropdownDisableKeydownDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DropdownDisableKeydownDirective, selectors: [["", "cdsDropdownDisableKeydown", ""]], hostBindings: function DropdownDisableKeydownDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function DropdownDisableKeydownDirective_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); });
    } }, inputs: { allowedCodes: ["cdsDropdownDisableKeydown", "allowedCodes"] } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DropdownDisableKeydownDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsDropdownDisableKeydown]'
            }]
    }], function () { return []; }, { onKeyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], allowedCodes: [{
            type: Input,
            args: ['cdsDropdownDisableKeydown']
        }] }); })();
    return DropdownDisableKeydownDirective;
}());

var DROPDOWN_EXPAND_HOST = new InjectionToken('DROPDOWN_EXPAND_HOST');
var DROPDOWN_OFFSET = -2;
var DropdownExpandableDirective = /** @class */ (function () {
    function DropdownExpandableDirective(elementRef, renderer, vcRef, host) {
        this.renderer = renderer;
        this.vcRef = vcRef;
        this.host = host;
        this.isOpen = false;
        this.element = elementRef.nativeElement;
    }
    DropdownExpandableDirective.prototype.ngOnInit = function () {
        var arrowElement = this.renderer.createElement('span');
        this.renderer.addClass(arrowElement, 'cds-icon-angle-right');
        this.renderer.addClass(arrowElement, 'cds-icon--size-24');
        this.renderer.addClass(arrowElement, 'cds-dropdown__item-icon');
        this.renderer.appendChild(this.element, arrowElement);
        var _a = this.host.getExpandableOptions(), hostContainer = _a.container, hostScrollParents = _a.scrollParents;
        this.hostContainer = hostContainer;
        if (hostScrollParents) {
            this.hostScrollParents = hostScrollParents.reference;
        }
    };
    DropdownExpandableDirective.prototype.toggle = function () {
        if (!this.isOpen) {
            this.open();
        }
        else {
            this.close();
        }
    };
    DropdownExpandableDirective.prototype.open = function () {
        if (!this.isOpen && this.hostContainer) {
            this.viewRef = this.vcRef.createEmbeddedView(this.expand);
            var insertedView = this.hostContainer.insert(this.viewRef);
            this.idInContainer = this.hostContainer.indexOf(insertedView);
            this.isOpen = true;
        }
    };
    DropdownExpandableDirective.prototype.close = function () {
        if (this.isOpen && this.hostContainer && this.viewRef && this.idInContainer !== undefined) {
            this.hostContainer.remove(this.idInContainer);
            if (this.hostContainer.length === 0) {
                this.hostContainer.clear();
            }
            this.isOpen = false;
            this.viewRef = undefined;
            this.idInContainer = undefined;
        }
    };
    DropdownExpandableDirective.prototype.contains = function (node) {
        if (this.element === node || this.element.contains(node)) {
            return true;
        }
        if (this.isOpen && this.viewRef) {
            return this.viewRef.rootNodes.find(function (rootNode) { return rootNode === node || rootNode.contains(node); });
        }
        return false;
    };
    DropdownExpandableDirective.prototype.getModifiers = function (modifiers) {
        var _this = this;
        modifiers.forEach(function (modifier) {
            if (modifier.data && 'disableInExpandedDropdown' in modifier.data) {
                modifier.enabled = !modifier.data.disableInExpandedDropdown;
            }
        });
        modifiers.push({
            name: 'offset',
            options: {
                offset: [0, DROPDOWN_OFFSET],
            },
        });
        if (this.hostScrollParents) {
            modifiers.push({
                name: 'additionalScrollParents',
                phase: 'write',
                enabled: true,
                effect: function (data) {
                    var instance = data.instance, currentScrollParents = data.state.scrollParents;
                    var scrollParents = _this.hostScrollParents.filter(function (scrollParent) {
                        return !currentScrollParents.reference.includes(scrollParent) && !currentScrollParents.popper.includes(scrollParent);
                    });
                    scrollParents.forEach(function (scrollParent) {
                        scrollParent.addEventListener('scroll', instance.update, { passive: true });
                    });
                    return function () {
                        scrollParents.forEach(function (scrollParent) {
                            scrollParent.removeEventListener('scroll', instance.update);
                        });
                    };
                },
            });
        }
        return modifiers;
    };
    DropdownExpandableDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ViewContainerRef },
        { type: undefined, decorators: [{ type: Host }, { type: Inject, args: [forwardRef(function () { return DROPDOWN_EXPAND_HOST; }),] }] }
    ]; };
    __decorate([
        ContentChild('expand', { static: true, read: TemplateRef }),
        __metadata("design:type", TemplateRef)
    ], DropdownExpandableDirective.prototype, "expand", void 0);
    __decorate([
        HostBinding('class.cds-dropdown__item--expanded'),
        HostBinding('attr.aria-expanded'),
        __metadata("design:type", Object)
    ], DropdownExpandableDirective.prototype, "isOpen", void 0);
    DropdownExpandableDirective = __decorate([ __param(3, Host()), __param(3, Inject(forwardRef(function () { return DROPDOWN_EXPAND_HOST; }))),
        __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            ViewContainerRef, Object])
    ], DropdownExpandableDirective);
DropdownExpandableDirective.ɵfac = function DropdownExpandableDirective_Factory(t) { return new (t || DropdownExpandableDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(forwardRef(function () { return DROPDOWN_EXPAND_HOST; }), 1)); };
DropdownExpandableDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DropdownExpandableDirective, selectors: [["", "cdsDropdownExpandable", ""]], contentQueries: function DropdownExpandableDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, _c1, true, TemplateRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.expand = _t.first);
    } }, hostVars: 3, hostBindings: function DropdownExpandableDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-expanded", ctx.isOpen);
        ɵngcc0.ɵɵclassProp("cds-dropdown__item--expanded", ctx.isOpen);
    } }, exportAs: ["cdsDropdownExpandable"] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DropdownExpandableDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsDropdownExpandable]',
                exportAs: 'cdsDropdownExpandable'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ViewContainerRef }, { type: undefined, decorators: [{
                type: Host
            }, {
                type: Inject,
                args: [forwardRef(function () { return DROPDOWN_EXPAND_HOST; })]
            }] }]; }, { isOpen: [{
            type: HostBinding,
            args: ['class.cds-dropdown__item--expanded']
        }, {
            type: HostBinding,
            args: ['attr.aria-expanded']
        }], expand: [{
            type: ContentChild,
            args: ['expand', { static: true, read: TemplateRef }]
        }] }); })();
    return DropdownExpandableDirective;
}());

function findFocusableElements(parentElement, activeElem, queryString) {
    if (parentElement === void 0) { parentElement = document; }
    if (activeElem === void 0) { activeElem = document.activeElement; }
    var queryResult = Array.prototype.filter.call(parentElement.querySelectorAll(queryString), function (elem) {
        /* check for visibility while always include the current activeElement */
        return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem === activeElem;
    });
    var indexedList = queryResult.slice().filter(function (elem) {
        /* filter out all indexes not greater than 0 */
        return elem.tabIndex == 0 || elem.tabIndex == -1 ? false : true;
    }).sort(function (a, b) {
        /* sort the array by index from smallest to largest */
        return a.tabIndex != 0 && b.tabIndex != 0
            ? (a.tabIndex < b.tabIndex ? -1 : b.tabIndex < a.tabIndex ? 1 : 0)
            : a.tabIndex != 0 ? -1 : b.tabIndex != 0 ? 1 : 0;
    });
    var focusable = [].concat(indexedList, queryResult.filter(function (elem) {
        /* filter out all indexes above 0 */
        return elem.tabIndex == 0 || elem.tabIndex == -1 ? true : false;
    }));
    return focusable;
}

var cache;
function supportOptions() {
    if (cache == null) {
        var result_1 = false;
        try {
            var opts = Object.defineProperty({}, 'capture', {
                get: function () {
                    result_1 = true;
                    return undefined;
                },
            });
            window.addEventListener('test', null, opts);
            window.removeEventListener('test', null, opts);
        }
        catch (e) {
            // do nothing
        }
        cache = result_1;
    }
    return cache;
}
function listen(target, eventName, callback, options) {
    var useOptions = supportOptions();
    var actualOptions = options && (useOptions ? options : !!options.capture);
    var destroy;
    var actualCallback = useOptions || !options || !options.once ? callback : function (event) {
        callback(event);
        destroy();
    };
    target.addEventListener(eventName, actualCallback, actualOptions);
    destroy = function () {
        target.removeEventListener(eventName, actualCallback, actualOptions);
    };
    return destroy;
}

var dropdownAnimation = [
    transition('void => 1', [
        style({ opacity: 0 }),
        animate(100, style({ opacity: 1 })),
    ]),
    transition(':leave', [
        style({ opacity: 1 }),
        animate(100, style({ opacity: 0 })),
    ]),
];

var CDS_DROPDOWN_CONFIG = new InjectionToken('CDS_DROPDOWN_CONFIG');

var DropdownPopper = /** @class */ (function () {
    function DropdownPopper(zone, anchor, dropdown, optionsFactory) {
        this.zone = zone;
        this.anchor = anchor;
        this.dropdown = dropdown;
        this.optionsFactory = optionsFactory;
    }
    DropdownPopper.prototype.scheduleUpdate = function () {
        var _this = this;
        if (this.popper) {
            this.zone.runOutsideAngular(function () {
                _this.popper.forceUpdate();
            });
        }
    };
    DropdownPopper.prototype.update = function (isOpen) {
        var _this = this;
        this.zone.runOutsideAngular(function () {
            if (_this.popper) {
                _this.popper.destroy();
            }
            if (isOpen) {
                var menuElement = _this.dropdown;
                menuElement.style.removeProperty('max-height');
                menuElement.style.removeProperty('min-width');
                _this.popper = createPopper(_this.anchor, menuElement, _this.optionsFactory());
            }
        });
    };
    DropdownPopper.prototype.destroy = function () {
        if (this.popper) {
            this.popper.destroy();
        }
    };
    DropdownPopper.prototype.getScrollParents = function () {
        if (this.popper) {
            return this.popper.state.scrollParents;
        }
        else {
            return undefined;
        }
    };
    return DropdownPopper;
}());

function valueTransition(duration, from, to, callback, easing) {
    var stop = false;
    if (!window.requestAnimationFrame) {
        callback(to);
        return;
    }
    var delta = to - from;
    var start;
    function step(timestamp) {
        if (stop) {
            return;
        }
        if (!start) {
            start = timestamp;
        }
        var progress = (timestamp - start) / duration;
        if (progress < 1) {
            callback(from + delta * easing(progress));
            window.requestAnimationFrame(step);
        }
        else {
            stop = true;
            callback(to);
        }
    }
    window.requestAnimationFrame(step);
    return function (finish) {
        if (!stop && finish) {
            callback(to);
        }
        stop = true;
    };
}
function easeOut(t) {
    return t * (2 - t);
}

var ANIMATION_DURATION = 300;
var SCROLL_OFFSET = 5;
// Due to wrong calculate popper width with overflow-y https://github.com/popperjs/popper-core/issues/1198
var LEFT_RIGHT_OFFSET = 16;
function defaultDropdownPopperOptionsFactory(config) {
    var _a = config || {}, _b = _a.positionFixed, positionFixed = _b === void 0 ? true : _b, _c = _a.scrollStrategy, scrollStrategy = _c === void 0 ? 'reposition' : _c;
    var firstScroll = true;
    var popperPreviousHeight;
    var customScroll = {
        name: 'customScroll',
        enabled: true,
        phase: 'write',
        requires: ['customFlip'],
        fn: function (data) {
            var instance = data.instance, state = data.state;
            var popperHeight = state.rects.popper.height;
            if (firstScroll && (popperPreviousHeight === undefined || popperHeight !== popperPreviousHeight)) {
                popperPreviousHeight = popperHeight;
                var scrollable_1 = findScrollableParent(state.scrollParents.reference, state.elements.reference);
                var _a = data.state.modifiersData['customFlip'], from = _a.from, to_1 = _a.to;
                if (from || to_1) {
                    firstScroll = false;
                    valueTransition(ANIMATION_DURATION, from, to_1, function (position) {
                        scrollable_1.scrollTop = position;
                        if (position === to_1) {
                            firstScroll = true;
                        }
                        if (scrollStrategy === 'block') {
                            // For block strategy we need to recalculate popper after scrolling
                            instance.update();
                        }
                    }, easeOut);
                }
            }
        },
        data: {
            disableInExpandedDropdown: true,
        },
    };
    var customAutoSizing = {
        name: 'customAutoSizing',
        enabled: true,
        phase: 'beforeWrite',
        fn: function (data) {
            var minWidth = data.state.rects.reference.width;
            data.state.styles.popper.minWidth = minWidth + "px";
        },
    };
    var customFlip = {
        name: 'customFlip',
        enabled: true,
        phase: 'beforeWrite',
        requiresIfExists: ['offset', 'customAutoSizing'],
        fn: function (data) {
            data.state.reset = false;
            if (data.state.modifiersData[data.name]._skip) {
                return;
            }
            var scrollable = findScrollableParent(data.state.scrollParents.reference, data.state.elements.reference);
            var scrollHeight = scrollable.scrollHeight, scrollTop = scrollable.scrollTop, clientHeight = scrollable.clientHeight;
            var _a = getBoundingClientRect(scrollable), scrollableRectTop = _a.top, scrollableRectBottom = _a.bottom, scrollWidth = _a.right;
            var _b = data.state.rects.popper, popperHeight = _b.height, popperWidth = _b.width;
            var _c = data.state.elements.reference.getBoundingClientRect(), referenceTop = _c.top, referenceHeight = _c.height, referenceLeft = _c.left, referenceWidth = _c.width;
            var popperTop = referenceTop + referenceHeight;
            var vh = window.innerHeight;
            var styleMaxHeight = Number(window.getComputedStyle(data.state.elements.popper).maxHeight.replace(/[^\d.]*/g, '')) || Infinity;
            var initialPosition = data.state.placement;
            var _d = __read(getVariationAndPosition(initialPosition), 2), initialBasePlacement = _d[0], initialVariation = _d[1];
            var isParentScrollable = scrollHeight !== clientHeight;
            var isReferenceTopFullVisible = referenceTop > scrollableRectTop;
            var isReferenceBottomFullVisible = referenceTop + referenceHeight < scrollableRectBottom;
            var isVertical = ['top', 'bottom'].includes(initialBasePlacement);
            function getVariationAndPosition(placement) {
                return placement.split('-');
            }
            function flipTo(placement) {
                data.state.modifiersData[data.name]._skip = true;
                data.state.placement = placement + "-" + initialVariation;
                data.state.reset = true;
            }
            if (!isReferenceTopFullVisible) {
                data.state.modifiersData[data.name] = {
                    from: scrollTop,
                    to: scrollTop + (referenceTop - scrollableRectTop) - SCROLL_OFFSET,
                };
            }
            if (!isReferenceBottomFullVisible) {
                data.state.modifiersData[data.name] = {
                    from: scrollTop,
                    to: scrollTop + ((referenceTop + referenceHeight) - scrollableRectBottom) + SCROLL_OFFSET,
                };
            }
            if (isVertical) {
                if (isParentScrollable && scrollHeight < vh) {
                    var popperBottomRelToScrollableBottom = (vh + (scrollHeight - clientHeight)) - (referenceTop + referenceHeight + popperHeight + scrollTop);
                    var popperBottomRelToVP = vh - (referenceTop + referenceHeight + popperHeight);
                    var isPopperFitOnBottom = popperBottomRelToVP > 0;
                    if (popperBottomRelToScrollableBottom > 0) {
                        if (!isPopperFitOnBottom) {
                            data.state.modifiersData[data.name] = {
                                from: scrollTop,
                                to: scrollTop - (popperBottomRelToVP - SCROLL_OFFSET),
                            };
                        }
                        return;
                    }
                    else {
                        var popperTopRelToVP = referenceTop - popperHeight;
                        var isScrollAvailable = popperTopRelToVP < 0 && isParentScrollable;
                        if (isScrollAvailable) {
                            data.state.modifiersData[data.name] = {
                                from: scrollTop,
                                to: scrollTop + referenceTop - (popperHeight + SCROLL_OFFSET),
                            };
                        }
                        flipTo('top');
                    }
                }
                else {
                    var popperBottomRelToScrollableBottom = scrollHeight - (scrollTop + popperTop + popperHeight);
                    var isPopperFitOnBottom = popperBottomRelToScrollableBottom > 0;
                    if (isPopperFitOnBottom) {
                        var popperTopRelToVP = vh - (referenceTop + referenceHeight + popperHeight);
                        var isScrollAvailable = popperTopRelToVP < 0 && isParentScrollable;
                        if (isScrollAvailable) {
                            data.state.modifiersData[data.name] = {
                                from: scrollTop,
                                to: scrollTop - (popperTopRelToVP - SCROLL_OFFSET),
                            };
                        }
                        return;
                    }
                    else {
                        var hasBottomMoreSpace = scrollHeight - (scrollTop + popperTop) > referenceTop + scrollTop;
                        if (hasBottomMoreSpace) {
                            var newHeight = Math.min(styleMaxHeight, popperHeight + popperBottomRelToScrollableBottom);
                            data.state.elements.popper.style.maxHeight = newHeight + "px";
                        }
                        else {
                            var isScrollAvailable = referenceTop - popperHeight < 0 && isParentScrollable;
                            if (isScrollAvailable) {
                                data.state.modifiersData[data.name] = {
                                    from: scrollTop,
                                    to: scrollTop + referenceTop - (popperHeight + SCROLL_OFFSET),
                                };
                            }
                            else {
                                var newHeight = Math.min(styleMaxHeight, referenceTop);
                                data.state.elements.popper.style.maxHeight = newHeight + "px";
                            }
                            flipTo('top');
                        }
                    }
                }
            }
            else {
                if (initialBasePlacement === 'right') {
                    var isPopperFitHorizontally = referenceLeft + referenceWidth + popperWidth < scrollWidth - LEFT_RIGHT_OFFSET;
                    if (!isPopperFitHorizontally) {
                        flipTo('left');
                    }
                }
                else {
                    var isPopperFitHorizontally = referenceLeft - popperWidth > LEFT_RIGHT_OFFSET;
                    if (!isPopperFitHorizontally) {
                        flipTo('right');
                    }
                }
            }
        },
        data: {
            disableInExpandedDropdown: true,
            _skip: false,
        },
    };
    var disableScroll = function () {
        var preventDefault = function (event) { return event.preventDefault(); };
        var events = ['wheel', 'mousewheel', 'touchmove'];
        window.addEventListener('DOMMouseScroll', preventDefault, false); // old firefox
        events.forEach(function (event) {
            window.addEventListener(event, preventDefault, { passive: false });
        });
        return function () {
            window.removeEventListener('DOMMouseScroll', preventDefault); // old firefox
            events.forEach(function (event) {
                window.removeEventListener(event, preventDefault);
            });
        };
    };
    var blockScrollModifier = {
        name: 'blockScroll',
        enabled: true,
        phase: 'write',
        effect: function () { return disableScroll(); },
        fn: function () { },
    };
    var modifiers = [
        {
            name: 'flip',
            enabled: false,
            data: {
                disableInExpandedDropdown: false,
            },
        },
        customAutoSizing,
        customFlip,
        customScroll,
    ];
    if (scrollStrategy === 'block') {
        modifiers.push({
            name: 'eventListeners',
            enabled: true,
            options: {
                scroll: false,
                resize: true,
            },
        }, blockScrollModifier);
    }
    return {
        placement: 'bottom-start',
        strategy: positionFixed ? 'fixed' : 'absolute',
        modifiers: modifiers,
    };
}
var CDS_DROPDOWN_POPPER_OPTIONS_FACTORY = new InjectionToken('CDS_DROPDOWN_POPPER_OPTIONS_FACTORY', {
    factory: function () { return defaultDropdownPopperOptionsFactory; },
});
var SCROLLABLE_PARENTS = new WeakMap();
function findScrollableParents(parents) {
    var e_1, _a;
    var elements = SCROLLABLE_PARENTS.get(parents);
    if (elements) {
        return elements;
    }
    elements = [];
    try {
        for (var parents_1 = __values(parents), parents_1_1 = parents_1.next(); !parents_1_1.done; parents_1_1 = parents_1.next()) {
            var element = parents_1_1.value;
            if (element instanceof HTMLElement) {
                if (element.scrollHeight !== element.clientHeight) {
                    elements.push(element);
                }
            }
            else { /*TODO: verify this condition in different browsers*/
                if (element === window) {
                    if (document.body.scrollHeight !== document.body.clientHeight) {
                        elements.push(document.documentElement);
                    }
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (parents_1_1 && !parents_1_1.done && (_a = parents_1.return)) _a.call(parents_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    SCROLLABLE_PARENTS.set(parents, elements);
    return elements;
}
function findScrollableParent(parents, excludeElement) {
    var elements = findScrollableParents(parents);
    return elements.filter(function (element) { return element !== excludeElement; })[0] || document.documentElement;
}
function getBoundingClientRect(scrollable) {
    if (scrollable === document.documentElement) {
        var _a = document.documentElement, clientHeight = _a.clientHeight, clientWidth = _a.clientWidth;
        return {
            top: 0,
            right: clientWidth,
            bottom: clientHeight,
            left: 0,
        };
    }
    else {
        return scrollable.getBoundingClientRect();
    }
}

var _a;
var isIE11 = ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) === null || _a === void 0 ? void 0 : _a.indexOf('Trident')) > -1;
var NAVIGATION_QUERY_STRING = [
    '[data-cds-keyboard-navigation]:not(.disabled)',
    'li[tabindex="-1"]:not(.disabled)',
].join(',');
var DROPDOWN_EXPAND_HOST_PROVIDER = {
    provide: DROPDOWN_EXPAND_HOST,
    useExisting: forwardRef(function () { return DropdownComponent; }),
};
var DropdownComponent = /** @class */ (function () {
    function DropdownComponent(zone, elementRef, viewContainerRef, config, optionsFactory, platform, expandParent, renderer) {
        var _this = this;
        this.zone = zone;
        this.elementRef = elementRef;
        this.viewContainerRef = viewContainerRef;
        this.platform = platform;
        this.expandParent = expandParent;
        this.animate = 1;
        this.keyboardNavigation = true;
        this.dismissOnEscape = true;
        this.dismissOnBlur = true;
        this.dismiss = new EventEmitter();
        this.destroy$ = new Subject();
        this.isDestroyed = false;
        this.element = elementRef.nativeElement;
        renderer.addClass(elementRef.nativeElement, 'cds-dropdown');
        renderer.addClass(elementRef.nativeElement, 'cds-dropdown--menu');
        if (isPlatformBrowser(platform)) {
            this.activeElement = document.activeElement;
        }
        this.optionsFactory = function () {
            var options = optionsFactory(config);
            if (_this.placement !== undefined) {
                options.placement = _this.placement;
            }
            if (_this.expandParent) {
                options.modifiers = _this.expandParent.getModifiers(options.modifiers);
            }
            return options;
        };
    }
    DropdownComponent.prototype.scheduleUpdate = function () {
        if (this.popper) {
            this.popper.scheduleUpdate();
        }
    };
    DropdownComponent.prototype.onAnchorKeyDown = function (event) {
        var prevent = true;
        var next;
        var activeElement = document.activeElement;
        var focusable = findFocusableElements(this.element, activeElement, NAVIGATION_QUERY_STRING);
        switch (event.key) {
            case 'ArrowDown':
            case 'Down':
            case 'Home':
                next = focusable[0];
                break;
            case 'ArrowUp':
            case 'Up':
            case 'End':
                next = focusable[focusable.length - 1];
                break;
            default:
                prevent = false;
                break;
        }
        if (prevent) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (next instanceof HTMLElement) {
            next.focus();
        }
    };
    DropdownComponent.prototype.onDropdownKeyDown = function (event) {
        var prevent = true;
        var next = null;
        var activeElement = document.activeElement;
        var focusable = findFocusableElements(this.element, activeElement, NAVIGATION_QUERY_STRING);
        var activeIndex = focusable.indexOf(activeElement);
        switch (event.key) {
            case 'ArrowDown':
            case 'Down':
                next = activeIndex === -1 ? focusable[0] : focusable[activeIndex + 1];
                break;
            case 'ArrowUp':
            case 'Up':
                next = activeIndex === -1 ? focusable[focusable.length - 1] : focusable[activeIndex - 1];
                break;
            case 'Home':
                next = focusable[0];
                break;
            case 'End':
                next = focusable[focusable.length - 1];
                break;
            case 'Enter':
            case ' ':
            case 'Spacebar':
                if (activeIndex !== -1) {
                    activeElement.click();
                }
                else {
                    prevent = false;
                }
                break;
            default:
                prevent = false;
                break;
        }
        if (prevent) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (next instanceof HTMLElement) {
            next.focus();
        }
    };
    DropdownComponent.prototype.onClick = function (event) {
        var _this = this;
        var target = event.target;
        var containsTargetInExpandable = this.expandableChildren.find(function (child) { return child.contains(target); });
        if (!this.element.contains(target) && !this.anchorElement.contains(target) && !containsTargetInExpandable) {
            this.zone.run(function () {
                _this.dismiss.emit({ source: 'blur', event: event });
            });
        }
    };
    DropdownComponent.prototype.ngOnInit = function () {
        var _this = this;
        var anchor = this.expandParent ? this.expandParent.element : this.anchor;
        this.anchorElement = anchor instanceof ElementRef ? anchor.nativeElement : anchor;
        this.popper = new DropdownPopper(this.zone, this.anchorElement, this.element, this.optionsFactory);
        this.popper.update(true);
        if (isPlatformBrowser(this.platform)) {
            this.zone.runOutsideAngular(function () {
                if (_this.keyboardNavigation) {
                    _this.destroy$.subscribe(listen(_this.element, 'keydown', function (event) {
                        _this.onDropdownKeyDown(event);
                    }));
                    _this.destroy$.subscribe(listen(_this.anchorElement, 'keydown', function (event) {
                        _this.onAnchorKeyDown(event);
                    }));
                }
                if (_this.dismissOnEscape) {
                    _this.destroy$.subscribe(listen(document, 'keyup', function (event) {
                        if (event.key === 'Esc' || event.key === 'Escape') {
                            _this.zone.run(function () {
                                _this.dismiss.emit({ source: 'escape', event: event });
                                if (_this.activeElement && 'focus' in _this.activeElement) {
                                    _this.activeElement.focus();
                                }
                            });
                        }
                    }));
                }
                if (_this.dismissOnBlur) {
                    if (isIE11) {
                        /**
                         * Workaround for issue:
                         * https://github.com/angular/angular/issues/35959
                         */
                        requestAnimationFrame(function () {
                            _this.addDismissListeners();
                        });
                    }
                    else {
                        _this.addDismissListeners();
                    }
                }
            });
        }
    };
    DropdownComponent.prototype.addDismissListeners = function () {
        var _this = this;
        this.destroy$.subscribe(listen(document, 'focus', function (event) {
            _this.onClick(event);
        }, { capture: true, passive: true }));
        this.destroy$.subscribe(listen(document, 'mousedown', function (event) {
            _this.onClick(event);
        }, { passive: true }));
        this.destroy$.subscribe(listen(document, 'touchend', function (event) {
            _this.onClick(event);
        }, { passive: true }));
    };
    DropdownComponent.prototype.ngAfterViewInit = function () {
        var e_1, _a;
        if (isPlatformBrowser(this.platform) && this.initialFocus) {
            try {
                for (var _b = __values([].concat(this.initialFocus)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var selector = _c.value;
                    var autofocus = this.element.querySelector(selector);
                    if (autofocus) {
                        autofocus.focus();
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    };
    DropdownComponent.prototype.onAnimateDone = function (event) {
        /**
         * Workaround for issue:
         * https://github.com/angular/angular/issues/35959
         */
        this.animate = 2;
        /**
         * Not checking if popper exists causes error in IE/Edge.
         * Animation is calling done twice in IE/Edge.
         */
        if (this.isDestroyed && event.toState === 'void' && this.popper) {
            this.popper.update(false);
            this.popper = null;
        }
    };
    DropdownComponent.prototype.ngOnDestroy = function () {
        this.isDestroyed = true;
        this.destroy$.next();
        this.destroy$.complete();
        if (this.popper) {
            this.popper.destroy();
        }
    };
    DropdownComponent.prototype.calculatePosition = function () {
        var elementRect = this.elementRef.nativeElement.getBoundingClientRect();
        var anchorRect = this.anchorElement.getBoundingClientRect();
        return elementRect.top > anchorRect.top ? 'bottom' : 'top';
    };
    DropdownComponent.prototype.getExpandableOptions = function () {
        return {
            container: this.viewContainerRef,
            scrollParents: this.popper ? this.popper.getScrollParents() : undefined,
        };
    };
    DropdownComponent.ctorParameters = function () { return [
        { type: NgZone },
        { type: ElementRef },
        { type: ViewContainerRef },
        { type: undefined, decorators: [{ type: Inject, args: [CDS_DROPDOWN_CONFIG,] }, { type: Optional }] },
        { type: undefined, decorators: [{ type: Inject, args: [CDS_DROPDOWN_POPPER_OPTIONS_FACTORY,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
        { type: DropdownExpandableDirective, decorators: [{ type: Optional }, { type: Inject, args: [DropdownExpandableDirective,] }] },
        { type: Renderer2 }
    ]; };
    __decorate([
        HostBinding('@animate'),
        __metadata("design:type", Number)
    ], DropdownComponent.prototype, "animate", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], DropdownComponent.prototype, "anchor", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DropdownComponent.prototype, "keyboardNavigation", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DropdownComponent.prototype, "dismissOnEscape", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], DropdownComponent.prototype, "initialFocus", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DropdownComponent.prototype, "dismissOnBlur", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DropdownComponent.prototype, "placement", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], DropdownComponent.prototype, "dismiss", void 0);
    __decorate([
        ContentChildren(DropdownExpandableDirective, { descendants: true }),
        __metadata("design:type", QueryList)
    ], DropdownComponent.prototype, "expandableChildren", void 0);
    __decorate([
        HostListener('@animate.done', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], DropdownComponent.prototype, "onAnimateDone", null);
    DropdownComponent = __decorate([ __param(3, Inject(CDS_DROPDOWN_CONFIG)), __param(3, Optional()),
        __param(4, Inject(CDS_DROPDOWN_POPPER_OPTIONS_FACTORY)),
        __param(5, Inject(PLATFORM_ID)),
        __param(6, Optional()), __param(6, Inject(DropdownExpandableDirective)),
        __metadata("design:paramtypes", [NgZone,
            ElementRef,
            ViewContainerRef, Object, Function, Object, DropdownExpandableDirective,
            Renderer2])
    ], DropdownComponent);
DropdownComponent.ɵfac = function DropdownComponent_Factory(t) { return new (t || DropdownComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(CDS_DROPDOWN_CONFIG, 8), ɵngcc0.ɵɵdirectiveInject(CDS_DROPDOWN_POPPER_OPTIONS_FACTORY), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID), ɵngcc0.ɵɵdirectiveInject(DropdownExpandableDirective, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
DropdownComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DropdownComponent, selectors: [["cds-dropdown"]], contentQueries: function DropdownComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, DropdownExpandableDirective, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.expandableChildren = _t);
    } }, hostVars: 1, hostBindings: function DropdownComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵsyntheticHostListener("@animate.done", function DropdownComponent_animation_animate_done_HostBindingHandler($event) { return ctx.onAnimateDone($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵsyntheticHostProperty("@animate", ctx.animate);
    } }, inputs: { keyboardNavigation: "keyboardNavigation", dismissOnEscape: "dismissOnEscape", dismissOnBlur: "dismissOnBlur", anchor: "anchor", initialFocus: "initialFocus", placement: "placement" }, outputs: { dismiss: "dismiss" }, features: [ɵngcc0.ɵɵProvidersFeature([DROPDOWN_EXPAND_HOST_PROVIDER])], ngContentSelectors: _c2, decls: 1, vars: 0, template: function DropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, data: { animation: [
            trigger('animate', dropdownAnimation),
        ] } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DropdownComponent, [{
        type: Component,
        args: [{
                selector: 'cds-dropdown',
                template: '<ng-content></ng-content>',
                animations: [
                    trigger('animate', dropdownAnimation),
                ],
                providers: [DROPDOWN_EXPAND_HOST_PROVIDER]
            }]
    }], function () { return [{ type: ɵngcc0.NgZone }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.ViewContainerRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [CDS_DROPDOWN_CONFIG]
            }, {
                type: Optional
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [CDS_DROPDOWN_POPPER_OPTIONS_FACTORY]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: DropdownExpandableDirective, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DropdownExpandableDirective]
            }] }, { type: ɵngcc0.Renderer2 }]; }, { animate: [{
            type: HostBinding,
            args: ['@animate']
        }], keyboardNavigation: [{
            type: Input
        }], dismissOnEscape: [{
            type: Input
        }], dismissOnBlur: [{
            type: Input
        }], dismiss: [{
            type: Output
        }], onAnimateDone: [{
            type: HostListener,
            args: ['@animate.done', ['$event']]
        }], anchor: [{
            type: Input
        }], initialFocus: [{
            type: Input
        }], placement: [{
            type: Input
        }], expandableChildren: [{
            type: ContentChildren,
            args: [DropdownExpandableDirective, { descendants: true }]
        }] }); })();
    return DropdownComponent;
}());

function isHTMLElement(element) {
    return element instanceof HTMLElement;
}
function noop() { }
function identity(value) {
    return value;
}
function groupBy(array, keyGetter) {
    var e_1, _a;
    var result = {};
    try {
        for (var array_1 = __values(array), array_1_1 = array_1.next(); !array_1_1.done; array_1_1 = array_1.next()) {
            var item = array_1_1.value;
            var key = keyGetter(item);
            if (Array.isArray(result[key])) {
                result[key].push(item);
            }
            else {
                result[key] = [item];
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (array_1_1 && !array_1_1.done && (_a = array_1.return)) _a.call(array_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return result;
}
function keyBy(array, keyGetter) {
    var e_2, _a;
    var result = {};
    try {
        for (var array_2 = __values(array), array_2_1 = array_2.next(); !array_2_1.done; array_2_1 = array_2.next()) {
            var item = array_2_1.value;
            var key = keyGetter(item);
            result[key] = item;
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (array_2_1 && !array_2_1.done && (_a = array_2.return)) _a.call(array_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return result;
}
function keyByMap(array, keyGetter, mapper) {
    var e_3, _a;
    var result = {};
    try {
        for (var array_3 = __values(array), array_3_1 = array_3.next(); !array_3_1.done; array_3_1 = array_3.next()) {
            var item = array_3_1.value;
            var key = keyGetter(item);
            result[key] = mapper(item);
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (array_3_1 && !array_3_1.done && (_a = array_3.return)) _a.call(array_3);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return result;
}
function replaceAtIndex(index, replaceWith) {
    return function (item, currentIndex) {
        if (currentIndex === index) {
            return replaceWith;
        }
        else {
            return item;
        }
    };
}
function clone(object) {
    return JSON.parse(JSON.stringify(object));
}
function field(field) {
    return function (obj) { return obj && obj[field]; };
}
function arraysEqual(a1, a2) {
    return a1.length === a2.length && a1.every(function (value, i) { return value === a2[i]; });
}
function ignoreError(err, caught) {
    return EMPTY$1;
}
function onNextMicrotask(callback) {
    Promise.resolve().then(callback);
}
function zeroPad(value, size) {
    value = "" + value;
    for (var i = value.length; i < size; ++i) {
        value = '0' + value;
    }
    return value;
}
function concatRunnableFunctions(fnList) {
    return function () {
        var e_4, _a;
        try {
            for (var fnList_1 = __values(fnList), fnList_1_1 = fnList_1.next(); !fnList_1_1.done; fnList_1_1 = fnList_1.next()) {
                var fn = fnList_1_1.value;
                fn();
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (fnList_1_1 && !fnList_1_1.done && (_a = fnList_1.return)) _a.call(fnList_1);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
}

var KEY_CODE_DOWN = 40;
var KEY_CODE_UP = 38;
var KEY_CODE_ENTER = 13;
var KEY_CODE_ESC = 27;
var KEY_CODE_TAB = 9;
var DropdownDirective = /** @class */ (function () {
    function DropdownDirective(elementRef, renderer, config, optionsFactory, platform, cdRef, zone) {
        var _this = this;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.platform = platform;
        this.cdRef = cdRef;
        this.zone = zone;
        this.closeOnEscape = true;
        this.allowTab = false;
        this.closeOnDocumentClick = true;
        this.focusActive = false;
        this.isOpen = false;
        this.popper = null;
        this.isOpenChange = new EventEmitter();
        this.dropdownEscape = new EventEmitter();
        this.isKeyDown = false;
        this.isOpenAfterKeyDown = false;
        isDevMode() && console.warn('Using deprecated *DropdownDirective* - switch to *DropdownComponent* instead');
        this.optionsFactory = function () { return optionsFactory(config); };
        var element = elementRef.nativeElement;
        renderer.addClass(element, 'cds-dropdown');
        if (isHTMLElement(element)) {
            this.element = element;
        }
        this.setupOnEnterListener();
        this.setupDocumentListener();
        this.isOpenChange.subscribe(function (isOpen) { return _this.updatePopper(isOpen); });
    }
    Object.defineProperty(DropdownDirective.prototype, "dropdownOpened", {
        get: function () {
            return this.isOpen;
        },
        set: function (isOpen) {
            if (isOpen) {
                this.isOpenAfterKeyDown = this.isKeyDown;
                if (this.focusActive) {
                    var currentElement_1 = this.element.querySelector('.dropdown-menu li.active');
                    if (currentElement_1) {
                        setTimeout(function () { return currentElement_1.focus(); });
                    }
                }
                else {
                    var scrollableElement_1 = this.element.querySelector('.dropdown-menu');
                    if (scrollableElement_1) {
                        setTimeout(function () { return scrollableElement_1.scrollTop = 0; });
                    }
                }
            }
            this.isKeyDown = false;
            if (isOpen !== this.isOpen) {
                this.isOpen = isOpen;
                this.updatePopper(isOpen);
            }
        },
        enumerable: true,
        configurable: true
    });
    DropdownDirective.prototype.updatePopper = function (isOpen) {
        if (isOpen && !this.dropdownPopper) {
            var menuElement = this.element.querySelector('.dropdown-menu');
            if (menuElement) {
                this.dropdownPopper = new DropdownPopper(this.zone, this.getHostElement(), menuElement, function () { return undefined; });
            }
        }
        if (this.dropdownPopper) {
            this.dropdownPopper.update(isOpen);
            if (!isOpen) {
                this.dropdownPopper = null;
            }
        }
    };
    DropdownDirective.prototype.onDocumentClick = function (event) {
        var _this = this;
        if (this.isOpen && this.closeOnDocumentClick) {
            var element = this.getHostElement();
            if (element && !element.contains(event.target)) {
                this.zone.run(function () {
                    _this.isOpen = false;
                    _this.isOpenChange.emit(false);
                    _this.cdRef.markForCheck();
                });
            }
        }
    };
    DropdownDirective.prototype.onKeyUp = function (event) {
        var _this = this;
        var prevent = this.isOpenAfterKeyDown;
        this.isKeyDown = false;
        this.isOpenAfterKeyDown = false;
        if (prevent) {
            return false;
        }
        var keyCode = event.keyCode;
        if (keyCode === KEY_CODE_ESC && this.closeOnEscape) {
            event.preventDefault();
            event.stopPropagation();
            if (this.isOpen) {
                this.zone.run(function () {
                    _this.isOpen = false;
                    _this.isOpenChange.emit(false);
                    _this.dropdownEscape.emit();
                    _this.cdRef.markForCheck();
                });
            }
        }
        if (keyCode === KEY_CODE_TAB) {
            if (this.allowTab) {
                return;
            }
            if (this.isOpen) {
                this.zone.run(function () {
                    _this.isOpen = false;
                    _this.isOpenChange.emit(false);
                    _this.cdRef.markForCheck();
                });
                return true;
            }
        }
        if ([KEY_CODE_DOWN, KEY_CODE_UP, KEY_CODE_ENTER].indexOf(keyCode) === -1) {
            return false;
        }
        event.preventDefault();
        event.stopPropagation();
        var currentElement = this.element.querySelector('.dropdown-menu li:focus, .dropdown-menu > .dropdown-list > *:focus');
        var hasFocused = !!currentElement;
        if (keyCode === KEY_CODE_ENTER) {
            if (currentElement) {
                this.zone.run(function () {
                    currentElement.click();
                });
                return true;
            }
            else {
                return false;
            }
        }
        if (!hasFocused) {
            currentElement = this.element.querySelector('.dropdown-menu li[tabindex], .dropdown-menu > .dropdown-list > *[tabindex]');
        }
        if (keyCode === KEY_CODE_DOWN) {
            if (hasFocused) {
                currentElement = currentElement.nextElementSibling;
            }
            while (currentElement && !this.isFocusable(currentElement)) {
                currentElement = currentElement.nextElementSibling;
            }
        }
        else if (keyCode === KEY_CODE_UP) {
            if (hasFocused) {
                currentElement = currentElement.previousElementSibling;
            }
            while (currentElement && !this.isFocusable(currentElement)) {
                currentElement = currentElement.previousElementSibling;
            }
        }
        if (currentElement) {
            this.zone.run(function () {
                currentElement.focus();
            });
        }
        return true;
    };
    DropdownDirective.prototype.ngOnChanges = function (changes) {
        if ('hostElement' in changes) {
            this.setupOnEnterListener();
        }
    };
    DropdownDirective.prototype.ngOnDestroy = function () {
        if (this.cancelHostEvents) {
            this.cancelHostEvents();
        }
        if (this.cancelDocumentEvents) {
            this.cancelDocumentEvents();
        }
    };
    DropdownDirective.prototype.scheduleUpdate = function () {
        if (this.popper) {
            this.popper.update();
        }
    };
    DropdownDirective.prototype.isFocusable = function (element) {
        return element.hasAttribute('tabindex') && window.getComputedStyle(element).display !== 'none';
    };
    DropdownDirective.prototype.getHostElement = function () {
        if (this.hostElement) {
            return isHTMLElement(this.hostElement) ? this.hostElement : this.hostElement.nativeElement;
        }
        else {
            return this.element;
        }
    };
    DropdownDirective.prototype.setupOnEnterListener = function () {
        var _this = this;
        var element = this.getHostElement();
        if (this.cancelHostEvents) {
            this.cancelHostEvents();
        }
        var cancelOnEnter = this.renderer.listen(element, 'keydown.enter', function (event) {
            _this.isKeyDown = true;
            if (event.target === element) {
                _this.isOpenAfterKeyDown = _this.isOpen;
                _this.cdRef.markForCheck();
            }
        });
        var cancelOnDown = this.renderer.listen(element, 'keydown.arrowdown', function (event) {
            event.preventDefault();
        });
        var cancelOnUp = this.renderer.listen(element, 'keydown.arrowup', function (event) {
            event.preventDefault();
        });
        this.cancelHostEvents = function () {
            cancelOnEnter();
            cancelOnDown();
            cancelOnUp();
        };
    };
    DropdownDirective.prototype.setupDocumentListener = function () {
        var _this = this;
        if (isPlatformBrowser(this.platform)) {
            this.zone.runOutsideAngular(function () {
                var cancelOnFocus = listen(document, 'focus', function (event) {
                    _this.onDocumentClick(event);
                }, { capture: true, passive: true });
                var cancelOnMouseUp = listen(document, 'mouseup', function (event) {
                    _this.onDocumentClick(event);
                }, { passive: true });
                var cancelOnTouchStart = listen(document, 'touchend', function (event) {
                    _this.onDocumentClick(event);
                }, { passive: true });
                var cancelOnKeyUp = listen(document, 'keyup', function (event) {
                    _this.onKeyUp(event);
                });
                _this.cancelDocumentEvents = function () {
                    cancelOnFocus();
                    cancelOnMouseUp();
                    cancelOnTouchStart();
                    cancelOnKeyUp();
                };
            });
        }
    };
    DropdownDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: undefined, decorators: [{ type: Inject, args: [CDS_DROPDOWN_CONFIG,] }, { type: Optional }] },
        { type: undefined, decorators: [{ type: Inject, args: [CDS_DROPDOWN_POPPER_OPTIONS_FACTORY,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
        { type: ChangeDetectorRef },
        { type: NgZone }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DropdownDirective.prototype, "closeOnEscape", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DropdownDirective.prototype, "allowTab", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DropdownDirective.prototype, "closeOnDocumentClick", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DropdownDirective.prototype, "focusActive", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], DropdownDirective.prototype, "hostElement", void 0);
    __decorate([
        HostBinding('class.open'),
        __metadata("design:type", Boolean)
    ], DropdownDirective.prototype, "isOpen", void 0);
    __decorate([
        Input('cdsDropdown'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], DropdownDirective.prototype, "dropdownOpened", null);
    __decorate([
        Output('cdsDropdownChange'),
        __metadata("design:type", EventEmitter)
    ], DropdownDirective.prototype, "isOpenChange", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], DropdownDirective.prototype, "dropdownEscape", void 0);
    DropdownDirective = __decorate([ __param(2, Inject(CDS_DROPDOWN_CONFIG)), __param(2, Optional()),
        __param(3, Inject(CDS_DROPDOWN_POPPER_OPTIONS_FACTORY)),
        __param(4, Inject(PLATFORM_ID)),
        __metadata("design:paramtypes", [ElementRef,
            Renderer2, Object, Function, Object, ChangeDetectorRef,
            NgZone])
    ], DropdownDirective);
DropdownDirective.ɵfac = function DropdownDirective_Factory(t) { return new (t || DropdownDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(CDS_DROPDOWN_CONFIG, 8), ɵngcc0.ɵɵdirectiveInject(CDS_DROPDOWN_POPPER_OPTIONS_FACTORY), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
DropdownDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DropdownDirective, selectors: [["", "cdsDropdown", ""]], hostVars: 2, hostBindings: function DropdownDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("open", ctx.isOpen);
    } }, inputs: { closeOnEscape: "closeOnEscape", allowTab: "allowTab", closeOnDocumentClick: "closeOnDocumentClick", focusActive: "focusActive", dropdownOpened: ["cdsDropdown", "dropdownOpened"], hostElement: "hostElement" }, outputs: { isOpenChange: "cdsDropdownChange", dropdownEscape: "dropdownEscape" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DropdownDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsDropdown]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: undefined, decorators: [{
                type: Inject,
                args: [CDS_DROPDOWN_CONFIG]
            }, {
                type: Optional
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [CDS_DROPDOWN_POPPER_OPTIONS_FACTORY]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.NgZone }]; }, { closeOnEscape: [{
            type: Input
        }], allowTab: [{
            type: Input
        }], closeOnDocumentClick: [{
            type: Input
        }], focusActive: [{
            type: Input
        }], isOpen: [{
            type: HostBinding,
            args: ['class.open']
        }], isOpenChange: [{
            type: Output,
            args: ['cdsDropdownChange']
        }], dropdownEscape: [{
            type: Output
        }], dropdownOpened: [{
            type: Input,
            args: ['cdsDropdown']
        }], hostElement: [{
            type: Input
        }] }); })();
    return DropdownDirective;
}());

var DropdownModule = /** @class */ (function () {
    function DropdownModule() {
    }
DropdownModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DropdownModule });
DropdownModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DropdownModule_Factory(t) { return new (t || DropdownModule)(); }, imports: [[
            PortalModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DropdownModule, { declarations: [DropdownDirective, DropdownDisableKeydownDirective, DropdownComponent, DropdownExpandableDirective], imports: [PortalModule], exports: [DropdownDirective, DropdownDisableKeydownDirective, DropdownComponent, DropdownExpandableDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DropdownModule, [{
        type: NgModule,
        args: [{
                imports: [
                    PortalModule,
                ],
                declarations: [
                    DropdownDirective,
                    DropdownDisableKeydownDirective,
                    DropdownComponent,
                    DropdownExpandableDirective,
                ],
                exports: [
                    DropdownDirective,
                    DropdownDisableKeydownDirective,
                    DropdownComponent,
                    DropdownExpandableDirective,
                ]
            }]
    }], function () { return []; }, null); })();
    return DropdownModule;
}());

var BreadcrumbObserveDirective = /** @class */ (function () {
    function BreadcrumbObserveDirective(elementRef) {
        this.elementRef = elementRef;
    }
    BreadcrumbObserveDirective.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (this.unobserve) {
            this.unobserve();
        }
        var observer = this.observer;
        if (observer) {
            observer.observe(this.elementRef.nativeElement);
            this.unobserve = function () {
                observer.unobserve(_this.elementRef.nativeElement);
            };
        }
    };
    BreadcrumbObserveDirective.prototype.ngOnDestroy = function () {
        if (this.unobserve) {
            this.unobserve();
        }
    };
    BreadcrumbObserveDirective.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    __decorate([
        Input('cdsBreadcrumbObserve'),
        __metadata("design:type", Object)
    ], BreadcrumbObserveDirective.prototype, "observer", void 0);
    BreadcrumbObserveDirective = __decorate([ __metadata("design:paramtypes", [ElementRef])
    ], BreadcrumbObserveDirective);
BreadcrumbObserveDirective.ɵfac = function BreadcrumbObserveDirective_Factory(t) { return new (t || BreadcrumbObserveDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
BreadcrumbObserveDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BreadcrumbObserveDirective, selectors: [["", "cdsBreadcrumbObserve", ""]], inputs: { observer: ["cdsBreadcrumbObserve", "observer"] }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BreadcrumbObserveDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsBreadcrumbObserve]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { observer: [{
            type: Input,
            args: ['cdsBreadcrumbObserve']
        }] }); })();
    return BreadcrumbObserveDirective;
}());

var BreadcrumbsModule = /** @class */ (function () {
    function BreadcrumbsModule() {
    }
BreadcrumbsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BreadcrumbsModule });
BreadcrumbsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BreadcrumbsModule_Factory(t) { return new (t || BreadcrumbsModule)(); }, imports: [[
            CommonModule,
            DropdownModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BreadcrumbsModule, { declarations: function () { return [BreadcrumbDirective, BreadcrumbObserveDirective, BreadcrumbsComponent]; }, imports: function () { return [CommonModule, DropdownModule]; }, exports: function () { return [BreadcrumbDirective, BreadcrumbsComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BreadcrumbsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    DropdownModule,
                ],
                declarations: [
                    BreadcrumbDirective,
                    BreadcrumbObserveDirective,
                    BreadcrumbsComponent,
                ],
                exports: [
                    BreadcrumbDirective,
                    BreadcrumbsComponent,
                ]
            }]
    }], function () { return []; }, null); })();
    return BreadcrumbsModule;
}());

var RippleService = /** @class */ (function () {
    function RippleService(platform, zone) {
        this.platform = platform;
        this.zone = zone;
        this.enableCalculations = false;
        var CSS = window.CSS;
        if (CSS && CSS.supports('color', 'var(--primary)')) {
            this.enableCalculations = true;
        }
    }
    RippleService.prototype.create = function (hostElement, queryRippleElement, options) {
        if (options === void 0) { options = {}; }
        if (!isPlatformBrowser(this.platform)) {
            return;
        }
        var queriedRippleElement = queryRippleElement();
        if (!isHTMLElement(queriedRippleElement)) {
            return;
        }
        var rippleElement = queriedRippleElement;
        var activeClass = 'cds-ripple--active';
        var duration = 800;
        var triggers = options.triggers || ['mousedown'];
        rippleElement.classList.add('cds-ripple');
        if (options.bounded) {
            rippleElement.classList.add('cds-ripple--bounded');
        }
        var timeout;
        var delay;
        var calculations = this.enableCalculations && (!options.centered || options.fit);
        function onMousedown(event) {
            if (hostElement.disabled || hostElement.classList.contains('disabled')) {
                return;
            }
            if (timeout) {
                clearTimeout(timeout);
            }
            if (delay) {
                clearTimeout(delay);
            }
            if (calculations && 'offsetX' in event && 'target' in event) {
                var targetRect = event.target.getBoundingClientRect();
                var rippleRect = rippleElement.getBoundingClientRect();
                var offsetX = event.offsetX + targetRect.left - rippleRect.left;
                var offsetY = event.offsetY + targetRect.top - rippleRect.top;
                if (!options.centered) {
                    rippleElement.style.setProperty('--cds-ripple-offset-x', offsetX + "px");
                    rippleElement.style.setProperty('--cds-ripple-offset-y', offsetY + "px");
                }
                if (options.fit) {
                    var toLeft = offsetX;
                    var toRight = rippleRect.right - rippleRect.left - offsetX;
                    var toTop = offsetY;
                    var toBottom = rippleRect.bottom - rippleRect.top - offsetY;
                    var x = Math.max(toLeft, toRight);
                    var y = Math.max(toTop, toBottom);
                    var size = Math.ceil(2 * Math.sqrt(x * x + y * y));
                    rippleElement.style.setProperty('--cds-ripple-size', size + "px");
                }
            }
            rippleElement.classList.remove(activeClass);
            rippleElement.classList.add('cds-ripple--start');
            delay = setTimeout(function () {
                delay = null;
                rippleElement.classList.add(activeClass);
                timeout = setTimeout(function () {
                    timeout = null;
                    rippleElement.classList.remove(activeClass);
                    rippleElement.classList.remove('cds-ripple--start');
                }, duration);
            });
        }
        this.zone.runOutsideAngular(function () {
            var e_1, _a;
            try {
                for (var triggers_1 = __values(triggers), triggers_1_1 = triggers_1.next(); !triggers_1_1.done; triggers_1_1 = triggers_1.next()) {
                    var trigger = triggers_1_1.value;
                    hostElement.addEventListener(trigger, function (event) {
                        onMousedown(event);
                    });
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (triggers_1_1 && !triggers_1_1.done && (_a = triggers_1.return)) _a.call(triggers_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
    };
    RippleService.prototype.createForToggle = function (hostElement) {
        this.create(hostElement, function () { return hostElement.getElementsByClassName('cds-ripple')[0]; }, {
            centered: true,
            triggers: ['click'],
            bounded: false,
            fit: false,
        });
    };
    RippleService.prototype.createForComboCheckboxItem = function (hostElement) {
        this.create(hostElement, function () { return hostElement.getElementsByClassName('cds-ripple')[0]; }, {
            centered: true,
            triggers: ['click'],
            bounded: false,
            fit: false,
        });
    };
    RippleService.prototype.createForComboItem = function (hostElement) {
        this.create(hostElement, function () { return hostElement; }, {
            centered: false,
            bounded: true,
            fit: true,
        });
    };
    RippleService.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
        { type: NgZone }
    ]; };
    RippleService.ɵprov = ɵɵdefineInjectable({ factory: function RippleService_Factory() { return new RippleService(ɵɵinject(PLATFORM_ID), ɵɵinject(NgZone)); }, token: RippleService, providedIn: "root" });
    RippleService = __decorate([ __param(0, Inject(PLATFORM_ID)),
        __metadata("design:paramtypes", [Object, NgZone])
    ], RippleService);
RippleService.ɵfac = function RippleService_Factory(t) { return new (t || RippleService)(ɵngcc0.ɵɵinject(PLATFORM_ID), ɵngcc0.ɵɵinject(ɵngcc0.NgZone)); };
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RippleService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: ɵngcc0.NgZone }]; }, null); })();
    return RippleService;
}());

var RippleDirective = /** @class */ (function () {
    function RippleDirective(rippleService, renderer, elementRef) {
        this.rippleService = rippleService;
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.bounded = true;
        this.fit = true;
        renderer.addClass(elementRef.nativeElement, 'cds-ripple');
    }
    RippleDirective.prototype.ngOnInit = function () {
        var _this = this;
        this.rippleService.create(this.elementRef.nativeElement, function () { return _this.elementRef.nativeElement; }, {
            centered: this.centered,
            triggers: this.triggers,
            bounded: this.bounded,
            fit: this.fit,
        });
    };
    RippleDirective.ctorParameters = function () { return [
        { type: RippleService },
        { type: Renderer2 },
        { type: ElementRef }
    ]; };
    __decorate([
        Input('rippleCentered'),
        __metadata("design:type", Object)
    ], RippleDirective.prototype, "centered", void 0);
    __decorate([
        Input('rippleTriggers'),
        __metadata("design:type", Object)
    ], RippleDirective.prototype, "triggers", void 0);
    __decorate([
        Input('rippleBounded'),
        __metadata("design:type", Object)
    ], RippleDirective.prototype, "bounded", void 0);
    __decorate([
        Input('rippleFit'),
        __metadata("design:type", Object)
    ], RippleDirective.prototype, "fit", void 0);
    RippleDirective = __decorate([ __metadata("design:paramtypes", [RippleService,
            Renderer2,
            ElementRef])
    ], RippleDirective);
RippleDirective.ɵfac = function RippleDirective_Factory(t) { return new (t || RippleDirective)(ɵngcc0.ɵɵdirectiveInject(RippleService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
RippleDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: RippleDirective, selectors: [["", "cdsRipple", ""]], inputs: { bounded: ["rippleBounded", "bounded"], fit: ["rippleFit", "fit"], centered: ["rippleCentered", "centered"], triggers: ["rippleTriggers", "triggers"] } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RippleDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsRipple]'
            }]
    }], function () { return [{ type: RippleService }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { bounded: [{
            type: Input,
            args: ['rippleBounded']
        }], fit: [{
            type: Input,
            args: ['rippleFit']
        }], centered: [{
            type: Input,
            args: ['rippleCentered']
        }], triggers: [{
            type: Input,
            args: ['rippleTriggers']
        }] }); })();
    return RippleDirective;
}());

var RippleModule = /** @class */ (function () {
    function RippleModule() {
    }
RippleModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: RippleModule });
RippleModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function RippleModule_Factory(t) { return new (t || RippleModule)(); }, imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(RippleModule, { declarations: function () { return [RippleDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [RippleDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RippleModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                ],
                declarations: [
                    RippleDirective,
                ],
                exports: [
                    RippleDirective,
                ]
            }]
    }], function () { return []; }, null); })();
    return RippleModule;
}());

var ButtonRippleDirective = /** @class */ (function (_super) {
    __extends(ButtonRippleDirective, _super);
    function ButtonRippleDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
ButtonRippleDirective.ɵfac = function ButtonRippleDirective_Factory(t) { return ɵButtonRippleDirective_BaseFactory(t || ButtonRippleDirective); };
ButtonRippleDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ButtonRippleDirective, selectors: [["", "cdsButton", "", 3, "cdsRippleDisable", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
var ɵButtonRippleDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(ButtonRippleDirective);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ButtonRippleDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsButton]:not([cdsRippleDisable])'
            }]
    }], null, null); })();
    return ButtonRippleDirective;
}(RippleDirective));

var ButtonGroupComponent = /** @class */ (function () {
    function ButtonGroupComponent(elementRef, renderer) {
        renderer.addClass(elementRef.nativeElement, 'cds-button-group');
    }
    ButtonGroupComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
    ButtonGroupComponent = __decorate([ __metadata("design:paramtypes", [ElementRef, Renderer2])
    ], ButtonGroupComponent);
ButtonGroupComponent.ɵfac = function ButtonGroupComponent_Factory(t) { return new (t || ButtonGroupComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
ButtonGroupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ButtonGroupComponent, selectors: [["cds-button-group"]], ngContentSelectors: _c4, decls: 1, vars: 0, template: function ButtonGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c3);
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ButtonGroupComponent, [{
        type: Component,
        args: [{
                selector: 'cds-button-group',
                template: "<ng-content select=\"[cdsButton]\"></ng-content>\n"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, null); })();
    return ButtonGroupComponent;
}());

var ButtonModule = /** @class */ (function () {
    function ButtonModule() {
    }
ButtonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ButtonModule });
ButtonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ButtonModule_Factory(t) { return new (t || ButtonModule)(); }, imports: [[
            RippleModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ButtonModule, { declarations: [ButtonGroupComponent, ButtonRippleDirective], imports: [RippleModule], exports: [ButtonGroupComponent, ButtonRippleDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ButtonModule, [{
        type: NgModule,
        args: [{
                imports: [
                    RippleModule,
                ],
                declarations: [
                    ButtonGroupComponent,
                    ButtonRippleDirective,
                ],
                exports: [
                    ButtonGroupComponent,
                    ButtonRippleDirective,
                ]
            }]
    }], function () { return []; }, null); })();
    return ButtonModule;
}());

var CALENDAR_TRANSLATIONS_EN = {
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
};
function calendarTranslationsFactory() {
    return CALENDAR_TRANSLATIONS_EN;
}
var CDS_CALENDAR_TRANSLATIONS = new InjectionToken('CDS_CALENDAR_TRANSLATIONS', { factory: calendarTranslationsFactory });

var DATE_TIME_REGEX = /^(\d{4}|[-+]\d{6})-(\d{2})-(\d{2})(T(\d{2}):(\d{2})(:(\d{2}))?(Z|[-+]\d{2}:\d{2})?)?$/;
var TIME_REGEX = /^(\d{2}):(\d{2})(:(\d{2}))?(Z|[-+]\d{2}:\d{2})?$/;
var Time = /** @class */ (function () {
    function Time(date) {
        this.date = date;
    }
    Time.stringToDate = function (str) {
        var match = DATE_TIME_REGEX.exec(str);
        if (match && match[1] !== '-000000') {
            return Time.objectToDate({
                year: +match[1],
                month: +match[2],
                day: +match[3],
                hours: +match[5] || 0,
                minutes: +match[6] || 0,
                seconds: +match[8] || 0,
                offset: match[9],
            });
        }
        match = TIME_REGEX.exec(str);
        if (match) {
            return Time.objectToDate({
                hours: +match[1],
                minutes: +match[2],
                seconds: +match[4] || 0,
                offset: match[5],
            });
        }
        throw new Error('Invalid date string');
    };
    Time.objectToDate = function (obj) {
        var date = new Date(2020, 0, 1);
        if (obj.year != null) {
            date.setFullYear(obj.year);
        }
        if (obj.month != null) {
            date.setMonth(obj.month - 1);
        }
        if (obj.day != null) {
            date.setDate(obj.day);
        }
        if (obj.hours != null) {
            date.setHours(obj.hours);
        }
        if (obj.minutes != null) {
            date.setMinutes(obj.minutes);
        }
        if (obj.seconds != null) {
            date.setSeconds(obj.seconds);
        }
        if (obj.offset) {
            date.__offset = obj.offset;
        }
        var isInvalid = (obj.year != null && obj.year !== date.getFullYear()) ||
            (obj.month != null && obj.month - 1 !== date.getMonth()) ||
            (obj.day != null && obj.day !== date.getDate()) ||
            (obj.hours != null && obj.hours !== date.getHours()) ||
            (obj.minutes != null && obj.minutes !== date.getMinutes()) ||
            (obj.seconds != null && obj.seconds !== date.getSeconds());
        if (isInvalid) {
            throw new Error('Invalid date object');
        }
        return date;
    };
    Time.fromString = function (dateString) {
        return new Time(Time.stringToDate(dateString));
    };
    Time.fromObject = function (dateObject) {
        return new Time(Time.objectToDate(dateObject));
    };
    Time.fromDate = function (date) {
        return new Time(new Date(date.getTime()));
    };
    Time.fromAny = function (date) {
        if (typeof date === 'string') {
            return new Time(Time.stringToDate(date));
        }
        else if (date instanceof Date) {
            return new Time(new Date(date.getTime()));
        }
        else if (date != null) {
            return new Time(Time.objectToDate(date));
        }
    };
    Time.prototype.floor = function () {
        this.date.setHours(0);
        this.date.setMinutes(0);
        this.date.setMilliseconds(0);
        this.date.setSeconds(0);
        return this;
    };
    Time.prototype.ceil = function () {
        this.date.setHours(23);
        this.date.setMinutes(59);
        this.date.setSeconds(59);
        this.date.setMilliseconds(999);
        return this;
    };
    Time.prototype.dayFloor = function (addDays) {
        if (addDays) {
            this.date.setDate(this.date.getDate() + addDays);
        }
        this.floor();
        return this;
    };
    Time.prototype.dayCeil = function (addDays) {
        if (addDays) {
            this.date.setDate(this.date.getDate() + addDays);
        }
        this.ceil();
        return this;
    };
    Time.prototype.isWeekend = function () {
        var dayOfWeek = this.date.getDay();
        return dayOfWeek === 0 || dayOfWeek === 6;
    };
    Time.prototype.getTime = function () {
        return this.date.getTime();
    };
    Time.prototype.getTimeValue = function () {
        return this.date.getHours() * 3600 + this.date.getMinutes() * 60 + this.date.getSeconds();
    };
    Time.prototype.toggleDayPeriod = function () {
        var newHour = this.date.getHours() >= 12 ? this.date.getHours() - 12 : this.date.getHours() + 12;
        this.date.setHours(newHour);
    };
    Time.prototype.getOffset = function () {
        return this.date.__offset;
    };
    Time.prototype.toDate = function () {
        return this.date;
    };
    Time.prototype.toString = function (mode) {
        var parts = [];
        if (mode !== 'time') {
            var day = zeroPad(this.date.getDate(), 2);
            var month = zeroPad(this.date.getMonth() + 1, 2);
            var fullYear = this.date.getFullYear();
            var year = fullYear < 0 ? ('-' + zeroPad("" + -fullYear, 6))
                : fullYear > 9999 ? ('+' + zeroPad("" + fullYear, 6))
                    : zeroPad("" + fullYear, 4);
            parts.push(year + "-" + month + "-" + day);
        }
        if (mode === 'time' || mode === 'datetime') {
            var hours = zeroPad(this.date.getHours(), 2);
            var minutes = zeroPad(this.date.getMinutes(), 2);
            var seconds = zeroPad(this.date.getSeconds(), 2);
            parts.push(hours + ":" + minutes + ":" + seconds);
        }
        return parts.join('T');
    };
    return Time;
}());

/* tslint:disable */
/*!
 * Pikaday 1.8.0
 *
 * Copyright © 2014 David Bushell | BSD & MIT license | https://github.com/Pikaday/Pikaday
 */
var moment;
/**
 * feature detection and helper functions
 */
var hasMoment = typeof moment === 'function', hasEventListeners = !!window.addEventListener, document$1 = window.document, sto = window.setTimeout, addEvent = function (el, e, callback, capture) {
    if (hasEventListeners) {
        el.addEventListener(e, callback, !!capture);
    }
    else {
        el.attachEvent('on' + e, callback);
    }
}, removeEvent = function (el, e, callback, capture) {
    if (hasEventListeners) {
        el.removeEventListener(e, callback, !!capture);
    }
    else {
        el.detachEvent('on' + e, callback);
    }
}, trim = function (str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}, hasClass = function (el, cn) {
    return (' ' + el.className + ' ').indexOf(' ' + cn + ' ') !== -1;
}, addClass = function (el, cn) {
    if (!hasClass(el, cn)) {
        el.className = (el.className === '') ? cn : el.className + ' ' + cn;
    }
}, removeClass = function (el, cn) {
    el.className = trim((' ' + el.className + ' ').replace(' ' + cn + ' ', ' '));
}, isArray = function (obj) {
    return (/Array/).test(Object.prototype.toString.call(obj));
}, isDate = function (obj) {
    return (/Date/).test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime());
}, isWeekend = function (date) {
    var day = date.getDay();
    return day === 0 || day === 6;
}, isLeapYear = function (year) {
    // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}, getDaysInMonth = function (year, month) {
    return [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
}, setToStartOfDay = function (date) {
    if (isDate(date))
        date.setHours(0, 0, 0, 0);
}, compareDates = function (a, b) {
    // weak date comparison (use setToStartOfDay(date) to ensure correct result)
    return a.getTime() === b.getTime();
}, extend = function (to, from, overwrite) {
    var prop, hasProp;
    for (prop in from) {
        hasProp = to[prop] !== undefined;
        if (hasProp && typeof from[prop] === 'object' && from[prop] !== null && from[prop].nodeName === undefined) {
            if (isDate(from[prop])) {
                if (overwrite) {
                    to[prop] = new Date(from[prop].getTime());
                }
            }
            else if (isArray(from[prop])) {
                if (overwrite) {
                    to[prop] = from[prop].slice(0);
                }
            }
            else {
                to[prop] = extend({}, from[prop], overwrite);
            }
        }
        else if (overwrite || !hasProp) {
            to[prop] = from[prop];
        }
    }
    return to;
}, fireEvent = function (el, eventName, data) {
    var ev;
    if (document$1.createEvent) {
        ev = document$1.createEvent('HTMLEvents');
        ev.initEvent(eventName, true, false);
        ev = extend(ev, data);
        el.dispatchEvent(ev);
    }
}, adjustCalendar = function (calendar) {
    if (calendar.month < 0) {
        calendar.year -= Math.ceil(Math.abs(calendar.month) / 12);
        calendar.month += 12;
    }
    if (calendar.month > 11) {
        calendar.year += Math.floor(Math.abs(calendar.month) / 12);
        calendar.month -= 12;
    }
    return calendar;
}, 
/**
 * defaults and localisation
 */
defaults = {
    // now
    now: undefined,
    // bind the picker to a form field
    field: null,
    // automatically show/hide the picker on `field` focus (default `true` if `field` is set)
    bound: undefined,
    // data-attribute on the input field with an aria assistance tekst (only applied when `bound` is set)
    ariaLabel: 'Use the arrow keys to pick a date',
    // position of the Calendar, relative to the field (default to bottom & left)
    // ('bottom' & 'left' keywords are not used, 'top' & 'right' are modifier on the bottom/left position)
    position: 'bottom left',
    // automatically fit in the viewport even if it means repositioning from the position option
    reposition: true,
    // the default output format for `.toString()` and `field` value
    format: 'YYYY-MM-DD',
    // the toString function which gets passed a current date object and format
    // and returns a string
    toString: null,
    // used to create date object from current input string
    parse: null,
    // the initial date to view when first opened
    defaultDate: null,
    // make the `defaultDate` the initial selected value
    setDefaultDate: false,
    // first day of week (0: Sunday, 1: Monday etc)
    firstDay: 0,
    // the default flag for moment's strict date parsing
    formatStrict: false,
    // the minimum/earliest date that can be selected
    minDate: null,
    // the maximum/latest date that can be selected
    maxDate: null,
    // number of years either side, or array of upper/lower range
    yearRange: 10,
    // show week numbers at head of row
    showWeekNumber: false,
    // Week picker mode
    pickWholeWeek: false,
    // used internally (don't config outside)
    minYear: 0,
    maxYear: 9999,
    minMonth: undefined,
    maxMonth: undefined,
    startRange: null,
    endRange: null,
    isRTL: false,
    // Additional text to append to the year in the calendar title
    yearSuffix: '',
    // Render the month after year in the calendar title
    showMonthAfterYear: false,
    // Render days of the calendar grid that fall in the next or previous month
    showDaysInNextAndPreviousMonths: false,
    // Allows user to select days that fall in the next or previous month
    enableSelectionDaysInNextAndPreviousMonths: false,
    // how many months are visible
    numberOfMonths: 1,
    // when numberOfMonths is used, this will help you to choose where the main calendar will be (default `left`, can be set to `right`)
    // only used for the first display or when a selected date is not visible
    mainCalendar: 'left',
    // Specify a DOM element to render the calendar in
    container: undefined,
    // Blur field when date is selected
    blurFieldOnSelect: true,
    // internationalization
    i18n: {
        previousMonth: 'Previous Month',
        nextMonth: 'Next Month',
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    },
    // Theme Classname
    theme: null,
    // events array
    events: [],
    // callback function
    onSelect: null,
    onOpen: null,
    onClose: null,
    onDraw: null,
    // Enable keyboard input
    // keyboardInput: true
    focusable: true,
}, 
/**
 * templating functions to abstract HTML rendering
 */
renderDayName = function (opts, day, abbr) {
    day += opts.firstDay;
    while (day >= 7) {
        day -= 7;
    }
    return abbr ? opts.i18n.weekdaysShort[day] : opts.i18n.weekdays[day];
}, renderDay = function (opts, focusable) {
    var arr = [];
    var ariaSelected = 'false';
    if (opts.isEmpty) {
        if (opts.showDaysInNextAndPreviousMonths) {
            arr.push('is-outside-current-month');
            if (!opts.enableSelectionDaysInNextAndPreviousMonths) {
                arr.push('is-selection-disabled');
            }
        }
        else {
            return '<td class="is-empty"></td>';
        }
    }
    if (opts.isDisabled) {
        arr.push('is-disabled');
    }
    if (opts.isToday) {
        arr.push('is-today');
    }
    if (opts.isSelected) {
        arr.push('is-selected');
        ariaSelected = 'true';
    }
    if (opts.hasEvent) {
        arr.push('has-event');
    }
    if (opts.isInRange) {
        arr.push('is-inrange');
    }
    if (opts.isStartRange) {
        arr.push('is-startrange');
    }
    if (opts.isEndRange) {
        arr.push('is-endrange');
    }
    /* CDS modifications: added tabindex="-1" to button */
    return '<td data-day="' + opts.day + '" class="' + arr.join(' ') + '" aria-selected="' + ariaSelected + '">' +
        ("<button class=\"pika-button pika-day\" type=\"button\" " + (opts.isSelected && focusable ? '' : 'tabindex="-1"')) +
        'data-pika-year="' + opts.year + '" data-pika-month="' + opts.month + '" data-pika-day="' + opts.day + '">' +
        opts.day +
        '</button>' +
        '</td>';
}, renderWeek = function (d, m, y) {
    // Lifted from http://javascript.about.com/library/blweekyear.htm, lightly modified.
    var onejan = new Date(y, 0, 1), weekNum = Math.ceil((((new Date(y, m, d) - onejan) / 86400000) + onejan.getDay() + 1) / 7);
    return '<td class="pika-week">' + weekNum + '</td>';
}, renderRow = function (days, isRTL, pickWholeWeek, isRowSelected) {
    return '<tr class="pika-row' + (pickWholeWeek ? ' pick-whole-week' : '') + (isRowSelected ? ' is-selected' : '') + '">' + (isRTL ? days.reverse() : days).join('') + '</tr>';
}, renderBody = function (rows) {
    return '<tbody>' + rows.join('') + '</tbody>';
}, renderHead = function (opts) {
    var i, arr = [];
    if (opts.showWeekNumber) {
        arr.push('<th></th>');
    }
    for (i = 0; i < 7; i++) {
        arr.push('<th scope="col"><abbr title="' + renderDayName(opts, i) + '">' + renderDayName(opts, i, true) + '</abbr></th>');
    }
    return '<thead><tr>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</tr></thead>';
}, renderTitle = function (instance, c, year, month, refYear, randId) {
    var i, j, arr, opts = instance._o, isMinYear = year === opts.minYear, isMaxYear = year === opts.maxYear, html = "<div class=\"pika-title\">", monthHtml, yearHtml, prev = true, next = true;
    if (instance._titleEl) {
        var text = opts.i18n.months[month] + " " + (year + opts.yearSuffix);
        if (text !== instance._titleEl.innerText) {
            instance._titleEl.innerText = opts.i18n.months[month] + " " + (year + opts.yearSuffix);
        }
    }
    for (arr = [], i = 0; i < 12; i++) {
        arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' +
            (i === month ? ' selected="selected"' : '') +
            ((isMinYear && i < opts.minMonth) || (isMaxYear && i > opts.maxMonth) ? 'disabled="disabled"' : '') + '>' +
            opts.i18n.months[i] + '</option>');
    }
    if (c === 0) {
        html += "<button cdsButton class=\"cds-button-icon cds-button-small pika-prev\"" + (prev ? '' : ' disabled') + " aria-label=\"" + opts.i18n.previousMonth + "\"" + (opts.focusable ? '' : ' tabindex="-1"') + "><i class=\"cds-icon-angle-left cds-icon--size-24\"></i></button>";
    }
    monthHtml = "<div class=\"pika-label\"><select class=\"pika-select pika-select-month\" aria-label=\"Select month\"" + (opts.focusable ? '' : ' tabindex="-1"') + ">" + arr.join('') + "</select><span aria-hidden=\"true\">" + opts.i18n.months[month] + "</span></div>";
    if (isArray(opts.yearRange)) {
        i = opts.yearRange[0];
        j = opts.yearRange[1] + 1;
    }
    else {
        i = year - opts.yearRange;
        j = 1 + year + opts.yearRange;
    }
    for (arr = []; i < j && i <= opts.maxYear; i++) {
        if (i >= opts.minYear) {
            arr.push('<option value="' + i + '"' + (i === year ? ' selected="selected"' : '') + '>' + (i) + '</option>');
        }
    }
    yearHtml = "<div class=\"pika-label\"><select class=\"pika-select pika-select-year\" aria-label=\"Select year\"" + (opts.focusable ? '' : ' tabindex="-1"') + ">" + arr.join('') + "</select><span aria-hidden=\"true\">" + (year + opts.yearSuffix) + "</span></div>";
    if (opts.showMonthAfterYear) {
        html += yearHtml + monthHtml;
    }
    else {
        html += monthHtml + yearHtml;
    }
    if (isMinYear && (month === 0 || opts.minMonth >= month)) {
        prev = false;
    }
    if (isMaxYear && (month === 11 || opts.maxMonth <= month)) {
        next = false;
    }
    /* CDS modifications: added tabindex="-1" to button */
    if (c === (instance._o.numberOfMonths - 1)) {
        html += "<button cdsButton class=\"cds-button-icon cds-button-small pika-next\"" + (next ? '' : ' disabled') + " aria-label=\"" + opts.i18n.nextMonth + "\"" + (opts.focusable ? '' : ' tabindex="-1"') + "><i class=\"cds-icon-angle-right cds-icon--size-24\"></i></button>";
    }
    return html += '</div>';
}, renderTable = function (opts, data, randId) {
    return '<table cellpadding="0" cellspacing="0" class="pika-table" role="grid" aria-labelledby="' + randId + '">' + renderHead(opts) + renderBody(data) + '</table>';
}, 
/**
 * Pikaday constructor
 */
Pikaday = function (options) {
    var self = this, opts = self.config(options);
    self._randId = 'pika-title-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
    self._onMouseDown = function (e) {
        if (!self._v) {
            return;
        }
        e = e || window.event;
        var target = e.target || e.srcElement;
        if (!target) {
            return;
        }
        if (!hasClass(target, 'is-disabled')) {
            if (hasClass(target, 'pika-button') && !hasClass(target, 'is-empty') && !hasClass(target.parentNode, 'is-disabled')) {
                self.setDate(new Date(target.getAttribute('data-pika-year'), target.getAttribute('data-pika-month'), target.getAttribute('data-pika-day')), false);
                if (opts.focusable) {
                    var button = self.el.querySelector('.is-selected > button');
                    if (button) {
                        button.focus();
                    }
                }
                if (opts.bound) {
                    sto(function () {
                        self.hide();
                        if (opts.blurFieldOnSelect && opts.field) {
                            opts.field.blur();
                        }
                    }, 100);
                }
            }
            else if (hasClass(target, 'pika-prev') || hasClass(target.parentNode, 'pika-prev')) {
                self.prevMonth();
                if (opts.focusable) {
                    var button = self.el.querySelector('.pika-prev');
                    if (button) {
                        button.focus();
                    }
                }
            }
            else if (hasClass(target, 'pika-next') || hasClass(target.parentNode, 'pika-next')) {
                self.nextMonth();
                if (opts.focusable) {
                    var button = self.el.querySelector('.pika-next');
                    if (button) {
                        button.focus();
                    }
                }
            }
        }
        if (!hasClass(target, 'pika-select')) {
            // if this is touch event prevent mouse events emulation
            if (e.preventDefault) {
                e.preventDefault();
            }
            else {
                e.returnValue = false;
                return false;
            }
        }
        else {
            self._c = true;
        }
    };
    self._onChange = function (e) {
        e = e || window.event;
        var target = e.target || e.srcElement;
        if (!target) {
            return;
        }
        if (!target.value) {
            e.preventDefault();
            return;
        }
        if (hasClass(target, 'pika-select-month')) {
            self.gotoMonth(target.value);
            if (opts.focusable) {
                var select = self.el.querySelector('.pika-select-month');
                if (select) {
                    select.focus();
                }
            }
        }
        else if (hasClass(target, 'pika-select-year')) {
            self.gotoYear(target.value);
            if (opts.focusable) {
                var select = self.el.querySelector('.pika-select-year');
                if (select) {
                    select.focus();
                }
            }
        }
    };
    // CDS Modifications: Removed keyboard input
    // self._onKeyChange = function(e)
    // {
    // 	e = e || window.event;
    // 	if (self.isVisible()) {
    // 		switch(e.keyCode){
    // 			case 13:
    // 				self.setDate(self.getDate() || new Date(), false);
    // 				break;
    // 			case 27:
    // 				if (opts.field) {
    // 					opts.field.blur();
    // 				}
    // 				break;
    // 			case 37:
    // 				e.preventDefault();
    // 				self.adjustDate('subtract', 1);
    // 				break;
    // 			case 38:
    // 				self.adjustDate('subtract', 7);
    // 				break;
    // 			case 39:
    // 				self.adjustDate('add', 1);
    // 				break;
    // 			case 40:
    // 				self.adjustDate('add', 7);
    // 				break;
    // 		}
    // 	}
    // };
    self._onInputChange = function (e) {
        var date;
        if (e.firedBy === self) {
            return;
        }
        if (opts.parse) {
            date = opts.parse(opts.field.value, opts.format);
        }
        else if (hasMoment) {
            date = moment(opts.field.value, opts.format, opts.formatStrict);
            date = (date && date.isValid()) ? date.toDate() : null;
        }
        else {
            date = new Date(Date.parse(opts.field.value));
        }
        if (isDate(date)) {
            self.setDate(date);
        }
        if (!self._v) {
            self.show();
        }
    };
    self._onInputFocus = function () {
        self.show();
    };
    self._onInputClick = function () {
        self.show();
    };
    self._onInputBlur = function () {
        // IE allows pika div to gain focus; catch blur the input field
        var pEl = document$1.activeElement;
        do {
            if (hasClass(pEl, 'pika-single')) {
                return;
            }
        } while ((pEl = pEl.parentNode));
        if (!self._c) {
            self._b = sto(function () {
                self.hide();
            }, 50);
        }
        self._c = false;
    };
    self._onClick = function (e) {
        e = e || window.event;
        var target = e.target || e.srcElement, pEl = target;
        if (!target) {
            return;
        }
        if (!hasEventListeners && hasClass(target, 'pika-select')) {
            if (!target.onchange) {
                target.setAttribute('onchange', 'return;');
                addEvent(target, 'change', self._onChange);
            }
        }
        do {
            if (hasClass(pEl, 'pika-single') || pEl === opts.trigger) {
                return;
            }
        } while ((pEl = pEl.parentNode));
        if (self._v && target !== opts.trigger && pEl !== opts.trigger) {
            self.hide();
        }
    };
    self.el = document$1.createElement('div');
    self.el.className = 'pika-single' + (opts.isRTL ? ' is-rtl' : '') + (opts.theme ? ' ' + opts.theme : '');
    if (opts.container) {
        self._titleEl = document$1.createElement('span');
        self._titleEl.id = self._randId;
        self._titleEl.className = 'cds-sr-only';
        self._titleEl.setAttribute('aria-live', 'assertive');
        opts.container.appendChild(self._titleEl);
    }
    addEvent(self.el, 'click', self._onMouseDown, true);
    // addEvent(self.el, 'touchend', self._onMouseDown, true);
    addEvent(self.el, 'change', self._onChange);
    // CDS Modifications: Removed keyboard input
    // if (opts.keyboardInput) {
    // 	addEvent(document, 'keydown', self._onKeyChange);
    // }
    if (opts.field) {
        if (opts.container) {
            opts.container.appendChild(self.el);
        }
        else if (opts.bound) {
            document$1.body.appendChild(self.el);
        }
        else {
            opts.field.parentNode.insertBefore(self.el, opts.field.nextSibling);
        }
        addEvent(opts.field, 'change', self._onInputChange);
        if (!opts.defaultDate) {
            if (hasMoment && opts.field.value) {
                opts.defaultDate = moment(opts.field.value, opts.format).toDate();
            }
            else {
                opts.defaultDate = new Date(Date.parse(opts.field.value));
            }
            opts.setDefaultDate = true;
        }
    }
    var defDate = opts.defaultDate;
    if (isDate(defDate)) {
        if (opts.setDefaultDate) {
            self.setDate(defDate, true);
        }
        else {
            self.gotoDate(defDate);
        }
    }
    else {
        self.gotoDate(new Date());
    }
    if (opts.bound) {
        this.hide();
        self.el.className += ' is-bound';
        addEvent(opts.trigger, 'click', self._onInputClick);
        addEvent(opts.trigger, 'focus', self._onInputFocus);
        addEvent(opts.trigger, 'blur', self._onInputBlur);
    }
    else {
        this.show();
    }
};
var ɵ0 = addEvent, ɵ1 = removeEvent, ɵ2 = trim, ɵ3 = hasClass, ɵ4 = addClass, ɵ5 = removeClass, ɵ6 = isArray, ɵ7 = isDate, ɵ8 = isWeekend, ɵ9 = isLeapYear, ɵ10 = getDaysInMonth, ɵ11 = setToStartOfDay, ɵ12 = compareDates, ɵ13 = extend, ɵ14 = fireEvent, ɵ15 = adjustCalendar, ɵ16 = renderDayName, ɵ17 = renderDay, ɵ18 = renderWeek, ɵ19 = renderRow, ɵ20 = renderBody, ɵ21 = renderHead, ɵ22 = renderTitle, ɵ23 = renderTable, ɵ24 = Pikaday;
/**
 * public Pikaday API
 */
Pikaday.prototype = {
    /**
     * configure functionality
     */
    config: function (options) {
        if (!this._o) {
            this._o = extend({}, defaults, true);
        }
        var opts = extend(this._o, options, true);
        opts.isRTL = !!opts.isRTL;
        opts.field = (opts.field && opts.field.nodeName) ? opts.field : null;
        opts.theme = (typeof opts.theme) === 'string' && opts.theme ? opts.theme : null;
        opts.bound = !!(opts.bound !== undefined ? opts.field && opts.bound : opts.field);
        opts.trigger = (opts.trigger && opts.trigger.nodeName) ? opts.trigger : opts.field;
        opts.disableWeekends = !!opts.disableWeekends;
        opts.disableDayFn = (typeof opts.disableDayFn) === 'function' ? opts.disableDayFn : null;
        var nom = parseInt(opts.numberOfMonths, 10) || 1;
        opts.numberOfMonths = nom > 4 ? 4 : nom;
        if (!isDate(opts.minDate)) {
            opts.minDate = false;
        }
        if (!isDate(opts.maxDate)) {
            opts.maxDate = false;
        }
        if ((opts.minDate && opts.maxDate) && opts.maxDate < opts.minDate) {
            opts.maxDate = opts.minDate = false;
        }
        if (opts.minDate) {
            this.setMinDate(opts.minDate);
        }
        if (opts.maxDate) {
            this.setMaxDate(opts.maxDate);
        }
        if (isArray(opts.yearRange)) {
            var fallback = new Date().getFullYear() - 10;
            opts.yearRange[0] = parseInt(opts.yearRange[0], 10) || fallback;
            opts.yearRange[1] = parseInt(opts.yearRange[1], 10) || fallback;
        }
        else {
            opts.yearRange = Math.abs(parseInt(opts.yearRange, 10)) || defaults.yearRange;
            if (opts.yearRange > 100) {
                opts.yearRange = 100;
            }
        }
        return opts;
    },
    /**
     * return a formatted string of the current selection (using Moment.js if available)
     */
    toString: function (format) {
        format = format || this._o.format;
        if (!isDate(this._d)) {
            return '';
        }
        if (this._o.toString) {
            return this._o.toString(this._d, format);
        }
        if (hasMoment) {
            return moment(this._d).format(format);
        }
        return this._d.toDateString();
    },
    /**
     * return a Moment.js object of the current selection (if available)
     */
    getMoment: function () {
        return hasMoment ? moment(this._d) : null;
    },
    /**
     * set the current selection from a Moment.js object (if available)
     */
    setMoment: function (date, preventOnSelect) {
        if (hasMoment && moment.isMoment(date)) {
            this.setDate(date.toDate(), preventOnSelect);
        }
    },
    /**
     * return a Date object of the current selection
     */
    getDate: function () {
        return isDate(this._d) ? new Date(this._d.getTime()) : null;
    },
    /**
     * set the current selection
     */
    setDate: function (date, preventOnSelect) {
        if (!date) {
            this._d = null;
            if (this._o.field) {
                this._o.field.inputValue = '';
                fireEvent(this._o.field, 'change', { firedBy: this });
            }
            return this.draw();
        }
        if (typeof date === 'string') {
            date = new Date(Date.parse(date));
        }
        if (!isDate(date)) {
            return;
        }
        var min = this._o.minDate, max = this._o.maxDate;
        if (isDate(min) && date < min) {
            date = min;
        }
        else if (isDate(max) && date > max) {
            date = max;
        }
        this._d = new Date(date.getTime());
        setToStartOfDay(this._d);
        this.gotoDate(this._d);
        if (this._o.field) {
            this._o.field.inputValue = this.toString();
            fireEvent(this._o.field, 'change', { firedBy: this });
        }
        if (!preventOnSelect && typeof this._o.onSelect === 'function') {
            this._o.onSelect.call(this, this.getDate());
        }
    },
    /**
     * change view to a specific date
     */
    gotoDate: function (date) {
        var newCalendar = true;
        if (!isDate(date)) {
            return;
        }
        if (this.calendars) {
            var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1), lastVisibleDate = new Date(this.calendars[this.calendars.length - 1].year, this.calendars[this.calendars.length - 1].month, 1), visibleDate = date.getTime();
            // get the end of the month
            lastVisibleDate.setMonth(lastVisibleDate.getMonth() + 1);
            lastVisibleDate.setDate(lastVisibleDate.getDate() - 1);
            newCalendar = (visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate);
        }
        if (newCalendar) {
            this.calendars = [{
                    month: date.getMonth(),
                    year: date.getFullYear()
                }];
            if (this._o.mainCalendar === 'right') {
                this.calendars[0].month += 1 - this._o.numberOfMonths;
            }
        }
        this.adjustCalendars();
    },
    // CDS modifications: fix not working selection on dates where there is time change + fixed start date if picker date in undefined + Removed keyboard input
    // adjustDate: function(sign, days) {
    // 	var day = this.getDate();
    // 	if (day) {
    // 		var newDay = new Date(day);
    // 		if (sign === 'add') {
    // 			newDay.setDate(newDay.getDate() + days);
    // 		} else if (sign === 'subtract') {
    // 			newDay.setDate(newDay.getDate() - Math.abs(days));
    // 		}
    // 		this.setDate(newDay);
    // 	} else {
    // 		this.setDate(this._o.defaultDate || new Date());
    // 	}
    // },
    adjustCalendars: function () {
        this.calendars[0] = adjustCalendar(this.calendars[0]);
        for (var c = 1; c < this._o.numberOfMonths; c++) {
            this.calendars[c] = adjustCalendar({
                month: this.calendars[0].month + c,
                year: this.calendars[0].year
            });
        }
        this.draw();
    },
    gotoToday: function () {
        this.gotoDate(new Date());
    },
    /**
     * change view to a specific month (zero-index, e.g. 0: January)
     */
    gotoMonth: function (month) {
        if (!isNaN(month)) {
            this.calendars[0].month = parseInt(month, 10);
            this.adjustCalendars();
        }
    },
    nextMonth: function () {
        this.calendars[0].month++;
        this.adjustCalendars();
    },
    prevMonth: function () {
        this.calendars[0].month--;
        this.adjustCalendars();
    },
    /**
     * change view to a specific full year (e.g. "2012")
     */
    gotoYear: function (year) {
        if (!isNaN(year)) {
            this.calendars[0].year = parseInt(year, 10);
            this.adjustCalendars();
        }
    },
    /**
     * change the minDate
     */
    setMinDate: function (value) {
        if (value instanceof Date) {
            setToStartOfDay(value);
            this._o.minDate = value;
            this._o.minYear = value.getFullYear();
            this._o.minMonth = value.getMonth();
        }
        else {
            this._o.minDate = defaults.minDate;
            this._o.minYear = defaults.minYear;
            this._o.minMonth = defaults.minMonth;
            // this._o.startRange = defaults.startRange; // CDS modifications - do not change range when changing minDate
        }
        this.draw();
    },
    /**
     * change the maxDate
     */
    setMaxDate: function (value) {
        if (value instanceof Date) {
            setToStartOfDay(value);
            this._o.maxDate = value;
            this._o.maxYear = value.getFullYear();
            this._o.maxMonth = value.getMonth();
        }
        else {
            this._o.maxDate = defaults.maxDate;
            this._o.maxYear = defaults.maxYear;
            this._o.maxMonth = defaults.maxMonth;
            // this._o.endRange = defaults.endRange; // CDS modifications - do not change range when changing maxDate
        }
        this.draw();
    },
    setStartRange: function (value) {
        this._o.startRange = value;
    },
    setEndRange: function (value) {
        this._o.endRange = value;
    },
    /**
     * refresh the HTML
     */
    draw: function (force) {
        if (!this._v && !force) {
            return;
        }
        var selected = this.el.querySelector('.is-selected > button');
        var focusAgain = selected === document$1.activeElement;
        var opts = this._o, minYear = opts.minYear, maxYear = opts.maxYear, minMonth = opts.minMonth, maxMonth = opts.maxMonth, html = '', randId;
        if (this._y <= minYear) {
            this._y = minYear;
            if (!isNaN(minMonth) && this._m < minMonth) {
                this._m = minMonth;
            }
        }
        if (this._y >= maxYear) {
            this._y = maxYear;
            if (!isNaN(maxMonth) && this._m > maxMonth) {
                this._m = maxMonth;
            }
        }
        randId = this._randId;
        for (var c = 0; c < opts.numberOfMonths; c++) {
            html += '<div class="pika-lendar">' + renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year, randId) + this.render(this.calendars[c].year, this.calendars[c].month, randId) + '</div>';
        }
        this.el.innerHTML = html;
        if (focusAgain) {
            selected = this.el.querySelector('.is-selected > button');
            if (selected) {
                selected.focus();
            }
        }
        if (opts.bound) {
            if (opts.field.type !== 'hidden') {
                sto(function () {
                    opts.trigger.focus();
                }, 1);
            }
        }
        if (typeof this._o.onDraw === 'function') {
            this._o.onDraw(this);
        }
        if (opts.bound) {
            // let the screen reader user know to use arrow keys
            opts.field.setAttribute('aria-label', opts.ariaLabel);
        }
    },
    adjustPosition: function () {
        var field, pEl, width, height, viewportWidth, viewportHeight, scrollTop, left, top, clientRect, leftAligned, bottomAligned;
        if (this._o.container)
            return;
        this.el.style.position = 'absolute';
        field = this._o.trigger;
        pEl = field;
        width = this.el.offsetWidth;
        height = this.el.offsetHeight;
        viewportWidth = window.innerWidth || document$1.documentElement.clientWidth;
        viewportHeight = window.innerHeight || document$1.documentElement.clientHeight;
        scrollTop = window.pageYOffset || document$1.body.scrollTop || document$1.documentElement.scrollTop;
        leftAligned = true;
        bottomAligned = true;
        if (typeof field.getBoundingClientRect === 'function') {
            clientRect = field.getBoundingClientRect();
            left = clientRect.left + window.pageXOffset;
            top = clientRect.bottom + window.pageYOffset;
        }
        else {
            left = pEl.offsetLeft;
            top = pEl.offsetTop + pEl.offsetHeight;
            while ((pEl = pEl.offsetParent)) {
                left += pEl.offsetLeft;
                top += pEl.offsetTop;
            }
        }
        // default position is bottom & left
        if ((this._o.reposition && left + width > viewportWidth) ||
            (this._o.position.indexOf('right') > -1 &&
                left - width + field.offsetWidth > 0)) {
            left = left - width + field.offsetWidth;
            leftAligned = false;
        }
        if ((this._o.reposition && top + height > viewportHeight + scrollTop) ||
            (this._o.position.indexOf('top') > -1 &&
                top - height - field.offsetHeight > 0)) {
            top = top - height - field.offsetHeight;
            bottomAligned = false;
        }
        this.el.style.left = left + 'px';
        this.el.style.top = top + 'px';
        addClass(this.el, leftAligned ? 'left-aligned' : 'right-aligned');
        addClass(this.el, bottomAligned ? 'bottom-aligned' : 'top-aligned');
        removeClass(this.el, !leftAligned ? 'left-aligned' : 'right-aligned');
        removeClass(this.el, !bottomAligned ? 'bottom-aligned' : 'top-aligned');
    },
    /**
     * render HTML for a particular month
     */
    render: function (year, month, randId) {
        var opts = this._o, now = opts.now || new Date(), days = getDaysInMonth(year, month), before = new Date(year, month, 1).getDay(), data = [], row = [];
        setToStartOfDay(now);
        if (opts.firstDay > 0) {
            before -= opts.firstDay;
            if (before < 0) {
                before += 7;
            }
        }
        var previousMonth = month === 0 ? 11 : month - 1, nextMonth = month === 11 ? 0 : month + 1, yearOfPreviousMonth = month === 0 ? year - 1 : year, yearOfNextMonth = month === 11 ? year + 1 : year, daysInPreviousMonth = getDaysInMonth(yearOfPreviousMonth, previousMonth);
        var cells = days + before, after = cells;
        while (after > 7) {
            after -= 7;
        }
        cells += 7 - after;
        var isWeekSelected = false;
        for (var i = 0, r = 0; i < cells; i++) {
            var day = new Date(year, month, 1 + (i - before)), isSelected = isDate(this._d) ? compareDates(day, this._d) : false, isToday = compareDates(day, now), hasEvent = opts.events.indexOf(day.toDateString()) !== -1 ? true : false, isEmpty = i < before || i >= (days + before), dayNumber = 1 + (i - before), monthNumber = month, yearNumber = year, isStartRange = opts.startRange && compareDates(opts.startRange, day), isEndRange = opts.endRange && compareDates(opts.endRange, day), isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange, isDisabled = (opts.minDate && day < opts.minDate) ||
                (opts.maxDate && day > opts.maxDate) ||
                (opts.disableWeekends && isWeekend(day)) ||
                (opts.disableDayFn && opts.disableDayFn(day));
            if (isEmpty) {
                if (i < before) {
                    dayNumber = daysInPreviousMonth + dayNumber;
                    monthNumber = previousMonth;
                    yearNumber = yearOfPreviousMonth;
                }
                else {
                    dayNumber = dayNumber - days;
                    monthNumber = nextMonth;
                    yearNumber = yearOfNextMonth;
                }
            }
            var dayConfig = {
                day: dayNumber,
                month: monthNumber,
                year: yearNumber,
                hasEvent: hasEvent,
                isSelected: isSelected,
                isToday: isToday,
                isDisabled: isDisabled,
                isEmpty: isEmpty,
                isStartRange: isStartRange,
                isEndRange: isEndRange,
                isInRange: isInRange,
                showDaysInNextAndPreviousMonths: opts.showDaysInNextAndPreviousMonths,
                enableSelectionDaysInNextAndPreviousMonths: opts.enableSelectionDaysInNextAndPreviousMonths
            };
            if (opts.pickWholeWeek && isSelected) {
                isWeekSelected = true;
            }
            row.push(renderDay(dayConfig, opts.focusable));
            if (++r === 7) {
                if (opts.showWeekNumber) {
                    row.unshift(renderWeek(i - before, month, year));
                }
                data.push(renderRow(row, opts.isRTL, opts.pickWholeWeek, isWeekSelected));
                row = [];
                r = 0;
                isWeekSelected = false;
            }
        }
        return renderTable(opts, data, randId);
    },
    isVisible: function () {
        return this._v;
    },
    show: function () {
        if (!this.isVisible()) {
            this._v = true;
            this.draw();
            removeClass(this.el, 'is-hidden');
            if (this._o.bound) {
                addEvent(document$1, 'click', this._onClick);
                this.adjustPosition();
            }
            if (typeof this._o.onOpen === 'function') {
                this._o.onOpen.call(this);
            }
        }
    },
    hide: function () {
        var v = this._v;
        if (v !== false) {
            if (this._o.bound) {
                removeEvent(document$1, 'click', this._onClick);
            }
            this.el.style.position = 'static'; // reset
            this.el.style.left = 'auto';
            this.el.style.top = 'auto';
            addClass(this.el, 'is-hidden');
            this._v = false;
            if (v !== undefined && typeof this._o.onClose === 'function') {
                this._o.onClose.call(this);
            }
        }
    },
    /**
     * GAME OVER
     */
    destroy: function (removeElement) {
        if (removeElement === void 0) { removeElement = true; }
        var opts = this._o;
        this.hide();
        removeEvent(this.el, 'mousedown', this._onMouseDown, true);
        removeEvent(this.el, 'touchend', this._onMouseDown, true);
        removeEvent(this.el, 'change', this._onChange);
        // CDS Modifications: Removed keyboard input
        // if (opts.keyboardInput) {
        // 	removeEvent(document, 'keydown', this._onKeyChange);
        // }
        if (opts.field) {
            removeEvent(opts.field, 'change', this._onInputChange);
            if (opts.bound) {
                removeEvent(opts.trigger, 'click', this._onInputClick);
                removeEvent(opts.trigger, 'focus', this._onInputFocus);
                removeEvent(opts.trigger, 'blur', this._onInputBlur);
            }
        }
        if (removeElement && this.el.parentNode) {
            this.el.parentNode.removeChild(this.el);
        }
    }
};

var DateTimeConstraintsOptions = /** @class */ (function () {
    function DateTimeConstraintsOptions() {
    }
    return DateTimeConstraintsOptions;
}());
var TIME_REGEX$1 = /^([0-1]?\d|[2][0-3]):([0-5]\d)(:[0-5]\d)?$/;
function getDefaultDate(constraints, now) {
    var normalizedNow = Time.fromString(Time.fromDate(now).toString('date')).toDate();
    return normalizedNow >= constraints.effectiveFrom && normalizedNow <= constraints.effectiveTo
        ? now
        : (constraints.effectiveFrom || constraints.effectiveTo || now);
}
var DateTimeConstraints = /** @class */ (function () {
    function DateTimeConstraints(constraints) {
        this.constraints = constraints;
        // computed time specific
        this.timeFromHour = 0;
        this.timeFromMinute = 0;
        this.timeFromSecond = 0;
        this.timeFromNumber = 0;
        this.timeToHour = 23;
        this.timeToMinute = 59;
        this.timeToSecond = 59;
        this.timeToNumber = 24 * 60 * 60 - 1;
        this.mode = constraints.mode;
        this.from = constraints.from;
        this.to = constraints.to;
        this.rangeFrom = constraints.rangeFrom;
        this.rangeTo = constraints.rangeTo;
        this.allowedDays = constraints.allowedDays;
        this.disableWeekends = constraints.disableWeekends;
        this.hourStep = this.normalizeInteger(constraints.hourStep, 1);
        this.minuteStep = this.normalizeInteger(constraints.minuteStep, 1);
        this.secondStep = this.normalizeInteger(constraints.secondStep, 1);
        this.timeFrom = constraints.timeFrom;
        this.timeTo = constraints.timeTo;
        this.offset = this.normalizeInteger(constraints.offset);
        this.offsetInSeconds = this.offset != null ? this.offset * 60 : 0;
        if (this.from) {
            try {
                if (this.from.indexOf('T') !== -1) {
                    this.fromTime = Time.fromString(this.from).getTime() + this.offsetInSeconds * 1000;
                }
                else {
                    this.fromTime = Time.fromString(this.from).dayFloor().getTime() + (this.offsetInSeconds < 0 ? this.offsetInSeconds * 1000 : 0);
                }
            }
            catch (e) {
                this.from = undefined;
            }
        }
        if (this.to) {
            try {
                if (this.to.indexOf('T') !== -1) {
                    this.toTime = Time.fromString(this.to).getTime() + this.offsetInSeconds * 1000;
                }
                else {
                    this.toTime = Time.fromString(this.to).dayCeil().getTime() + (this.offsetInSeconds > 0 ? this.offsetInSeconds * 1000 : 0);
                }
            }
            catch (e) {
                this.to = undefined;
            }
        }
        if (this.rangeFrom) {
            try {
                if (this.rangeFrom.indexOf('T') !== -1) {
                    this.rangeFromTime = Time.fromString(this.rangeFrom).getTime();
                }
                else {
                    this.rangeFromTime = Time.fromString(this.rangeFrom).dayFloor().getTime();
                }
            }
            catch (e) {
                this.rangeFrom = undefined;
            }
        }
        if (this.rangeTo) {
            try {
                if (this.rangeTo.indexOf('T') !== -1) {
                    this.rangeToTime = Time.fromString(this.rangeTo).getTime();
                }
                else {
                    this.rangeToTime = Time.fromString(this.rangeTo).dayCeil().getTime();
                }
            }
            catch (e) {
                this.rangeTo = undefined;
            }
        }
        var allowedDaysLength = 0;
        if (Array.isArray(this.allowedDays)) {
            allowedDaysLength = this.allowedDays.length;
            if (allowedDaysLength !== 0) {
                this.allowedDays = this.allowedDays.filter(function (day) {
                    try {
                        Time.fromString(day);
                        return true;
                    }
                    catch (e) {
                        return false;
                    }
                });
                allowedDaysLength = this.allowedDays.length;
                this.allowedDays.sort();
                this.allowedDaysSet = new Set(this.allowedDays);
            }
            else {
                this.allowedDaysSet = new Set();
            }
        }
        var effectiveFrom = this.from && Time.fromDate(new Date(this.fromTime)).toString('date');
        var effectiveTo = this.to && Time.fromDate(new Date(this.toTime)).toString('date');
        if (allowedDaysLength !== 0) {
            if (!effectiveFrom || this.allowedDays[0] > effectiveFrom) {
                effectiveFrom = this.allowedDays[0];
            }
            if (!effectiveTo || this.allowedDays[allowedDaysLength - 1] < effectiveTo) {
                effectiveTo = this.allowedDays[allowedDaysLength - 1];
            }
        }
        if (effectiveFrom) {
            this.effectiveFrom = Time.fromString(effectiveFrom).toDate();
        }
        if (effectiveTo) {
            this.effectiveTo = Time.fromString(effectiveTo).toDate();
        }
        if (TIME_REGEX$1.test(this.timeFrom) && TIME_REGEX$1.test(this.timeTo)) {
            var timeFrom = this.getTimeNumber(this.timeFrom);
            this.timeFromHour = timeFrom.hours;
            this.timeFromMinute = timeFrom.minutes;
            this.timeFromSecond = timeFrom.seconds;
            this.timeFromNumber = timeFrom.total;
            var timeTo = this.getTimeNumber(this.timeTo);
            this.timeToHour = timeTo.hours;
            this.timeToMinute = timeTo.minutes;
            this.timeToSecond = timeTo.seconds;
            this.timeToNumber = timeTo.total;
        }
        else {
            this.timeFrom = undefined;
            this.timeTo = undefined;
        }
    }
    DateTimeConstraints.empty = function () {
        return new DateTimeConstraints({});
    };
    DateTimeConstraints.from = function (constraints) {
        if (constraints instanceof DateTimeConstraints) {
            return constraints;
        }
        else if (constraints) {
            return new DateTimeConstraints(constraints);
        }
        else {
            return new DateTimeConstraints({});
        }
    };
    DateTimeConstraints.prototype.createTimeConstraints = function (date) {
        return new DateTimeConstraints({
            hourStep: this.hourStep,
            minuteStep: this.minuteStep,
            secondStep: this.secondStep,
            // TODO calculate effective timeFrom and timeTo based on date
            timeFrom: this.timeFrom,
            timeTo: this.timeTo,
        });
    };
    DateTimeConstraints.prototype.update = function (constraints) {
        return new DateTimeConstraints(__assign(__assign({}, this.constraints), constraints));
    };
    DateTimeConstraints.prototype.updateTimezone = function (timezone) {
        if (timezone) {
            var offset = timezone.offset;
            if (offset !== this.offset) {
                return new DateTimeConstraints(__assign(__assign({}, this.constraints), { offset: offset }));
            }
        }
        else if (this.offset) {
            return new DateTimeConstraints(__assign(__assign({}, this.constraints), { offset: undefined }));
        }
        return this;
    };
    DateTimeConstraints.prototype.checkTimeRange = function (timeNumber) {
        if (this.timeFromNumber <= this.timeToNumber) {
            return timeNumber >= this.timeFromNumber && timeNumber <= this.timeToNumber;
        }
        else {
            return timeNumber >= this.timeFromNumber || timeNumber <= this.timeToNumber;
        }
    };
    DateTimeConstraints.prototype.getTimeNumber = function (time, noOffset) {
        var parts = time.split(':');
        var hours = +parts[0] || 0;
        var minutes = +parts[1] || 0;
        var seconds = +parts[2] || 0;
        var total = hours * 3600 + minutes * 60 + seconds + (noOffset ? 0 : (this.offsetInSeconds || 0));
        total = (total + 86400) % 86400;
        seconds = total % 60;
        minutes = Math.floor(total / 60) % 60;
        hours = Math.floor(total / 3600);
        return {
            total: total,
            hours: hours,
            minutes: minutes,
            seconds: seconds,
        };
    };
    DateTimeConstraints.prototype.normalizeInteger = function (step, defaultStep) {
        // tslint:disable-next-line no-bitwise
        return step === (step | 0) ? step : defaultStep;
    };
    return DateTimeConstraints;
}());

var TIMEZONES = [
    { code: 'UTC-12:00', offset: -(12 * 60), name: 'UTC -12' },
    { code: 'UTC-11:00', offset: -(11 * 60), name: 'UTC -11' },
    { code: 'UTC-10:00', offset: -(10 * 60), name: 'UTC -10' },
    { code: 'UTC-09:30', offset: -(9 * 60 + 30), name: 'UTC -9:30' },
    { code: 'UTC-09:00', offset: -(9 * 60), name: 'UTC -9' },
    { code: 'UTC-08:00', offset: -(8 * 60), name: 'UTC -8' },
    { code: 'UTC-07:00', offset: -(7 * 60), name: 'UTC -7' },
    { code: 'UTC-06:00', offset: -(6 * 60), name: 'UTC -6' },
    { code: 'UTC-05:00', offset: -(5 * 60), name: 'UTC -5' },
    { code: 'UTC-04:00', offset: -(4 * 60), name: 'UTC -4' },
    { code: 'UTC-03:00', offset: -(3 * 60), name: 'UTC -3' },
    { code: 'UTC-03:30', offset: -(3 * 60 + 30), name: 'UTC -3:30' },
    { code: 'UTC-02:00', offset: -(2 * 60), name: 'UTC -2' },
    { code: 'UTC-01:00', offset: -(1 * 60), name: 'UTC -1' },
    { code: 'UTC+00:00', offset: (0), name: 'UTC' },
    { code: 'UTC+01:00', offset: (1 * 60), name: 'UTC +1' },
    { code: 'UTC+02:00', offset: (2 * 60), name: 'UTC +2' },
    { code: 'UTC+03:00', offset: (3 * 60), name: 'UTC +3' },
    { code: 'UTC+03:30', offset: (3 * 60 + 30), name: 'UTC +3:30' },
    { code: 'UTC+04:00', offset: (4 * 60), name: 'UTC +4' },
    { code: 'UTC+04:30', offset: (4 * 60 + 30), name: 'UTC +4:30' },
    { code: 'UTC+05:00', offset: (5 * 60), name: 'UTC +5' },
    { code: 'UTC+05:30', offset: (5 * 60 + 30), name: 'UTC +5:30' },
    { code: 'UTC+05:45', offset: (5 * 60 + 45), name: 'UTC +5:45' },
    { code: 'UTC+06:00', offset: (6 * 60), name: 'UTC +6' },
    { code: 'UTC+06:30', offset: (6 * 60 + 30), name: 'UTC +6:30' },
    { code: 'UTC+07:00', offset: (7 * 60), name: 'UTC +7' },
    { code: 'UTC+08:00', offset: (8 * 60), name: 'UTC +8' },
    { code: 'UTC+08:45', offset: (8 * 60 + 45), name: 'UTC +8:45' },
    { code: 'UTC+09:00', offset: (9 * 60), name: 'UTC +9' },
    { code: 'UTC+09:30', offset: (9 * 60 + 30), name: 'UTC +9:30' },
    { code: 'UTC+10:00', offset: (10 * 60), name: 'UTC +10' },
    { code: 'UTC+10:30', offset: (10 * 60 + 30), name: 'UTC +10:30' },
    { code: 'UTC+11:00', offset: (11 * 60), name: 'UTC +11' },
    { code: 'UTC+12:00', offset: (12 * 60), name: 'UTC +12' },
    { code: 'UTC+12:45', offset: (12 * 60 + 45), name: 'UTC +12:45' },
    { code: 'UTC+13:00', offset: (13 * 60), name: 'UTC +13' },
    { code: 'UTC+14:00', offset: (14 * 60), name: 'UTC +14' },
];
var TimezonesService = /** @class */ (function () {
    function TimezonesService() {
        this.timezonesMap = keyBy(TIMEZONES, function (timezone) { return timezone.code; });
    }
    TimezonesService.prototype.getTimezone = function (code) {
        return this.timezonesMap[code];
    };
    TimezonesService.prototype.getTimezones = function () {
        return TIMEZONES;
    };
    TimezonesService.prototype.getUTCTimezone = function () {
        if (!this.utcTimezone) {
            var timezones = this.getTimezones();
            this.utcTimezone = timezones.find(function (zone) { return zone.offset === 0; });
        }
        return this.utcTimezone;
    };
    TimezonesService.prototype.getLocalTimezone = function () {
        if (!this.localTimezone) {
            var localOffset_1 = -new Date().getTimezoneOffset();
            var timezones = this.getTimezones();
            this.localTimezone = timezones.find(function (zone) { return zone.offset === localOffset_1; });
        }
        return this.localTimezone;
    };
    TimezonesService.ɵprov = ɵɵdefineInjectable({ factory: function TimezonesService_Factory() { return new TimezonesService(); }, token: TimezonesService, providedIn: "root" });
    TimezonesService = __decorate([ __metadata("design:paramtypes", [])
    ], TimezonesService);
TimezonesService.ɵfac = function TimezonesService_Factory(t) { return new (t || TimezonesService)(); };
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TimezonesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
    return TimezonesService;
}());

var BaseTimeComponent = /** @class */ (function () {
    function BaseTimeComponent(timezonesService) {
        this.timezonesService = timezonesService;
        this.constraints = DateTimeConstraints.from(this.updatedConstraints());
    }
    BaseTimeComponent.prototype.ngOnChanges = function (changes) {
        var constraints = this.updatedConstraints();
        if (constraints) {
            this.constraints = this.constraints.update(constraints);
        }
    };
    BaseTimeComponent.prototype.updatedConstraints = function () {
        if (this.hourStep || this.minuteStep || this.secondStep || this.timeFrom || this.timeTo || this.timezoneValue) {
            var offset = void 0;
            if (this.timezonesService) {
                var timezone = this.timezonesService.getTimezone(this.timezoneValue);
                if (timezone) {
                    offset = timezone.offset;
                }
            }
            return {
                hourStep: this.hourStep,
                minuteStep: this.minuteStep,
                secondStep: this.secondStep,
                timeFrom: this.timeFrom,
                timeTo: this.timeTo,
                offset: offset,
            };
        }
    };
    BaseTimeComponent.ctorParameters = function () { return [
        { type: TimezonesService, decorators: [{ type: Optional }] }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], BaseTimeComponent.prototype, "hourStep", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], BaseTimeComponent.prototype, "minuteStep", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], BaseTimeComponent.prototype, "secondStep", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], BaseTimeComponent.prototype, "timeFrom", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], BaseTimeComponent.prototype, "timeTo", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], BaseTimeComponent.prototype, "timezoneValue", void 0);
    BaseTimeComponent = __decorate([ __param(0, Optional()),
        __metadata("design:paramtypes", [TimezonesService])
    ], BaseTimeComponent);
BaseTimeComponent.ɵfac = function BaseTimeComponent_Factory(t) { return new (t || BaseTimeComponent)(ɵngcc0.ɵɵdirectiveInject(TimezonesService, 8)); };
BaseTimeComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BaseTimeComponent, inputs: { hourStep: "hourStep", minuteStep: "minuteStep", secondStep: "secondStep", timeFrom: "timeFrom", timeTo: "timeTo", timezoneValue: "timezoneValue" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BaseTimeComponent, [{
        type: Directive
    }], function () { return [{ type: TimezonesService, decorators: [{
                type: Optional
            }] }]; }, { hourStep: [{
            type: Input
        }], minuteStep: [{
            type: Input
        }], secondStep: [{
            type: Input
        }], timeFrom: [{
            type: Input
        }], timeTo: [{
            type: Input
        }], timezoneValue: [{
            type: Input
        }] }); })();
    return BaseTimeComponent;
}());

var BaseDateTimeComponent = /** @class */ (function (_super) {
    __extends(BaseDateTimeComponent, _super);
    function BaseDateTimeComponent(timezonesService) {
        var _this = _super.call(this, timezonesService) || this;
        _this.constraints = DateTimeConstraints.from(_this.updatedConstraints());
        return _this;
    }
    BaseDateTimeComponent.prototype.updatedConstraints = function () {
        var constraints = _super.prototype.updatedConstraints.call(this);
        if (this.from || this.to || this.rangeFrom || this.rangeTo || this.disableWeekends || this.allowedDays) {
            return __assign(__assign({}, constraints), { from: this.from, to: this.to, rangeFrom: this.rangeFrom, rangeTo: this.rangeTo, allowedDays: this.allowedDays, disableWeekends: this.disableWeekends });
        }
        return constraints;
    };
    BaseDateTimeComponent.ctorParameters = function () { return [
        { type: TimezonesService, decorators: [{ type: Optional }] }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], BaseDateTimeComponent.prototype, "allowedDays", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], BaseDateTimeComponent.prototype, "from", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], BaseDateTimeComponent.prototype, "to", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], BaseDateTimeComponent.prototype, "rangeFrom", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], BaseDateTimeComponent.prototype, "rangeTo", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], BaseDateTimeComponent.prototype, "yearSelectRange", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], BaseDateTimeComponent.prototype, "disableWeekends", void 0);
    BaseDateTimeComponent = __decorate([ __param(0, Optional()),
        __metadata("design:paramtypes", [TimezonesService])
    ], BaseDateTimeComponent);
BaseDateTimeComponent.ɵfac = function BaseDateTimeComponent_Factory(t) { return new (t || BaseDateTimeComponent)(ɵngcc0.ɵɵdirectiveInject(TimezonesService, 8)); };
BaseDateTimeComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: BaseDateTimeComponent, inputs: { allowedDays: "allowedDays", from: "from", to: "to", rangeFrom: "rangeFrom", rangeTo: "rangeTo", yearSelectRange: "yearSelectRange", disableWeekends: "disableWeekends" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BaseDateTimeComponent, [{
        type: Directive
    }], function () { return [{ type: TimezonesService, decorators: [{
                type: Optional
            }] }]; }, { allowedDays: [{
            type: Input
        }], from: [{
            type: Input
        }], to: [{
            type: Input
        }], rangeFrom: [{
            type: Input
        }], rangeTo: [{
            type: Input
        }], yearSelectRange: [{
            type: Input
        }], disableWeekends: [{
            type: Input
        }] }); })();
    return BaseDateTimeComponent;
}(BaseTimeComponent));

function dateTimeNowFactory() {
    return function () {
        var date = new Date();
        var offsetDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
        var isoDate = offsetDate.toISOString().substr(0, 19);
        return isoDate;
    };
}
/**
 * Provide current date and time in YYYY-MM-DDTHH:MM:SS format without timezone
 */
var CDS_DATE_TIME_NOW = new InjectionToken('CDS_DATE_TIME_NOW', { factory: dateTimeNowFactory });

function deviceBreakpointsFactory() {
    return {
        desktop: 1024,
        tablet: 768,
        mobile: 0,
    };
}
var CDS_DEVICE_BREAKPOINTS = new InjectionToken('CDS_DEVICE_BREAKPOINTS', {
    factory: deviceBreakpointsFactory,
});

var MatchMediaService = /** @class */ (function () {
    function MatchMediaService(platform, breakpoints) {
        var _this = this;
        this.platform = platform;
        this.breakpoints = breakpoints;
        this.device$ = defer(function () {
            return _this.observeBreakpoints(_this.breakpoints);
        });
    }
    MatchMediaService.prototype.matchMedia = function (query) {
        if (isPlatformBrowser(this.platform) && window.matchMedia) {
            createEmptyStyleRule(query);
            return window.matchMedia(query);
        }
        else {
            return null;
        }
    };
    MatchMediaService.prototype.observeMedia = function (query) {
        var _this = this;
        return new Observable(function (subscriber) {
            var match = _this.matchMedia(query);
            if (!match) {
                subscriber.complete();
            }
            else {
                subscriber.next(match);
                var callback_1 = function (event) {
                    subscriber.next(event);
                };
                if (match.addListener) {
                    match.addListener(callback_1);
                    return function () {
                        match.removeListener(callback_1);
                    };
                }
                else {
                    match.addEventListener('change', callback_1);
                    return function () {
                        match.removeEventListener('change', callback_1);
                    };
                }
            }
        });
    };
    MatchMediaService.prototype.observeBreakpoints = function (breakpoints) {
        var _this = this;
        var breakpointList = Object.keys(breakpoints).map(function (name) {
            return {
                name: name,
                minWidth: breakpoints[name],
            };
        }).sort(function (a, b) { return b.minWidth - a.minWidth; });
        var matches = {};
        return merge.apply(void 0, __spread(breakpointList.map(function (breakpoint) {
            if (breakpoint.minWidth === 0) {
                return of({
                    name: breakpoint.name,
                    matches: true,
                });
            }
            return _this.observeMedia("(min-width: " + breakpoint.minWidth + "px)").pipe(map(function (mediaQuery) {
                return {
                    name: breakpoint.name,
                    matches: mediaQuery.matches,
                };
            }));
        }))).pipe(map(function (query) {
            var e_1, _a;
            matches[query.name] = query.matches;
            try {
                for (var breakpointList_1 = __values(breakpointList), breakpointList_1_1 = breakpointList_1.next(); !breakpointList_1_1.done; breakpointList_1_1 = breakpointList_1.next()) {
                    var breakpoint = breakpointList_1_1.value;
                    if (matches[breakpoint.name]) {
                        return breakpoint.name;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (breakpointList_1_1 && !breakpointList_1_1.done && (_a = breakpointList_1.return)) _a.call(breakpointList_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return null;
        }), skip(breakpointList.length - 1), distinctUntilChanged());
    };
    MatchMediaService.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [CDS_DEVICE_BREAKPOINTS,] }] }
    ]; };
    MatchMediaService.ɵprov = ɵɵdefineInjectable({ factory: function MatchMediaService_Factory() { return new MatchMediaService(ɵɵinject(PLATFORM_ID), ɵɵinject(CDS_DEVICE_BREAKPOINTS)); }, token: MatchMediaService, providedIn: "root" });
    MatchMediaService = __decorate([ __param(0, Inject(PLATFORM_ID)),
        __param(1, Inject(CDS_DEVICE_BREAKPOINTS)),
        __metadata("design:paramtypes", [Object, Object])
    ], MatchMediaService);
MatchMediaService.ɵfac = function MatchMediaService_Factory(t) { return new (t || MatchMediaService)(ɵngcc0.ɵɵinject(PLATFORM_ID), ɵngcc0.ɵɵinject(CDS_DEVICE_BREAKPOINTS)); };
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MatchMediaService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [CDS_DEVICE_BREAKPOINTS]
            }] }]; }, null); })();
    return MatchMediaService;
}());
var queryCache = new Set();
var styleNode;
function createEmptyStyleRule(query) {
    if (queryCache.has(query)) {
        return;
    }
    try {
        if (!styleNode) {
            styleNode = document.createElement('style');
            styleNode.setAttribute('type', 'text/css');
            document.head.appendChild(styleNode);
        }
        if (styleNode.sheet) {
            styleNode.sheet.insertRule("@media " + query + " { .cds-query{ } }", 0);
            queryCache.add(query);
        }
    }
    catch (e) {
        console.error(e);
    }
}

var Keys;
(function (Keys) {
    Keys[Keys["PageUp"] = 33] = "PageUp";
    Keys[Keys["PageDown"] = 34] = "PageDown";
    Keys[Keys["End"] = 35] = "End";
    Keys[Keys["Home"] = 36] = "Home";
    Keys[Keys["Left"] = 37] = "Left";
    Keys[Keys["Top"] = 38] = "Top";
    Keys[Keys["Right"] = 39] = "Right";
    Keys[Keys["Bottom"] = 40] = "Bottom";
})(Keys || (Keys = {}));
function keyboardNavigation(value, isSelected, constraints, event) {
    var setDate = function (date) {
        if (constraints.effectiveFrom && date < constraints.effectiveFrom) {
            date = constraints.effectiveFrom;
        }
        else if (constraints.effectiveTo && date > constraints.effectiveTo) {
            date = constraints.effectiveTo;
        }
        var value = Time.fromDate(date).toString('date');
        return value;
    };
    var addDays = function (time, days) {
        var date = new Date(time.getTime());
        date.setDate(date.getDate() + days);
        return setDate(date);
    };
    var addMonths = function (time, months) {
        var originalDate = new Date(time.getTime());
        var date = new Date(time.getTime());
        date.setMonth(date.getMonth() + months);
        var originalMonth = originalDate.getMonth() || 12;
        if (date.getMonth() !== (originalMonth + months) % 12) {
            date.setDate(0);
        }
        return setDate(date);
    };
    var time;
    if (!value) {
        return;
    }
    try {
        time = Time.fromString(value);
    }
    catch (e) {
        return;
    }
    if (isSelected) {
        switch (event.keyCode) {
            case Keys.Home:
                var homeDate = new Date(time.getTime());
                homeDate.setDate(1);
                return setDate(homeDate);
            case Keys.PageUp:
                return addMonths(time, -1);
            case Keys.Top:
                return addDays(time, -7);
            case Keys.Left:
                return addDays(time, -1);
            case Keys.Right:
                return addDays(time, 1);
            case Keys.Bottom:
                return addDays(time, 7);
            case Keys.PageDown:
                return addMonths(time, 1);
            case Keys.End:
                var endDate = new Date(time.getTime());
                endDate.setDate(1);
                endDate.setMonth(endDate.getMonth() + 1);
                endDate.setDate(0);
                return setDate(endDate);
        }
    }
    else {
        switch (event.keyCode) {
            case Keys.Home:
            case Keys.PageUp:
            case Keys.Right:
            case Keys.Bottom:
                var startDate = new Date(time.getTime());
                startDate.setDate(1);
                return setDate(startDate);
            case Keys.Top:
            case Keys.Left:
            case Keys.End:
            case Keys.PageDown:
                var endDate = new Date(time.getTime());
                endDate.setDate(1);
                endDate.setMonth(endDate.getMonth() + 1);
                endDate.setDate(0);
                return setDate(endDate);
        }
    }
}

var DEFAULT_YEARS_RANGE = 10;
var DATE_PICKER_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return CalendarComponent; }),
    multi: true,
};
var CalendarComponent = /** @class */ (function (_super) {
    __extends(CalendarComponent, _super);
    function CalendarComponent(renderer, elementRef, cdRef, localeId, now, componentTranslations, matchMedia) {
        var _this = _super.call(this, null) || this;
        _this.elementRef = elementRef;
        _this.cdRef = cdRef;
        _this.localeId = localeId;
        _this.now = now;
        _this.matchMedia = matchMedia;
        _this.padDaysInMonth = false;
        _this.numberOfMonths = 1;
        _this.focusable = true;
        _this.yearSelectRange = DEFAULT_YEARS_RANGE;
        _this.onChange = noop;
        _this.onTouched = noop;
        _this.onSelect = function (date) {
            if (date) {
                _this.onChange(Time.fromDate(date).toString());
            }
            else {
                _this.onChange(null);
            }
            _this.cdRef.markForCheck();
        };
        _this.disabled = false;
        renderer.addClass(elementRef.nativeElement, 'cds-calendar');
        _this.weekdays = getLocaleDayNames(localeId, FormStyle.Standalone, TranslationWidth.Wide);
        _this.weekdaysShort = getLocaleDayNames(localeId, FormStyle.Standalone, TranslationWidth.Short);
        _this.months = getLocaleMonthNames(localeId, FormStyle.Standalone, TranslationWidth.Abbreviated);
        _this.firstDay = getLocaleFirstDayOfWeek(localeId);
        componentTranslations.use(CDS_CALENDAR_TRANSLATIONS, calendarTranslationsFactory, function (translations) {
            _this.translations = translations;
            if (_this.picker) {
                _this.picker.config({
                    firstDay: _this.translations.firstDay != null ? _this.translations.firstDay : _this.firstDay,
                    i18n: {
                        months: _this.translations.months ? _this.translations.months : _this.months,
                        weekdays: _this.translations.weekdays ? _this.translations.weekdays : _this.weekdays,
                        weekdaysShort: _this.translations.weekdaysShort ? _this.translations.weekdaysShort : _this.weekdaysShort,
                        previousMonth: _this.translations.previousMonth,
                        nextMonth: _this.translations.nextMonth,
                    },
                });
                _this.picker.draw();
            }
        });
        return _this;
    }
    CalendarComponent.prototype.onKeyPress = function (event) {
        if (this.focusable) {
            var startDate = void 0;
            var isSelected = false;
            if (this.picker) {
                var selectedDate = this.picker.getDate();
                var calendar = this.picker.calendars[0];
                if (selectedDate && selectedDate.getFullYear() === calendar.year && selectedDate.getMonth() === calendar.month) {
                    startDate = selectedDate;
                    isSelected = true;
                }
                else {
                    startDate = new Date(calendar.year, calendar.month, 1);
                }
            }
            else {
                return;
            }
            var startValue = startDate && Time.fromDate(startDate).toString('date');
            if (startValue) {
                var value = keyboardNavigation(startValue, isSelected, this.constraints, event);
                if (value) {
                    event.preventDefault();
                    if (!isSelected || value !== startValue) {
                        this.writeValue(value);
                        var button = this.elementRef.nativeElement.querySelector('.is-selected > button');
                        button.focus();
                        this.onChange(value);
                    }
                }
            }
        }
    };
    CalendarComponent.prototype.ngOnChanges = function (changes) {
        _super.prototype.ngOnChanges.call(this, changes);
        if (this.picker) {
            this.picker.setMinDate(this.constraints.effectiveFrom || null);
            this.picker.setMaxDate(this.constraints.effectiveTo || null);
        }
    };
    CalendarComponent.prototype.ngOnInit = function () {
        var _this = this;
        var now = new Date(this.now());
        var defaultDate = getDefaultDate(this.constraints, now);
        var config = {
            now: now,
            field: document.createElement('div'),
            container: this.elementRef.nativeElement,
            bound: false,
            firstDay: this.translations.firstDay != null ? this.translations.firstDay : this.firstDay,
            disableWeekends: this.constraints.disableWeekends,
            showDaysInNextAndPreviousMonths: this.padDaysInMonth,
            minDate: this.constraints.effectiveFrom,
            maxDate: this.constraints.effectiveTo,
            defaultDate: defaultDate,
            blurFieldOnSelect: !this.focusable,
            focusable: this.focusable,
            yearRange: this.yearSelectRange
                ? typeof this.yearSelectRange === 'number'
                    ? this.yearSelectRange
                    : [this.yearSelectRange.from, this.yearSelectRange.to]
                : DEFAULT_YEARS_RANGE,
            i18n: {
                months: this.translations.months ? this.translations.months : this.months,
                weekdays: this.translations.weekdays ? this.translations.weekdays : this.weekdays,
                weekdaysShort: this.translations.weekdaysShort ? this.translations.weekdaysShort : this.weekdaysShort,
                previousMonth: this.translations.previousMonth,
                nextMonth: this.translations.nextMonth,
            },
            onSelect: this.onSelect,
            disableDayFn: function (date) {
                if (_this.disabled) {
                    return true;
                }
                if (_this.constraints && _this.constraints.allowedDaysSet) {
                    return !_this.constraints.allowedDaysSet.has(Time.fromDate(date).toString());
                }
                return false;
            },
            onClose: function () { return _this.onTouched(); },
            numberOfMonths: this.numberOfMonths,
        };
        this.picker = new Pikaday(config);
        if (this.numberOfMonths != 1) {
            this.mediaSubscription = this.matchMedia.observeBreakpoints({ one: 0, more: 768 }).subscribe(function (breakpoint) {
                if (breakpoint === 'one') {
                    _this.picker.config({ numberOfMonths: 1 });
                }
                else {
                    _this.picker.config({ numberOfMonths: _this.numberOfMonths });
                }
            });
        }
    };
    CalendarComponent.prototype.ngOnDestroy = function () {
        this.picker.destroy(false);
        if (this.mediaSubscription) {
            this.mediaSubscription.unsubscribe();
        }
    };
    CalendarComponent.prototype.writeValue = function (obj) {
        if (!obj) {
            this.picker.setDate(null, true);
        }
        else {
            var date = typeof obj === 'string' ? new Date(obj) : obj;
            if (date instanceof Date) {
                // Normalize to UTC
                date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
            }
            this.picker.setDate(date, true);
            var pickerDate = this.picker.getDate();
            if (pickerDate !== null && Time.fromDate(pickerDate).toString() !== obj) {
                this.picker.setDate(null, true);
            }
        }
    };
    CalendarComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    CalendarComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    CalendarComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
        if (this.picker) {
            this.picker.gotoDate(this.picker.getDate());
        }
        this.cdRef.markForCheck();
    };
    CalendarComponent.prototype.goToDate = function (date) {
        this.picker.gotoDate(Time.fromString(date).toDate());
    };
    CalendarComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef },
        { type: ChangeDetectorRef },
        { type: String, decorators: [{ type: Inject, args: [LOCALE_ID,] }] },
        { type: undefined, decorators: [{ type: Inject, args: [CDS_DATE_TIME_NOW,] }] },
        { type: DynamicTranslations },
        { type: MatchMediaService }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", DateTimeConstraints)
    ], CalendarComponent.prototype, "constraints", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], CalendarComponent.prototype, "padDaysInMonth", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], CalendarComponent.prototype, "numberOfMonths", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], CalendarComponent.prototype, "focusable", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], CalendarComponent.prototype, "yearSelectRange", void 0);
    __decorate([
        HostListener('keydown', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [KeyboardEvent]),
        __metadata("design:returntype", void 0)
    ], CalendarComponent.prototype, "onKeyPress", null);
    CalendarComponent = __decorate([ __param(3, Inject(LOCALE_ID)),
        __param(4, Inject(CDS_DATE_TIME_NOW)),
        __metadata("design:paramtypes", [Renderer2,
            ElementRef,
            ChangeDetectorRef, String, Function, DynamicTranslations,
            MatchMediaService])
    ], CalendarComponent);
CalendarComponent.ɵfac = function CalendarComponent_Factory(t) { return new (t || CalendarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(LOCALE_ID), ɵngcc0.ɵɵdirectiveInject(CDS_DATE_TIME_NOW), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations), ɵngcc0.ɵɵdirectiveInject(MatchMediaService)); };
CalendarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CalendarComponent, selectors: [["cds-calendar"]], hostBindings: function CalendarComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function CalendarComponent_keydown_HostBindingHandler($event) { return ctx.onKeyPress($event); });
    } }, inputs: { constraints: "constraints", padDaysInMonth: "padDaysInMonth", numberOfMonths: "numberOfMonths", focusable: "focusable", yearSelectRange: "yearSelectRange" }, features: [ɵngcc0.ɵɵProvidersFeature([DATE_PICKER_CONTROL_VALUE_ACCESSOR, DynamicTranslations]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 0, vars: 0, template: function CalendarComponent_Template(rf, ctx) { }, encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CalendarComponent, [{
        type: Component,
        args: [{
                selector: 'cds-calendar',
                template: '',
                providers: [DATE_PICKER_CONTROL_VALUE_ACCESSOR, DynamicTranslations],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }, { type: String, decorators: [{
                type: Inject,
                args: [LOCALE_ID]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [CDS_DATE_TIME_NOW]
            }] }, { type: DynamicTranslations }, { type: MatchMediaService }]; }, { onKeyPress: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], constraints: [{
            type: Input
        }], padDaysInMonth: [{
            type: Input
        }], numberOfMonths: [{
            type: Input
        }], focusable: [{
            type: Input
        }], yearSelectRange: [{
            type: Input
        }] }); })();
    return CalendarComponent;
}(BaseDateTimeComponent));

var DATE_PICKER_RANGE_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return CalendarRangeComponent; }),
    multi: true,
};
/**
 * Component for internal usage within project.
 * It should not be exposed as a part of public API.
 */
var CalendarRangeComponent = /** @class */ (function (_super) {
    __extends(CalendarRangeComponent, _super);
    function CalendarRangeComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clickValueChange = new EventEmitter();
        _this.keyboardValueChange = new EventEmitter();
        _this.onChange = noop;
        _this.onSelect = function (date) {
            if (date) {
                _this.onChange(Time.fromDate(date).toString(), true);
            }
            else {
                _this.onChange(null, true);
            }
            _this.cdRef.markForCheck();
        };
        return _this;
    }
    Object.defineProperty(CalendarRangeComponent.prototype, "isFocusOnFrom", {
        get: function () {
            return this.focusOn === 'from';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarRangeComponent.prototype, "isFocusOnTo", {
        get: function () {
            return this.focusOn === 'to';
        },
        enumerable: true,
        configurable: true
    });
    CalendarRangeComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (this.startRange && this.endRange && this.startRange <= this.endRange) {
            this.updateRange();
        }
    };
    CalendarRangeComponent.prototype.registerOnChange = function (fn) {
        var _this = this;
        this.onChange = function (value, click) {
            if (click === void 0) { click = false; }
            if (click) {
                _this.clickValueChange.emit(value);
            }
            else {
                _this.keyboardValueChange.emit(value);
            }
            fn(value);
        };
    };
    CalendarRangeComponent.prototype.ngOnChanges = function (changes) {
        _super.prototype.ngOnChanges.call(this, changes);
        if (this.picker && ('startRange' in changes || 'endRange' in changes)) {
            if (!this.startRange || !this.endRange) {
                this.clearRange();
                if (this.startRange || this.endRange) {
                    try {
                        this.picker.setDate(Time.fromString(this.startRange || this.endRange).toDate(), true);
                    }
                    catch (e) {
                        /* Invalid date string - do not set range on calendar */
                    }
                }
            }
            else if (this.startRange <= this.endRange) {
                this.updateRange();
            }
            else {
                this.clearRange();
            }
        }
    };
    CalendarRangeComponent.prototype.updateRange = function () {
        var _a = this.picker.config(), prevEndRange = _a.endRange, prevStartRange = _a.startRange;
        try {
            var startRange = Time.fromString(this.startRange).toDate();
            var endRange = Time.fromString(this.endRange).toDate();
            if (+startRange === +prevStartRange && +endRange === +prevEndRange) {
                return;
            }
            this.picker.setStartRange(startRange);
            this.picker.setEndRange(endRange);
            this.picker.draw(true);
        }
        catch (error) {
            /* Invalid date strings */
            this.clearRange();
        }
    };
    CalendarRangeComponent.prototype.clearRange = function () {
        var _a = this.picker.config(), endRange = _a.endRange, startRange = _a.startRange;
        if (startRange && endRange) {
            this.picker.setStartRange(null);
            this.picker.setEndRange(null);
            this.picker.draw(true);
        }
    };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], CalendarRangeComponent.prototype, "startRange", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], CalendarRangeComponent.prototype, "endRange", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], CalendarRangeComponent.prototype, "focusOn", void 0);
    __decorate([
        HostBinding('class.cds-calendar-range-focus-on-from'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], CalendarRangeComponent.prototype, "isFocusOnFrom", null);
    __decorate([
        HostBinding('class.cds-calendar-range-focus-on-to'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], CalendarRangeComponent.prototype, "isFocusOnTo", null);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], CalendarRangeComponent.prototype, "clickValueChange", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], CalendarRangeComponent.prototype, "keyboardValueChange", void 0);
CalendarRangeComponent.ɵfac = function CalendarRangeComponent_Factory(t) { return ɵCalendarRangeComponent_BaseFactory(t || CalendarRangeComponent); };
CalendarRangeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CalendarRangeComponent, selectors: [["cds-calendar-range"]], hostVars: 4, hostBindings: function CalendarRangeComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("cds-calendar-range-focus-on-from", ctx.isFocusOnFrom)("cds-calendar-range-focus-on-to", ctx.isFocusOnTo);
    } }, inputs: { startRange: "startRange", endRange: "endRange", focusOn: "focusOn" }, outputs: { clickValueChange: "clickValueChange", keyboardValueChange: "keyboardValueChange" }, features: [ɵngcc0.ɵɵProvidersFeature([DATE_PICKER_RANGE_CONTROL_VALUE_ACCESSOR]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 0, vars: 0, template: function CalendarRangeComponent_Template(rf, ctx) { }, encapsulation: 2, changeDetection: 0 });
var ɵCalendarRangeComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(CalendarRangeComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CalendarRangeComponent, [{
        type: Component,
        args: [{
                selector: 'cds-calendar-range',
                template: '',
                providers: [DATE_PICKER_RANGE_CONTROL_VALUE_ACCESSOR],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], null, { isFocusOnFrom: [{
            type: HostBinding,
            args: ['class.cds-calendar-range-focus-on-from']
        }], isFocusOnTo: [{
            type: HostBinding,
            args: ['class.cds-calendar-range-focus-on-to']
        }], startRange: [{
            type: Input
        }], endRange: [{
            type: Input
        }], focusOn: [{
            type: Input
        }], clickValueChange: [{
            type: Output
        }], keyboardValueChange: [{
            type: Output
        }] }); })();
    return CalendarRangeComponent;
}(CalendarComponent));

var CalendarModule = /** @class */ (function () {
    function CalendarModule() {
    }
CalendarModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CalendarModule });
CalendarModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CalendarModule_Factory(t) { return new (t || CalendarModule)(); }, imports: [[
            FormsModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CalendarModule, { declarations: function () { return [CalendarComponent, CalendarRangeComponent]; }, imports: function () { return [FormsModule]; }, exports: function () { return [CalendarComponent, CalendarRangeComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CalendarModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FormsModule,
                ],
                declarations: [
                    CalendarComponent,
                    CalendarRangeComponent,
                ],
                exports: [
                    CalendarComponent,
                    CalendarRangeComponent,
                ]
            }]
    }], function () { return []; }, null); })();
    return CalendarModule;
}());

var ABSTRACT_TOGGLE_COMPONENT_INPUTS = [
    'tabindex',
    'value',
    'uncheckable',
];
var ABSTRACT_TOGGLE_COMPONENT_HOST = {
    '[class.checked]': 'isChecked',
    '[class.disabled]': 'isDisabled',
    '[attr.aria-checked]': 'ariaChecked',
    '[attr.aria-disabled]': 'ariaDisabled',
    '[attr.tabindex]': 'attrTabindex',
};
function EMPTY() { }
var AbstractToggleComponent = /** @class */ (function () {
    function AbstractToggleComponent(cdRef) {
        this.cdRef = cdRef;
        this.isChecked = false;
        this.isDisabled = false;
        this.isBlocked = false;
        this.onChange = noop;
        this.onTouched = noop;
        this._value = true;
        this.initialized = false;
        this.modelValue = EMPTY;
        this.uncheckable = true;
    }
    Object.defineProperty(AbstractToggleComponent.prototype, "ariaChecked", {
        get: function () {
            return this.isChecked ? 'true' : 'false';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractToggleComponent.prototype, "ariaDisabled", {
        get: function () {
            return this.isDisabled ? 'true' : 'false';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractToggleComponent.prototype, "attrTabindex", {
        get: function () {
            return this.isDisabled || this.overrideTabindex ? '-1' : (this.tabindex || '0');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractToggleComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            if (!this.initialized) {
                this._value = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    AbstractToggleComponent.prototype.ngOnInit = function () {
        this.initialized = true;
        this.isChecked = this.modelValue === this._value;
    };
    AbstractToggleComponent.prototype.writeValue = function (modelValue) {
        this.modelValue = modelValue;
        if (this.initialized) {
            var isActive = modelValue === this._value;
            if (isActive !== this.isChecked) {
                this.isChecked = isActive;
                this.updateBlocked(this.isDisabled);
                this.cdRef.markForCheck();
            }
        }
    };
    AbstractToggleComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    AbstractToggleComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    AbstractToggleComponent.prototype.setDisabledState = function (isDisabled) {
        this.updateBlocked(isDisabled);
        this.isDisabled = isDisabled;
        this.cdRef.markForCheck();
    };
    AbstractToggleComponent.prototype.updateBlocked = function (isDisabled) {
        this.isBlocked = isDisabled || (!this.uncheckable && this.isChecked);
    };
    AbstractToggleComponent.prototype.setChecked = function (active) {
        this.isChecked = active;
        if (this._value === true) {
            this.onChange(active);
        }
        else {
            this.onChange(active ? this._value : null);
        }
        this.updateBlocked(this.isDisabled);
        this.onTouched();
    };
    AbstractToggleComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef }
    ]; };
    AbstractToggleComponent = __decorate([ __metadata("design:paramtypes", [ChangeDetectorRef])
    ], AbstractToggleComponent);
AbstractToggleComponent.ɵfac = function AbstractToggleComponent_Factory(t) { return new (t || AbstractToggleComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
AbstractToggleComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AbstractToggleComponent });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbstractToggleComponent, [{
        type: Directive
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, null); })();
    return AbstractToggleComponent;
}());

var TOGGLE_GROUP_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return ToggleGroupDirective; }),
    multi: true,
};
var ToggleGroupDirective = /** @class */ (function () {
    function ToggleGroupDirective() {
        this.onChange = noop;
        this.onTouched = noop;
        this.accessors = new Set();
        this.isDestroyed = false;
    }
    ToggleGroupDirective.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    ToggleGroupDirective.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    ToggleGroupDirective.prototype.setDisabledState = function (isDisabled) {
        this.accessors.forEach(function (accessor) {
            accessor.setDisabledState(isDisabled);
        });
    };
    ToggleGroupDirective.prototype.writeValue = function (value) {
        if (value !== this.value) {
            this.value = value;
            this.accessors.forEach(function (accessor) {
                accessor.writeValue(value);
            });
        }
    };
    ToggleGroupDirective.prototype.handleOnChange = function (origin, value) {
        this.value = value;
        this.onChange(value);
        this.accessors.forEach(function (accessor) {
            if (accessor !== origin) {
                accessor.writeValue(value);
            }
        });
    };
    ToggleGroupDirective.prototype.registerComponent = function (accessor) {
        var _this = this;
        if (!this.isDestroyed) {
            this.accessors.add(accessor);
            accessor.registerOnChange(function (value) {
                _this.handleOnChange(accessor, value);
            });
            accessor.registerOnTouched(function () {
                _this.onTouched();
            });
            accessor.writeValue(this.value);
        }
    };
    ToggleGroupDirective.prototype.unregisterComponent = function (accessor) {
        if (!this.isDestroyed) {
            this.accessors.delete(accessor);
        }
    };
    ToggleGroupDirective.prototype.ngOnDestroy = function () {
        this.accessors.clear();
        this.isDestroyed = true;
    };
ToggleGroupDirective.ɵfac = function ToggleGroupDirective_Factory(t) { return new (t || ToggleGroupDirective)(); };
ToggleGroupDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ToggleGroupDirective, selectors: [["", "cdsToggleGroup", ""]], features: [ɵngcc0.ɵɵProvidersFeature([TOGGLE_GROUP_CONTROL_VALUE_ACCESSOR])] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ToggleGroupDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsToggleGroup]',
                providers: [TOGGLE_GROUP_CONTROL_VALUE_ACCESSOR]
            }]
    }], function () { return []; }, null); })();
    return ToggleGroupDirective;
}());

var CHECKBOX_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return CheckboxComponent; }),
    multi: true,
};
var CheckboxComponent = /** @class */ (function (_super) {
    __extends(CheckboxComponent, _super);
    function CheckboxComponent(cdRef, toggleGroupDirective, platform, renderer, elementRef, zone, rippleService) {
        var _this = _super.call(this, cdRef) || this;
        _this.toggleGroupDirective = toggleGroupDirective;
        _this.platform = platform;
        _this.renderer = renderer;
        _this.elementRef = elementRef;
        _this.zone = zone;
        _this.rippleService = rippleService;
        _this.labelId = Unique.next('cds-checkbox__label-');
        _this._indeterminate = false;
        _this.indeterminateChange = new EventEmitter();
        renderer.addClass(elementRef.nativeElement, 'cds-checkbox');
        renderer.setAttribute(elementRef.nativeElement, 'role', 'checkbox');
        if (toggleGroupDirective) {
            toggleGroupDirective.registerComponent(_this);
        }
        return _this;
    }
    Object.defineProperty(CheckboxComponent.prototype, "ariaLabelledBy", {
        get: function () {
            return this.label ? this.labelId : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckboxComponent.prototype, "ariaChecked", {
        get: function () {
            return this._indeterminate ? 'mixed' : (this.isChecked ? 'true' : 'false');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckboxComponent.prototype, "indeterminate", {
        get: function () {
            return this._indeterminate;
        },
        set: function (indeterminate) {
            this._indeterminate = indeterminate;
        },
        enumerable: true,
        configurable: true
    });
    CheckboxComponent.prototype.ngAfterViewInit = function () {
        this.rippleService.createForToggle(this.elementRef.nativeElement);
    };
    CheckboxComponent.prototype.ngOnDestroy = function () {
        if (this.toggleGroupDirective) {
            this.toggleGroupDirective.unregisterComponent(this);
        }
    };
    CheckboxComponent.prototype.onClick = function (event) {
        event.preventDefault();
        if (this._indeterminate && !this.isDisabled) {
            this._indeterminate = false;
            this.indeterminateChange.emit(this._indeterminate);
        }
        if (this.isBlocked) {
            return;
        }
        this.setChecked(!this.isChecked);
    };
    CheckboxComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ToggleGroupDirective, decorators: [{ type: Host }, { type: Optional }] },
        { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
        { type: Renderer2 },
        { type: ElementRef },
        { type: NgZone },
        { type: RippleService }
    ]; };
    __decorate([
        HostBinding('attr.aria-labelledby'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], CheckboxComponent.prototype, "ariaLabelledBy", null);
    __decorate([
        HostBinding('attr.aria-checked'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], CheckboxComponent.prototype, "ariaChecked", null);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], CheckboxComponent.prototype, "label", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], CheckboxComponent.prototype, "indeterminateChange", void 0);
    __decorate([
        Input(),
        HostBinding('class.cds-checkbox--indeterminate'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], CheckboxComponent.prototype, "indeterminate", null);
    __decorate([
        HostListener('click', ['$event']),
        HostListener('keydown.enter', ['$event']),
        HostListener('keydown.space', ['$event']),
        HostListener('keydown.spacebar', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Event]),
        __metadata("design:returntype", void 0)
    ], CheckboxComponent.prototype, "onClick", null);
    CheckboxComponent = __decorate([ __param(1, Host()), __param(1, Optional()),
        __param(2, Inject(PLATFORM_ID)),
        __metadata("design:paramtypes", [ChangeDetectorRef,
            ToggleGroupDirective, Object, Renderer2,
            ElementRef,
            NgZone,
            RippleService])
    ], CheckboxComponent);
CheckboxComponent.ɵfac = function CheckboxComponent_Factory(t) { return new (t || CheckboxComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ToggleGroupDirective, 9), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(RippleService)); };
CheckboxComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CheckboxComponent, selectors: [["cds-checkbox"]], hostVars: 10, hostBindings: function CheckboxComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function CheckboxComponent_click_HostBindingHandler($event) { return ctx.onClick($event); })("keydown.enter", function CheckboxComponent_keydown_enter_HostBindingHandler($event) { return ctx.onClick($event); })("keydown.space", function CheckboxComponent_keydown_space_HostBindingHandler($event) { return ctx.onClick($event); })("keydown.spacebar", function CheckboxComponent_keydown_spacebar_HostBindingHandler($event) { return ctx.onClick($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-checked", ctx.ariaChecked)("aria-disabled", ctx.ariaDisabled)("tabindex", ctx.attrTabindex)("aria-labelledby", ctx.ariaLabelledBy);
        ɵngcc0.ɵɵclassProp("checked", ctx.isChecked)("disabled", ctx.isDisabled)("cds-checkbox--indeterminate", ctx.indeterminate);
    } }, inputs: { tabindex: "tabindex", value: "value", uncheckable: "uncheckable", indeterminate: "indeterminate", label: "label" }, outputs: { indeterminateChange: "indeterminateChange" }, features: [ɵngcc0.ɵɵProvidersFeature([CHECKBOX_CONTROL_VALUE_ACCESSOR]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 8, vars: 3, consts: [["tabindex", "-1", 1, "toggle-wrapper"], [1, "cds-zero-width-space"], ["aria-hidden", "true", 1, "checkbox", "cds-ripple", "cds-ripple--toggle-fade-delay"], [1, "checkbox__background"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 14 14", "stroke-linecap", "round", "focusable", "false", 1, "tick"], ["class", "checkmark__check", "fill", "none", "stroke-width", "1.5", "d", "M3.3 7.5 L5.6 10 L10.3 4.2", 4, "ngIf"], ["x1", "3.5", "x2", "10.5", "y1", "7", "y2", "7", 4, "ngIf"], [4, "ngIf"], ["fill", "none", "stroke-width", "1.5", "d", "M3.3 7.5 L5.6 10 L10.3 4.2", 1, "checkmark__check"], ["x1", "3.5", "x2", "10.5", "y1", "7", "y2", "7"]], template: function CheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "span", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵelementStart(3, "span", 3);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(4, "svg", 4);
        ɵngcc0.ɵɵtemplate(5, CheckboxComponent__svg_path_5_Template, 1, 0, "path", 5);
        ɵngcc0.ɵɵtemplate(6, CheckboxComponent__svg_line_6_Template, 1, 0, "line", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, CheckboxComponent_label_7_Template, 2, 2, "label", 7);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.indeterminate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.indeterminate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CheckboxComponent, [{
        type: Component,
        args: [{
                selector: 'cds-checkbox',
                template: "<div class=\"toggle-wrapper\" tabindex=\"-1\">\n\t<span class=\"cds-zero-width-space\"></span>\n\t<span class=\"checkbox cds-ripple cds-ripple--toggle-fade-delay\" aria-hidden=\"true\">\n\t\t<span class=\"checkbox__background\">\n\t\t\t<svg class=\"tick\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" stroke-linecap=\"round\" focusable=\"false\">\n\t\t\t\t<path *ngIf=\"!indeterminate\" class=\"checkmark__check\" fill=\"none\" stroke-width=\"1.5\" d=\"M3.3 7.5 L5.6 10 L10.3 4.2\"></path>\n\t\t\t\t<line *ngIf=\"indeterminate\" x1=\"3.5\" x2=\"10.5\" y1=\"7\" y2=\"7\"></line>\n\t\t\t</svg>\n\t\t</span>\n\t</span>\n\t<label *ngIf=\"label\" [attr.id]=\"labelId\">{{label}}</label>\n</div>\n",
                providers: [CHECKBOX_CONTROL_VALUE_ACCESSOR],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                inputs: ABSTRACT_TOGGLE_COMPONENT_INPUTS,
                host: ABSTRACT_TOGGLE_COMPONENT_HOST
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ToggleGroupDirective, decorators: [{
                type: Host
            }, {
                type: Optional
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }, { type: RippleService }]; }, { ariaLabelledBy: [{
            type: HostBinding,
            args: ['attr.aria-labelledby']
        }], ariaChecked: [{
            type: HostBinding,
            args: ['attr.aria-checked']
        }], indeterminate: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.cds-checkbox--indeterminate']
        }], onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }, {
            type: HostListener,
            args: ['keydown.enter', ['$event']]
        }, {
            type: HostListener,
            args: ['keydown.space', ['$event']]
        }, {
            type: HostListener,
            args: ['keydown.spacebar', ['$event']]
        }], label: [{
            type: Input
        }], indeterminateChange: [{
            type: Output
        }] }); })();
    return CheckboxComponent;
}(AbstractToggleComponent));

var ToggleLinkDirective = /** @class */ (function () {
    function ToggleLinkDirective(router, accessors, link) {
        this.router = router;
        this.link = link;
        if (accessors && accessors.length !== 0) {
            this.accessor = accessors[0];
        }
    }
    ToggleLinkDirective.prototype.ngOnInit = function () {
        var _this = this;
        if (this.accessor) {
            this.update(this.accessor);
            this.subscription = this.router.events.subscribe(function (event) {
                if (event instanceof NavigationEnd) {
                    _this.update(_this.accessor);
                }
            });
        }
    };
    ToggleLinkDirective.prototype.update = function (accessor) {
        var _a = (this.options || {}).exact, exact = _a === void 0 ? false : _a;
        var isActive = this.router.isActive(this.link.urlTree, exact);
        accessor.writeValue(this.value && typeof this.value !== 'boolean'
            ? (isActive ? this.value : null)
            : isActive);
    };
    ToggleLinkDirective.prototype.ngOnDestroy = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    };
    ToggleLinkDirective.ctorParameters = function () { return [
        { type: Router },
        { type: Array, decorators: [{ type: Inject, args: [NG_VALUE_ACCESSOR,] }, { type: Optional }] },
        { type: RouterLink, decorators: [{ type: Self }] }
    ]; };
    __decorate([
        Input('cdsToggleLink'),
        __metadata("design:type", Object)
    ], ToggleLinkDirective.prototype, "options", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ToggleLinkDirective.prototype, "value", void 0);
    ToggleLinkDirective = __decorate([ __param(1, Inject(NG_VALUE_ACCESSOR)), __param(1, Optional()),
        __param(2, Self()),
        __metadata("design:paramtypes", [Router, Array, RouterLink])
    ], ToggleLinkDirective);
ToggleLinkDirective.ɵfac = function ToggleLinkDirective_Factory(t) { return new (t || ToggleLinkDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router), ɵngcc0.ɵɵdirectiveInject(NG_VALUE_ACCESSOR, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.RouterLink, 2)); };
ToggleLinkDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ToggleLinkDirective, selectors: [["", "cdsToggleLink", ""]], inputs: { options: ["cdsToggleLink", "options"], value: "value" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ToggleLinkDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsToggleLink]'
            }]
    }], function () { return [{ type: ɵngcc2.Router }, { type: Array, decorators: [{
                type: Inject,
                args: [NG_VALUE_ACCESSOR]
            }, {
                type: Optional
            }] }, { type: ɵngcc2.RouterLink, decorators: [{
                type: Self
            }] }]; }, { options: [{
            type: Input,
            args: ['cdsToggleLink']
        }], value: [{
            type: Input
        }] }); })();
    return ToggleLinkDirective;
}());

var ToggleModule = /** @class */ (function () {
    function ToggleModule() {
    }
ToggleModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ToggleModule });
ToggleModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ToggleModule_Factory(t) { return new (t || ToggleModule)(); }, imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ToggleModule, { declarations: [ToggleGroupDirective, ToggleLinkDirective], exports: [ToggleGroupDirective, ToggleLinkDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ToggleModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [
                    ToggleGroupDirective,
                    ToggleLinkDirective,
                ],
                exports: [
                    ToggleGroupDirective,
                    ToggleLinkDirective,
                ]
            }]
    }], function () { return []; }, null); })();
    return ToggleModule;
}());

var CheckboxModule = /** @class */ (function () {
    function CheckboxModule() {
    }
CheckboxModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CheckboxModule });
CheckboxModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function CheckboxModule_Factory(t) { return new (t || CheckboxModule)(); }, imports: [[
            CommonModule,
            RippleModule,
            ToggleModule,
        ], ToggleModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CheckboxModule, { declarations: function () { return [CheckboxComponent]; }, imports: function () { return [CommonModule, RippleModule, ToggleModule]; }, exports: function () { return [CheckboxComponent, ToggleModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CheckboxModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    RippleModule,
                    ToggleModule,
                ],
                declarations: [
                    CheckboxComponent,
                ],
                exports: [
                    CheckboxComponent,
                    // modules
                    ToggleModule,
                ]
            }]
    }], function () { return []; }, null); })();
    return CheckboxModule;
}());

var CHIP_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return ChipComponent; }),
    multi: true,
};
var ChipComponent = /** @class */ (function (_super) {
    __extends(ChipComponent, _super);
    function ChipComponent(cdRef, toggleGroupDirective, renderer, elementRef) {
        var _this = _super.call(this, cdRef) || this;
        _this.toggleGroupDirective = toggleGroupDirective;
        _this.renderer = renderer;
        _this.elementRef = elementRef;
        _this.removable = false;
        _this.readonly = false;
        _this.remove = new EventEmitter();
        _this.appearance = 'outline';
        renderer.addClass(elementRef.nativeElement, 'cds-chip');
        renderer.setAttribute(elementRef.nativeElement, 'role', 'switch');
        if (toggleGroupDirective) {
            toggleGroupDirective.registerComponent(_this);
        }
        return _this;
    }
    ChipComponent.prototype.onClick = function (event) {
        event.preventDefault();
        if (this.isBlocked || this.readonly) {
            return;
        }
        this.setChecked(!this.isChecked);
    };
    ChipComponent.prototype.onRemove = function (event) {
        this.onClose(event);
    };
    ChipComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.removable = this.removable == null ? this.remove.observers.length !== 0 : this.removable;
    };
    ChipComponent.prototype.ngOnDestroy = function () {
        if (this.toggleGroupDirective) {
            this.toggleGroupDirective.unregisterComponent(this);
        }
    };
    ChipComponent.prototype.onClose = function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.removable) {
            this.remove.emit(null);
        }
    };
    ChipComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ToggleGroupDirective, decorators: [{ type: Host }, { type: Optional }] },
        { type: Renderer2 },
        { type: ElementRef }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], ChipComponent.prototype, "removable", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], ChipComponent.prototype, "readonly", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], ChipComponent.prototype, "remove", void 0);
    __decorate([
        Input(),
        HostBinding('attr.cds-chip-appearance'),
        __metadata("design:type", String)
    ], ChipComponent.prototype, "appearance", void 0);
    __decorate([
        HostListener('click', ['$event']),
        HostListener('keydown.enter', ['$event']),
        HostListener('keydown.space', ['$event']),
        HostListener('keydown.spacebar', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Event]),
        __metadata("design:returntype", void 0)
    ], ChipComponent.prototype, "onClick", null);
    __decorate([
        HostListener('keydown.delete', ['$event']),
        HostListener('keydown.del', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Event]),
        __metadata("design:returntype", void 0)
    ], ChipComponent.prototype, "onRemove", null);
    ChipComponent = __decorate([ __param(1, Host()), __param(1, Optional()),
        __metadata("design:paramtypes", [ChangeDetectorRef,
            ToggleGroupDirective,
            Renderer2,
            ElementRef])
    ], ChipComponent);
ChipComponent.ɵfac = function ChipComponent_Factory(t) { return new (t || ChipComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ToggleGroupDirective, 9), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ChipComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ChipComponent, selectors: [["cds-chip"]], hostVars: 8, hostBindings: function ChipComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function ChipComponent_click_HostBindingHandler($event) { return ctx.onClick($event); })("keydown.enter", function ChipComponent_keydown_enter_HostBindingHandler($event) { return ctx.onClick($event); })("keydown.space", function ChipComponent_keydown_space_HostBindingHandler($event) { return ctx.onClick($event); })("keydown.spacebar", function ChipComponent_keydown_spacebar_HostBindingHandler($event) { return ctx.onClick($event); })("keydown.delete", function ChipComponent_keydown_delete_HostBindingHandler($event) { return ctx.onRemove($event); })("keydown.del", function ChipComponent_keydown_del_HostBindingHandler($event) { return ctx.onRemove($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-checked", ctx.ariaChecked)("aria-disabled", ctx.ariaDisabled)("tabindex", ctx.attrTabindex)("cds-chip-appearance", ctx.appearance);
        ɵngcc0.ɵɵclassProp("checked", ctx.isChecked)("disabled", ctx.isDisabled);
    } }, inputs: { tabindex: "tabindex", value: "value", uncheckable: "uncheckable", removable: "removable", readonly: "readonly", appearance: "appearance" }, outputs: { remove: "remove" }, features: [ɵngcc0.ɵɵProvidersFeature([CHIP_CONTROL_VALUE_ACCESSOR]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c2, decls: 3, vars: 1, consts: [["aria-hidden", "true", "class", "cds-icon-close cds-chip__remove", 3, "click", 4, "ngIf"], ["aria-hidden", "true", 1, "cds-icon-close", "cds-chip__remove", 3, "click"]], template: function ChipComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "span");
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, ChipComponent_a_2_Template, 1, 0, "a", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.removable);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ChipComponent, [{
        type: Component,
        args: [{
                selector: 'cds-chip',
                template: "<span><ng-content></ng-content></span>\n<a *ngIf=\"removable\" aria-hidden=\"true\" class=\"cds-icon-close cds-chip__remove\" (click)=\"onClose($event)\"></a>\n",
                providers: [CHIP_CONTROL_VALUE_ACCESSOR],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                inputs: ABSTRACT_TOGGLE_COMPONENT_INPUTS,
                host: ABSTRACT_TOGGLE_COMPONENT_HOST
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ToggleGroupDirective, decorators: [{
                type: Host
            }, {
                type: Optional
            }] }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }, {
            type: HostListener,
            args: ['keydown.enter', ['$event']]
        }, {
            type: HostListener,
            args: ['keydown.space', ['$event']]
        }, {
            type: HostListener,
            args: ['keydown.spacebar', ['$event']]
        }], onRemove: [{
            type: HostListener,
            args: ['keydown.delete', ['$event']]
        }, {
            type: HostListener,
            args: ['keydown.del', ['$event']]
        }], removable: [{
            type: Input
        }], readonly: [{
            type: Input
        }], remove: [{
            type: Output
        }], appearance: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.cds-chip-appearance']
        }] }); })();
    return ChipComponent;
}(AbstractToggleComponent));

var ChipRippleDirective = /** @class */ (function (_super) {
    __extends(ChipRippleDirective, _super);
    function ChipRippleDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
ChipRippleDirective.ɵfac = function ChipRippleDirective_Factory(t) { return ɵChipRippleDirective_BaseFactory(t || ChipRippleDirective); };
ChipRippleDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ChipRippleDirective, selectors: [["cds-chip", 3, "cdsRippleDisable", ""]], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
var ɵChipRippleDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(ChipRippleDirective);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ChipRippleDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line: directive-selector
                selector: 'cds-chip:not([cdsRippleDisable])'
            }]
    }], null, null); })();
    return ChipRippleDirective;
}(RippleDirective));

var ChipModule = /** @class */ (function () {
    function ChipModule() {
    }
ChipModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ChipModule });
ChipModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ChipModule_Factory(t) { return new (t || ChipModule)(); }, imports: [[
            CommonModule,
            RippleModule,
            ToggleModule,
        ], ToggleModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ChipModule, { declarations: function () { return [ChipComponent, ChipRippleDirective]; }, imports: function () { return [CommonModule, RippleModule, ToggleModule]; }, exports: function () { return [ChipComponent, ChipRippleDirective, ToggleModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ChipModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    RippleModule,
                    ToggleModule,
                ],
                declarations: [
                    ChipComponent,
                    ChipRippleDirective,
                ],
                exports: [
                    ChipComponent,
                    ChipRippleDirective,
                    // modules
                    ToggleModule,
                ]
            }]
    }], function () { return []; }, null); })();
    return ChipModule;
}());

function matches(element, selector) {
    var fn = element.matches || element['msMatchesSelector'] || element['webkitMatchesSelector'];
    return fn.call(element, selector);
}

function createCustomEvent(typeArg, eventInitDict) {
    try {
        return new CustomEvent(typeArg, eventInitDict);
    }
    catch (e) {
        var event_1 = document.createEvent('CustomEvent');
        event_1.initCustomEvent(typeArg, eventInitDict.bubbles, eventInitDict.cancelable, eventInitDict.detail);
        return event_1;
    }
}

var CDS_INPUT_MODEL_TRANSFORMER = new InjectionToken('CDS_INPUT_MODEL_TRANSFORMER');

var INPUT_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return InputComponent; }),
    multi: true,
};
var InputComponent = /** @class */ (function () {
    function InputComponent(elementRef, renderer, cdRef, transformer) {
        var _this = this;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.cdRef = cdRef;
        this.transformer = transformer;
        this.appearance = 'outline';
        this.preventHover = false;
        this.hasAutofillAnimation = false;
        this.isFocused = false;
        this.isSearchIconFocused = false;
        this.isNotEmpty = false;
        this.disabled = false;
        this.type = 'text';
        this.placeholder = '';
        this.autofocus = false;
        this.resettable = false;
        this.readonly = false;
        this.selected = false;
        this.searchButton = false;
        this.autocomplete = 'off';
        this.enter = new EventEmitter();
        this.innerValue = '';
        this.onTouchedCallback = noop;
        this.onChangeCallback = noop;
        this.labelId = Unique.next('cds-input__label-');
        renderer.addClass(elementRef.nativeElement, 'cds-control');
        renderer.addClass(elementRef.nativeElement, 'cds-control--transparent-value');
        renderer.addClass(elementRef.nativeElement, 'cds-input');
        renderer.listen(elementRef.nativeElement, 'click', function () {
            if (_this.inputElement) {
                _this.inputElement.nativeElement.focus();
            }
        });
    }
    Object.defineProperty(InputComponent.prototype, "controlFocus", {
        get: function () {
            return this.isSearchIconFocused || this.isFocused || this.selected;
        },
        enumerable: true,
        configurable: true
    });
    InputComponent.prototype.submitSearch = function (event) {
        event.stopPropagation();
        this.inputElement.nativeElement.dispatchEvent(createCustomEvent('search', {
            bubbles: true,
            cancelable: false,
        }));
    };
    Object.defineProperty(InputComponent.prototype, "controlNotEmpty", {
        get: function () {
            if (this.inputElement) {
                var element = this.inputElement.nativeElement;
                if (this.type === 'number') {
                    return this.isNotEmpty || !element.validity.valid;
                }
                else if (this.isAutofilled(element)) {
                    return true;
                }
            }
            return this.isNotEmpty;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputComponent.prototype, "controlActiveLabel", {
        get: function () {
            return this.isFocused || this.selected || this.controlNotEmpty || !!this.chip;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputComponent.prototype, "required", {
        set: function (value) {
            this.ariaRequired = value != null && value !== false && "" + value !== 'false';
        },
        enumerable: true,
        configurable: true
    });
    InputComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.enter.observers.length !== 0) {
            this.renderer.listen(this.inputElement.nativeElement, 'keyup.enter', function (event) { return _this.enter.emit(event); });
        }
        if (this.autofocus && this.inputElement && !this.isFocused) {
            setTimeout(function () {
                _this.inputElement.nativeElement.focus();
            });
        }
    };
    InputComponent.prototype.viewToModel = function (value) {
        return this.transformer ? this.transformer.parseViewValue(value) : value;
    };
    InputComponent.prototype.modelToView = function (value) {
        return this.transformer ? this.transformer.formatModelValue(value) : this.tryParseToString(value);
    };
    InputComponent.prototype.tryParseToString = function (value) {
        if (value == null) {
            return null;
        }
        try {
            return value.toString();
        }
        catch (e) {
            return null;
        }
    };
    InputComponent.prototype.invalidModel = function (value) {
        return value;
    };
    InputComponent.prototype.onBlur = function (event) {
        this.onTouchedCallback();
        this.isFocused = false;
        this.elementRef.nativeElement.dispatchEvent(createCustomEvent('blur', {
            bubbles: false,
            detail: event,
        }));
    };
    InputComponent.prototype.onFocus = function (event) {
        this.isFocused = true;
        this.elementRef.nativeElement.dispatchEvent(createCustomEvent('focus', {
            bubbles: false,
            detail: event,
        }));
    };
    InputComponent.prototype.onAnimationStart = function () {
        this.hasAutofillAnimation = true;
    };
    InputComponent.prototype.isAutofilled = function (element) {
        if (this.hasAutofillAnimation) {
            /* Should be true in Chrome, but using try..catch just in case */
            try {
                return element.matches(':-webkit-autofill');
            }
            catch (e) { }
        }
        return false;
    };
    Object.defineProperty(InputComponent.prototype, "value", {
        get: function () {
            return this.innerValue;
        },
        set: function (innerValue) {
            this.isNotEmpty = !!innerValue;
            if (innerValue !== this.innerValue) {
                this.innerValue = innerValue;
            }
            var modelValue = this.viewToModel(innerValue);
            if (modelValue !== this.modelValue) {
                this.modelValue = modelValue;
                this.onChangeCallback(this.invalidModel(modelValue));
            }
        },
        enumerable: true,
        configurable: true
    });
    InputComponent.prototype.writeValue = function (modelValue) {
        if (modelValue !== this.modelValue) {
            this.modelValue = modelValue;
        }
        var innerValue = this.modelToView(modelValue);
        this.isNotEmpty = !!innerValue;
        if (innerValue !== this.innerValue) {
            this.innerValue = innerValue;
        }
        this.cdRef.markForCheck();
    };
    InputComponent.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    InputComponent.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    InputComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
        this.cdRef.markForCheck();
    };
    InputComponent.prototype.clear = function () {
        this.value = '';
    };
    InputComponent.prototype.focus = function () {
        this.inputElement.nativeElement.focus();
    };
    InputComponent.prototype.blur = function () {
        this.inputElement.nativeElement.blur();
    };
    InputComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ChangeDetectorRef },
        { type: undefined, decorators: [{ type: Host }, { type: Optional }, { type: Inject, args: [CDS_INPUT_MODEL_TRANSFORMER,] }] }
    ]; };
    __decorate([
        Input(),
        HostBinding('attr.cds-control-appearance'),
        __metadata("design:type", String)
    ], InputComponent.prototype, "appearance", void 0);
    __decorate([
        ContentChild(ChipComponent),
        __metadata("design:type", ChipComponent)
    ], InputComponent.prototype, "chip", void 0);
    __decorate([
        HostBinding('class.cds-control--focus'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], InputComponent.prototype, "controlFocus", null);
    __decorate([
        HostBinding('class.cds-control--prevent-hover'),
        __metadata("design:type", Boolean)
    ], InputComponent.prototype, "preventHover", void 0);
    __decorate([
        HostBinding('class.cds-control--not-empty'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], InputComponent.prototype, "controlNotEmpty", null);
    __decorate([
        HostBinding('class.cds-control--active-label'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], InputComponent.prototype, "controlActiveLabel", null);
    __decorate([
        HostBinding('class.disabled'),
        __metadata("design:type", Boolean)
    ], InputComponent.prototype, "disabled", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], InputComponent.prototype, "name", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], InputComponent.prototype, "type", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], InputComponent.prototype, "placeholder", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], InputComponent.prototype, "maxlength", void 0);
    __decorate([
        Input('cdsLength'),
        __metadata("design:type", Number)
    ], InputComponent.prototype, "length", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], InputComponent.prototype, "autofocus", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], InputComponent.prototype, "resettable", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], InputComponent.prototype, "readonly", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], InputComponent.prototype, "selected", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], InputComponent.prototype, "min", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], InputComponent.prototype, "max", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], InputComponent.prototype, "step", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], InputComponent.prototype, "searchButton", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], InputComponent.prototype, "autocomplete", void 0);
    __decorate([
        ViewChild('input', { read: ElementRef, static: true }),
        __metadata("design:type", ElementRef)
    ], InputComponent.prototype, "inputElement", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], InputComponent.prototype, "enter", void 0);
    __decorate([
        Input('label'),
        __metadata("design:type", String)
    ], InputComponent.prototype, "labelValue", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], InputComponent.prototype, "required", null);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], InputComponent.prototype, "ariaLabelledBy", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], InputComponent.prototype, "ariaDescribedBy", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], InputComponent.prototype, "ariaLabel", void 0);
    InputComponent = __decorate([ __param(3, Host()), __param(3, Optional()), __param(3, Inject(CDS_INPUT_MODEL_TRANSFORMER)),
        __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            ChangeDetectorRef, Object])
    ], InputComponent);
InputComponent.ɵfac = function InputComponent_Factory(t) { return new (t || InputComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(CDS_INPUT_MODEL_TRANSFORMER, 9)); };
InputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: InputComponent, selectors: [["cds-input"]], contentQueries: function InputComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, ChipComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.chip = _t.first);
    } }, viewQuery: function InputComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c5, true, ElementRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
    } }, hostVars: 11, hostBindings: function InputComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("cds-control-appearance", ctx.appearance);
        ɵngcc0.ɵɵclassProp("cds-control--prevent-hover", ctx.preventHover)("disabled", ctx.disabled)("cds-control--focus", ctx.controlFocus)("cds-control--not-empty", ctx.controlNotEmpty)("cds-control--active-label", ctx.controlActiveLabel);
    } }, inputs: { appearance: "appearance", type: "type", placeholder: "placeholder", autofocus: "autofocus", resettable: "resettable", readonly: "readonly", selected: "selected", searchButton: "searchButton", autocomplete: "autocomplete", required: "required", name: "name", maxlength: "maxlength", length: ["cdsLength", "length"], min: "min", max: "max", step: "step", labelValue: ["label", "labelValue"], ariaLabelledBy: "ariaLabelledBy", ariaDescribedBy: "ariaDescribedBy", ariaLabel: "ariaLabel" }, outputs: { enter: "enter" }, features: [ɵngcc0.ɵɵProvidersFeature([INPUT_CONTROL_VALUE_ACCESSOR])], ngContentSelectors: _c7, decls: 10, vars: 19, consts: [[1, "cds-control__container", "cds-zero-width-space"], [1, "cds-control__content"], ["class", "cds-control__label", 4, "ngIf"], ["cdsAriaControlSkipSelf", "", 1, "cds-control__value", "cds-control__value--input", "cds-control__value--single-line", 3, "maxlength", "autofocus", "readOnly", "ngModel", "disabled", "ngModelChange", "blur", "focus", "animationstart"], ["input", ""], ["class", "cds-input__reset cds-icon-close", 3, "cds-input__reset--hidden", "cds-input__reset--invisible", "click", 4, "ngIf"], ["cdsRipple", "", "class", "cds-input__search-button", "tabindex", "-1", "type", "button", 3, "click", "mouseenter", "mouseleave", "focus", "blur", 4, "ngIf"], [1, "cds-control__label"], [1, "cds-control__label-text"], [1, "cds-input__reset", "cds-icon-close", 3, "click"], ["cdsRipple", "", "tabindex", "-1", "type", "button", 1, "cds-input__search-button", 3, "click", "mouseenter", "mouseleave", "focus", "blur"], [1, "cds-icon-search"]], template: function InputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c6);
        ɵngcc0.ɵɵelement(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, InputComponent_div_3_Template, 3, 2, "div", 2);
        ɵngcc0.ɵɵprojection(4, 1);
        ɵngcc0.ɵɵelementStart(5, "input", 3, 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function InputComponent_Template_input_ngModelChange_5_listener($event) { return ctx.value = $event; })("blur", function InputComponent_Template_input_blur_5_listener($event) { return ctx.onBlur($event); })("focus", function InputComponent_Template_input_focus_5_listener($event) { return ctx.onFocus($event); })("animationstart", function InputComponent_Template_input_animationstart_5_listener() { return ctx.onAnimationStart(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, InputComponent_a_7_Template, 1, 4, "a", 5);
        ɵngcc0.ɵɵprojection(8, 2);
        ɵngcc0.ɵɵtemplate(9, InputComponent_button_9_Template, 2, 2, "button", 6);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.labelValue);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("maxlength", ctx.length != null ? ctx.length : ctx.maxlength);
        ɵngcc0.ɵɵproperty("autofocus", ctx.autofocus)("readOnly", ctx.readonly)("ngModel", ctx.value)("disabled", ctx.disabled);
        ɵngcc0.ɵɵattribute("name", ctx.name)("type", ctx.type)("placeholder", ctx.placeholder)("min", ctx.min)("max", ctx.max)("step", ctx.step)("autocomplete", ctx.autocomplete)("aria-describedby", ctx.ariaDescribedBy)("aria-required", ctx.ariaRequired)("aria-labelledby", ctx.ariaLabelledBy || (ctx.labelValue ? ctx.labelId : null))("aria-label", ctx.ariaLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.resettable);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.searchButton);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc3.DefaultValueAccessor, AriaControlSkipSelfDirective, ɵngcc3.MaxLengthValidator, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, RippleDirective]; }, encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(InputComponent, [{
        type: Component,
        args: [{
                selector: 'cds-input',
                template: "<div class=\"cds-control__container cds-zero-width-space\"></div>\n<ng-content select=\"i.cds-icon--placement-before,a.cds-icon--placement-before\"></ng-content>\n<div class=\"cds-control__content\">\n\t<div class=\"cds-control__label\" *ngIf=\"labelValue\">\n\t\t<div [attr.id]=\"!ariaLabelledBy ? labelId : null\" class=\"cds-control__label-text\">{{labelValue}}</div>\n\t</div>\n\t<ng-content select=\"cds-chip\"></ng-content>\n\t<input class=\"cds-control__value cds-control__value--input cds-control__value--single-line\"\n\t       [attr.name]=\"name\" [attr.type]=\"type\" [attr.placeholder]=\"placeholder\"\n\t       [attr.min]=\"min\" [attr.max]=\"max\" [attr.step]=\"step\" maxlength=\"{{length != null ? length : maxlength}}\"\n\t       [autofocus]=\"autofocus\" [readOnly]=\"readonly\" [attr.autocomplete]=\"autocomplete\"\n\t       [(ngModel)]=\"value\" [disabled]=\"disabled\" (blur)=\"onBlur($event)\" (focus)=\"onFocus($event)\"\n\t       cdsAriaControlSkipSelf [attr.aria-describedby]=\"ariaDescribedBy\" [attr.aria-required]=\"ariaRequired\"\n\t       [attr.aria-labelledby]=\"ariaLabelledBy || (labelValue ? labelId : null)\" [attr.aria-label]=\"ariaLabel\"\n\t       #input (animationstart)=\"onAnimationStart()\"/>\n</div>\n<a *ngIf=\"resettable\"\n   class=\"cds-input__reset cds-icon-close\"\n   [class.cds-input__reset--hidden]=\"!value && !chip\"\n   [class.cds-input__reset--invisible]=\"!value && chip\"\n   (click)=\"clear()\"></a>\n<ng-content select=\"i:not(.cds-icon--placement-before),a:not(.cds-icon--placement-before)\"></ng-content>\n<button cdsRipple *ngIf=\"searchButton\"\n\tclass=\"cds-input__search-button\"\n\t(click)=\"submitSearch($event)\"\n\t(mouseenter)=\"preventHover = true\"\n\t(mouseleave)=\"preventHover = false\"\n\t(focus)=\"isSearchIconFocused = true\"\n\t(blur)=\"isSearchIconFocused = false\"\n\ttabindex=\"-1\"\n\ttype=\"button\"\n\t[attr.aria-hidden]=\"searchButton === true || null\"\n\t[attr.aria-label]=\"searchButton !== true ? searchButton : null\">\n\t<i class=\"cds-icon-search\"></i>\n</button>\n",
                providers: [INPUT_CONTROL_VALUE_ACCESSOR],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: undefined, decorators: [{
                type: Host
            }, {
                type: Optional
            }, {
                type: Inject,
                args: [CDS_INPUT_MODEL_TRANSFORMER]
            }] }]; }, { appearance: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.cds-control-appearance']
        }], preventHover: [{
            type: HostBinding,
            args: ['class.cds-control--prevent-hover']
        }], disabled: [{
            type: HostBinding,
            args: ['class.disabled']
        }], type: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], autofocus: [{
            type: Input
        }], resettable: [{
            type: Input
        }], readonly: [{
            type: Input
        }], selected: [{
            type: Input
        }], searchButton: [{
            type: Input
        }], autocomplete: [{
            type: Input
        }], enter: [{
            type: Output
        }], controlFocus: [{
            type: HostBinding,
            args: ['class.cds-control--focus']
        }], controlNotEmpty: [{
            type: HostBinding,
            args: ['class.cds-control--not-empty']
        }], controlActiveLabel: [{
            type: HostBinding,
            args: ['class.cds-control--active-label']
        }], required: [{
            type: Input
        }], chip: [{
            type: ContentChild,
            args: [ChipComponent]
        }], name: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], length: [{
            type: Input,
            args: ['cdsLength']
        }], min: [{
            type: Input
        }], max: [{
            type: Input
        }], step: [{
            type: Input
        }], inputElement: [{
            type: ViewChild,
            args: ['input', { read: ElementRef, static: true }]
        }], labelValue: [{
            type: Input,
            args: ['label']
        }], ariaLabelledBy: [{
            type: Input
        }], ariaDescribedBy: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }] }); })();
    return InputComponent;
}());

var AbstractCombo = /** @class */ (function () {
    function AbstractCombo(tabindex, cdRef, renderer, elementRef) {
        this.tabindex = tabindex;
        this.cdRef = cdRef;
        this.disableKeydown = [
            38,
            40,
        ];
        this.changesSubject$ = new Subject();
        this.changes$ = this.changesSubject$.asObservable().pipe(map(function (model) {
            return {
                totalCount: model.totalCount,
                selectedCount: model.selectedCount,
                selectedLabel: model.selectedLabel,
            };
        }), distinctUntilChanged(function (prev, curr) {
            if (prev !== curr) {
                return false;
            }
            return prev.totalCount === curr.totalCount && prev.selectedCount === curr.selectedCount && prev.selectedLabel == curr.selectedLabel;
        }));
        this.appearance = 'outline';
        this.isDisabled = false;
        this.chips = false;
        this.search$ = new Subject();
        this.searchChange = new EventEmitter();
        this.searchType = 'inside';
        this.searchDebounceTime = 500;
        this.hostMouseDownSearch = false;
        this.focusInput = false;
        this.onTouchedCallback = noop;
        this.onChangeCallback = noop;
        this.trackByFunction = identity;
        this.isFocus = false;
        if (!this.tabindex) {
            this.tabindex = '0';
        }
    }
    Object.defineProperty(AbstractCombo.prototype, "attrTabindex", {
        get: function () {
            return this.isDisabled ? null : this.tabindex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractCombo.prototype, "withSearchInside", {
        get: function () {
            return this.search != null && this.searchType === 'inside';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractCombo.prototype, "withSearchInline", {
        get: function () {
            return this.search != null && this.searchType === 'inline';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractCombo.prototype, "isOpen", {
        get: function () {
            return this._isOpen;
        },
        set: function (value) {
            if (!value && this._isOpen) {
                this.onTouchedCallback();
                if (this.elementRef && this.elementRef.nativeElement && this.hasFocus(this.elementRef.nativeElement)) {
                    this.elementRef.nativeElement.querySelector('.cds-combo__caret').focus();
                }
            }
            this._isOpen = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractCombo.prototype, "labelValue", {
        get: function () {
            return this._labelValue || this.fallbackLabel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractCombo.prototype, "placeholder", {
        get: function () {
            return this._placeholder || this.fallbackPlaceholder;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractCombo.prototype, "trackBy", {
        set: function (value) {
            if (typeof value === 'string') {
                this.trackByFunction = field(value);
            }
            else {
                this.trackByFunction = !isComboTrackByFunction(value) ?
                    function (obj) { return value(-1, obj); } :
                    value;
            }
        },
        enumerable: true,
        configurable: true
    });
    AbstractCombo.prototype.ngOnInit = function () {
        this.search$.pipe(debounceTime(this.searchDebounceTime)).subscribe(this.searchChange);
        if (isDevMode() && this.appearance === 'underline') {
            console.warn('Use of \'underline\' appearance is deprecated. Please use \'inline\' instead');
        }
    };
    AbstractCombo.prototype.ngAfterViewChecked = function () {
        var _this = this;
        if (this.focusInput) {
            this.focusInput = false;
            // requestAnimationFrame fixes scrolling issues in Chrome and Safari
            requestAnimationFrame(function () {
                if (_this.withSearchInline && _this.searchInline) {
                    _this.searchInline.nativeElement.focus();
                }
                else if (_this.withSearchInside && _this.searchInside) {
                    _this.searchInside.focus();
                    _this.cdRef.detectChanges();
                }
            });
        }
    };
    AbstractCombo.prototype.ngOnDestroy = function () {
        this.changesSubject$.complete();
        this.search$.complete();
    };
    AbstractCombo.prototype.toggle = function (event) {
        if (!this.isDisabled && event) {
            var target = event.target;
            if ((!this.withSearchInside && !this.withSearchInline && !this.confirmButtons)
                || (!matches(target, 'cds-dropdown *')
                    && !(this.withSearchInline && this.searchInline && document.activeElement === this.searchInline.nativeElement))) {
                event.stopPropagation();
                event.preventDefault();
                if (event instanceof KeyboardEvent && (event.key === 'ArrowDown' || event.key === 'Down' || event.key === 'ArrowUp' || event.key === 'Up')) {
                    if (!this.isOpen) {
                        this.isOpen = true;
                    }
                }
                else {
                    this.isOpen = !this.isOpen;
                }
                this.onOpenChange(this.isOpen);
            }
        }
    };
    AbstractCombo.prototype.onMouseDown = function (event) {
        this.hostMouseDownSearch = event.type === 'mousedown';
    };
    AbstractCombo.prototype.onSearchFieldBlur = function (relatedTarget) {
        if (this.elementRef && relatedTarget === this.elementRef.nativeElement && !this.hostMouseDownSearch) {
            this.close();
        }
    };
    AbstractCombo.prototype.close = function () {
        this.isOpen = false;
        this.onOpenChange(false);
    };
    AbstractCombo.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    AbstractCombo.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    AbstractCombo.prototype.setDisabledState = function (isDisabled) {
        this.isDisabled = isDisabled;
        this.cdRef.markForCheck();
    };
    AbstractCombo.prototype.setFallbackValues = function (label, placeholder) {
        this.fallbackLabel = label;
        this.fallbackPlaceholder = placeholder;
        this.cdRef.markForCheck();
    };
    AbstractCombo.prototype.onOpenChange = function (isOpen) {
        this.focusInput = isOpen;
        this.isOpen = isOpen;
    };
    AbstractCombo.prototype.onButtonFocus = function (event, isFocus) {
        this.isFocus = isFocus;
    };
    AbstractCombo.prototype.onDropdownClick = function (event) { };
    AbstractCombo.prototype.onDropdownKey = function (event) { };
    AbstractCombo.prototype.isEqual = function (valueA, valueB) {
        return this.trackByFunction(valueA) === this.trackByFunction(valueB);
    };
    AbstractCombo.prototype.hasFocus = function (element) {
        return window.document ? element.contains(document.activeElement) : false;
    };
    AbstractCombo.ctorParameters = function () { return [
        { type: String, decorators: [{ type: Attribute, args: ['tabindex',] }] },
        { type: ChangeDetectorRef },
        { type: Renderer2 },
        { type: ElementRef }
    ]; };
    __decorate([
        Input(),
        HostBinding('attr.cds-control-appearance'),
        __metadata("design:type", String)
    ], AbstractCombo.prototype, "appearance", void 0);
    __decorate([
        HostBinding('class.disabled'),
        __metadata("design:type", Boolean)
    ], AbstractCombo.prototype, "isDisabled", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], AbstractCombo.prototype, "chips", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], AbstractCombo.prototype, "search", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], AbstractCombo.prototype, "searchChange", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], AbstractCombo.prototype, "searchType", void 0);
    __decorate([
        ViewChild('searchInline'),
        __metadata("design:type", ElementRef)
    ], AbstractCombo.prototype, "searchInline", void 0);
    __decorate([
        ViewChild('searchInside'),
        __metadata("design:type", InputComponent)
    ], AbstractCombo.prototype, "searchInside", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], AbstractCombo.prototype, "searchDebounceTime", void 0);
    __decorate([
        Input('label'),
        __metadata("design:type", String)
    ], AbstractCombo.prototype, "_labelValue", void 0);
    __decorate([
        Input('placeholder'),
        __metadata("design:type", String)
    ], AbstractCombo.prototype, "_placeholder", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], AbstractCombo.prototype, "trackBy", null);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], AbstractCombo.prototype, "inputLabel", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], AbstractCombo.prototype, "buttonLabel", void 0);
    __decorate([
        HostListener('click', ['$event']),
        HostListener('keydown.enter', ['$event']),
        HostListener('keydown.space', ['$event']),
        HostListener('keydown.spacebar', ['$event']),
        HostListener('keydown.arrowdown', ['$event']),
        HostListener('keydown.arrowup', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], AbstractCombo.prototype, "toggle", null);
    __decorate([
        HostListener('mousedown', ['$event']),
        HostListener('mouseup', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [MouseEvent]),
        __metadata("design:returntype", void 0)
    ], AbstractCombo.prototype, "onMouseDown", null);
    AbstractCombo = __decorate([ __param(0, Attribute('tabindex')),
        __metadata("design:paramtypes", [String, ChangeDetectorRef,
            Renderer2,
            ElementRef])
    ], AbstractCombo);
AbstractCombo.ɵfac = function AbstractCombo_Factory(t) { return new (t || AbstractCombo)(ɵngcc0.ɵɵinjectAttribute('tabindex'), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
AbstractCombo.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AbstractCombo, viewQuery: function AbstractCombo_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c8, true);
        ɵngcc0.ɵɵviewQuery(_c9, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.searchInline = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.searchInside = _t.first);
    } }, hostVars: 3, hostBindings: function AbstractCombo_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function AbstractCombo_click_HostBindingHandler($event) { return ctx.toggle($event); })("keydown.enter", function AbstractCombo_keydown_enter_HostBindingHandler($event) { return ctx.toggle($event); })("keydown.space", function AbstractCombo_keydown_space_HostBindingHandler($event) { return ctx.toggle($event); })("keydown.spacebar", function AbstractCombo_keydown_spacebar_HostBindingHandler($event) { return ctx.toggle($event); })("keydown.arrowdown", function AbstractCombo_keydown_arrowdown_HostBindingHandler($event) { return ctx.toggle($event); })("keydown.arrowup", function AbstractCombo_keydown_arrowup_HostBindingHandler($event) { return ctx.toggle($event); })("mousedown", function AbstractCombo_mousedown_HostBindingHandler($event) { return ctx.onMouseDown($event); })("mouseup", function AbstractCombo_mouseup_HostBindingHandler($event) { return ctx.onMouseDown($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("cds-control-appearance", ctx.appearance);
        ɵngcc0.ɵɵclassProp("disabled", ctx.isDisabled);
    } }, inputs: { appearance: "appearance", chips: "chips", searchType: "searchType", searchDebounceTime: "searchDebounceTime", trackBy: "trackBy", search: "search", _labelValue: ["label", "_labelValue"], _placeholder: ["placeholder", "_placeholder"], inputLabel: "inputLabel", buttonLabel: "buttonLabel" }, outputs: { searchChange: "searchChange" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbstractCombo, [{
        type: Directive
    }], function () { return [{ type: String, decorators: [{
                type: Attribute,
                args: ['tabindex']
            }] }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { appearance: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.cds-control-appearance']
        }], isDisabled: [{
            type: HostBinding,
            args: ['class.disabled']
        }], chips: [{
            type: Input
        }], searchChange: [{
            type: Output
        }], searchType: [{
            type: Input
        }], searchDebounceTime: [{
            type: Input
        }], trackBy: [{
            type: Input
        }], toggle: [{
            type: HostListener,
            args: ['click', ['$event']]
        }, {
            type: HostListener,
            args: ['keydown.enter', ['$event']]
        }, {
            type: HostListener,
            args: ['keydown.space', ['$event']]
        }, {
            type: HostListener,
            args: ['keydown.spacebar', ['$event']]
        }, {
            type: HostListener,
            args: ['keydown.arrowdown', ['$event']]
        }, {
            type: HostListener,
            args: ['keydown.arrowup', ['$event']]
        }], onMouseDown: [{
            type: HostListener,
            args: ['mousedown', ['$event']]
        }, {
            type: HostListener,
            args: ['mouseup', ['$event']]
        }], search: [{
            type: Input
        }], searchInline: [{
            type: ViewChild,
            args: ['searchInline']
        }], searchInside: [{
            type: ViewChild,
            args: ['searchInside']
        }], _labelValue: [{
            type: Input,
            args: ['label']
        }], _placeholder: [{
            type: Input,
            args: ['placeholder']
        }], inputLabel: [{
            type: Input
        }], buttonLabel: [{
            type: Input
        }] }); })();
    return AbstractCombo;
}());
function isComboTrackByFunction(element) {
    if (element.length === 1) {
        return true;
    }
}

var COMBO_BUTTON_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return ComboButtonComponent; }),
    multi: true,
};
var ComboButtonComponent = /** @class */ (function () {
    function ComboButtonComponent(tabindex, element, renderer) {
        this.tabindex = tabindex;
        this.element = element;
        this.appearance = 'outline';
        this.disabled = false;
        this.onTouchedCallback = noop;
        this.modelValue = null;
        renderer.addClass(element.nativeElement, 'cds-control');
        renderer.addClass(element.nativeElement, 'cds-combo');
        renderer.addClass(element.nativeElement, 'cds-control--active-label');
        renderer.setAttribute(element.nativeElement, 'role', 'button');
        renderer.setAttribute(element.nativeElement, 'aria-haspopup', 'listbox');
        if (!this.tabindex) {
            this.tabindex = '0';
        }
    }
    Object.defineProperty(ComboButtonComponent.prototype, "isNotEmpty", {
        get: function () {
            var modelValue = this.modelValue;
            return Array.isArray(modelValue)
                ? modelValue.length > 0
                : modelValue != null && modelValue !== '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboButtonComponent.prototype, "attrTabindex", {
        get: function () {
            return this.disabled ? null : this.tabindex;
        },
        enumerable: true,
        configurable: true
    });
    ComboButtonComponent.prototype.ngOnInit = function () {
        if (isDevMode() && this.appearance === 'underline' && this.element.nativeElement.cl) {
            console.warn('Use of \'underline\' appearance is deprecated. Please use \'inline\' instead');
        }
    };
    ComboButtonComponent.prototype.onBlur = function () {
        if (!this.disabled) {
            this.onTouchedCallback();
        }
    };
    ComboButtonComponent.prototype.onClick = function (event) {
        if (this.disabled) {
            event.stopPropagation();
        }
        else {
            this.onTouchedCallback();
        }
    };
    ComboButtonComponent.prototype.registerOnChange = function () {
        /**
         * This function is empty because
         * we dont want to change model
         */
    };
    ComboButtonComponent.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    ComboButtonComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    ComboButtonComponent.prototype.toggle = function () {
        if (!this.disabled) {
            this.element.nativeElement.click();
        }
    };
    ComboButtonComponent.prototype.writeValue = function (value) {
        this.modelValue = value;
    };
    ComboButtonComponent.ctorParameters = function () { return [
        { type: String, decorators: [{ type: Attribute, args: ['tabindex',] }] },
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
    __decorate([
        Input(),
        HostBinding('attr.cds-control-appearance'),
        __metadata("design:type", String)
    ], ComboButtonComponent.prototype, "appearance", void 0);
    __decorate([
        HostBinding('class.disabled'),
        __metadata("design:type", Boolean)
    ], ComboButtonComponent.prototype, "disabled", void 0);
    __decorate([
        HostBinding('class.cds-control--not-empty'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ComboButtonComponent.prototype, "isNotEmpty", null);
    __decorate([
        HostBinding('attr.tabindex'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], ComboButtonComponent.prototype, "attrTabindex", null);
    __decorate([
        HostListener('blur'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ComboButtonComponent.prototype, "onBlur", null);
    __decorate([
        HostListener('click', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ComboButtonComponent.prototype, "onClick", null);
    __decorate([
        HostListener('keydown.enter'),
        HostListener('keydown.space'),
        HostListener('keydown.spacebar'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ComboButtonComponent.prototype, "toggle", null);
    ComboButtonComponent = __decorate([ __param(0, Attribute('tabindex')),
        __metadata("design:paramtypes", [String, ElementRef,
            Renderer2])
    ], ComboButtonComponent);
ComboButtonComponent.ɵfac = function ComboButtonComponent_Factory(t) { return new (t || ComboButtonComponent)(ɵngcc0.ɵɵinjectAttribute('tabindex'), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
ComboButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ComboButtonComponent, selectors: [["cds-combo-button"]], hostVars: 6, hostBindings: function ComboButtonComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("blur", function ComboButtonComponent_blur_HostBindingHandler() { return ctx.onBlur(); })("click", function ComboButtonComponent_click_HostBindingHandler($event) { return ctx.onClick($event); })("keydown.enter", function ComboButtonComponent_keydown_enter_HostBindingHandler() { return ctx.toggle(); })("keydown.space", function ComboButtonComponent_keydown_space_HostBindingHandler() { return ctx.toggle(); })("keydown.spacebar", function ComboButtonComponent_keydown_spacebar_HostBindingHandler() { return ctx.toggle(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("cds-control-appearance", ctx.appearance)("tabindex", ctx.attrTabindex);
        ɵngcc0.ɵɵclassProp("disabled", ctx.disabled)("cds-control--not-empty", ctx.isNotEmpty);
    } }, inputs: { appearance: "appearance" }, features: [ɵngcc0.ɵɵProvidersFeature([COMBO_BUTTON_CONTROL_VALUE_ACCESSOR])], ngContentSelectors: _c2, decls: 6, vars: 0, consts: [[1, "cds-control__container", "cds-zero-width-space"], [1, "cds-control__content"], [1, "cds-control__value"], [1, "cds-combo__caret"], ["aria-hidden", "true", 1, "cds-icon-angle-down"]], template: function ComboButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelement(0, "span", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "i", 3);
        ɵngcc0.ɵɵelement(5, "span", 4);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ComboButtonComponent, [{
        type: Component,
        args: [{
                selector: 'cds-combo-button',
                template: "<span class=\"cds-control__container cds-zero-width-space\"></span>\n<div class=\"cds-control__content\">\n\t<div class=\"cds-control__value\"><ng-content></ng-content></div>\n</div>\n<i class=\"cds-combo__caret\"><span class=\"cds-icon-angle-down\" aria-hidden=\"true\"></span></i>\n",
                providers: [COMBO_BUTTON_CONTROL_VALUE_ACCESSOR],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Attribute,
                args: ['tabindex']
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { appearance: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.cds-control-appearance']
        }], disabled: [{
            type: HostBinding,
            args: ['class.disabled']
        }], isNotEmpty: [{
            type: HostBinding,
            args: ['class.cds-control--not-empty']
        }], attrTabindex: [{
            type: HostBinding,
            args: ['attr.tabindex']
        }], onBlur: [{
            type: HostListener,
            args: ['blur']
        }], onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], toggle: [{
            type: HostListener,
            args: ['keydown.enter']
        }, {
            type: HostListener,
            args: ['keydown.space']
        }, {
            type: HostListener,
            args: ['keydown.spacebar']
        }] }); })();
    return ComboButtonComponent;
}());

var COMBO_TRANSLATIONS_EN = {
    selectAll: 'Select all',
    unselectAll: 'Unselect all',
    selected: 'Selected',
    selectedSingle: 'Selected {{1}}',
    selectedNothing: 'Nothing selected',
    selectedMulti: 'Selected {{1}} of {{2}} options',
    buttonLabel: 'Combo button',
    inputLabel: 'Filter options',
    reset: 'Reset',
    confirm: 'Confirm',
};
function comboTranslationsFactory() {
    return COMBO_TRANSLATIONS_EN;
}
var CDS_COMBO_TRANSLATIONS = new InjectionToken('CDS_COMBO_TRANSLATIONS', { factory: comboTranslationsFactory });

var ComboItemAllComponent = /** @class */ (function () {
    function ComboItemAllComponent(combo, elementRef, renderer, rippleService, componentTranslations) {
        var _this = this;
        this.combo = combo;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.rippleService = rippleService;
        this.isActive = false;
        renderer.addClass(elementRef.nativeElement, 'cds-combo-item-all');
        renderer.setAttribute(elementRef.nativeElement, 'role', 'option');
        componentTranslations.use(CDS_COMBO_TRANSLATIONS, comboTranslationsFactory, function (translations) {
            _this.translations = translations;
        });
    }
    Object.defineProperty(ComboItemAllComponent.prototype, "attrAriaSelected", {
        get: function () {
            return this.isActive;
        },
        enumerable: true,
        configurable: true
    });
    ComboItemAllComponent.prototype.onClick = function (event) {
        this.combo.toggleSelectAll(event, this);
    };
    ComboItemAllComponent.prototype.ngOnInit = function () {
        this.combo.registerItemAll(this);
    };
    ComboItemAllComponent.prototype.ngAfterContentInit = function () {
        this.rippleService.createForComboItem(this.elementRef.nativeElement);
    };
    ComboItemAllComponent.prototype.ngOnDestroy = function () {
        this.combo.unregisterItemAll(this);
    };
    ComboItemAllComponent.prototype.setActive = function (active) {
        this.isActive = active;
    };
    ComboItemAllComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Host }, { type: Inject, args: [forwardRef(function () { return COMBO_ITEM_ALL_HOST; }),] }] },
        { type: ElementRef },
        { type: Renderer2 },
        { type: RippleService },
        { type: DynamicTranslations }
    ]; };
    __decorate([
        HostBinding('class.active'),
        __metadata("design:type", Boolean)
    ], ComboItemAllComponent.prototype, "isActive", void 0);
    __decorate([
        HostBinding('attr.aria-selected'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ComboItemAllComponent.prototype, "attrAriaSelected", null);
    __decorate([
        HostListener('click', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Event]),
        __metadata("design:returntype", void 0)
    ], ComboItemAllComponent.prototype, "onClick", null);
    ComboItemAllComponent = __decorate([ __param(0, Host()), __param(0, Inject(forwardRef(function () { return COMBO_ITEM_ALL_HOST; }))),
        __metadata("design:paramtypes", [Object, ElementRef,
            Renderer2,
            RippleService,
            DynamicTranslations])
    ], ComboItemAllComponent);
ComboItemAllComponent.ɵfac = function ComboItemAllComponent_Factory(t) { return new (t || ComboItemAllComponent)(ɵngcc0.ɵɵdirectiveInject(forwardRef(function () { return COMBO_ITEM_ALL_HOST; }), 1), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(RippleService), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations)); };
ComboItemAllComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ComboItemAllComponent, selectors: [["", "cdsComboItemAll", ""]], hostVars: 3, hostBindings: function ComboItemAllComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function ComboItemAllComponent_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-selected", ctx.attrAriaSelected);
        ɵngcc0.ɵɵclassProp("active", ctx.isActive);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            DynamicTranslations,
        ])], attrs: _c10, decls: 2, vars: 2, consts: [[4, "ngIf"]], template: function ComboItemAllComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ComboItemAllComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, ComboItemAllComponent_ng_container_1_Template, 2, 1, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isActive);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isActive);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ComboItemAllComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line component-selector
                selector: '[cdsComboItemAll]',
                template: "<ng-container *ngIf=\"!isActive\">{{translations.selectAll}}</ng-container>\n<ng-container *ngIf=\"isActive\">{{translations.unselectAll}}</ng-container>",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                providers: [
                    DynamicTranslations,
                ]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Host
            }, {
                type: Inject,
                args: [forwardRef(function () { return COMBO_ITEM_ALL_HOST; })]
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: RippleService }, { type: DynamicTranslations }]; }, { isActive: [{
            type: HostBinding,
            args: ['class.active']
        }], attrAriaSelected: [{
            type: HostBinding,
            args: ['attr.aria-selected']
        }], onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();
    return ComboItemAllComponent;
}());
var COMBO_ITEM_ALL_HOST = new InjectionToken('COMBO_ITEM_ALL_HOST');

var ComboItemDirective = /** @class */ (function () {
    function ComboItemDirective(combo, elementRef, renderer, rippleService) {
        this.combo = combo;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.rippleService = rippleService;
        this.labelValue = undefined;
        this.isActive = false;
        this.disabled = false;
        renderer.addClass(elementRef.nativeElement, 'cds-combo-item');
        renderer.setAttribute(elementRef.nativeElement, 'role', 'option');
    }
    Object.defineProperty(ComboItemDirective.prototype, "attrAriaSelected", {
        get: function () {
            return this.isActive;
        },
        enumerable: true,
        configurable: true
    });
    ComboItemDirective.prototype.onClick = function (event) {
        this.combo.onItemClick(event, this);
    };
    ComboItemDirective.prototype.ngOnInit = function () {
        var _this = this;
        // Delay for change detection cycle to avoid ExpressionChangedAfterItHasBeenCheckedError
        Promise.resolve().then(function () {
            _this.combo.registerItem(_this);
        });
    };
    ComboItemDirective.prototype.ngAfterContentInit = function () {
        this.rippleService.createForComboItem(this.elementRef.nativeElement);
    };
    ComboItemDirective.prototype.ngOnDestroy = function () {
        var _this = this;
        Promise.resolve().then(function () {
            _this.combo.unregisterItem(_this);
        });
    };
    ComboItemDirective.prototype.setActive = function (active) {
        this.isActive = active;
    };
    ComboItemDirective.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Host }, { type: Inject, args: [forwardRef(function () { return COMBO_ITEM_HOST; }),] }] },
        { type: ElementRef },
        { type: Renderer2 },
        { type: RippleService }
    ]; };
    __decorate([
        Input('cdsComboItem'),
        __metadata("design:type", Object)
    ], ComboItemDirective.prototype, "value", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ComboItemDirective.prototype, "labelValue", void 0);
    __decorate([
        HostBinding('class.active'),
        __metadata("design:type", Boolean)
    ], ComboItemDirective.prototype, "isActive", void 0);
    __decorate([
        Input('itemDisabled'),
        HostBinding('class.disabled'),
        __metadata("design:type", Boolean)
    ], ComboItemDirective.prototype, "disabled", void 0);
    __decorate([
        HostBinding('attr.aria-selected'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ComboItemDirective.prototype, "attrAriaSelected", null);
    __decorate([
        HostListener('click', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Event]),
        __metadata("design:returntype", void 0)
    ], ComboItemDirective.prototype, "onClick", null);
    ComboItemDirective = __decorate([ __param(0, Host()), __param(0, Inject(forwardRef(function () { return COMBO_ITEM_HOST; }))),
        __metadata("design:paramtypes", [Object, ElementRef,
            Renderer2,
            RippleService])
    ], ComboItemDirective);
ComboItemDirective.ɵfac = function ComboItemDirective_Factory(t) { return new (t || ComboItemDirective)(ɵngcc0.ɵɵdirectiveInject(forwardRef(function () { return COMBO_ITEM_HOST; }), 1), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(RippleService)); };
ComboItemDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ComboItemDirective, selectors: [["", "cdsComboItem", ""]], hostVars: 5, hostBindings: function ComboItemDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function ComboItemDirective_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-selected", ctx.attrAriaSelected);
        ɵngcc0.ɵɵclassProp("active", ctx.isActive)("disabled", ctx.disabled);
    } }, inputs: { labelValue: "labelValue", disabled: ["itemDisabled", "disabled"], value: ["cdsComboItem", "value"] } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ComboItemDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsComboItem]'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Host
            }, {
                type: Inject,
                args: [forwardRef(function () { return COMBO_ITEM_HOST; })]
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: RippleService }]; }, { labelValue: [{
            type: Input
        }], isActive: [{
            type: HostBinding,
            args: ['class.active']
        }], disabled: [{
            type: Input,
            args: ['itemDisabled']
        }, {
            type: HostBinding,
            args: ['class.disabled']
        }], attrAriaSelected: [{
            type: HostBinding,
            args: ['attr.aria-selected']
        }], onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], value: [{
            type: Input,
            args: ['cdsComboItem']
        }] }); })();
    return ComboItemDirective;
}());
var COMBO_ITEM_HOST = new InjectionToken('COMBO_ITEM_HOST');

var ComboItemModalDirective = /** @class */ (function (_super) {
    __extends(ComboItemModalDirective, _super);
    function ComboItemModalDirective(combo, cdRef, elementRef, renderer, rippleService) {
        var _this = _super.call(this, combo, elementRef, renderer, rippleService) || this;
        _this.combo = combo;
        _this.cdRef = cdRef;
        _this.labelValue = undefined;
        _this.isActive = false;
        _this.isRegistered = false;
        return _this;
    }
    ComboItemModalDirective.prototype.onClick = function (event) { };
    ComboItemModalDirective.prototype.ngOnChanges = function (changes) {
        var _this = this;
        setTimeout(function () {
            _this.updateCombo();
        });
    };
    ComboItemModalDirective.prototype.updateCombo = function () {
        if (this.modalResponse) {
            this.combo.unregisterItem(this);
            var item = this.combo.findItem(this.modalResponse.value);
            var event_1 = createCustomEvent('combo-item-modal-selected', {
                bubbles: false,
            });
            if (item) {
                this.combo.onItemClick(event_1, item);
            }
            else {
                this.value = this.modalResponse.value;
                this.labelValue = this.modalResponse.labelValue;
                this.isRegistered = true;
                this.combo.registerItem(this);
                this.combo.onItemClick(event_1, this);
            }
            this.cdRef.markForCheck();
        }
    };
    ComboItemModalDirective.prototype.ngOnInit = function () { };
    ComboItemModalDirective.prototype.ngOnDestroy = function () { };
    ComboItemModalDirective.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Host }, { type: Inject, args: [forwardRef(function () { return COMBO_ITEM_HOST; }),] }] },
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: Renderer2 },
        { type: RippleService }
    ]; };
    __decorate([
        HostBinding('class.active'),
        __metadata("design:type", Boolean)
    ], ComboItemModalDirective.prototype, "isActive", void 0);
    __decorate([
        Input('cdsComboItemModal'),
        __metadata("design:type", Object)
    ], ComboItemModalDirective.prototype, "modalResponse", void 0);
    __decorate([
        HostListener('click', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Event]),
        __metadata("design:returntype", void 0)
    ], ComboItemModalDirective.prototype, "onClick", null);
    ComboItemModalDirective = __decorate([ __param(0, Host()), __param(0, Inject(forwardRef(function () { return COMBO_ITEM_HOST; }))),
        __metadata("design:paramtypes", [Object, ChangeDetectorRef,
            ElementRef,
            Renderer2,
            RippleService])
    ], ComboItemModalDirective);
ComboItemModalDirective.ɵfac = function ComboItemModalDirective_Factory(t) { return new (t || ComboItemModalDirective)(ɵngcc0.ɵɵdirectiveInject(forwardRef(function () { return COMBO_ITEM_HOST; }), 1), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(RippleService)); };
ComboItemModalDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ComboItemModalDirective, selectors: [["", "cdsComboItemModal", ""]], hostVars: 2, hostBindings: function ComboItemModalDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function ComboItemModalDirective_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("active", ctx.isActive);
    } }, inputs: { modalResponse: ["cdsComboItemModal", "modalResponse"] }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ComboItemModalDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsComboItemModal]'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Host
            }, {
                type: Inject,
                args: [forwardRef(function () { return COMBO_ITEM_HOST; })]
            }] }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: RippleService }]; }, { onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], isActive: [{
            type: HostBinding,
            args: ['class.active']
        }], modalResponse: [{
            type: Input,
            args: ['cdsComboItemModal']
        }] }); })();
    return ComboItemModalDirective;
}(ComboItemDirective));

var ComboCheckboxItemComponent = /** @class */ (function (_super) {
    __extends(ComboCheckboxItemComponent, _super);
    function ComboCheckboxItemComponent(combo, elementRef, renderer, rippleService) {
        var _this = _super.call(this, combo, elementRef, renderer, rippleService) || this;
        _this.combo = combo;
        renderer.removeClass(elementRef.nativeElement, 'cds-combo-item');
        renderer.addClass(elementRef.nativeElement, 'cds-combo-checkbox-item');
        renderer.addClass(elementRef.nativeElement, 'cds-dropdown__item--toggle');
        renderer.setAttribute(elementRef.nativeElement, 'role', 'option');
        return _this;
    }
    ComboCheckboxItemComponent_1 = ComboCheckboxItemComponent;
    Object.defineProperty(ComboCheckboxItemComponent.prototype, "attrAriaSelected", {
        get: function () {
            return this.isActive;
        },
        enumerable: true,
        configurable: true
    });
    ComboCheckboxItemComponent.prototype.ngAfterContentInit = function () {
        this.rippleService.createForComboCheckboxItem(this.elementRef.nativeElement);
    };
    ComboCheckboxItemComponent.prototype.ngOnChanges = function (changes) {
        if ('disabled' in changes) {
            this.checkbox.setDisabledState(this.disabled);
        }
    };
    ComboCheckboxItemComponent.prototype.setActive = function (active) {
        _super.prototype.setActive.call(this, active);
        this.checkbox.writeValue(active);
    };
    var ComboCheckboxItemComponent_1;
    ComboCheckboxItemComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Host }, { type: Inject, args: [forwardRef(function () { return COMBO_ITEM_HOST; }),] }] },
        { type: ElementRef },
        { type: Renderer2 },
        { type: RippleService }
    ]; };
    __decorate([
        Input('cdsComboCheckboxItem'),
        __metadata("design:type", Object)
    ], ComboCheckboxItemComponent.prototype, "value", void 0);
    __decorate([
        ViewChild('checkbox', { static: true }),
        __metadata("design:type", CheckboxComponent)
    ], ComboCheckboxItemComponent.prototype, "checkbox", void 0);
    __decorate([
        HostBinding('attr.aria-selected'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ComboCheckboxItemComponent.prototype, "attrAriaSelected", null);
    ComboCheckboxItemComponent = ComboCheckboxItemComponent_1 = __decorate([ __param(0, Host()), __param(0, Inject(forwardRef(function () { return COMBO_ITEM_HOST; }))),
        __metadata("design:paramtypes", [Object, ElementRef,
            Renderer2,
            RippleService])
    ], ComboCheckboxItemComponent);
ComboCheckboxItemComponent.ɵfac = function ComboCheckboxItemComponent_Factory(t) { return new (t || ComboCheckboxItemComponent)(ɵngcc0.ɵɵdirectiveInject(forwardRef(function () { return COMBO_ITEM_HOST; }), 1), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(RippleService)); };
ComboCheckboxItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ComboCheckboxItemComponent, selectors: [["", "cdsComboCheckboxItem", ""]], viewQuery: function ComboCheckboxItemComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c11, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.checkbox = _t.first);
    } }, hostVars: 1, hostBindings: function ComboCheckboxItemComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-selected", ctx.attrAriaSelected);
    } }, inputs: { value: ["cdsComboCheckboxItem", "value"] }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: ComboItemDirective,
                useExisting: forwardRef(function () { return ComboCheckboxItemComponent_1; })
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], attrs: _c12, ngContentSelectors: _c2, decls: 3, vars: 0, consts: [["aria-hidden", "true", "tabindex", "-1", 1, "cds-dropdown__toggle"], ["checkbox", ""]], template: function ComboCheckboxItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelement(0, "cds-checkbox", 0, 1);
        ɵngcc0.ɵɵprojection(2);
    } }, directives: [CheckboxComponent], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ComboCheckboxItemComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line component-selector
                selector: '[cdsComboCheckboxItem]',
                template: "<cds-checkbox aria-hidden=\"true\" class=\"cds-dropdown__toggle\" tabindex=\"-1\" #checkbox></cds-checkbox>\n<ng-content></ng-content>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                providers: [
                    {
                        provide: ComboItemDirective,
                        useExisting: forwardRef(function () { return ComboCheckboxItemComponent_1; })
                    },
                ]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Host
            }, {
                type: Inject,
                args: [forwardRef(function () { return COMBO_ITEM_HOST; })]
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: RippleService }]; }, { attrAriaSelected: [{
            type: HostBinding,
            args: ['attr.aria-selected']
        }], value: [{
            type: Input,
            args: ['cdsComboCheckboxItem']
        }], checkbox: [{
            type: ViewChild,
            args: ['checkbox', { static: true }]
        }] }); })();
    return ComboCheckboxItemComponent;
}(ComboItemDirective));

var ComboCheckboxItemAllComponent = /** @class */ (function (_super) {
    __extends(ComboCheckboxItemAllComponent, _super);
    function ComboCheckboxItemAllComponent(combo, elementRef, renderer, rippleService, componentTranslations) {
        var _this = _super.call(this, combo, elementRef, renderer, rippleService, componentTranslations) || this;
        renderer.removeClass(elementRef.nativeElement, 'cds-combo-item-all');
        renderer.addClass(elementRef.nativeElement, 'cds-combo-checkbox-item-all');
        renderer.addClass(elementRef.nativeElement, 'cds-dropdown__item--toggle');
        componentTranslations.use(CDS_COMBO_TRANSLATIONS, comboTranslationsFactory, function (translations) {
            _this.translations = translations;
        });
        return _this;
    }
    Object.defineProperty(ComboCheckboxItemAllComponent.prototype, "attrAriaSelected", {
        get: function () {
            return this.isActive;
        },
        enumerable: true,
        configurable: true
    });
    ComboCheckboxItemAllComponent.prototype.ngAfterContentInit = function () {
        this.rippleService.createForComboCheckboxItem(this.elementRef.nativeElement);
    };
    ComboCheckboxItemAllComponent.prototype.setActive = function (active) {
        _super.prototype.setActive.call(this, active);
        this.checkbox.writeValue(active);
    };
    ComboCheckboxItemAllComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Host }, { type: Inject, args: [forwardRef(function () { return COMBO_ITEM_ALL_HOST; }),] }] },
        { type: ElementRef },
        { type: Renderer2 },
        { type: RippleService },
        { type: DynamicTranslations }
    ]; };
    __decorate([
        ViewChild('checkbox', { static: true }),
        __metadata("design:type", CheckboxComponent)
    ], ComboCheckboxItemAllComponent.prototype, "checkbox", void 0);
    __decorate([
        HostBinding('attr.aria-selected'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ComboCheckboxItemAllComponent.prototype, "attrAriaSelected", null);
    ComboCheckboxItemAllComponent = __decorate([ __param(0, Host()), __param(0, Inject(forwardRef(function () { return COMBO_ITEM_ALL_HOST; }))),
        __metadata("design:paramtypes", [Object, ElementRef,
            Renderer2,
            RippleService,
            DynamicTranslations])
    ], ComboCheckboxItemAllComponent);
ComboCheckboxItemAllComponent.ɵfac = function ComboCheckboxItemAllComponent_Factory(t) { return new (t || ComboCheckboxItemAllComponent)(ɵngcc0.ɵɵdirectiveInject(forwardRef(function () { return COMBO_ITEM_ALL_HOST; }), 1), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(RippleService), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations)); };
ComboCheckboxItemAllComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ComboCheckboxItemAllComponent, selectors: [["", "cdsComboCheckboxItemAll", ""]], viewQuery: function ComboCheckboxItemAllComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c11, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.checkbox = _t.first);
    } }, hostVars: 1, hostBindings: function ComboCheckboxItemAllComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-selected", ctx.attrAriaSelected);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([
            DynamicTranslations,
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], attrs: _c13, decls: 3, vars: 1, consts: [["aria-hidden", "true", "tabindex", "-1", 1, "cds-dropdown__toggle"], ["checkbox", ""]], template: function ComboCheckboxItemAllComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "cds-checkbox", 0, 1);
        ɵngcc0.ɵɵtext(2);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1("\n", ctx.translations.selectAll, "\n");
    } }, directives: [CheckboxComponent], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ComboCheckboxItemAllComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line component-selector
                selector: '[cdsComboCheckboxItemAll]',
                template: "<cds-checkbox aria-hidden=\"true\" class=\"cds-dropdown__toggle\" tabindex=\"-1\" #checkbox></cds-checkbox>\n{{translations.selectAll}}\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                providers: [
                    DynamicTranslations,
                ]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Host
            }, {
                type: Inject,
                args: [forwardRef(function () { return COMBO_ITEM_ALL_HOST; })]
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: RippleService }, { type: DynamicTranslations }]; }, { attrAriaSelected: [{
            type: HostBinding,
            args: ['attr.aria-selected']
        }], checkbox: [{
            type: ViewChild,
            args: ['checkbox', { static: true }]
        }] }); })();
    return ComboCheckboxItemAllComponent;
}(ComboItemAllComponent));

var COMBO_MULTI_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return ComboMultiComponent; }),
    multi: true,
};
var COMBO_ITEM_HOST_PROVIDER = {
    provide: COMBO_ITEM_HOST,
    useExisting: forwardRef(function () { return ComboMultiComponent; }),
};
var COMBO_ITEM_ALL_HOST_PROVIDER = {
    provide: COMBO_ITEM_ALL_HOST,
    useExisting: forwardRef(function () { return ComboMultiComponent; }),
};
var ComboMultiComponent = /** @class */ (function (_super) {
    __extends(ComboMultiComponent, _super);
    function ComboMultiComponent(tabindex, elementRef, renderer, cdRef, componentTranslations) {
        var _this = _super.call(this, tabindex, cdRef, renderer, elementRef) || this;
        _this.elementRef = elementRef;
        _this.focusActive = false;
        _this.itemAll = null;
        _this.items = [];
        _this.visibleItems = new Set();
        _this.modelValue = null;
        _this.resetValue = null;
        _this.activeItems = new Map();
        _this.visibleActiveItems = new Map();
        _this._selectedLabel = '';
        _this._selectedCount = 0;
        _this._totalCount = 0;
        _this._selectedAll = false;
        _this.allowUnregisterItem = true;
        _this.confirmButtons = false;
        renderer.addClass(elementRef.nativeElement, 'cds-control');
        renderer.addClass(elementRef.nativeElement, 'cds-combo');
        _this.changes$.subscribe(function () {
            cdRef.detectChanges();
        });
        componentTranslations.use(CDS_COMBO_TRANSLATIONS, comboTranslationsFactory, function (translations) {
            _this.translations = translations;
        });
        return _this;
    }
    Object.defineProperty(ComboMultiComponent.prototype, "controlFocus", {
        get: function () {
            return this.isFocus || this.isOpen;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboMultiComponent.prototype, "controlActiveLabel", {
        get: function () {
            return this.selectedCount !== 0 || !!this.placeholder || (this.withSearchInline && this.isOpen);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboMultiComponent.prototype, "selectedCount", {
        get: function () { return this._selectedCount; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboMultiComponent.prototype, "totalCount", {
        get: function () { return this._totalCount; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboMultiComponent.prototype, "selectedAll", {
        get: function () { return this._selectedAll; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboMultiComponent.prototype, "selectedLabel", {
        get: function () { return this._selectedLabel; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboMultiComponent.prototype, "completeButtonLabel", {
        get: function () {
            return this.buttonLabel || (this.labelValue || this.translations.buttonLabel) + " " + this.getSelectedLabel();
        },
        enumerable: true,
        configurable: true
    });
    ComboMultiComponent.prototype.getSelectedLabel = function () {
        return this.translations.selectedMulti.replace('{{1}}', "" + this.selectedCount).replace('{{2}}', "" + this.totalCount);
    };
    ComboMultiComponent.prototype.onDropdownClick = function (event) {
        event.stopPropagation();
        event.preventDefault();
    };
    ComboMultiComponent.prototype.onDropdownKey = function (event) {
        if (event.key === 'a' && event.ctrlKey) {
            this.toggleSelectAll(event);
            event.stopPropagation();
            event.preventDefault();
        }
    };
    ComboMultiComponent.prototype.onChange = function (value, forceChangeCallback) {
        if (forceChangeCallback === void 0) { forceChangeCallback = false; }
        if (!this.confirmButtons || forceChangeCallback) {
            this.onChangeCallback(value);
        }
    };
    ComboMultiComponent.prototype.confirmChanges = function () {
        this.onChangeCallback(this.modelValue);
        this.close();
    };
    ComboMultiComponent.prototype.resetChanges = function () {
        this.clear();
        this.close();
    };
    ComboMultiComponent.prototype.registerOnChange = function (fn) {
        var _this = this;
        _super.prototype.registerOnChange.call(this, function (value) {
            fn(value);
            _this.resetValue = value;
        });
    };
    ComboMultiComponent.prototype.updateSelectedLabel = function () {
        if (this.selectedCount > 0) {
            var activeItem = this.activeItems.values().next().value;
            this._selectedLabel = activeItem.labelValue !== undefined ? activeItem.labelValue : activeItem.value;
            this.changesSubject$.next(this);
        }
    };
    ComboMultiComponent.prototype.updateCounters = function () {
        this._totalCount = this.items.length;
        this._selectedCount = this.activeItems.size;
        this._selectedAll = this._totalCount > 0 ? this.selectedCount === this._totalCount : false;
        if (this.itemAll) {
            if (this.visibleItems.size > 0) {
                this.itemAll.setActive(this.visibleActiveItems.size === this.visibleItems.size);
            }
            else {
                this.itemAll.setActive(this.selectedCount === this.items.length);
            }
        }
        this.changesSubject$.next(this);
    };
    ComboMultiComponent.prototype.setActiveItem = function (item, active) {
        var trackByKey = this.trackByFunction(item.value);
        var activeItem = this.activeItems.get(trackByKey);
        item.setActive(active);
        var change = false;
        if (active) {
            this.activeItems.set(trackByKey, item);
            if (this.visibleItems.has(item)) {
                this.visibleActiveItems.set(trackByKey, item);
            }
            change = !activeItem;
            if (change) {
                this.updateCounters();
                this.updateSelectedLabel();
            }
        }
        else {
            if (activeItem) {
                this.activeItems.delete(trackByKey);
                this.visibleActiveItems.delete(trackByKey);
                change = true;
                this.updateCounters();
                this.updateSelectedLabel();
            }
        }
        return change;
    };
    ComboMultiComponent.prototype.getModelValue = function () {
        var values = [];
        this.activeItems.forEach(function (item) {
            values.push(item.value);
        });
        return values;
    };
    ComboMultiComponent.prototype.writeValue = function (values) {
        var e_1, _a;
        var _this = this;
        this.cdRef.markForCheck();
        this.resetValue = values;
        this.modelValue = values;
        var _loop_1 = function (item) {
            var active = values == null ? false : values.some(function (value) { return _this.isEqual(value, item.value); });
            this_1.setActiveItem(item, active);
        };
        var this_1 = this;
        try {
            for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                _loop_1(item);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.cdRef.detectChanges();
    };
    ComboMultiComponent.prototype.findItem = function (value) {
        var e_2, _a;
        try {
            for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                if (this.isEqual(item.value, value)) {
                    return item;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return null;
    };
    ComboMultiComponent.prototype.onOpenChange = function (isOpen) {
        _super.prototype.onOpenChange.call(this, isOpen);
        if (!isOpen && this.modelValue !== this.resetValue) {
            this.cdRef.detectChanges();
            this.writeValue(this.resetValue);
        }
    };
    ComboMultiComponent.prototype.onItemClick = function (event, item) {
        if (!item.disabled) {
            var active = !item.isActive;
            var changed = this.setActiveItem(item, active);
            if (changed) {
                this.modelValue = this.getModelValue();
                this.onChange(this.modelValue);
            }
        }
        this.cdRef.markForCheck();
        this.cdRef.detectChanges();
    };
    ComboMultiComponent.prototype.onItemVisibilityChange = function (item, visible) {
        var trackByKey = this.trackByFunction(item.value);
        if (visible) {
            this.visibleItems.add(item);
            if (this.activeItems.has(trackByKey)) {
                this.visibleActiveItems.set(trackByKey, item);
            }
        }
        else {
            this.visibleItems.delete(item);
            this.visibleActiveItems.delete(trackByKey);
        }
        this.updateCounters();
        this.updateSelectedLabel();
        this.scheduleUpdate();
    };
    ComboMultiComponent.prototype.scheduleUpdate = function () {
        if (this.dropdown) {
            this.dropdown.scheduleUpdate();
        }
    };
    ComboMultiComponent.prototype.clear = function () {
        var e_3, _a;
        try {
            for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                this.setActiveItem(item, false);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        this.modelValue = this.getModelValue();
        this.onChange(this.modelValue, true);
    };
    ComboMultiComponent.prototype.registerItem = function (item) {
        var _this = this;
        setTimeout(function () {
            var e_4, _a;
            _this.items.push(item);
            var trackByKey = _this.trackByFunction(item.value);
            if (!_this.activeItems.has(trackByKey) && _this.modelValue != null) {
                try {
                    for (var _b = __values(_this.modelValue), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var value = _c.value;
                        if (_this.isEqual(value, item.value)) {
                            _this.setActiveItem(item, true);
                            break;
                        }
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            }
            _this.updateCounters();
        });
    };
    ComboMultiComponent.prototype.unregisterItem = function (item) {
        var _this = this;
        if (this.allowUnregisterItem) {
            var idx = this.items.indexOf(item);
            if (idx !== -1) {
                this.items.splice(idx, 1);
            }
            this.visibleItems.delete(item);
            this.activeItems.forEach(function (activeItem) {
                if (_this.isEqual(activeItem.value, item.value)) {
                    var changed = _this.setActiveItem(item, false);
                    if (changed) {
                        _this.modelValue = _this.getModelValue();
                        _this.onChange(_this.modelValue);
                    }
                }
            });
            this.updateCounters();
        }
    };
    ComboMultiComponent.prototype.registerItemAll = function (item) {
        this.itemAll = item;
    };
    ComboMultiComponent.prototype.unregisterItemAll = function (item) {
        this.itemAll = null;
    };
    ComboMultiComponent.prototype.toggleSelectAll = function (event, itemAll) {
        var _this = this;
        var selectAll = false;
        var toggleOverVisible = this.visibleItems.size > 0;
        var items = toggleOverVisible ? this.visibleItems : this.items;
        var iterator = items.values();
        while (!selectAll) {
            var nextItem = iterator.next();
            if (nextItem.done) {
                break;
            }
            if (!nextItem.value.isActive) {
                selectAll = true;
                break;
            }
        }
        if (toggleOverVisible) {
            this.visibleActiveItems.clear();
            this.modelValue = this.getModelValue();
            items.forEach(function (item) {
                _this.setActiveItem(item, selectAll);
                var indexInModel = _this.modelValue.indexOf(item.value);
                if (selectAll && indexInModel === -1) {
                    _this.modelValue.push(item.value);
                }
                else if (!selectAll && indexInModel !== -1) {
                    _this.modelValue.splice(indexInModel, 1);
                }
            });
        }
        else {
            this.activeItems.clear();
            this.modelValue = [];
            items.forEach(function (item) {
                _this.setActiveItem(item, selectAll);
                if (selectAll) {
                    _this.modelValue.push(item.value);
                }
            });
        }
        this.updateCounters();
        this.onChange(this.modelValue);
    };
    ComboMultiComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    ComboMultiComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.allowUnregisterItem = false;
    };
    ComboMultiComponent.ctorParameters = function () { return [
        { type: String, decorators: [{ type: Attribute, args: ['tabindex',] }] },
        { type: ElementRef },
        { type: Renderer2 },
        { type: ChangeDetectorRef },
        { type: DynamicTranslations }
    ]; };
    __decorate([
        HostBinding('class.cds-control--not-empty'),
        __metadata("design:type", Number)
    ], ComboMultiComponent.prototype, "_selectedCount", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], ComboMultiComponent.prototype, "confirmButtons", void 0);
    __decorate([
        ViewChild('dropdown'),
        __metadata("design:type", DropdownComponent)
    ], ComboMultiComponent.prototype, "dropdown", void 0);
    __decorate([
        HostBinding('class.cds-control--focus'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ComboMultiComponent.prototype, "controlFocus", null);
    __decorate([
        HostBinding('class.cds-control--active-label'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ComboMultiComponent.prototype, "controlActiveLabel", null);
    ComboMultiComponent = __decorate([ __param(0, Attribute('tabindex')),
        __metadata("design:paramtypes", [String, ElementRef,
            Renderer2,
            ChangeDetectorRef,
            DynamicTranslations])
    ], ComboMultiComponent);
ComboMultiComponent.ɵfac = function ComboMultiComponent_Factory(t) { return new (t || ComboMultiComponent)(ɵngcc0.ɵɵinjectAttribute('tabindex'), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations)); };
ComboMultiComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ComboMultiComponent, selectors: [["cds-combo-multi"]], viewQuery: function ComboMultiComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c14, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
    } }, hostVars: 6, hostBindings: function ComboMultiComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("cds-control--focus", ctx.controlFocus)("cds-control--active-label", ctx.controlActiveLabel)("cds-control--not-empty", ctx._selectedCount);
    } }, inputs: { confirmButtons: "confirmButtons" }, features: [ɵngcc0.ɵɵProvidersFeature([COMBO_MULTI_CONTROL_VALUE_ACCESSOR, COMBO_ITEM_HOST_PROVIDER, COMBO_ITEM_ALL_HOST_PROVIDER, DynamicTranslations]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c17, decls: 15, vars: 11, consts: [["aria-hidden", "true", 1, "cds-control__container", "cds-zero-width-space"], ["cdsViewRef", ""], ["labelContent", "", "labelContentRef", "cdsViewRef"], ["valueContent", ""], ["role", "button", "aria-haspopup", "listbox", 1, "cds-combo__caret", 3, "focus", "blur"], ["aria-hidden", "true", 1, "cds-icon-angle-down"], [1, "cds-control__content"], ["class", "cds-control__label", "aria-hidden", "true", 4, "ngIf"], ["withoutSearchInline", ""], [4, "ngIf", "ngIfElse"], [3, "anchor", "initialFocus", "cds-dropdown--auto-height", "dismiss", "click", "keydown", 4, "ngIf"], ["aria-hidden", "true", 1, "cds-control__label"], [1, "cds-control__label-text"], [4, "ngTemplateOutlet"], [4, "ngIf"], ["aria-hidden", "true", "class", "cds-control__value", 4, "ngIf"], ["aria-hidden", "true", "class", "cds-control__placeholder", 4, "ngIf"], ["aria-hidden", "true", "appearance", "control", "tabindex", "-1", 1, "cds-chip-small", 3, "ngModel", "uncheckable", "removable", "remove"], ["aria-hidden", "true", 1, "cds-control__value"], ["aria-hidden", "true", 1, "cds-control__placeholder"], [1, "cds-control__value", 3, "ngModel", "ngModelChange", "keydown.enter", "blur"], ["searchInline", ""], [3, "anchor", "initialFocus", "dismiss", "click", "keydown"], ["dropdown", ""], ["dropdownOptions", ""], ["searchInsideDropdown", ""], ["class", "cds-combo__search-inside", 3, "cdsDropdownDisableKeydown", 4, "ngIf"], [1, "cds-combo__search-inside", 3, "cdsDropdownDisableKeydown"], [3, "resettable", "ngModel", "ariaLabel", "ngModelChange", "keydown.enter", "blur"], ["searchInside", ""], [1, "cds-icon-search", "cds-icon--placement-before", "cds-combo__search-icon"], [1, "cds-combo__scrollable-content"], [1, "cds-combo__confirm-buttons"], ["cdsButton", "", "type", "button", 1, "cds-button-text", 3, "click"]], template: function ComboMultiComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c16);
        ɵngcc0.ɵɵelement(0, "span", 0);
        ɵngcc0.ɵɵtemplate(1, ComboMultiComponent_ng_template_1_Template, 1, 0, "ng-template", 1, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(4, ComboMultiComponent_ng_template_4_Template, 1, 0, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(6, "i", 4);
        ɵngcc0.ɵɵlistener("focus", function ComboMultiComponent_Template_i_focus_6_listener($event) { return ctx.onButtonFocus($event, true); })("blur", function ComboMultiComponent_Template_i_blur_6_listener($event) { return ctx.onButtonFocus($event, false); });
        ɵngcc0.ɵɵelement(7, "span", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵtemplate(9, ComboMultiComponent_div_9_Template, 3, 1, "div", 7);
        ɵngcc0.ɵɵtemplate(10, ComboMultiComponent_div_10_Template, 3, 1, "div", 7);
        ɵngcc0.ɵɵtemplate(11, ComboMultiComponent_ng_template_11_Template, 4, 4, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(13, ComboMultiComponent_ng_container_13_Template, 3, 2, "ng-container", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(14, ComboMultiComponent_cds_dropdown_14_Template, 7, 7, "cds-dropdown", 10);
    } if (rf & 2) {
        var _r1 = ɵngcc0.ɵɵreference(3);
        var _r7 = ɵngcc0.ɵɵreference(12);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵclassProp("cds-combo__caret--open", ctx.isOpen);
        ɵngcc0.ɵɵattribute("tabindex", ctx.attrTabindex)("aria-disabled", ctx.isDisabled)("aria-expanded", !!ctx.isOpen)("aria-label", ctx.completeButtonLabel);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.labelValue);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.labelValue && _r1.hasChildren);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.withSearchInline && ctx.isOpen)("ngIfElse", _r7);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isOpen);
    } }, directives: function () { return [ViewRefDirective, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ChipComponent, ChipRippleDirective, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.DefaultValueAccessor, DropdownComponent, DropdownDisableKeydownDirective, InputComponent, ButtonRippleDirective]; }, encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ComboMultiComponent, [{
        type: Component,
        args: [{
                selector: 'cds-combo-multi',
                template: "<span class=\"cds-control__container cds-zero-width-space\" aria-hidden=\"true\"></span>\n<ng-template #labelContent #labelContentRef=\"cdsViewRef\" cdsViewRef><ng-content select=\"label[title]\"></ng-content></ng-template>\n<ng-template #valueContent><ng-content select=\"label:not([default]):not([title])\"></ng-content></ng-template>\n<i class=\"cds-combo__caret\" [class.cds-combo__caret--open]=\"isOpen\"\n   role=\"button\"\n   aria-haspopup=\"listbox\"\n   (focus)=\"onButtonFocus($event, true)\"\n   (blur)=\"onButtonFocus($event, false)\"\n   [attr.tabindex]=\"attrTabindex\"\n   [attr.aria-disabled]=\"isDisabled\"\n   [attr.aria-expanded]=\"!!isOpen\"\n   [attr.aria-label]=\"completeButtonLabel\">\n\t<span class=\"cds-icon-angle-down\" aria-hidden=\"true\"></span>\n</i>\n<div class=\"cds-control__content\">\n\t<div class=\"cds-control__label\" aria-hidden=\"true\" *ngIf=\"labelValue\">\n\t\t<div class=\"cds-control__label-text\">{{labelValue}}</div>\n\t</div>\n\t<div class=\"cds-control__label\" aria-hidden=\"true\" *ngIf=\"!labelValue && labelContentRef.hasChildren\">\n\t\t<div class=\"cds-control__label-text\"><ng-container *ngTemplateOutlet=\"labelContent\"></ng-container></div>\n\t</div>\n\t<ng-template #withoutSearchInline>\n\t\t<ng-container *ngIf=\"chips && selectedCount !== 0\" >\n\t\t\t<cds-chip aria-hidden=\"true\" [ngModel]=\"true\" class=\"cds-chip-small\" appearance=\"control\" [uncheckable]=\"false\" [removable]=\"true\" (remove)=\"clear()\" tabindex=\"-1\">\n\t\t\t\t<ng-container *ngTemplateOutlet=\"valueContent\"></ng-container>\n\t\t\t</cds-chip>\n\t\t</ng-container>\n\t\t<div *ngIf=\"!chips && selectedCount !== 0\" aria-hidden=\"true\" class=\"cds-control__value\">\n\t\t\t<ng-container *ngTemplateOutlet=\"valueContent\"></ng-container>\n\t\t\t<!-- fix an issue where there's always have to be non empty value or placeholder -->&#8203;\n\t\t</div>\n\t\t<div *ngIf=\"placeholder && selectedCount === 0\" aria-hidden=\"true\" class=\"cds-control__placeholder\">\n\t\t\t{{placeholder}}\n\t\t</div>\n\t\t<div *ngIf=\"!placeholder && selectedCount === 0\" aria-hidden=\"true\" class=\"cds-control__placeholder\">\n\t\t\t<ng-content select=\"label[default],label[all]\"></ng-content>\n\t\t\t<!-- fix an issue where there's always have to be non empty value or placeholder -->&#8203;\n\t\t</div>\n\t</ng-template>\n\n\t<ng-container *ngIf=\"withSearchInline && isOpen; else withoutSearchInline\">\n\t\t<input #searchInline class=\"cds-control__value\" [attr.aria-label]=\"inputLabel || translations.inputLabel\" [ngModel]=\"search\" (ngModelChange)=\"search$.next($event)\" (keydown.enter)=\"$event.preventDefault()\" (blur)=\"onSearchFieldBlur($event.relatedTarget)\" />\n\t</ng-container>\n</div>\n<cds-dropdown #dropdown *ngIf=\"isOpen\" (dismiss)=\"onOpenChange(false)\" [anchor]=\"elementRef\"\n              [initialFocus]=\"!withSearchInside && !withSearchInline ? (focusActive ? ['li.active', 'li'] : 'li') : null\"\n              [class.cds-dropdown--auto-height]=\"confirmButtons\" (click)=\"onDropdownClick($event)\" (keydown)=\"onDropdownKey($event)\">\n\t<ng-template #dropdownOptions>\n\t\t<ng-content select=\"ul\"></ng-content>\n\t</ng-template>\n\t<ng-template #searchInsideDropdown>\n\t\t<div *ngIf=\"withSearchInside\" class=\"cds-combo__search-inside\" [cdsDropdownDisableKeydown]=\"disableKeydown\">\n\t\t\t<cds-input #searchInside [resettable]=\"true\" [ngModel]=\"search\" (ngModelChange)=\"search$.next($event)\" (keydown.enter)=\"$event.preventDefault()\" (blur)=\"onSearchFieldBlur($event.detail.relatedTarget)\" [ariaLabel]=\"inputLabel || translations.inputLabel\">\n\t\t\t\t<i class=\"cds-icon-search cds-icon--placement-before cds-combo__search-icon\"></i>\n\t\t\t</cds-input>\n\t\t</div>\n\t\t<ng-container *ngTemplateOutlet=\"dropdownOptions\"></ng-container>\n\t</ng-template>\n\t<ng-container *ngIf=\"confirmButtons || withSearchInside; else dropdownOptions\">\n\t\t<ng-container *ngIf=\"confirmButtons; else searchInsideDropdown\">\n\t\t\t<div class=\"cds-combo__scrollable-content\">\n\t\t\t\t<ng-container *ngTemplateOutlet=\"searchInsideDropdown\"></ng-container>\n\t\t\t</div>\n\t\t\t<div class=\"cds-combo__confirm-buttons\">\n\t\t\t\t<button cdsButton type=\"button\" (click)=\"resetChanges()\" class=\"cds-button-text\">{{translations.reset}}</button>\n\t\t\t\t<button cdsButton type=\"button\" (click)=\"confirmChanges()\" class=\"cds-button-text\">{{translations.confirm}}</button>\n\t\t\t</div>\n\t\t</ng-container>\n\t</ng-container>\n</cds-dropdown>\n",
                providers: [COMBO_MULTI_CONTROL_VALUE_ACCESSOR, COMBO_ITEM_HOST_PROVIDER, COMBO_ITEM_ALL_HOST_PROVIDER, DynamicTranslations],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Attribute,
                args: ['tabindex']
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: DynamicTranslations }]; }, { controlFocus: [{
            type: HostBinding,
            args: ['class.cds-control--focus']
        }], controlActiveLabel: [{
            type: HostBinding,
            args: ['class.cds-control--active-label']
        }], _selectedCount: [{
            type: HostBinding,
            args: ['class.cds-control--not-empty']
        }], confirmButtons: [{
            type: Input
        }], dropdown: [{
            type: ViewChild,
            args: ['dropdown']
        }] }); })();
    return ComboMultiComponent;
}(AbstractCombo));

var ComboMultiSelectedLabelComponent = /** @class */ (function () {
    function ComboMultiSelectedLabelComponent(cdRef, zone, componentTranslations) {
        var _this = this;
        this.cdRef = cdRef;
        this.zone = zone;
        cdRef.detach();
        componentTranslations.use(CDS_COMBO_TRANSLATIONS, comboTranslationsFactory, function (translations) {
            _this.translations = translations;
            if (_this.combo) {
                cdRef.detectChanges();
            }
        });
    }
    ComboMultiSelectedLabelComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if ('combo' in changes) {
            if (this.subscription) {
                this.subscription.unsubscribe();
                this.subscription = null;
            }
            if (this.combo && this.combo instanceof AbstractCombo) {
                var combo_1 = this.combo;
                combo_1.setFallbackValues(this.titleLabel, this.allLabel);
                this.zone.runOutsideAngular(function () {
                    _this.subscription = combo_1.changes$.pipe(debounceTime(0)).subscribe(function () {
                        _this.cdRef.detectChanges();
                    });
                });
            }
        }
        this.cdRef.detectChanges();
    };
    ComboMultiSelectedLabelComponent.prototype.ngOnDestroy = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    };
    ComboMultiSelectedLabelComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: NgZone },
        { type: DynamicTranslations }
    ]; };
    __decorate([
        Input('cdsComboMultiSelectedLabel'),
        __metadata("design:type", Object)
    ], ComboMultiSelectedLabelComponent.prototype, "combo", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ComboMultiSelectedLabelComponent.prototype, "titleLabel", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ComboMultiSelectedLabelComponent.prototype, "allLabel", void 0);
    ComboMultiSelectedLabelComponent = __decorate([ __metadata("design:paramtypes", [ChangeDetectorRef,
            NgZone,
            DynamicTranslations])
    ], ComboMultiSelectedLabelComponent);
ComboMultiSelectedLabelComponent.ɵfac = function ComboMultiSelectedLabelComponent_Factory(t) { return new (t || ComboMultiSelectedLabelComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations)); };
ComboMultiSelectedLabelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ComboMultiSelectedLabelComponent, selectors: [["label", "cdsComboMultiSelectedLabel", ""]], inputs: { combo: ["cdsComboMultiSelectedLabel", "combo"], titleLabel: "titleLabel", allLabel: "allLabel" }, features: [ɵngcc0.ɵɵProvidersFeature([
            DynamicTranslations,
        ]), ɵngcc0.ɵɵNgOnChangesFeature], attrs: _c18, decls: 4, vars: 4, consts: [["class", "label-title", 4, "ngIf"], ["class", "label-desc", 4, "ngIf"], [1, "label-title"], [1, "label-desc"]], template: function ComboMultiSelectedLabelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ComboMultiSelectedLabelComponent_span_0_Template, 2, 1, "span", 0);
        ɵngcc0.ɵɵtemplate(1, ComboMultiSelectedLabelComponent_span_1_Template, 2, 1, "span", 1);
        ɵngcc0.ɵɵtemplate(2, ComboMultiSelectedLabelComponent_span_2_Template, 2, 1, "span", 1);
        ɵngcc0.ɵɵtemplate(3, ComboMultiSelectedLabelComponent_span_3_Template, 2, 3, "span", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.titleLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.allLabel && ctx.combo.selectedCount === 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.combo.selectedCount === 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.combo.selectedCount > 1);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ComboMultiSelectedLabelComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line component-selector
                selector: 'label[cdsComboMultiSelectedLabel]',
                template: "<span class=\"label-title\" *ngIf=\"titleLabel\">{{titleLabel}}</span>\n<span class=\"label-desc\" *ngIf=\"allLabel && combo.selectedCount === 0\">{{allLabel}}</span>\n<span class=\"label-desc\" *ngIf=\"combo.selectedCount === 1\">{{combo.selectedLabel}}</span>\n<span class=\"label-desc\" *ngIf=\"combo.selectedCount > 1\">{{translations.selected}}: {{combo.selectedCount}} / {{combo.totalCount}}</span>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                providers: [
                    DynamicTranslations,
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.NgZone }, { type: DynamicTranslations }]; }, { combo: [{
            type: Input,
            args: ['cdsComboMultiSelectedLabel']
        }], titleLabel: [{
            type: Input
        }], allLabel: [{
            type: Input
        }] }); })();
    return ComboMultiSelectedLabelComponent;
}());

var ComboSearchDirective = /** @class */ (function () {
    function ComboSearchDirective(elementRef, renderer, comboItem, combo) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.comboItem = comboItem;
        this.combo = combo;
        this.results$ = new Subject();
    }
    ComboSearchDirective.prototype.ngOnInit = function () {
        var _this = this;
        setTimeout(function () {
            var isHidden = window.getComputedStyle(_this.elementRef.nativeElement).display === 'none';
            _this.combo.onItemVisibilityChange(_this.comboItem, !isHidden);
        });
    };
    ComboSearchDirective.prototype.ngOnChanges = function (changes) {
        if ('results' in changes) {
            var nativeElement = this.elementRef.nativeElement;
            var isHidden = window.getComputedStyle(nativeElement).display === 'none';
            if (this.results == null && !isHidden) {
                this.renderer.setStyle(nativeElement, 'display', 'none');
                this.combo.onItemVisibilityChange(this.comboItem, false);
            }
            else if (isHidden) {
                this.renderer.removeStyle(nativeElement, 'display');
                this.combo.onItemVisibilityChange(this.comboItem, true);
            }
            this.results$.next(this.results);
        }
    };
    ComboSearchDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ComboItemDirective, decorators: [{ type: Host }, { type: Inject, args: [forwardRef(function () { return ComboItemDirective; }),] }] },
        { type: undefined, decorators: [{ type: Host }, { type: Inject, args: [forwardRef(function () { return COMBO_ITEM_HOST; }),] }] }
    ]; };
    __decorate([
        Input('cdsComboSearch'),
        __metadata("design:type", Object)
    ], ComboSearchDirective.prototype, "results", void 0);
    ComboSearchDirective = __decorate([ __param(2, Host()), __param(2, Inject(forwardRef(function () { return ComboItemDirective; }))),
        __param(3, Host()), __param(3, Inject(forwardRef(function () { return COMBO_ITEM_HOST; }))),
        __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            ComboItemDirective, Object])
    ], ComboSearchDirective);
ComboSearchDirective.ɵfac = function ComboSearchDirective_Factory(t) { return new (t || ComboSearchDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(forwardRef(function () { return ComboItemDirective; }), 1), ɵngcc0.ɵɵdirectiveInject(forwardRef(function () { return COMBO_ITEM_HOST; }), 1)); };
ComboSearchDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ComboSearchDirective, selectors: [["", "cdsComboSearch", ""]], inputs: { results: ["cdsComboSearch", "results"] }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ComboSearchDirective, [{
        type: Directive,
        args: [{ selector: '[cdsComboSearch]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ComboItemDirective, decorators: [{
                type: Host
            }, {
                type: Inject,
                args: [forwardRef(function () { return ComboItemDirective; })]
            }] }, { type: undefined, decorators: [{
                type: Host
            }, {
                type: Inject,
                args: [forwardRef(function () { return COMBO_ITEM_HOST; })]
            }] }]; }, { results: [{
            type: Input,
            args: ['cdsComboSearch']
        }] }); })();
    return ComboSearchDirective;
}());

function markResults(text, phrases, activePhraseIndex) {
    if (activePhraseIndex === void 0) { activePhraseIndex = 0; }
    if (!phrases.length || activePhraseIndex === phrases.length) {
        return text;
    }
    var activePhrase = phrases[activePhraseIndex];
    return text
        .split(activePhrase)
        .map(function (textFragment) { return markResults(textFragment, phrases, activePhraseIndex + 1); })
        .join("<mark>" + activePhrase + "</mark>");
}
var ComboSearchHighlightDirective = /** @class */ (function () {
    function ComboSearchHighlightDirective(elementRef, renderer, comboSearch) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.comboSearch = comboSearch;
        this.text$ = new Subject();
        renderer.addClass(elementRef.nativeElement, 'cds-combo__search-highlight');
        this.subscription = combineLatest(comboSearch.results$, this.text$)
            .pipe(map(function (_a) {
            var _b = __read(_a, 2), results = _b[0], text = _b[1];
            return Array.isArray(results) && text
                ? markResults(text, results)
                : text;
        }), distinctUntilChanged())
            .subscribe(function (html) {
            renderer.setProperty(elementRef.nativeElement, 'innerHTML', html);
        });
    }
    ComboSearchHighlightDirective.prototype.ngOnChanges = function (changes) {
        if ('text' in changes) {
            this.text$.next(this.text);
        }
    };
    ComboSearchHighlightDirective.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.text$.complete();
    };
    ComboSearchHighlightDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ComboSearchDirective, decorators: [{ type: Inject, args: [forwardRef(function () { return ComboSearchDirective; }),] }] }
    ]; };
    __decorate([
        Input('cdsComboSearchHighlight'),
        HostBinding('attr.aria-label'),
        __metadata("design:type", String)
    ], ComboSearchHighlightDirective.prototype, "text", void 0);
    ComboSearchHighlightDirective = __decorate([ __param(2, Inject(forwardRef(function () { return ComboSearchDirective; }))),
        __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            ComboSearchDirective])
    ], ComboSearchHighlightDirective);
ComboSearchHighlightDirective.ɵfac = function ComboSearchHighlightDirective_Factory(t) { return new (t || ComboSearchHighlightDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(forwardRef(function () { return ComboSearchDirective; }))); };
ComboSearchHighlightDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ComboSearchHighlightDirective, selectors: [["", "cdsComboSearchHighlight", ""]], hostVars: 1, hostBindings: function ComboSearchHighlightDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-label", ctx.text);
    } }, inputs: { text: ["cdsComboSearchHighlight", "text"] }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ComboSearchHighlightDirective, [{
        type: Directive,
        args: [{ selector: '[cdsComboSearchHighlight]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ComboSearchDirective, decorators: [{
                type: Inject,
                args: [forwardRef(function () { return ComboSearchDirective; })]
            }] }]; }, { text: [{
            type: Input,
            args: ['cdsComboSearchHighlight']
        }, {
            type: HostBinding,
            args: ['attr.aria-label']
        }] }); })();
    return ComboSearchHighlightDirective;
}());

var ComboSearchMatchAnyPipe = /** @class */ (function () {
    function ComboSearchMatchAnyPipe() {
    }
    ComboSearchMatchAnyPipe.prototype.transform = function (value, query, opts) {
        if (opts === void 0) { opts = {}; }
        if (value && query) {
            var caseSensitive_1 = opts.caseSensitive, separator = opts.separator, sort = opts.sort;
            var valuePhrase_1 = caseSensitive_1 ? value : value.toLowerCase();
            var queryPhrase = caseSensitive_1 ? query : query.toLowerCase();
            var splitPhrases = queryPhrase.split(separator != null ? separator : ' ');
            var matchResults_1 = [];
            splitPhrases.forEach(function (phrase) {
                if (phrase !== '') {
                    var index = valuePhrase_1.indexOf(phrase);
                    if (index !== -1) {
                        matchResults_1.push(caseSensitive_1 ? phrase : value.substr(index, phrase.length));
                    }
                }
            });
            if (matchResults_1.length) {
                return sort === false ? matchResults_1 : matchResults_1.sort(function (a, b) { return b.length - a.length; });
            }
            return null;
        }
        return true;
    };
ComboSearchMatchAnyPipe.ɵfac = function ComboSearchMatchAnyPipe_Factory(t) { return new (t || ComboSearchMatchAnyPipe)(); };
ComboSearchMatchAnyPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "cdsComboSearchMatchAny", type: ComboSearchMatchAnyPipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ComboSearchMatchAnyPipe, [{
        type: Pipe,
        args: [{
                name: 'cdsComboSearchMatchAny'
            }]
    }], function () { return []; }, null); })();
    return ComboSearchMatchAnyPipe;
}());

var ComboSearchMatchPipe = /** @class */ (function () {
    function ComboSearchMatchPipe() {
    }
    ComboSearchMatchPipe.prototype.transform = function (value, query, opts) {
        if (opts === void 0) { opts = {}; }
        if (value && query) {
            var caseSensitive = opts.caseSensitive;
            var valuePhrase = caseSensitive ? value : value.toLowerCase();
            var queryPhrase = caseSensitive ? query : query.toLowerCase();
            var index = valuePhrase.indexOf(queryPhrase);
            if (index !== -1) {
                return [value.substr(index, queryPhrase.length)];
            }
            return null;
        }
        return true;
    };
ComboSearchMatchPipe.ɵfac = function ComboSearchMatchPipe_Factory(t) { return new (t || ComboSearchMatchPipe)(); };
ComboSearchMatchPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "cdsComboSearchMatch", type: ComboSearchMatchPipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ComboSearchMatchPipe, [{
        type: Pipe,
        args: [{
                name: 'cdsComboSearchMatch'
            }]
    }], function () { return []; }, null); })();
    return ComboSearchMatchPipe;
}());

var COMBO_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return ComboComponent; }),
    multi: true,
};
var COMBO_ITEM_HOST_PROVIDER$1 = {
    provide: COMBO_ITEM_HOST,
    useExisting: forwardRef(function () { return ComboComponent; }),
};
var ComboComponent = /** @class */ (function (_super) {
    __extends(ComboComponent, _super);
    function ComboComponent(tabindex, elementRef, renderer, cdRef, componentTranslations) {
        var _this = _super.call(this, tabindex, cdRef, renderer, elementRef) || this;
        _this.elementRef = elementRef;
        _this.focusActive = true;
        _this.confirmButtons = false;
        _this.uncheckable = false;
        _this.items = [];
        _this.modelValue = null;
        _this.activeItem = null;
        _this.selectedLabel = null;
        _this._selectedCount = 0;
        _this.allowUnregisterItem = true;
        renderer.addClass(elementRef.nativeElement, 'cds-control');
        renderer.addClass(elementRef.nativeElement, 'cds-combo');
        componentTranslations.use(CDS_COMBO_TRANSLATIONS, comboTranslationsFactory, function (translations) {
            _this.translations = translations;
        });
        _this.changes$.subscribe(function () {
            cdRef.detectChanges();
        });
        return _this;
    }
    Object.defineProperty(ComboComponent.prototype, "controlFocus", {
        get: function () {
            return this.isFocus || this.isOpen;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboComponent.prototype, "controlActiveLabel", {
        get: function () {
            return this.selectedCount !== 0 || !!this.placeholder || (this.withSearchInline && this.isOpen);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboComponent.prototype, "isNotEmpty", {
        get: function () {
            var modelValue = this.modelValue;
            return modelValue != null && modelValue !== '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboComponent.prototype, "selectedCount", {
        get: function () {
            return this._selectedCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboComponent.prototype, "totalCount", {
        get: function () {
            return this.items.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComboComponent.prototype, "completeButtonLabel", {
        get: function () {
            return this.buttonLabel || (this.labelValue || this.translations.buttonLabel) + " " + this.getSelectedLabel();
        },
        enumerable: true,
        configurable: true
    });
    ComboComponent.prototype.getSelectedLabel = function () {
        return this.selectedCount
            ? this.translations.selectedSingle.replace('{{1}}', this.selectedLabel)
            : this.translations.selectedNothing;
    };
    ComboComponent.prototype.setActiveItem = function (item) {
        this.selectedLabel =
            item.labelValue !== undefined ? item.labelValue : item.value;
        if (item === this.activeItem) {
            return;
        }
        if (this.activeItem) {
            this.activeItem.setActive(false);
        }
        this.activeItem = item;
        this.activeItem.setActive(true);
        this._selectedCount = 1;
        this.changesSubject$.next(this);
    };
    ComboComponent.prototype.unsetActiveItem = function () {
        if (this.activeItem) {
            this.activeItem.setActive(false);
        }
        this.activeItem = null;
        this.selectedLabel = null;
        this._selectedCount = 0;
        this.changesSubject$.next(this);
    };
    ComboComponent.prototype.writeValue = function (value) {
        this.cdRef.markForCheck();
        this.modelValue = value;
        if (this.activeItem) {
            if (this.isEqual(this.activeItem.value, value)) {
                this.selectedLabel =
                    this.activeItem.labelValue !== undefined
                        ? this.activeItem.labelValue
                        : this.activeItem.value;
                this.changesSubject$.next(this);
                return;
            }
        }
        var item = this.findItem(value);
        if (item) {
            this.setActiveItem(item);
            return;
        }
        this.unsetActiveItem();
    };
    ComboComponent.prototype.findItem = function (value) {
        var e_1, _a;
        try {
            for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                var item = _c.value;
                if (this.isEqual(item.value, value)) {
                    return item;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return null;
    };
    ComboComponent.prototype.onItemClick = function (event, item) {
        if (!item.disabled) {
            if (item && !item.isActive) {
                this.setActiveItem(item);
                this.modelValue = item.value;
                this.onChangeCallback(item.value);
            }
            else if (this.uncheckable) {
                this.unsetActiveItem();
                this.modelValue = null;
                this.onChangeCallback(null);
            }
            this.close();
            event.stopPropagation();
            event.preventDefault();
        }
        this.cdRef.markForCheck();
    };
    ComboComponent.prototype.onItemVisibilityChange = function () {
        this.scheduleUpdate();
    };
    ComboComponent.prototype.scheduleUpdate = function () {
        if (this.dropdown) {
            this.dropdown.scheduleUpdate();
        }
    };
    ComboComponent.prototype.clear = function () {
        this.modelValue = null;
        this.unsetActiveItem();
        this.onChangeCallback(null);
    };
    ComboComponent.prototype.registerItem = function (item) {
        this.items.push(item);
        if (this.activeItem == null && this.modelValue != null) {
            if (this.isEqual(item.value, this.modelValue)) {
                this.setActiveItem(item);
            }
        }
    };
    ComboComponent.prototype.unregisterItem = function (item) {
        if (this.allowUnregisterItem) {
            var idx = this.items.indexOf(item);
            if (idx !== -1) {
                this.items.splice(idx, 1);
            }
            if (this.activeItem != null) {
                if (this.isEqual(item.value, this.activeItem.value)) {
                    this.unsetActiveItem();
                    this.modelValue = null;
                    this.onChangeCallback(null);
                }
            }
        }
    };
    ComboComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    ComboComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.allowUnregisterItem = false;
    };
    /* Functions required by template but not used in simple combo */
    ComboComponent.prototype.resetChanges = function () { };
    ComboComponent.prototype.confirmChanges = function () { };
    ComboComponent.ctorParameters = function () { return [
        { type: String, decorators: [{ type: Attribute, args: ['tabindex',] }] },
        { type: ElementRef },
        { type: Renderer2 },
        { type: ChangeDetectorRef },
        { type: DynamicTranslations }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], ComboComponent.prototype, "uncheckable", void 0);
    __decorate([
        ViewChild('dropdown'),
        __metadata("design:type", DropdownComponent)
    ], ComboComponent.prototype, "dropdown", void 0);
    __decorate([
        HostBinding('class.cds-control--focus'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ComboComponent.prototype, "controlFocus", null);
    __decorate([
        HostBinding('class.cds-control--active-label'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ComboComponent.prototype, "controlActiveLabel", null);
    __decorate([
        HostBinding('class.cds-control--not-empty'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ComboComponent.prototype, "isNotEmpty", null);
    ComboComponent = __decorate([ __param(0, Attribute('tabindex')),
        __metadata("design:paramtypes", [String, ElementRef,
            Renderer2,
            ChangeDetectorRef,
            DynamicTranslations])
    ], ComboComponent);
ComboComponent.ɵfac = function ComboComponent_Factory(t) { return new (t || ComboComponent)(ɵngcc0.ɵɵinjectAttribute('tabindex'), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations)); };
ComboComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ComboComponent, selectors: [["cds-combo"]], viewQuery: function ComboComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c14, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
    } }, hostVars: 6, hostBindings: function ComboComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("cds-control--focus", ctx.controlFocus)("cds-control--active-label", ctx.controlActiveLabel)("cds-control--not-empty", ctx.isNotEmpty);
    } }, inputs: { uncheckable: "uncheckable" }, features: [ɵngcc0.ɵɵProvidersFeature([COMBO_CONTROL_VALUE_ACCESSOR, COMBO_ITEM_HOST_PROVIDER$1, DynamicTranslations]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c17, decls: 15, vars: 11, consts: [["aria-hidden", "true", 1, "cds-control__container", "cds-zero-width-space"], ["cdsViewRef", ""], ["labelContent", "", "labelContentRef", "cdsViewRef"], ["valueContent", ""], ["role", "button", "aria-haspopup", "listbox", 1, "cds-combo__caret", 3, "focus", "blur"], ["aria-hidden", "true", 1, "cds-icon-angle-down"], [1, "cds-control__content"], ["class", "cds-control__label", "aria-hidden", "true", 4, "ngIf"], ["withoutSearchInline", ""], [4, "ngIf", "ngIfElse"], [3, "anchor", "initialFocus", "cds-dropdown--auto-height", "dismiss", "click", "keydown", 4, "ngIf"], ["aria-hidden", "true", 1, "cds-control__label"], [1, "cds-control__label-text"], [4, "ngTemplateOutlet"], [4, "ngIf"], ["aria-hidden", "true", "class", "cds-control__value", 4, "ngIf"], ["aria-hidden", "true", "class", "cds-control__placeholder", 4, "ngIf"], ["aria-hidden", "true", "appearance", "control", "tabindex", "-1", 1, "cds-chip-small", 3, "ngModel", "uncheckable", "removable", "remove"], ["aria-hidden", "true", 1, "cds-control__value"], ["aria-hidden", "true", 1, "cds-control__placeholder"], [1, "cds-control__value", 3, "ngModel", "ngModelChange", "keydown.enter", "blur"], ["searchInline", ""], [3, "anchor", "initialFocus", "dismiss", "click", "keydown"], ["dropdown", ""], ["dropdownOptions", ""], ["searchInsideDropdown", ""], ["class", "cds-combo__search-inside", 3, "cdsDropdownDisableKeydown", 4, "ngIf"], [1, "cds-combo__search-inside", 3, "cdsDropdownDisableKeydown"], [3, "resettable", "ngModel", "ariaLabel", "ngModelChange", "keydown.enter", "blur"], ["searchInside", ""], [1, "cds-icon-search", "cds-icon--placement-before", "cds-combo__search-icon"], [1, "cds-combo__scrollable-content"], [1, "cds-combo__confirm-buttons"], ["cdsButton", "", "type", "button", 1, "cds-button-text", 3, "click"]], template: function ComboComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c16);
        ɵngcc0.ɵɵelement(0, "span", 0);
        ɵngcc0.ɵɵtemplate(1, ComboComponent_ng_template_1_Template, 1, 0, "ng-template", 1, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(4, ComboComponent_ng_template_4_Template, 1, 0, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(6, "i", 4);
        ɵngcc0.ɵɵlistener("focus", function ComboComponent_Template_i_focus_6_listener($event) { return ctx.onButtonFocus($event, true); })("blur", function ComboComponent_Template_i_blur_6_listener($event) { return ctx.onButtonFocus($event, false); });
        ɵngcc0.ɵɵelement(7, "span", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵtemplate(9, ComboComponent_div_9_Template, 3, 1, "div", 7);
        ɵngcc0.ɵɵtemplate(10, ComboComponent_div_10_Template, 3, 1, "div", 7);
        ɵngcc0.ɵɵtemplate(11, ComboComponent_ng_template_11_Template, 4, 4, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(13, ComboComponent_ng_container_13_Template, 3, 2, "ng-container", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(14, ComboComponent_cds_dropdown_14_Template, 7, 7, "cds-dropdown", 10);
    } if (rf & 2) {
        var _r1 = ɵngcc0.ɵɵreference(3);
        var _r7 = ɵngcc0.ɵɵreference(12);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵclassProp("cds-combo__caret--open", ctx.isOpen);
        ɵngcc0.ɵɵattribute("tabindex", ctx.attrTabindex)("aria-disabled", ctx.isDisabled)("aria-expanded", !!ctx.isOpen)("aria-label", ctx.completeButtonLabel);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.labelValue);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.labelValue && _r1.hasChildren);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.withSearchInline && ctx.isOpen)("ngIfElse", _r7);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isOpen);
    } }, directives: function () { return [ViewRefDirective, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ChipComponent, ChipRippleDirective, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.DefaultValueAccessor, DropdownComponent, DropdownDisableKeydownDirective, InputComponent, ButtonRippleDirective]; }, encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ComboComponent, [{
        type: Component,
        args: [{
                selector: 'cds-combo',
                template: "<span class=\"cds-control__container cds-zero-width-space\" aria-hidden=\"true\"></span>\n<ng-template #labelContent #labelContentRef=\"cdsViewRef\" cdsViewRef><ng-content select=\"label[title]\"></ng-content></ng-template>\n<ng-template #valueContent><ng-content select=\"label:not([default]):not([title])\"></ng-content></ng-template>\n<i class=\"cds-combo__caret\" [class.cds-combo__caret--open]=\"isOpen\"\n   role=\"button\"\n   aria-haspopup=\"listbox\"\n   (focus)=\"onButtonFocus($event, true)\"\n   (blur)=\"onButtonFocus($event, false)\"\n   [attr.tabindex]=\"attrTabindex\"\n   [attr.aria-disabled]=\"isDisabled\"\n   [attr.aria-expanded]=\"!!isOpen\"\n   [attr.aria-label]=\"completeButtonLabel\">\n\t<span class=\"cds-icon-angle-down\" aria-hidden=\"true\"></span>\n</i>\n<div class=\"cds-control__content\">\n\t<div class=\"cds-control__label\" aria-hidden=\"true\" *ngIf=\"labelValue\">\n\t\t<div class=\"cds-control__label-text\">{{labelValue}}</div>\n\t</div>\n\t<div class=\"cds-control__label\" aria-hidden=\"true\" *ngIf=\"!labelValue && labelContentRef.hasChildren\">\n\t\t<div class=\"cds-control__label-text\"><ng-container *ngTemplateOutlet=\"labelContent\"></ng-container></div>\n\t</div>\n\t<ng-template #withoutSearchInline>\n\t\t<ng-container *ngIf=\"chips && selectedCount !== 0\" >\n\t\t\t<cds-chip aria-hidden=\"true\" [ngModel]=\"true\" class=\"cds-chip-small\" appearance=\"control\" [uncheckable]=\"false\" [removable]=\"true\" (remove)=\"clear()\" tabindex=\"-1\">\n\t\t\t\t<ng-container *ngTemplateOutlet=\"valueContent\"></ng-container>\n\t\t\t</cds-chip>\n\t\t</ng-container>\n\t\t<div *ngIf=\"!chips && selectedCount !== 0\" aria-hidden=\"true\" class=\"cds-control__value\">\n\t\t\t<ng-container *ngTemplateOutlet=\"valueContent\"></ng-container>\n\t\t\t<!-- fix an issue where there's always have to be non empty value or placeholder -->&#8203;\n\t\t</div>\n\t\t<div *ngIf=\"placeholder && selectedCount === 0\" aria-hidden=\"true\" class=\"cds-control__placeholder\">\n\t\t\t{{placeholder}}\n\t\t</div>\n\t\t<div *ngIf=\"!placeholder && selectedCount === 0\" aria-hidden=\"true\" class=\"cds-control__placeholder\">\n\t\t\t<ng-content select=\"label[default],label[all]\"></ng-content>\n\t\t\t<!-- fix an issue where there's always have to be non empty value or placeholder -->&#8203;\n\t\t</div>\n\t</ng-template>\n\n\t<ng-container *ngIf=\"withSearchInline && isOpen; else withoutSearchInline\">\n\t\t<input #searchInline class=\"cds-control__value\" [attr.aria-label]=\"inputLabel || translations.inputLabel\" [ngModel]=\"search\" (ngModelChange)=\"search$.next($event)\" (keydown.enter)=\"$event.preventDefault()\" (blur)=\"onSearchFieldBlur($event.relatedTarget)\" />\n\t</ng-container>\n</div>\n<cds-dropdown #dropdown *ngIf=\"isOpen\" (dismiss)=\"onOpenChange(false)\" [anchor]=\"elementRef\"\n              [initialFocus]=\"!withSearchInside && !withSearchInline ? (focusActive ? ['li.active', 'li'] : 'li') : null\"\n              [class.cds-dropdown--auto-height]=\"confirmButtons\" (click)=\"onDropdownClick($event)\" (keydown)=\"onDropdownKey($event)\">\n\t<ng-template #dropdownOptions>\n\t\t<ng-content select=\"ul\"></ng-content>\n\t</ng-template>\n\t<ng-template #searchInsideDropdown>\n\t\t<div *ngIf=\"withSearchInside\" class=\"cds-combo__search-inside\" [cdsDropdownDisableKeydown]=\"disableKeydown\">\n\t\t\t<cds-input #searchInside [resettable]=\"true\" [ngModel]=\"search\" (ngModelChange)=\"search$.next($event)\" (keydown.enter)=\"$event.preventDefault()\" (blur)=\"onSearchFieldBlur($event.detail.relatedTarget)\" [ariaLabel]=\"inputLabel || translations.inputLabel\">\n\t\t\t\t<i class=\"cds-icon-search cds-icon--placement-before cds-combo__search-icon\"></i>\n\t\t\t</cds-input>\n\t\t</div>\n\t\t<ng-container *ngTemplateOutlet=\"dropdownOptions\"></ng-container>\n\t</ng-template>\n\t<ng-container *ngIf=\"confirmButtons || withSearchInside; else dropdownOptions\">\n\t\t<ng-container *ngIf=\"confirmButtons; else searchInsideDropdown\">\n\t\t\t<div class=\"cds-combo__scrollable-content\">\n\t\t\t\t<ng-container *ngTemplateOutlet=\"searchInsideDropdown\"></ng-container>\n\t\t\t</div>\n\t\t\t<div class=\"cds-combo__confirm-buttons\">\n\t\t\t\t<button cdsButton type=\"button\" (click)=\"resetChanges()\" class=\"cds-button-text\">{{translations.reset}}</button>\n\t\t\t\t<button cdsButton type=\"button\" (click)=\"confirmChanges()\" class=\"cds-button-text\">{{translations.confirm}}</button>\n\t\t\t</div>\n\t\t</ng-container>\n\t</ng-container>\n</cds-dropdown>\n",
                providers: [COMBO_CONTROL_VALUE_ACCESSOR, COMBO_ITEM_HOST_PROVIDER$1, DynamicTranslations],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Attribute,
                args: ['tabindex']
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: DynamicTranslations }]; }, { controlFocus: [{
            type: HostBinding,
            args: ['class.cds-control--focus']
        }], controlActiveLabel: [{
            type: HostBinding,
            args: ['class.cds-control--active-label']
        }], isNotEmpty: [{
            type: HostBinding,
            args: ['class.cds-control--not-empty']
        }], uncheckable: [{
            type: Input
        }], dropdown: [{
            type: ViewChild,
            args: ['dropdown']
        }] }); })();
    return ComboComponent;
}(AbstractCombo));

var A11yClickDirective = /** @class */ (function () {
    function A11yClickDirective() {
        this.cdsA11yClick = new EventEmitter();
    }
    A11yClickDirective.prototype.onClick = function (event) {
        this.cdsA11yClick.emit(event);
    };
    A11yClickDirective.prototype.onKeydown = function (event) {
        event.preventDefault();
        this.cdsA11yClick.emit(event);
    };
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], A11yClickDirective.prototype, "cdsA11yClick", void 0);
    __decorate([
        HostListener('click', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [MouseEvent]),
        __metadata("design:returntype", void 0)
    ], A11yClickDirective.prototype, "onClick", null);
    __decorate([
        HostListener('keydown.enter', ['$event']),
        HostListener('keydown.space', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [KeyboardEvent]),
        __metadata("design:returntype", void 0)
    ], A11yClickDirective.prototype, "onKeydown", null);
A11yClickDirective.ɵfac = function A11yClickDirective_Factory(t) { return new (t || A11yClickDirective)(); };
A11yClickDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: A11yClickDirective, selectors: [["", "cdsA11yClick", ""]], hostBindings: function A11yClickDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function A11yClickDirective_click_HostBindingHandler($event) { return ctx.onClick($event); })("keydown.enter", function A11yClickDirective_keydown_enter_HostBindingHandler($event) { return ctx.onKeydown($event); })("keydown.space", function A11yClickDirective_keydown_space_HostBindingHandler($event) { return ctx.onKeydown($event); });
    } }, outputs: { cdsA11yClick: "cdsA11yClick" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(A11yClickDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsA11yClick]'
            }]
    }], function () { return []; }, { cdsA11yClick: [{
            type: Output
        }], onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], onKeydown: [{
            type: HostListener,
            args: ['keydown.enter', ['$event']]
        }, {
            type: HostListener,
            args: ['keydown.space', ['$event']]
        }] }); })();
    return A11yClickDirective;
}());

var AriaControlSkipSelfDirective = /** @class */ (function () {
    function AriaControlSkipSelfDirective(control) {
        this.control = control;
    }
    AriaControlSkipSelfDirective.prototype.ngOnInit = function () {
        var _this = this;
        if (this.control != null) {
            this.subscription = this.control.statusChanges
                .pipe(startWith(this.control.status), distinctUntilChanged())
                .subscribe(function (status) {
                _this.ariaInvalid = status === 'INVALID';
            });
        }
    };
    AriaControlSkipSelfDirective.prototype.ngOnDestroy = function () {
        this.subscription && this.subscription.unsubscribe();
    };
    AriaControlSkipSelfDirective.ctorParameters = function () { return [
        { type: NgControl, decorators: [{ type: SkipSelf }, { type: Optional }] }
    ]; };
    __decorate([
        HostBinding('attr.aria-invalid'),
        __metadata("design:type", Boolean)
    ], AriaControlSkipSelfDirective.prototype, "ariaInvalid", void 0);
    AriaControlSkipSelfDirective = __decorate([ __param(0, SkipSelf()), __param(0, Optional()),
        __metadata("design:paramtypes", [NgControl])
    ], AriaControlSkipSelfDirective);
AriaControlSkipSelfDirective.ɵfac = function AriaControlSkipSelfDirective_Factory(t) { return new (t || AriaControlSkipSelfDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgControl, 12)); };
AriaControlSkipSelfDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AriaControlSkipSelfDirective, selectors: [["", "cdsAriaControlSkipSelf", ""]], hostVars: 1, hostBindings: function AriaControlSkipSelfDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-invalid", ctx.ariaInvalid);
    } } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AriaControlSkipSelfDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsAriaControlSkipSelf]'
            }]
    }], function () { return [{ type: ɵngcc3.NgControl, decorators: [{
                type: SkipSelf
            }, {
                type: Optional
            }] }]; }, { ariaInvalid: [{
            type: HostBinding,
            args: ['attr.aria-invalid']
        }] }); })();
    return AriaControlSkipSelfDirective;
}());

var AccessibilityModule = /** @class */ (function () {
    function AccessibilityModule() {
    }
AccessibilityModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AccessibilityModule });
AccessibilityModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AccessibilityModule_Factory(t) { return new (t || AccessibilityModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AccessibilityModule, { declarations: [AriaControlSkipSelfDirective, A11yClickDirective], exports: [AriaControlSkipSelfDirective, A11yClickDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AccessibilityModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    AriaControlSkipSelfDirective,
                    A11yClickDirective,
                ],
                exports: [
                    AriaControlSkipSelfDirective,
                    A11yClickDirective,
                ]
            }]
    }], function () { return []; }, null); })();
    return AccessibilityModule;
}());

var InputModule = /** @class */ (function () {
    function InputModule() {
    }
InputModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: InputModule });
InputModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function InputModule_Factory(t) { return new (t || InputModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            RippleModule,
            AccessibilityModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(InputModule, { declarations: function () { return [InputComponent]; }, imports: function () { return [CommonModule,
        FormsModule, RippleModule, AccessibilityModule]; }, exports: function () { return [InputComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(InputModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    RippleModule,
                    AccessibilityModule,
                ],
                declarations: [
                    InputComponent,
                ],
                exports: [
                    InputComponent,
                ]
            }]
    }], function () { return []; }, null); })();
    return InputModule;
}());

var ViewRefDirective = /** @class */ (function () {
    function ViewRefDirective(template) {
        this.destroyed = false;
        this._view = null;
        this.createView(template);
    }
    Object.defineProperty(ViewRefDirective.prototype, "view", {
        get: function () {
            return this._view;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewRefDirective.prototype, "hasChildren", {
        get: function () {
            /* VE returns additional comment node angular#37237 */
            return this._view && this._view.rootNodes.length > (ɵivyEnabled ? 0 : 1);
        },
        enumerable: true,
        configurable: true
    });
    ViewRefDirective.prototype.ngOnDestroy = function () {
        this.destroyed = true;
    };
    ViewRefDirective.prototype.createView = function (template) {
        var _this = this;
        if (this.destroyed) {
            return;
        }
        if (this._view && !this._view.destroyed) {
            this._view.destroy();
        }
        this._view = template.createEmbeddedView({});
        this._view.onDestroy(function () {
            _this._view = null;
            _this.createView(template);
        });
    };
    ViewRefDirective.ctorParameters = function () { return [
        { type: TemplateRef, decorators: [{ type: Inject, args: [TemplateRef,] }] }
    ]; };
    ViewRefDirective = __decorate([ __param(0, Inject(TemplateRef)),
        __metadata("design:paramtypes", [TemplateRef])
    ], ViewRefDirective);
ViewRefDirective.ɵfac = function ViewRefDirective_Factory(t) { return new (t || ViewRefDirective)(ɵngcc0.ɵɵdirectiveInject(TemplateRef)); };
ViewRefDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ViewRefDirective, selectors: [["", "cdsViewRef", ""]], exportAs: ["cdsViewRef"] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ViewRefDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsViewRef]',
                exportAs: 'cdsViewRef'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef, decorators: [{
                type: Inject,
                args: [TemplateRef]
            }] }]; }, null); })();
    return ViewRefDirective;
}());

var ComboModule = /** @class */ (function () {
    function ComboModule() {
    }
ComboModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ComboModule });
ComboModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ComboModule_Factory(t) { return new (t || ComboModule)(); }, imports: [[
            CommonModule,
            DropdownModule,
            FormsModule,
            ButtonModule,
            CheckboxModule,
            ChipModule,
            InputModule,
            RippleModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ComboModule, { declarations: function () { return [ComboButtonComponent, ComboCheckboxItemAllComponent, ComboCheckboxItemComponent, ComboComponent, ComboItemAllComponent, ComboItemDirective, ComboItemModalDirective, ComboMultiComponent, ComboMultiSelectedLabelComponent, ComboSearchDirective, ComboSearchHighlightDirective, ComboSearchMatchAnyPipe, ComboSearchMatchPipe, ViewRefDirective]; }, imports: function () { return [CommonModule, DropdownModule, FormsModule, ButtonModule, CheckboxModule, ChipModule, InputModule, RippleModule]; }, exports: function () { return [ComboButtonComponent, ComboComponent, ComboCheckboxItemAllComponent, ComboItemAllComponent, ComboItemDirective, ComboItemModalDirective, ComboMultiComponent, ComboCheckboxItemComponent, ComboMultiSelectedLabelComponent, ComboSearchMatchPipe, ComboSearchDirective, ComboSearchHighlightDirective, ComboSearchMatchAnyPipe]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ComboModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    DropdownModule,
                    FormsModule,
                    ButtonModule,
                    CheckboxModule,
                    ChipModule,
                    InputModule,
                    RippleModule,
                ],
                declarations: [
                    ComboButtonComponent,
                    ComboCheckboxItemAllComponent,
                    ComboCheckboxItemComponent,
                    ComboComponent,
                    ComboItemAllComponent,
                    ComboItemDirective,
                    ComboItemModalDirective,
                    ComboMultiComponent,
                    ComboMultiSelectedLabelComponent,
                    ComboSearchDirective,
                    ComboSearchHighlightDirective,
                    ComboSearchMatchAnyPipe,
                    ComboSearchMatchPipe,
                    ViewRefDirective,
                ],
                exports: [
                    ComboButtonComponent,
                    ComboComponent,
                    ComboCheckboxItemAllComponent,
                    ComboItemAllComponent,
                    ComboItemDirective,
                    ComboItemModalDirective,
                    ComboMultiComponent,
                    ComboCheckboxItemComponent,
                    ComboMultiSelectedLabelComponent,
                    ComboSearchMatchPipe,
                    ComboSearchDirective,
                    ComboSearchHighlightDirective,
                    ComboSearchMatchAnyPipe,
                ]
            }]
    }], function () { return []; }, null); })();
    return ComboModule;
}());

var SelectedLabelModelImpl = /** @class */ (function () {
    function SelectedLabelModelImpl(totalCount) {
        this.selectedLabel = null;
        this.selectedCount = 0;
        this.totalCount = 0;
        this.totalCount = totalCount;
    }
    SelectedLabelModelImpl.prototype.update = function (items, labelGetter) {
        var length = items && items.length;
        if (length) {
            if (length === 1) {
                this.selectedLabel = labelGetter(items[0]);
            }
            else {
                this.selectedLabel = null;
            }
            this.selectedCount = length;
            return;
        }
        this.selectedLabel = null;
        this.selectedCount = 0;
    };
    return SelectedLabelModelImpl;
}());

var OnEscapeService = /** @class */ (function () {
    function OnEscapeService() {
    }
    OnEscapeService.prototype.scheduleAction = function (action) {
        var _this = this;
        if (!this.action) {
            setTimeout(function () {
                if (_this.action) {
                    var currentAction = _this.action;
                    _this.action = null;
                    currentAction();
                }
            });
        }
        this.action = action;
    };
    OnEscapeService.ɵprov = ɵɵdefineInjectable({ factory: function OnEscapeService_Factory() { return new OnEscapeService(); }, token: OnEscapeService, providedIn: "root" });
OnEscapeService.ɵfac = function OnEscapeService_Factory(t) { return new (t || OnEscapeService)(); };
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(OnEscapeService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
    return OnEscapeService;
}());

var OnEscapeDirective = /** @class */ (function () {
    function OnEscapeDirective(onEscapeService) {
        this.onEscapeService = onEscapeService;
        this.escape = new EventEmitter();
    }
    OnEscapeDirective.prototype.onEscape = function () {
        var _this = this;
        this.onEscapeService.scheduleAction(function () {
            _this.escape.emit();
        });
    };
    OnEscapeDirective.ctorParameters = function () { return [
        { type: OnEscapeService }
    ]; };
    __decorate([
        Output('cdsOnEscape'),
        __metadata("design:type", EventEmitter)
    ], OnEscapeDirective.prototype, "escape", void 0);
    __decorate([
        HostListener('window:keyup.esc'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], OnEscapeDirective.prototype, "onEscape", null);
    OnEscapeDirective = __decorate([ __metadata("design:paramtypes", [OnEscapeService])
    ], OnEscapeDirective);
OnEscapeDirective.ɵfac = function OnEscapeDirective_Factory(t) { return new (t || OnEscapeDirective)(ɵngcc0.ɵɵdirectiveInject(OnEscapeService)); };
OnEscapeDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: OnEscapeDirective, selectors: [["", "cdsOnEscape", ""]], hostBindings: function OnEscapeDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keyup.esc", function OnEscapeDirective_keyup_esc_HostBindingHandler() { return ctx.onEscape(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, outputs: { escape: "cdsOnEscape" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(OnEscapeDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsOnEscape]'
            }]
    }], function () { return [{ type: OnEscapeService }]; }, { escape: [{
            type: Output,
            args: ['cdsOnEscape']
        }], onEscape: [{
            type: HostListener,
            args: ['window:keyup.esc']
        }] }); })();
    return OnEscapeDirective;
}());

var OnEscapeModule = /** @class */ (function () {
    function OnEscapeModule() {
    }
OnEscapeModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: OnEscapeModule });
OnEscapeModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function OnEscapeModule_Factory(t) { return new (t || OnEscapeModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(OnEscapeModule, { declarations: [OnEscapeDirective], exports: [OnEscapeDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(OnEscapeModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    OnEscapeDirective,
                ],
                exports: [
                    OnEscapeDirective,
                ]
            }]
    }], function () { return []; }, null); })();
    return OnEscapeModule;
}());

var SlotsDirective = /** @class */ (function () {
    function SlotsDirective() {
    }
SlotsDirective.ɵfac = function SlotsDirective_Factory(t) { return new (t || SlotsDirective)(); };
SlotsDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: SlotsDirective, selectors: [["cds-slot-title"], ["cds-slot-content"], ["cds-slot-footer"]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SlotsDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'cds-slot-title,cds-slot-content,cds-slot-footer'
            }]
    }], function () { return []; }, null); })();
    return SlotsDirective;
}());

var SlotsModule = /** @class */ (function () {
    function SlotsModule() {
    }
SlotsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SlotsModule });
SlotsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SlotsModule_Factory(t) { return new (t || SlotsModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SlotsModule, { declarations: [SlotsDirective], exports: [SlotsDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SlotsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SlotsDirective,
                ],
                exports: [
                    SlotsDirective,
                ]
            }]
    }], function () { return []; }, null); })();
    return SlotsModule;
}());

var CDS_FOCUS_TRAP = new InjectionToken('CDS_FOCUS_TRAP');
// This function should be tree-shaken.
// It exists to assert that our custom types are compatible with the focus-trap version that is installed.
function focusTrapAssert(focusTrapFn) {
    var customFocusTrapFn = focusTrapFn;
}

var DIALOG_TRANSLATIONS_EN = {
    close: 'Close dialog',
};
function dialogTranslationsFactory() {
    return DIALOG_TRANSLATIONS_EN;
}
var CDS_DIALOG_TRANSLATIONS = new InjectionToken('CDS_DIALOG_TRANSLATIONS', { factory: dialogTranslationsFactory });

var DialogComponent = /** @class */ (function () {
    function DialogComponent(elementRef, renderer, componentTranslations, focusTrapFn) {
        var _this = this;
        this.elementRef = elementRef;
        this.focusTrapFn = focusTrapFn;
        this.disableFocusTrap = false;
        this.dialog = 'slide';
        this.dialogClose = new EventEmitter();
        this.backdropClose = new EventEmitter();
        this.dialogHeaderId = Unique.next('cds-dialog-header-');
        renderer.addClass(elementRef.nativeElement, 'cds-dialog');
        renderer.setAttribute(elementRef.nativeElement, 'aria-modal', 'true');
        renderer.setAttribute(elementRef.nativeElement, 'aria-labelledby', this.dialogHeaderId);
        componentTranslations.use(CDS_DIALOG_TRANSLATIONS, dialogTranslationsFactory, function (translations) {
            _this.translations = translations;
        });
    }
    Object.defineProperty(DialogComponent.prototype, "dark", {
        get: function () {
            return this.schema === 'dark';
        },
        enumerable: true,
        configurable: true
    });
    DialogComponent.prototype.ngAfterContentInit = function () {
        if (this.disableFocusTrap || !this.focusTrapFn) {
            return;
        }
        this.focusTrap = this.focusTrapFn(this.elementRef.nativeElement, {
            fallbackFocus: this.elementRef.nativeElement,
            escapeDeactivates: false,
        });
        this.focusTrap.activate();
    };
    DialogComponent.prototype.ngOnDestroy = function () {
        if (this.focusTrap) {
            this.focusTrap.deactivate();
        }
    };
    DialogComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: DynamicTranslations },
        { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [CDS_FOCUS_TRAP,] }] }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DialogComponent.prototype, "schema", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DialogComponent.prototype, "disableFocusTrap", void 0);
    __decorate([
        HostBinding('@dialog'),
        __metadata("design:type", String)
    ], DialogComponent.prototype, "dialog", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], DialogComponent.prototype, "dialogClose", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], DialogComponent.prototype, "backdropClose", void 0);
    __decorate([
        HostBinding('class.cds-dialog--header-dark'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], DialogComponent.prototype, "dark", null);
    DialogComponent = __decorate([ __param(3, Optional()), __param(3, Inject(CDS_FOCUS_TRAP)),
        __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            DynamicTranslations, Function])
    ], DialogComponent);
DialogComponent.ɵfac = function DialogComponent_Factory(t) { return new (t || DialogComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations), ɵngcc0.ɵɵdirectiveInject(CDS_FOCUS_TRAP, 8)); };
DialogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DialogComponent, selectors: [["cds-dialog"]], hostVars: 3, hostBindings: function DialogComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵsyntheticHostProperty("@dialog", ctx.dialog);
        ɵngcc0.ɵɵclassProp("cds-dialog--header-dark", ctx.dark);
    } }, inputs: { disableFocusTrap: "disableFocusTrap", schema: "schema" }, outputs: { dialogClose: "dialogClose", backdropClose: "backdropClose" }, features: [ɵngcc0.ɵɵProvidersFeature([
            DynamicTranslations,
        ])], ngContentSelectors: _c20, decls: 8, vars: 2, consts: [[1, "cds-dialog__window"], [1, "cds-dialog__content"], [1, "cds-dialog__header"], [4, "ngIf"], [1, "cds-dialog__backdrop", 3, "click"], ["cdsButton", "", 1, "cds-dialog__close-button", 3, "ngClass", "click"], [1, "cds-icon-close-big", "cds-icon--size-24"]], template: function DialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c19);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div");
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DialogComponent_ng_container_5_Template, 3, 2, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(6, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵlistener("click", function DialogComponent_Template_div_click_7_listener() { return ctx.backdropClose.emit(); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵattribute("id", ctx.dialogHeaderId);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.dialogClose.observers.length !== 0);
    } }, directives: [ɵngcc1.NgIf, ButtonRippleDirective, ɵngcc1.NgClass], encapsulation: 2, data: { animation: [
            trigger('dialog', [
                transition('void => slide', [
                    style({ opacity: 0 }),
                    query('.cds-dialog__window', style({ transform: 'translate(0, 20%)' })),
                    group([
                        animate('0.3s cubic-bezier(0.165, 0.84, 0.44, 1)', style({ opacity: 1 })),
                        query('.cds-dialog__window', animate('0.3s cubic-bezier(0.165, 0.84, 0.44, 1)', style({ transform: 'translate(0, 0)' }))),
                    ]),
                ]),
                transition('slide => void', [
                    style({ opacity: 1 }),
                    query('.cds-dialog__window', style({ transform: 'translate(0, 0)' })),
                    group([
                        animate('0.3s cubic-bezier(0.165, 0.84, 0.44, 1)', style({ opacity: 0 })),
                        query('.cds-dialog__window', animate('0.3s cubic-bezier(0.165, 0.84, 0.44, 1)', style({ transform: 'translate(0, -20%)' }))),
                    ]),
                ]),
            ]),
        ] }, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DialogComponent, [{
        type: Component,
        args: [{
                selector: 'cds-dialog',
                template: "<div class=\"cds-dialog__window\">\n\t<div class=\"cds-dialog__content\">\n\t\t<div class=\"cds-dialog__header\">\n\t\t\t<div [attr.id]=\"dialogHeaderId\">\n\t\t\t\t<ng-content select=\"header,cds-slot-title\"></ng-content>\n\t\t\t</div>\n\t\t\t<ng-container *ngIf=\"dialogClose.observers.length !== 0\">\n\t\t\t\t<button\n\t\t\t\t\tcdsButton\n\t\t\t\t\tclass=\"cds-dialog__close-button\"\n\t\t\t\t\t[ngClass]=\"schema === 'dark' ? 'cds-button-icon-dark' : 'cds-button-icon'\"\n\t\t\t\t\t(click)=\"dialogClose.emit()\"\n\t\t\t\t\t[attr.aria-label]=\"translations.close\">\n\t\t\t\t\t<i class=\"cds-icon-close-big cds-icon--size-24\"></i>\n\t\t\t\t</button>\n\t\t\t</ng-container>\n\t\t</div>\n\t\t<ng-content select=\":not(header):not(cds-slot-title)\"></ng-content>\n\t</div>\n</div>\n<div class=\"cds-dialog__backdrop\" (click)=\"backdropClose.emit()\"></div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                animations: [
                    trigger('dialog', [
                        transition('void => slide', [
                            style({ opacity: 0 }),
                            query('.cds-dialog__window', style({ transform: 'translate(0, 20%)' })),
                            group([
                                animate('0.3s cubic-bezier(0.165, 0.84, 0.44, 1)', style({ opacity: 1 })),
                                query('.cds-dialog__window', animate('0.3s cubic-bezier(0.165, 0.84, 0.44, 1)', style({ transform: 'translate(0, 0)' }))),
                            ]),
                        ]),
                        transition('slide => void', [
                            style({ opacity: 1 }),
                            query('.cds-dialog__window', style({ transform: 'translate(0, 0)' })),
                            group([
                                animate('0.3s cubic-bezier(0.165, 0.84, 0.44, 1)', style({ opacity: 0 })),
                                query('.cds-dialog__window', animate('0.3s cubic-bezier(0.165, 0.84, 0.44, 1)', style({ transform: 'translate(0, -20%)' }))),
                            ]),
                        ]),
                    ]),
                ],
                providers: [
                    DynamicTranslations,
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: DynamicTranslations }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [CDS_FOCUS_TRAP]
            }] }]; }, { disableFocusTrap: [{
            type: Input
        }], dialog: [{
            type: HostBinding,
            args: ['@dialog']
        }], dialogClose: [{
            type: Output
        }], backdropClose: [{
            type: Output
        }], dark: [{
            type: HostBinding,
            args: ['class.cds-dialog--header-dark']
        }], schema: [{
            type: Input
        }] }); })();
    return DialogComponent;
}());

var DialogModule = /** @class */ (function () {
    function DialogModule() {
    }
DialogModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DialogModule });
DialogModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DialogModule_Factory(t) { return new (t || DialogModule)(); }, imports: [[
            CommonModule,
            FormsModule,
            OnEscapeModule,
            PortalModule,
            ButtonModule,
            SlotsModule,
        ], OnEscapeModule, SlotsModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DialogModule, { declarations: function () { return [DialogComponent]; }, imports: function () { return [CommonModule,
        FormsModule, OnEscapeModule, PortalModule, ButtonModule, SlotsModule]; }, exports: function () { return [DialogComponent, OnEscapeModule, SlotsModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DialogModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    FormsModule,
                    OnEscapeModule,
                    PortalModule,
                    ButtonModule,
                    SlotsModule,
                ],
                declarations: [
                    DialogComponent,
                ],
                exports: [
                    DialogComponent,
                    // modules
                    OnEscapeModule,
                    SlotsModule,
                ]
            }]
    }], function () { return []; }, null); })();
    return DialogModule;
}());

var TooltipComponent = /** @class */ (function () {
    function TooltipComponent(elementRef, renderer) {
        this.arrow = false;
        this.fade = 'visible';
        renderer.addClass(elementRef.nativeElement, 'cds-tooltip');
        renderer.addClass(elementRef.nativeElement, 'cds-tooltip-z-index');
    }
    Object.defineProperty(TooltipComponent.prototype, "hiddenArrow", {
        get: function () {
            return !this.arrow;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TooltipComponent.prototype, "danger", {
        get: function () {
            return this.status === 'danger';
        },
        enumerable: true,
        configurable: true
    });
    TooltipComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], TooltipComponent.prototype, "arrow", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TooltipComponent.prototype, "status", void 0);
    __decorate([
        HostBinding('@fade'),
        __metadata("design:type", Object)
    ], TooltipComponent.prototype, "fade", void 0);
    __decorate([
        HostBinding('class.cds-tooltip--hidden-arrow'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], TooltipComponent.prototype, "hiddenArrow", null);
    __decorate([
        HostBinding('class.cds-tooltip--danger'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], TooltipComponent.prototype, "danger", null);
    TooltipComponent = __decorate([ __metadata("design:paramtypes", [ElementRef, Renderer2])
    ], TooltipComponent);
TooltipComponent.ɵfac = function TooltipComponent_Factory(t) { return new (t || TooltipComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
TooltipComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TooltipComponent, selectors: [["cds-tooltip"]], hostVars: 5, hostBindings: function TooltipComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵsyntheticHostProperty("@fade", ctx.fade);
        ɵngcc0.ɵɵclassProp("cds-tooltip--hidden-arrow", ctx.hiddenArrow)("cds-tooltip--danger", ctx.danger);
    } }, inputs: { arrow: "arrow", status: "status" }, ngContentSelectors: _c2, decls: 4, vars: 0, consts: [[1, "cds-tooltip__arrow"], [1, "cds-tooltip__body"], [1, "cds-tooltip__message"]], template: function TooltipComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelement(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2, data: { animation: [
            trigger('fade', [
                transition(':enter', [
                    style({ opacity: 0 }),
                    animate(300, style({ opacity: 1 })),
                ]),
                transition(':leave', [
                    style({ opacity: 1 }),
                    animate(300, style({ opacity: 0 })),
                ]),
            ]),
        ] }, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TooltipComponent, [{
        type: Component,
        args: [{
                selector: 'cds-tooltip',
                template: "<div class=\"cds-tooltip__arrow\"></div>\n<div class=\"cds-tooltip__body\">\n\t<div class=\"cds-tooltip__message\">\n\t\t<ng-content></ng-content>\n\t</div>\n</div>\n",
                animations: [
                    trigger('fade', [
                        transition(':enter', [
                            style({ opacity: 0 }),
                            animate(300, style({ opacity: 1 })),
                        ]),
                        transition(':leave', [
                            style({ opacity: 1 }),
                            animate(300, style({ opacity: 0 })),
                        ]),
                    ]),
                ],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { arrow: [{
            type: Input
        }], fade: [{
            type: HostBinding,
            args: ['@fade']
        }], hiddenArrow: [{
            type: HostBinding,
            args: ['class.cds-tooltip--hidden-arrow']
        }], danger: [{
            type: HostBinding,
            args: ['class.cds-tooltip--danger']
        }], status: [{
            type: Input
        }] }); })();
    return TooltipComponent;
}());

var TooltipService = /** @class */ (function () {
    function TooltipService(appRef, zone) {
        this.appRef = appRef;
        this.zone = zone;
    }
    TooltipService.prototype.createTooltip = function (referenceElement, options) {
        var _this = this;
        var tooltipRef = options.createTooltipRef();
        var tooltipElement = tooltipRef.nativeElement;
        this.getContainer().appendChild(tooltipElement);
        this.appRef.attachView(tooltipRef.view);
        var arrowElement = tooltipElement.querySelector('.cds-tooltip__arrow');
        tooltipElement.setAttribute('role', 'tooltip');
        var popper = createPopper(referenceElement, tooltipElement, {
            strategy: 'fixed',
            placement: options.placement,
            modifiers: [
                {
                    name: 'arrow',
                    options: {
                        element: arrowElement,
                    },
                },
            ],
        });
        requestAnimationFrame(function () {
            popper.forceUpdate();
        });
        var destroyTooltip = function () {
            var removeContainer = function () {
                if (_this.container && _this.container.childNodes.length === 0) {
                    document.body.removeChild(_this.container);
                    _this.container = null;
                    return true;
                }
                return false;
            };
            if (removeContainer()) {
                return;
            }
            _this.zone.runOutsideAngular(function () {
                var observer = new MutationObserver(function (mutationsList, observer) {
                    var e_1, _a;
                    try {
                        for (var mutationsList_1 = __values(mutationsList), mutationsList_1_1 = mutationsList_1.next(); !mutationsList_1_1.done; mutationsList_1_1 = mutationsList_1.next()) {
                            var mutation = mutationsList_1_1.value;
                            if (mutation.type == 'childList' && Array.prototype.find.call(mutation.removedNodes, function (node) { return node === tooltipElement; })) {
                                popper.destroy();
                                if (removeContainer()) {
                                    observer.disconnect();
                                    return;
                                }
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (mutationsList_1_1 && !mutationsList_1_1.done && (_a = mutationsList_1.return)) _a.call(mutationsList_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                });
                observer.observe(_this.container, { childList: true });
            });
        };
        tooltipRef.view.onDestroy(destroyTooltip);
        return {
            popper: popper,
            destroy: function () {
                tooltipRef.view.destroy();
                destroyTooltip();
            },
        };
    };
    TooltipService.prototype.getContainer = function () {
        if (this.container) {
            return this.container;
        }
        var container = document.createElement('div');
        container.className = 'cds-tooltip-container';
        document.body.appendChild(container);
        this.container = container;
        return container;
    };
    TooltipService.ctorParameters = function () { return [
        { type: ApplicationRef },
        { type: NgZone }
    ]; };
    TooltipService.ɵprov = ɵɵdefineInjectable({ factory: function TooltipService_Factory() { return new TooltipService(ɵɵinject(ApplicationRef), ɵɵinject(NgZone)); }, token: TooltipService, providedIn: "root" });
    TooltipService = __decorate([ __metadata("design:paramtypes", [ApplicationRef, NgZone])
    ], TooltipService);
TooltipService.ɵfac = function TooltipService_Factory(t) { return new (t || TooltipService)(ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(ɵngcc0.NgZone)); };
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TooltipService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.ApplicationRef }, { type: ɵngcc0.NgZone }]; }, null); })();
    return TooltipService;
}());

var TooltipDirective = /** @class */ (function () {
    function TooltipDirective(cfResolver, injector, element, renderer, tooltipService, onEscapeService) {
        this.injector = injector;
        this.element = element;
        this.renderer = renderer;
        this.tooltipService = tooltipService;
        this.onEscapeService = onEscapeService;
        this.describedBy = null;
        this.factory = cfResolver.resolveComponentFactory(TooltipComponent);
    }
    TooltipDirective.prototype.showTooltip = function () {
        if (this.tooltip) {
            this.tooltip.destroy();
        }
        var tooltipRefOptions = this.getOptions(this.tooltipOptions);
        if (tooltipRefOptions) {
            this.tooltip = this.tooltipService.createTooltip(this.element.nativeElement, tooltipRefOptions);
            this.renderer.setAttribute(this.element.nativeElement, 'aria-expanded', 'true');
            if (this.describedBy) {
                this.renderer.setAttribute(this.element.nativeElement, 'aria-describedby', this.describedBy);
            }
        }
    };
    TooltipDirective.prototype.ngOnChanges = function (changes) {
        if ('describedById' in changes) {
            if (this.describedById === true) {
                this.describedBy = Unique.next('cds-tooltip');
            }
            else if (this.describedById) {
                this.describedBy = this.describedById;
            }
            else {
                this.describedBy = null;
            }
        }
    };
    TooltipDirective.prototype.onEscape = function () {
        var _this = this;
        if (this.tooltip) {
            this.onEscapeService.scheduleAction(function () { return _this.hideTooltip(); });
        }
    };
    TooltipDirective.prototype.hideTooltip = function () {
        if (this.tooltip) {
            this.tooltip.destroy();
            this.tooltip = null;
            this.removeExpanded();
        }
    };
    TooltipDirective.prototype.removeExpanded = function () {
        this.renderer.removeAttribute(this.element.nativeElement, 'aria-expanded');
    };
    TooltipDirective.prototype.getOptions = function (options) {
        var _this = this;
        if (options === null)
            return null;
        if (typeof options == 'string') {
            return {
                createTooltipRef: function () { return _this.createTooltipFromString(options); },
                placement: 'top',
            };
        }
        if ('createEmbeddedView' in options) {
            return {
                createTooltipRef: function () { return _this.createTooltipFromTemplate(options); },
                placement: 'top',
            };
        }
        if ('template' in options) {
            return {
                createTooltipRef: function () { return _this.createTooltipFromTemplate(options.template); },
                placement: options.placement || 'top',
            };
        }
        if ('message' in options) {
            return {
                createTooltipRef: function () { return _this.createTooltipFromString(options.message, options.arrow, options.status); },
                placement: options.placement || 'top',
            };
        }
    };
    TooltipDirective.prototype.createTooltipFromString = function (message, arrow, status) {
        var componentRef = this.factory.create(this.injector, [[this.renderer.createText(message)]]);
        if (this.describedBy) {
            this.renderer.setAttribute(componentRef.location.nativeElement, 'id', this.describedBy);
        }
        if (arrow != null) {
            componentRef.instance.arrow = arrow;
        }
        if (status != null) {
            componentRef.instance.status = status;
        }
        return {
            nativeElement: componentRef.location.nativeElement,
            view: componentRef.hostView,
        };
    };
    TooltipDirective.prototype.createTooltipFromTemplate = function (templateRef) {
        var view = templateRef.createEmbeddedView({ describedById: this.describedBy });
        return {
            nativeElement: view.rootNodes[0],
            view: view,
        };
    };
    TooltipDirective.prototype.ngOnDestroy = function () {
        if (this.tooltip) {
            this.tooltip.destroy();
        }
    };
    TooltipDirective.ctorParameters = function () { return [
        { type: ComponentFactoryResolver },
        { type: Injector },
        { type: ElementRef },
        { type: Renderer2 },
        { type: TooltipService },
        { type: OnEscapeService }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], TooltipDirective.prototype, "describedById", void 0);
    __decorate([
        HostListener('window:keyup.esc'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TooltipDirective.prototype, "onEscape", null);
    TooltipDirective = __decorate([ __metadata("design:paramtypes", [ComponentFactoryResolver,
            Injector,
            ElementRef,
            Renderer2,
            TooltipService,
            OnEscapeService])
    ], TooltipDirective);
TooltipDirective.ɵfac = function TooltipDirective_Factory(t) { return new (t || TooltipDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(TooltipService), ɵngcc0.ɵɵdirectiveInject(OnEscapeService)); };
TooltipDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TooltipDirective, hostBindings: function TooltipDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keyup.esc", function TooltipDirective_keyup_esc_HostBindingHandler() { return ctx.onEscape(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { describedById: "describedById" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
TooltipDirective.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: TooltipDirective, factory: function (t) { return TooltipDirective.ɵfac(t); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TooltipDirective, [{
        type: Directive
    }, {
        type: Injectable
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.Injector }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: TooltipService }, { type: OnEscapeService }]; }, { onEscape: [{
            type: HostListener,
            args: ['window:keyup.esc']
        }], describedById: [{
            type: Input
        }] }); })();
    return TooltipDirective;
}());

var TooltipHoverDirective = /** @class */ (function (_super) {
    __extends(TooltipHoverDirective, _super);
    function TooltipHoverDirective() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.destroy$ = new Subject();
        return _this;
    }
    TooltipHoverDirective.prototype.onMouseEnter = function () {
        this.cursorOnElement = true;
        if (!this.tooltipDisplayed) {
            this.showTooltip();
            if (this.tooltip) {
                this.addListeners();
                this.tooltipDisplayed = true;
            }
            else {
                this.cursorOnElement = false;
            }
        }
    };
    TooltipHoverDirective.prototype.onMouseLeave = function () {
        this.cursorOnElement = false;
        this.hideTooltip();
    };
    TooltipHoverDirective.prototype.hideTooltip = function () {
        var _this = this;
        requestAnimationFrame(function () {
            if (!_this.cursorOnElement && !_this.cursorOnTooltip) {
                _this.removeListeners();
                _super.prototype.hideTooltip.call(_this);
                _this.tooltipDisplayed = false;
            }
        });
    };
    TooltipHoverDirective.prototype.addListeners = function () {
        var _this = this;
        this.destroy$.subscribe(listen(this.tooltip.popper.state.elements.popper, 'mouseenter', function () {
            _this.cursorOnTooltip = true;
        }));
        this.destroy$.subscribe(listen(this.tooltip.popper.state.elements.popper, 'mouseleave', function () {
            _this.cursorOnTooltip = false;
            _this.hideTooltip();
        }));
    };
    TooltipHoverDirective.prototype.removeListeners = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    __decorate([
        Input('cdsTooltipHover'),
        __metadata("design:type", Object)
    ], TooltipHoverDirective.prototype, "tooltipOptions", void 0);
    __decorate([
        HostListener('mouseenter'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TooltipHoverDirective.prototype, "onMouseEnter", null);
    __decorate([
        HostListener('mouseleave'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TooltipHoverDirective.prototype, "onMouseLeave", null);
TooltipHoverDirective.ɵfac = function TooltipHoverDirective_Factory(t) { return ɵTooltipHoverDirective_BaseFactory(t || TooltipHoverDirective); };
TooltipHoverDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TooltipHoverDirective, selectors: [["", "cdsTooltipHover", ""]], hostBindings: function TooltipHoverDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mouseenter", function TooltipHoverDirective_mouseenter_HostBindingHandler() { return ctx.onMouseEnter(); })("mouseleave", function TooltipHoverDirective_mouseleave_HostBindingHandler() { return ctx.onMouseLeave(); });
    } }, inputs: { tooltipOptions: ["cdsTooltipHover", "tooltipOptions"] }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
var ɵTooltipHoverDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(TooltipHoverDirective);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TooltipHoverDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsTooltipHover]'
            }]
    }], null, { onMouseEnter: [{
            type: HostListener,
            args: ['mouseenter']
        }], onMouseLeave: [{
            type: HostListener,
            args: ['mouseleave']
        }], tooltipOptions: [{
            type: Input,
            args: ['cdsTooltipHover']
        }] }); })();
    return TooltipHoverDirective;
}(TooltipDirective));

var TooltipClickDirective = /** @class */ (function (_super) {
    __extends(TooltipClickDirective, _super);
    function TooltipClickDirective(cfResolver, injector, element, renderer, tooltipService, onEscapeService, zone) {
        var _this = _super.call(this, cfResolver, injector, element, renderer, tooltipService, onEscapeService) || this;
        _this.zone = zone;
        return _this;
    }
    TooltipClickDirective.prototype.onClick = function (event) {
        if (!this.cancelClick) {
            this.listenForCancelClick();
        }
    };
    TooltipClickDirective.prototype.ngOnInit = function () {
        this.renderer.setAttribute(this.element.nativeElement, 'aria-expanded', 'false');
    };
    TooltipClickDirective.prototype.listenForCancelClick = function () {
        var _this = this;
        this.zone.runOutsideAngular(function () {
            _this.cancelClick = listen(document, 'click', function (event) {
                var native = _this.tooltip ? _this.tooltip.popper.state.elements.popper : null;
                if (native && !native.contains(event.target) && native !== event.target) {
                    _this.zone.run(function () {
                        _this.hideTooltip();
                    });
                }
                else if (!_this.tooltip) {
                    _this.zone.run(function () {
                        _this.showTooltip();
                    });
                }
            }, { passive: true });
        });
    };
    TooltipClickDirective.prototype.hideTooltip = function () {
        _super.prototype.hideTooltip.call(this);
        if (this.cancelClick) {
            this.cancelClick();
            this.cancelClick = null;
        }
    };
    TooltipClickDirective.prototype.removeExpanded = function () {
        this.renderer.setAttribute(this.element.nativeElement, 'aria-expanded', 'false');
    };
    TooltipClickDirective.ctorParameters = function () { return [
        { type: ComponentFactoryResolver },
        { type: Injector },
        { type: ElementRef },
        { type: Renderer2 },
        { type: TooltipService },
        { type: OnEscapeService },
        { type: NgZone }
    ]; };
    __decorate([
        Input('cdsTooltipClick'),
        __metadata("design:type", Object)
    ], TooltipClickDirective.prototype, "tooltipOptions", void 0);
    __decorate([
        HostListener('click', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [MouseEvent]),
        __metadata("design:returntype", void 0)
    ], TooltipClickDirective.prototype, "onClick", null);
    TooltipClickDirective = __decorate([ __metadata("design:paramtypes", [ComponentFactoryResolver,
            Injector,
            ElementRef,
            Renderer2,
            TooltipService,
            OnEscapeService,
            NgZone])
    ], TooltipClickDirective);
TooltipClickDirective.ɵfac = function TooltipClickDirective_Factory(t) { return new (t || TooltipClickDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(TooltipService), ɵngcc0.ɵɵdirectiveInject(OnEscapeService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
TooltipClickDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TooltipClickDirective, selectors: [["", "cdsTooltipClick", ""]], hostBindings: function TooltipClickDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function TooltipClickDirective_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } }, inputs: { tooltipOptions: ["cdsTooltipClick", "tooltipOptions"] }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TooltipClickDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsTooltipClick]'
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.Injector }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: TooltipService }, { type: OnEscapeService }, { type: ɵngcc0.NgZone }]; }, { onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], tooltipOptions: [{
            type: Input,
            args: ['cdsTooltipClick']
        }] }); })();
    return TooltipClickDirective;
}(TooltipDirective));

var TooltipFocusDirective = /** @class */ (function (_super) {
    __extends(TooltipFocusDirective, _super);
    function TooltipFocusDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TooltipFocusDirective.prototype.onFocus = function () {
        this.showTooltip();
    };
    TooltipFocusDirective.prototype.onBlur = function () {
        this.hideTooltip();
    };
    __decorate([
        HostListener('focus'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TooltipFocusDirective.prototype, "onFocus", null);
    __decorate([
        HostListener('blur'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TooltipFocusDirective.prototype, "onBlur", null);
    __decorate([
        Input('cdsTooltipFocus'),
        __metadata("design:type", Object)
    ], TooltipFocusDirective.prototype, "tooltipOptions", void 0);
TooltipFocusDirective.ɵfac = function TooltipFocusDirective_Factory(t) { return ɵTooltipFocusDirective_BaseFactory(t || TooltipFocusDirective); };
TooltipFocusDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TooltipFocusDirective, selectors: [["", "cdsTooltipFocus", ""]], hostBindings: function TooltipFocusDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focus", function TooltipFocusDirective_focus_HostBindingHandler() { return ctx.onFocus(); })("blur", function TooltipFocusDirective_blur_HostBindingHandler() { return ctx.onBlur(); });
    } }, inputs: { tooltipOptions: ["cdsTooltipFocus", "tooltipOptions"] }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
var ɵTooltipFocusDirective_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(TooltipFocusDirective);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TooltipFocusDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsTooltipFocus]'
            }]
    }], null, { onFocus: [{
            type: HostListener,
            args: ['focus']
        }], onBlur: [{
            type: HostListener,
            args: ['blur']
        }], tooltipOptions: [{
            type: Input,
            args: ['cdsTooltipFocus']
        }] }); })();
    return TooltipFocusDirective;
}(TooltipDirective));

var TooltipModule = /** @class */ (function () {
    function TooltipModule() {
    }
TooltipModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TooltipModule });
TooltipModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TooltipModule_Factory(t) { return new (t || TooltipModule)(); }, imports: [[
            CommonModule,
            OnEscapeModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TooltipModule, { declarations: function () { return [TooltipClickDirective, TooltipComponent, TooltipFocusDirective, TooltipHoverDirective]; }, imports: function () { return [CommonModule, OnEscapeModule]; }, exports: function () { return [TooltipClickDirective, TooltipComponent, TooltipFocusDirective, TooltipHoverDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TooltipModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    OnEscapeModule,
                ],
                declarations: [
                    TooltipClickDirective,
                    TooltipComponent,
                    TooltipFocusDirective,
                    TooltipHoverDirective,
                ],
                exports: [
                    TooltipClickDirective,
                    TooltipComponent,
                    TooltipFocusDirective,
                    TooltipHoverDirective,
                ],
                entryComponents: [
                    TooltipComponent,
                ]
            }]
    }], function () { return []; }, null); })();
    return TooltipModule;
}());

var ErrorInterpolatePipe = /** @class */ (function () {
    function ErrorInterpolatePipe() {
    }
    ErrorInterpolatePipe.prototype.transform = function (value) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!value) {
            return value;
        }
        var newValue = value.replace(/\{\{\s*(\d+)\s*}}/g, function (match, param) {
            var index = +param;
            return args[index - 1] || '';
        });
        return newValue;
    };
ErrorInterpolatePipe.ɵfac = function ErrorInterpolatePipe_Factory(t) { return new (t || ErrorInterpolatePipe)(); };
ErrorInterpolatePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "cdsErrorInterpolate", type: ErrorInterpolatePipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ErrorInterpolatePipe, [{
        type: Pipe,
        args: [{
                name: 'cdsErrorInterpolate'
            }]
    }], function () { return []; }, null); })();
    return ErrorInterpolatePipe;
}());

var MISSING_ERROR = '.MISSING';
var ErrorsDirective = /** @class */ (function () {
    function ErrorsDirective(ignoreErrors) {
        this.handlers = {};
        this.lastError = null;
        this.ignoreErrors = ignoreErrors ? keyBy(ignoreErrors.split(','), function (error) { return error; }) : {};
    }
    ErrorsDirective.prototype.ngOnInit = function () {
        var _this = this;
        var control = this.cdsErrors;
        if (!this.control && control) {
            this.control = toControl(control);
            this.control.statusChanges.pipe(startWith(this.control.status)).subscribe(function (status) {
                var showError = null;
                var errorObject;
                if (status === 'INVALID' && _this.control.errors) {
                    showError = Object.keys(_this.control.errors).reduce(function (showError, error) {
                        if (error === 'required' && _this.handlers['required']) {
                            return 'required';
                        }
                        else if (showError) {
                            return showError;
                        }
                        else if (_this.ignoreErrors[error] !== error && _this.handlers[error]) {
                            return error;
                        }
                        else {
                            errorObject = _this.control.errors[error];
                            return null;
                        }
                    }, null) || MISSING_ERROR;
                }
                if (_this.lastError === showError) {
                    if (showError && _this.handlers.hasOwnProperty(showError)) {
                        _this.handlers[showError].show(_this.control.errors[showError] || errorObject);
                    }
                    return;
                }
                _this.lastError = showError;
                for (var error in _this.handlers) {
                    if (_this.handlers.hasOwnProperty(error)) {
                        if (error === showError) {
                            _this.handlers[error].show(_this.control.errors[error] || errorObject);
                        }
                        else {
                            _this.handlers[error].hide();
                        }
                    }
                }
            });
        }
    };
    Object.defineProperty(ErrorsDirective.prototype, "hidden", {
        get: function () {
            return this.lastError == null || (this.control.pristine && this.control.untouched && (!this.control.value || this.control.value.length === 0));
        },
        enumerable: true,
        configurable: true
    });
    ErrorsDirective.prototype.registerError = function (name, handler) {
        this.handlers[name] = handler;
        if (this.lastError === MISSING_ERROR && this.control && this.control.hasError(name)) {
            this.lastError = name;
            handler.show(this.control.errors[name]);
        }
    };
    ErrorsDirective.prototype.hasError = function (name) {
        return this.handlers[name] != null;
    };
    ErrorsDirective.ctorParameters = function () { return [
        { type: String, decorators: [{ type: Attribute, args: ['ignoreErrors',] }] }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ErrorsDirective.prototype, "cdsErrors", void 0);
    __decorate([
        HostBinding('class.cds-errors--hidden'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ErrorsDirective.prototype, "hidden", null);
    ErrorsDirective = __decorate([ __param(0, Attribute('ignoreErrors')),
        __metadata("design:paramtypes", [String])
    ], ErrorsDirective);
ErrorsDirective.ɵfac = function ErrorsDirective_Factory(t) { return new (t || ErrorsDirective)(ɵngcc0.ɵɵinjectAttribute('ignoreErrors')); };
ErrorsDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ErrorsDirective, selectors: [["", "cdsErrors", ""]], hostVars: 2, hostBindings: function ErrorsDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("cds-errors--hidden", ctx.hidden);
    } }, inputs: { cdsErrors: "cdsErrors" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ErrorsDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsErrors]'
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Attribute,
                args: ['ignoreErrors']
            }] }]; }, { hidden: [{
            type: HostBinding,
            args: ['class.cds-errors--hidden']
        }], cdsErrors: [{
            type: Input
        }] }); })();
    return ErrorsDirective;
}());
function toControl(control) {
    if ('control' in control) {
        return control.control;
    }
    else {
        return control;
    }
}

var ERRORS_TRANSLATIONS_EN = {
    dateInvalidMessage: 'Entered value is not a valid date',
    dateFromMessage: 'Entered date must not be before {{1}}',
    dateToMessage: 'Entered date must not be after {{1}}',
    dateDisableWeekendsMessage: 'Entered date must be a weekday',
    dateAllowedDaysMessage: 'Entered date is not allowed',
    dateTimeStepsMessage: 'Entered time is invalid',
    dateTimeRangeMessage: 'Entered time must be in range {{1}} - {{2}}',
    dateTimeTimezoneMessage: 'Selected time zone is invalid',
    more: 'More',
    required: 'This field is required',
};
function errorsTranslationsFactory() {
    return ERRORS_TRANSLATIONS_EN;
}
var CDS_ERRORS_TRANSLATIONS = new InjectionToken('CDS_ERRORS_TRANSLATIONS', { factory: errorsTranslationsFactory });

var ErrorsComponent = /** @class */ (function () {
    function ErrorsComponent(cdRef, elementRef, renderer, zone, componentTranslations) {
        var _this = this;
        this.cdRef = cdRef;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.zone = zone;
        this.messageId = Unique.next('cds-error__message-');
        this.disableMessageCollapse = false;
        this.moreButtonHidden = true;
        this.changesSubject$ = new Subject();
        this.changes$ = this.changesSubject$.asObservable();
        this.intersectionObserverCallback = function (entries) {
            entries.forEach(function () {
                var messageWidth = _this.message.nativeElement.getBoundingClientRect().width;
                var messageWrapperWidth = _this.messageWrapper.nativeElement.getBoundingClientRect().width;
                var errorMessageFit = Math.abs(messageWidth - messageWrapperWidth) < 0.1;
                if (_this.moreButtonHidden !== errorMessageFit) {
                    _this.zone.run(function () {
                        _this.moreButtonHidden = errorMessageFit;
                        _this.cdRef.detectChanges();
                    });
                }
            });
        };
        renderer.addClass(elementRef.nativeElement, 'cds-errors');
        componentTranslations.use(CDS_ERRORS_TRANSLATIONS, errorsTranslationsFactory, function (translations) {
            _this.translations = translations;
            if (_this.initialized) {
                cdRef.detectChanges();
                _this.changesSubject$.next();
            }
        });
    }
    ErrorsComponent.prototype.ngOnInit = function () {
        this.fallback = this.disableMessageCollapse || !window['IntersectionObserver'];
        this.initialized = true;
    };
    ErrorsComponent.prototype.ngOnDestroy = function () {
        if (this.observer) {
            this.observer.disconnect();
        }
        this.changesSubject$.complete();
    };
    ErrorsComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (!this.fallback) {
            this.zone.runOutsideAngular(function () {
                var intersectionObserver = new IntersectionObserver(_this.intersectionObserverCallback, {
                    root: _this.messageWrapper.nativeElement,
                    threshold: [1, 0.99],
                });
                intersectionObserver.observe(_this.intersectionRight.nativeElement);
                intersectionObserver.observe(_this.intersectionLeft.nativeElement);
                _this.observer = intersectionObserver;
            });
        }
    };
    ErrorsComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: Renderer2 },
        { type: NgZone },
        { type: DynamicTranslations }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ErrorsComponent.prototype, "ariaId", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], ErrorsComponent.prototype, "disableMessageCollapse", void 0);
    __decorate([
        ViewChild('messageWrapper', { static: true }),
        __metadata("design:type", ElementRef)
    ], ErrorsComponent.prototype, "messageWrapper", void 0);
    __decorate([
        ViewChild('message', { static: true }),
        __metadata("design:type", ElementRef)
    ], ErrorsComponent.prototype, "message", void 0);
    __decorate([
        ViewChild('intersectionLeft', { static: true }),
        __metadata("design:type", ElementRef)
    ], ErrorsComponent.prototype, "intersectionLeft", void 0);
    __decorate([
        ViewChild('intersectionRight', { static: true }),
        __metadata("design:type", ElementRef)
    ], ErrorsComponent.prototype, "intersectionRight", void 0);
    ErrorsComponent = __decorate([ __metadata("design:paramtypes", [ChangeDetectorRef,
            ElementRef,
            Renderer2,
            NgZone,
            DynamicTranslations])
    ], ErrorsComponent);
ErrorsComponent.ɵfac = function ErrorsComponent_Factory(t) { return new (t || ErrorsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations)); };
ErrorsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ErrorsComponent, selectors: [["cds-errors"]], viewQuery: function ErrorsComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c21, true);
        ɵngcc0.ɵɵstaticViewQuery(_c22, true);
        ɵngcc0.ɵɵstaticViewQuery(_c23, true);
        ɵngcc0.ɵɵstaticViewQuery(_c24, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.messageWrapper = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.message = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.intersectionLeft = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.intersectionRight = _t.first);
    } }, inputs: { disableMessageCollapse: "disableMessageCollapse", ariaId: "ariaId" }, features: [ɵngcc0.ɵɵProvidersFeature([
            DynamicTranslations,
        ])], ngContentSelectors: _c2, decls: 21, vars: 22, consts: [["role", "alert", 1, "cds-errors__message"], ["messageWrapper", ""], ["message", ""], [1, "cds-errors__intersection"], ["intersectionLeft", ""], [4, "cdsError", "cdsErrorOverride"], ["intersectionRight", ""], ["tabindex", "0", "class", "cds-errors__more", "type", "button", 3, "cds-errors__more--hidden", "cdsTooltipClick", 4, "ngIf"], ["tooltip", ""], [4, "ngIf"], ["tabindex", "0", "type", "button", 1, "cds-errors__more", 3, "cdsTooltipClick"], ["status", "danger", 3, "arrow"]], template: function ErrorsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "span", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "span", null, 2);
        ɵngcc0.ɵɵelement(4, "span", 3, 4);
        ɵngcc0.ɵɵprojection(6);
        ɵngcc0.ɵɵtemplate(7, ErrorsComponent_span_7_Template, 2, 1, "span", 5);
        ɵngcc0.ɵɵtemplate(8, ErrorsComponent_span_8_Template, 3, 4, "span", 5);
        ɵngcc0.ɵɵtemplate(9, ErrorsComponent_span_9_Template, 3, 4, "span", 5);
        ɵngcc0.ɵɵtemplate(10, ErrorsComponent_span_10_Template, 2, 1, "span", 5);
        ɵngcc0.ɵɵtemplate(11, ErrorsComponent_span_11_Template, 2, 1, "span", 5);
        ɵngcc0.ɵɵtemplate(12, ErrorsComponent_span_12_Template, 2, 1, "span", 5);
        ɵngcc0.ɵɵtemplate(13, ErrorsComponent_span_13_Template, 3, 5, "span", 5);
        ɵngcc0.ɵɵtemplate(14, ErrorsComponent_span_14_Template, 2, 1, "span", 5);
        ɵngcc0.ɵɵtemplate(15, ErrorsComponent_ng_container_15_Template, 2, 1, "ng-container", 5);
        ɵngcc0.ɵɵelement(16, "span", 3, 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(18, ErrorsComponent_button_18_Template, 2, 7, "button", 7);
        ɵngcc0.ɵɵtemplate(19, ErrorsComponent_ng_template_19_Template, 2, 3, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("white-space", ctx.fallback ? "normal" : null);
        ɵngcc0.ɵɵattribute("id", ctx.ariaId);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("cdsError", "date-invalid")("cdsErrorOverride", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("cdsError", "date-from")("cdsErrorOverride", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("cdsError", "date-to")("cdsErrorOverride", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("cdsError", "date-disable-weekends")("cdsErrorOverride", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("cdsError", "date-allowed-days")("cdsErrorOverride", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("cdsError", "date-time-steps")("cdsErrorOverride", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("cdsError", "date-time-range")("cdsErrorOverride", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("cdsError", "date-time-timezone")("cdsErrorOverride", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("cdsError", ".MISSING")("cdsErrorOverride", false);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.fallback);
    } }, directives: function () { return [ErrorDirective, ɵngcc1.NgIf, TooltipClickDirective, TooltipComponent]; }, pipes: function () { return [ErrorInterpolatePipe]; }, encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ErrorsComponent, [{
        type: Component,
        args: [{
                selector: 'cds-errors',
                template: "<span role=\"alert\" #messageWrapper class=\"cds-errors__message\">\n\t<span [attr.id]=\"ariaId\" #message [style.white-space]=\"fallback ? 'normal' : null\">\n\t\t<span #intersectionLeft class=\"cds-errors__intersection\"></span>\n\t\t<ng-content></ng-content>\n\t\t<span *cdsError=\"'date-invalid'; override: false; let error\">{{translations.dateInvalidMessage}}</span>\n\t\t<span *cdsError=\"'date-from'; override: false; let error\">{{translations.dateFromMessage | cdsErrorInterpolate:error.from}}</span>\n\t\t<span *cdsError=\"'date-to'; override: false; let error\">{{translations.dateToMessage | cdsErrorInterpolate:error.to}}</span>\n\t\t<span *cdsError=\"'date-disable-weekends'; override: false; let error\">{{translations.dateDisableWeekendsMessage}}</span>\n\t\t<span *cdsError=\"'date-allowed-days'; override: false; let error\">{{translations.dateAllowedDaysMessage}}</span>\n\t\t<span *cdsError=\"'date-time-steps'; override: false; let error\">{{translations.dateTimeStepsMessage}}</span>\n\t\t<span *cdsError=\"'date-time-range'; override: false; let error\">{{translations.dateTimeRangeMessage | cdsErrorInterpolate:error.from:error.to}}</span>\n\t\t<span *cdsError=\"'date-time-timezone'; override: false; let error\">{{translations.dateTimeTimezoneMessage}}</span>\n\t\t<ng-container *cdsError=\"'.MISSING'; override: false; let error\"><span *ngIf=\"error.messageText\">{{error.messageText}}</span></ng-container>\n\t\t<span #intersectionRight class=\"cds-errors__intersection\"></span>\n\t</span>\n</span>\n<button *ngIf=\"!fallback\"\n      tabindex=\"0\"\n      class=\"cds-errors__more\"\n      type=\"button\"\n      [attr.aria-describedby]=\"messageId\"\n      [class.cds-errors__more--hidden]=\"moreButtonHidden\"\n      [cdsTooltipClick]=\"{template: tooltip, placement: 'right-start'}\">\n\t{{translations.more}}\n</button>\n<ng-template #tooltip>\n\t<cds-tooltip status=\"danger\"\n\t             [arrow]=\"true\"\n\t             [attr.id]=\"messageId\">\n\t\t{{message.innerText}}\n\t</cds-tooltip>\n</ng-template>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                providers: [
                    DynamicTranslations,
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.NgZone }, { type: DynamicTranslations }]; }, { disableMessageCollapse: [{
            type: Input
        }], ariaId: [{
            type: Input
        }], messageWrapper: [{
            type: ViewChild,
            args: ['messageWrapper', { static: true }]
        }], message: [{
            type: ViewChild,
            args: ['message', { static: true }]
        }], intersectionLeft: [{
            type: ViewChild,
            args: ['intersectionLeft', { static: true }]
        }], intersectionRight: [{
            type: ViewChild,
            args: ['intersectionRight', { static: true }]
        }] }); })();
    return ErrorsComponent;
}());

var ErrorDirective = /** @class */ (function () {
    function ErrorDirective(vcRef, templateRef, errorsDirective, errorsComponent) {
        this.vcRef = vcRef;
        this.templateRef = templateRef;
        this.errorsDirective = errorsDirective;
        this.errorsComponent = errorsComponent;
        this.override = true;
        this.context = {};
    }
    ErrorDirective.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.errorsDirective.hasError(this.error) || this.override) {
            this.errorsDirective.registerError(this.error, this);
        }
        if (this.errorsComponent) {
            this.subscription = this.errorsComponent.changes$.subscribe(function () {
                if (_this.isVisible) {
                    _this.updateVcRef();
                }
            });
        }
    };
    ErrorDirective.prototype.show = function (error) {
        this.isVisible = true;
        Object.assign(this.context, error);
        this.updateVcRef();
    };
    ErrorDirective.prototype.hide = function () {
        this.isVisible = false;
        if (this.vcRef.length) {
            this.context = {};
            this.vcRef.clear();
        }
    };
    ErrorDirective.prototype.ngOnDestroy = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    };
    ErrorDirective.prototype.updateVcRef = function () {
        if (!this.vcRef.length) {
            this.vcRef.clear();
            var view = this.vcRef.createEmbeddedView(this.templateRef, { $implicit: this.context });
            view.detach();
            view.detectChanges();
        }
        else {
            this.vcRef.get(0).detectChanges();
        }
    };
    ErrorDirective.ctorParameters = function () { return [
        { type: ViewContainerRef },
        { type: TemplateRef },
        { type: ErrorsDirective },
        { type: ErrorsComponent, decorators: [{ type: Host }, { type: Optional }] }
    ]; };
    __decorate([
        Input('cdsError'),
        __metadata("design:type", String)
    ], ErrorDirective.prototype, "error", void 0);
    __decorate([
        Input('cdsErrorOverride'),
        __metadata("design:type", Boolean)
    ], ErrorDirective.prototype, "override", void 0);
    ErrorDirective = __decorate([ __param(3, Host()), __param(3, Optional()),
        __metadata("design:paramtypes", [ViewContainerRef,
            TemplateRef,
            ErrorsDirective,
            ErrorsComponent])
    ], ErrorDirective);
ErrorDirective.ɵfac = function ErrorDirective_Factory(t) { return new (t || ErrorDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ErrorsDirective), ɵngcc0.ɵɵdirectiveInject(ErrorsComponent, 9)); };
ErrorDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ErrorDirective, selectors: [["", "cdsError", ""]], inputs: { override: ["cdsErrorOverride", "override"], error: ["cdsError", "error"] }, features: [ɵngcc0.ɵɵProvidersFeature([DynamicTranslations])] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ErrorDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsError]',
                providers: [DynamicTranslations]
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.TemplateRef }, { type: ErrorsDirective }, { type: ErrorsComponent, decorators: [{
                type: Host
            }, {
                type: Optional
            }] }]; }, { override: [{
            type: Input,
            args: ['cdsErrorOverride']
        }], error: [{
            type: Input,
            args: ['cdsError']
        }] }); })();
    return ErrorDirective;
}());

var ErrorsModule = /** @class */ (function () {
    function ErrorsModule() {
    }
ErrorsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ErrorsModule });
ErrorsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ErrorsModule_Factory(t) { return new (t || ErrorsModule)(); }, imports: [[
            CommonModule,
            TooltipModule,
            AccessibilityModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ErrorsModule, { declarations: function () { return [ErrorDirective, ErrorInterpolatePipe, ErrorsComponent, ErrorsDirective]; }, imports: function () { return [CommonModule, TooltipModule, AccessibilityModule]; }, exports: function () { return [ErrorDirective, ErrorsComponent, ErrorsDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ErrorsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TooltipModule,
                    AccessibilityModule,
                ],
                declarations: [
                    ErrorDirective,
                    ErrorInterpolatePipe,
                    ErrorsComponent,
                    ErrorsDirective,
                ],
                exports: [
                    ErrorDirective,
                    ErrorsComponent,
                    ErrorsDirective,
                ]
            }]
    }], function () { return []; }, null); })();
    return ErrorsModule;
}());

var TIME_PICKER_TRANSLATIONS_EN = {
    selectHour: 'Select hour',
    selectMinute: 'Select minute',
    selectSecond: 'Select second',
};
function timePickerTranslationsFactory() {
    return TIME_PICKER_TRANSLATIONS_EN;
}
var CDS_TIME_PICKER_TRANSLATIONS = new InjectionToken('CDS_TIME_PICKER_TRANSLATIONS', { factory: timePickerTranslationsFactory });

var TIME_PICKER_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return TimePickerComponent; }),
    multi: true,
};
var TimePickerComponent = /** @class */ (function (_super) {
    __extends(TimePickerComponent, _super);
    function TimePickerComponent(elementRef, renderer, timezonesService, componentTranslations, cdRef) {
        var _this = _super.call(this, timezonesService) || this;
        _this.cdRef = cdRef;
        _this.showMinutes = true;
        _this.showSeconds = true;
        _this.selectedHour = -1;
        _this.selectedMinute = -1;
        _this.selectedSecond = -1;
        _this.onTouchedCallback = noop;
        _this.onChangeCallback = noop;
        _this.pickerId = Unique.next('cds-time-picker-');
        _this.hourLabelId = _this.pickerId + '-hl';
        _this.hourValueId = _this.pickerId + '-hv';
        _this.minuteLabelId = _this.pickerId + '-ml';
        _this.minuteValueId = _this.pickerId + '-mv';
        _this.secondLabelId = _this.pickerId + '-sl';
        _this.secondValueId = _this.pickerId + '-sv';
        _this.initialized = false;
        renderer.addClass(elementRef.nativeElement, 'cds-time-picker');
        componentTranslations.use(CDS_TIME_PICKER_TRANSLATIONS, timePickerTranslationsFactory, function (translations) {
            _this.translations = translations;
            if (_this.initialized) {
                _this.cdRef.detectChanges();
            }
        });
        return _this;
    }
    Object.defineProperty(TimePickerComponent.prototype, "format", {
        set: function (format) {
            if (format) {
                this.showMinutes = format.indexOf('m') !== -1;
                this.showSeconds = format.indexOf('s') !== -1;
            }
        },
        enumerable: true,
        configurable: true
    });
    TimePickerComponent.prototype.ngOnChanges = function (changes) {
        _super.prototype.ngOnChanges.call(this, changes);
        this.initialize(changes);
    };
    TimePickerComponent.prototype.ngOnInit = function () {
        this.initialize({});
        this.initialized = true;
    };
    TimePickerComponent.prototype.initialize = function (changes) {
        if (!this.hoursList || 'hourStep' in changes) {
            this.hoursList = this.prepareItems(24, this.constraints.hourStep);
        }
        if (!this.minutesList || 'minuteStep' in changes) {
            this.minutesList = this.prepareItems(60, this.constraints.minuteStep);
        }
        if (!this.secondsList || 'secondStep' in changes) {
            this.secondsList = this.prepareItems(60, this.constraints.secondStep);
        }
    };
    TimePickerComponent.prototype.next = function (part) {
        var selectedElement;
        if (part === 'hours') {
            selectedElement = this.nextItem(this.hoursList, this.selectedHour);
        }
        else if (part === 'minutes') {
            selectedElement = this.nextItem(this.minutesList, this.selectedMinute);
        }
        else if (part === 'seconds') {
            selectedElement = this.nextItem(this.secondsList, this.selectedSecond);
        }
        this.selectItem(selectedElement, part, true);
    };
    TimePickerComponent.prototype.prev = function (part) {
        var selectedElement;
        if (part === 'hours') {
            selectedElement = this.prevItem(this.hoursList, this.selectedHour);
        }
        else if (part === 'minutes') {
            selectedElement = this.prevItem(this.minutesList, this.selectedMinute);
        }
        else if (part === 'seconds') {
            selectedElement = this.prevItem(this.secondsList, this.selectedSecond);
        }
        this.selectItem(selectedElement, part, false);
    };
    TimePickerComponent.prototype.selectItem = function (value, part, next) {
        if (part === 'hours') {
            var minute = this.selectedHour !== -1
                ? (next ? this.constraints.timeToMinute : this.constraints.timeFromMinute)
                : (next ? this.constraints.timeFromMinute : this.constraints.timeToMinute);
            var second = next ? this.constraints.timeFromSecond : this.constraints.timeToSecond;
            if (this.isValid(value, this.selectedMinute, this.selectedSecond)) {
                this.update(value);
            }
            else if (this.isValid(value, minute, this.selectedSecond)) {
                this.update(value, minute);
            }
            else if (this.isValid(value, minute, second)) {
                this.update(value, minute, second);
            }
        }
        else if (part === 'minutes') {
            var second = this.selectedMinute !== -1
                ? (next ? this.constraints.timeToSecond : this.constraints.timeFromSecond)
                : (next ? this.constraints.timeFromSecond : this.constraints.timeToSecond);
            if (this.isValid(this.selectedHour, value, this.selectedSecond)) {
                this.update(this.selectedHour, value);
            }
            else if (this.isValid(this.selectedHour, value, second)) {
                this.update(this.selectedHour, value, second);
            }
        }
        else if (part === 'seconds') {
            if (this.isValid(this.selectedHour, this.selectedMinute, value)) {
                this.update(this.selectedHour, this.selectedMinute, value);
            }
        }
        if (!this.isValid(this.selectedHour, this.selectedMinute, this.selectedSecond)) {
            if (next) {
                this.update(this.constraints.timeFromHour, this.constraints.timeFromMinute, this.constraints.timeFromSecond);
            }
            else {
                this.update(this.constraints.timeToHour, this.constraints.timeToMinute, this.constraints.timeToSecond);
            }
        }
    };
    TimePickerComponent.prototype.focusNext = function (part) {
        if (part === 'hours' && this.showMinutes) {
            this.minutesColumn.nativeElement.focus();
        }
        else if (part === 'minutes' && this.showSeconds) {
            this.secondsColumn.nativeElement.focus();
        }
    };
    TimePickerComponent.prototype.focusPrev = function (part) {
        if (part === 'seconds' && this.showMinutes) {
            this.minutesColumn.nativeElement.focus();
        }
        else if (part === 'minutes') {
            this.hoursColumn.nativeElement.focus();
        }
    };
    TimePickerComponent.prototype.writeValue = function (value) {
        if (value && value != this._value && TIME_REGEX.test(value)) {
            this.setTime(value);
            this._value = value;
        }
        else if (!value) {
            this.selectedHour = -1;
            this.selectedMinute = -1;
            this.selectedSecond = -1;
            this._value = value;
        }
        this.cdRef.markForCheck();
    };
    TimePickerComponent.prototype.isValid = function (hour, minute, second) {
        if (hour < 0 || minute < 0 || second < 0 || hour >= 24 || minute >= 60 || second >= 60) {
            return false;
        }
        var timeNumber = this.getTimeNumber(hour, minute, second);
        return this.constraints.checkTimeRange(timeNumber);
    };
    TimePickerComponent.prototype.isDisabled = function (item, part) {
        if (this.constraints.timeFrom == null && this.constraints.timeTo == null) {
            return false;
        }
        if (part === 'hours') {
            return !this.inRange(item, this.constraints.timeFromHour, this.constraints.timeToHour);
        }
        else if (part === 'minutes') {
            var value = this.selectedHour * 3600 + item * 60;
            var from = this.constraints.timeFromNumber - this.constraints.timeFromSecond;
            var to = this.constraints.timeToNumber - this.constraints.timeToSecond + 59;
            return !this.inRange(value, from, to);
        }
        else if (part === 'seconds') {
            var value = this.selectedHour * 3600 + this.selectedMinute * 60 + item;
            return !this.inRange(value, this.constraints.timeFromNumber, this.constraints.timeToNumber);
        }
    };
    TimePickerComponent.prototype.inRange = function (value, from, to) {
        if (from <= to) {
            return value >= from && value <= to;
        }
        else {
            return value >= from || value <= to;
        }
    };
    TimePickerComponent.prototype.setTime = function (time) {
        var timeParts = time.split(':');
        this.selectedHour = +timeParts[0] || 0;
        this.selectedMinute = +timeParts[1] || 0;
        this.selectedSecond = +timeParts[2] || 0;
    };
    TimePickerComponent.prototype.prepareItems = function (count, step) {
        var list = [];
        for (var i = 0; i < count; i += step) {
            list.push(i);
        }
        return list;
    };
    TimePickerComponent.prototype.nextItem = function (list, selectedItem) {
        var newItem = list.find(function (item) { return item > selectedItem; });
        if (newItem != null) {
            return newItem;
        }
        else {
            return list[0];
        }
    };
    TimePickerComponent.prototype.prevItem = function (list, selectedItem) {
        var newIndex = list.findIndex(function (item) { return item >= selectedItem; }) - 1;
        if (newIndex >= 0) {
            return list[newIndex];
        }
        else {
            return list[list.length - 1];
        }
    };
    TimePickerComponent.prototype.update = function (selectedHour, selectedMinute, selectedSecond) {
        var change = false;
        if (selectedHour != null && selectedHour !== this.selectedHour) {
            this.selectedHour = selectedHour;
            change = true;
        }
        if (selectedMinute != null && selectedMinute !== this.selectedMinute) {
            this.selectedMinute = selectedMinute;
            change = true;
        }
        if (selectedSecond != null && selectedSecond !== this.selectedSecond) {
            this.selectedSecond = selectedSecond;
            change = true;
        }
        if (change) {
            this.onChangeCallback(this.getSelectedTime());
        }
    };
    TimePickerComponent.prototype.getSelectedTime = function () {
        var time = "" + this.padNumber(this.selectedHour);
        if (this.showMinutes) {
            time += ":" + this.padNumber(this.selectedMinute);
        }
        else {
            time += ':00';
        }
        if (this.showSeconds) {
            time += ":" + this.padNumber(this.selectedSecond);
        }
        else {
            time += ':00';
        }
        return time;
    };
    TimePickerComponent.prototype.getTimeNumber = function (hour, minute, second) {
        return hour * 3600 + minute * 60 + second;
    };
    TimePickerComponent.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    TimePickerComponent.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    TimePickerComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
        this.cdRef.markForCheck();
    };
    TimePickerComponent.prototype.trackByIdentity = function (index, obj) {
        return obj;
    };
    TimePickerComponent.prototype.padNumber = function (value) {
        if (value > 9) {
            return "" + value;
        }
        else {
            return "0" + value;
        }
    };
    TimePickerComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: TimezonesService },
        { type: DynamicTranslations },
        { type: ChangeDetectorRef }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", DateTimeConstraints)
    ], TimePickerComponent.prototype, "constraints", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], TimePickerComponent.prototype, "format", null);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], TimePickerComponent.prototype, "useDayPeriod", void 0);
    __decorate([
        ViewChild('hours', { static: true }),
        __metadata("design:type", ElementRef)
    ], TimePickerComponent.prototype, "hoursColumn", void 0);
    __decorate([
        ViewChild('minutes'),
        __metadata("design:type", ElementRef)
    ], TimePickerComponent.prototype, "minutesColumn", void 0);
    __decorate([
        ViewChild('seconds'),
        __metadata("design:type", ElementRef)
    ], TimePickerComponent.prototype, "secondsColumn", void 0);
    __decorate([
        HostBinding('class.disabled'),
        __metadata("design:type", Boolean)
    ], TimePickerComponent.prototype, "disabled", void 0);
    TimePickerComponent = __decorate([ __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            TimezonesService,
            DynamicTranslations,
            ChangeDetectorRef])
    ], TimePickerComponent);
TimePickerComponent.ɵfac = function TimePickerComponent_Factory(t) { return new (t || TimePickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(TimezonesService), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
TimePickerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TimePickerComponent, selectors: [["cds-time-picker"]], viewQuery: function TimePickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c26, true);
        ɵngcc0.ɵɵviewQuery(_c27, true);
        ɵngcc0.ɵɵviewQuery(_c28, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.hoursColumn = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.minutesColumn = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.secondsColumn = _t.first);
    } }, hostVars: 2, hostBindings: function TimePickerComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("disabled", ctx.disabled);
    } }, inputs: { format: "format", constraints: "constraints", useDayPeriod: "useDayPeriod" }, features: [ɵngcc0.ɵɵProvidersFeature([TIME_PICKER_CONTROL_VALUE_ACCESSOR, DynamicTranslations]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 12, vars: 14, consts: [["class", "cds-sr-only", 4, "ngIf"], ["cdsTimePickerColumn", "hours", "role", "listbox", 1, "cds-time-picker__column"], ["hours", ""], [1, "cds-sr-only"], ["aria-hidden", "true", 1, "cds-time-picker__arrow", "cds-icon-angle-up", 3, "click"], ["class", "cds-time-picker__item", "role", "option", 3, "cds-time-picker__item--selected", "cds-time-picker__item--disabled", "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["aria-hidden", "true", 1, "cds-time-picker__arrow", "cds-icon-angle-down", 3, "click"], [4, "ngIf"], ["role", "option", 1, "cds-time-picker__item", 3, "click"], ["aria-hidden", "true", 1, "cds-time-picker__separator"], ["cdsTimePickerColumn", "minutes", "role", "listbox", 1, "cds-time-picker__column"], ["minutes", ""], ["cdsTimePickerColumn", "seconds", "role", "listbox", 1, "cds-time-picker__column"], ["seconds", ""]], template: function TimePickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TimePickerComponent_span_0_Template, 5, 13, "span", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1, 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "span", 4);
        ɵngcc0.ɵɵlistener("click", function TimePickerComponent_Template_span_click_5_listener() { return ctx.prev("hours"); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div");
        ɵngcc0.ɵɵtemplate(7, TimePickerComponent_span_7_Template, 4, 15, "span", 5);
        ɵngcc0.ɵɵpipe(8, "cdsTimePicker");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "span", 6);
        ɵngcc0.ɵɵlistener("click", function TimePickerComponent_Template_span_click_9_listener() { return ctx.next("hours"); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, TimePickerComponent_ng_container_10_Template, 12, 11, "ng-container", 7);
        ɵngcc0.ɵɵtemplate(11, TimePickerComponent_ng_container_11_Template, 12, 11, "ng-container", 7);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectedHour != -1 && ctx.selectedMinute != -1 && ctx.selectedSecond != -1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("tabindex", ctx.disabled ? "-1" : "0")("aria-disabled", ctx.disabled ? "true" : null)("aria-labelledby", ctx.pickerId + " " + ctx.hourLabelId);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("id", ctx.hourLabelId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.translations.selectHour);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind3(8, 10, ctx.hoursList, ctx.selectedHour, ctx.constraints.timeFromHour))("ngForTrackBy", ctx.trackByIdentity);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showMinutes);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showSeconds);
    } }, directives: function () { return [ɵngcc1.NgIf, TimePickerColumnDirective, ɵngcc1.NgForOf]; }, pipes: function () { return [TimePickerPipe, ɵngcc1.DecimalPipe, TimePickerDisplayHourPipe]; }, encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TimePickerComponent, [{
        type: Component,
        args: [{
                selector: 'cds-time-picker',
                template: "<span [attr.id]=\"pickerId\" class=\"cds-sr-only\" *ngIf=\"selectedHour != -1 && selectedMinute != -1 && selectedSecond != -1\">{{selectedHour | number:'2.0-0'}}:{{selectedMinute | number:'2.0-0'}}:{{selectedSecond | number:'2.0-0'}}</span>\n<div class=\"cds-time-picker__column\" cdsTimePickerColumn=\"hours\" #hours\n     role=\"listbox\" [attr.tabindex]=\"disabled ? '-1' : '0'\" [attr.aria-disabled]=\"disabled ? 'true' : null\"\n     [attr.aria-labelledby]=\"pickerId + ' ' + hourLabelId\">\n\t<div class=\"cds-sr-only\" [attr.id]=\"hourLabelId\">{{translations.selectHour}}</div>\n\t<span class=\"cds-time-picker__arrow cds-icon-angle-up\" aria-hidden=\"true\" (click)=\"prev('hours')\"></span>\n\t<div>\n\t\t<span class=\"cds-time-picker__item\"\n\t\t      role=\"option\"\n\t\t      [attr.id]=\"index === 2 && selectedHour === hour ? hourValueId : null\"\n\t\t      [attr.aria-selected]=\"index === 2 && selectedHour === hour\"\n\t\t      [class.cds-time-picker__item--selected]=\"index === 2 && selectedHour === hour\"\n\t\t      [attr.aria-disabled]=\"isDisabled(hour, 'hours') ? 'true' : null\"\n\t\t      [class.cds-time-picker__item--disabled]=\"isDisabled(hour, 'hours')\"\n\t\t      [attr.aria-hidden]=\"hour === -1\"\n\t\t      (click)=\"isDisabled(hour, 'hours') || selectItem(hour, 'hours', hour > selectedHour)\"\n\t\t      *ngFor=\"let hour of hoursList | cdsTimePicker:selectedHour:constraints.timeFromHour; let index = index; trackBy: trackByIdentity\">{{hour === -1 ? '--' : hour | cdsTimePickerDisplayHour:useDayPeriod | number:'2.0-0'}}</span>\n\t</div>\n\t<span class=\"cds-time-picker__arrow cds-icon-angle-down\" aria-hidden=\"true\" (click)=\"next('hours')\"></span>\n</div>\n<ng-container *ngIf=\"showMinutes\">\n\t<div class=\"cds-time-picker__separator\" aria-hidden=\"true\">:</div>\n\t<div class=\"cds-time-picker__column\" cdsTimePickerColumn=\"minutes\" #minutes\n\t     role=\"listbox\" [attr.tabindex]=\"disabled ? '-1' : '0'\" [attr.aria-disabled]=\"disabled ? 'true' : null\"\n\t     [attr.aria-labelledby]=\"pickerId + ' ' + minuteLabelId\">\n\t\t<div class=\"cds-sr-only\" [attr.id]=\"minuteLabelId\">{{translations.selectMinute}}</div>\n\t\t<span class=\"cds-time-picker__arrow cds-icon-angle-up\" aria-hidden=\"true\" (click)=\"prev('minutes')\"></span>\n\t\t<div>\n\t\t\t<span class=\"cds-time-picker__item\"\n\t\t\t      role=\"option\"\n\t\t\t      [attr.id]=\"index === 2 && selectedMinute === minute ? minuteValueId : null\"\n\t\t\t      [attr.aria-selected]=\"index === 2 && selectedMinute === minute\"\n\t\t\t      [class.cds-time-picker__item--selected]=\"index === 2 && selectedMinute === minute\"\n\t\t\t      [attr.aria-disabled]=\"isDisabled(minute, 'minutes') ? 'true' : null\"\n\t\t\t      [class.cds-time-picker__item--disabled]=\"isDisabled(minute, 'minutes')\"\n\t\t\t      [attr.aria-hidden]=\"minute === -1\"\n\t\t\t      (click)=\"isDisabled(minute, 'minutes') || selectItem(minute, 'minutes', minute > selectedMinute)\"\n\t\t\t      *ngFor=\"let minute of minutesList | cdsTimePicker:selectedMinute:constraints.timeFromMinute; let index = index; trackBy: trackByIdentity\">{{minute === -1 ? '--' : (minute | number:'2.0-0')}}</span>\n\t\t</div>\n\t\t<span class=\"cds-time-picker__arrow cds-icon-angle-down\" aria-hidden=\"true\" (click)=\"next('minutes')\"></span>\n\t</div>\n</ng-container>\n<ng-container *ngIf=\"showSeconds\">\n\t<div class=\"cds-time-picker__separator\" aria-hidden=\"true\">:</div>\n\t<div class=\"cds-time-picker__column\" cdsTimePickerColumn=\"seconds\" #seconds\n\t     role=\"listbox\" [attr.tabindex]=\"disabled ? '-1' : '0'\" [attr.aria-disabled]=\"disabled ? 'true' : null\"\n\t     [attr.aria-labelledby]=\"pickerId + ' ' + secondLabelId\">\n\t\t<div class=\"cds-sr-only\" [attr.id]=\"secondLabelId\">{{translations.selectSecond}}</div>\n\t\t<span class=\"cds-time-picker__arrow cds-icon-angle-up\" aria-hidden=\"true\" (click)=\"prev('seconds')\"></span>\n\t\t<div>\n\t\t\t<span class=\"cds-time-picker__item\"\n\t\t\t      role=\"option\"\n\t\t\t      [attr.id]=\"index === 2 && selectedSecond === second ? secondValueId : null\"\n\t\t\t      [attr.aria-selected]=\"index === 2 && selectedSecond === second\"\n\t\t\t      [class.cds-time-picker__item--selected]=\"index === 2 && selectedSecond === second\"\n\t\t\t      [attr.aria-disabled]=\"isDisabled(second, 'seconds') ? 'true' : null\"\n\t\t\t      [class.cds-time-picker__item--disabled]=\"isDisabled(second, 'seconds')\"\n\t\t\t      [attr.aria-hidden]=\"second === -1\"\n\t\t\t      (click)=\"isDisabled(second, 'seconds') || selectItem(second, 'seconds', second > selectedSecond)\"\n\t\t\t      *ngFor=\"let second of secondsList | cdsTimePicker:selectedSecond:constraints.timeFromSecond; let index = index; trackBy: trackByIdentity\">{{second === -1 ? '--' : (second | number:'2.0-0')}}</span>\n\t\t</div>\n\t\t<span class=\"cds-time-picker__arrow cds-icon-angle-down\" aria-hidden=\"true\" (click)=\"next('seconds')\"></span>\n\t</div>\n</ng-container>\n",
                providers: [TIME_PICKER_CONTROL_VALUE_ACCESSOR, DynamicTranslations],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: TimezonesService }, { type: DynamicTranslations }, { type: ɵngcc0.ChangeDetectorRef }]; }, { format: [{
            type: Input
        }], disabled: [{
            type: HostBinding,
            args: ['class.disabled']
        }], constraints: [{
            type: Input
        }], useDayPeriod: [{
            type: Input
        }], hoursColumn: [{
            type: ViewChild,
            args: ['hours', { static: true }]
        }], minutesColumn: [{
            type: ViewChild,
            args: ['minutes']
        }], secondsColumn: [{
            type: ViewChild,
            args: ['seconds']
        }] }); })();
    return TimePickerComponent;
}(BaseTimeComponent));

var TimePickerColumnDirective = /** @class */ (function () {
    function TimePickerColumnDirective(timePicker) {
        this.timePicker = timePicker;
    }
    TimePickerColumnDirective.prototype.onWheel = function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.deltaY > 0) {
            this.timePicker.next(this.part);
        }
        else if (event.deltaY < 0) {
            this.timePicker.prev(this.part);
        }
    };
    TimePickerColumnDirective.prototype.onTouchStart = function (event) {
        this.lastY = event.touches[0].clientY;
    };
    TimePickerColumnDirective.prototype.onTouchMove = function (event) {
        event.preventDefault();
        event.stopPropagation();
        var currentY = event.touches[0].clientY;
        if (Math.abs(this.lastY - currentY) < 20) {
            return;
        }
        if (currentY > this.lastY) {
            this.timePicker.prev(this.part);
        }
        else if (currentY < this.lastY) {
            this.timePicker.next(this.part);
        }
        this.lastY = currentY;
    };
    TimePickerColumnDirective.prototype.onKeydownArrowDown = function (event) {
        event.preventDefault();
        event.stopPropagation();
        this.timePicker.next(this.part);
    };
    TimePickerColumnDirective.prototype.onKeydownArrowUp = function (event) {
        event.preventDefault();
        event.stopPropagation();
        this.timePicker.prev(this.part);
    };
    TimePickerColumnDirective.prototype.onKeydownArrowRight = function (event) {
        event.preventDefault();
        event.stopPropagation();
        this.timePicker.focusNext(this.part);
    };
    TimePickerColumnDirective.prototype.onKeydownArrowLeft = function (event) {
        event.preventDefault();
        event.stopPropagation();
        this.timePicker.focusPrev(this.part);
    };
    TimePickerColumnDirective.ctorParameters = function () { return [
        { type: TimePickerComponent, decorators: [{ type: Host }] }
    ]; };
    __decorate([
        Input('cdsTimePickerColumn'),
        __metadata("design:type", String)
    ], TimePickerColumnDirective.prototype, "part", void 0);
    __decorate([
        HostListener('wheel', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], TimePickerColumnDirective.prototype, "onWheel", null);
    __decorate([
        HostListener('touchstart', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], TimePickerColumnDirective.prototype, "onTouchStart", null);
    __decorate([
        HostListener('touchmove', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], TimePickerColumnDirective.prototype, "onTouchMove", null);
    __decorate([
        HostListener('keydown.arrowdown', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], TimePickerColumnDirective.prototype, "onKeydownArrowDown", null);
    __decorate([
        HostListener('keydown.arrowup', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], TimePickerColumnDirective.prototype, "onKeydownArrowUp", null);
    __decorate([
        HostListener('keydown.arrowright', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], TimePickerColumnDirective.prototype, "onKeydownArrowRight", null);
    __decorate([
        HostListener('keydown.arrowleft', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], TimePickerColumnDirective.prototype, "onKeydownArrowLeft", null);
    TimePickerColumnDirective = __decorate([ __param(0, Host()),
        __metadata("design:paramtypes", [TimePickerComponent])
    ], TimePickerColumnDirective);
TimePickerColumnDirective.ɵfac = function TimePickerColumnDirective_Factory(t) { return new (t || TimePickerColumnDirective)(ɵngcc0.ɵɵdirectiveInject(TimePickerComponent, 1)); };
TimePickerColumnDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TimePickerColumnDirective, selectors: [["", "cdsTimePickerColumn", ""]], hostBindings: function TimePickerColumnDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("wheel", function TimePickerColumnDirective_wheel_HostBindingHandler($event) { return ctx.onWheel($event); })("touchstart", function TimePickerColumnDirective_touchstart_HostBindingHandler($event) { return ctx.onTouchStart($event); })("touchmove", function TimePickerColumnDirective_touchmove_HostBindingHandler($event) { return ctx.onTouchMove($event); })("keydown.arrowdown", function TimePickerColumnDirective_keydown_arrowdown_HostBindingHandler($event) { return ctx.onKeydownArrowDown($event); })("keydown.arrowup", function TimePickerColumnDirective_keydown_arrowup_HostBindingHandler($event) { return ctx.onKeydownArrowUp($event); })("keydown.arrowright", function TimePickerColumnDirective_keydown_arrowright_HostBindingHandler($event) { return ctx.onKeydownArrowRight($event); })("keydown.arrowleft", function TimePickerColumnDirective_keydown_arrowleft_HostBindingHandler($event) { return ctx.onKeydownArrowLeft($event); });
    } }, inputs: { part: ["cdsTimePickerColumn", "part"] } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TimePickerColumnDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsTimePickerColumn]'
            }]
    }], function () { return [{ type: TimePickerComponent, decorators: [{
                type: Host
            }] }]; }, { onWheel: [{
            type: HostListener,
            args: ['wheel', ['$event']]
        }], onTouchStart: [{
            type: HostListener,
            args: ['touchstart', ['$event']]
        }], onTouchMove: [{
            type: HostListener,
            args: ['touchmove', ['$event']]
        }], onKeydownArrowDown: [{
            type: HostListener,
            args: ['keydown.arrowdown', ['$event']]
        }], onKeydownArrowUp: [{
            type: HostListener,
            args: ['keydown.arrowup', ['$event']]
        }], onKeydownArrowRight: [{
            type: HostListener,
            args: ['keydown.arrowright', ['$event']]
        }], onKeydownArrowLeft: [{
            type: HostListener,
            args: ['keydown.arrowleft', ['$event']]
        }], part: [{
            type: Input,
            args: ['cdsTimePickerColumn']
        }] }); })();
    return TimePickerColumnDirective;
}());

var TimePickerPipe = /** @class */ (function () {
    function TimePickerPipe() {
    }
    TimePickerPipe.prototype.transform = function (items, selectedItem, firstItem) {
        if (firstItem === void 0) { firstItem = 0; }
        var noSelectedItem = selectedItem == null || selectedItem === -1;
        if (noSelectedItem) {
            selectedItem = firstItem - 0.5;
        }
        var len = items.length;
        var nextIndex = items.findIndex(function (item) { return item > selectedItem; });
        var prevIndex = items.findIndex(function (item) { return item >= selectedItem; }) - 1;
        if (nextIndex === -1) {
            nextIndex = len;
        }
        if (prevIndex === -2) {
            prevIndex = len - 1;
        }
        var list = [
            items[(prevIndex - 1 + len) % len],
            items[(prevIndex + len) % len],
            noSelectedItem ? -1 : selectedItem,
            items[(nextIndex) % len],
            items[(nextIndex + 1) % len],
        ];
        return list;
    };
TimePickerPipe.ɵfac = function TimePickerPipe_Factory(t) { return new (t || TimePickerPipe)(); };
TimePickerPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "cdsTimePicker", type: TimePickerPipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TimePickerPipe, [{
        type: Pipe,
        args: [{
                name: 'cdsTimePicker'
            }]
    }], function () { return []; }, null); })();
    return TimePickerPipe;
}());

var TimePickerDisplayHourPipe = /** @class */ (function () {
    function TimePickerDisplayHourPipe() {
    }
    TimePickerDisplayHourPipe.prototype.transform = function (selectedHour, useDayPeriod) {
        return useDayPeriod ? ((selectedHour % 12) || 12) : selectedHour;
    };
TimePickerDisplayHourPipe.ɵfac = function TimePickerDisplayHourPipe_Factory(t) { return new (t || TimePickerDisplayHourPipe)(); };
TimePickerDisplayHourPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "cdsTimePickerDisplayHour", type: TimePickerDisplayHourPipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TimePickerDisplayHourPipe, [{
        type: Pipe,
        args: [{
                name: 'cdsTimePickerDisplayHour'
            }]
    }], function () { return []; }, null); })();
    return TimePickerDisplayHourPipe;
}());

var TimePickerModule = /** @class */ (function () {
    function TimePickerModule() {
    }
TimePickerModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TimePickerModule });
TimePickerModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TimePickerModule_Factory(t) { return new (t || TimePickerModule)(); }, imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TimePickerModule, { declarations: function () { return [TimePickerColumnDirective, TimePickerComponent, TimePickerPipe, TimePickerDisplayHourPipe]; }, imports: function () { return [CommonModule]; }, exports: function () { return [TimePickerColumnDirective, TimePickerComponent, TimePickerPipe]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TimePickerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                ],
                declarations: [
                    TimePickerColumnDirective,
                    TimePickerComponent,
                    TimePickerPipe,
                    TimePickerDisplayHourPipe,
                ],
                exports: [
                    TimePickerColumnDirective,
                    TimePickerComponent,
                    TimePickerPipe,
                ]
            }]
    }], function () { return []; }, null); })();
    return TimePickerModule;
}());

var EQUAL_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(function () { return EqualDirective; }),
    multi: true,
};
var EqualDirective = /** @class */ (function () {
    function EqualDirective() {
        this.onValidatorChange = noop;
    }
    Object.defineProperty(EqualDirective.prototype, "cdsEqual", {
        set: function (equalTo) {
            this.equalTo = equalTo;
            this.onValidatorChange();
        },
        enumerable: true,
        configurable: true
    });
    EqualDirective.prototype.validate = function (control) {
        if (control.value == null) {
            return null;
        }
        if (control.value !== this.equalTo) {
            return {
                notEqual: { valid: false },
            };
        }
        return null;
    };
    EqualDirective.prototype.registerOnValidatorChange = function (fn) {
        this.onValidatorChange = fn;
    };
    __decorate([
        Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], EqualDirective.prototype, "cdsEqual", null);
EqualDirective.ɵfac = function EqualDirective_Factory(t) { return new (t || EqualDirective)(); };
EqualDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: EqualDirective, selectors: [["", "cdsEqual", ""]], inputs: { cdsEqual: "cdsEqual" }, features: [ɵngcc0.ɵɵProvidersFeature([EQUAL_VALIDATOR])] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EqualDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsEqual]',
                providers: [EQUAL_VALIDATOR]
            }]
    }], function () { return []; }, { cdsEqual: [{
            type: Input
        }] }); })();
    return EqualDirective;
}());

var INVALID_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(function () { return InvalidDirective; }),
    multi: true,
};
var InvalidDirective = /** @class */ (function () {
    function InvalidDirective() {
        this.onValidatorChange = noop;
    }
    Object.defineProperty(InvalidDirective.prototype, "cdsInvalid", {
        set: function (invalid) {
            this.invalid = invalid;
            this.onValidatorChange();
        },
        enumerable: true,
        configurable: true
    });
    InvalidDirective.prototype.validate = function (control) {
        if (this.invalid) {
            return { 'invalid': true };
        }
        return null;
    };
    InvalidDirective.prototype.registerOnValidatorChange = function (fn) {
        this.onValidatorChange = fn;
    };
    __decorate([
        Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], InvalidDirective.prototype, "cdsInvalid", null);
InvalidDirective.ɵfac = function InvalidDirective_Factory(t) { return new (t || InvalidDirective)(); };
InvalidDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: InvalidDirective, selectors: [["", "cdsInvalid", ""]], inputs: { cdsInvalid: "cdsInvalid" }, features: [ɵngcc0.ɵɵProvidersFeature([INVALID_VALIDATOR])] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(InvalidDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsInvalid]',
                providers: [INVALID_VALIDATOR]
            }]
    }], function () { return []; }, { cdsInvalid: [{
            type: Input
        }] }); })();
    return InvalidDirective;
}());

var LENGTH_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(function () { return LengthDirective; }),
    multi: true,
};
var LengthDirective = /** @class */ (function () {
    function LengthDirective() {
        this.onValidatorChange = noop;
    }
    Object.defineProperty(LengthDirective.prototype, "cdsLength", {
        set: function (length) {
            this.length = length;
            this.onValidatorChange();
        },
        enumerable: true,
        configurable: true
    });
    LengthDirective.prototype.validate = function (control) {
        if (control.value == null || !control.value.length) {
            return null;
        }
        if (control.value.length !== this.length) {
            return {
                length: { requiredLength: this.length },
            };
        }
        return null;
    };
    LengthDirective.prototype.registerOnValidatorChange = function (fn) {
        this.onValidatorChange = fn;
    };
    __decorate([
        Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], LengthDirective.prototype, "cdsLength", null);
LengthDirective.ɵfac = function LengthDirective_Factory(t) { return new (t || LengthDirective)(); };
LengthDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: LengthDirective, selectors: [["", "cdsLength", ""]], inputs: { cdsLength: "cdsLength" }, features: [ɵngcc0.ɵɵProvidersFeature([LENGTH_VALIDATOR])] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LengthDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsLength]',
                providers: [LENGTH_VALIDATOR]
            }]
    }], function () { return []; }, { cdsLength: [{
            type: Input
        }] }); })();
    return LengthDirective;
}());

var NOT_EQUAL_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(function () { return NotEqualDirective; }),
    multi: true,
};
var NotEqualDirective = /** @class */ (function () {
    function NotEqualDirective() {
        this.onValidatorChange = noop;
    }
    Object.defineProperty(NotEqualDirective.prototype, "cdsNotEqual", {
        set: function (notEqualTo) {
            this.notEqualTo = notEqualTo;
            this.onValidatorChange();
        },
        enumerable: true,
        configurable: true
    });
    NotEqualDirective.prototype.validate = function (control) {
        if (control.value == null) {
            return null;
        }
        if (control.pristine && control.value === this.notEqualTo) {
            return null;
        }
        if (control.value === this.notEqualTo) {
            return {
                notEqual: { valid: false },
            };
        }
        return null;
    };
    NotEqualDirective.prototype.registerOnValidatorChange = function (fn) {
        this.onValidatorChange = fn;
    };
    __decorate([
        Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], NotEqualDirective.prototype, "cdsNotEqual", null);
NotEqualDirective.ɵfac = function NotEqualDirective_Factory(t) { return new (t || NotEqualDirective)(); };
NotEqualDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: NotEqualDirective, selectors: [["", "cdsNotEqual", ""]], inputs: { cdsNotEqual: "cdsNotEqual" }, features: [ɵngcc0.ɵɵProvidersFeature([NOT_EQUAL_VALIDATOR])] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NotEqualDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsNotEqual]',
                providers: [NOT_EQUAL_VALIDATOR]
            }]
    }], function () { return []; }, { cdsNotEqual: [{
            type: Input
        }] }); })();
    return NotEqualDirective;
}());

var UNIQUE_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(function () { return UniqueDirective; }),
    multi: true,
};
var UniqueDirective = /** @class */ (function () {
    function UniqueDirective() {
        this.onValidatorChange = noop;
    }
    Object.defineProperty(UniqueDirective.prototype, "cdsUnique", {
        set: function (items) {
            this.items = items;
            this.onValidatorChange();
        },
        enumerable: true,
        configurable: true
    });
    UniqueDirective.prototype.validate = function (control) {
        if (control.value == null) {
            return null;
        }
        if (this.items.indexOf(control.value) !== -1) {
            return {
                unique: { valid: false },
            };
        }
        return null;
    };
    UniqueDirective.prototype.registerOnValidatorChange = function (fn) {
        this.onValidatorChange = fn;
    };
    __decorate([
        Input(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [Array])
    ], UniqueDirective.prototype, "cdsUnique", null);
UniqueDirective.ɵfac = function UniqueDirective_Factory(t) { return new (t || UniqueDirective)(); };
UniqueDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: UniqueDirective, selectors: [["", "cdsUnique", ""]], inputs: { cdsUnique: "cdsUnique" }, features: [ɵngcc0.ɵɵProvidersFeature([UNIQUE_VALIDATOR])] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UniqueDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsUnique]',
                providers: [UNIQUE_VALIDATOR]
            }]
    }], function () { return []; }, { cdsUnique: [{
            type: Input
        }] }); })();
    return UniqueDirective;
}());

var VALIDATOR_FN_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(function () { return ValidatorFnDirective; }),
    multi: true,
};
var ValidatorFnDirective = /** @class */ (function () {
    function ValidatorFnDirective() {
        this.onValidatorChange = noop;
    }
    Object.defineProperty(ValidatorFnDirective.prototype, "cdsValidatorFn", {
        set: function (validatorFn) {
            this.validatorFn = validatorFn;
            this.onValidatorChange();
        },
        enumerable: true,
        configurable: true
    });
    ValidatorFnDirective.prototype.validate = function (control) {
        if (this.validatorFn) {
            return this.validatorFn(control);
        }
        return null;
    };
    ValidatorFnDirective.prototype.registerOnValidatorChange = function (fn) {
        this.onValidatorChange = fn;
    };
    __decorate([
        Input(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Function])
    ], ValidatorFnDirective.prototype, "cdsValidatorFn", null);
ValidatorFnDirective.ɵfac = function ValidatorFnDirective_Factory(t) { return new (t || ValidatorFnDirective)(); };
ValidatorFnDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ValidatorFnDirective, selectors: [["", "cdsValidatorFn", ""]], inputs: { cdsValidatorFn: "cdsValidatorFn" }, features: [ɵngcc0.ɵɵProvidersFeature([VALIDATOR_FN_VALIDATOR])] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ValidatorFnDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsValidatorFn]',
                providers: [VALIDATOR_FN_VALIDATOR]
            }]
    }], function () { return []; }, { cdsValidatorFn: [{
            type: Input
        }] }); })();
    return ValidatorFnDirective;
}());

var ValidationModule = /** @class */ (function () {
    function ValidationModule() {
    }
ValidationModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ValidationModule });
ValidationModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ValidationModule_Factory(t) { return new (t || ValidationModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ValidationModule, { declarations: [EqualDirective, InvalidDirective, LengthDirective, NotEqualDirective, UniqueDirective, ValidatorFnDirective], exports: [EqualDirective, InvalidDirective, LengthDirective, NotEqualDirective, UniqueDirective, ValidatorFnDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ValidationModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    EqualDirective,
                    InvalidDirective,
                    LengthDirective,
                    NotEqualDirective,
                    UniqueDirective,
                    ValidatorFnDirective,
                ],
                exports: [
                    EqualDirective,
                    InvalidDirective,
                    LengthDirective,
                    NotEqualDirective,
                    UniqueDirective,
                    ValidatorFnDirective,
                ]
            }]
    }], function () { return []; }, null); })();
    return ValidationModule;
}());

var AdjustTimeConstraintsPipe = /** @class */ (function () {
    function AdjustTimeConstraintsPipe() {
    }
    AdjustTimeConstraintsPipe.prototype.transform = function (constraints, currentDate) {
        if (!currentDate) {
            return constraints;
        }
        if (!constraints.from && !constraints.to) {
            return constraints;
        }
        var current = currentDate.substr(0, 10);
        var update = {};
        var secondsInDay = 24 * 3600;
        if (constraints.from && constraints.from.indexOf('T') !== -1) {
            var fromTime = constraints.from.split('T')[1];
            var fromDate = Time.fromDate(new Date(constraints.fromTime)).toString('date');
            if (fromDate === current) {
                var fromTimeNumber = constraints.getTimeNumber(fromTime, false).total;
                if (constraints.checkTimeRange(fromTimeNumber)) {
                    update.timeFrom = fromTime;
                    if (!constraints.timeTo || constraints.timeToNumber < fromTimeNumber) {
                        update.timeTo = timeNumberToString((secondsInDay - constraints.offsetInSeconds - 1) % secondsInDay);
                    }
                }
            }
        }
        if (constraints.to && constraints.to.indexOf('T') !== -1) {
            var toTime = constraints.to.split('T')[1];
            var toDate = Time.fromDate(new Date(constraints.toTime)).toString('date');
            if (toDate === current) {
                var toTimeNumber = constraints.getTimeNumber(toTime, false).total;
                if (constraints.checkTimeRange(toTimeNumber)) {
                    update.timeTo = toTime;
                    if (!update.timeFrom) {
                        if (!constraints.timeFrom || constraints.timeFromNumber > toTimeNumber) {
                            update.timeFrom = timeNumberToString((secondsInDay - constraints.offsetInSeconds) % secondsInDay);
                        }
                    }
                }
            }
        }
        if (update.timeFrom || update.timeTo) {
            return constraints.update(update);
        }
        return constraints;
    };
AdjustTimeConstraintsPipe.ɵfac = function AdjustTimeConstraintsPipe_Factory(t) { return new (t || AdjustTimeConstraintsPipe)(); };
AdjustTimeConstraintsPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "cdsAdjustTimeConstraints", type: AdjustTimeConstraintsPipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AdjustTimeConstraintsPipe, [{
        type: Pipe,
        args: [{
                name: 'cdsAdjustTimeConstraints'
            }]
    }], function () { return []; }, null); })();
    return AdjustTimeConstraintsPipe;
}());
function timeNumberToString(timeNumber) {
    var seconds = timeNumber % 60;
    timeNumber = Math.floor(timeNumber / 60);
    var minutes = timeNumber % 60;
    var hours = Math.floor(timeNumber / 60);
    return zeroPad(hours, 2) + ":" + zeroPad(minutes, 2) + ":" + zeroPad(seconds, 2);
}

var PortalServiceState = /** @class */ (function () {
    function PortalServiceState() {
    }
    return PortalServiceState;
}());
var BasePortalService = /** @class */ (function () {
    function BasePortalService(className, state, injector) {
        this.className = className;
        this.state = state;
        this.injector = injector;
        var cfRef = injector.get(ComponentFactoryResolver);
        this.appRef = injector.get(ApplicationRef);
        this.componentFactory = cfRef.resolveComponentFactory(PortalComponent);
    }
    BasePortalService.prototype.insertTemplate = function (templateRef, context, options) {
        return this.insertView(templateRef.createEmbeddedView(context), options);
    };
    BasePortalService.prototype.insertView = function (viewRef, options) {
        var _this = this;
        var componentRef = this.componentFactory.create(this.injector);
        this.appRef.attachView(componentRef.hostView);
        var element = this.getContainer();
        element.appendChild(componentRef.location.nativeElement);
        componentRef.instance.leave$.subscribe(function () {
            _this.clearContainer();
        });
        if (options && options.wrapperClass && isHTMLElement(componentRef.location.nativeElement)) {
            var className = componentRef.location.nativeElement.className;
            componentRef.location.nativeElement.className = className ? className + " " + options.wrapperClass : options.wrapperClass;
        }
        componentRef.instance.vcRef.insert(viewRef);
        componentRef.changeDetectorRef.detectChanges();
        return componentRef;
    };
    BasePortalService.prototype.getContainer = function () {
        if (!this.state.container) {
            this.state.container = document.createElement('div');
            this.state.container.className = this.className;
            document.body.appendChild(this.state.container);
        }
        return this.state.container;
    };
    BasePortalService.prototype.clearContainer = function () {
        if (this.state.container && this.state.container.childNodes.length === 0) {
            document.body.removeChild(this.state.container);
            this.state.container = null;
        }
    };
    return BasePortalService;
}());

function rootPortalServiceStateFactory() {
    return new PortalServiceState();
}
var ROOT_PORTAL_SERVICE_STATE = new InjectionToken('ROOT_PORTAL_SERVICE_STATE', {
    factory: rootPortalServiceStateFactory,
    providedIn: 'root',
});
var RootPortalService = /** @class */ (function (_super) {
    __extends(RootPortalService, _super);
    function RootPortalService(injector, state) {
        return _super.call(this, 'cds-root-portal', state, injector) || this;
    }
    RootPortalService.ctorParameters = function () { return [
        { type: Injector },
        { type: PortalServiceState, decorators: [{ type: Inject, args: [ROOT_PORTAL_SERVICE_STATE,] }] }
    ]; };
    RootPortalService.ɵprov = ɵɵdefineInjectable({ factory: function RootPortalService_Factory() { return new RootPortalService(ɵɵinject(INJECTOR), ɵɵinject(ROOT_PORTAL_SERVICE_STATE)); }, token: RootPortalService, providedIn: PortalModule });
    RootPortalService = __decorate([ __param(1, Inject(ROOT_PORTAL_SERVICE_STATE)),
        __metadata("design:paramtypes", [Injector, PortalServiceState])
    ], RootPortalService);
RootPortalService.ɵfac = function RootPortalService_Factory(t) { return new (t || RootPortalService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(ROOT_PORTAL_SERVICE_STATE)); };
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RootPortalService, [{
        type: Injectable,
        args: [{
                providedIn: PortalModule
            }]
    }], function () { return [{ type: ɵngcc0.Injector }, { type: PortalServiceState, decorators: [{
                type: Inject,
                args: [ROOT_PORTAL_SERVICE_STATE]
            }] }]; }, null); })();
    return RootPortalService;
}(BasePortalService));

var CDS_DIALOG_INSTANCE = new InjectionToken('CDS_DIALOG_INSTANCE');
var CDS_DIALOG_CONTEXT = new InjectionToken('CDS_DIALOG_CONTEXT');

var DialogService = /** @class */ (function () {
    function DialogService(rootPortalService, cfResolver, injector) {
        this.rootPortalService = rootPortalService;
        this.cfResolver = cfResolver;
        this.injector = injector;
    }
    DialogService.prototype.open = function (templateRefOrComponentType, context) {
        if (templateRefOrComponentType instanceof TemplateRef) {
            return this.openWitTemplate(templateRefOrComponentType, context);
        }
        else {
            return this.openWithComponentType(templateRefOrComponentType, context);
        }
    };
    DialogService.prototype.openWithComponentType = function (componentType, context) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var factory = _this.cfResolver.resolveComponentFactory(componentType);
            var instance = {
                resolve: function (value) {
                    resolve(value);
                    ref.destroy();
                },
                reject: function (error) {
                    reject(error);
                    ref.destroy();
                },
            };
            var injector = Injector.create({
                parent: _this.injector,
                providers: [
                    { provide: CDS_DIALOG_INSTANCE, useValue: instance },
                    { provide: CDS_DIALOG_CONTEXT, useValue: context },
                ],
            });
            var component = factory.create(injector);
            var ref = _this.rootPortalService.insertView(component.hostView, {
                wrapperClass: 'cds-dialog-z-index cds-dialog-service-container',
            });
            ref.onDestroy(function () {
                reject();
            });
        });
    };
    DialogService.prototype.openWitTemplate = function (templateRef, context) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var ref = _this.rootPortalService.insertTemplate(templateRef, __assign(__assign({}, context), { $implicit: {
                    resolve: function (value) {
                        resolve(value);
                        ref.destroy();
                    },
                    reject: function (error) {
                        reject(error);
                        ref.destroy();
                    },
                } }), {
                wrapperClass: 'cds-dialog-z-index cds-dialog-service-container',
            });
            ref.onDestroy(function () {
                reject();
            });
        });
    };
    DialogService.ctorParameters = function () { return [
        { type: RootPortalService },
        { type: ComponentFactoryResolver },
        { type: Injector }
    ]; };
    DialogService.ɵprov = ɵɵdefineInjectable({ factory: function DialogService_Factory() { return new DialogService(ɵɵinject(RootPortalService), ɵɵinject(ComponentFactoryResolver), ɵɵinject(INJECTOR)); }, token: DialogService, providedIn: DialogModule });
    DialogService = __decorate([ __metadata("design:paramtypes", [RootPortalService,
            ComponentFactoryResolver,
            Injector])
    ], DialogService);
DialogService.ɵfac = function DialogService_Factory(t) { return new (t || DialogService)(ɵngcc0.ɵɵinject(RootPortalService), ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DialogService, [{
        type: Injectable,
        args: [{
                providedIn: DialogModule
            }]
    }], function () { return [{ type: RootPortalService }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.Injector }]; }, null); })();
    return DialogService;
}());

var DATE_TIME_TRANSLATIONS_EN = {
    applyButton: 'Apply',
    clearButton: 'Clear',
    cancelButton: 'Cancel',
    apply: 'Apply',
    cancel: 'Cancel',
    selectDateHeader: 'Select date',
    selectDateRangeHeader: 'Select date range',
    selectTimeHeader: 'Select time',
    dateFormat: 'yyyy/M/d',
    dateRangeFormat: 'yyyy/M/d-yyyy/M/d',
    dateTimeFormat: 'yyyy/M/d HH:mm:ss',
    timeFormat: 'HH:mm:ss',
    timeLabel: 'Time',
    timezoneLabel: 'Time zone',
    dayPeriodLabel: 'Format',
    dateInputLabel: 'Press enter to open date selection dialog',
};
function dateTimeTranslationsFactory() {
    return DATE_TIME_TRANSLATIONS_EN;
}
var CDS_DATE_TIME_TRANSLATIONS = new InjectionToken('CDS_DATE_TIME_TRANSLATIONS', { factory: dateTimeTranslationsFactory });

var DATE_RANGE_INPUT_VALUE_TEXT = new WeakMap();

var DateTimeService = /** @class */ (function () {
    function DateTimeService(locale, injector) {
        var _this = this;
        this.locale = locale;
        this.parsers = {};
        this.fieldsMap = {
            'yyyy': { regex: '\\d{4,}', field: 'year' },
            'yyy': { regex: '\\d{3,}', field: 'year' },
            'yy': { regex: '\\d{2,}', field: 'year' },
            'y': { regex: '[1-9]\\d*', field: 'year' },
            'MM': { regex: '0?[1-9]|1[0-2]', field: 'month' },
            'M': { regex: '0?[1-9]|1[0-2]', field: 'month' },
            'LL': { regex: '0?[1-9]|1[0-2]', field: 'month' },
            'L': { regex: '0?[1-9]|1[0-2]', field: 'month' },
            'dd': { regex: '0?[1-9]|[12][0-9]|3[01]', field: 'day' },
            'd': { regex: '0?[1-9]|[12][0-9]|3[01]', field: 'day' },
            'hh': { regex: '0?[1-9]|1[0-2]', field: 'hours' },
            'h': { regex: '0?[1-9]|1[0-2]', field: 'hours' },
            'HH': { regex: '0?[0-9]|1[0-9]|2[0-3]', field: 'hours' },
            'H': { regex: '0?[0-9]|1[0-9]|2[0-3]', field: 'hours' },
            'mm': { regex: '[0-5]?\\d', field: 'minutes' },
            'm': { regex: '[0-5]?\\d', field: 'minutes' },
            'ss': { regex: '[0-5]?\\d', field: 'seconds' },
            's': { regex: '[0-5]?\\d', field: 'seconds' },
            'aaa': { enum: getLocaleDayPeriods(this.locale, FormStyle.Format, TranslationWidth.Abbreviated), field: 'period' },
            'aa': { enum: getLocaleDayPeriods(this.locale, FormStyle.Format, TranslationWidth.Abbreviated), field: 'period' },
            'a': { enum: getLocaleDayPeriods(this.locale, FormStyle.Format, TranslationWidth.Abbreviated), field: 'period' },
        };
        this.fieldsRegex = new RegExp(Object.keys(this.fieldsMap).sort(function (a, b) { return b.length - a.length; }).join('|'), 'g');
        this.componentTranslations = new DynamicTranslations(injector, null);
        this.componentTranslations.use(CDS_DATE_TIME_TRANSLATIONS, dateTimeTranslationsFactory, function (translations) {
            _this.translations = translations;
        });
    }
    DateTimeService.prototype.ngOnDestroy = function () {
        if (this.componentTranslations) {
            this.componentTranslations.ngOnDestroy();
        }
    };
    DateTimeService.prototype.getDayPeriods = function () {
        return getLocaleDayPeriods(this.locale, FormStyle.Standalone, TranslationWidth.Abbreviated);
    };
    DateTimeService.prototype.resolveFormat = function (format) {
        if (format === 'daterange') {
            return this.translations.dateRangeFormat;
        }
        else if (format === 'date' || !format) {
            return this.translations.dateFormat;
        }
        else if (format === 'datetime') {
            return this.translations.dateTimeFormat;
        }
        else if (format === 'time') {
            return this.translations.timeFormat;
        }
        else {
            return format;
        }
    };
    DateTimeService.prototype.includesSeconds = function (format) {
        format = this.resolveFormat(format);
        return format.indexOf('s') !== -1;
    };
    DateTimeService.prototype.includesTime = function (format) {
        format = this.resolveFormat(format);
        return format.indexOf('h') !== -1
            || format.indexOf('H') !== -1;
    };
    DateTimeService.prototype.includesDate = function (format) {
        format = this.resolveFormat(format);
        return format.indexOf('y') !== -1
            || format.indexOf('M') !== -1
            || format.indexOf('L') !== -1
            || format.indexOf('d') !== -1;
    };
    DateTimeService.prototype.includesRange = function (format) {
        format = this.resolveFormat(format);
        return format.indexOf('-') !== -1
            && format.indexOf('y') !== -1;
    };
    DateTimeService.prototype.format = function (value, format, offsetInSeconds) {
        if (offsetInSeconds === void 0) { offsetInSeconds = 0; }
        format = this.resolveFormat(format);
        if (value == null) {
            return null;
        }
        try {
            var time = Time.fromString(value).getTime() + offsetInSeconds * 1000;
            var formatted = formatDate(time, format, this.locale);
            return formatted;
        }
        catch (e) { }
        return null;
    };
    DateTimeService.prototype.is12hMode = function (format) {
        format = this.resolveFormat(format);
        return format.indexOf('h') !== -1
            || format.indexOf('a') !== -1;
    };
    DateTimeService.prototype.parse = function (value, format, dayPeriod) {
        if (value == null) {
            return null;
        }
        format = this.resolveFormat(format);
        var parser = this.getParser(format);
        var match = parser.match(value);
        if (!match) {
            return null;
        }
        try {
            var includeDate = this.includesDate(format);
            var includeTime = this.includesTime(format);
            dayPeriod = dayPeriod || match.period;
            if (dayPeriod && match.hours != null) {
                if (dayPeriod === 'PM') {
                    match.hours = match.hours < 12 ? (match.hours + 12) : match.hours;
                }
                else {
                    match.hours = match.hours === 12 ? 0 : match.hours;
                }
            }
            return Time.fromObject(match).toString(includeDate ? (includeTime ? 'datetime' : 'date') : (includeTime ? 'time' : null));
        }
        catch (e) {
            return null;
        }
    };
    DateTimeService.prototype.getParser = function (format) {
        var parser = this.parsers[format];
        if (!parser) {
            parser = new DateTimeParser(format, this.fieldsMap, this.fieldsRegex);
            this.parsers[format] = parser;
        }
        return parser;
    };
    DateTimeService.ctorParameters = function () { return [
        { type: String, decorators: [{ type: Inject, args: [LOCALE_ID,] }] },
        { type: Injector }
    ]; };
    DateTimeService.ɵprov = ɵɵdefineInjectable({ factory: function DateTimeService_Factory() { return new DateTimeService(ɵɵinject(LOCALE_ID), ɵɵinject(INJECTOR)); }, token: DateTimeService, providedIn: "root" });
    DateTimeService = __decorate([ __param(0, Inject(LOCALE_ID)),
        __metadata("design:paramtypes", [String, Injector])
    ], DateTimeService);
DateTimeService.ɵfac = function DateTimeService_Factory(t) { return new (t || DateTimeService)(ɵngcc0.ɵɵinject(LOCALE_ID), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DateTimeService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [LOCALE_ID]
            }] }, { type: ɵngcc0.Injector }]; }, null); })();
    return DateTimeService;
}());
var DateTimeParser = /** @class */ (function () {
    function DateTimeParser(format, fieldsMap, fieldsRegex) {
        var _this = this;
        this.format = format;
        this.fieldsMap = fieldsMap;
        this.fields = [];
        var regex = format.replace(/(\\\^\$\.\|\?\*\+\(\)\[\{)/g, '\\$1').replace(/\/|\.|\-|\:/g, '[\\/|\\.|\\-|\\:]');
        regex = regex.replace(fieldsRegex, function (match, offset) {
            var field = fieldsMap[match];
            _this.fields.push({
                key: match,
                field: field.field,
            });
            if ('regex' in field) {
                return "(" + field.regex + ")";
            }
            else {
                return "(" + field.enum.join('|') + ")";
            }
        });
        this.regex = new RegExp("^" + regex + "$", 'i');
        this.regexNotComplete = new RegExp("" + regex, 'i');
    }
    DateTimeParser.prototype.test = function (value, _a) {
        var _b = (_a === void 0 ? {} : _a).complete, complete = _b === void 0 ? true : _b;
        return (complete ? this.regex : this.regexNotComplete).exec(value);
    };
    DateTimeParser.prototype.match = function (value) {
        var _this = this;
        var rmatch = this.regex.exec(value);
        if (!rmatch) {
            return null;
        }
        var match = this.fields.reduce(function (match, field, index) {
            var stringValue = rmatch[index + 1];
            var value = +stringValue;
            if (value <= 99 && value >= 0 && field.key === 'yy' || field.key == 'y') {
                value += 2000;
            }
            else if (field.field === 'period') {
                var fieldDef = _this.fieldsMap[field.key];
                if ('enum' in fieldDef) {
                    match[field.field] = fieldDef.enum[0] === stringValue ? 'AM' : fieldDef.enum[1] === stringValue ? 'PM' : null;
                    return match;
                }
                else {
                    value = null;
                }
            }
            match[field.field] = value;
            return match;
        }, {});
        return match;
    };
    return DateTimeParser;
}());

var DateTimeValidatorService = /** @class */ (function () {
    function DateTimeValidatorService(dateTimeService) {
        this.dateTimeService = dateTimeService;
    }
    DateTimeValidatorService.prototype.formatDate = function (value, format, offsetInSeconds) {
        var useDayPeriod = this.dateTimeService.is12hMode(format);
        var newFormat = useDayPeriod && format.indexOf('a') === -1 ? format + " a" : format;
        return this.dateTimeService.format(value, newFormat, offsetInSeconds);
    };
    DateTimeValidatorService.prototype.validateRange = function (constraints, value, format) {
        if (!value) {
            return null;
        }
        if (!value.from || !value.to) {
            return { 'date-invalid': { value: DATE_RANGE_INPUT_VALUE_TEXT.get(value) } };
        }
        var rangeConstraints = constraints.update({
            rangeFrom: value.from,
            rangeTo: value.to,
        });
        var errors = null;
        if (value.from) {
            errors = errors || this.validate(rangeConstraints, value.from, format, 'date');
        }
        if (value.to) {
            errors = errors || this.validate(rangeConstraints, value.to, format, 'date');
        }
        return errors;
    };
    DateTimeValidatorService.prototype.validate = function (constraints, value, format, mode) {
        if (!value) {
            return null;
        }
        var time;
        try {
            time = Time.fromString(value);
        }
        catch (error) {
            return { 'date-invalid': { value: value } };
        }
        var selectedMode = mode || constraints.mode;
        var timeString = time.toString(selectedMode);
        if (timeString !== value.substr(0, timeString.length)) {
            if (selectedMode && selectedMode !== 'time') {
                return { 'date-invalid': { value: value } };
            }
            else {
                timeString = time.toString('time');
                if (timeString !== value.substr(0, timeString.length)) {
                    return { 'date-invalid': { value: value } };
                }
            }
        }
        var validateTime = !selectedMode || selectedMode != 'date';
        var validateDate = !selectedMode || selectedMode != 'time';
        if (validateDate) {
            if (this.validateFrom(constraints, time)) {
                return { 'date-from': { value: value, from: this.formatDate(constraints.from, format, constraints.offsetInSeconds) } };
            }
            if (this.validateRangeFrom(constraints, time)) {
                return { 'date-from': { value: value, from: this.formatDate(constraints.rangeFrom, format, constraints.offsetInSeconds) } };
            }
            if (this.validateTo(constraints, time)) {
                return { 'date-to': { value: value, to: this.formatDate(constraints.to, format, constraints.offsetInSeconds) } };
            }
            if (this.validateDisableWeekends(constraints, time)) {
                return { 'date-disable-weekends': { value: value } };
            }
            if (this.validateAllowedDays(constraints, time)) {
                return { 'date-allowed-days': { value: value } };
            }
        }
        if (validateTime) {
            if (this.validateTimeSteps(constraints, time)) {
                return { 'date-time-steps': { value: value, hourStep: constraints.hourStep, minuteStep: constraints.minuteStep, secondStep: constraints.secondStep } };
            }
        }
        if (this.validateTimeRange(constraints, time)) {
            var useDayPeriod = this.dateTimeService.is12hMode(format);
            var from = this.formatTime(constraints.timeFromHour, constraints.timeFromMinute, constraints.timeFromSecond, useDayPeriod);
            var to = this.formatTime(constraints.timeToHour, constraints.timeToMinute, constraints.timeToSecond, useDayPeriod);
            return { 'date-time-range': { value: value, from: from, to: to } };
        }
        return null;
    };
    DateTimeValidatorService.prototype.createValidator = function (constraints, format) {
        var _this = this;
        return function (control) {
            return _this.validate(constraints, control.value, format);
        };
    };
    DateTimeValidatorService.prototype.validateFrom = function (constraints, value) {
        return constraints.fromTime != null && constraints.fromTime > value.getTime();
    };
    DateTimeValidatorService.prototype.validateRangeFrom = function (constraints, value) {
        return constraints.rangeFromTime != null && constraints.rangeFromTime > value.getTime();
    };
    DateTimeValidatorService.prototype.validateTo = function (constraints, value) {
        return constraints.toTime != null && constraints.toTime < value.getTime();
    };
    DateTimeValidatorService.prototype.validateDisableWeekends = function (constraints, value) {
        return constraints.disableWeekends && value.isWeekend();
    };
    DateTimeValidatorService.prototype.validateAllowedDays = function (constraints, value) {
        return constraints.allowedDaysSet != null && constraints.allowedDaysSet.has(value.toString()) !== true;
    };
    DateTimeValidatorService.prototype.validateTimeSteps = function (constraints, value) {
        var date = value.toDate();
        if (constraints.hourStep != null && date.getHours() % constraints.hourStep !== 0) {
            return true;
        }
        if (constraints.minuteStep != null && date.getMinutes() % constraints.minuteStep !== 0) {
            return true;
        }
        if (constraints.secondStep != null && date.getSeconds() % constraints.secondStep !== 0) {
            return true;
        }
    };
    DateTimeValidatorService.prototype.validateTimeRange = function (constraints, value) {
        if (constraints.timeFrom != null && constraints.timeTo != null) {
            var date = value.toDate();
            var timeNumber = date.getHours() * 3600 + date.getMinutes() * 60 + date.getSeconds();
            return !constraints.checkTimeRange(timeNumber);
        }
        return false;
    };
    DateTimeValidatorService.prototype.padNumber = function (value) {
        if (value < 10) {
            return "0" + value;
        }
        else {
            return "" + value;
        }
    };
    DateTimeValidatorService.prototype.getDayPeriod = function (hour) {
        var _a = __read(this.dateTimeService.getDayPeriods(), 2), AM = _a[0], PM = _a[1];
        return hour >= 12 ? PM : AM;
    };
    DateTimeValidatorService.prototype.recalculateHour = function (hourValue, useDayPeriod) {
        return useDayPeriod ? ((hourValue % 12) || 12) : hourValue;
    };
    DateTimeValidatorService.prototype.formatTime = function (hours, minutes, seconds, useDayPeriod) {
        var time = this.padNumber(this.recalculateHour(hours, useDayPeriod)) + ":" + this.padNumber(minutes) + ":" + this.padNumber(seconds);
        return useDayPeriod ? time + " " + this.getDayPeriod(hours) : time;
    };
    DateTimeValidatorService.ctorParameters = function () { return [
        { type: DateTimeService }
    ]; };
    DateTimeValidatorService.ɵprov = ɵɵdefineInjectable({ factory: function DateTimeValidatorService_Factory() { return new DateTimeValidatorService(ɵɵinject(DateTimeService)); }, token: DateTimeValidatorService, providedIn: "root" });
    DateTimeValidatorService = __decorate([ __metadata("design:paramtypes", [DateTimeService])
    ], DateTimeValidatorService);
DateTimeValidatorService.ɵfac = function DateTimeValidatorService_Factory(t) { return new (t || DateTimeValidatorService)(ɵngcc0.ɵɵinject(DateTimeService)); };
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DateTimeValidatorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DateTimeService }]; }, null); })();
    return DateTimeValidatorService;
}());

var DATE_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return DateControlComponent; }),
    multi: true,
};
var DATE_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(function () { return DateControlComponent; }),
    multi: true,
};
var DateControlComponent = /** @class */ (function (_super) {
    __extends(DateControlComponent, _super);
    function DateControlComponent(elementRef, renderer, timezonesService, cdRef, dateTimeService, dateTimeValidatorService, dialogService, componentTranslations, now) {
        var _this = _super.call(this, timezonesService) || this;
        _this.elementRef = elementRef;
        _this.cdRef = cdRef;
        _this.dateTimeService = dateTimeService;
        _this.dateTimeValidatorService = dateTimeValidatorService;
        _this.dialogService = dialogService;
        _this.now = now;
        _this.keepFocus = false;
        _this.appearance = 'outline';
        _this.format = 'date';
        _this.inlineEdit = false;
        _this.dateRequired = false;
        _this.padDaysInMonth = false;
        _this.disabled = false;
        _this.onTouchedCallback = noop;
        _this.onChangeCallback = noop;
        _this.onValidatorChange = noop;
        renderer.addClass(elementRef.nativeElement, 'cds-date-control');
        renderer.addClass(elementRef.nativeElement, 'cds-control--parent');
        renderer.addClass(elementRef.nativeElement, 'cds-control');
        componentTranslations.use(CDS_DATE_TIME_TRANSLATIONS, dateTimeTranslationsFactory, function (translations) {
            _this.translations = translations;
            if (_this.afterChanges) {
                cdRef.detectChanges();
            }
        });
        return _this;
    }
    DateControlComponent.prototype.ngOnInit = function () {
        if (!this.afterChanges) {
            this.ngOnChanges({});
        }
        var defaultDate = getDefaultDate(this.constraints, new Date(this.now()));
        this.defaultDate = Time.fromDate(defaultDate).toString('date');
    };
    DateControlComponent.prototype.ngOnChanges = function (changes) {
        this.afterChanges = true;
        _super.prototype.ngOnChanges.call(this, changes);
        if ('timezoneValue' in changes) {
            this.setTimezone(this.timezoneValue);
        }
        if (this.inChanges(changes, ['format', 'from', 'to', 'rangeFrom', 'rangeTo', 'disableWeekends', 'allowedDays', 'dateRequired', 'timezoneValue', 'timeValue'])) {
            this.onValidatorChange();
        }
    };
    DateControlComponent.prototype.inChanges = function (changes, keys) {
        return keys.some(function (key) { return key in changes; });
    };
    DateControlComponent.prototype.onOpenChange = function (isOpen) {
        if (isOpen && !this.isOpen) {
            this.currentValue = this.inputValue;
        }
        else if (!isOpen && this.isOpen) {
            this.restoreCurrentValue(this.currentValue);
            /** writeValue to format input view value */
            this.input.writeValue(this.inputValue);
        }
        if (!this.disabled) {
            this.isOpen = isOpen;
            this.keepFocus = isOpen;
            this.cdRef.detectChanges();
            if (isOpen && this.dropdown) {
                this.dropdown.scheduleUpdate();
            }
        }
    };
    DateControlComponent.prototype.writeValue = function (modelValue) {
        this.restoreCurrentValue(modelValue);
        this.cdRef.markForCheck();
    };
    DateControlComponent.prototype.restoreCurrentValue = function (value) {
        try {
            var date = Time.fromString(value).toDate();
            this.inputValue = value;
            this.calendarValue = Time.fromDate(date).toString('date');
        }
        catch (e) {
            this.inputValue = null;
            this.calendarValue = null;
        }
    };
    DateControlComponent.prototype.changeInputValue = function (newValue) {
        try {
            var date = Time.fromString(newValue).toDate();
            this.calendarValue = Time.fromDate(date).toString('date');
        }
        catch (e) {
            this.calendarValue = null;
        }
        this.inputValue = newValue;
        if (!this.isOpen) {
            this.currentValue = this.inputValue;
            this.onChangeCallback(this.inputValue);
        }
        this.cdRef.detectChanges();
    };
    DateControlComponent.prototype.changeCalendarValue = function (newValue) {
        try {
            var date = Time.fromString(newValue).toDate();
            this.inputValue = Time.fromDate(date).toString('date');
        }
        catch (e) {
            this.inputValue = null;
        }
        this.calendarValue = newValue;
        this.cdRef.detectChanges();
    };
    DateControlComponent.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    DateControlComponent.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    DateControlComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
        this.cdRef.markForCheck();
    };
    DateControlComponent.prototype.validate = function (control) {
        this.cdRef.markForCheck();
        if (!control.value) {
            this.errors = this.dateRequired ? { required: true } : null;
        }
        else {
            var mode = this.timeValue != null || this.timezoneValue != null ? 'datetime' : 'date';
            var value = mode === 'datetime'
                ? (this.constraints.offset >= 0
                    ? control.value + "T00:00:00"
                    : control.value + "T23:59:59")
                : control.value;
            this.errors = this.dateTimeValidatorService.validate(this.constraints, value, this.format, mode);
        }
        return this.errors;
    };
    DateControlComponent.prototype.registerOnValidatorChange = function (fn) {
        this.onValidatorChange = fn;
    };
    DateControlComponent.prototype.onBlur = function () {
        this.onTouchedCallback();
    };
    DateControlComponent.prototype.onMouseDown = function () {
        if (!this.disabled) {
            this.keepFocus = true;
        }
    };
    DateControlComponent.prototype.setTimezone = function (timezoneCode) {
        if (timezoneCode) {
            this.constraints = this.constraints.updateTimezone(this.timezonesService.getTimezone(timezoneCode));
        }
    };
    DateControlComponent.prototype.updatedConstraints = function () {
        return __assign({ mode: 'date' }, _super.prototype.updatedConstraints.call(this));
    };
    DateControlComponent.prototype.applyValue = function () {
        this.currentValue = this.inputValue;
        this.onChangeCallback(this.inputValue);
        this.onOpenChange(false);
    };
    DateControlComponent.prototype.clearValue = function () {
        this.onOpenChange(false);
    };
    DateControlComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: TimezonesService },
        { type: ChangeDetectorRef },
        { type: DateTimeService },
        { type: DateTimeValidatorService },
        { type: DialogService },
        { type: DynamicTranslations },
        { type: undefined, decorators: [{ type: Inject, args: [CDS_DATE_TIME_NOW,] }] }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateControlComponent.prototype, "appearance", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateControlComponent.prototype, "format", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateControlComponent.prototype, "timeValue", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateControlComponent.prototype, "placeholder", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateControlComponent.prototype, "label", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateControlComponent.prototype, "inlineEdit", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateControlComponent.prototype, "dateRequired", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], DateControlComponent.prototype, "numberOfMonths", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateControlComponent.prototype, "padDaysInMonth", void 0);
    __decorate([
        ViewChild('dropdown'),
        __metadata("design:type", DropdownComponent)
    ], DateControlComponent.prototype, "dropdown", void 0);
    __decorate([
        ViewChild('input', { static: true }),
        __metadata("design:type", InputComponent)
    ], DateControlComponent.prototype, "input", void 0);
    DateControlComponent = __decorate([ __param(8, Inject(CDS_DATE_TIME_NOW)),
        __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            TimezonesService,
            ChangeDetectorRef,
            DateTimeService,
            DateTimeValidatorService,
            DialogService,
            DynamicTranslations, Function])
    ], DateControlComponent);
DateControlComponent.ɵfac = function DateControlComponent_Factory(t) { return new (t || DateControlComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(TimezonesService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DateTimeService), ɵngcc0.ɵɵdirectiveInject(DateTimeValidatorService), ɵngcc0.ɵɵdirectiveInject(DialogService), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations), ɵngcc0.ɵɵdirectiveInject(CDS_DATE_TIME_NOW)); };
DateControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DateControlComponent, selectors: [["cds-date-control"]], viewQuery: function DateControlComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c14, true);
        ɵngcc0.ɵɵstaticViewQuery(_c5, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, inputs: { appearance: "appearance", format: "format", timeValue: "timeValue", placeholder: "placeholder", label: "label", inlineEdit: "inlineEdit", dateRequired: "dateRequired", numberOfMonths: "numberOfMonths", padDaysInMonth: "padDaysInMonth" }, features: [ɵngcc0.ɵɵProvidersFeature([DATE_CONTROL_VALUE_ACCESSOR, DATE_VALIDATOR, DynamicTranslations]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 17, consts: [["cdsDateInput", "", 1, "cds-date-control__control", "cds-control--child", 3, "appearance", "format", "constraints", "timeValue", "timezoneValue", "cdsDateKeyboardNavigation", "keyboardConstraints", "selected", "ngModel", "label", "placeholder", "readonly", "disabled", "cdsInvalid", "cdsDateKeyboardNavigationChange", "ngModelChange", "focus", "mousedown", "blur", "keydown.enter", "cdsOnEscape"], ["input", "", "inputModel", "ngModel"], ["class", "cds-date-control__dropdown cds-dropdown--auto-height", 3, "anchor", "dismiss", 4, "ngIf"], [1, "cds-date-control__dropdown", "cds-dropdown--auto-height", 3, "anchor", "dismiss"], ["dropdown", ""], [1, "cds-date-control__scrollable"], [1, "cds-date-control__content"], [3, "constraints", "numberOfMonths", "startRange", "endRange", "padDaysInMonth", "ngModel", "ngModelChange"], [1, "cds-date-control__footer"], ["cdsButton", "", "type", "button", 1, "cds-button-text", 3, "click"], ["cdsButton", "", "type", "button", 1, "cds-button-primary", 3, "disabled", "click"]], template: function DateControlComponent_Template(rf, ctx) { if (rf & 1) {
        var _r9 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "cds-input", 0, 1);
        ɵngcc0.ɵɵlistener("cdsDateKeyboardNavigationChange", function DateControlComponent_Template_cds_input_cdsDateKeyboardNavigationChange_0_listener($event) { return ctx.changeCalendarValue($event); })("ngModelChange", function DateControlComponent_Template_cds_input_ngModelChange_0_listener($event) { return ctx.changeInputValue($event); })("focus", function DateControlComponent_Template_cds_input_focus_0_listener() { return ctx.onOpenChange(true); })("mousedown", function DateControlComponent_Template_cds_input_mousedown_0_listener() { return ctx.onMouseDown(); })("blur", function DateControlComponent_Template_cds_input_blur_0_listener() { return ctx.onBlur(); })("keydown.enter", function DateControlComponent_Template_cds_input_keydown_enter_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); var _r1 = ɵngcc0.ɵɵreference(2); return ctx.isOpen ? _r1.valid && ctx.applyValue() : ctx.onOpenChange(true); })("cdsOnEscape", function DateControlComponent_Template_cds_input_cdsOnEscape_0_listener() { return ctx.clearValue(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, DateControlComponent_cds_dropdown_3_Template, 10, 12, "cds-dropdown", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("cds-control--required", ctx.dateRequired);
        ɵngcc0.ɵɵproperty("appearance", ctx.appearance)("format", ctx.format)("constraints", ctx.isOpen ? ctx.constraints : null)("timeValue", ctx.timeValue)("timezoneValue", ctx.timezoneValue)("cdsDateKeyboardNavigation", ctx.calendarValue || ctx.defaultDate)("keyboardConstraints", ctx.constraints)("selected", ctx.keepFocus)("ngModel", ctx.inputValue)("label", ctx.label || ctx.translations.selectDateHeader)("placeholder", ctx.placeholder)("readonly", !ctx.inlineEdit)("disabled", ctx.disabled)("cdsInvalid", ctx.isOpen ? false : ctx.errors != null);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isOpen);
    } }, directives: function () { return [InputComponent, DateInputDirective, DateKeyboardNavigationDirective, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, InvalidDirective, OnEscapeDirective, ɵngcc1.NgIf, DropdownComponent, CalendarRangeComponent, ButtonRippleDirective]; }, encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DateControlComponent, [{
        type: Component,
        args: [{
                selector: 'cds-date-control',
                template: "<cds-input #input #inputModel=\"ngModel\"\n           [appearance]=\"appearance\"\n           class=\"cds-date-control__control cds-control--child\"\n           [class.cds-control--required]=\"dateRequired\"\n           cdsDateInput\n           [format]=\"format\"\n           [constraints]=\"isOpen ? constraints : null\"\n           [timeValue]=\"timeValue\"\n           [timezoneValue]=\"timezoneValue\"\n           [cdsDateKeyboardNavigation]=\"calendarValue || defaultDate\"\n           (cdsDateKeyboardNavigationChange)=\"changeCalendarValue($event)\"\n           [keyboardConstraints]=\"constraints\"\n           [selected]=\"keepFocus\"\n           [ngModel]=\"inputValue\"\n           (ngModelChange)=\"changeInputValue($event)\"\n           [label]=\"label || translations.selectDateHeader\"\n           [placeholder]=\"placeholder\"\n           [readonly]=\"!inlineEdit\"\n           [disabled]=\"disabled\"\n           [cdsInvalid]=\"isOpen ? false : errors != null\"\n           (focus)=\"onOpenChange(true)\"\n           (mousedown)=\"onMouseDown()\"\n           (blur)=\"onBlur()\"\n           (keydown.enter)=\"isOpen ? (inputModel.valid && applyValue()) : onOpenChange(true)\"\n           (cdsOnEscape)=\"clearValue()\">\n</cds-input>\n<cds-dropdown #dropdown *ngIf=\"isOpen\" (dismiss)=\"onOpenChange(false)\" [anchor]=\"input.elementRef\" class=\"cds-date-control__dropdown cds-dropdown--auto-height\">\n\t<div class=\"cds-date-control__scrollable\">\n\t\t<div class=\"cds-date-control__content\">\n\t\t\t<cds-calendar-range [constraints]=\"constraints\"\n\t\t\t                    [numberOfMonths]=\"numberOfMonths\"\n\t\t\t                    [startRange]=\"(rangeFrom || rangeTo) ? (rangeFrom || calendarValue) : null\"\n\t\t\t                    [endRange]=\"(rangeFrom || rangeTo) ? (rangeTo || calendarValue) : null\"\n\t\t\t                    [padDaysInMonth]=\"padDaysInMonth\"\n\t\t\t                    [ngModel]=\"calendarValue\"\n\t\t\t                    (ngModelChange)=\"changeCalendarValue($event)\"></cds-calendar-range>\n\t\t</div>\n\t</div>\n\t<div class=\"cds-date-control__footer\">\n\t\t<button cdsButton type=\"button\" class=\"cds-button-text\" (click)=\"clearValue()\" [attr.aria-label]=\"translations.cancel\">{{translations.cancelButton}}</button>\n\t\t<button cdsButton type=\"button\" class=\"cds-button-primary\" (click)=\"applyValue()\" [attr.aria-label]=\"translations.apply\" [disabled]=\"!inputModel.valid\">{{translations.applyButton}}</button>\n\t</div>\n</cds-dropdown>\n",
                providers: [DATE_CONTROL_VALUE_ACCESSOR, DATE_VALIDATOR, DynamicTranslations],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: TimezonesService }, { type: ɵngcc0.ChangeDetectorRef }, { type: DateTimeService }, { type: DateTimeValidatorService }, { type: DialogService }, { type: DynamicTranslations }, { type: undefined, decorators: [{
                type: Inject,
                args: [CDS_DATE_TIME_NOW]
            }] }]; }, { appearance: [{
            type: Input
        }], format: [{
            type: Input
        }], timeValue: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], label: [{
            type: Input
        }], inlineEdit: [{
            type: Input
        }], dateRequired: [{
            type: Input
        }], numberOfMonths: [{
            type: Input
        }], padDaysInMonth: [{
            type: Input
        }], dropdown: [{
            type: ViewChild,
            args: ['dropdown']
        }], input: [{
            type: ViewChild,
            args: ['input', { static: true }]
        }] }); })();
    return DateControlComponent;
}(BaseDateTimeComponent));

var DATE_INPUT_MODEL_TRANSFORMER = {
    provide: CDS_INPUT_MODEL_TRANSFORMER,
    useExisting: forwardRef(function () { return DateInputDirective; }),
};
var DATE_INPUT_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(function () { return DateInputDirective; }),
    multi: true,
};
var DateInputDirective = /** @class */ (function (_super) {
    __extends(DateInputDirective, _super);
    function DateInputDirective(timezonesService, dateTimeService, dateTimeValidatorService, componentTranslations) {
        var _this = _super.call(this, timezonesService) || this;
        _this.dateTimeService = dateTimeService;
        _this.dateTimeValidatorService = dateTimeValidatorService;
        _this.onValidatorChange = noop;
        componentTranslations.use(CDS_DATE_TIME_TRANSLATIONS, dateTimeTranslationsFactory, function (translations) {
            _this.translations = translations;
        });
        return _this;
    }
    DateInputDirective.prototype.formatModelValue = function (modelValue) {
        if (this.type !== 'date') {
            return this.dateTimeService.format(modelValue || null, this.format) || modelValue;
        }
        return modelValue;
    };
    DateInputDirective.prototype.parseViewValue = function (viewValue) {
        if (this.type !== 'date') {
            return this.dateTimeService.parse(viewValue || null, this.format, this.dayPeriod || null) || viewValue;
        }
        return viewValue;
    };
    DateInputDirective.prototype.registerOnValidatorChange = function (fn) {
        this.onValidatorChange = fn;
    };
    DateInputDirective.prototype.validate = function (control) {
        if (this.constraints) {
            if (this.constraints.mode === 'date') {
                var mode = this.timeValue != null || this.timezoneValue != null ? 'datetime' : 'date';
                var value = mode === 'datetime'
                    ? (this.constraints.offset >= 0
                        ? control.value + "T00:00:00"
                        : control.value + "T23:59:59")
                    : control.value;
                return this.dateTimeValidatorService.validate(this.constraints, value, this.format, mode);
            }
            else if (this.constraints.mode === 'time') {
                var mode = this.dateValue != null ? 'datetime' : 'time';
                var value = mode === 'datetime' ? this.dateValue + "T" + control.value : control.value;
                return this.dateTimeValidatorService.validate(this.constraints, value, this.format, mode);
            }
            else {
                return this.dateTimeValidatorService.validate(this.constraints, control.value, this.format);
            }
        }
        return null;
    };
    DateInputDirective.prototype.ngOnChanges = function (changes) {
        if (this.constraints) {
            _super.prototype.ngOnChanges.call(this, changes);
            this.onValidatorChange();
        }
    };
    DateInputDirective.ctorParameters = function () { return [
        { type: TimezonesService },
        { type: DateTimeService },
        { type: DateTimeValidatorService },
        { type: DynamicTranslations }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", DateTimeConstraints)
    ], DateInputDirective.prototype, "constraints", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateInputDirective.prototype, "format", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateInputDirective.prototype, "type", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateInputDirective.prototype, "dayPeriod", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateInputDirective.prototype, "timeValue", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateInputDirective.prototype, "dateValue", void 0);
    DateInputDirective = __decorate([ __metadata("design:paramtypes", [TimezonesService,
            DateTimeService,
            DateTimeValidatorService,
            DynamicTranslations])
    ], DateInputDirective);
DateInputDirective.ɵfac = function DateInputDirective_Factory(t) { return new (t || DateInputDirective)(ɵngcc0.ɵɵdirectiveInject(TimezonesService), ɵngcc0.ɵɵdirectiveInject(DateTimeService), ɵngcc0.ɵɵdirectiveInject(DateTimeValidatorService), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations)); };
DateInputDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DateInputDirective, selectors: [["", "cdsDateInput", ""]], inputs: { constraints: "constraints", format: "format", type: "type", dayPeriod: "dayPeriod", timeValue: "timeValue", dateValue: "dateValue" }, exportAs: ["cdsDateInput"], features: [ɵngcc0.ɵɵProvidersFeature([DATE_INPUT_MODEL_TRANSFORMER, DATE_INPUT_VALIDATOR, DynamicTranslations]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DateInputDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsDateInput]',
                providers: [DATE_INPUT_MODEL_TRANSFORMER, DATE_INPUT_VALIDATOR, DynamicTranslations],
                exportAs: 'cdsDateInput'
            }]
    }], function () { return [{ type: TimezonesService }, { type: DateTimeService }, { type: DateTimeValidatorService }, { type: DynamicTranslations }]; }, { constraints: [{
            type: Input
        }], format: [{
            type: Input
        }], type: [{
            type: Input
        }], dayPeriod: [{
            type: Input
        }], timeValue: [{
            type: Input
        }], dateValue: [{
            type: Input
        }] }); })();
    return DateInputDirective;
}(BaseDateTimeComponent));

var Keys$1;
(function (Keys) {
    Keys[Keys["PageUp"] = 33] = "PageUp";
    Keys[Keys["PageDown"] = 34] = "PageDown";
    Keys[Keys["End"] = 35] = "End";
    Keys[Keys["Home"] = 36] = "Home";
    Keys[Keys["Left"] = 37] = "Left";
    Keys[Keys["Top"] = 38] = "Top";
    Keys[Keys["Right"] = 39] = "Right";
    Keys[Keys["Bottom"] = 40] = "Bottom";
})(Keys$1 || (Keys$1 = {}));
var DateKeyboardNavigationDirective = /** @class */ (function () {
    function DateKeyboardNavigationDirective() {
        this.valueChange = new EventEmitter();
    }
    DateKeyboardNavigationDirective.prototype.onKeyPress = function (event) {
        var value = keyboardNavigation(this.value, true, this.constraints, event);
        if (value) {
            event.preventDefault();
            if (value !== this.value) {
                this.valueChange.emit(value);
            }
        }
    };
    __decorate([
        Input('cdsDateKeyboardNavigation'),
        __metadata("design:type", String)
    ], DateKeyboardNavigationDirective.prototype, "value", void 0);
    __decorate([
        Output('cdsDateKeyboardNavigationChange'),
        __metadata("design:type", Object)
    ], DateKeyboardNavigationDirective.prototype, "valueChange", void 0);
    __decorate([
        Input('keyboardConstraints'),
        __metadata("design:type", DateTimeConstraints)
    ], DateKeyboardNavigationDirective.prototype, "constraints", void 0);
    __decorate([
        HostListener('keydown', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [KeyboardEvent]),
        __metadata("design:returntype", void 0)
    ], DateKeyboardNavigationDirective.prototype, "onKeyPress", null);
DateKeyboardNavigationDirective.ɵfac = function DateKeyboardNavigationDirective_Factory(t) { return new (t || DateKeyboardNavigationDirective)(); };
DateKeyboardNavigationDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DateKeyboardNavigationDirective, selectors: [["", "cdsDateKeyboardNavigation", ""]], hostBindings: function DateKeyboardNavigationDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function DateKeyboardNavigationDirective_keydown_HostBindingHandler($event) { return ctx.onKeyPress($event); });
    } }, inputs: { value: ["cdsDateKeyboardNavigation", "value"], constraints: ["keyboardConstraints", "constraints"] }, outputs: { valueChange: "cdsDateKeyboardNavigationChange" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DateKeyboardNavigationDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsDateKeyboardNavigation]'
            }]
    }], function () { return []; }, { valueChange: [{
            type: Output,
            args: ['cdsDateKeyboardNavigationChange']
        }], onKeyPress: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], value: [{
            type: Input,
            args: ['cdsDateKeyboardNavigation']
        }], constraints: [{
            type: Input,
            args: ['keyboardConstraints']
        }] }); })();
    return DateKeyboardNavigationDirective;
}());

var DATE_RANGE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return DateRangeControlComponent; }),
    multi: true,
};
var DATE_RANGE_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(function () { return DateRangeControlComponent; }),
    multi: true,
};
var DateRangeControlComponent = /** @class */ (function (_super) {
    __extends(DateRangeControlComponent, _super);
    function DateRangeControlComponent(elementRef, renderer, timezonesService, cdRef, dateTimeService, dateTimeValidatorService, dialogService, componentTranslations, now) {
        var _this = _super.call(this, timezonesService) || this;
        _this.elementRef = elementRef;
        _this.cdRef = cdRef;
        _this.dateTimeService = dateTimeService;
        _this.dateTimeValidatorService = dateTimeValidatorService;
        _this.dialogService = dialogService;
        _this.now = now;
        _this.keepFocus = false;
        _this.setRangeTo = false;
        _this.format = 'date';
        _this.appearance = 'outline';
        _this.inlineEdit = false;
        _this.dateRequired = false;
        _this.padDaysInMonth = false;
        _this.disabled = false;
        _this.onTouchedCallback = noop;
        _this.onChangeCallback = noop;
        _this.onValidatorChange = noop;
        renderer.addClass(elementRef.nativeElement, 'cds-date-control');
        renderer.addClass(elementRef.nativeElement, 'cds-control--parent');
        renderer.addClass(elementRef.nativeElement, 'cds-control');
        componentTranslations.use(CDS_DATE_TIME_TRANSLATIONS, dateTimeTranslationsFactory, function (translations) {
            _this.translations = translations;
            if (_this.afterChanges) {
                cdRef.detectChanges();
            }
        });
        return _this;
    }
    DateRangeControlComponent.prototype.ngOnInit = function () {
        if (!this.afterChanges) {
            this.ngOnChanges({});
        }
        var defaultDate = getDefaultDate(this.constraints, new Date(this.now()));
        this.defaultDate = Time.fromDate(defaultDate).toString('date');
    };
    DateRangeControlComponent.prototype.ngOnChanges = function (changes) {
        this.afterChanges = true;
        _super.prototype.ngOnChanges.call(this, changes);
        if (this.inChanges(changes, ['format', 'from', 'to', 'rangeFrom', 'rangeTo', 'disableWeekends', 'allowedDays', 'dateRequired'])) {
            this.onValidatorChange();
        }
    };
    DateRangeControlComponent.prototype.inChanges = function (changes, keys) {
        return keys.some(function (key) { return key in changes; });
    };
    DateRangeControlComponent.prototype.onOpenChange = function (isOpen) {
        if (isOpen && !this.isOpen) {
            this.currentValue = this.inputValue;
        }
        else if (!isOpen && this.isOpen) {
            this.restoreCurrentValue(this.currentValue);
            /** writeValue to format input view value */
            this.input.writeValue(this.inputValue);
        }
        if (!this.disabled) {
            this.isOpen = isOpen;
            this.keepFocus = isOpen;
            this.cdRef.detectChanges();
            if (isOpen) {
                if (this.dropdown) {
                    this.dropdown.scheduleUpdate();
                }
            }
        }
    };
    DateRangeControlComponent.prototype.writeValue = function (modelValue) {
        this.restoreCurrentValue(modelValue);
        this.cdRef.markForCheck();
    };
    DateRangeControlComponent.prototype.restoreCurrentValue = function (value) {
        try {
            this.inputValue = value;
            this.calendarValue = value ? (value.from || value.to || null) : null;
        }
        catch (e) {
            this.inputValue = null;
            this.calendarValue = null;
        }
        this.updateSetRangeTo();
    };
    DateRangeControlComponent.prototype.changeInputValue = function (newValue) {
        try {
            this.calendarValue = newValue ? (newValue.from || newValue.to || null) : null;
        }
        catch (e) {
            this.calendarValue = null;
        }
        this.inputValue = newValue;
        this.updateSetRangeTo();
        if (!this.isOpen) {
            this.currentValue = this.inputValue;
            this.onChangeCallback(this.inputValue);
        }
        this.cdRef.detectChanges();
    };
    DateRangeControlComponent.prototype.changeCalendarValueFromKeyboard = function (newValue) {
        try {
            var inputValue = this.inputValue || {};
            if (this.setRangeTo) {
                var from = inputValue.from;
                if (from && from > newValue) {
                    this.inputValue = {
                        from: newValue,
                    };
                    this.setRangeTo = false;
                }
                else {
                    this.inputValue = {
                        from: from,
                        to: newValue,
                    };
                }
            }
            else {
                var to = inputValue.to;
                if (to && to < newValue) {
                    this.inputValue = {
                        from: newValue,
                    };
                }
                else {
                    this.inputValue = {
                        from: newValue,
                        to: to,
                    };
                }
            }
        }
        catch (e) {
            this.inputValue = null;
        }
        this.calendarValue = newValue;
        this.cdRef.detectChanges();
    };
    DateRangeControlComponent.prototype.changeCalendarValue = function (newValue) {
        try {
            var inputValue = this.inputValue;
            if (inputValue) {
                var to = inputValue.to;
                if (to) {
                    if (to < newValue) {
                        this.inputValue = {
                            from: newValue,
                        };
                    }
                    else {
                        this.inputValue = {
                            from: newValue,
                            to: to,
                        };
                    }
                }
                else {
                    var from = inputValue.from;
                    if (from && from > newValue) {
                        this.inputValue = {
                            from: newValue,
                        };
                    }
                    else {
                        this.inputValue = {
                            from: from,
                            to: newValue,
                        };
                    }
                }
            }
            else if (newValue) {
                this.inputValue = { from: newValue };
            }
            else {
                this.inputValue = null;
            }
        }
        catch (e) {
            this.inputValue = null;
        }
        this.updateSetRangeTo();
        this.calendarValue = (this.inputValue ? (this.setRangeTo ? this.inputValue.to : this.inputValue.from) : null) || null;
        this.input.focus();
        this.cdRef.detectChanges();
    };
    DateRangeControlComponent.prototype.toggleSetRangeTo = function () {
        this.setRangeTo = !this.setRangeTo;
        var inputValue = this.inputValue || {};
        var newValue = this.setRangeTo ? inputValue.to : inputValue.from;
        if (newValue) {
            this.calendarValue = newValue;
        }
    };
    DateRangeControlComponent.prototype.updateSetRangeTo = function () {
        if (this.inputValue) {
            this.setRangeTo = !!this.inputValue.from && !this.inputValue.to;
        }
        else {
            this.setRangeTo = false;
        }
    };
    DateRangeControlComponent.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    DateRangeControlComponent.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    DateRangeControlComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
        this.cdRef.markForCheck();
    };
    DateRangeControlComponent.prototype.validate = function (control) {
        this.cdRef.markForCheck();
        if (!control.value) {
            this.errors = this.dateRequired ? { required: true } : null;
        }
        else {
            var value = control.value;
            if (!value.from || !value.to) {
                this.errors = this.dateRequired ? { required: true } : null;
            }
            else {
                this.errors = this.dateTimeValidatorService.validateRange(this.constraints, value, this.format);
            }
        }
        return this.errors;
    };
    DateRangeControlComponent.prototype.registerOnValidatorChange = function (fn) {
        this.onValidatorChange = fn;
    };
    DateRangeControlComponent.prototype.onBlur = function () {
        this.onTouchedCallback();
    };
    DateRangeControlComponent.prototype.onMouseDown = function () {
        if (!this.disabled) {
            this.keepFocus = true;
        }
    };
    DateRangeControlComponent.prototype.updatedConstraints = function () {
        return __assign({ mode: 'date' }, _super.prototype.updatedConstraints.call(this));
    };
    DateRangeControlComponent.prototype.applyValue = function () {
        this.currentValue = this.inputValue;
        if (this.inputValue) {
            this.onChangeCallback({
                from: this.inputValue.from,
                to: this.inputValue.to,
            });
        }
        else {
            this.onChangeCallback(null);
        }
        this.onOpenChange(false);
    };
    DateRangeControlComponent.prototype.clearValue = function () {
        this.onOpenChange(false);
    };
    DateRangeControlComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: TimezonesService },
        { type: ChangeDetectorRef },
        { type: DateTimeService },
        { type: DateTimeValidatorService },
        { type: DialogService },
        { type: DynamicTranslations },
        { type: undefined, decorators: [{ type: Inject, args: [CDS_DATE_TIME_NOW,] }] }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateRangeControlComponent.prototype, "format", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateRangeControlComponent.prototype, "appearance", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateRangeControlComponent.prototype, "placeholder", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateRangeControlComponent.prototype, "label", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateRangeControlComponent.prototype, "inlineEdit", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateRangeControlComponent.prototype, "dateRequired", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], DateRangeControlComponent.prototype, "numberOfMonths", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateRangeControlComponent.prototype, "padDaysInMonth", void 0);
    __decorate([
        ViewChild('dropdown'),
        __metadata("design:type", DropdownComponent)
    ], DateRangeControlComponent.prototype, "dropdown", void 0);
    __decorate([
        ViewChild('input', { static: true }),
        __metadata("design:type", InputComponent)
    ], DateRangeControlComponent.prototype, "input", void 0);
    DateRangeControlComponent = __decorate([ __param(8, Inject(CDS_DATE_TIME_NOW)),
        __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            TimezonesService,
            ChangeDetectorRef,
            DateTimeService,
            DateTimeValidatorService,
            DialogService,
            DynamicTranslations, Function])
    ], DateRangeControlComponent);
DateRangeControlComponent.ɵfac = function DateRangeControlComponent_Factory(t) { return new (t || DateRangeControlComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(TimezonesService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DateTimeService), ɵngcc0.ɵɵdirectiveInject(DateTimeValidatorService), ɵngcc0.ɵɵdirectiveInject(DialogService), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations), ɵngcc0.ɵɵdirectiveInject(CDS_DATE_TIME_NOW)); };
DateRangeControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DateRangeControlComponent, selectors: [["cds-date-range-control"]], viewQuery: function DateRangeControlComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c14, true);
        ɵngcc0.ɵɵstaticViewQuery(_c5, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, inputs: { format: "format", appearance: "appearance", placeholder: "placeholder", label: "label", inlineEdit: "inlineEdit", dateRequired: "dateRequired", numberOfMonths: "numberOfMonths", padDaysInMonth: "padDaysInMonth" }, features: [ɵngcc0.ɵɵProvidersFeature([DATE_RANGE_VALUE_ACCESSOR, DATE_RANGE_VALIDATOR, DynamicTranslations]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 15, consts: [["cdsDateRangeInput", "", 1, "cds-date-control__control", "cds-control--child", 3, "appearance", "format", "constraints", "cdsDateKeyboardNavigation", "keyboardConstraints", "selected", "ngModel", "label", "placeholder", "readonly", "disabled", "cdsInvalid", "cdsDateKeyboardNavigationChange", "ngModelChange", "focus", "mousedown", "blur", "keydown.enter", "cdsOnEscape"], ["input", "", "inputModel", "ngModel"], ["class", "cds-dropdown--auto-height", 3, "anchor", "dismiss", 4, "ngIf"], [1, "cds-dropdown--auto-height", 3, "anchor", "dismiss"], ["dropdown", ""], [1, "cds-date-control__content"], [3, "focusable", "focusOn", "constraints", "numberOfMonths", "startRange", "endRange", "padDaysInMonth", "ngModel", "ngModelChange"], [1, "cds-date-control__footer"], ["cdsButton", "", "type", "button", 1, "cds-button-text", 3, "click"], ["cdsButton", "", "type", "button", 1, "cds-button-primary", 3, "disabled", "click"]], template: function DateRangeControlComponent_Template(rf, ctx) { if (rf & 1) {
        var _r9 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "cds-input", 0, 1);
        ɵngcc0.ɵɵlistener("cdsDateKeyboardNavigationChange", function DateRangeControlComponent_Template_cds_input_cdsDateKeyboardNavigationChange_0_listener($event) { return ctx.changeCalendarValueFromKeyboard($event); })("ngModelChange", function DateRangeControlComponent_Template_cds_input_ngModelChange_0_listener($event) { return ctx.changeInputValue($event); })("focus", function DateRangeControlComponent_Template_cds_input_focus_0_listener() { return ctx.onOpenChange(true); })("mousedown", function DateRangeControlComponent_Template_cds_input_mousedown_0_listener() { return ctx.onMouseDown(); })("blur", function DateRangeControlComponent_Template_cds_input_blur_0_listener() { return ctx.onBlur(); })("keydown.enter", function DateRangeControlComponent_Template_cds_input_keydown_enter_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); var _r1 = ɵngcc0.ɵɵreference(2); return ctx.isOpen ? ctx.setRangeTo ? _r1.valid && ctx.applyValue() : ctx.toggleSetRangeTo() : ctx.onOpenChange(true); })("cdsOnEscape", function DateRangeControlComponent_Template_cds_input_cdsOnEscape_0_listener() { return ctx.clearValue(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, DateRangeControlComponent_cds_dropdown_3_Template, 9, 14, "cds-dropdown", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("cds-control--required", ctx.dateRequired);
        ɵngcc0.ɵɵproperty("appearance", ctx.appearance)("format", ctx.format)("constraints", ctx.isOpen ? ctx.constraints : null)("cdsDateKeyboardNavigation", ctx.calendarValue || ctx.defaultDate)("keyboardConstraints", ctx.constraints)("selected", ctx.keepFocus)("ngModel", ctx.inputValue)("label", ctx.label || ctx.translations.selectDateRangeHeader)("placeholder", ctx.placeholder)("readonly", !ctx.inlineEdit)("disabled", ctx.disabled)("cdsInvalid", ctx.isOpen ? false : ctx.errors != null);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isOpen);
    } }, directives: function () { return [InputComponent, DateRangeInputDirective, DateKeyboardNavigationDirective, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, InvalidDirective, OnEscapeDirective, ɵngcc1.NgIf, DropdownComponent, CalendarRangeComponent, ButtonRippleDirective]; }, encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DateRangeControlComponent, [{
        type: Component,
        args: [{
                selector: 'cds-date-range-control',
                template: "<cds-input #input #inputModel=\"ngModel\"\n           [appearance]=\"appearance\"\n           class=\"cds-date-control__control cds-control--child\"\n           [class.cds-control--required]=\"dateRequired\"\n           cdsDateRangeInput\n           [format]=\"format\"\n           [constraints]=\"isOpen ? constraints : null\"\n           [cdsDateKeyboardNavigation]=\"calendarValue || defaultDate\"\n           (cdsDateKeyboardNavigationChange)=\"changeCalendarValueFromKeyboard($event)\"\n           [keyboardConstraints]=\"constraints\"\n           [selected]=\"keepFocus\"\n           [ngModel]=\"inputValue\"\n           (ngModelChange)=\"changeInputValue($event)\"\n           [label]=\"label || translations.selectDateRangeHeader\"\n           [placeholder]=\"placeholder\"\n           [readonly]=\"!inlineEdit\"\n           [disabled]=\"disabled\"\n           [cdsInvalid]=\"isOpen ? false : errors != null\"\n           (focus)=\"onOpenChange(true)\"\n           (mousedown)=\"onMouseDown()\"\n           (blur)=\"onBlur()\"\n           (keydown.enter)=\"isOpen ? (setRangeTo ? (inputModel.valid && applyValue()) : toggleSetRangeTo()) : onOpenChange(true)\"\n           (cdsOnEscape)=\"clearValue()\"></cds-input>\n<cds-dropdown #dropdown *ngIf=\"isOpen\" (dismiss)=\"onOpenChange(false)\" [anchor]=\"input.elementRef\" class=\"cds-dropdown--auto-height\">\n\t<div class=\"cds-date-control__content\">\n\t\t<cds-calendar-range [focusable]=\"false\"\n\t\t                    [focusOn]=\"setRangeTo ? 'to' : 'from'\"\n\t\t                    [constraints]=\"constraints\"\n\t\t                    [numberOfMonths]=\"numberOfMonths\"\n\t\t                    [startRange]=\"inputValue?.from\"\n\t\t                    [endRange]=\"inputValue?.to\"\n\t\t                    [padDaysInMonth]=\"padDaysInMonth\"\n\t\t                    [ngModel]=\"calendarValue\"\n\t\t                    (ngModelChange)=\"changeCalendarValue($event)\"></cds-calendar-range>\n\t</div>\n\t<div class=\"cds-date-control__footer\">\n\t\t<button cdsButton type=\"button\" class=\"cds-button-text\" (click)=\"clearValue()\" [attr.aria-label]=\"translations.cancel\">{{translations.cancelButton}}</button>\n\t\t<button cdsButton type=\"button\" class=\"cds-button-primary\" (click)=\"applyValue()\" [attr.aria-label]=\"translations.apply\" [disabled]=\"!inputModel.valid\">{{translations.applyButton}}</button>\n\t</div>\n</cds-dropdown>\n",
                providers: [DATE_RANGE_VALUE_ACCESSOR, DATE_RANGE_VALIDATOR, DynamicTranslations],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: TimezonesService }, { type: ɵngcc0.ChangeDetectorRef }, { type: DateTimeService }, { type: DateTimeValidatorService }, { type: DialogService }, { type: DynamicTranslations }, { type: undefined, decorators: [{
                type: Inject,
                args: [CDS_DATE_TIME_NOW]
            }] }]; }, { format: [{
            type: Input
        }], appearance: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], label: [{
            type: Input
        }], inlineEdit: [{
            type: Input
        }], dateRequired: [{
            type: Input
        }], numberOfMonths: [{
            type: Input
        }], padDaysInMonth: [{
            type: Input
        }], dropdown: [{
            type: ViewChild,
            args: ['dropdown']
        }], input: [{
            type: ViewChild,
            args: ['input', { static: true }]
        }] }); })();
    return DateRangeControlComponent;
}(BaseDateTimeComponent));

var DATE_RANGE_INPUT_MODEL_TRANSFORMER = {
    provide: CDS_INPUT_MODEL_TRANSFORMER,
    useExisting: forwardRef(function () { return DateRangeInputDirective; }),
};
var DATE_RANGE_INPUT_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(function () { return DateRangeInputDirective; }),
    multi: true,
};
var DateRangeInputDirective = /** @class */ (function (_super) {
    __extends(DateRangeInputDirective, _super);
    function DateRangeInputDirective(timezonesService, dateTimeService, dateTimeValidatorService, componentTranslations) {
        var _this = _super.call(this, timezonesService) || this;
        _this.dateTimeService = dateTimeService;
        _this.dateTimeValidatorService = dateTimeValidatorService;
        _this.onValidatorChange = noop;
        componentTranslations.use(CDS_DATE_TIME_TRANSLATIONS, dateTimeTranslationsFactory, function (translations) {
            _this.translations = translations;
        });
        return _this;
    }
    DateRangeInputDirective.prototype.formatModelValue = function (modelValue) {
        if (modelValue) {
            if (modelValue.from || modelValue.to) {
                var from = this.dateTimeService.format(modelValue.from || null, this.format);
                var to = this.dateTimeService.format(modelValue.to || null, this.format);
                if (from && to) {
                    return from + " - " + to;
                }
                else if (from) {
                    return from + " - ";
                }
                else if (to) {
                    return " - " + to;
                }
            }
            else {
                return DATE_RANGE_INPUT_VALUE_TEXT.get(modelValue) || null;
            }
        }
        else {
            return null;
        }
    };
    DateRangeInputDirective.prototype.parseViewValue = function (viewValue) {
        if (viewValue) {
            var format = this.dateTimeService.resolveFormat(this.format);
            var matchViewValue = viewValue.trim();
            var parser = this.dateTimeService.getParser(format);
            var match = parser.test(matchViewValue, { complete: false });
            var fromViewValue = void 0;
            var toViewValue = void 0;
            if (match) {
                var separatorRegex = /^\s*-\s*/;
                if (match.index === 0) {
                    fromViewValue = match[0];
                    matchViewValue = matchViewValue.substr(fromViewValue.length);
                    var matchSeparator = separatorRegex.exec(matchViewValue);
                    if (matchSeparator) {
                        matchViewValue = matchViewValue.substr(matchSeparator[0].length);
                        var matchTo = parser.test(matchViewValue);
                        if (matchTo) {
                            toViewValue = matchTo[0];
                        }
                    }
                }
                else {
                    if ((match.index + match[0].length) == matchViewValue.length) {
                        var separator = matchViewValue.substr(0, match.index);
                        var matchSeparator = separatorRegex.exec(separator);
                        if (matchSeparator && matchSeparator[0].length === separator.length) {
                            toViewValue = match[0];
                        }
                    }
                }
            }
            var from = this.dateTimeService.parse(fromViewValue || null, format);
            var to = this.dateTimeService.parse(toViewValue || null, format);
            var value = { from: from, to: to };
            DATE_RANGE_INPUT_VALUE_TEXT.set(value, viewValue);
            return value;
        }
        else {
            return null;
        }
    };
    DateRangeInputDirective.prototype.registerOnValidatorChange = function (fn) {
        this.onValidatorChange = fn;
    };
    DateRangeInputDirective.prototype.validate = function (control) {
        if (this.constraints) {
            return this.dateTimeValidatorService.validateRange(this.constraints, control.value, this.format);
        }
        return null;
    };
    DateRangeInputDirective.prototype.ngOnChanges = function (changes) {
        _super.prototype.ngOnChanges.call(this, changes);
        this.onValidatorChange();
    };
    DateRangeInputDirective.ctorParameters = function () { return [
        { type: TimezonesService },
        { type: DateTimeService },
        { type: DateTimeValidatorService },
        { type: DynamicTranslations }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", DateTimeConstraints)
    ], DateRangeInputDirective.prototype, "constraints", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateRangeInputDirective.prototype, "format", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateRangeInputDirective.prototype, "type", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateRangeInputDirective.prototype, "dayPeriod", void 0);
    DateRangeInputDirective = __decorate([ __metadata("design:paramtypes", [TimezonesService,
            DateTimeService,
            DateTimeValidatorService,
            DynamicTranslations])
    ], DateRangeInputDirective);
DateRangeInputDirective.ɵfac = function DateRangeInputDirective_Factory(t) { return new (t || DateRangeInputDirective)(ɵngcc0.ɵɵdirectiveInject(TimezonesService), ɵngcc0.ɵɵdirectiveInject(DateTimeService), ɵngcc0.ɵɵdirectiveInject(DateTimeValidatorService), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations)); };
DateRangeInputDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DateRangeInputDirective, selectors: [["", "cdsDateRangeInput", ""]], inputs: { constraints: "constraints", format: "format", type: "type", dayPeriod: "dayPeriod" }, exportAs: ["cdsDateRangeInput"], features: [ɵngcc0.ɵɵProvidersFeature([DATE_RANGE_INPUT_MODEL_TRANSFORMER, DATE_RANGE_INPUT_VALIDATOR, DynamicTranslations]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DateRangeInputDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsDateRangeInput]',
                providers: [DATE_RANGE_INPUT_MODEL_TRANSFORMER, DATE_RANGE_INPUT_VALIDATOR, DynamicTranslations],
                exportAs: 'cdsDateRangeInput'
            }]
    }], function () { return [{ type: TimezonesService }, { type: DateTimeService }, { type: DateTimeValidatorService }, { type: DynamicTranslations }]; }, { constraints: [{
            type: Input
        }], format: [{
            type: Input
        }], type: [{
            type: Input
        }], dayPeriod: [{
            type: Input
        }] }); })();
    return DateRangeInputDirective;
}(BaseDateTimeComponent));

var DateRangeAbstractControlComponent = /** @class */ (function () {
    function DateRangeAbstractControlComponent(elementRef, renderer, cdRef, componentTranslations, now) {
        var _this = this;
        this.cdRef = cdRef;
        this.now = now;
        this.dateRequired = false;
        this.padDaysInMonth = false;
        this.focusOn = 'from';
        this.initialized = false;
        renderer.addClass(elementRef.nativeElement, 'cds-date-time-dialog');
        renderer.addClass(elementRef.nativeElement, 'cds-date-time-dialog--range');
        componentTranslations.use(CDS_DATE_TIME_TRANSLATIONS, dateTimeTranslationsFactory, function (translations) {
            _this.translations = translations;
            if (_this.initialized) {
                cdRef.detectChanges();
            }
        });
    }
    DateRangeAbstractControlComponent.prototype.ngOnInit = function () {
        var defaultDate = getDefaultDate(this.constraints, new Date(this.now()));
        this.defaultDate = Time.fromDate(defaultDate).toString('date');
    };
    DateRangeAbstractControlComponent.prototype.changeCalendarValue = function (newValue, keyboardChange) {
        if (keyboardChange === void 0) { keyboardChange = false; }
        var _a = this.value || { from: null, to: null }, from = _a.from, to = _a.to;
        this.calendarValue = newValue;
        if (this.focusOn === 'to') {
            if (from && newValue < from) {
                this.value = {
                    from: newValue,
                    to: from,
                };
                this.makeFocus('from');
            }
            else {
                this.value = {
                    from: from,
                    to: newValue,
                };
            }
        }
        else if (this.focusOn === 'from') {
            if (to && to < newValue) {
                this.value = {
                    from: to,
                    to: newValue,
                };
                this.makeFocus('to');
            }
            else {
                this.value = {
                    from: newValue,
                    to: to,
                };
                if (!keyboardChange) {
                    this.makeFocus('to');
                }
            }
        }
    };
    DateRangeAbstractControlComponent.prototype.clearValue = function () {
        this.calendarValue = null;
        this.value = null;
    };
    DateRangeAbstractControlComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ChangeDetectorRef },
        { type: DynamicTranslations },
        { type: undefined, decorators: [{ type: Inject, args: [CDS_DATE_TIME_NOW,] }] }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", DateTimeConstraints)
    ], DateRangeAbstractControlComponent.prototype, "constraints", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateRangeAbstractControlComponent.prototype, "format", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateRangeAbstractControlComponent.prototype, "placeholder", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], DateRangeAbstractControlComponent.prototype, "value", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], DateRangeAbstractControlComponent.prototype, "dateRequired", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], DateRangeAbstractControlComponent.prototype, "numberOfMonths", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], DateRangeAbstractControlComponent.prototype, "yearSelectRange", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateRangeAbstractControlComponent.prototype, "padDaysInMonth", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateRangeAbstractControlComponent.prototype, "focusOn", void 0);
    DateRangeAbstractControlComponent = __decorate([ __param(4, Inject(CDS_DATE_TIME_NOW)),
        __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            ChangeDetectorRef,
            DynamicTranslations, Function])
    ], DateRangeAbstractControlComponent);
DateRangeAbstractControlComponent.ɵfac = function DateRangeAbstractControlComponent_Factory(t) { return new (t || DateRangeAbstractControlComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations), ɵngcc0.ɵɵdirectiveInject(CDS_DATE_TIME_NOW)); };
DateRangeAbstractControlComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DateRangeAbstractControlComponent, inputs: { dateRequired: "dateRequired", padDaysInMonth: "padDaysInMonth", focusOn: "focusOn", value: "value", constraints: "constraints", format: "format", placeholder: "placeholder", numberOfMonths: "numberOfMonths", yearSelectRange: "yearSelectRange" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DateRangeAbstractControlComponent, [{
        type: Directive
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: DynamicTranslations }, { type: undefined, decorators: [{
                type: Inject,
                args: [CDS_DATE_TIME_NOW]
            }] }]; }, { dateRequired: [{
            type: Input
        }], padDaysInMonth: [{
            type: Input
        }], focusOn: [{
            type: Input
        }], value: [{
            type: Input
        }], constraints: [{
            type: Input
        }], format: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], numberOfMonths: [{
            type: Input
        }], yearSelectRange: [{
            type: Input
        }] }); })();
    return DateRangeAbstractControlComponent;
}());

var DateRangeDialogComponent = /** @class */ (function (_super) {
    __extends(DateRangeDialogComponent, _super);
    function DateRangeDialogComponent(elementRef, renderer, cdRef, componentTranslations, now) {
        var _this = _super.call(this, elementRef, renderer, cdRef, componentTranslations, now) || this;
        _this.animate = 1;
        _this.showInputs = true;
        _this.dialogClose = new EventEmitter();
        _this.pristineCalendarFromValue = true;
        _this.pristineCalendarToValue = true;
        renderer.addClass(elementRef.nativeElement, 'cds-date-time-dialog');
        renderer.addClass(elementRef.nativeElement, 'cds-date-time-dialog--range');
        componentTranslations.use(CDS_ERRORS_TRANSLATIONS, errorsTranslationsFactory, function (translations) {
            _this.errorsTranslations = translations;
            if (_this.initialized) {
                cdRef.detectChanges();
            }
        });
        return _this;
    }
    DateRangeDialogComponent.prototype.ngOnInit = function () {
        var _a, _b;
        var defaultDate = getDefaultDate(this.constraints, new Date(this.now()));
        this.defaultDate = Time.fromDate(defaultDate).toString('date');
        if (this.focusOn === 'to') {
            this.calendarValue = (_a = this.value) === null || _a === void 0 ? void 0 : _a.from;
        }
        else {
            this.calendarValue = (_b = this.value) === null || _b === void 0 ? void 0 : _b.from;
        }
        this.updateConstraints();
    };
    DateRangeDialogComponent.prototype.changeInputFromValue = function (newValue) {
        var _a;
        if (newValue || ((_a = this.value) === null || _a === void 0 ? void 0 : _a.from)) {
            this.value = __assign(__assign({}, this.value), { from: newValue });
            try {
                this.calendarValue = Time.fromString(newValue).toString();
            }
            catch (e) {
                this.calendarValue = null;
            }
            this.updateConstraints();
        }
    };
    DateRangeDialogComponent.prototype.changeInputToValue = function (newValue) {
        var _a;
        if (newValue || ((_a = this.value) === null || _a === void 0 ? void 0 : _a.to)) {
            this.value = __assign(__assign({}, this.value), { to: newValue });
            try {
                this.calendarValue = Time.fromString(newValue).toString();
            }
            catch (e) {
                this.calendarValue = null;
            }
        }
        this.updateConstraints();
    };
    DateRangeDialogComponent.prototype.makeFocus = function (focusField) {
        this.changeInputFocus(focusField);
        if (focusField === 'from') {
            this.inputFrom.focus();
        }
        else {
            this.inputTo.focus();
        }
    };
    DateRangeDialogComponent.prototype.changeInputFocus = function (focusOn) {
        var _this = this;
        setTimeout(function () {
            var _a, _b;
            if (_this.focusOn !== focusOn) {
                _this.focusOn = focusOn;
                if (focusOn === 'to') {
                    _this.changeInputToValue((_a = _this.value) === null || _a === void 0 ? void 0 : _a.to);
                }
                else if (focusOn === 'from') {
                    _this.changeInputFromValue((_b = _this.value) === null || _b === void 0 ? void 0 : _b.from);
                }
            }
            _this.cdRef.markForCheck();
        });
    };
    DateRangeDialogComponent.prototype.changeCalendarValue = function (newValue, keyboardChange) {
        if (keyboardChange === void 0) { keyboardChange = false; }
        if (this.focusOn === 'to') {
            this.pristineCalendarToValue = false;
        }
        else if (this.focusOn === 'from') {
            this.pristineCalendarFromValue = false;
        }
        _super.prototype.changeCalendarValue.call(this, newValue, keyboardChange);
        this.cdRef.detectChanges();
    };
    DateRangeDialogComponent.prototype.isDateRequired = function (range) {
        return this.dateRequired === true || this.dateRequired === range;
    };
    DateRangeDialogComponent.prototype.closeDialog = function () {
        this.dialogClose.emit();
    };
    Object.defineProperty(DateRangeDialogComponent.prototype, "disableApply", {
        get: function () {
            return !this.inputFromModel.valid || !this.inputToModel.valid;
        },
        enumerable: true,
        configurable: true
    });
    DateRangeDialogComponent.prototype.onBlur = function (blurOn) {
        var _a, _b;
        if (blurOn === 'from' && this.value) {
            this.inputFrom.writeValue((_a = this.value) === null || _a === void 0 ? void 0 : _a.from);
        }
        else if (blurOn === 'to' && this.value) {
            this.inputTo.writeValue((_b = this.value) === null || _b === void 0 ? void 0 : _b.to);
        }
    };
    DateRangeDialogComponent.prototype.applyValue = function () {
        var _a, _b;
        var value = { from: (_a = this.value) === null || _a === void 0 ? void 0 : _a.from, to: (_b = this.value) === null || _b === void 0 ? void 0 : _b.to };
        this.dialogClose.emit(value);
    };
    DateRangeDialogComponent.prototype.clearValue = function () {
        _super.prototype.clearValue.call(this);
        this.inputFromModel.control.markAsPristine();
        this.inputFromModel.control.markAsUntouched();
        this.inputToModel.control.markAsPristine();
        this.inputToModel.control.markAsUntouched();
        this.makeFocus('from');
    };
    DateRangeDialogComponent.prototype.updateConstraints = function () {
        var _a, _b;
        if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.from) {
            this.constraintsTo = this.constraints.update({
                from: (_b = this.value) === null || _b === void 0 ? void 0 : _b.from,
            });
        }
        else {
            this.constraintsTo = this.constraints;
        }
    };
    DateRangeDialogComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ChangeDetectorRef },
        { type: DynamicTranslations },
        { type: undefined, decorators: [{ type: Inject, args: [CDS_DATE_TIME_NOW,] }] }
    ]; };
    __decorate([
        HostBinding('@animate'),
        __metadata("design:type", Number)
    ], DateRangeDialogComponent.prototype, "animate", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateRangeDialogComponent.prototype, "labelFrom", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateRangeDialogComponent.prototype, "labelTo", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateRangeDialogComponent.prototype, "showInputs", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], DateRangeDialogComponent.prototype, "dialogClose", void 0);
    __decorate([
        ViewChild('inputFrom', { static: true }),
        __metadata("design:type", InputComponent)
    ], DateRangeDialogComponent.prototype, "inputFrom", void 0);
    __decorate([
        ViewChild('inputTo', { static: true }),
        __metadata("design:type", InputComponent)
    ], DateRangeDialogComponent.prototype, "inputTo", void 0);
    __decorate([
        ViewChild('inputFromModel', { static: true }),
        __metadata("design:type", NgModel)
    ], DateRangeDialogComponent.prototype, "inputFromModel", void 0);
    __decorate([
        ViewChild('inputToModel', { static: true }),
        __metadata("design:type", NgModel)
    ], DateRangeDialogComponent.prototype, "inputToModel", void 0);
    DateRangeDialogComponent = __decorate([ __param(4, Inject(CDS_DATE_TIME_NOW)),
        __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            ChangeDetectorRef,
            DynamicTranslations, Function])
    ], DateRangeDialogComponent);
DateRangeDialogComponent.ɵfac = function DateRangeDialogComponent_Factory(t) { return new (t || DateRangeDialogComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations), ɵngcc0.ɵɵdirectiveInject(CDS_DATE_TIME_NOW)); };
DateRangeDialogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DateRangeDialogComponent, selectors: [["cds-date-range-dialog"]], viewQuery: function DateRangeDialogComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c29, true);
        ɵngcc0.ɵɵstaticViewQuery(_c30, true);
        ɵngcc0.ɵɵstaticViewQuery(_c31, true);
        ɵngcc0.ɵɵstaticViewQuery(_c32, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputFrom = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputTo = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputFromModel = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputToModel = _t.first);
    } }, hostVars: 1, hostBindings: function DateRangeDialogComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵsyntheticHostProperty("@animate", ctx.animate);
    } }, inputs: { labelFrom: "labelFrom", labelTo: "labelTo", showInputs: "showInputs" }, outputs: { dialogClose: "dialogClose" }, features: [ɵngcc0.ɵɵProvidersFeature([
            DynamicTranslations,
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 25, vars: 44, consts: [["role", "dialog", 3, "dialogClose", "cdsOnEscape"], [1, "cds-date-time-dialog__fields"], [1, "cds-date-time-dialog__container"], [1, "cds-date-time-dialog__date-input"], ["cdsDateInput", "", 3, "cdsDateKeyboardNavigation", "format", "constraints", "keyboardConstraints", "selected", "ngModel", "label", "placeholder", "readonly", "required", "autofocus", "cdsDateKeyboardNavigationChange", "ngModelChange", "focus", "keydown.enter", "blur"], ["inputFrom", "", "inputFromModel", "ngModel"], ["cdsDateInput", "", 3, "cdsDateKeyboardNavigation", "keyboardConstraints", "format", "constraints", "selected", "ngModel", "label", "placeholder", "readonly", "required", "autofocus", "cdsDateKeyboardNavigationChange", "ngModelChange", "focus", "blur"], ["inputTo", "", "inputToModel", "ngModel"], [1, "cds-date-time-dialog__errors"], [3, "cdsErrors", 4, "ngIf"], [1, "cds-date-time-dialog__pickers"], [3, "focusOn", "numberOfMonths", "constraints", "ngModel", "startRange", "endRange", "padDaysInMonth", "yearSelectRange", "ngModelChange"], [1, "cds-dialog-buttons"], ["cdsButton", "", "type", "button", 1, "cds-button-text", 3, "click"], ["cdsButton", "", "type", "button", 1, "cds-button-primary", 3, "disabled", "click"], [3, "cdsErrors"], [4, "cdsError"]], template: function DateRangeDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "cds-dialog", 0);
        ɵngcc0.ɵɵlistener("dialogClose", function DateRangeDialogComponent_Template_cds_dialog_dialogClose_0_listener() { return ctx.closeDialog(); })("cdsOnEscape", function DateRangeDialogComponent_Template_cds_dialog_cdsOnEscape_0_listener() { return ctx.closeDialog(); });
        ɵngcc0.ɵɵelementStart(1, "cds-slot-title");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "cds-slot-content");
        ɵngcc0.ɵɵelementStart(4, "div", 1);
        ɵngcc0.ɵɵelementStart(5, "div", 2);
        ɵngcc0.ɵɵelementStart(6, "div", 3);
        ɵngcc0.ɵɵelementStart(7, "cds-input", 4, 5);
        ɵngcc0.ɵɵlistener("cdsDateKeyboardNavigationChange", function DateRangeDialogComponent_Template_cds_input_cdsDateKeyboardNavigationChange_7_listener($event) { return ctx.changeCalendarValue($event, true); })("ngModelChange", function DateRangeDialogComponent_Template_cds_input_ngModelChange_7_listener($event) { return ctx.changeInputFromValue($event); })("focus", function DateRangeDialogComponent_Template_cds_input_focus_7_listener() { return ctx.changeInputFocus("from"); })("keydown.enter", function DateRangeDialogComponent_Template_cds_input_keydown_enter_7_listener() { return ctx.makeFocus("to"); })("blur", function DateRangeDialogComponent_Template_cds_input_blur_7_listener() { return ctx.onBlur("from"); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 3);
        ɵngcc0.ɵɵelementStart(11, "cds-input", 6, 7);
        ɵngcc0.ɵɵlistener("cdsDateKeyboardNavigationChange", function DateRangeDialogComponent_Template_cds_input_cdsDateKeyboardNavigationChange_11_listener($event) { return ctx.changeCalendarValue($event, true); })("ngModelChange", function DateRangeDialogComponent_Template_cds_input_ngModelChange_11_listener($event) { return ctx.changeInputToValue($event); })("focus", function DateRangeDialogComponent_Template_cds_input_focus_11_listener() { return ctx.changeInputFocus("to"); })("blur", function DateRangeDialogComponent_Template_cds_input_blur_11_listener() { return ctx.onBlur("to"); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 8);
        ɵngcc0.ɵɵtemplate(15, DateRangeDialogComponent_cds_errors_15_Template, 4, 2, "cds-errors", 9);
        ɵngcc0.ɵɵtemplate(16, DateRangeDialogComponent_cds_errors_16_Template, 4, 2, "cds-errors", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 10);
        ɵngcc0.ɵɵelementStart(18, "cds-calendar-range", 11);
        ɵngcc0.ɵɵlistener("ngModelChange", function DateRangeDialogComponent_Template_cds_calendar_range_ngModelChange_18_listener($event) { return ctx.changeCalendarValue($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "cds-slot-footer");
        ɵngcc0.ɵɵelementStart(20, "div", 12);
        ɵngcc0.ɵɵelementStart(21, "button", 13);
        ɵngcc0.ɵɵlistener("click", function DateRangeDialogComponent_Template_button_click_21_listener() { return ctx.clearValue(); });
        ɵngcc0.ɵɵtext(22);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "button", 14);
        ɵngcc0.ɵɵlistener("click", function DateRangeDialogComponent_Template_button_click_23_listener() { return ctx.applyValue(); });
        ɵngcc0.ɵɵtext(24);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        var _r1 = ɵngcc0.ɵɵreference(9);
        var _r3 = ɵngcc0.ɵɵreference(13);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.translations.selectDateRangeHeader, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("cds-date-time-dialog__fields--hidden", !ctx.showInputs);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵclassProp("cds-control--pristine", _r1.pristine && ctx.pristineCalendarFromValue);
        ɵngcc0.ɵɵproperty("cdsDateKeyboardNavigation", (ctx.value == null ? null : ctx.value.from) || (ctx.value == null ? null : ctx.value.to) || ctx.defaultDate)("format", ctx.format)("constraints", ctx.constraints)("keyboardConstraints", ctx.constraints)("selected", ctx.focusOn === "from")("ngModel", ctx.value == null ? null : ctx.value.from)("label", ctx.labelFrom)("placeholder", ctx.placeholder)("readonly", !ctx.showInputs)("required", ctx.isDateRequired("from"))("autofocus", ctx.focusOn === "from");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵclassProp("cds-control--pristine", _r3.pristine && ctx.pristineCalendarToValue);
        ɵngcc0.ɵɵproperty("cdsDateKeyboardNavigation", (ctx.value == null ? null : ctx.value.to) || (ctx.value == null ? null : ctx.value.from) || ctx.defaultDate)("keyboardConstraints", ctx.constraints)("format", ctx.format)("constraints", ctx.constraintsTo)("selected", ctx.focusOn === "to")("ngModel", ctx.value == null ? null : ctx.value.to)("label", ctx.labelTo)("placeholder", ctx.placeholder)("readonly", !ctx.showInputs)("required", ctx.isDateRequired("to"))("autofocus", ctx.focusOn === "to");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵclassProp("cds-date-time-dialog__errors--no-padding", !ctx.showInputs);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !_r1.pristine || !ctx.pristineCalendarFromValue);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !_r3.pristine || !ctx.pristineCalendarToValue);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("focusOn", !ctx.showInputs ? ctx.focusOn : undefined)("numberOfMonths", ctx.numberOfMonths)("constraints", ctx.constraints)("ngModel", ctx.calendarValue)("startRange", ctx.value == null ? null : ctx.value.from)("endRange", ctx.value == null ? null : ctx.value.to)("padDaysInMonth", ctx.padDaysInMonth)("yearSelectRange", ctx.yearSelectRange);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.translations.clearButton);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.disableApply);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.translations.applyButton);
    } }, directives: [DialogComponent, OnEscapeDirective, SlotsDirective, InputComponent, DateInputDirective, DateKeyboardNavigationDirective, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.RequiredValidator, ɵngcc1.NgIf, CalendarRangeComponent, ButtonRippleDirective, ErrorsComponent, ErrorsDirective, ErrorDirective], encapsulation: 2, data: { animation: [
            trigger('animate', [
                transition(':leave', query('cds-dialog', animateChild())),
            ]),
        ] } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DateRangeDialogComponent, [{
        type: Component,
        args: [{
                selector: 'cds-date-range-dialog',
                template: "<cds-dialog role=\"dialog\" (dialogClose)=\"closeDialog()\" (cdsOnEscape)=\"closeDialog()\">\n\t<cds-slot-title>\n\t\t{{translations.selectDateRangeHeader}}\n\t</cds-slot-title>\n\t<cds-slot-content>\n\t\t<div class=\"cds-date-time-dialog__fields\" [class.cds-date-time-dialog__fields--hidden]=\"!showInputs\">\n\t\t\t<div class=\"cds-date-time-dialog__container\">\n\t\t\t\t<div class=\"cds-date-time-dialog__date-input\">\n\t\t\t\t\t<cds-input #inputFrom\n\t\t\t\t\t           #inputFromModel=\"ngModel\"\n\t\t\t\t\t           [class.cds-control--pristine]=\"inputFromModel.pristine && pristineCalendarFromValue\"\n\t\t\t\t\t           cdsDateInput\n\t\t\t\t\t           [cdsDateKeyboardNavigation]=\"value?.from || value?.to || defaultDate\"\n\t\t\t\t\t           (cdsDateKeyboardNavigationChange)=\"changeCalendarValue($event, true)\"\n\t\t\t\t\t           [format]=\"format\"\n\t\t\t\t\t           [constraints]=\"constraints\"\n\t\t\t\t\t           [keyboardConstraints]=\"constraints\"\n\t\t\t\t\t           [selected]=\"focusOn==='from'\"\n\t\t\t\t\t           [ngModel]=\"value?.from\"\n\t\t\t\t\t           (ngModelChange)=\"changeInputFromValue($event)\"\n\t\t\t\t\t           (focus)=\"changeInputFocus('from')\"\n\t\t\t\t\t           [label]=\"labelFrom\"\n\t\t\t\t\t           [placeholder]=\"placeholder\"\n\t\t\t\t\t           [readonly]=\"!showInputs\"\n\t\t\t\t\t           (keydown.enter)=\"makeFocus('to')\"\n\t\t\t\t\t           [required]=\"isDateRequired('from')\"\n\t\t\t\t\t           (blur)=\"onBlur('from')\"\n\t\t\t\t\t           [autofocus]=\"focusOn==='from'\"></cds-input>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"cds-date-time-dialog__date-input\">\n\t\t\t\t\t<cds-input #inputTo\n\t\t\t\t\t           #inputToModel=\"ngModel\"\n\t\t\t\t\t           [class.cds-control--pristine]=\"inputToModel.pristine && pristineCalendarToValue\"\n\t\t\t\t\t           cdsDateInput\n\t\t\t\t\t           [cdsDateKeyboardNavigation]=\"value?.to || value?.from || defaultDate\"\n\t\t\t\t\t           (cdsDateKeyboardNavigationChange)=\"changeCalendarValue($event, true)\"\n\t\t\t\t\t           [keyboardConstraints]=\"constraints\"\n\t\t\t\t\t           [format]=\"format\"\n\t\t\t\t\t           [constraints]=\"constraintsTo\"\n\t\t\t\t\t           [selected]=\"focusOn==='to'\"\n\t\t\t\t\t           [ngModel]=\"value?.to\"\n\t\t\t\t\t           (ngModelChange)=\"changeInputToValue($event)\"\n\t\t\t\t\t           (focus)=\"changeInputFocus('to')\"\n\t\t\t\t\t           [label]=\"labelTo\"\n\t\t\t\t\t           [placeholder]=\"placeholder\"\n\t\t\t\t\t           [readonly]=\"!showInputs\"\n\t\t\t\t\t           [required]=\"isDateRequired('to')\"\n\t\t\t\t\t           (blur)=\"onBlur('to')\"\n\t\t\t\t\t           [autofocus]=\"focusOn==='to'\"></cds-input>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"cds-date-time-dialog__errors\" [class.cds-date-time-dialog__errors--no-padding]=\"!showInputs\">\n\t\t\t<cds-errors *ngIf=\"!inputFromModel.pristine || !pristineCalendarFromValue\" [cdsErrors]=\"inputFromModel\">\n\t\t\t\t<span>&#8203;</span>\n\t\t\t\t<span *cdsError=\"'required'\">{{errorsTranslations.required}}</span>\n\t\t\t</cds-errors>\n\t\t\t<cds-errors *ngIf=\"!inputToModel.pristine || !pristineCalendarToValue\" [cdsErrors]=\"inputToModel\">\n\t\t\t\t<span>&#8203;</span>\n\t\t\t\t<span *cdsError=\"'required'\">{{errorsTranslations.required}}</span>\n\t\t\t</cds-errors>\n\t\t</div>\n\t\t<div class=\"cds-date-time-dialog__pickers\">\n\t\t\t<cds-calendar-range [focusOn]=\"!showInputs ? focusOn : undefined\"\n\t\t\t                    [numberOfMonths]=\"numberOfMonths\"\n\t\t\t                    [constraints]=\"constraints\"\n\t\t\t                    [ngModel]=\"calendarValue\"\n\t\t\t                    (ngModelChange)=\"changeCalendarValue($event)\"\n\t\t\t                    [startRange]=\"value?.from\"\n\t\t\t                    [endRange]=\"value?.to\"\n\t\t\t                    [padDaysInMonth]=\"padDaysInMonth\"\n\t\t\t                    [yearSelectRange]=\"yearSelectRange\"></cds-calendar-range>\n\t\t</div>\n\t</cds-slot-content>\n\t<cds-slot-footer>\n\t\t<div class=\"cds-dialog-buttons\">\n\t\t\t<button cdsButton type=\"button\" class=\"cds-button-text\" (click)=\"clearValue()\">{{translations.clearButton}}</button>\n\t\t\t<button cdsButton type=\"button\" class=\"cds-button-primary\" [disabled]=\"disableApply\" (click)=\"applyValue()\">{{translations.applyButton}}</button>\n\t\t</div>\n\t</cds-slot-footer>\n</cds-dialog>\n",
                animations: [
                    trigger('animate', [
                        transition(':leave', query('cds-dialog', animateChild())),
                    ]),
                ],
                providers: [
                    DynamicTranslations,
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: DynamicTranslations }, { type: undefined, decorators: [{
                type: Inject,
                args: [CDS_DATE_TIME_NOW]
            }] }]; }, { animate: [{
            type: HostBinding,
            args: ['@animate']
        }], labelFrom: [{
            type: Input
        }], labelTo: [{
            type: Input
        }], showInputs: [{
            type: Input
        }], dialogClose: [{
            type: Output
        }], inputFrom: [{
            type: ViewChild,
            args: ['inputFrom', { static: true }]
        }], inputTo: [{
            type: ViewChild,
            args: ['inputTo', { static: true }]
        }], inputFromModel: [{
            type: ViewChild,
            args: ['inputFromModel', { static: true }]
        }], inputToModel: [{
            type: ViewChild,
            args: ['inputToModel', { static: true }]
        }] }); })();
    return DateRangeDialogComponent;
}(DateRangeAbstractControlComponent));

var DateRangeDropdownComponent = /** @class */ (function (_super) {
    __extends(DateRangeDropdownComponent, _super);
    function DateRangeDropdownComponent(elementRef, renderer, cdRef, componentTranslations, now) {
        var _this = _super.call(this, elementRef, renderer, cdRef, componentTranslations, now) || this;
        _this.elementRef = elementRef;
        _this.appearance = 'outline';
        _this.inlineEdit = false;
        _this.valueChange = new EventEmitter();
        _this.disabled = false;
        _this.descriptionId = Unique.next('cds-date-time-form-');
        renderer.addClass(elementRef.nativeElement, 'cds-date-time-form__container');
        return _this;
    }
    DateRangeDropdownComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    DateRangeDropdownComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        requestAnimationFrame(function () {
            var _a, _b;
            if ((_a = _this.value) === null || _a === void 0 ? void 0 : _a.from) {
                _this.calendarValue = Time.fromString((_b = _this.value) === null || _b === void 0 ? void 0 : _b.from).toString();
            }
        });
    };
    DateRangeDropdownComponent.prototype.getConstraints = function () {
        return this.isDropdownOpen ? this.constraints : DateTimeConstraints.empty();
    };
    DateRangeDropdownComponent.prototype.onOpenChange = function (isOpen) {
        var _a;
        if (isOpen && !this.isDropdownOpen) {
            this.currentValue = this.value;
            this.calendarValue = (_a = this.value) === null || _a === void 0 ? void 0 : _a.from;
            this.focusOn = 'from';
        }
        else if (!isOpen && this.isDropdownOpen) {
            this.restoreCurrentValue(this.currentValue);
            /** writeValue to format input view value */
            this.inputElement.writeValue(this.value);
        }
        if (!this.disabled) {
            this.isDropdownOpen = isOpen;
            this.keepFocus = isOpen;
            this.cdRef.detectChanges();
            if (isOpen) {
                if (this.dropdown) {
                    this.dropdown.scheduleUpdate();
                }
            }
        }
    };
    DateRangeDropdownComponent.prototype.restoreCurrentValue = function (value) {
        try {
            this.value = value;
            this.calendarValue = ((value === null || value === void 0 ? void 0 : value.from) || (value === null || value === void 0 ? void 0 : value.to) || null);
        }
        catch (e) {
            this.value = null;
            this.calendarValue = null;
        }
    };
    DateRangeDropdownComponent.prototype.changeCalendarValue = function (newValue, keyboardChange) {
        var _this = this;
        if (keyboardChange === void 0) { keyboardChange = false; }
        requestAnimationFrame(function () {
            if (keyboardChange && !_this.isDropdownOpen) {
                return;
            }
            _super.prototype.changeCalendarValue.call(_this, newValue, keyboardChange);
            _this.inputElement.focus();
            _this.cdRef.detectChanges();
        });
    };
    DateRangeDropdownComponent.prototype.makeFocus = function (focusOn) {
        var _this = this;
        setTimeout(function () {
            if (_this.focusOn !== focusOn) {
                _this.focusOn = focusOn;
                if (_this.value[focusOn]) {
                    _this.calendarValue = _this.value[focusOn];
                }
            }
            _this.cdRef.markForCheck();
        });
    };
    DateRangeDropdownComponent.prototype.changeInputValue = function (newValue) {
        try {
            this.calendarValue = newValue ? (newValue.from || newValue.to || null) : null;
        }
        catch (e) {
            this.calendarValue = null;
        }
        this.value = newValue;
        if (!this.isDropdownOpen) {
            this.currentValue = this.value;
        }
        this.valueChange.emit(this.value);
        this.cdRef.detectChanges();
    };
    DateRangeDropdownComponent.prototype.onBlur = function () {
        if (!this.isDropdownOpen) {
            this.elementRef.nativeElement.dispatchEvent(createCustomEvent('blur', {
                bubbles: false,
            }));
            this.inputElement.writeValue(this.value);
            this.cdRef.detectChanges();
        }
        if (this.inlineEdit) {
            this.keepFocus = this.isDropdownOpen;
        }
        if (this.inputModel) {
            this.inputModel.control.markAsTouched();
        }
    };
    DateRangeDropdownComponent.prototype.onMouseDown = function () {
        if (!this.disabled) {
            if (!this.isDropdownOpen && !this.inlineEdit) {
                this.onOpenChange(true);
            }
            this.keepFocus = true;
        }
    };
    DateRangeDropdownComponent.prototype.applyValue = function () {
        this.inputElement.focus();
        this.currentValue = this.value;
        this.inputElement.writeValue(this.value);
        this.valueChange.emit(this.value);
        this.onOpenChange(false);
    };
    DateRangeDropdownComponent.prototype.clearValue = function () {
        _super.prototype.clearValue.call(this);
        this.currentValue = null;
        this.valueChange.emit(this.value);
        this.inputModel.control.markAsPristine();
        this.inputModel.control.markAsUntouched();
        this.onOpenChange(false);
    };
    DateRangeDropdownComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ChangeDetectorRef },
        { type: DynamicTranslations },
        { type: undefined, decorators: [{ type: Inject, args: [CDS_DATE_TIME_NOW,] }] }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateRangeDropdownComponent.prototype, "appearance", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateRangeDropdownComponent.prototype, "label", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateRangeDropdownComponent.prototype, "inlineEdit", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], DateRangeDropdownComponent.prototype, "numberOfMonths", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], DateRangeDropdownComponent.prototype, "valueChange", void 0);
    __decorate([
        ViewChild('dropdown'),
        __metadata("design:type", DropdownComponent)
    ], DateRangeDropdownComponent.prototype, "dropdown", void 0);
    __decorate([
        ViewChild('input'),
        __metadata("design:type", InputComponent)
    ], DateRangeDropdownComponent.prototype, "inputElement", void 0);
    __decorate([
        ViewChild('input', { read: NgModel }),
        __metadata("design:type", NgModel)
    ], DateRangeDropdownComponent.prototype, "inputModel", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateRangeDropdownComponent.prototype, "disabled", void 0);
    DateRangeDropdownComponent = __decorate([ __param(4, Inject(CDS_DATE_TIME_NOW)),
        __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            ChangeDetectorRef,
            DynamicTranslations, Function])
    ], DateRangeDropdownComponent);
DateRangeDropdownComponent.ɵfac = function DateRangeDropdownComponent_Factory(t) { return new (t || DateRangeDropdownComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations), ɵngcc0.ɵɵdirectiveInject(CDS_DATE_TIME_NOW)); };
DateRangeDropdownComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DateRangeDropdownComponent, selectors: [["cds-date-range-dropdown"]], viewQuery: function DateRangeDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c14, true);
        ɵngcc0.ɵɵviewQuery(_c5, true);
        ɵngcc0.ɵɵviewQuery(_c5, true, NgModel);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputModel = _t.first);
    } }, inputs: { appearance: "appearance", label: "label", inlineEdit: "inlineEdit", numberOfMonths: "numberOfMonths", disabled: "disabled" }, outputs: { valueChange: "valueChange" }, features: [ɵngcc0.ɵɵProvidersFeature([DynamicTranslations]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 6, vars: 14, consts: [[1, "cds-date-time-form__range-input"], ["cdsDateRangeInput", "", 1, "cds-control--child", 3, "appearance", "format", "selected", "constraints", "cdsDateKeyboardNavigation", "keyboardConstraints", "ngModel", "label", "placeholder", "readonly", "disabled", "cdsDateKeyboardNavigationChange", "ngModelChange", "blur", "click", "mousedown", "keydown.enter"], ["input", "", "inputModel", "ngModel"], [1, "cds-icon-calendar", 3, "click"], ["class", "cds-dropdown--auto-height", 3, "anchor", "dismiss", 4, "ngIf"], [1, "cds-dropdown--auto-height", 3, "anchor", "dismiss"], ["dropdown", ""], [1, "cds-date-time-form__content"], [3, "focusOn", "constraints", "numberOfMonths", "startRange", "endRange", "padDaysInMonth", "ngModel", "yearSelectRange", "clickValueChange", "keyboardValueChange"], [1, "cds-date-time-form__footer"], ["cdsButton", "", "type", "button", 1, "cds-button-text", 3, "click"], ["cdsButton", "", "type", "button", 1, "cds-button-primary", 3, "disabled", "click"]], template: function DateRangeDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        var _r10 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "cds-input", 1, 2);
        ɵngcc0.ɵɵlistener("cdsDateKeyboardNavigationChange", function DateRangeDropdownComponent_Template_cds_input_cdsDateKeyboardNavigationChange_1_listener($event) { return ctx.changeCalendarValue($event, true); })("ngModelChange", function DateRangeDropdownComponent_Template_cds_input_ngModelChange_1_listener($event) { return ctx.changeInputValue($event); })("blur", function DateRangeDropdownComponent_Template_cds_input_blur_1_listener() { return ctx.onBlur(); })("click", function DateRangeDropdownComponent_Template_cds_input_click_1_listener() { return !ctx.inlineEdit && ctx.onOpenChange(true); })("mousedown", function DateRangeDropdownComponent_Template_cds_input_mousedown_1_listener() { return ctx.onMouseDown(); })("keydown.enter", function DateRangeDropdownComponent_Template_cds_input_keydown_enter_1_listener() { ɵngcc0.ɵɵrestoreView(_r10); var _r1 = ɵngcc0.ɵɵreference(3); return ctx.isDropdownOpen ? ctx.focusOn === "to" ? _r1.valid && ctx.applyValue() : ctx.makeFocus("to") : ctx.onOpenChange(true); });
        ɵngcc0.ɵɵelementStart(4, "a", 3);
        ɵngcc0.ɵɵlistener("click", function DateRangeDropdownComponent_Template_a_click_4_listener() { return ctx.inlineEdit && ctx.onOpenChange(true); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DateRangeDropdownComponent_cds_dropdown_5_Template, 9, 14, "cds-dropdown", 4);
    } if (rf & 2) {
        var _r0 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("cds-control--required", ctx.dateRequired);
        ɵngcc0.ɵɵproperty("appearance", ctx.appearance)("format", ctx.format)("selected", ctx.keepFocus)("constraints", ctx.getConstraints())("cdsDateKeyboardNavigation", ctx.isDropdownOpen ? ctx.calendarValue || ctx.defaultDate : null)("keyboardConstraints", ctx.isDropdownOpen ? ctx.constraints : null)("ngModel", ctx.value)("label", ctx.label)("placeholder", ctx.placeholder)("readonly", !ctx.inlineEdit)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", _r0 && ctx.isDropdownOpen);
    } }, directives: [InputComponent, DateRangeInputDirective, DateKeyboardNavigationDirective, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc1.NgIf, DropdownComponent, CalendarRangeComponent, ButtonRippleDirective], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DateRangeDropdownComponent, [{
        type: Component,
        args: [{
                selector: 'cds-date-range-dropdown',
                template: "<div class=\"cds-date-time-form__range-input\">\n    <cds-input #input #inputModel=\"ngModel\"\n               [appearance]=\"appearance\"\n               class=\"cds-control--child\"\n               [class.cds-control--required]=\"dateRequired\"\n               cdsDateRangeInput\n               [format]=\"format\"\n               [selected]=\"keepFocus\"\n               [constraints]=\"getConstraints()\"\n               [cdsDateKeyboardNavigation]=\"isDropdownOpen ? calendarValue || defaultDate : null\"\n               (cdsDateKeyboardNavigationChange)=\"changeCalendarValue($event, true)\"\n               [keyboardConstraints]=\"isDropdownOpen ? constraints : null\"\n               [ngModel]=\"value\"\n               (ngModelChange)=\"changeInputValue($event)\"\n               [label]=\"label\"\n               [placeholder]=\"placeholder\"\n               [readonly]=\"!inlineEdit\"\n               [disabled]=\"disabled\"\n               (blur)=\"onBlur()\"\n               (click)=\"!inlineEdit && onOpenChange(true)\"\n               (mousedown)=\"onMouseDown()\"\n               (keydown.enter)=\"isDropdownOpen ? (focusOn === 'to' ? (inputModel.valid && applyValue()) : makeFocus('to')) : onOpenChange(true)\">\n        <a class=\"cds-icon-calendar\" (click)=\"inlineEdit && onOpenChange(true)\"></a>\n    </cds-input>\n</div>\n<cds-dropdown #dropdown *ngIf=\"input && isDropdownOpen\" (dismiss)=\"onOpenChange(false)\" [anchor]=\"input.elementRef\" class=\"cds-dropdown--auto-height\">\n\t<div class=\"cds-date-time-form__content\">\n\t\t<cds-calendar-range [focusOn]=\"focusOn\"\n\t\t                [constraints]=\"constraints\"\n\t\t                [numberOfMonths]=\"numberOfMonths\"\n\t\t                [startRange]=\"value?.from\"\n\t\t                [endRange]=\"value?.to\"\n\t\t                [padDaysInMonth]=\"padDaysInMonth\"\n\t\t                [ngModel]=\"calendarValue\"\n\t\t                (clickValueChange)=\"changeCalendarValue($event)\"\n\t\t                (keyboardValueChange)=\"changeCalendarValue($event, true)\"\n\t\t                [yearSelectRange]=\"yearSelectRange\"></cds-calendar-range>\n\t</div>\n\t<div class=\"cds-date-time-form__footer\">\n\t\t<button cdsButton type=\"button\" class=\"cds-button-text\" (click)=\"clearValue()\" [attr.aria-label]=\"translations.clearButton\">{{translations.clearButton}}</button>\n\t\t<button cdsButton type=\"button\" class=\"cds-button-primary\" (click)=\"applyValue()\" [attr.aria-label]=\"translations.apply\" [disabled]=\"!inputModel.valid\">{{translations.applyButton}}</button>\n\t</div>\n</cds-dropdown>",
                providers: [DynamicTranslations]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: DynamicTranslations }, { type: undefined, decorators: [{
                type: Inject,
                args: [CDS_DATE_TIME_NOW]
            }] }]; }, { appearance: [{
            type: Input
        }], label: [{
            type: Input
        }], inlineEdit: [{
            type: Input
        }], numberOfMonths: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], dropdown: [{
            type: ViewChild,
            args: ['dropdown']
        }], inputElement: [{
            type: ViewChild,
            args: ['input']
        }], inputModel: [{
            type: ViewChild,
            args: ['input', { read: NgModel }]
        }], disabled: [{
            type: Input
        }] }); })();
    return DateRangeDropdownComponent;
}(DateRangeAbstractControlComponent));

var DATE_RANGE_FORM_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return DateRangeFormComponent; }),
    multi: true,
};
var DATE_RANGE_FORM_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(function () { return DateRangeFormComponent; }),
    multi: true,
};
var DateRangeFormComponent = /** @class */ (function (_super) {
    __extends(DateRangeFormComponent, _super);
    function DateRangeFormComponent(elementRef, renderer, timezonesService, cdRef, dateTimeValidatorService, dialogService, componentTranslations, now) {
        var _this = _super.call(this, timezonesService) || this;
        _this.cdRef = cdRef;
        _this.dateTimeValidatorService = dateTimeValidatorService;
        _this.dialogService = dialogService;
        _this.now = now;
        _this.appearance = 'outline';
        _this.inlineEdit = false;
        _this.dateRequired = false;
        _this.showInputs = true;
        _this.padDaysInMonth = false;
        _this.mode = 'dialog';
        _this.disabled = false;
        _this.onTouchedCallback = noop;
        _this.onChangeCallback = noop;
        _this.onValidatorChange = noop;
        _this.descriptionId = Unique.next('cds-date-time-form-');
        renderer.addClass(elementRef.nativeElement, 'cds-date-time-form');
        renderer.addClass(elementRef.nativeElement, 'cds-date-time-form--range');
        renderer.addClass(elementRef.nativeElement, 'cds-control--parent');
        renderer.addClass(elementRef.nativeElement, 'cds-control');
        componentTranslations.use(CDS_DATE_TIME_TRANSLATIONS, dateTimeTranslationsFactory, function (translations) {
            _this.translations = translations;
            if (_this.afterChanges) {
                cdRef.detectChanges();
            }
        });
        return _this;
    }
    DateRangeFormComponent.prototype.ngOnInit = function () {
        if (!this.afterChanges) {
            this.ngOnChanges({});
        }
    };
    DateRangeFormComponent.prototype.ngOnChanges = function (changes) {
        this.afterChanges = true;
        _super.prototype.ngOnChanges.call(this, changes);
        this.updateConstraints();
        if ('from' in changes || 'to' in changes || 'disableWeekends' in changes || 'allowedDays' in changes || 'dateRequired' in changes) {
            this.onValidatorChange();
        }
    };
    DateRangeFormComponent.prototype.openDialog = function (focusOn) {
        var _this = this;
        if (focusOn === void 0) { focusOn = 'from'; }
        if (!this.disabled) {
            this.keepFocus = focusOn;
            this.focusOn = focusOn;
            this.dialogService.open(this.dialog).then(function (value) {
                _this.closeDialog(value);
                return value;
            }, function () { return null; });
        }
        return Promise.resolve(null);
    };
    DateRangeFormComponent.prototype.closeDialog = function (value) {
        if (this.keepFocus === 'to') {
            if (this.inputTo) {
                this.inputTo.focus();
            }
        }
        else if (this.keepFocus === 'from') {
            if (this.inputFrom) {
                this.inputFrom.focus();
            }
        }
        this.focusOn = null;
        this.keepFocus = null;
        this.onTouchedCallback();
        if (value !== this.value && value !== undefined) {
            this.value = value;
            this.updateConstraints();
            this.onChangeCallback(value);
        }
    };
    DateRangeFormComponent.prototype.updateValue = function (newValue) {
        this.value = newValue;
        this.onChangeCallback(newValue);
    };
    DateRangeFormComponent.prototype.updateFromValue = function (value) {
        if (this.value) {
            this.value = { from: value, to: this.value.to };
        }
        else {
            this.value = { from: value };
        }
        this.updateConstraints();
    };
    DateRangeFormComponent.prototype.updateToValue = function (value) {
        if (this.value) {
            this.value = { from: this.value.from, to: value };
        }
        else {
            this.value = { to: value };
        }
        this.updateConstraints();
    };
    DateRangeFormComponent.prototype.writeValue = function (modelValue) {
        this.value = modelValue;
        this.cdRef.markForCheck();
    };
    DateRangeFormComponent.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    DateRangeFormComponent.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    DateRangeFormComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
        this.cdRef.markForCheck();
    };
    DateRangeFormComponent.prototype.validate = function (control) {
        this.cdRef.markForCheck();
        var value = control.value;
        if (!value) {
            this.errorsFrom = this.isDateRequired('from') ? { required: true } : null;
            this.errorsTo = this.isDateRequired('to') ? { required: true } : null;
            return this.errorsFrom || this.errorsTo;
        }
        this.errorsFrom = this.dateTimeValidatorService.validate(this.constraints, value.from, this.format);
        if (!value.from && this.isDateRequired('from')) {
            this.errorsFrom = __assign(__assign({}, this.errorsFrom), { required: true });
        }
        this.errorsTo = this.dateTimeValidatorService.validate(this.constraintsTo, value.to, this.format);
        if (!value.to && this.isDateRequired('to')) {
            this.errorsTo = __assign(__assign({}, this.errorsTo), { required: true });
        }
        return this.errorsFrom || this.errorsTo;
    };
    DateRangeFormComponent.prototype.isDateRequired = function (range) {
        return this.dateRequired === true || this.dateRequired === range;
    };
    DateRangeFormComponent.prototype.registerOnValidatorChange = function (fn) {
        this.onValidatorChange = fn;
    };
    DateRangeFormComponent.prototype.onBlur = function (range) {
        var _a, _b;
        this.onTouchedCallback();
        if (this.inlineEdit) {
            this.keepFocus = this.focusOn;
        }
        if (range === 'from') {
            this.inputFrom.writeValue((_a = this.value) === null || _a === void 0 ? void 0 : _a.from);
            if (this.inputToModel) {
                this.inputToModel.control.markAsTouched();
            }
        }
        else if (range === 'to') {
            this.inputTo.writeValue((_b = this.value) === null || _b === void 0 ? void 0 : _b.to);
            if (this.inputFromModel) {
                this.inputFromModel.control.markAsTouched();
            }
        }
    };
    DateRangeFormComponent.prototype.onMouseDown = function (field) {
        if (!this.disabled) {
            this.keepFocus = field;
        }
    };
    DateRangeFormComponent.prototype.updateConstraints = function () {
        var _a;
        if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.from) {
            this.constraintsTo = this.constraints.update({
                from: this.value.from,
            });
        }
        else {
            this.constraintsTo = this.constraints;
        }
    };
    DateRangeFormComponent.prototype.updatedConstraints = function () {
        var mode = 'date';
        return __assign({ mode: mode }, _super.prototype.updatedConstraints.call(this));
    };
    DateRangeFormComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: TimezonesService },
        { type: ChangeDetectorRef },
        { type: DateTimeValidatorService },
        { type: DialogService },
        { type: DynamicTranslations },
        { type: undefined, decorators: [{ type: Inject, args: [CDS_DATE_TIME_NOW,] }] }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateRangeFormComponent.prototype, "appearance", void 0);
    __decorate([
        Input(),
        HostBinding('class.cds-date-time-form--hidden'),
        __metadata("design:type", Boolean)
    ], DateRangeFormComponent.prototype, "hidden", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateRangeFormComponent.prototype, "format", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateRangeFormComponent.prototype, "placeholder", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateRangeFormComponent.prototype, "labelFrom", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateRangeFormComponent.prototype, "labelTo", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateRangeFormComponent.prototype, "label", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateRangeFormComponent.prototype, "inlineEdit", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], DateRangeFormComponent.prototype, "dateRequired", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateRangeFormComponent.prototype, "showInputs", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], DateRangeFormComponent.prototype, "numberOfMonths", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateRangeFormComponent.prototype, "padDaysInMonth", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateRangeFormComponent.prototype, "mode", void 0);
    __decorate([
        ViewChild('inputFrom'),
        __metadata("design:type", InputComponent)
    ], DateRangeFormComponent.prototype, "inputFrom", void 0);
    __decorate([
        ViewChild('inputTo'),
        __metadata("design:type", InputComponent)
    ], DateRangeFormComponent.prototype, "inputTo", void 0);
    __decorate([
        ViewChild('inputFrom', { read: NgModel }),
        __metadata("design:type", NgModel)
    ], DateRangeFormComponent.prototype, "inputFromModel", void 0);
    __decorate([
        ViewChild('inputTo', { read: NgModel }),
        __metadata("design:type", NgModel)
    ], DateRangeFormComponent.prototype, "inputToModel", void 0);
    __decorate([
        ViewChild('input', { read: NgModel }),
        __metadata("design:type", NgModel)
    ], DateRangeFormComponent.prototype, "inputModel", void 0);
    __decorate([
        ViewChild('dialog', { static: true }),
        __metadata("design:type", TemplateRef)
    ], DateRangeFormComponent.prototype, "dialog", void 0);
    DateRangeFormComponent = __decorate([ __param(7, Inject(CDS_DATE_TIME_NOW)),
        __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            TimezonesService,
            ChangeDetectorRef,
            DateTimeValidatorService,
            DialogService,
            DynamicTranslations, Function])
    ], DateRangeFormComponent);
DateRangeFormComponent.ɵfac = function DateRangeFormComponent_Factory(t) { return new (t || DateRangeFormComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(TimezonesService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DateTimeValidatorService), ɵngcc0.ɵɵdirectiveInject(DialogService), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations), ɵngcc0.ɵɵdirectiveInject(CDS_DATE_TIME_NOW)); };
DateRangeFormComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DateRangeFormComponent, selectors: [["cds-date-range-form"]], viewQuery: function DateRangeFormComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c29, true);
        ɵngcc0.ɵɵviewQuery(_c30, true);
        ɵngcc0.ɵɵviewQuery(_c29, true, NgModel);
        ɵngcc0.ɵɵviewQuery(_c30, true, NgModel);
        ɵngcc0.ɵɵviewQuery(_c5, true, NgModel);
        ɵngcc0.ɵɵstaticViewQuery(_c33, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputFrom = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputTo = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputFromModel = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputToModel = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputModel = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dialog = _t.first);
    } }, hostVars: 2, hostBindings: function DateRangeFormComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("cds-date-time-form--hidden", ctx.hidden);
    } }, inputs: { appearance: "appearance", hidden: "hidden", format: "format", placeholder: "placeholder", labelFrom: "labelFrom", labelTo: "labelTo", label: "label", inlineEdit: "inlineEdit", dateRequired: "dateRequired", showInputs: "showInputs", numberOfMonths: "numberOfMonths", padDaysInMonth: "padDaysInMonth", mode: "mode" }, features: [ɵngcc0.ɵɵProvidersFeature([DATE_RANGE_FORM_CONTROL_VALUE_ACCESSOR, DATE_RANGE_FORM_VALIDATOR, DynamicTranslations]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 2, consts: [["class", "cds-date-time-form__container", 4, "ngIf"], [3, "appearance", "focusOn", "format", "placeholder", "label", "disabled", "value", "constraints", "numberOfMonths", "dateRequired", "inlineEdit", "padDaysInMonth", "yearSelectRange", "valueChange", "blur", 4, "ngIf"], ["dialog", ""], [1, "cds-date-time-form__container"], [1, "cds-date-time-form__date-input"], [1, "cds-sr-only"], ["cdsDateInput", "", 1, "cds-control--child", 3, "appearance", "constraints", "format", "selected", "ngModel", "label", "placeholder", "readonly", "disabled", "cdsInvalid", "ariaDescribedBy", "ngModelChange", "mousedown", "blur", "click", "keydown.enter"], ["inputFrom", ""], [1, "cds-icon-calendar", 3, "click"], ["inputTo", ""], [3, "appearance", "focusOn", "format", "placeholder", "label", "disabled", "value", "constraints", "numberOfMonths", "dateRequired", "inlineEdit", "padDaysInMonth", "yearSelectRange", "valueChange", "blur"], [3, "focusOn", "format", "placeholder", "labelFrom", "labelTo", "showInputs", "value", "constraints", "numberOfMonths", "dateRequired", "padDaysInMonth", "yearSelectRange", "dialogClose"]], template: function DateRangeFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DateRangeFormComponent_div_0_Template, 11, 28, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DateRangeFormComponent_cds_date_range_dropdown_1_Template, 1, 13, "cds-date-range-dropdown", 1);
        ɵngcc0.ɵɵtemplate(2, DateRangeFormComponent_ng_template_2_Template, 1, 12, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hidden && ctx.mode === "dialog");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.mode === "dropdown");
    } }, directives: [ɵngcc1.NgIf, InputComponent, DateInputDirective, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, InvalidDirective, DateRangeDropdownComponent, DateRangeDialogComponent], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DateRangeFormComponent, [{
        type: Component,
        args: [{
                selector: 'cds-date-range-form',
                template: "<div class=\"cds-date-time-form__container\" *ngIf=\"!hidden && mode === 'dialog'\">\n\t<div class=\"cds-date-time-form__date-input\">\n\t\t<div [attr.id]=\"descriptionId\" class=\"cds-sr-only\">{{translations.dateInputLabel}}</div>\n\t\t<cds-input #inputFrom\n\t\t           [appearance]=\"appearance\"\n\t\t           cdsDateInput\n\t\t           [constraints]=\"null\"\n\t\t           class=\"cds-control--child\"\n\t\t           [class.cds-control--required]=\"isDateRequired('from')\"\n\t\t           [format]=\"format\"\n\t\t           [selected]=\"keepFocus==='from'\"\n\t\t           [ngModel]=\"value?.from\"\n\t\t           (ngModelChange)=\"updateFromValue($event)\"\n\t\t           [label]=\"labelFrom\"\n\t\t           [placeholder]=\"placeholder\"\n\t\t           [readonly]=\"!inlineEdit\"\n\t\t           [disabled]=\"disabled\"\n\t\t           [cdsInvalid]=\"errorsFrom != null\"\n\t\t           (mousedown)=\"onMouseDown('from')\"\n\t\t           (blur)=\"onBlur('from')\"\n\t\t           (click)=\"!inlineEdit && openDialog('from')\"\n\t\t           (keydown.enter)=\"openDialog('from')\"\n\t\t           [ariaDescribedBy]=\"descriptionId\">\n\t\t\t<a class=\"cds-icon-calendar\" (click)=\"inlineEdit && openDialog('from')\"></a>\n\t\t</cds-input>\n\t</div>\n\t<div class=\"cds-date-time-form__date-input\">\n\t\t<cds-input #inputTo\n\t\t           [appearance]=\"appearance\"\n\t\t           cdsDateInput\n\t\t           [constraints]=\"null\"\n\t\t           class=\"cds-control--child\"\n\t\t           [class.cds-control--required]=\"isDateRequired('to')\"\n\t\t           [format]=\"format\"\n\t\t           [selected]=\"keepFocus==='to'\"\n\t\t           [ngModel]=\"value?.to\"\n\t\t           (ngModelChange)=\"updateToValue($event)\"\n\t\t           [label]=\"labelTo\"\n\t\t           [placeholder]=\"placeholder\"\n\t\t           [readonly]=\"!inlineEdit\"\n\t\t           [disabled]=\"disabled\"\n\t\t           [cdsInvalid]=\"errorsTo != null\"\n\t\t           (mousedown)=\"onMouseDown('to')\"\n\t\t           (blur)=\"onBlur('to')\"\n\t\t           (click)=\"!inlineEdit && openDialog('to')\"\n\t\t           (keydown.enter)=\"openDialog('to')\"\n\t\t           [ariaDescribedBy]=\"descriptionId\">\n\t\t\t<a class=\"cds-icon-calendar\" (click)=\"inlineEdit && openDialog('to')\"></a>\n\t\t</cds-input>\n\t</div>\n</div>\n<cds-date-range-dropdown *ngIf=\"mode === 'dropdown'\" [appearance]=\"appearance\" [focusOn]=\"focusOn\" [format]=\"format\" [placeholder]=\"placeholder\"\n                         [label]=\"label\" (valueChange)=\"updateValue($event)\" (blur)=\"onBlur()\" [disabled]=\"disabled\"\n                         [value]=\"value\" [constraints]=\"constraints\" [numberOfMonths]=\"numberOfMonths\"\n                         [dateRequired]=\"dateRequired\" [inlineEdit]=\"inlineEdit\" [padDaysInMonth]=\"padDaysInMonth\" [yearSelectRange]=\"yearSelectRange\"></cds-date-range-dropdown>\n<ng-template #dialog let-dialog>\n\t<cds-date-range-dialog [focusOn]=\"focusOn\" [format]=\"format\" [placeholder]=\"placeholder\"\n\t                       [labelFrom]=\"labelFrom\" [labelTo]=\"labelTo\" [showInputs]=\"showInputs\"\n\t                       [value]=\"value\" [constraints]=\"constraints\" [numberOfMonths]=\"numberOfMonths\"\n\t                       [dateRequired]=\"dateRequired\" [padDaysInMonth]=\"padDaysInMonth\" [yearSelectRange]=\"yearSelectRange\" (dialogClose)=\"dialog.resolve($event)\"></cds-date-range-dialog>\n</ng-template>\n",
                providers: [DATE_RANGE_FORM_CONTROL_VALUE_ACCESSOR, DATE_RANGE_FORM_VALIDATOR, DynamicTranslations]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: TimezonesService }, { type: ɵngcc0.ChangeDetectorRef }, { type: DateTimeValidatorService }, { type: DialogService }, { type: DynamicTranslations }, { type: undefined, decorators: [{
                type: Inject,
                args: [CDS_DATE_TIME_NOW]
            }] }]; }, { appearance: [{
            type: Input
        }], hidden: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.cds-date-time-form--hidden']
        }], format: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], labelFrom: [{
            type: Input
        }], labelTo: [{
            type: Input
        }], label: [{
            type: Input
        }], inlineEdit: [{
            type: Input
        }], dateRequired: [{
            type: Input
        }], showInputs: [{
            type: Input
        }], numberOfMonths: [{
            type: Input
        }], padDaysInMonth: [{
            type: Input
        }], mode: [{
            type: Input
        }], inputFrom: [{
            type: ViewChild,
            args: ['inputFrom']
        }], inputTo: [{
            type: ViewChild,
            args: ['inputTo']
        }], inputFromModel: [{
            type: ViewChild,
            args: ['inputFrom', { read: NgModel }]
        }], inputToModel: [{
            type: ViewChild,
            args: ['inputTo', { read: NgModel }]
        }], inputModel: [{
            type: ViewChild,
            args: ['input', { read: NgModel }]
        }], dialog: [{
            type: ViewChild,
            args: ['dialog', { static: true }]
        }] }); })();
    return DateRangeFormComponent;
}(BaseDateTimeComponent));

var TIMEZONE_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(function () { return TimezoneDirective; }),
    multi: true,
};
var TimezoneDirective = /** @class */ (function () {
    function TimezoneDirective(timezoneService) {
        this.timezoneService = timezoneService;
        this.selectedChange = new EventEmitter();
        this.$changes = new Subject();
        this.onValidatorChange = noop;
        this.timezones = timezoneService.getTimezones();
    }
    TimezoneDirective.prototype.getTimezones = function () {
        return this.timezones;
    };
    TimezoneDirective.prototype.changeTimezone = function (timezone) {
        if (timezone !== this.selected) {
            this.selected = timezone;
            this.selectedChange.emit(timezone);
            this.onValidatorChange();
        }
    };
    TimezoneDirective.prototype.ngOnChanges = function (changes) {
        this.onValidatorChange();
        this.$changes.next(this.selected);
    };
    TimezoneDirective.prototype.registerOnValidatorChange = function (fn) {
        this.onValidatorChange = fn;
    };
    TimezoneDirective.prototype.validate = function (control) {
        if (!control.value) {
            return null;
        }
        var timezone = this.timezoneService.getTimezone(this.selected);
        if (timezone) {
            return null;
        }
        return {
            'date-time-timezone': { timezone: this.selected },
        };
    };
    TimezoneDirective.prototype.ngOnDestroy = function () {
        this.$changes.complete();
    };
    TimezoneDirective.ctorParameters = function () { return [
        { type: TimezonesService }
    ]; };
    __decorate([
        Input('cdsTimezone'),
        __metadata("design:type", String)
    ], TimezoneDirective.prototype, "selected", void 0);
    __decorate([
        Output('cdsTimezoneChange'),
        __metadata("design:type", EventEmitter)
    ], TimezoneDirective.prototype, "selectedChange", void 0);
    TimezoneDirective = __decorate([ __metadata("design:paramtypes", [TimezonesService])
    ], TimezoneDirective);
TimezoneDirective.ɵfac = function TimezoneDirective_Factory(t) { return new (t || TimezoneDirective)(ɵngcc0.ɵɵdirectiveInject(TimezonesService)); };
TimezoneDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TimezoneDirective, selectors: [["", "cdsTimezone", ""]], inputs: { selected: ["cdsTimezone", "selected"] }, outputs: { selectedChange: "cdsTimezoneChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            TIMEZONE_VALIDATOR,
        ]), ɵngcc0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TimezoneDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsTimezone]',
                providers: [
                    TIMEZONE_VALIDATOR,
                ]
            }]
    }], function () { return [{ type: TimezonesService }]; }, { selectedChange: [{
            type: Output,
            args: ['cdsTimezoneChange']
        }], selected: [{
            type: Input,
            args: ['cdsTimezone']
        }] }); })();
    return TimezoneDirective;
}());

var DateAbstractControlComponent = /** @class */ (function () {
    function DateAbstractControlComponent(timezonesService, dateTimeService, componentTranslations, cdRef, now) {
        var _this = this;
        this.timezonesService = timezonesService;
        this.dateTimeService = dateTimeService;
        this.cdRef = cdRef;
        this.now = now;
        this.timePickerValue = '00:00:00';
        this.format = 'date';
        this.dateRequired = false;
        this.padDaysInMonth = false;
        this.initialized = false;
        componentTranslations.use(CDS_DATE_TIME_TRANSLATIONS, dateTimeTranslationsFactory, function (translations) {
            _this.translations = translations;
            if (_this.initialized) {
                cdRef.detectChanges();
            }
        });
    }
    DateAbstractControlComponent.prototype.ngOnInit = function () {
        this.resolvedFormat = this.dateTimeService.resolveFormat(this.format);
        this.includesTime = this.dateTimeService.includesTime(this.format);
        this.useDayPeriod = this.dateTimeService.is12hMode(this.format);
        var defaultDate = getDefaultDate(this.constraints, new Date(this.now()));
        this.defaultDate = Time.fromDate(defaultDate).toString('date');
        this.dayPeriodsTranslation = this.dateTimeService.getDayPeriods();
        var value = this.inputValue || this.value;
        this.initialized = true;
        if (value) {
            try {
                var time = Time.fromString(this.value);
                this.inputValue = time.toString(this.includesTime ? 'datetime' : 'date');
                this.calendarValue = time.toString('date');
                this.timePickerValue = time.toString('time');
            }
            catch (_a) {
            }
        }
        if (this.useDayPeriod) {
            this.dayPeriodValue = this.dayPeriod ? this.dayPeriod : 'AM';
        }
    };
    DateAbstractControlComponent.prototype.changeInputValue = function (newValue) {
        this.inputValue = newValue;
        try {
            var time = Time.fromString(newValue);
            this.calendarValue = time.toString();
            this.timePickerValue = time.toString('time');
        }
        catch (e) {
            this.calendarValue = null;
            this.timePickerValue = null;
        }
    };
    DateAbstractControlComponent.prototype.changeCalendarValue = function (newValue) {
        this.calendarValue = newValue;
        if (this.includesTime) {
            if (this.timePickerValue == null) {
                this.timePickerValue = '00:00:00';
            }
            this.inputValue = newValue + "T" + this.timePickerValue;
        }
        else {
            this.inputValue = newValue;
        }
    };
    DateAbstractControlComponent.prototype.changeTimePickerValue = function (newValue) {
        this.timePickerValue = newValue;
        this.inputValue = this.calendarValue + "T" + newValue;
        if (this.dayPeriodValue == null) {
            return;
        }
        var _a = __read(newValue.split(':'), 1), hourPart = _a[0];
        this.dayPeriodValue = +hourPart >= 12 ? 'PM' : 'AM';
    };
    DateAbstractControlComponent.prototype.changeDayPeriodValue = function (dayPeriod) {
        if (dayPeriod && this.dayPeriodValue !== dayPeriod) {
            this.dayPeriodValue = dayPeriod;
            this.dayPeriod = dayPeriod;
            this.recalculateHour();
        }
    };
    DateAbstractControlComponent.prototype.recalculateHour = function () {
        if (this.dayPeriodValue == null || !this.inputValue) {
            return;
        }
        var timeAndNewHour = Time.fromString(this.inputValue);
        timeAndNewHour.toggleDayPeriod();
        var newValue = timeAndNewHour.toString('time');
        this.changeTimePickerValue(newValue);
    };
    DateAbstractControlComponent.prototype.clearValue = function () {
        this.calendarValue = null;
        this.timePickerValue = this.useDayPeriod ? '01:00:00' : '00:00:00';
        this.inputValue = null;
        if (this.dayPeriod != null) {
            this.dayPeriodValue = 'AM';
        }
        this.input.focus();
    };
    DateAbstractControlComponent.ctorParameters = function () { return [
        { type: TimezonesService },
        { type: DateTimeService },
        { type: DynamicTranslations },
        { type: ChangeDetectorRef },
        { type: undefined, decorators: [{ type: Inject, args: [CDS_DATE_TIME_NOW,] }] }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", DateTimeConstraints)
    ], DateAbstractControlComponent.prototype, "constraints", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateAbstractControlComponent.prototype, "format", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateAbstractControlComponent.prototype, "placeholder", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateAbstractControlComponent.prototype, "label", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateAbstractControlComponent.prototype, "dateRequired", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateAbstractControlComponent.prototype, "padDaysInMonth", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateAbstractControlComponent.prototype, "dayPeriod", void 0);
    __decorate([
        Input(),
        __metadata("design:type", TimezoneDirective)
    ], DateAbstractControlComponent.prototype, "timezone", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], DateAbstractControlComponent.prototype, "yearSelectRange", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateAbstractControlComponent.prototype, "value", void 0);
    __decorate([
        ViewChild('input'),
        __metadata("design:type", InputComponent)
    ], DateAbstractControlComponent.prototype, "input", void 0);
    DateAbstractControlComponent = __decorate([ __param(4, Inject(CDS_DATE_TIME_NOW)),
        __metadata("design:paramtypes", [TimezonesService,
            DateTimeService,
            DynamicTranslations,
            ChangeDetectorRef, Function])
    ], DateAbstractControlComponent);
DateAbstractControlComponent.ɵfac = function DateAbstractControlComponent_Factory(t) { return new (t || DateAbstractControlComponent)(ɵngcc0.ɵɵdirectiveInject(TimezonesService), ɵngcc0.ɵɵdirectiveInject(DateTimeService), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(CDS_DATE_TIME_NOW)); };
DateAbstractControlComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DateAbstractControlComponent, viewQuery: function DateAbstractControlComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c5, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, inputs: { format: "format", dateRequired: "dateRequired", padDaysInMonth: "padDaysInMonth", dayPeriod: "dayPeriod", constraints: "constraints", placeholder: "placeholder", label: "label", timezone: "timezone", yearSelectRange: "yearSelectRange", value: "value" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DateAbstractControlComponent, [{
        type: Directive
    }], function () { return [{ type: TimezonesService }, { type: DateTimeService }, { type: DynamicTranslations }, { type: ɵngcc0.ChangeDetectorRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [CDS_DATE_TIME_NOW]
            }] }]; }, { format: [{
            type: Input
        }], dateRequired: [{
            type: Input
        }], padDaysInMonth: [{
            type: Input
        }], dayPeriod: [{
            type: Input
        }], constraints: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], label: [{
            type: Input
        }], timezone: [{
            type: Input
        }], yearSelectRange: [{
            type: Input
        }], value: [{
            type: Input
        }], input: [{
            type: ViewChild,
            args: ['input']
        }] }); })();
    return DateAbstractControlComponent;
}());

var DateDialogComponent = /** @class */ (function (_super) {
    __extends(DateDialogComponent, _super);
    function DateDialogComponent(elementRef, renderer, timezonesService, dateTimeService, componentTranslations, cdRef, now) {
        var _this = _super.call(this, timezonesService, dateTimeService, componentTranslations, cdRef, now) || this;
        _this.animate = 1;
        _this.showInputs = true;
        _this.padDaysInMonth = false;
        _this.dialogClose = new EventEmitter();
        _this.timePickerValue = '00:00:00';
        _this.pristineCalendarValue = true;
        renderer.addClass(elementRef.nativeElement, 'cds-date-time-dialog');
        componentTranslations.use(CDS_ERRORS_TRANSLATIONS, errorsTranslationsFactory, function (translations) {
            _this.errorsTranslations = translations;
            if (_this.initialized) {
                cdRef.detectChanges();
            }
        });
        return _this;
    }
    DateDialogComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (this.timezone) {
            this.timezones = this.timezone.getTimezones();
            var localTimezone = this.timezonesService.getLocalTimezone();
            this.changeTimezoneValue(this.timezone.selected || (localTimezone ? localTimezone.code : null));
        }
    };
    DateDialogComponent.prototype.changeCalendarValue = function (newValue) {
        this.pristineCalendarValue = false;
        _super.prototype.changeCalendarValue.call(this, newValue);
        this.input.focus();
    };
    DateDialogComponent.prototype.changeTimezoneValue = function (timezoneCode) {
        this.timezoneValue = timezoneCode;
        if (timezoneCode) {
            this.constraints = this.constraints.updateTimezone(this.timezonesService.getTimezone(timezoneCode));
        }
    };
    DateDialogComponent.prototype.onBlur = function () {
        this.input.writeValue(this.inputValue);
    };
    DateDialogComponent.prototype.closeDialog = function () {
        this.dialogClose.emit(null);
    };
    DateDialogComponent.prototype.applyValue = function () {
        var value = this.inputValue;
        this.dialogClose.emit({
            date: value,
            timezone: this.timezoneValue,
            dayPeriod: this.dayPeriodValue,
        });
    };
    DateDialogComponent.prototype.clearValue = function () {
        _super.prototype.clearValue.call(this);
        if (this.timezone) {
            var localTimezone = this.timezonesService.getLocalTimezone();
            this.changeTimezoneValue(localTimezone ? localTimezone.code : null);
        }
    };
    DateDialogComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: TimezonesService },
        { type: DateTimeService },
        { type: DynamicTranslations },
        { type: ChangeDetectorRef },
        { type: undefined, decorators: [{ type: Inject, args: [CDS_DATE_TIME_NOW,] }] }
    ]; };
    __decorate([
        HostBinding('@animate'),
        __metadata("design:type", Number)
    ], DateDialogComponent.prototype, "animate", void 0);
    __decorate([
        Input(),
        __metadata("design:type", TimezoneDirective)
    ], DateDialogComponent.prototype, "timezone", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateDialogComponent.prototype, "dayPeriod", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateDialogComponent.prototype, "showInputs", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateDialogComponent.prototype, "padDaysInMonth", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], DateDialogComponent.prototype, "dialogClose", void 0);
    __decorate([
        ViewChild('input', { static: true }),
        __metadata("design:type", InputComponent)
    ], DateDialogComponent.prototype, "input", void 0);
    DateDialogComponent = __decorate([ __param(6, Inject(CDS_DATE_TIME_NOW)),
        __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            TimezonesService,
            DateTimeService,
            DynamicTranslations,
            ChangeDetectorRef, Function])
    ], DateDialogComponent);
DateDialogComponent.ɵfac = function DateDialogComponent_Factory(t) { return new (t || DateDialogComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(TimezonesService), ɵngcc0.ɵɵdirectiveInject(DateTimeService), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(CDS_DATE_TIME_NOW)); };
DateDialogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DateDialogComponent, selectors: [["cds-date-dialog"]], viewQuery: function DateDialogComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c5, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, hostVars: 1, hostBindings: function DateDialogComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵsyntheticHostProperty("@animate", ctx.animate);
    } }, inputs: { timezone: "timezone", dayPeriod: "dayPeriod", showInputs: "showInputs", padDaysInMonth: "padDaysInMonth" }, outputs: { dialogClose: "dialogClose" }, features: [ɵngcc0.ɵɵProvidersFeature([
            DynamicTranslations,
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 24, vars: 31, consts: [["role", "dialog", 3, "dialogClose", "cdsOnEscape"], ["ngForm", "", 1, "cds-date-time-dialog__fields"], ["form", "ngForm"], [1, "cds-date-time-dialog__container"], ["class", "cds-date-time-dialog__timezone-combo", 4, "ngIf"], [1, "cds-date-time-dialog__date-input"], ["cdsDateInput", "", "name", "input", 3, "cdsDateKeyboardNavigation", "format", "constraints", "dayPeriod", "keyboardConstraints", "ngModel", "label", "placeholder", "readonly", "required", "autofocus", "cdsDateKeyboardNavigationChange", "ngModelChange", "blur"], ["input", "", "inputModel", "ngModel"], ["class", "cds-date-time-dialog__day-period-combo", 4, "ngIf"], [1, "cds-date-time-dialog__errors"], [3, "cdsErrors", 4, "ngIf"], [1, "cds-date-time-dialog__pickers"], [3, "constraints", "padDaysInMonth", "ngModel", "yearSelectRange", "ngModelChange"], ["class", "cds-date-time-dialog__time-picker", 4, "ngIf"], [1, "cds-dialog-buttons"], ["cdsButton", "", "type", "button", 1, "cds-button-text", 3, "click"], ["cdsButton", "", "type", "button", 1, "cds-button-primary", 3, "disabled", "click"], [1, "cds-date-time-dialog__timezone-combo"], ["name", "timezone", "required", "", 3, "ngModel", "ngModelChange"], ["timezoneCombo", ""], ["title", ""], ["tabindex", "-1", 3, "cdsComboItem", "labelValue", 4, "ngFor", "ngForOf"], ["tabindex", "-1", 3, "cdsComboItem", "labelValue"], [1, "cds-date-time-dialog__day-period-combo"], ["appearance", "inline", "name", "useDayPeriod", 3, "ngModel", "ngModelChange"], ["dayPeriodCombo", ""], ["default", ""], [3, "cdsErrors"], [4, "cdsError"], [1, "cds-date-time-dialog__time-picker"], [1, "cds-date-time-dialog__time-label"], [3, "constraints", "format", "useDayPeriod", "disabled", "ngModel", "ngModelChange"]], template: function DateDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "cds-dialog", 0);
        ɵngcc0.ɵɵlistener("dialogClose", function DateDialogComponent_Template_cds_dialog_dialogClose_0_listener() { return ctx.closeDialog(); })("cdsOnEscape", function DateDialogComponent_Template_cds_dialog_cdsOnEscape_0_listener() { return ctx.closeDialog(); });
        ɵngcc0.ɵɵelementStart(1, "cds-slot-title");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "cds-slot-content");
        ɵngcc0.ɵɵelementStart(4, "div", 1, 2);
        ɵngcc0.ɵɵelementStart(6, "div", 3);
        ɵngcc0.ɵɵtemplate(7, DateDialogComponent_div_7_Template, 9, 4, "div", 4);
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵelementStart(9, "cds-input", 6, 7);
        ɵngcc0.ɵɵlistener("cdsDateKeyboardNavigationChange", function DateDialogComponent_Template_cds_input_cdsDateKeyboardNavigationChange_9_listener($event) { return ctx.changeCalendarValue($event); })("ngModelChange", function DateDialogComponent_Template_cds_input_ngModelChange_9_listener($event) { return ctx.changeInputValue($event); })("blur", function DateDialogComponent_Template_cds_input_blur_9_listener() { return ctx.onBlur(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, DateDialogComponent_div_12_Template, 12, 9, "div", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 9);
        ɵngcc0.ɵɵtemplate(14, DateDialogComponent_cds_errors_14_Template, 4, 2, "cds-errors", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 11);
        ɵngcc0.ɵɵelementStart(16, "cds-calendar", 12);
        ɵngcc0.ɵɵlistener("ngModelChange", function DateDialogComponent_Template_cds_calendar_ngModelChange_16_listener($event) { return ctx.changeCalendarValue($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(17, DateDialogComponent_div_17_Template, 5, 9, "div", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "cds-slot-footer");
        ɵngcc0.ɵɵelementStart(19, "div", 14);
        ɵngcc0.ɵɵelementStart(20, "button", 15);
        ɵngcc0.ɵɵlistener("click", function DateDialogComponent_Template_button_click_20_listener() { return ctx.clearValue(); });
        ɵngcc0.ɵɵtext(21);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "button", 16);
        ɵngcc0.ɵɵlistener("click", function DateDialogComponent_Template_button_click_22_listener() { return ctx.applyValue(); });
        ɵngcc0.ɵɵtext(23);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        var _r0 = ɵngcc0.ɵɵreference(5);
        var _r3 = ɵngcc0.ɵɵreference(11);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.translations.selectDateHeader, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("cds-date-time-dialog__fields--hidden", !ctx.timezones && !ctx.showInputs);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.timezones);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("cds-date-time-dialog__date-input--time", ctx.includesTime);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("cds-control--pristine", _r3.pristine && ctx.pristineCalendarValue);
        ɵngcc0.ɵɵproperty("cdsDateKeyboardNavigation", ctx.calendarValue || ctx.defaultDate)("format", ctx.format)("constraints", ctx.constraints)("dayPeriod", ctx.dayPeriodValue)("keyboardConstraints", ctx.constraints)("ngModel", ctx.inputValue)("label", ctx.label)("placeholder", ctx.placeholder)("readonly", !ctx.timezones && !ctx.showInputs)("required", ctx.dateRequired)("autofocus", true);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.includesTime && ctx.useDayPeriod);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("cds-date-time-dialog__errors--no-padding", !ctx.timezones && !ctx.showInputs);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !_r3.pristine || !ctx.pristineCalendarValue);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("constraints", ctx.constraints)("padDaysInMonth", ctx.padDaysInMonth)("ngModel", ctx.calendarValue)("yearSelectRange", ctx.yearSelectRange);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.includesTime);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.translations.clearButton);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", !_r0.valid);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.translations.applyButton);
    } }, directives: [DialogComponent, OnEscapeDirective, SlotsDirective, ɵngcc3.NgControlStatusGroup, ɵngcc3.NgForm, ɵngcc1.NgIf, InputComponent, DateInputDirective, DateKeyboardNavigationDirective, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.RequiredValidator, CalendarComponent, ButtonRippleDirective, ComboComponent, ɵngcc1.NgForOf, ComboItemDirective, ErrorsComponent, ErrorsDirective, ErrorDirective, TimePickerComponent], pipes: [AdjustTimeConstraintsPipe], encapsulation: 2, data: { animation: [
            trigger('animate', [
                transition(':leave', query('cds-dialog', animateChild())),
            ]),
        ] } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DateDialogComponent, [{
        type: Component,
        args: [{
                selector: 'cds-date-dialog',
                template: "<cds-dialog role=\"dialog\" (dialogClose)=\"closeDialog()\" (cdsOnEscape)=\"closeDialog()\">\n\t<cds-slot-title>\n\t\t{{translations.selectDateHeader}}\n\t</cds-slot-title>\n\t<cds-slot-content>\n\t\t<div class=\"cds-date-time-dialog__fields\" ngForm #form=\"ngForm\" [class.cds-date-time-dialog__fields--hidden]=\"!timezones && !showInputs\">\n\t\t\t<div class=\"cds-date-time-dialog__container\">\n\t\t\t\t<div class=\"cds-date-time-dialog__timezone-combo\" *ngIf=\"timezones\">\n\t\t\t\t\t<cds-combo #timezoneCombo\n\t\t\t\t\t           name=\"timezone\"\n\t\t\t\t\t           [ngModel]=\"timezoneValue\"\n\t\t\t\t\t           (ngModelChange)=\"changeTimezoneValue($event)\"\n\t\t\t\t\t           required>\n\t\t\t\t\t\t<label>{{timezoneCombo.selectedLabel}}</label>\n\t\t\t\t\t\t<label title>{{translations.timezoneLabel}}</label>\n\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t<li *ngFor=\"let timezone of timezones\" [cdsComboItem]=\"timezone.code\" [labelValue]=\"timezone.name\" tabindex=\"-1\">{{timezone.name}}</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</cds-combo>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"cds-date-time-dialog__date-input\" [class.cds-date-time-dialog__date-input--time]=\"includesTime\">\n\t\t\t\t\t<cds-input #input\n\t\t\t\t\t           #inputModel=\"ngModel\"\n\t\t\t\t\t           [class.cds-control--pristine]=\"inputModel.pristine && pristineCalendarValue\"\n\t\t\t\t\t           cdsDateInput\n\t\t\t\t\t           [cdsDateKeyboardNavigation]=\"calendarValue || defaultDate\"\n\t\t\t\t\t           (cdsDateKeyboardNavigationChange)=\"changeCalendarValue($event)\"\n\t\t\t\t\t           [format]=\"format\"\n\t\t\t\t\t           [constraints]=\"constraints\"\n\t\t\t\t\t           [dayPeriod]=\"dayPeriodValue\"\n\t\t\t\t\t           [keyboardConstraints]=\"constraints\"\n\t\t\t\t\t           name=\"input\"\n\t\t\t\t\t           [ngModel]=\"inputValue\"\n\t\t\t\t\t           (ngModelChange)=\"changeInputValue($event)\"\n\t\t\t\t\t           [label]=\"label\"\n\t\t\t\t\t           [placeholder]=\"placeholder\"\n\t\t\t\t\t           [readonly]=\"!timezones && !showInputs\"\n\t\t\t\t\t           [required]=\"dateRequired\"\n\t\t\t\t\t           (blur)=\"onBlur()\"\n\t\t\t\t\t           [autofocus]=\"true\"></cds-input>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"cds-date-time-dialog__day-period-combo\" *ngIf=\"includesTime && useDayPeriod\">\n\t\t\t\t\t<cds-combo #dayPeriodCombo\n\t\t\t\t\t           appearance=\"inline\"\n\t\t\t\t\t           name=\"useDayPeriod\"\n\t\t\t\t\t           [ngModel]=\"dayPeriodValue\"\n\t\t\t\t\t           (ngModelChange)=\"changeDayPeriodValue($event)\">\n\t\t\t\t\t\t<label>{{dayPeriodCombo.selectedLabel}}</label>\n\t\t\t\t\t\t<label default>{{translations.dayPeriodLabel}}</label>\n\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t<li [cdsComboItem]=\"'AM'\" [labelValue]=\"dayPeriodsTranslation[0]\" tabindex=\"-1\">{{dayPeriodsTranslation[0]}}</li>\n\t\t\t\t\t\t\t<li [cdsComboItem]=\"'PM'\" [labelValue]=\"dayPeriodsTranslation[1]\" tabindex=\"-1\">{{dayPeriodsTranslation[1]}}</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</cds-combo>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"cds-date-time-dialog__errors\" [class.cds-date-time-dialog__errors--no-padding]=\"!timezones && !showInputs\">\n\t\t\t<cds-errors *ngIf=\"!inputModel.pristine || !pristineCalendarValue\" [cdsErrors]=\"inputModel\">\n\t\t\t\t<i>&#8203;</i>\n\t\t\t\t<span *cdsError=\"'required'\">{{errorsTranslations.required}}</span>\n\t\t\t</cds-errors>\n\t\t</div>\n\t\t<div class=\"cds-date-time-dialog__pickers\">\n\t\t\t<cds-calendar [constraints]=\"constraints\"\n\t\t\t              [padDaysInMonth]=\"padDaysInMonth\"\n\t\t\t              [ngModel]=\"calendarValue\"\n\t\t\t              [yearSelectRange]=\"yearSelectRange\"\n\t\t\t              (ngModelChange)=\"changeCalendarValue($event)\"></cds-calendar>\n\t\t\t<div class=\"cds-date-time-dialog__time-picker\" *ngIf=\"includesTime\">\n\t\t\t\t<div class=\"cds-date-time-dialog__time-label\">{{translations.timeLabel}}</div>\n\t\t\t\t<cds-time-picker [constraints]=\"constraints | cdsAdjustTimeConstraints:inputValue\"\n\t\t\t\t                 [format]=\"resolvedFormat\"\n\t\t\t\t                 [useDayPeriod]=\"useDayPeriod\"\n\t\t\t\t                 [disabled]=\"!calendarValue\"\n\t\t\t\t                 [ngModel]=\"timePickerValue\"\n\t\t\t\t                 (ngModelChange)=\"changeTimePickerValue($event)\"></cds-time-picker>\n\t\t\t</div>\n\t\t</div>\n\t</cds-slot-content>\n\t<cds-slot-footer>\n\t\t<div class=\"cds-dialog-buttons\">\n\t\t\t<button cdsButton type=\"button\" class=\"cds-button-text\" (click)=\"clearValue()\">{{translations.clearButton}}</button>\n\t\t\t<button cdsButton type=\"button\" class=\"cds-button-primary\" [disabled]=\"!form.valid\" (click)=\"applyValue()\">{{translations.applyButton}}</button>\n\t\t</div>\n\t</cds-slot-footer>\n</cds-dialog>\n",
                animations: [
                    trigger('animate', [
                        transition(':leave', query('cds-dialog', animateChild())),
                    ]),
                ],
                providers: [
                    DynamicTranslations,
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: TimezonesService }, { type: DateTimeService }, { type: DynamicTranslations }, { type: ɵngcc0.ChangeDetectorRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [CDS_DATE_TIME_NOW]
            }] }]; }, { animate: [{
            type: HostBinding,
            args: ['@animate']
        }], timezone: [{
            type: Input
        }], dayPeriod: [{
            type: Input
        }], showInputs: [{
            type: Input
        }], padDaysInMonth: [{
            type: Input
        }], dialogClose: [{
            type: Output
        }], input: [{
            type: ViewChild,
            args: ['input', { static: true }]
        }] }); })();
    return DateDialogComponent;
}(DateAbstractControlComponent));

var DateDropdownComponent = /** @class */ (function (_super) {
    __extends(DateDropdownComponent, _super);
    function DateDropdownComponent(elementRef, renderer, timezonesService, cdRef, dateTimeService, componentTranslations, now) {
        var _this = _super.call(this, timezonesService, dateTimeService, componentTranslations, cdRef, now) || this;
        _this.elementRef = elementRef;
        _this.keepFocus = false;
        _this.appearance = 'outline';
        _this.inlineEdit = false;
        _this.valueChange = new EventEmitter();
        _this.dayPeriodChange = new EventEmitter();
        _this.disabled = false;
        renderer.addClass(elementRef.nativeElement, 'cds-date-time-form__container');
        return _this;
    }
    DateDropdownComponent.prototype.onOpenChange = function (isOpen) {
        if (isOpen && !this.isOpen) {
            this.currentValue = this.inputValue;
        }
        else if (!isOpen && this.isOpen) {
            /** writeValue to format input view value */
            this.input.writeValue(this.inputValue);
        }
        this.restoreCurrentValue(this.currentValue);
        if (!this.disabled) {
            this.isOpen = isOpen;
            this.keepFocus = isOpen;
            this.cdRef.detectChanges();
            if (isOpen && this.dropdown) {
                this.dropdown.scheduleUpdate();
            }
        }
    };
    DateDropdownComponent.prototype.restoreCurrentValue = function (value) {
        try {
            var date = Time.fromString(value).toDate();
            this.inputValue = value;
            this.calendarValue = Time.fromDate(date).toString('date');
        }
        catch (e) {
            this.inputValue = null;
            this.calendarValue = null;
        }
    };
    DateDropdownComponent.prototype.changeInputValue = function (newValue) {
        _super.prototype.changeInputValue.call(this, newValue);
        this.valueChange.emit(newValue);
        this.cdRef.detectChanges();
    };
    DateDropdownComponent.prototype.changeCalendarValue = function (newValue) {
        var _this = this;
        requestAnimationFrame(function () {
            _super.prototype.changeCalendarValue.call(_this, newValue);
            _this.input.focus();
            _this.cdRef.detectChanges();
        });
    };
    DateDropdownComponent.prototype.changeTimePickerValue = function (newValue) {
        _super.prototype.changeTimePickerValue.call(this, newValue);
        this.cdRef.detectChanges();
    };
    DateDropdownComponent.prototype.changeDayPeriodValue = function (dayPeriod) {
        _super.prototype.changeDayPeriodValue.call(this, dayPeriod);
        this.cdRef.detectChanges();
    };
    DateDropdownComponent.prototype.onBlur = function () {
        if (!this.isOpen) {
            this.elementRef.nativeElement.dispatchEvent(createCustomEvent('blur', {
                bubbles: false,
            }));
            this.currentValue = this.inputValue;
            this.valueChange.emit(this.inputValue);
            this.input.writeValue(this.inputValue);
        }
        if (this.inlineEdit) {
            this.keepFocus = this.isOpen;
        }
        this.cdRef.detectChanges();
    };
    DateDropdownComponent.prototype.onMouseDown = function () {
        if (!this.disabled) {
            this.keepFocus = true;
        }
    };
    DateDropdownComponent.prototype.applyValue = function () {
        this.currentValue = this.inputValue;
        this.onOpenChange(false);
        this.valueChange.emit(this.inputValue);
        this.dayPeriodChange.emit(this.dayPeriodValue);
    };
    DateDropdownComponent.prototype.clearValue = function () {
        _super.prototype.clearValue.call(this);
        this.applyValue();
    };
    DateDropdownComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: TimezonesService },
        { type: ChangeDetectorRef },
        { type: DateTimeService },
        { type: DynamicTranslations },
        { type: undefined, decorators: [{ type: Inject, args: [CDS_DATE_TIME_NOW,] }] }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateDropdownComponent.prototype, "appearance", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateDropdownComponent.prototype, "timeValue", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateDropdownComponent.prototype, "inlineEdit", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], DateDropdownComponent.prototype, "numberOfMonths", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], DateDropdownComponent.prototype, "inputValue", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], DateDropdownComponent.prototype, "valueChange", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], DateDropdownComponent.prototype, "dayPeriodChange", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateDropdownComponent.prototype, "timezoneValue", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateDropdownComponent.prototype, "rangeFrom", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateDropdownComponent.prototype, "rangeTo", void 0);
    __decorate([
        ViewChild('dropdown'),
        __metadata("design:type", DropdownComponent)
    ], DateDropdownComponent.prototype, "dropdown", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateDropdownComponent.prototype, "disabled", void 0);
    DateDropdownComponent = __decorate([ __param(6, Inject(CDS_DATE_TIME_NOW)),
        __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            TimezonesService,
            ChangeDetectorRef,
            DateTimeService,
            DynamicTranslations, Function])
    ], DateDropdownComponent);
DateDropdownComponent.ɵfac = function DateDropdownComponent_Factory(t) { return new (t || DateDropdownComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(TimezonesService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DateTimeService), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations), ɵngcc0.ɵɵdirectiveInject(CDS_DATE_TIME_NOW)); };
DateDropdownComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DateDropdownComponent, selectors: [["cds-date-dropdown"]], viewQuery: function DateDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c14, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
    } }, inputs: { inputValue: "inputValue", appearance: "appearance", timeValue: "timeValue", inlineEdit: "inlineEdit", numberOfMonths: "numberOfMonths", timezoneValue: "timezoneValue", rangeFrom: "rangeFrom", rangeTo: "rangeTo", disabled: "disabled" }, outputs: { valueChange: "valueChange", dayPeriodChange: "dayPeriodChange" }, features: [ɵngcc0.ɵɵProvidersFeature([DynamicTranslations]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 6, vars: 16, consts: [[1, "cds-date-time-form__date-input"], ["cdsDateInput", "", 1, "cds-control--child", 3, "appearance", "format", "constraints", "timeValue", "timezoneValue", "cdsDateKeyboardNavigation", "keyboardConstraints", "selected", "ngModel", "label", "placeholder", "readonly", "disabled", "cdsDateKeyboardNavigationChange", "ngModelChange", "mousedown", "blur", "click", "keydown.enter"], ["input", "", "inputModel", "ngModel"], [1, "cds-icon-calendar", 3, "click"], ["class", "cds-date-time-form__dropdown cds-dropdown--auto-height", 3, "anchor", "dismiss", 4, "ngIf"], [1, "cds-date-time-form__dropdown", "cds-dropdown--auto-height", 3, "anchor", "dismiss"], ["dropdown", ""], [1, "cds-date-time-form__content", "cds-date-time-form__dropdown-content"], [3, "constraints", "padDaysInMonth", "numberOfMonths", "startRange", "endRange", "ngModel", "yearSelectRange", "ngModelChange"], ["class", "cds-date-time-form__time-picker", 4, "ngIf"], ["class", "cds-date-time-form__day-period-combo", 4, "ngIf"], [1, "cds-date-time-form__footer"], ["cdsButton", "", "type", "button", 1, "cds-button-text", 3, "click"], ["cdsButton", "", "type", "button", 1, "cds-button-primary", 3, "disabled", "click"], [1, "cds-date-time-form__time-picker"], [1, "cds-date-time-form__time-label"], [3, "constraints", "format", "useDayPeriod", "disabled", "ngModel", "ngModelChange"], [1, "cds-date-time-form__day-period-combo"], ["appearance", "inline", "name", "useDayPeriod", 3, "ngModel", "ngModelChange"], ["dayPeriodCombo", ""], ["default", ""], ["tabindex", "-1", 3, "cdsComboItem", "labelValue"]], template: function DateDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        var _r16 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "cds-input", 1, 2);
        ɵngcc0.ɵɵlistener("cdsDateKeyboardNavigationChange", function DateDropdownComponent_Template_cds_input_cdsDateKeyboardNavigationChange_1_listener($event) { return ctx.changeCalendarValue($event); })("ngModelChange", function DateDropdownComponent_Template_cds_input_ngModelChange_1_listener($event) { return ctx.changeInputValue($event); })("mousedown", function DateDropdownComponent_Template_cds_input_mousedown_1_listener() { return ctx.onMouseDown(); })("blur", function DateDropdownComponent_Template_cds_input_blur_1_listener() { return ctx.onBlur(); })("click", function DateDropdownComponent_Template_cds_input_click_1_listener() { return !ctx.inlineEdit && ctx.onOpenChange(true); })("keydown.enter", function DateDropdownComponent_Template_cds_input_keydown_enter_1_listener() { ɵngcc0.ɵɵrestoreView(_r16); var _r1 = ɵngcc0.ɵɵreference(3); return ctx.isOpen ? _r1.valid && ctx.applyValue() : ctx.onOpenChange(true); });
        ɵngcc0.ɵɵelementStart(4, "a", 3);
        ɵngcc0.ɵɵlistener("click", function DateDropdownComponent_Template_a_click_4_listener() { return ctx.inlineEdit && ctx.onOpenChange(true); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DateDropdownComponent_cds_dropdown_5_Template, 11, 13, "cds-dropdown", 4);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("cds-control--required", ctx.dateRequired);
        ɵngcc0.ɵɵproperty("appearance", ctx.appearance)("format", ctx.format)("constraints", ctx.isOpen ? ctx.constraints : null)("timeValue", ctx.timeValue)("timezoneValue", ctx.timezoneValue)("cdsDateKeyboardNavigation", ctx.isOpen && (ctx.calendarValue || ctx.defaultDate))("keyboardConstraints", ctx.constraints)("selected", ctx.keepFocus)("ngModel", ctx.inputValue)("label", ctx.label)("placeholder", ctx.placeholder)("readonly", !ctx.inlineEdit)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isOpen);
    } }, directives: [InputComponent, DateInputDirective, DateKeyboardNavigationDirective, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc1.NgIf, DropdownComponent, CalendarRangeComponent, ButtonRippleDirective, TimePickerComponent, ComboComponent, ComboItemDirective], pipes: [AdjustTimeConstraintsPipe], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DateDropdownComponent, [{
        type: Component,
        args: [{
                selector: 'cds-date-dropdown',
                template: "<div class=\"cds-date-time-form__date-input\">\n    <cds-input #input #inputModel=\"ngModel\"\n               [appearance]=\"appearance\"\n               class=\"cds-control--child\"\n               [class.cds-control--required]=\"dateRequired\"\n               cdsDateInput\n               [format]=\"format\"\n               [constraints]=\"isOpen ? constraints : null\"\n               [timeValue]=\"timeValue\"\n               [timezoneValue]=\"timezoneValue\"\n               [cdsDateKeyboardNavigation]=\"isOpen && (calendarValue || defaultDate)\"\n               (cdsDateKeyboardNavigationChange)=\"changeCalendarValue($event)\"\n               [keyboardConstraints]=\"constraints\"\n               [selected]=\"keepFocus\"\n               [ngModel]=\"inputValue\"\n               (ngModelChange)=\"changeInputValue($event)\"\n               [label]=\"label\"\n               [placeholder]=\"placeholder\"\n               [readonly]=\"!inlineEdit\"\n               [disabled]=\"disabled\"\n               (mousedown)=\"onMouseDown()\"\n               (blur)=\"onBlur()\"\n               (click)=\"!inlineEdit && onOpenChange(true)\"\n               (keydown.enter)=\"isOpen ? (inputModel.valid && applyValue()) : onOpenChange(true)\">\n        <a class=\"cds-icon-calendar\" (click)=\"inlineEdit && onOpenChange(true)\"></a>\n    </cds-input>\n</div>\n<cds-dropdown #dropdown *ngIf=\"isOpen\" (dismiss)=\"onOpenChange(false)\" [anchor]=\"input.elementRef\" class=\"cds-date-time-form__dropdown cds-dropdown--auto-height\">\n    <div class=\"cds-date-time-form__content cds-date-time-form__dropdown-content\">\n        <cds-calendar-range [constraints]=\"constraints\"\n                        [padDaysInMonth]=\"padDaysInMonth\"\n                        [numberOfMonths]=\"numberOfMonths\"\n                        [startRange]=\"(rangeFrom || rangeTo) ? (rangeFrom || calendarValue) : null\"\n                        [endRange]=\"(rangeFrom || rangeTo) ? (rangeTo || calendarValue) : null\"\n                        [ngModel]=\"calendarValue\"\n                        [yearSelectRange]=\"yearSelectRange\"\n                        (ngModelChange)=\"changeCalendarValue($event)\"></cds-calendar-range>\n        <div class=\"cds-date-time-form__time-picker\" *ngIf=\"includesTime\">\n            <div class=\"cds-date-time-form__time-label\">{{translations.timeLabel}}</div>\n            <cds-time-picker [constraints]=\"constraints | cdsAdjustTimeConstraints:inputValue\"\n                                [format]=\"resolvedFormat\"\n                                [useDayPeriod]=\"useDayPeriod\"\n                                [disabled]=\"!calendarValue\"\n                                [ngModel]=\"timePickerValue\"\n                                (ngModelChange)=\"changeTimePickerValue($event)\"></cds-time-picker>\n        </div>\n        <div class=\"cds-date-time-form__day-period-combo\" *ngIf=\"includesTime && useDayPeriod\">\n            <cds-combo #dayPeriodCombo\n                        appearance=\"inline\"\n                        name=\"useDayPeriod\"\n                        [ngModel]=\"dayPeriodValue\"\n                        (ngModelChange)=\"changeDayPeriodValue($event)\">\n                <label>{{dayPeriodCombo.selectedLabel}}</label>\n                <label default>{{translations.dayPeriodLabel}}</label>\n                <ul>\n                    <li [cdsComboItem]=\"'AM'\" [labelValue]=\"dayPeriodsTranslation[0]\" tabindex=\"-1\">{{dayPeriodsTranslation[0]}}</li>\n                    <li [cdsComboItem]=\"'PM'\" [labelValue]=\"dayPeriodsTranslation[1]\" tabindex=\"-1\">{{dayPeriodsTranslation[1]}}</li>\n                </ul>\n            </cds-combo>\n        </div>\n    </div>\n    <div class=\"cds-date-time-form__footer\">\n        <button cdsButton type=\"button\" class=\"cds-button-text\" (click)=\"clearValue()\">{{translations.clearButton}}</button>\n        <button cdsButton type=\"button\" class=\"cds-button-primary\" [disabled]=\"!inputModel.valid\" (click)=\"applyValue()\">{{translations.applyButton}}</button>\n    </div>\n</cds-dropdown>\n",
                providers: [DynamicTranslations],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: TimezonesService }, { type: ɵngcc0.ChangeDetectorRef }, { type: DateTimeService }, { type: DynamicTranslations }, { type: undefined, decorators: [{
                type: Inject,
                args: [CDS_DATE_TIME_NOW]
            }] }]; }, { inputValue: [{
            type: Input
        }], appearance: [{
            type: Input
        }], timeValue: [{
            type: Input
        }], inlineEdit: [{
            type: Input
        }], numberOfMonths: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], dayPeriodChange: [{
            type: Output
        }], timezoneValue: [{
            type: Input
        }], rangeFrom: [{
            type: Input
        }], rangeTo: [{
            type: Input
        }], dropdown: [{
            type: ViewChild,
            args: ['dropdown']
        }], disabled: [{
            type: Input
        }] }); })();
    return DateDropdownComponent;
}(DateAbstractControlComponent));

var DATE_FORM_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return DateFormComponent; }),
    multi: true,
};
var DATE_FORM_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(function () { return DateFormComponent; }),
    multi: true,
};
var DateFormComponent = /** @class */ (function (_super) {
    __extends(DateFormComponent, _super);
    function DateFormComponent(elementRef, renderer, timezonesService, cdRef, dateTimeService, dateTimeValidatorService, dialogService, timezoneDirective, componentTranslations) {
        var _this = _super.call(this, timezonesService) || this;
        _this.cdRef = cdRef;
        _this.dateTimeService = dateTimeService;
        _this.dateTimeValidatorService = dateTimeValidatorService;
        _this.dialogService = dialogService;
        _this.timezoneDirective = timezoneDirective;
        _this.keepFocus = false;
        _this.focusOn = false;
        _this.appearance = 'outline';
        _this.format = 'date';
        _this.inlineEdit = false;
        _this.dateRequired = false;
        _this.showInputs = true;
        _this.padDaysInMonth = false;
        _this.mode = 'dialog';
        _this.disabled = false;
        _this.onTouchedCallback = noop;
        _this.onChangeCallback = noop;
        _this.onValidatorChange = noop;
        _this.descriptionId = Unique.next('cds-date-time-form-');
        componentTranslations.use(CDS_DATE_TIME_TRANSLATIONS, dateTimeTranslationsFactory, function (translations) {
            _this.translations = translations;
            if (_this.afterChanges) {
                cdRef.detectChanges();
            }
        });
        renderer.addClass(elementRef.nativeElement, 'cds-date-time-form');
        renderer.addClass(elementRef.nativeElement, 'cds-control--parent');
        renderer.addClass(elementRef.nativeElement, 'cds-control');
        return _this;
    }
    DateFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.afterChanges) {
            this.ngOnChanges({});
        }
        this.resolvedFormat = this.dateTimeService.resolveFormat(this.format);
        this.includesTime = this.dateTimeService.includesTime(this.format);
        this.useDayPeriod = this.dateTimeService.is12hMode(this.format);
        this.dayPeriodsTranslation = this.dateTimeService.getDayPeriods();
        if (this.timezoneDirective) {
            this.timezones = this.timezoneDirective.getTimezones();
            this.timezoneObservable = this.timezoneDirective.$changes.subscribe(function (value) {
                if (_this.mode === 'dropdown') {
                    _this.setTimezone(value);
                    _this.onChangeCallback(_this.value);
                }
            });
        }
    };
    DateFormComponent.prototype.ngOnDestroy = function () {
        if (this.timezoneObservable) {
            this.timezoneObservable.unsubscribe();
        }
    };
    DateFormComponent.prototype.ngOnChanges = function (changes) {
        this.afterChanges = true;
        if ('format' in changes) {
            this.resolvedFormat = this.dateTimeService.resolveFormat(this.format);
            this.includesTime = this.dateTimeService.includesTime(this.format);
            this.useDayPeriod = this.dateTimeService.is12hMode(this.format);
        }
        _super.prototype.ngOnChanges.call(this, changes);
        if ('from' in changes || 'to' in changes || 'disableWeekends' in changes || 'allowedDays' in changes || 'dateRequired' in changes || 'timeValue' in changes) {
            this.onValidatorChange();
        }
    };
    DateFormComponent.prototype.openDialog = function () {
        var _this = this;
        if (!this.disabled) {
            this.keepFocus = true;
            this.focusOn = true;
            return this.dialogService.open(this.dialog).then(function (value) {
                _this.closeDialog(value);
                return value;
            }, function () { return null; });
        }
        return Promise.resolve(null);
    };
    DateFormComponent.prototype.closeDialog = function (value) {
        this.keepFocus = false;
        this.focusOn = false;
        if (this.input) {
            this.input.focus();
        }
        this.onTouchedCallback();
        if (value) {
            this.setTimezone(value.timezone);
            if (value.dayPeriod !== this.dayPeriod) {
                this.dayPeriod = value.dayPeriod;
            }
            if (value.date !== this.value) {
                this.value = value.date;
                this.onChangeCallback(value.date);
            }
        }
    };
    DateFormComponent.prototype.updateValue = function (value) {
        if (value !== this.value) {
            this.value = value;
            this.onChangeCallback(value);
        }
    };
    DateFormComponent.prototype.updateDayPeriod = function (dayPeriod) {
        if (dayPeriod !== this.dayPeriod) {
            this.dayPeriod = dayPeriod;
        }
    };
    DateFormComponent.prototype.writeValue = function (modelValue) {
        this.value = modelValue;
        this.cdRef.markForCheck();
    };
    DateFormComponent.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    DateFormComponent.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    DateFormComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
        this.cdRef.markForCheck();
    };
    DateFormComponent.prototype.validate = function (control) {
        var _a;
        this.cdRef.markForCheck();
        if (!control.value) {
            this.errors = this.dateRequired ? { required: true } : null;
            return this.errors;
        }
        if (this.mode === 'dropdown' && !this.includesTime) {
            var mode = this.timeValue != null || ((_a = this.timezoneDirective) === null || _a === void 0 ? void 0 : _a.selected) != null ? 'datetime' : 'date';
            var value = mode === 'datetime'
                ? (this.constraints.offset >= 0
                    ? control.value + "T00:00:00"
                    : control.value + "T23:59:59")
                : control.value;
            this.errors = this.dateTimeValidatorService.validate(this.constraints, value, this.format, mode);
        }
        else {
            this.errors = this.dateTimeValidatorService.validate(this.constraints, control.value, this.format);
        }
        return this.errors;
    };
    DateFormComponent.prototype.registerOnValidatorChange = function (fn) {
        this.onValidatorChange = fn;
    };
    DateFormComponent.prototype.onBlur = function () {
        var isDropdown = this.mode === 'dropdown';
        if (!isDropdown && this.input) {
            this.input.writeValue(this.value);
        }
        this.onTouchedCallback();
        if (this.inlineEdit) {
            this.keepFocus = this.focusOn;
        }
    };
    DateFormComponent.prototype.onMouseDown = function () {
        if (!this.disabled) {
            this.keepFocus = true;
        }
    };
    DateFormComponent.prototype.setTimezone = function (timezoneCode) {
        if (timezoneCode) {
            this.constraints = this.constraints.updateTimezone(this.timezonesService.getTimezone(timezoneCode));
        }
        if (this.timezoneDirective) {
            this.timezoneDirective.changeTimezone(timezoneCode);
        }
    };
    DateFormComponent.prototype.setDayPeriod = function (dayPeriod) {
        if (this.useDayPeriod && dayPeriod) {
            this.dayPeriod = dayPeriod;
            if (this.value) {
                var dateAndNewHour = Time.fromString(this.value);
                dateAndNewHour.toggleDayPeriod();
                this.value = dateAndNewHour.toString('datetime');
                this.onChangeCallback(this.value);
            }
        }
    };
    DateFormComponent.prototype.updatedConstraints = function () {
        var mode = this.includesTime ? 'datetime' : 'date';
        return __assign({ mode: mode }, _super.prototype.updatedConstraints.call(this));
    };
    DateFormComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: TimezonesService },
        { type: ChangeDetectorRef },
        { type: DateTimeService },
        { type: DateTimeValidatorService },
        { type: DialogService },
        { type: TimezoneDirective, decorators: [{ type: Optional }] },
        { type: DynamicTranslations }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateFormComponent.prototype, "appearance", void 0);
    __decorate([
        Input(),
        HostBinding('class.cds-date-time-form--hidden'),
        __metadata("design:type", Boolean)
    ], DateFormComponent.prototype, "hidden", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateFormComponent.prototype, "format", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateFormComponent.prototype, "timeValue", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateFormComponent.prototype, "placeholder", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateFormComponent.prototype, "label", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateFormComponent.prototype, "inlineEdit", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateFormComponent.prototype, "dateRequired", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateFormComponent.prototype, "showInputs", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], DateFormComponent.prototype, "padDaysInMonth", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], DateFormComponent.prototype, "mode", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], DateFormComponent.prototype, "numberOfMonths", void 0);
    __decorate([
        ViewChild('input'),
        __metadata("design:type", InputComponent)
    ], DateFormComponent.prototype, "input", void 0);
    __decorate([
        ViewChild('dialog', { static: true }),
        __metadata("design:type", TemplateRef)
    ], DateFormComponent.prototype, "dialog", void 0);
    DateFormComponent = __decorate([ __param(7, Optional()),
        __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            TimezonesService,
            ChangeDetectorRef,
            DateTimeService,
            DateTimeValidatorService,
            DialogService,
            TimezoneDirective,
            DynamicTranslations])
    ], DateFormComponent);
DateFormComponent.ɵfac = function DateFormComponent_Factory(t) { return new (t || DateFormComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(TimezonesService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DateTimeService), ɵngcc0.ɵɵdirectiveInject(DateTimeValidatorService), ɵngcc0.ɵɵdirectiveInject(DialogService), ɵngcc0.ɵɵdirectiveInject(TimezoneDirective, 8), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations)); };
DateFormComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DateFormComponent, selectors: [["cds-date-form"]], viewQuery: function DateFormComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c5, true);
        ɵngcc0.ɵɵstaticViewQuery(_c33, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dialog = _t.first);
    } }, hostVars: 2, hostBindings: function DateFormComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("cds-date-time-form--hidden", ctx.hidden);
    } }, inputs: { appearance: "appearance", hidden: "hidden", format: "format", timeValue: "timeValue", placeholder: "placeholder", label: "label", inlineEdit: "inlineEdit", dateRequired: "dateRequired", showInputs: "showInputs", padDaysInMonth: "padDaysInMonth", mode: "mode", numberOfMonths: "numberOfMonths" }, features: [ɵngcc0.ɵɵProvidersFeature([DATE_FORM_CONTROL_VALUE_ACCESSOR, DATE_FORM_VALIDATOR, DynamicTranslations]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 2, consts: [["class", "cds-date-time-form__container", 4, "ngIf"], [3, "appearance", "format", "placeholder", "label", "rangeFrom", "rangeTo", "inputValue", "timezoneValue", "constraints", "dayPeriod", "padDaysInMonth", "dateRequired", "inlineEdit", "numberOfMonths", "timeValue", "yearSelectRange", "disabled", "valueChange", "blur", "dayPeriodChange", 4, "ngIf"], ["dialog", ""], [1, "cds-date-time-form__container"], [1, "cds-date-time-form__date-input"], [1, "cds-sr-only"], ["cdsDateInput", "", 1, "cds-control--child", 3, "appearance", "constraints", "format", "dayPeriod", "selected", "ngModel", "label", "placeholder", "readonly", "disabled", "cdsInvalid", "ariaDescribedBy", "ngModelChange", "mousedown", "blur", "click", "keydown.enter"], ["input", ""], [1, "cds-icon-calendar", 3, "click"], ["class", "cds-date-time-form__day-period-combo", 4, "ngIf"], ["class", "cds-date-time-form__timezone-combo", 4, "ngIf"], [1, "cds-date-time-form__day-period-combo"], ["appearance", "inline", "class", "cds-control--child", "name", "useDayPeriod", "required", "", 3, "ngModel", "disabled", "ngModelChange", 4, "ngIf"], ["appearance", "inline", "name", "useDayPeriod", "required", "", 1, "cds-control--child", 3, "ngModel", "disabled", "ngModelChange"], ["dayPeriodCombo", ""], ["default", ""], ["tabindex", "-1", 3, "cdsComboItem", "labelValue"], [1, "cds-date-time-form__timezone-combo"], ["class", "cds-control--child", "appearance", "inline", "name", "timezone", "required", "", 3, "ngModel", "disabled", "ngModelChange", 4, "ngIf"], ["appearance", "inline", "name", "timezone", "required", "", 1, "cds-control--child", 3, "ngModel", "disabled", "ngModelChange"], ["timezoneCombo", ""], ["tabindex", "-1", 3, "cdsComboItem", "labelValue", 4, "ngFor", "ngForOf"], [3, "appearance", "format", "placeholder", "label", "rangeFrom", "rangeTo", "inputValue", "timezoneValue", "constraints", "dayPeriod", "padDaysInMonth", "dateRequired", "inlineEdit", "numberOfMonths", "timeValue", "yearSelectRange", "disabled", "valueChange", "blur", "dayPeriodChange"], [3, "format", "placeholder", "label", "showInputs", "dayPeriod", "value", "timezone", "constraints", "padDaysInMonth", "dateRequired", "yearSelectRange", "dialogClose"]], template: function DateFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DateFormComponent_div_0_Template, 9, 20, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DateFormComponent_cds_date_dropdown_1_Template, 1, 17, "cds-date-dropdown", 1);
        ɵngcc0.ɵɵtemplate(2, DateFormComponent_ng_template_2_Template, 1, 11, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hidden && ctx.mode === "dialog");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.mode === "dropdown");
    } }, directives: [ɵngcc1.NgIf, InputComponent, DateInputDirective, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, InvalidDirective, ComboComponent, ɵngcc3.RequiredValidator, ComboItemDirective, ɵngcc1.NgForOf, DateDropdownComponent, DateDialogComponent], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DateFormComponent, [{
        type: Component,
        args: [{
                selector: 'cds-date-form',
                template: "<div class=\"cds-date-time-form__container\" *ngIf=\"!hidden && mode === 'dialog'\">\n\t<div class=\"cds-date-time-form__date-input\" [class.cds-date-time-form__date-input--time]=\"includesTime\">\n\t\t<div [attr.id]=\"descriptionId\" class=\"cds-sr-only\">{{translations.dateInputLabel}}</div>\n\t\t<cds-input #input\n\t\t           [appearance]=\"appearance\"\n\t\t           cdsDateInput\n\t\t           [constraints]=\"null\"\n\t\t           class=\"cds-control--child\"\n\t\t           [class.cds-control--required]=\"dateRequired\"\n\t\t           [format]=\"format\"\n\t\t           [dayPeriod]=\"dayPeriod\"\n\t\t           [selected]=\"keepFocus\"\n\t\t           [ngModel]=\"value\"\n\t\t           (ngModelChange)=\"updateValue($event)\"\n\t\t           [label]=\"label\"\n\t\t           [placeholder]=\"placeholder\"\n\t\t           [readonly]=\"!inlineEdit\"\n\t\t           [disabled]=\"disabled\"\n\t\t           [cdsInvalid]=\"errors != null\"\n\t\t           (mousedown)=\"onMouseDown()\"\n\t\t           (blur)=\"onBlur()\"\n\t\t           (click)=\"!inlineEdit && openDialog()\"\n\t\t           (keydown.enter)=\"openDialog()\"\n\t\t           [ariaDescribedBy]=\"descriptionId\">\n\t\t\t<a class=\"cds-icon-calendar\" (click)=\"inlineEdit && openDialog()\"></a>\n\t\t</cds-input>\n\t</div>\n\t<div class=\"cds-date-time-form__day-period-combo\" *ngIf=\"useDayPeriod\">\n\t\t<cds-combo #dayPeriodCombo\n\t\t           *ngIf=\"useDayPeriod\"\n\t\t           appearance=\"inline\"\n\t\t           class=\"cds-control--child\"\n\t\t           name=\"useDayPeriod\"\n\t\t           [ngModel]=\"dayPeriod\"\n\t\t           (ngModelChange)=\"setDayPeriod($event)\"\n\t\t           [disabled]=\"disabled\"\n\t\t           required>\n\t\t\t<label>{{dayPeriodCombo.selectedLabel}}</label>\n\t\t\t<label default>{{translations.dayPeriodLabel}}</label>\n\t\t\t<ul>\n\t\t\t\t<li [cdsComboItem]=\"'AM'\" [labelValue]=\"dayPeriodsTranslation[0]\" tabindex=\"-1\">{{dayPeriodsTranslation[0]}}</li>\n\t\t\t\t<li [cdsComboItem]=\"'PM'\" [labelValue]=\"dayPeriodsTranslation[1]\" tabindex=\"-1\">{{dayPeriodsTranslation[1]}}</li>\n\t\t\t</ul>\n\t\t</cds-combo>\n\t</div>\n\t<div class=\"cds-date-time-form__timezone-combo\" *ngIf=\"timezoneDirective\">\n\t\t<cds-combo #timezoneCombo\n\t\t           *ngIf=\"timezones\"\n\t\t           class=\"cds-control--child\"\n\t\t           appearance=\"inline\"\n\t\t           name=\"timezone\"\n\t\t           [ngModel]=\"timezoneDirective.selected\"\n\t\t           (ngModelChange)=\"setTimezone($event)\"\n\t\t           [disabled]=\"disabled\"\n\t\t           required>\n\t\t\t<label>{{timezoneCombo.selectedLabel}}</label>\n\t\t\t<label default>{{translations.timezoneLabel}}</label>\n\t\t\t<ul>\n\t\t\t\t<li *ngFor=\"let timezone of timezones\" [cdsComboItem]=\"timezone.code\" [labelValue]=\"timezone.name\" tabindex=\"-1\">{{timezone.name}}</li>\n\t\t\t</ul>\n\t\t</cds-combo>\n\t</div>\n</div>\n<cds-date-dropdown *ngIf=\"mode === 'dropdown'\" [appearance]=\"appearance\" [format]=\"format\" [placeholder]=\"placeholder\" [label]=\"label\" [rangeFrom]=\"rangeFrom\" [rangeTo]=\"rangeTo\"\n                   [inputValue]=\"value\" [timezoneValue]=\"timezoneDirective?.selected\" [constraints]=\"constraints\" [dayPeriod]=\"dayPeriod\" (valueChange)=\"updateValue($event)\" (blur)=\"onBlur()\" [padDaysInMonth]=\"padDaysInMonth\"\n                   (dayPeriodChange)=\"updateDayPeriod($event)\" [dateRequired]=\"dateRequired\" [inlineEdit]=\"inlineEdit\" [numberOfMonths]=\"numberOfMonths\" [timeValue]=\"timeValue\" [yearSelectRange]=\"yearSelectRange\" [disabled]=\"disabled\"></cds-date-dropdown>\n<ng-template #dialog let-dialog>\n\t<cds-date-dialog [format]=\"format\" [placeholder]=\"placeholder\" [label]=\"label\" [showInputs]=\"showInputs\" [dayPeriod]=\"dayPeriod\"\n\t                 [value]=\"value\" [timezone]=\"timezoneDirective\" [constraints]=\"constraints\" [padDaysInMonth]=\"padDaysInMonth\"\n\t                 [dateRequired]=\"dateRequired\" [yearSelectRange]=\"yearSelectRange\" (dialogClose)=\"dialog.resolve($event)\"></cds-date-dialog>\n</ng-template>\n",
                providers: [DATE_FORM_CONTROL_VALUE_ACCESSOR, DATE_FORM_VALIDATOR, DynamicTranslations]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: TimezonesService }, { type: ɵngcc0.ChangeDetectorRef }, { type: DateTimeService }, { type: DateTimeValidatorService }, { type: DialogService }, { type: TimezoneDirective, decorators: [{
                type: Optional
            }] }, { type: DynamicTranslations }]; }, { appearance: [{
            type: Input
        }], hidden: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.cds-date-time-form--hidden']
        }], format: [{
            type: Input
        }], timeValue: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], label: [{
            type: Input
        }], inlineEdit: [{
            type: Input
        }], dateRequired: [{
            type: Input
        }], showInputs: [{
            type: Input
        }], padDaysInMonth: [{
            type: Input
        }], mode: [{
            type: Input
        }], numberOfMonths: [{
            type: Input
        }], input: [{
            type: ViewChild,
            args: ['input']
        }], dialog: [{
            type: ViewChild,
            args: ['dialog', { static: true }]
        }] }); })();
    return DateFormComponent;
}(BaseDateTimeComponent));

var TimeControlDisplayHourPipe = /** @class */ (function () {
    function TimeControlDisplayHourPipe() {
    }
    TimeControlDisplayHourPipe.prototype.transform = function (selectedTime, useDayPeriod, format, dayPeriods) {
        if (selectedTime) {
            var _a = __read(selectedTime.split(':'), 2), hours = _a[0], restOfTime = _a[1];
            var newHours = useDayPeriod ? ((+hours % 12) || 12).toString() : hours;
            var dayPeriod = useDayPeriod ? (+hours >= 12 ? dayPeriods[1] : dayPeriods[0]) : '';
            if (format.indexOf('hh') !== -1 || format.indexOf('HH') !== -1) {
                return zeroPad(newHours, 2) + ":" + restOfTime + " " + dayPeriod;
            }
            else if (format.indexOf('H') !== -1) {
                return +newHours + ":" + restOfTime;
            }
            else {
                return newHours + ":" + restOfTime + " " + dayPeriod;
            }
        }
    };
TimeControlDisplayHourPipe.ɵfac = function TimeControlDisplayHourPipe_Factory(t) { return new (t || TimeControlDisplayHourPipe)(); };
TimeControlDisplayHourPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "cdsTimeControlDisplayHour", type: TimeControlDisplayHourPipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TimeControlDisplayHourPipe, [{
        type: Pipe,
        args: [{
                name: 'cdsTimeControlDisplayHour'
            }]
    }], function () { return []; }, null); })();
    return TimeControlDisplayHourPipe;
}());

var TimeControlListPipe = /** @class */ (function () {
    function TimeControlListPipe() {
    }
    TimeControlListPipe.prototype.transform = function (inputValue, constraints) {
        return prepareTimeList(inputValue, {
            hours: prepareItems(24, constraints.hourStep || 1),
            minutes: prepareItems(60, constraints.minuteStep || 1),
            seconds: prepareItems(60, constraints.secondStep || 1),
        }, constraints);
    };
TimeControlListPipe.ɵfac = function TimeControlListPipe_Factory(t) { return new (t || TimeControlListPipe)(); };
TimeControlListPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "cdsTimeControlList", type: TimeControlListPipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TimeControlListPipe, [{
        type: Pipe,
        args: [{
                name: 'cdsTimeControlList'
            }]
    }], function () { return []; }, null); })();
    return TimeControlListPipe;
}());
function prepareItems(count, step) {
    var list = [];
    for (var i = 0; i < count; i += step) {
        list.push(i);
    }
    return list;
}
function prepareTimeList(inputValue, timeList, constraints) {
    if (timeList) {
        var parts = [];
        if (timeList.hours) {
            for (var a = 0; a < timeList.hours.length; a++) {
                if (isEnabled(timeList.hours[a], 'hours', constraints)) {
                    for (var i = 0; i < timeList.minutes.length; i++) {
                        if (isEnabled(timeList.minutes[i], 'minutes', constraints, timeList.hours[a])) {
                            var time = zeroPad(timeList.hours[a], 2) + ":" + zeroPad(timeList.minutes[i], 2) + ":00";
                            if (inputValue && inputValue < time && inputValue > (parts[parts.length - 1] || '')) {
                                parts.push(inputValue);
                                inputValue = null;
                            }
                            parts.push(time);
                        }
                    }
                }
            }
        }
        return parts;
    }
}
function isEnabled(item, part, constraints, selectedHour) {
    if (constraints.timeFrom == null && constraints.timeTo == null) {
        return true;
    }
    if (part === 'hours') {
        return inRange(item, constraints.timeFromHour, constraints.timeToHour);
    }
    else if (part === 'minutes') {
        var value = selectedHour * 3600 + item * 60;
        var from = constraints.timeFromNumber - constraints.timeFromSecond;
        var to = constraints.timeToNumber - constraints.timeToSecond + 59;
        return inRange(value, from, to);
    }
}
function inRange(value, from, to) {
    if (from <= to) {
        return value >= from && value <= to;
    }
    else {
        return value >= from || value <= to;
    }
}

var TimeService = /** @class */ (function () {
    // tslint:disable-next-line:directive-class-suffix
    function TimeService() {
    }
    TimeService.prototype.initialize = function (changes, constraints) {
        if (!this.hoursList || constraints.hourStep != null || 'hourStep' in changes) {
            this.hoursList = this.prepareItems(24, constraints.hourStep);
        }
        if (!this.minutesList || constraints.minuteStep != null || 'minuteStep' in changes) {
            this.minutesList = this.prepareItems(60, constraints.minuteStep);
        }
        if (!this.secondsList || constraints.secondStep != null || 'secondStep' in changes) {
            this.secondsList = this.prepareItems(60, constraints.secondStep);
        }
        return { hours: this.hoursList, minutes: this.minutesList, seconds: this.secondsList };
    };
    TimeService.prototype.prepareItems = function (count, step) {
        var list = [];
        for (var i = 0; i < count; i += step) {
            list.push(i);
        }
        return list;
    };
    TimeService.ɵprov = ɵɵdefineInjectable({ factory: function TimeService_Factory() { return new TimeService(); }, token: TimeService, providedIn: "root" });
    __decorate([
        Input(),
        __metadata("design:type", DateTimeConstraints)
    ], TimeService.prototype, "constraints", void 0);
TimeService.ɵfac = function TimeService_Factory(t) { return new (t || TimeService)(); };
TimeService.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TimeService, inputs: { constraints: "constraints" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TimeService, [{
        type: Directive
    }, {
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, { constraints: [{
            type: Input
        }] }); })();
    return TimeService;
}());

var TIME_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return TimeControlComponent; }),
    multi: true,
};
var TIME_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(function () { return TimeControlComponent; }),
    multi: true,
};
var TimeControlComponent = /** @class */ (function (_super) {
    __extends(TimeControlComponent, _super);
    function TimeControlComponent(elementRef, renderer, timezonesService, cdRef, dateTimeService, timeService, dateTimeValidatorService, componentTranslations) {
        var _this = _super.call(this, timezonesService) || this;
        _this.elementRef = elementRef;
        _this.renderer = renderer;
        _this.cdRef = cdRef;
        _this.dateTimeService = dateTimeService;
        _this.timeService = timeService;
        _this.dateTimeValidatorService = dateTimeValidatorService;
        _this.timePickerValue = null;
        _this.dayPeriodValue = 'AM';
        _this.keepFocus = false;
        _this.appearance = 'outline';
        _this.format = 'time';
        _this.inlineEdit = false;
        _this.dateRequired = false;
        _this.timePicker = false;
        _this.disabled = false;
        _this.onTouchedCallback = noop;
        _this.onChangeCallback = noop;
        _this.onValidatorChange = noop;
        renderer.addClass(elementRef.nativeElement, 'cds-time-control');
        renderer.addClass(elementRef.nativeElement, 'cds-control--parent');
        renderer.addClass(elementRef.nativeElement, 'cds-control');
        componentTranslations.use(CDS_DATE_TIME_TRANSLATIONS, dateTimeTranslationsFactory, function (translations) {
            _this.translations = translations;
            if (_this.afterChanges) {
                cdRef.detectChanges();
            }
        });
        return _this;
    }
    TimeControlComponent.prototype.ngOnInit = function () {
        if (!this.afterChanges) {
            this.ngOnChanges({});
        }
        this.resolvedFormat = this.dateTimeService.resolveFormat(this.format);
        this.includesSeconds = this.dateTimeService.includesSeconds(this.format);
        this.useDayPeriod = this.dateTimeService.is12hMode(this.format);
        this.dayPeriodsTranslation = this.dateTimeService.getDayPeriods();
    };
    TimeControlComponent.prototype.ngOnChanges = function (changes) {
        this.afterChanges = true;
        _super.prototype.ngOnChanges.call(this, changes);
        if ('format' in changes) {
            this.resolvedFormat = this.dateTimeService.resolveFormat(this.format);
            this.includesSeconds = this.dateTimeService.includesSeconds(this.format);
            this.useDayPeriod = this.dateTimeService.is12hMode(this.format);
        }
        if ('timezoneValue' in changes) {
            this.setTimezone(this.timezoneValue);
        }
        if (this.inChanges(changes, ['format', 'from', 'to', 'rangeFrom', 'rangeTo', 'timeFrom', 'timeTo', 'hourStep', 'minuteStep', 'secondStep', 'dateValue'])) {
            this.onValidatorChange();
        }
    };
    TimeControlComponent.prototype.inChanges = function (changes, keys) {
        return keys.some(function (key) { return key in changes; });
    };
    TimeControlComponent.prototype.onOpenChange = function (isOpen) {
        if (isOpen && !this.isOpen) {
            this.currentValue = this.inputValue;
        }
        else if (!isOpen && this.isOpen) {
            this.restoreCurrentValue(this.currentValue);
            /** writeValue to format input view value */
            this.input.writeValue(this.inputValue);
        }
        if (!this.disabled) {
            this.isOpen = isOpen;
            this.keepFocus = isOpen;
            this.cdRef.detectChanges();
            if (isOpen) {
                if (this.dropdown) {
                    this.dropdown.scheduleUpdate();
                }
            }
        }
    };
    TimeControlComponent.prototype.writeValue = function (modelValue) {
        this.restoreCurrentValue(modelValue);
        this.cdRef.markForCheck();
    };
    TimeControlComponent.prototype.restoreCurrentValue = function (value) {
        try {
            var date = Time.fromString(value).toDate();
            this.inputValue = value;
            this.timePickerValue = value;
            this.dayPeriodValue = date.getHours() >= 12 ? 'PM' : 'AM';
        }
        catch (e) {
            this.inputValue = null;
            this.timePickerValue = null;
            this.dayPeriodValue = 'AM';
        }
    };
    TimeControlComponent.prototype.changeInputValue = function (newValue) {
        try {
            var date = Time.fromString(newValue).toDate();
            this.timePickerValue = newValue;
            this.dayPeriodValue = date.getHours() >= 12 ? 'PM' : 'AM';
        }
        catch (e) {
            this.timePickerValue = null;
            this.dayPeriodValue = 'AM';
        }
        this.inputValue = newValue;
        if (!this.isOpen) {
            this.currentValue = this.inputValue;
            this.onChangeCallback(this.inputValue);
        }
        this.cdRef.detectChanges();
    };
    TimeControlComponent.prototype.changeTimePickerValue = function (newValue) {
        try {
            var date = Time.fromString(newValue).toDate();
            this.inputValue = newValue;
            this.dayPeriodValue = date.getHours() >= 12 ? 'PM' : 'AM';
        }
        catch (e) {
            this.inputValue = null;
            this.dayPeriodValue = 'AM';
        }
        this.timePickerValue = newValue;
        this.cdRef.detectChanges();
    };
    TimeControlComponent.prototype.changeDayPeriodValue = function (dayPeriod) {
        try {
            var date = Time.fromString(this.inputValue).toDate();
            if (date.getHours() >= 12) {
                if (dayPeriod === 'AM') {
                    date.setHours(date.getHours() - 12);
                }
            }
            else {
                if (dayPeriod === 'PM') {
                    date.setHours(date.getHours() + 12);
                }
            }
            this.inputValue = Time.fromDate(date).toString('time');
        }
        catch (e) { }
        this.dayPeriodValue = dayPeriod;
        this.cdRef.detectChanges();
    };
    TimeControlComponent.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    TimeControlComponent.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    TimeControlComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
        this.cdRef.markForCheck();
    };
    TimeControlComponent.prototype.validate = function (control) {
        this.cdRef.markForCheck();
        if (!control.value) {
            this.errors = this.dateRequired ? { required: true } : null;
        }
        else {
            var mode = this.dateValue != null ? 'datetime' : 'time';
            var value = mode === 'datetime' ? this.dateValue + "T" + control.value : control.value;
            this.errors = this.dateTimeValidatorService.validate(this.constraints, value, this.format, mode);
        }
        return this.errors;
    };
    TimeControlComponent.prototype.registerOnValidatorChange = function (fn) {
        this.onValidatorChange = fn;
    };
    TimeControlComponent.prototype.onBlur = function () {
        this.onTouchedCallback();
    };
    TimeControlComponent.prototype.onMouseDown = function () {
        if (!this.disabled) {
            this.keepFocus = true;
        }
    };
    TimeControlComponent.prototype.setTimezone = function (timezoneCode) {
        if (timezoneCode) {
            this.constraints = this.constraints.updateTimezone(this.timezonesService.getTimezone(timezoneCode));
        }
    };
    TimeControlComponent.prototype.updatedConstraints = function () {
        return __assign({ mode: 'time' }, _super.prototype.updatedConstraints.call(this));
    };
    TimeControlComponent.prototype.applyValue = function () {
        this.currentValue = this.inputValue;
        this.onChangeCallback(this.inputValue);
        this.onOpenChange(false);
    };
    TimeControlComponent.prototype.clearValue = function () {
        this.onOpenChange(false);
    };
    TimeControlComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: TimezonesService },
        { type: ChangeDetectorRef },
        { type: DateTimeService },
        { type: TimeService },
        { type: DateTimeValidatorService },
        { type: DynamicTranslations }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TimeControlComponent.prototype, "appearance", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TimeControlComponent.prototype, "format", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TimeControlComponent.prototype, "placeholder", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TimeControlComponent.prototype, "label", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], TimeControlComponent.prototype, "inlineEdit", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], TimeControlComponent.prototype, "dateRequired", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], TimeControlComponent.prototype, "timePicker", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TimeControlComponent.prototype, "dateValue", void 0);
    __decorate([
        ViewChild('dropdown'),
        __metadata("design:type", DropdownComponent)
    ], TimeControlComponent.prototype, "dropdown", void 0);
    __decorate([
        ViewChild('input'),
        __metadata("design:type", InputComponent)
    ], TimeControlComponent.prototype, "input", void 0);
    TimeControlComponent = __decorate([ __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            TimezonesService,
            ChangeDetectorRef,
            DateTimeService,
            TimeService,
            DateTimeValidatorService,
            DynamicTranslations])
    ], TimeControlComponent);
TimeControlComponent.ɵfac = function TimeControlComponent_Factory(t) { return new (t || TimeControlComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(TimezonesService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DateTimeService), ɵngcc0.ɵɵdirectiveInject(TimeService), ɵngcc0.ɵɵdirectiveInject(DateTimeValidatorService), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations)); };
TimeControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TimeControlComponent, selectors: [["cds-time-control"]], viewQuery: function TimeControlComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c14, true);
        ɵngcc0.ɵɵviewQuery(_c5, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, inputs: { appearance: "appearance", format: "format", placeholder: "placeholder", label: "label", inlineEdit: "inlineEdit", dateRequired: "dateRequired", timePicker: "timePicker", dateValue: "dateValue" }, features: [ɵngcc0.ɵɵProvidersFeature([TIME_CONTROL_VALUE_ACCESSOR, TIME_VALIDATOR, DynamicTranslations]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[4, "ngIf"], ["cdsDateInput", "", 1, "cds-time-control__control", "cds-control--child", 3, "appearance", "format", "constraints", "dateValue", "selected", "ngModel", "label", "placeholder", "readonly", "disabled", "cdsInvalid", "ngModelChange", "focus", "mousedown", "blur", "keydown.enter", "cdsOnEscape"], ["input", "", "inputModel", "ngModel"], ["class", "cds-time-control__dropdown cds-dropdown--auto-height", 3, "anchor", "dismiss", 4, "ngIf"], [1, "cds-time-control__dropdown", "cds-dropdown--auto-height", 3, "anchor", "dismiss"], ["dropdown", ""], [1, "cds-time-control__scrollable"], [1, "cds-time-control__content"], [3, "constraints", "format", "useDayPeriod", "ngModel", "ngModelChange"], ["class", "cds-date-time-control__day-period-combo-control", 4, "ngIf"], [1, "cds-time-control__footer"], ["cdsButton", "", "type", "button", 1, "cds-button-text", 3, "click"], ["cdsButton", "", "type", "button", 1, "cds-button-primary", 3, "disabled", "click"], [1, "cds-date-time-control__day-period-combo-control"], ["appearance", "inline", 3, "placeholder", "ngModel", "ngModelChange"], ["dayPeriodCombo", ""], ["tabindex", "-1", 3, "cdsComboItem", "labelValue"], [1, "cds-time-control__control", "cds-control--child", 3, "appearance", "label", "ngModel", "cdsInvalid", "disabled", "ngModelChange"], ["timeCombo", ""], ["tabindex", "-1", 3, "cdsComboItem", "labelValue", 4, "ngFor", "ngForOf"]], template: function TimeControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TimeControlComponent_ng_container_0_Template, 5, 14, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, TimeControlComponent_ng_container_1_Template, 9, 15, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.timePicker);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.timePicker);
    } }, directives: [ɵngcc1.NgIf, InputComponent, DateInputDirective, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, InvalidDirective, OnEscapeDirective, DropdownComponent, TimePickerComponent, ButtonRippleDirective, ComboComponent, ComboItemDirective, ɵngcc1.NgForOf], pipes: [TimeControlDisplayHourPipe, TimeControlListPipe], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TimeControlComponent, [{
        type: Component,
        args: [{
                selector: 'cds-time-control',
                template: "<ng-container *ngIf=\"timePicker\">\n\t<cds-input #input #inputModel=\"ngModel\"\n\t           [appearance]=\"appearance\"\n\t           class=\"cds-time-control__control cds-control--child\"\n\t           [class.cds-control--required]=\"dateRequired\"\n\t           cdsDateInput\n\t           [format]=\"format\"\n\t           [constraints]=\"isOpen ? constraints : null\"\n\t           [dateValue]=\"dateValue\"\n\t           [selected]=\"keepFocus\"\n\t           [ngModel]=\"inputValue\"\n\t           (ngModelChange)=\"changeInputValue($event)\"\n\t           [label]=\"label || translations.selectTimeHeader\"\n\t           [placeholder]=\"placeholder\"\n\t           [readonly]=\"!inlineEdit\"\n\t           [disabled]=\"disabled\"\n\t           [cdsInvalid]=\"isOpen ? false : errors != null\"\n\t           (focus)=\"onOpenChange(true)\"\n\t           (mousedown)=\"onMouseDown()\"\n\t           (blur)=\"onBlur()\"\n\t           (keydown.enter)=\"isOpen ? (inputModel.valid && applyValue()) : onOpenChange(true)\"\n\t           (cdsOnEscape)=\"clearValue()\">\n\t</cds-input>\n\t<cds-dropdown #dropdown *ngIf=\"isOpen\" (dismiss)=\"onOpenChange(false)\" [anchor]=\"input.elementRef\" class=\"cds-time-control__dropdown cds-dropdown--auto-height\">\n\t\t<div class=\"cds-time-control__scrollable\">\n\t\t\t<div class=\"cds-time-control__content\">\n\t\t\t\t<cds-time-picker [constraints]=\"constraints\"\n\t\t\t\t                 [format]=\"resolvedFormat\"\n\t\t\t\t                 [useDayPeriod]=\"useDayPeriod\"\n\t\t\t\t                 [ngModel]=\"timePickerValue\"\n\t\t\t\t                 (ngModelChange)=\"changeTimePickerValue($event)\"></cds-time-picker>\n\t\t\t\t<div class=\"cds-date-time-control__day-period-combo-control\" *ngIf=\"useDayPeriod\">\n\t\t\t\t\t<cds-combo #dayPeriodCombo\n\t\t\t\t\t           appearance=\"inline\"\n\t\t\t\t\t           [placeholder]=\"translations.dayPeriodLabel\"\n\t\t\t\t\t           [ngModel]=\"dayPeriodValue\"\n\t\t\t\t\t           (ngModelChange)=\"changeDayPeriodValue($event)\">\n\t\t\t\t\t<label>{{dayPeriodCombo.selectedLabel}}</label>\n\t\t\t\t\t<ul>\n\t\t\t\t\t\t<li [cdsComboItem]=\"'AM'\" [labelValue]=\"dayPeriodsTranslation[0]\" tabindex=\"-1\">{{dayPeriodsTranslation[0]}}</li>\n\t\t\t\t\t\t<li [cdsComboItem]=\"'PM'\" [labelValue]=\"dayPeriodsTranslation[1]\" tabindex=\"-1\">{{dayPeriodsTranslation[1]}}</li>\n\t\t\t\t\t</ul>\n\t\t\t\t\t</cds-combo>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"cds-time-control__footer\">\n\t\t\t<button cdsButton type=\"button\" class=\"cds-button-text\" (click)=\"clearValue()\" [attr.aria-label]=\"translations.cancel\">{{translations.cancelButton}}</button>\n\t\t\t<button cdsButton type=\"button\" class=\"cds-button-primary\" (click)=\"applyValue()\" [attr.aria-label]=\"translations.apply\" [disabled]=\"!inputModel.valid\">{{translations.applyButton}}</button>\n\t\t</div>\n\t</cds-dropdown>\n</ng-container>\n<ng-container *ngIf=\"!timePicker\">\n\t<cds-combo #timeCombo\n\t           [appearance]=\"appearance\"\n\t           class=\"cds-time-control__control cds-control--child\"\n\t           [label]=\"label || translations.selectTimeHeader\"\n\t           [ngModel]=\"inputValue\"\n\t           [cdsInvalid]=\"errors != null\"\n\t           [disabled]=\"disabled\"\n\t           (ngModelChange)=\"changeInputValue($event)\">\n\t\t<label>{{inputValue | cdsTimeControlDisplayHour:useDayPeriod:format:dayPeriodsTranslation || timeCombo.selectedLabel}}</label>\n\t\t<ul>\n\t\t\t<li *ngFor=\"let time of inputValue | cdsTimeControlList:constraints\" [cdsComboItem]=\"time\" [labelValue]=\"time\" tabindex=\"-1\">{{time | cdsTimeControlDisplayHour:useDayPeriod:format:dayPeriodsTranslation}}</li>\n\t\t</ul>\n\t</cds-combo>\n</ng-container>\n\n",
                providers: [TIME_CONTROL_VALUE_ACCESSOR, TIME_VALIDATOR, DynamicTranslations],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: TimezonesService }, { type: ɵngcc0.ChangeDetectorRef }, { type: DateTimeService }, { type: TimeService }, { type: DateTimeValidatorService }, { type: DynamicTranslations }]; }, { appearance: [{
            type: Input
        }], format: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], label: [{
            type: Input
        }], inlineEdit: [{
            type: Input
        }], dateRequired: [{
            type: Input
        }], timePicker: [{
            type: Input
        }], dateValue: [{
            type: Input
        }], dropdown: [{
            type: ViewChild,
            args: ['dropdown']
        }], input: [{
            type: ViewChild,
            args: ['input']
        }] }); })();
    return TimeControlComponent;
}(BaseDateTimeComponent));

var TimeAbstractControlComponent = /** @class */ (function () {
    function TimeAbstractControlComponent(timezonesService, dateTimeService) {
        this.timezonesService = timezonesService;
        this.dateTimeService = dateTimeService;
        this.timePickerValue = '00:00:00';
        this.format = 'time';
        this.dateRequired = false;
    }
    TimeAbstractControlComponent.prototype.ngOnInit = function () {
        this.resolvedFormat = this.dateTimeService.resolveFormat(this.format);
        this.includesSeconds = this.dateTimeService.includesSeconds(this.format);
        this.useDayPeriod = this.dateTimeService.is12hMode(this.format);
        this.dayPeriodsTranslation = this.dateTimeService.getDayPeriods();
        var value = this.inputValue || this.value;
        if (value) {
            try {
                var time = Time.fromString(this.value);
                var timeString = time.toString('time');
                this.inputValue = timeString;
                this.timePickerValue = timeString;
            }
            catch (_a) {
            }
        }
        if (this.timezone) {
            this.timezones = this.timezone.getTimezones();
            var localTimezone = this.timezonesService.getLocalTimezone();
            this.changeTimezoneValue(this.timezone.selected || (localTimezone ? localTimezone.code : null));
        }
        if (this.useDayPeriod) {
            this.dayPeriodValue = this.dayPeriod ? this.dayPeriod : 'AM';
        }
    };
    TimeAbstractControlComponent.prototype.changeInputValue = function (newValue) {
        try {
            var time = Time.fromString(newValue).toDate();
            this.timePickerValue = newValue;
            this.dayPeriodValue = time.getHours() >= 12 ? 'PM' : 'AM';
        }
        catch (e) {
            this.timePickerValue = null;
            this.dayPeriodValue = 'AM';
        }
        this.inputValue = newValue;
    };
    TimeAbstractControlComponent.prototype.changeTimePickerValue = function (newValue) {
        try {
            var date = Time.fromString(newValue).toDate();
            this.inputValue = newValue;
            this.dayPeriodValue = date.getHours() >= 12 ? 'PM' : 'AM';
        }
        catch (e) {
            this.inputValue = null;
            this.dayPeriodValue = 'AM';
        }
        this.timePickerValue = newValue;
    };
    TimeAbstractControlComponent.prototype.changeTimezoneValue = function (timezoneCode) {
        this.timezoneValue = timezoneCode;
        if (timezoneCode) {
            this.constraints = this.constraints.updateTimezone(this.timezonesService.getTimezone(timezoneCode));
        }
    };
    TimeAbstractControlComponent.prototype.changeDayPeriodValue = function (dayPeriod) {
        if (dayPeriod && this.dayPeriodValue !== dayPeriod) {
            this.dayPeriodValue = dayPeriod;
            this.dayPeriod = dayPeriod;
            this.recalculateHour();
        }
    };
    TimeAbstractControlComponent.prototype.recalculateHour = function () {
        if (this.dayPeriodValue == null || !this.inputValue) {
            return;
        }
        var timeAndNewHour = Time.fromString(this.inputValue);
        timeAndNewHour.toggleDayPeriod();
        var newValue = timeAndNewHour.toString('time');
        this.changeTimePickerValue(newValue);
    };
    TimeAbstractControlComponent.prototype.clearValue = function () {
        this.timePickerValue = this.useDayPeriod ? '01:00:00' : '00:00:00';
        this.inputValue = null;
        if (this.dayPeriod != null) {
            this.dayPeriodValue = 'AM';
        }
        if (this.timezone) {
            var localTimezone = this.timezonesService.getLocalTimezone();
            this.changeTimezoneValue(localTimezone ? localTimezone.code : null);
        }
        this.input.focus();
    };
    TimeAbstractControlComponent.ctorParameters = function () { return [
        { type: TimezonesService },
        { type: DateTimeService }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", DateTimeConstraints)
    ], TimeAbstractControlComponent.prototype, "constraints", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TimeAbstractControlComponent.prototype, "format", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TimeAbstractControlComponent.prototype, "placeholder", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TimeAbstractControlComponent.prototype, "label", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], TimeAbstractControlComponent.prototype, "dateRequired", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TimeAbstractControlComponent.prototype, "dayPeriod", void 0);
    __decorate([
        Input(),
        __metadata("design:type", TimezoneDirective)
    ], TimeAbstractControlComponent.prototype, "timezone", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TimeAbstractControlComponent.prototype, "value", void 0);
    __decorate([
        ViewChild('input'),
        __metadata("design:type", InputComponent)
    ], TimeAbstractControlComponent.prototype, "input", void 0);
    TimeAbstractControlComponent = __decorate([ __metadata("design:paramtypes", [TimezonesService,
            DateTimeService])
    ], TimeAbstractControlComponent);
TimeAbstractControlComponent.ɵfac = function TimeAbstractControlComponent_Factory(t) { return new (t || TimeAbstractControlComponent)(ɵngcc0.ɵɵdirectiveInject(TimezonesService), ɵngcc0.ɵɵdirectiveInject(DateTimeService)); };
TimeAbstractControlComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TimeAbstractControlComponent, viewQuery: function TimeAbstractControlComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c5, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, inputs: { format: "format", dateRequired: "dateRequired", constraints: "constraints", dayPeriod: "dayPeriod", placeholder: "placeholder", label: "label", timezone: "timezone", value: "value" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TimeAbstractControlComponent, [{
        type: Directive
    }], function () { return [{ type: TimezonesService }, { type: DateTimeService }]; }, { format: [{
            type: Input
        }], dateRequired: [{
            type: Input
        }], constraints: [{
            type: Input
        }], dayPeriod: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], label: [{
            type: Input
        }], timezone: [{
            type: Input
        }], value: [{
            type: Input
        }], input: [{
            type: ViewChild,
            args: ['input']
        }] }); })();
    return TimeAbstractControlComponent;
}());

var TimeDialogComponent = /** @class */ (function (_super) {
    __extends(TimeDialogComponent, _super);
    function TimeDialogComponent(elementRef, renderer, cdRef, timezonesService, dateTimeService, componentTranslations) {
        var _this = _super.call(this, timezonesService, dateTimeService) || this;
        _this.animate = 1;
        _this.dialogClose = new EventEmitter();
        renderer.addClass(elementRef.nativeElement, 'cds-date-time-dialog');
        renderer.addClass(elementRef.nativeElement, 'cds-date-time-dialog--time');
        componentTranslations.use(CDS_DATE_TIME_TRANSLATIONS, dateTimeTranslationsFactory, function (translations) {
            _this.translations = translations;
            if (_this.initialized) {
                cdRef.detectChanges();
            }
        });
        componentTranslations.use(CDS_ERRORS_TRANSLATIONS, errorsTranslationsFactory, function (translations) {
            _this.errorsTranslations = translations;
            if (_this.initialized) {
                cdRef.detectChanges();
            }
        });
        return _this;
    }
    TimeDialogComponent.prototype.ngOnInit = function () {
        this.initialized = true;
        _super.prototype.ngOnInit.call(this);
    };
    TimeDialogComponent.prototype.changeInputValue = function (newValue) {
        _super.prototype.changeInputValue.call(this, newValue);
        this.value = newValue;
    };
    TimeDialogComponent.prototype.changeTimePickerValue = function (newValue) {
        _super.prototype.changeTimePickerValue.call(this, newValue);
    };
    TimeDialogComponent.prototype.changeTimezoneValue = function (timezoneCode) {
        _super.prototype.changeTimezoneValue.call(this, timezoneCode);
    };
    TimeDialogComponent.prototype.changeDayPeriodValue = function (dayPeriod) {
        _super.prototype.changeDayPeriodValue.call(this, dayPeriod);
    };
    TimeDialogComponent.prototype.closeDialog = function () {
        this.dialogClose.emit(null);
    };
    TimeDialogComponent.prototype.onBlur = function () {
        this.input.writeValue(this.inputValue);
    };
    TimeDialogComponent.prototype.applyValue = function () {
        var value = this.inputValue;
        this.dialogClose.emit({
            date: value,
            timezone: this.timezoneValue,
            dayPeriod: this.dayPeriodValue,
        });
    };
    TimeDialogComponent.prototype.clearValue = function () {
        _super.prototype.clearValue.call(this);
    };
    TimeDialogComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ChangeDetectorRef },
        { type: TimezonesService },
        { type: DateTimeService },
        { type: DynamicTranslations }
    ]; };
    __decorate([
        HostBinding('@animate'),
        __metadata("design:type", Number)
    ], TimeDialogComponent.prototype, "animate", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], TimeDialogComponent.prototype, "dialogClose", void 0);
    __decorate([
        ViewChild('input', { static: true }),
        __metadata("design:type", InputComponent)
    ], TimeDialogComponent.prototype, "input", void 0);
    TimeDialogComponent = __decorate([ __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            ChangeDetectorRef,
            TimezonesService,
            DateTimeService,
            DynamicTranslations])
    ], TimeDialogComponent);
TimeDialogComponent.ɵfac = function TimeDialogComponent_Factory(t) { return new (t || TimeDialogComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(TimezonesService), ɵngcc0.ɵɵdirectiveInject(DateTimeService), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations)); };
TimeDialogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TimeDialogComponent, selectors: [["cds-time-dialog"]], viewQuery: function TimeDialogComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c5, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, hostVars: 1, hostBindings: function TimeDialogComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵsyntheticHostProperty("@animate", ctx.animate);
    } }, outputs: { dialogClose: "dialogClose" }, features: [ɵngcc0.ɵɵProvidersFeature([
            DynamicTranslations,
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 27, vars: 22, consts: [["role", "dialog", 3, "dialogClose", "cdsOnEscape"], [1, "cds-date-time-dialog__time-section"], ["ngForm", "", 1, "cds-date-time-dialog__fields"], ["form", "ngForm"], [1, "cds-date-time-dialog__container"], ["class", "cds-date-time-dialog__timezone-combo", 4, "ngIf"], [1, "cds-date-time-dialog__time-input"], ["cdsDateInput", "", "name", "input", 3, "format", "constraints", "dayPeriod", "ngModel", "label", "placeholder", "required", "autofocus", "ngModelChange", "blur"], ["input", "", "inputModel", "ngModel"], ["class", "cds-date-time-dialog__day-period-combo", 4, "ngIf"], [1, "cds-date-time-dialog__errors"], [3, "cdsErrors"], [4, "cdsError"], [1, "cds-date-time-dialog__pickers"], [1, "cds-date-time-dialog__time-picker"], [3, "constraints", "format", "useDayPeriod", "ngModel", "ngModelChange"], [1, "cds-dialog-buttons"], ["cdsButton", "", "type", "button", 1, "cds-button-text", 3, "click"], ["cdsButton", "", "type", "button", 1, "cds-button-primary", 3, "disabled", "click"], [1, "cds-date-time-dialog__timezone-combo"], ["name", "timezone", "required", "", 3, "ngModel", "ngModelChange"], ["timezoneCombo", ""], ["title", ""], ["tabindex", "-1", 3, "cdsComboItem", "labelValue", 4, "ngFor", "ngForOf"], ["tabindex", "-1", 3, "cdsComboItem", "labelValue"], [1, "cds-date-time-dialog__day-period-combo"], ["appearance", "inline", "name", "useDayPeriod", 3, "ngModel", "ngModelChange"], ["dayPeriodCombo", ""], ["default", ""]], template: function TimeDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "cds-dialog", 0);
        ɵngcc0.ɵɵlistener("dialogClose", function TimeDialogComponent_Template_cds_dialog_dialogClose_0_listener() { return ctx.closeDialog(); })("cdsOnEscape", function TimeDialogComponent_Template_cds_dialog_cdsOnEscape_0_listener() { return ctx.closeDialog(); });
        ɵngcc0.ɵɵelementStart(1, "cds-slot-title");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "cds-slot-content", 1);
        ɵngcc0.ɵɵelementStart(4, "div", 2, 3);
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵtemplate(7, TimeDialogComponent_div_7_Template, 9, 4, "div", 5);
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵelementStart(9, "cds-input", 7, 8);
        ɵngcc0.ɵɵlistener("ngModelChange", function TimeDialogComponent_Template_cds_input_ngModelChange_9_listener($event) { return ctx.changeInputValue($event); })("blur", function TimeDialogComponent_Template_cds_input_blur_9_listener() { return ctx.onBlur(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, TimeDialogComponent_div_12_Template, 12, 9, "div", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 10);
        ɵngcc0.ɵɵelementStart(14, "cds-errors", 11);
        ɵngcc0.ɵɵelementStart(15, "span");
        ɵngcc0.ɵɵtext(16, "\u200B");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(17, TimeDialogComponent_span_17_Template, 2, 1, "span", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "div", 13);
        ɵngcc0.ɵɵelementStart(19, "div", 14);
        ɵngcc0.ɵɵelementStart(20, "cds-time-picker", 15);
        ɵngcc0.ɵɵlistener("ngModelChange", function TimeDialogComponent_Template_cds_time_picker_ngModelChange_20_listener($event) { return ctx.changeTimePickerValue($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "cds-slot-footer");
        ɵngcc0.ɵɵelementStart(22, "div", 16);
        ɵngcc0.ɵɵelementStart(23, "button", 17);
        ɵngcc0.ɵɵlistener("click", function TimeDialogComponent_Template_button_click_23_listener() { return ctx.clearValue(); });
        ɵngcc0.ɵɵtext(24);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "button", 18);
        ɵngcc0.ɵɵlistener("click", function TimeDialogComponent_Template_button_click_25_listener() { return ctx.applyValue(); });
        ɵngcc0.ɵɵtext(26);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        var _r0 = ɵngcc0.ɵɵreference(5);
        var _r3 = ɵngcc0.ɵɵreference(11);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.translations.selectTimeHeader, " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.timezones);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("cds-date-time-dialog__time-input--seconds", ctx.includesSeconds);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("format", ctx.format)("constraints", ctx.constraints)("dayPeriod", ctx.dayPeriodValue)("ngModel", ctx.inputValue)("label", ctx.label)("placeholder", ctx.placeholder)("required", ctx.dateRequired)("autofocus", true);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.useDayPeriod);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("cdsErrors", _r3);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("cdsError", "required");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("constraints", ctx.constraints)("format", ctx.resolvedFormat)("useDayPeriod", ctx.useDayPeriod)("ngModel", ctx.timePickerValue);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.translations.clearButton);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", !_r0.valid);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.translations.applyButton);
    } }, directives: [DialogComponent, OnEscapeDirective, SlotsDirective, ɵngcc3.NgControlStatusGroup, ɵngcc3.NgForm, ɵngcc1.NgIf, InputComponent, DateInputDirective, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.RequiredValidator, ErrorsComponent, ErrorsDirective, ErrorDirective, TimePickerComponent, ButtonRippleDirective, ComboComponent, ɵngcc1.NgForOf, ComboItemDirective], encapsulation: 2, data: { animation: [
            trigger('animate', [
                transition(':leave', query('cds-dialog', animateChild())),
            ]),
        ] } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TimeDialogComponent, [{
        type: Component,
        args: [{
                selector: 'cds-time-dialog',
                template: "<cds-dialog role=\"dialog\" (dialogClose)=\"closeDialog()\" (cdsOnEscape)=\"closeDialog()\">\n\t<cds-slot-title>\n\t\t{{translations.selectTimeHeader}}\n\t</cds-slot-title>\n\t<cds-slot-content class=\"cds-date-time-dialog__time-section\">\n\t\t<div class=\"cds-date-time-dialog__fields\" ngForm #form=\"ngForm\">\n\t\t\t<div class=\"cds-date-time-dialog__container\">\n\t\t\t\t<div class=\"cds-date-time-dialog__timezone-combo\"  *ngIf=\"timezones\">\n\t\t\t\t\t<cds-combo #timezoneCombo\n\t\t\t\t\t           name=\"timezone\"\n\t\t\t\t\t           [ngModel]=\"timezoneValue\"\n\t\t\t\t\t           (ngModelChange)=\"changeTimezoneValue($event)\"\n\t\t\t\t\t           required>\n\t\t\t\t\t\t<label>{{timezoneCombo.selectedLabel}}</label>\n\t\t\t\t\t\t<label title>{{translations.timezoneLabel}}</label>\n\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t<li *ngFor=\"let timezone of timezones\" [cdsComboItem]=\"timezone.code\" [labelValue]=\"timezone.name\" tabindex=\"-1\">{{timezone.name}}</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</cds-combo>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"cds-date-time-dialog__time-input\" [class.cds-date-time-dialog__time-input--seconds]=\"includesSeconds\">\n\t\t\t\t\t<cds-input #input\n\t\t\t\t\t           #inputModel=\"ngModel\"\n\t\t\t\t\t           cdsDateInput\n\t\t\t\t\t           [format]=\"format\"\n\t\t\t\t\t           [constraints]=\"constraints\"\n\t\t\t\t\t           [dayPeriod]=\"dayPeriodValue\"\n\t\t\t\t\t           name=\"input\"\n\t\t\t\t\t           [ngModel]=\"inputValue\"\n\t\t\t\t\t           (ngModelChange)=\"changeInputValue($event)\"\n\t\t\t\t\t           [label]=\"label\"\n\t\t\t\t\t           [placeholder]=\"placeholder\"\n\t\t\t\t\t           [required]=\"dateRequired\"\n\t\t\t\t\t           (blur)=\"onBlur()\"\n\t\t\t\t\t           [autofocus]=\"true\"></cds-input>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"cds-date-time-dialog__day-period-combo\" *ngIf=\"useDayPeriod\">\n\t\t\t\t\t<cds-combo #dayPeriodCombo\n\t\t\t\t\t           appearance=\"inline\"\n\t\t\t\t\t           name=\"useDayPeriod\"\n\t\t\t\t\t           [ngModel]=\"dayPeriodValue\"\n\t\t\t\t\t           (ngModelChange)=\"changeDayPeriodValue($event)\">\n\t\t\t\t\t\t<label>{{dayPeriodCombo.selectedLabel}}</label>\n\t\t\t\t\t\t<label default>{{translations.dayPeriodLabel}}</label>\n\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t<li [cdsComboItem]=\"'AM'\" [labelValue]=\"dayPeriodsTranslation[0]\" tabindex=\"-1\">{{dayPeriodsTranslation[0]}}</li>\n\t\t\t\t\t\t\t<li [cdsComboItem]=\"'PM'\" [labelValue]=\"dayPeriodsTranslation[1]\" tabindex=\"-1\">{{dayPeriodsTranslation[1]}}</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</cds-combo>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"cds-date-time-dialog__errors\">\n\t\t\t<cds-errors [cdsErrors]=\"inputModel\">\n\t\t\t\t<span>&#8203;</span>\n\t\t\t\t<span *cdsError=\"'required'\">{{errorsTranslations.required}}</span>\n\t\t\t</cds-errors>\n\t\t</div>\n\t\t<div class=\"cds-date-time-dialog__pickers\">\n\t\t\t<div class=\"cds-date-time-dialog__time-picker\">\n\t\t\t\t<cds-time-picker [constraints]=\"constraints\"\n\t\t\t\t                 [format]=\"resolvedFormat\"\n\t\t\t\t                 [useDayPeriod]=\"useDayPeriod\"\n\t\t\t\t                 [ngModel]=\"timePickerValue\"\n\t\t\t\t                 (ngModelChange)=\"changeTimePickerValue($event)\"></cds-time-picker>\n\t\t\t</div>\n\t\t</div>\n\t</cds-slot-content>\n\t<cds-slot-footer>\n\t\t<div class=\"cds-dialog-buttons\">\n\t\t\t<button cdsButton type=\"button\" class=\"cds-button-text\" (click)=\"clearValue()\">{{translations.clearButton}}</button>\n\t\t\t<button cdsButton type=\"button\" class=\"cds-button-primary\" [disabled]=\"!form.valid\" (click)=\"applyValue()\">{{translations.applyButton}}</button>\n\t\t</div>\n\t</cds-slot-footer>\n</cds-dialog>\n",
                animations: [
                    trigger('animate', [
                        transition(':leave', query('cds-dialog', animateChild())),
                    ]),
                ],
                providers: [
                    DynamicTranslations,
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: TimezonesService }, { type: DateTimeService }, { type: DynamicTranslations }]; }, { animate: [{
            type: HostBinding,
            args: ['@animate']
        }], dialogClose: [{
            type: Output
        }], input: [{
            type: ViewChild,
            args: ['input', { static: true }]
        }] }); })();
    return TimeDialogComponent;
}(TimeAbstractControlComponent));

var TIME_FORM_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return TimeFormComponent; }),
    multi: true,
};
var TIME_FORM_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(function () { return TimeFormComponent; }),
    multi: true,
};
var TimeFormComponent = /** @class */ (function (_super) {
    __extends(TimeFormComponent, _super);
    function TimeFormComponent(elementRef, renderer, timezonesService, cdRef, dateTimeService, dateTimeValidatorService, dialogService, timezoneDirective, componentTranslations) {
        var _this = _super.call(this, timezonesService) || this;
        _this.cdRef = cdRef;
        _this.dateTimeService = dateTimeService;
        _this.dateTimeValidatorService = dateTimeValidatorService;
        _this.dialogService = dialogService;
        _this.timezoneDirective = timezoneDirective;
        _this.keepFocus = false;
        _this.focusOn = false;
        _this.appearance = 'outline';
        _this.format = 'time';
        _this.inlineEdit = false;
        _this.dateRequired = false;
        _this.timePicker = false;
        _this.mode = 'dialog';
        _this.disabled = false;
        _this.onTouchedCallback = noop;
        _this.onChangeCallback = noop;
        _this.onValidatorChange = noop;
        componentTranslations.use(CDS_DATE_TIME_TRANSLATIONS, dateTimeTranslationsFactory, function (translations) {
            _this.translations = translations;
            if (_this.afterChanges) {
                cdRef.detectChanges();
            }
        });
        renderer.addClass(elementRef.nativeElement, 'cds-date-time-form');
        renderer.addClass(elementRef.nativeElement, 'cds-date-time-form--time');
        renderer.addClass(elementRef.nativeElement, 'cds-control--parent');
        renderer.addClass(elementRef.nativeElement, 'cds-control');
        if (_this.timezoneDirective) {
            _this.timezones = _this.timezoneDirective.getTimezones();
        }
        return _this;
    }
    TimeFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.afterChanges) {
            this.ngOnChanges({});
        }
        this.resolvedFormat = this.dateTimeService.resolveFormat(this.format);
        this.includesSeconds = this.dateTimeService.includesSeconds(this.format);
        this.useDayPeriod = this.dateTimeService.is12hMode(this.format);
        this.dayPeriodsTranslation = this.dateTimeService.getDayPeriods();
        if (this.timezoneDirective) {
            this.timezoneValue = this.timezoneDirective.selected;
            this.timezoneObservable = this.timezoneDirective.$changes.subscribe(function (value) {
                if (_this.mode === 'dropdown') {
                    _this.setTimezone(value);
                    _this.onChangeCallback(_this.value);
                }
            });
        }
    };
    TimeFormComponent.prototype.ngOnChanges = function (changes) {
        this.afterChanges = true;
        if ('format' in changes) {
            this.resolvedFormat = this.dateTimeService.resolveFormat(this.format);
            this.includesSeconds = this.dateTimeService.includesSeconds(this.format);
            this.useDayPeriod = this.dateTimeService.is12hMode(this.format);
        }
        _super.prototype.ngOnChanges.call(this, changes);
        if ('dateRequired' in changes || 'dateValue' in changes) {
            this.onValidatorChange();
        }
    };
    TimeFormComponent.prototype.openDialog = function () {
        var _this = this;
        if (!this.disabled) {
            this.keepFocus = true;
            this.focusOn = true;
            this.dialogService.open(this.dialog).then(function (value) {
                _this.closeDialog(value);
                return value;
            }, function () { return null; });
        }
        return Promise.resolve(null);
    };
    TimeFormComponent.prototype.closeDialog = function (value) {
        this.keepFocus = false;
        this.focusOn = false;
        if (this.input) {
            this.input.focus();
        }
        this.onTouchedCallback();
        if (value) {
            this.setTimezone(value.timezone);
            if (value.dayPeriod !== this.dayPeriod) {
                this.dayPeriod = value.dayPeriod;
            }
            if (value.date !== this.value) {
                this.value = value.date;
                this.onChangeCallback(value.date);
            }
        }
    };
    TimeFormComponent.prototype.updateValue = function (value) {
        if (value !== this.value) {
            this.value = value;
            this.onChangeCallback(value);
        }
    };
    TimeFormComponent.prototype.writeValue = function (modelValue) {
        this.value = modelValue;
        this.cdRef.markForCheck();
    };
    TimeFormComponent.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    TimeFormComponent.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    TimeFormComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
        this.cdRef.markForCheck();
    };
    TimeFormComponent.prototype.validate = function (control) {
        this.cdRef.markForCheck();
        if (!control.value) {
            this.errors = this.dateRequired ? { required: true } : null;
        }
        else if (this.mode === 'dropdown') {
            var mode = this.dateValue != null ? 'datetime' : 'time';
            var value = mode === 'datetime' ? this.dateValue + "T" + control.value : control.value;
            this.errors = this.dateTimeValidatorService.validate(this.constraints, value, this.format, mode);
        }
        else {
            this.errors = this.dateTimeValidatorService.validate(this.constraints, control.value, this.format);
        }
        return this.errors;
    };
    TimeFormComponent.prototype.registerOnValidatorChange = function (fn) {
        this.onValidatorChange = fn;
    };
    TimeFormComponent.prototype.onBlur = function () {
        this.onTouchedCallback();
        var isDropdown = this.mode === 'dropdown';
        if (!isDropdown && this.input) {
            this.input.writeValue(this.value);
        }
        if (this.inlineEdit) {
            this.keepFocus = this.focusOn;
        }
    };
    TimeFormComponent.prototype.onMouseDown = function () {
        if (!this.disabled) {
            this.keepFocus = true;
        }
    };
    TimeFormComponent.prototype.setTimezone = function (timezoneCode) {
        if (timezoneCode) {
            this.constraints = this.constraints.updateTimezone(this.timezonesService.getTimezone(timezoneCode));
        }
        if (this.timezoneDirective) {
            this.timezoneDirective.changeTimezone(timezoneCode);
        }
    };
    TimeFormComponent.prototype.setDayPeriod = function (dayPeriod) {
        if (this.useDayPeriod && dayPeriod) {
            this.dayPeriod = dayPeriod;
            if (this.value) {
                var newTime = Time.fromString(this.value);
                newTime.toggleDayPeriod();
                this.value = newTime.toString('time');
                this.onChangeCallback(this.value);
            }
        }
    };
    TimeFormComponent.prototype.updatedConstraints = function () {
        var mode = 'time';
        return __assign({ mode: mode }, _super.prototype.updatedConstraints.call(this));
    };
    TimeFormComponent.prototype.ngOnDestroy = function () {
        if (this.timezoneObservable) {
            this.timezoneObservable.unsubscribe();
        }
    };
    TimeFormComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: TimezonesService },
        { type: ChangeDetectorRef },
        { type: DateTimeService },
        { type: DateTimeValidatorService },
        { type: DialogService },
        { type: TimezoneDirective, decorators: [{ type: Optional }] },
        { type: DynamicTranslations }
    ]; };
    __decorate([
        Input(),
        HostBinding('class.cds-date-time-form--hidden'),
        __metadata("design:type", Boolean)
    ], TimeFormComponent.prototype, "hidden", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TimeFormComponent.prototype, "appearance", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TimeFormComponent.prototype, "format", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TimeFormComponent.prototype, "placeholder", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TimeFormComponent.prototype, "label", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], TimeFormComponent.prototype, "inlineEdit", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], TimeFormComponent.prototype, "dateRequired", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], TimeFormComponent.prototype, "timePicker", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TimeFormComponent.prototype, "dateValue", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TimeFormComponent.prototype, "mode", void 0);
    __decorate([
        ViewChild('input'),
        __metadata("design:type", InputComponent)
    ], TimeFormComponent.prototype, "input", void 0);
    __decorate([
        ViewChild('dialog', { static: true }),
        __metadata("design:type", TemplateRef)
    ], TimeFormComponent.prototype, "dialog", void 0);
    TimeFormComponent = __decorate([ __param(7, Optional()),
        __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            TimezonesService,
            ChangeDetectorRef,
            DateTimeService,
            DateTimeValidatorService,
            DialogService,
            TimezoneDirective,
            DynamicTranslations])
    ], TimeFormComponent);
TimeFormComponent.ɵfac = function TimeFormComponent_Factory(t) { return new (t || TimeFormComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(TimezonesService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DateTimeService), ɵngcc0.ɵɵdirectiveInject(DateTimeValidatorService), ɵngcc0.ɵɵdirectiveInject(DialogService), ɵngcc0.ɵɵdirectiveInject(TimezoneDirective, 8), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations)); };
TimeFormComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TimeFormComponent, selectors: [["cds-time-form"]], viewQuery: function TimeFormComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c5, true);
        ɵngcc0.ɵɵstaticViewQuery(_c33, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dialog = _t.first);
    } }, hostVars: 2, hostBindings: function TimeFormComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("cds-date-time-form--hidden", ctx.hidden);
    } }, inputs: { hidden: "hidden", appearance: "appearance", format: "format", placeholder: "placeholder", label: "label", inlineEdit: "inlineEdit", dateRequired: "dateRequired", timePicker: "timePicker", dateValue: "dateValue", mode: "mode" }, features: [ɵngcc0.ɵɵProvidersFeature([TIME_FORM_CONTROL_VALUE_ACCESSOR, TIME_FORM_VALIDATOR, DynamicTranslations]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 2, consts: [["class", "cds-date-time-form__container", 4, "ngIf"], [3, "appearance", "format", "placeholder", "label", "timePicker", "disabled", "inputValue", "timezoneValue", "constraints", "dayPeriod", "dateRequired", "inlineEdit", "dateValue", "valueChange", "blur", 4, "ngIf"], ["dialog", ""], [1, "cds-date-time-form__container"], [1, "cds-date-time-form__time-input"], ["cdsDateInput", "", 1, "cds-control--child", 3, "appearance", "constraints", "format", "dayPeriod", "selected", "ngModel", "label", "placeholder", "readonly", "disabled", "cdsInvalid", "ngModelChange", "mousedown", "blur", "click", "keydown.enter"], ["input", ""], [1, "cds-icon-time", 3, "click"], ["class", "cds-date-time-form__day-period-combo", 4, "ngIf"], ["class", "cds-date-time-form__timezone-combo", 4, "ngIf"], [1, "cds-date-time-form__day-period-combo"], ["appearance", "inline", "name", "useDayPeriod", "required", "", 1, "cds-control--child", 3, "ngModel", "disabled", "ngModelChange"], ["dayPeriodCombo", ""], ["default", ""], ["tabindex", "-1", 3, "cdsComboItem", "labelValue"], [1, "cds-date-time-form__timezone-combo"], ["appearance", "inline", "class", "cds-control--child", "name", "timezone", "required", "", 3, "ngModel", "disabled", "ngModelChange", 4, "ngIf"], ["appearance", "inline", "name", "timezone", "required", "", 1, "cds-control--child", 3, "ngModel", "disabled", "ngModelChange"], ["timezoneCombo", ""], ["tabindex", "-1", 3, "cdsComboItem", "labelValue", 4, "ngFor", "ngForOf"], [3, "appearance", "format", "placeholder", "label", "timePicker", "disabled", "inputValue", "timezoneValue", "constraints", "dayPeriod", "dateRequired", "inlineEdit", "dateValue", "valueChange", "blur"], ["dropdown", ""], [3, "format", "placeholder", "label", "dayPeriod", "value", "timezone", "constraints", "dateRequired", "dialogClose"]], template: function TimeFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TimeFormComponent_div_0_Template, 7, 17, "div", 0);
        ɵngcc0.ɵɵtemplate(1, TimeFormComponent_cds_time_dropdown_1_Template, 2, 13, "cds-time-dropdown", 1);
        ɵngcc0.ɵɵtemplate(2, TimeFormComponent_ng_template_2_Template, 1, 8, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hidden && ctx.mode === "dialog");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.mode === "dropdown");
    } }, directives: function () { return [ɵngcc1.NgIf, InputComponent, DateInputDirective, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, InvalidDirective, ComboComponent, ɵngcc3.RequiredValidator, ComboItemDirective, ɵngcc1.NgForOf, TimeDropdownComponent, TimeDialogComponent]; }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TimeFormComponent, [{
        type: Component,
        args: [{
                selector: 'cds-time-form',
                template: "<div class=\"cds-date-time-form__container\" *ngIf=\"!hidden && mode === 'dialog'\">\n\t<div class=\"cds-date-time-form__time-input\" [class.cds-date-time-form__time-input--seconds]=\"includesSeconds\">\n\t\t<cds-input #input\n\t\t           [appearance]=\"appearance\"\n\t\t           cdsDateInput\n\t\t           [constraints]=\"null\"\n\t\t           class=\"cds-control--child\"\n\t\t           [class.cds-control--required]=\"dateRequired\"\n\t\t           [format]=\"format\"\n\t\t           [dayPeriod]=\"dayPeriod\"\n\t\t           [selected]=\"keepFocus\"\n\t\t           [ngModel]=\"value\"\n\t\t           (ngModelChange)=\"updateValue($event)\"\n\t\t           [label]=\"label\"\n\t\t           [placeholder]=\"placeholder\"\n\t\t           [readonly]=\"!inlineEdit\"\n\t\t           [disabled]=\"disabled\"\n\t\t           [cdsInvalid]=\"errors != null\"\n\t\t           (mousedown)=\"onMouseDown()\"\n\t\t           (blur)=\"onBlur()\"\n\t\t           (click)=\"!inlineEdit && openDialog()\"\n\t\t           (keydown.enter)=\"openDialog()\">\n\t\t\t\t<a class=\"cds-icon-time\" (click)=\"inlineEdit && openDialog()\"></a>\n\t\t</cds-input>\n\t</div>\n\t<div class=\"cds-date-time-form__day-period-combo\" *ngIf=\"useDayPeriod\">\n\t\t<cds-combo #dayPeriodCombo\n\t\t           appearance=\"inline\"\n\t\t           class=\"cds-control--child\"\n\t\t           name=\"useDayPeriod\"\n\t\t           [ngModel]=\"dayPeriod\"\n\t\t           (ngModelChange)=\"setDayPeriod($event)\"\n\t\t           [disabled]=\"disabled\"\n\t\t           required>\n\t\t\t<label>{{dayPeriodCombo.selectedLabel}}</label>\n\t\t\t<label default>{{translations.dayPeriodLabel}}</label>\n\t\t\t<ul>\n\t\t\t\t<li [cdsComboItem]=\"'AM'\" [labelValue]=\"dayPeriodsTranslation[0]\" tabindex=\"-1\">{{dayPeriodsTranslation[0]}}</li>\n\t\t\t\t<li [cdsComboItem]=\"'PM'\" [labelValue]=\"dayPeriodsTranslation[1]\" tabindex=\"-1\">{{dayPeriodsTranslation[1]}}</li>\n\t\t\t</ul>\n\t\t</cds-combo>\n\t</div>\n\t<div class=\"cds-date-time-form__timezone-combo\" *ngIf=\"timezoneDirective\">\n\t\t<cds-combo #timezoneCombo\n\t\t           *ngIf=\"timezones\"\n\t\t           appearance=\"inline\"\n\t\t           class=\"cds-control--child\"\n\t\t           name=\"timezone\"\n\t\t           [ngModel]=\"timezoneDirective.selected\"\n\t\t           (ngModelChange)=\"setTimezone($event)\"\n\t\t           [disabled]=\"disabled\"\n\t\t           required>\n\t\t\t<label>{{timezoneCombo.selectedLabel}}</label>\n\t\t\t<label default>{{translations.timezoneLabel}}</label>\n\t\t\t<ul>\n\t\t\t\t<li *ngFor=\"let timezone of timezones\" [cdsComboItem]=\"timezone.code\" [labelValue]=\"timezone.name\" tabindex=\"-1\">{{timezone.name}}</li>\n\t\t\t</ul>\n\t\t</cds-combo>\n\t</div>\n</div>\n<cds-time-dropdown #dropdown *ngIf=\"mode === 'dropdown'\" [appearance]=\"appearance\" [format]=\"format\" [placeholder]=\"placeholder\" [label]=\"label\" [timePicker]=\"timePicker\" [disabled]=\"disabled\"\n                   [inputValue]=\"value\" [timezoneValue]=\"timezoneDirective?.selected\" [constraints]=\"constraints\" [dayPeriod]=\"dayPeriod\" (valueChange)=\"updateValue($event)\" (blur)=\"onBlur()\"\n                   [dateRequired]=\"dateRequired\" [inlineEdit]=\"inlineEdit\" [dateValue]=\"dateValue\"></cds-time-dropdown>\n<ng-template #dialog let-dialog>\n\t<cds-time-dialog [format]=\"format\" [placeholder]=\"placeholder\" [label]=\"label\" [dayPeriod]=\"dayPeriod\"\n\t                 [value]=\"value\" [timezone]=\"timezoneDirective\" [constraints]=\"constraints\"\n\t                 [dateRequired]=\"dateRequired\" (dialogClose)=\"dialog.resolve($event)\"></cds-time-dialog>\n</ng-template>\n",
                providers: [TIME_FORM_CONTROL_VALUE_ACCESSOR, TIME_FORM_VALIDATOR, DynamicTranslations]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: TimezonesService }, { type: ɵngcc0.ChangeDetectorRef }, { type: DateTimeService }, { type: DateTimeValidatorService }, { type: DialogService }, { type: TimezoneDirective, decorators: [{
                type: Optional
            }] }, { type: DynamicTranslations }]; }, { hidden: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.cds-date-time-form--hidden']
        }], appearance: [{
            type: Input
        }], format: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], label: [{
            type: Input
        }], inlineEdit: [{
            type: Input
        }], dateRequired: [{
            type: Input
        }], timePicker: [{
            type: Input
        }], dateValue: [{
            type: Input
        }], mode: [{
            type: Input
        }], input: [{
            type: ViewChild,
            args: ['input']
        }], dialog: [{
            type: ViewChild,
            args: ['dialog', { static: true }]
        }] }); })();
    return TimeFormComponent;
}(BaseDateTimeComponent));

var TIMEZONE_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return TimezoneControlComponent; }),
    multi: true,
};
var TIMEZONE_VALIDATOR$1 = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(function () { return TimezoneControlComponent; }),
    multi: true,
};
var TimezoneControlComponent = /** @class */ (function () {
    function TimezoneControlComponent(elementRef, renderer, cdRef, timezoneService) {
        this.elementRef = elementRef;
        this.cdRef = cdRef;
        this.timezoneService = timezoneService;
        this.appearance = 'outline';
        this.dateRequired = false;
        this.disabled = false;
        this.onTouchedCallback = noop;
        this.onChangeCallback = noop;
        renderer.addClass(elementRef.nativeElement, 'cds-timezone-control');
        renderer.addClass(elementRef.nativeElement, 'cds-control--parent');
        renderer.addClass(elementRef.nativeElement, 'cds-control');
        this.timezones = this.timezoneService.getTimezones();
    }
    TimezoneControlComponent.prototype.changeTimezoneValue = function (timezoneCode) {
        if (this.timezoneValue != timezoneCode) {
            this.timezoneValue = timezoneCode;
            this.onChangeCallback(timezoneCode);
        }
    };
    TimezoneControlComponent.prototype.writeValue = function (modelValue) {
        this.timezoneValue = modelValue;
        this.cdRef.markForCheck();
    };
    TimezoneControlComponent.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    TimezoneControlComponent.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    TimezoneControlComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
        this.cdRef.markForCheck();
    };
    TimezoneControlComponent.prototype.validate = function (control) {
        if (!control.value) {
            return this.dateRequired ? { required: true } : null;
        }
        var timezone = this.timezoneService.getTimezone(this.timezoneValue);
        if (timezone) {
            return null;
        }
        return {
            'date-time-timezone': { timezone: this.timezoneValue },
        };
    };
    TimezoneControlComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ChangeDetectorRef },
        { type: TimezonesService }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TimezoneControlComponent.prototype, "label", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TimezoneControlComponent.prototype, "placeholder", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TimezoneControlComponent.prototype, "appearance", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], TimezoneControlComponent.prototype, "dateRequired", void 0);
    TimezoneControlComponent = __decorate([ __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            ChangeDetectorRef,
            TimezonesService])
    ], TimezoneControlComponent);
TimezoneControlComponent.ɵfac = function TimezoneControlComponent_Factory(t) { return new (t || TimezoneControlComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(TimezonesService)); };
TimezoneControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TimezoneControlComponent, selectors: [["cds-timezone-control"]], inputs: { appearance: "appearance", dateRequired: "dateRequired", label: "label", placeholder: "placeholder" }, features: [ɵngcc0.ɵɵProvidersFeature([TIMEZONE_CONTROL_VALUE_ACCESSOR, TIMEZONE_VALIDATOR$1])], decls: 6, vars: 10, consts: [[1, "cds-timezone-control__control", "cds-control--child", 3, "appearance", "required", "ngModel", "label", "placeholder", "disabled", "ngModelChange"], ["timezoneCombo", ""], ["tabindex", "-1", 3, "cdsComboItem", "labelValue", 4, "ngFor", "ngForOf"], ["tabindex", "-1", 3, "cdsComboItem", "labelValue"]], template: function TimezoneControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "cds-combo", 0, 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function TimezoneControlComponent_Template_cds_combo_ngModelChange_0_listener($event) { return ctx.changeTimezoneValue($event); });
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "ul");
        ɵngcc0.ɵɵtemplate(5, TimezoneControlComponent_li_5_Template, 2, 3, "li", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        var _r0 = ɵngcc0.ɵɵreference(1);
        ɵngcc0.ɵɵclassProp("cds-control--required", ctx.dateRequired);
        ɵngcc0.ɵɵproperty("appearance", ctx.appearance)("required", ctx.dateRequired)("ngModel", ctx.timezoneValue)("label", ctx.label)("placeholder", ctx.placeholder)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(_r0.selectedLabel);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.timezones);
    } }, directives: [ComboComponent, ɵngcc3.RequiredValidator, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc1.NgForOf, ComboItemDirective], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TimezoneControlComponent, [{
        type: Component,
        args: [{
                selector: 'cds-timezone-control',
                template: "<cds-combo #timezoneCombo\n           [appearance]=\"appearance\"\n           [required]=\"dateRequired\"\n           class=\"cds-timezone-control__control cds-control--child\"\n           [class.cds-control--required]=\"dateRequired\"\n           [ngModel]=\"timezoneValue\"\n           (ngModelChange)=\"changeTimezoneValue($event)\"\n           [label]=\"label\"\n           [placeholder]=\"placeholder\"\n           [disabled]=\"disabled\">\n\t<label>{{timezoneCombo.selectedLabel}}</label>\n\t<ul>\n\t\t<li *ngFor=\"let timezone of timezones\" [cdsComboItem]=\"timezone.code\" [labelValue]=\"timezone.name\" tabindex=\"-1\">{{timezone.name}}</li>\n\t</ul>\n</cds-combo>\n",
                providers: [TIMEZONE_CONTROL_VALUE_ACCESSOR, TIMEZONE_VALIDATOR$1],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: TimezonesService }]; }, { appearance: [{
            type: Input
        }], dateRequired: [{
            type: Input
        }], label: [{
            type: Input
        }], placeholder: [{
            type: Input
        }] }); })();
    return TimezoneControlComponent;
}());

var TimeDropdownComponent = /** @class */ (function (_super) {
    __extends(TimeDropdownComponent, _super);
    function TimeDropdownComponent(elementRef, renderer, timezonesService, cdRef, dateTimeService, dateTimeValidatorService, componentTranslations) {
        var _this = _super.call(this, timezonesService, dateTimeService) || this;
        _this.elementRef = elementRef;
        _this.cdRef = cdRef;
        _this.dateTimeValidatorService = dateTimeValidatorService;
        _this.keepFocus = false;
        _this.appearance = 'outline';
        _this.inlineEdit = false;
        _this.timePicker = false;
        _this.valueChange = new EventEmitter();
        _this.dayPeriodChange = new EventEmitter();
        _this.disabled = false;
        renderer.addClass(elementRef.nativeElement, 'cds-date-time-form__container');
        componentTranslations.use(CDS_DATE_TIME_TRANSLATIONS, dateTimeTranslationsFactory, function (translations) {
            _this.translations = translations;
            if (_this.afterChanges) {
                cdRef.detectChanges();
            }
        });
        return _this;
    }
    TimeDropdownComponent.prototype.onOpenChange = function (isOpen, event) {
        if (event) {
            event.stopPropagation();
        }
        if (isOpen && !this.isOpen) {
            this.currentValue = this.inputValue;
        }
        else if (!isOpen && this.isOpen) {
            /** writeValue to format input view value */
            this.input.writeValue(this.inputValue);
        }
        this.restoreCurrentValue(this.currentValue);
        if (!this.disabled) {
            this.isOpen = isOpen;
            this.keepFocus = isOpen;
            this.cdRef.detectChanges();
            if (isOpen && this.dropdown) {
                this.dropdown.scheduleUpdate();
            }
        }
    };
    TimeDropdownComponent.prototype.writeValue = function (modelValue) {
        this.restoreCurrentValue(modelValue);
        this.cdRef.markForCheck();
    };
    TimeDropdownComponent.prototype.restoreCurrentValue = function (value) {
        try {
            var time = Time.fromString(value).toDate();
            this.inputValue = value;
            this.timePickerValue = value;
            this.dayPeriodValue = time.getHours() >= 12 ? 'PM' : 'AM';
        }
        catch (e) {
            this.inputValue = null;
            this.timePickerValue = '00:00:00';
            this.dayPeriodValue = 'AM';
        }
    };
    TimeDropdownComponent.prototype.changeInputValue = function (newValue) {
        _super.prototype.changeInputValue.call(this, newValue);
        this.valueChange.emit(this.inputValue);
        this.cdRef.detectChanges();
    };
    TimeDropdownComponent.prototype.changeTimePickerValue = function (newValue) {
        _super.prototype.changeTimePickerValue.call(this, newValue);
        this.cdRef.detectChanges();
    };
    TimeDropdownComponent.prototype.changeDayPeriodValue = function (dayPeriod) {
        _super.prototype.changeDayPeriodValue.call(this, dayPeriod);
        this.cdRef.detectChanges();
    };
    TimeDropdownComponent.prototype.getConstraints = function () {
        return this.isOpen ? this.constraints : DateTimeConstraints.empty();
    };
    TimeDropdownComponent.prototype.onBlur = function () {
        if (!this.isOpen) {
            this.elementRef.nativeElement.dispatchEvent(createCustomEvent('blur', {
                bubbles: false,
            }));
            this.input.writeValue(this.inputValue);
        }
        if (this.inlineEdit) {
            this.keepFocus = this.isOpen;
        }
        this.cdRef.detectChanges();
    };
    TimeDropdownComponent.prototype.onMouseDown = function () {
        if (!this.disabled) {
            this.keepFocus = true;
        }
    };
    TimeDropdownComponent.prototype.applyValue = function () {
        this.input.focus();
        this.currentValue = this.inputValue;
        this.onOpenChange(false);
        this.valueChange.emit(this.inputValue);
    };
    TimeDropdownComponent.prototype.clearValue = function () {
        _super.prototype.clearValue.call(this);
        this.applyValue();
    };
    TimeDropdownComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: TimezonesService },
        { type: ChangeDetectorRef },
        { type: DateTimeService },
        { type: DateTimeValidatorService },
        { type: DynamicTranslations }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TimeDropdownComponent.prototype, "appearance", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], TimeDropdownComponent.prototype, "inlineEdit", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TimeDropdownComponent.prototype, "inputValue", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TimeDropdownComponent.prototype, "dateValue", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], TimeDropdownComponent.prototype, "timePicker", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TimeDropdownComponent.prototype, "timezoneValue", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], TimeDropdownComponent.prototype, "valueChange", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], TimeDropdownComponent.prototype, "dayPeriodChange", void 0);
    __decorate([
        ViewChild('dropdown'),
        __metadata("design:type", DropdownComponent)
    ], TimeDropdownComponent.prototype, "dropdown", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], TimeDropdownComponent.prototype, "disabled", void 0);
    TimeDropdownComponent = __decorate([ __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            TimezonesService,
            ChangeDetectorRef,
            DateTimeService,
            DateTimeValidatorService,
            DynamicTranslations])
    ], TimeDropdownComponent);
TimeDropdownComponent.ɵfac = function TimeDropdownComponent_Factory(t) { return new (t || TimeDropdownComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(TimezonesService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DateTimeService), ɵngcc0.ɵɵdirectiveInject(DateTimeValidatorService), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations)); };
TimeDropdownComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TimeDropdownComponent, selectors: [["cds-time-dropdown"]], viewQuery: function TimeDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c14, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
    } }, inputs: { inputValue: "inputValue", appearance: "appearance", inlineEdit: "inlineEdit", dateValue: "dateValue", timePicker: "timePicker", timezoneValue: "timezoneValue", disabled: "disabled" }, outputs: { valueChange: "valueChange", dayPeriodChange: "dayPeriodChange" }, features: [ɵngcc0.ɵɵProvidersFeature([DynamicTranslations]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [[4, "ngIf"], [1, "cds-date-time-form__time-input"], ["cdsDateInput", "", 1, "cds-control--child", 3, "appearance", "constraints", "format", "dayPeriod", "dateValue", "selected", "ngModel", "label", "placeholder", "readonly", "disabled", "ngModelChange", "mousedown", "blur", "click", "keydown.enter"], ["input", "", "inputModel", "ngModel"], [1, "cds-icon-time", 3, "click"], ["initialFocus", "div.cds-time-picker__column", "class", "cds-date-time-form__dropdown cds-dropdown--auto-height", 3, "anchor", "dismiss", 4, "ngIf"], ["initialFocus", "div.cds-time-picker__column", 1, "cds-date-time-form__dropdown", "cds-dropdown--auto-height", 3, "anchor", "dismiss"], ["dropdown", ""], [1, "cds-date-time-form__scrollable"], [1, "cds-date-time-form__content"], [3, "constraints", "format", "useDayPeriod", "ngModel", "ngModelChange"], ["class", "cds-date-time-form__day-period-combo", 4, "ngIf"], [1, "cds-date-time-form__footer"], ["cdsButton", "", "type", "button", 1, "cds-button-text", 3, "click"], ["cdsButton", "", "type", "button", 1, "cds-button-primary", 3, "disabled", "click"], [1, "cds-date-time-form__day-period-combo"], ["appearance", "inline", 3, "placeholder", "ngModel", "ngModelChange"], ["dayPeriodCombo", ""], ["tabindex", "-1", 3, "cdsComboItem", "labelValue"], [1, "cds-date-time-form__time-combo"], [1, "cds-date-time-form__control", "cds-control--child", 3, "appearance", "required", "label", "placeholder", "ngModel", "cdsInvalid", "disabled", "ngModelChange"], ["timeCombo", ""], ["tabindex", "-1", 3, "cdsComboItem", "labelValue", 4, "ngFor", "ngForOf"]], template: function TimeDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TimeDropdownComponent_ng_container_0_Template, 7, 14, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, TimeDropdownComponent_ng_container_1_Template, 10, 19, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.timePicker);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.timePicker);
    } }, directives: [ɵngcc1.NgIf, InputComponent, DateInputDirective, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DropdownComponent, TimePickerComponent, ButtonRippleDirective, ComboComponent, ComboItemDirective, ɵngcc3.RequiredValidator, InvalidDirective, ɵngcc1.NgForOf], pipes: [TimeControlDisplayHourPipe, TimeControlListPipe], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TimeDropdownComponent, [{
        type: Component,
        args: [{
                selector: 'cds-time-dropdown',
                template: "<ng-container *ngIf=\"timePicker\">\n    <div class=\"cds-date-time-form__time-input\">\n        <cds-input #input #inputModel=\"ngModel\"\n                   [appearance]=\"appearance\"\n                   cdsDateInput\n                   [constraints]=\"getConstraints()\"\n                   class=\"cds-control--child\"\n                   [class.cds-control--required]=\"dateRequired\"\n                   [format]=\"format\"\n                   [dayPeriod]=\"dayPeriod\"\n                   [dateValue]=\"dateValue\"\n                   [selected]=\"keepFocus\"\n                   [ngModel]=\"inputValue\"\n                   (ngModelChange)=\"changeInputValue($event)\"\n                   [label]=\"label\"\n                   [placeholder]=\"placeholder\"\n                   [readonly]=\"!inlineEdit\"\n                   [disabled]=\"disabled\"\n                   (mousedown)=\"onMouseDown()\"\n                   (blur)=\"onBlur()\"\n                   (click)=\"!inlineEdit && onOpenChange(true)\"\n                   (keydown.enter)=\"isOpen ? (inputModel.valid && applyValue()) : onOpenChange(true)\">\n            <a class=\"cds-icon-time\" (click)=\"inlineEdit && onOpenChange(true, $event)\"></a>\n        </cds-input>\n    </div>\n    <cds-dropdown #dropdown *ngIf=\"isOpen\" (dismiss)=\"onOpenChange(false)\" initialFocus=\"div.cds-time-picker__column\" [anchor]=\"input.elementRef\" class=\"cds-date-time-form__dropdown cds-dropdown--auto-height\">\n        <div class=\"cds-date-time-form__scrollable\">\n            <div class=\"cds-date-time-form__content\">\n                <cds-time-picker [constraints]=\"constraints\"\n                                 [format]=\"resolvedFormat\"\n                                 [useDayPeriod]=\"useDayPeriod\"\n                                 [ngModel]=\"timePickerValue\"\n                                 (ngModelChange)=\"changeTimePickerValue($event)\"></cds-time-picker>\n                <div class=\"cds-date-time-form__day-period-combo\" *ngIf=\"useDayPeriod\">\n                    <cds-combo #dayPeriodCombo\n                               appearance=\"inline\"\n                               [placeholder]=\"translations.dayPeriodLabel\"\n                               [ngModel]=\"dayPeriodValue\"\n                               (ngModelChange)=\"changeDayPeriodValue($event)\">\n                        <label>{{dayPeriodCombo.selectedLabel}}</label>\n                        <ul>\n                            <li [cdsComboItem]=\"'AM'\" [labelValue]=\"dayPeriodsTranslation[0]\" tabindex=\"-1\">{{dayPeriodsTranslation[0]}}</li>\n                            <li [cdsComboItem]=\"'PM'\" [labelValue]=\"dayPeriodsTranslation[1]\" tabindex=\"-1\">{{dayPeriodsTranslation[1]}}</li>\n                        </ul>\n                    </cds-combo>\n                </div>\n            </div>\n        </div>\n        <div class=\"cds-date-time-form__footer\">\n            <button cdsButton type=\"button\" class=\"cds-button-text\" (click)=\"clearValue()\" [attr.aria-label]=\"translations.clearButton\">{{translations.clearButton}}</button>\n            <button cdsButton type=\"button\" class=\"cds-button-primary\" (click)=\"applyValue()\" [attr.aria-label]=\"translations.apply\" [disabled]=\"!inputModel.valid\">{{translations.applyButton}}</button>\n        </div>\n    </cds-dropdown>\n</ng-container>\n<ng-container *ngIf=\"!timePicker\">\n    <div class=\"cds-date-time-form__time-combo\">\n        <cds-combo #timeCombo\n                   [appearance]=\"appearance\"\n                   class=\"cds-date-time-form__control cds-control--child\"\n                   [required]=\"dateRequired\"\n                   [class.cds-control--required]=\"dateRequired\"\n                   [label]=\"label\"\n                   [placeholder]=\"placeholder\"\n                   [ngModel]=\"inputValue\"\n                   [cdsInvalid]=\"errors != null\"\n                   [disabled]=\"disabled\"\n                   (ngModelChange)=\"changeInputValue($event)\">\n            <label>{{inputValue | cdsTimeControlDisplayHour:useDayPeriod:format:dayPeriodsTranslation || timeCombo.selectedLabel}}</label>\n            <ul>\n                <li *ngFor=\"let time of inputValue | cdsTimeControlList:constraints\" [cdsComboItem]=\"time\" [labelValue]=\"time\" tabindex=\"-1\">{{time | cdsTimeControlDisplayHour:useDayPeriod:format:dayPeriodsTranslation}}</li>\n            </ul>\n        </cds-combo>\n    </div>\n</ng-container>\n",
                providers: [DynamicTranslations],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: TimezonesService }, { type: ɵngcc0.ChangeDetectorRef }, { type: DateTimeService }, { type: DateTimeValidatorService }, { type: DynamicTranslations }]; }, { inputValue: [{
            type: Input
        }], appearance: [{
            type: Input
        }], inlineEdit: [{
            type: Input
        }], dateValue: [{
            type: Input
        }], timePicker: [{
            type: Input
        }], timezoneValue: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], dayPeriodChange: [{
            type: Output
        }], dropdown: [{
            type: ViewChild,
            args: ['dropdown']
        }], disabled: [{
            type: Input
        }] }); })();
    return TimeDropdownComponent;
}(TimeAbstractControlComponent));

var DateTimeModule = /** @class */ (function () {
    function DateTimeModule() {
    }
DateTimeModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DateTimeModule });
DateTimeModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DateTimeModule_Factory(t) { return new (t || DateTimeModule)(); }, imports: [[
            CalendarModule,
            ComboModule,
            CommonModule,
            DialogModule,
            DropdownModule,
            ErrorsModule,
            FormsModule,
            InputModule,
            ButtonModule,
            TimePickerModule,
            ValidationModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DateTimeModule, { declarations: function () { return [AdjustTimeConstraintsPipe, DateControlComponent, DateDialogComponent, DateDropdownComponent, DateFormComponent, DateInputDirective, DateKeyboardNavigationDirective, DateRangeControlComponent, DateRangeControlComponent, DateRangeDropdownComponent, DateRangeDialogComponent, DateRangeFormComponent, DateRangeInputDirective, TimeControlComponent, TimeControlDisplayHourPipe, TimeControlListPipe, TimeDialogComponent, TimeDropdownComponent, TimeFormComponent, TimezoneControlComponent, TimezoneDirective]; }, imports: function () { return [CalendarModule, ComboModule, CommonModule, DialogModule, DropdownModule, ErrorsModule, FormsModule, InputModule, ButtonModule, TimePickerModule, ValidationModule]; }, exports: function () { return [DateControlComponent, DateFormComponent, DateInputDirective, DateRangeControlComponent, DateRangeFormComponent, DateRangeInputDirective, TimeControlComponent, TimeFormComponent, TimezoneControlComponent, TimezoneDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DateTimeModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CalendarModule,
                    ComboModule,
                    CommonModule,
                    DialogModule,
                    DropdownModule,
                    ErrorsModule,
                    FormsModule,
                    InputModule,
                    ButtonModule,
                    TimePickerModule,
                    ValidationModule,
                ],
                declarations: [
                    AdjustTimeConstraintsPipe,
                    DateControlComponent,
                    DateDialogComponent,
                    DateDropdownComponent,
                    DateFormComponent,
                    DateInputDirective,
                    DateKeyboardNavigationDirective,
                    DateRangeControlComponent,
                    DateRangeControlComponent,
                    DateRangeDropdownComponent,
                    DateRangeDialogComponent,
                    DateRangeFormComponent,
                    DateRangeInputDirective,
                    TimeControlComponent,
                    TimeControlDisplayHourPipe,
                    TimeControlListPipe,
                    TimeDialogComponent,
                    TimeDropdownComponent,
                    TimeFormComponent,
                    TimezoneControlComponent,
                    TimezoneDirective,
                ],
                exports: [
                    DateControlComponent,
                    DateFormComponent,
                    DateInputDirective,
                    DateRangeControlComponent,
                    DateRangeFormComponent,
                    DateRangeInputDirective,
                    TimeControlComponent,
                    TimeFormComponent,
                    TimezoneControlComponent,
                    TimezoneDirective,
                ]
            }]
    }], function () { return []; }, null); })();
    return DateTimeModule;
}());

var DisabledDirective = /** @class */ (function () {
    function DisabledDirective(accessors) {
        if (accessors && accessors.length !== 0) {
            this.accessor = accessors[0];
        }
    }
    DisabledDirective.prototype.ngOnChanges = function (changes) {
        if (this.accessor) {
            var disabledValue = changes['disabled'].currentValue;
            // value is sanitized the same way as in NgModel's disabled attribute
            this.accessor.setDisabledState(disabledValue === '' || (disabledValue && disabledValue !== 'false'));
        }
    };
    DisabledDirective.ctorParameters = function () { return [
        { type: Array, decorators: [{ type: Inject, args: [NG_VALUE_ACCESSOR,] }, { type: Optional }] }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], DisabledDirective.prototype, "disabled", void 0);
    DisabledDirective = __decorate([ __param(0, Inject(NG_VALUE_ACCESSOR)), __param(0, Optional()),
        __metadata("design:paramtypes", [Array])
    ], DisabledDirective);
DisabledDirective.ɵfac = function DisabledDirective_Factory(t) { return new (t || DisabledDirective)(ɵngcc0.ɵɵdirectiveInject(NG_VALUE_ACCESSOR, 8)); };
DisabledDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DisabledDirective, selectors: [["", "disabled", "", 5, "button", 5, "fieldset", 5, "input", 5, "optgroup", 5, "option", 5, "select", 5, "textarea", 3, "ngModel", "", 3, "formControl", "", 3, "formControlName", ""]], inputs: { disabled: "disabled" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DisabledDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[disabled]:not(button):not(fieldset):not(input):not(optgroup):not(option):not(select):not(textarea):not([ngModel]):not([formControl]):not([formControlName])'
            }]
    }], function () { return [{ type: Array, decorators: [{
                type: Inject,
                args: [NG_VALUE_ACCESSOR]
            }, {
                type: Optional
            }] }]; }, { disabled: [{
            type: Input
        }] }); })();
    return DisabledDirective;
}());

var DisabledModule = /** @class */ (function () {
    function DisabledModule() {
    }
DisabledModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DisabledModule });
DisabledModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DisabledModule_Factory(t) { return new (t || DisabledModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DisabledModule, { declarations: [DisabledDirective], exports: [DisabledDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DisabledModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DisabledDirective,
                ],
                exports: [
                    DisabledDirective,
                ]
            }]
    }], function () { return []; }, null); })();
    return DisabledModule;
}());

var NavContext = /** @class */ (function () {
    function NavContext() {
    }
    return NavContext;
}());

var NavItemComponent = /** @class */ (function () {
    function NavItemComponent(rippleService, renderer, elementRef, vcRef) {
        this.rippleService = rippleService;
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.vcRef = vcRef;
        this.expandId = Unique.next('cds-nav-item-');
        renderer.addClass(elementRef.nativeElement, 'cds-nav-item');
    }
    NavItemComponent.prototype.onClick = function (event) {
        if (this.context) {
            var visibility = this.context.getVisibility();
            if (this.expand) {
                this.context.expandNavigation(this.expand, this.expandId, this.elementRef, this.vcRef);
            }
            var hide = visibility === 'visible' && (this.hideOnClick != null ? this.hideOnClick : !this.expand);
            if (hide) {
                this.context.hideDrawer();
            }
        }
    };
    NavItemComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.context && this.context.ripple) {
            this.renderer.addClass(this.elementRef.nativeElement, 'cds-ripple');
            this.rippleService.create(this.elementRef.nativeElement, function () { return _this.elementRef.nativeElement; }, {
                fit: true,
                bounded: true,
            });
        }
    };
    NavItemComponent.prototype.ngOnChanges = function (changes) {
        if ('expand' in changes) {
            if (this.expand) {
                this.renderer.setAttribute(this.elementRef.nativeElement, 'aria-expanded', 'false');
                this.renderer.setAttribute(this.elementRef.nativeElement, 'aria-controls', this.expandId);
                this.renderer.setAttribute(this.elementRef.nativeElement, 'aria-haspopup', 'true');
            }
            else {
                this.renderer.removeAttribute(this.elementRef.nativeElement, 'aria-expanded');
                this.renderer.removeAttribute(this.elementRef.nativeElement, 'aria-controls');
                this.renderer.removeAttribute(this.elementRef.nativeElement, 'aria-haspopup');
            }
        }
    };
    NavItemComponent.ctorParameters = function () { return [
        { type: RippleService },
        { type: Renderer2 },
        { type: ElementRef },
        { type: ViewContainerRef }
    ]; };
    __decorate([
        Input('cdsNavItem'),
        __metadata("design:type", NavContext)
    ], NavItemComponent.prototype, "context", void 0);
    __decorate([
        Input(),
        __metadata("design:type", TemplateRef)
    ], NavItemComponent.prototype, "expand", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], NavItemComponent.prototype, "hideOnClick", void 0);
    __decorate([
        HostListener('click', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [MouseEvent]),
        __metadata("design:returntype", void 0)
    ], NavItemComponent.prototype, "onClick", null);
    NavItemComponent = __decorate([ __metadata("design:paramtypes", [RippleService,
            Renderer2,
            ElementRef,
            ViewContainerRef])
    ], NavItemComponent);
NavItemComponent.ɵfac = function NavItemComponent_Factory(t) { return new (t || NavItemComponent)(ɵngcc0.ɵɵdirectiveInject(RippleService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
NavItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NavItemComponent, selectors: [["", "cdsNavItem", ""]], hostBindings: function NavItemComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function NavItemComponent_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } }, inputs: { context: ["cdsNavItem", "context"], expand: "expand", hideOnClick: "hideOnClick" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], attrs: _c34, ngContentSelectors: _c2, decls: 3, vars: 1, consts: [["tabindex", "-1", 1, "cds-nav-item__content"], [4, "ngIf"], [1, "cds-nav-item__fill"], [1, "cds-nav-item__icon", "cds-icon--size-24", 3, "ngClass"]], template: function NavItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵtemplate(2, NavItemComponent_ng_container_2_Template, 3, 1, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.expand && (ctx.context == null ? null : ctx.context.position) === "side");
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NavItemComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: '[cdsNavItem]',
                template: "<div class=\"cds-nav-item__content\" tabindex=\"-1\">\n\t<ng-content></ng-content>\n\t<ng-container *ngIf=\"expand && context?.position === 'side'\">\n\t\t<span class=\"cds-nav-item__fill\"></span>\n\t\t<span class=\"cds-nav-item__icon cds-icon--size-24\" [ngClass]=\"context?.rotateIcon ? 'cds-icon-angle-down' : 'cds-icon-angle-right'\"></span>\n\t</ng-container>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: RippleService }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.ViewContainerRef }]; }, { onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], context: [{
            type: Input,
            args: ['cdsNavItem']
        }], expand: [{
            type: Input
        }], hideOnClick: [{
            type: Input
        }] }); })();
    return NavItemComponent;
}());

var NavOverlayComponent = /** @class */ (function () {
    function NavOverlayComponent() {
        this.overlay = 'visible';
    }
    __decorate([
        HostBinding('@overlay'),
        __metadata("design:type", String)
    ], NavOverlayComponent.prototype, "overlay", void 0);
NavOverlayComponent.ɵfac = function NavOverlayComponent_Factory(t) { return new (t || NavOverlayComponent)(); };
NavOverlayComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NavOverlayComponent, selectors: [["cds-nav-overlay"]], hostVars: 1, hostBindings: function NavOverlayComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵsyntheticHostProperty("@overlay", ctx.overlay);
    } }, decls: 0, vars: 0, template: function NavOverlayComponent_Template(rf, ctx) { }, encapsulation: 2, data: { animation: [
            trigger('overlay', [
                state('void', style({
                    opacity: 0
                })),
                state('visible', style({
                    opacity: 1
                })),
                transition('* => *', [
                    animate('0.3s ease-out'),
                ]),
            ]),
        ] }, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NavOverlayComponent, [{
        type: Component,
        args: [{
                selector: 'cds-nav-overlay',
                template: '',
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                animations: [
                    trigger('overlay', [
                        state('void', style({
                            opacity: 0
                        })),
                        state('visible', style({
                            opacity: 1
                        })),
                        transition('* => *', [
                            animate('0.3s ease-out'),
                        ]),
                    ]),
                ]
            }]
    }], function () { return []; }, { overlay: [{
            type: HostBinding,
            args: ['@overlay']
        }] }); })();
    return NavOverlayComponent;
}());

var NavModule = /** @class */ (function () {
    function NavModule() {
    }
NavModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NavModule });
NavModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NavModule_Factory(t) { return new (t || NavModule)(); }, imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NavModule, { declarations: function () { return [NavItemComponent, NavOverlayComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NavItemComponent, NavOverlayComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NavModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                ],
                declarations: [
                    NavItemComponent,
                    NavOverlayComponent,
                ],
                exports: [
                    NavItemComponent,
                    NavOverlayComponent,
                ],
                entryComponents: [
                    NavOverlayComponent,
                ]
            }]
    }], function () { return []; }, null); })();
    return NavModule;
}());

var DropdownService = /** @class */ (function () {
    function DropdownService(portal) {
        this.portal = portal;
        this.dropdowns = new Map();
    }
    DropdownService.prototype.open = function (templateRef, options, context) {
        var _this = this;
        var host = this.dropdowns.get(options.anchor);
        if (host) {
            host.destroy();
        }
        var $implicit = {
            anchor: options.anchor,
            dismiss: function () {
                host.destroy();
                _this.dropdowns.delete(options.anchor);
            },
        };
        var view = templateRef.createEmbeddedView(__assign(__assign({}, context), { $implicit: $implicit }));
        if (!options.container) {
            host = this.portal.insertView(view, {
                wrapperClass: 'cds-dropdown-z-index',
            });
        }
        else {
            host = options.container.insert(view);
        }
        this.dropdowns.set(options.anchor, host);
        host.onDestroy(function () {
            _this.dropdowns.delete(options.anchor);
        });
        return host;
    };
    DropdownService.prototype.toggle = function (templateRef, options, context) {
        var host = this.dropdowns.get(options.anchor);
        if (host) {
            host.destroy();
            this.dropdowns.delete(options.anchor);
            return null;
        }
        return this.open(templateRef, options, context);
    };
    DropdownService.prototype.isOpen = function (anchor) {
        return this.dropdowns.has(anchor);
    };
    DropdownService.prototype.closeAll = function () {
        this.dropdowns.forEach(function (host) {
            host.destroy();
        });
    };
    DropdownService.ctorParameters = function () { return [
        { type: RootPortalService }
    ]; };
    DropdownService.ɵprov = ɵɵdefineInjectable({ factory: function DropdownService_Factory() { return new DropdownService(ɵɵinject(RootPortalService)); }, token: DropdownService, providedIn: "root" });
    DropdownService = __decorate([ __metadata("design:paramtypes", [RootPortalService])
    ], DropdownService);
DropdownService.ɵfac = function DropdownService_Factory(t) { return new (t || DropdownService)(ɵngcc0.ɵɵinject(RootPortalService)); };
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DropdownService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: RootPortalService }]; }, null); })();
    return DropdownService;
}());

var DeviceAwareComponent = /** @class */ (function () {
    function DeviceAwareComponent(matchMedia) {
        this.matchMedia = matchMedia;
        this._mode = 'auto';
    }
    Object.defineProperty(DeviceAwareComponent.prototype, "mode", {
        get: function () {
            return this._mode;
        },
        set: function (mode) {
            this._mode = mode;
            if (mode === 'auto') {
                this.createDeviceSubscription();
            }
            else {
                if (this.deviceSubscription) {
                    this.deviceSubscription.unsubscribe();
                    this.deviceSubscription = null;
                }
                this.onDeviceChange(mode || 'desktop', false);
            }
        },
        enumerable: true,
        configurable: true
    });
    DeviceAwareComponent.prototype.onDeviceChange = function (device, subscription) { };
    DeviceAwareComponent.prototype.ngOnInit = function () {
        if (this.mode === 'auto') {
            this.createDeviceSubscription();
        }
    };
    DeviceAwareComponent.prototype.ngOnDestroy = function () {
        if (this.deviceSubscription) {
            this.deviceSubscription.unsubscribe();
        }
    };
    DeviceAwareComponent.prototype.createDeviceSubscription = function () {
        var _this = this;
        if (!this.deviceSubscription) {
            this.deviceSubscription = this.matchMedia.device$.subscribe(function (device) {
                _this.onDeviceChange(device, true);
            });
        }
    };
    DeviceAwareComponent.ctorParameters = function () { return [
        { type: MatchMediaService }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], DeviceAwareComponent.prototype, "mode", null);
    DeviceAwareComponent = __decorate([ __metadata("design:paramtypes", [MatchMediaService])
    ], DeviceAwareComponent);
DeviceAwareComponent.ɵfac = function DeviceAwareComponent_Factory(t) { return new (t || DeviceAwareComponent)(ɵngcc0.ɵɵdirectiveInject(MatchMediaService)); };
DeviceAwareComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DeviceAwareComponent, inputs: { mode: "mode" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DeviceAwareComponent, [{
        type: Directive
    }], function () { return [{ type: MatchMediaService }]; }, { mode: [{
            type: Input
        }] }); })();
    return DeviceAwareComponent;
}());

var NAV_COLUMN_ANIMATIONS = [
    state('hidden', style({
        display: 'none',
        transform: 'translateX(-100%)',
    })),
    state('visible', style({
        transform: 'translateX(0)',
    })),
    state('visible-main', style({
        transform: 'translateX(0)',
    })),
    state('visible-first', style({
        transform: 'translateX(0)',
    })),
    state('void', style({
        transform: 'translateX(100%)',
    })),
    transition('hidden => *, * => hidden, visible => void, void => visible', [
        style({ display: 'initial' }),
        animate('0.3s ease-out'),
    ]),
];

var AUTO_GRID_SIDENAV_ELEMENT = new InjectionToken('AUTO_GRID_SIDENAV_ELEMENT');

var HEADER_TRANSLATIONS_EN = {
    back: 'Back',
    closeMenu: 'Close menu',
    openMenu: 'Open menu',
};
function headerTranslationsFactory() {
    return HEADER_TRANSLATIONS_EN;
}
var CDS_HEADER_TRANSLATIONS = new InjectionToken('CDS_HEADER_TRANSLATIONS', { factory: headerTranslationsFactory });

function autoGridFactory(header) {
    var fn = function () { return header.containerRef; };
    return fn;
}
var AUTO_GRID_PROVIDER = {
    provide: AUTO_GRID_SIDENAV_ELEMENT,
    useFactory: autoGridFactory,
    deps: [forwardRef(function () { return HeaderComponent; })],
};
var RESIZE_DEBOUNCE_TIME = 128;
var RESIZE_ERROR_MARGIN = 8;
function getOuterWidth(element) {
    var styles = window.getComputedStyle(element, null);
    return element.offsetWidth
        + parseInt(styles.getPropertyValue('margin-left'))
        + parseInt(styles.getPropertyValue('margin-right'));
}
var HeaderComponent = /** @class */ (function (_super) {
    __extends(HeaderComponent, _super);
    function HeaderComponent(zone, renderer, element, dropdownService, matchMedia, cdRef, componentTranslations) {
        var _this = _super.call(this, matchMedia) || this;
        _this.zone = zone;
        _this.renderer = renderer;
        _this.element = element;
        _this.dropdownService = dropdownService;
        _this.cdRef = cdRef;
        _this.hamburgerButton = true;
        _this.openSidenav = new EventEmitter();
        _this.detectWrap = false;
        _this.reverseElements = true;
        _this.device = 'desktop';
        _this.toggle = false;
        _this.columns = [];
        _this.navigationId = Unique.next('cds-header-nav-');
        _this.sideId = Unique.next('cds-header-side-');
        _this.megaMenuExpanding = false;
        renderer.addClass(element.nativeElement, 'cds-header');
        renderer.setAttribute(element.nativeElement, 'role', 'banner');
        componentTranslations.use(CDS_HEADER_TRANSLATIONS, headerTranslationsFactory, function (translations) {
            _this.translations = translations;
        });
        return _this;
    }
    Object.defineProperty(HeaderComponent.prototype, "mega", {
        set: function (element) {
            var _this = this;
            if (this.cancelClick) {
                this.cancelClick();
                this.cancelClick = null;
            }
            if (element) {
                this.cancelClick = listen(document, 'click', function (event) {
                    var native = element.nativeElement;
                    if (native.contains(event.target) || _this.megaMenuExpanding) {
                        return;
                    }
                    _this.openMegaMenu(null);
                    _this.cdRef.detectChanges();
                }, { passive: true });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderComponent.prototype, "dark", {
        get: function () {
            return this.schema === 'dark';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderComponent.prototype, "float", {
        get: function () {
            return this.device === 'mobile';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderComponent.prototype, "containerClasses", {
        get: function () {
            return 'cds-header__container ' + (this.containerClass || '');
        },
        enumerable: true,
        configurable: true
    });
    HeaderComponent.prototype.resizeObserver = function () {
        var _this = this;
        if ('ResizeObserver' in window) {
            return new Observable(function (subject) {
                var observer = new window['ResizeObserver'](function (entries) {
                    var e_1, _a;
                    try {
                        for (var entries_1 = __values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
                            var entry = entries_1_1.value;
                            subject.next(entry.contentRect.width);
                            return;
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                });
                observer.observe(_this.wrapperElement.nativeElement);
                return function () {
                    observer.unobserve(_this.wrapperElement.nativeElement);
                };
            }).pipe(sampleTime(RESIZE_DEBOUNCE_TIME));
        }
        else {
            return merge(fromEvent(window, 'resize').pipe(sampleTime(RESIZE_DEBOUNCE_TIME)), fromEvent(window, 'orientationchange')).pipe(map(function () { return _this.wrapperElement.nativeElement.clientWidth; }));
        }
    };
    HeaderComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.accessibleFocus) {
            this.zone.runOutsideAngular(function () {
                _this.resizeSubscription = _this.resizeObserver()
                    .pipe(startWith(_this.wrapperElement.nativeElement.clientWidth), pairwise(), filter(function (_a) {
                    var _b = __read(_a, 2), oldWidth = _b[0], newWidth = _b[1];
                    if (_this.reverseElements) {
                        return newWidth + RESIZE_ERROR_MARGIN > oldWidth;
                    }
                    else {
                        return newWidth - RESIZE_ERROR_MARGIN < oldWidth;
                    }
                }), map(function (_a) {
                    var _b = __read(_a, 2), oldWidth = _b[0], newWidth = _b[1];
                    return newWidth;
                }))
                    .subscribe(function (containerWidth) {
                    _this.updateReverseElements(containerWidth);
                });
            });
        }
    };
    HeaderComponent.prototype.updateReverseElements = function (containerWidth) {
        var _this = this;
        requestAnimationFrame(function () {
            if (!_this.detectWrap) {
                _this.detectWrap = true;
                _this.renderer.addClass(_this.wrapperElement.nativeElement, 'cds-header__wrapper--detect');
            }
            var reverseElements;
            var nav = _this.navElement && _this.navElement.nativeElement;
            if (nav) {
                var before = _this.beforeElement && _this.beforeElement.nativeElement;
                var after = _this.afterElement && _this.afterElement.nativeElement;
                if (before && after) {
                    reverseElements = getOuterWidth(nav) + getOuterWidth(before) + getOuterWidth(after) + RESIZE_ERROR_MARGIN >= containerWidth;
                }
                else {
                    reverseElements = _this.reverseElements;
                }
            }
            else {
                reverseElements = true;
            }
            if (reverseElements !== _this.reverseElements) {
                _this.zone.run(function () {
                    _this.reverseElements = reverseElements;
                    _this.cdRef.detectChanges();
                });
            }
        });
    };
    HeaderComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (this.navigation && !this.topContext) {
            this.topContext = this.createNavContext(this.navigation, 'top', this.navigationId);
            this.sideContext = this.createNavContext(this.navigation, 'side', this.navigationId);
        }
    };
    HeaderComponent.prototype.ngOnChanges = function (changes) {
        if ('navigation' in changes) {
            if (this.navigation) {
                this.topContext = this.createNavContext(this.navigation, 'top', this.navigationId);
                this.sideContext = this.createNavContext(this.navigation, 'side', this.navigationId);
            }
            else {
                this.topContext = this.sideContext = null;
            }
        }
    };
    HeaderComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this.resizeSubscription) {
            this.resizeSubscription.unsubscribe();
        }
    };
    HeaderComponent.prototype.toggleHamburger = function () {
        var toggle = !this.toggle;
        var event = {
            toggle: toggle,
            defaultPrevented: false,
            preventDefault: function () {
                this.defaultPrevented = true;
            },
        };
        this.openSidenav.emit(event);
        if (!event.defaultPrevented) {
            this.columns = [];
            this.toggle = event.toggle;
            this.dropdownService.closeAll();
            this.cdRef.detectChanges();
        }
    };
    HeaderComponent.prototype.back = function () {
        this.columns = this.columns.slice(0, -1);
        this.cdRef.detectChanges();
    };
    HeaderComponent.prototype.onColumnAnimation = function (event) {
        if (event.triggerName === 'column' && (event.toState === 'visible' || event.toState === 'visible-main')) {
            if (isHTMLElement(event.element)) {
                var element_1 = event.element.querySelector('a[tabindex]:not([tabindex|="-"]),a[href]:not([tabindex|="-"]),button:not([tabindex|="-"])');
                if (element_1) {
                    element_1.focus();
                    element_1.classList.add('cds-nav-columns__no-focus');
                    var destroy_1 = listen(element_1, 'blur', function () {
                        element_1.classList.remove('cds-nav-columns__no-focus');
                        destroy_1();
                    });
                }
            }
        }
    };
    HeaderComponent.prototype.onFloatAnimation = function (event) {
        if (event.toState === 'visible') {
            if (isHTMLElement(event.element)) {
                var element = event.element.querySelector('button');
                if (element) {
                    element.focus();
                }
            }
        }
    };
    HeaderComponent.prototype.openMegaMenu = function (context, expandedItem) {
        this.dropdownService.closeAll();
        if (context) {
            if (this.megaExpandedItem) {
                this.setNavItemExpanded(this.megaExpandedItem.nativeElement, false);
            }
            if (expandedItem) {
                this.setNavItemExpanded(expandedItem.nativeElement, true);
            }
            this.megaContext = context;
            this.megaExpandedItem = expandedItem;
        }
        else {
            if (this.megaExpandedItem) {
                this.setNavItemExpanded(this.megaExpandedItem.nativeElement, false);
            }
            this.megaContext = null;
            this.megaExpandedItem = null;
        }
    };
    HeaderComponent.prototype.setNavItemExpanded = function (element, expanded) {
        if (expanded) {
            this.renderer.addClass(element, 'cds-nav-item--expanded');
        }
        else {
            this.renderer.removeClass(element, 'cds-nav-item--expanded');
        }
        this.renderer.setAttribute(element, 'aria-expanded', "" + expanded);
    };
    HeaderComponent.prototype.onDeviceChange = function (device, subscription) {
        var _this = this;
        /**
         * MatchMediaService may not necessarily run onDeviceChange() callback in Angular zone.
         * Should you require it running in the zone, use NgZone.run() explicitly.
         */
        this.zone.run(function () {
            _this.device = device;
            _this.toggle = false;
            _this.columns = [];
            _this.openMegaMenu(null);
            if (subscription) {
                _this.cdRef.markForCheck();
                _this.cdRef.detectChanges();
            }
        });
    };
    HeaderComponent.prototype.createNavContext = function (template, position, id) {
        var _this = this;
        var context = {
            id: id,
            template: template,
            position: position,
            ripple: position === 'side',
            expandNavigation: function (nextTemplate, id, elementRef) {
                if (position === 'side') {
                    var index = _this.columns.findIndex(function (context) { return context.template === nextTemplate; });
                    if (index !== -1) {
                        return;
                    }
                    if (template === _this.navigation) {
                        _this.columns = [_this.createNavContext(nextTemplate, position, id)];
                    }
                    else {
                        _this.columns = __spread(_this.columns, [_this.createNavContext(nextTemplate, position, id)]);
                    }
                    _this.cdRef.detectChanges();
                }
                else if (position === 'top') {
                    if (_this.megaContext && _this.megaContext.template === nextTemplate) {
                        _this.openMegaMenu(null);
                    }
                    else {
                        _this.openMegaMenu(_this.createNavContext(nextTemplate, 'mega', id), elementRef);
                        _this.megaMenuExpanding = true;
                        setTimeout(function () {
                            _this.megaMenuExpanding = false;
                        });
                    }
                    _this.cdRef.detectChanges();
                }
            },
            hideDrawer: function () {
                _this.columns = [];
                _this.toggle = false;
                _this.openMegaMenu(null);
                _this.cdRef.detectChanges();
            },
            getVisibility: function () { return 'visible'; },
            requestVisibilityChange: function () { return false; },
        };
        return context;
    };
    HeaderComponent.ctorParameters = function () { return [
        { type: NgZone },
        { type: Renderer2 },
        { type: ElementRef },
        { type: DropdownService },
        { type: MatchMediaService },
        { type: ChangeDetectorRef },
        { type: DynamicTranslations }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], HeaderComponent.prototype, "schema", void 0);
    __decorate([
        Input(),
        __metadata("design:type", TemplateRef)
    ], HeaderComponent.prototype, "navigation", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], HeaderComponent.prototype, "containerClass", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], HeaderComponent.prototype, "autoGridSidenav", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], HeaderComponent.prototype, "overlay", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], HeaderComponent.prototype, "hamburgerButton", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], HeaderComponent.prototype, "accessibleFocus", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], HeaderComponent.prototype, "openSidenav", void 0);
    __decorate([
        ViewChild('container', { static: true }),
        __metadata("design:type", ElementRef)
    ], HeaderComponent.prototype, "containerRef", void 0);
    __decorate([
        ContentChild('brand', { static: true, read: TemplateRef }),
        __metadata("design:type", TemplateRef)
    ], HeaderComponent.prototype, "brandRef", void 0);
    __decorate([
        ContentChild('extra', { static: true, read: TemplateRef }),
        __metadata("design:type", TemplateRef)
    ], HeaderComponent.prototype, "extraRef", void 0);
    __decorate([
        ContentChild('footer', { static: true, read: TemplateRef }),
        __metadata("design:type", TemplateRef)
    ], HeaderComponent.prototype, "footerRef", void 0);
    __decorate([
        ViewChild('wrapperElement', { static: true }),
        __metadata("design:type", ElementRef)
    ], HeaderComponent.prototype, "wrapperElement", void 0);
    __decorate([
        ViewChild('beforeElement'),
        __metadata("design:type", ElementRef)
    ], HeaderComponent.prototype, "beforeElement", void 0);
    __decorate([
        ViewChild('navElement'),
        __metadata("design:type", ElementRef)
    ], HeaderComponent.prototype, "navElement", void 0);
    __decorate([
        ViewChild('afterElement'),
        __metadata("design:type", ElementRef)
    ], HeaderComponent.prototype, "afterElement", void 0);
    __decorate([
        ViewChild('mega'),
        __metadata("design:type", ElementRef),
        __metadata("design:paramtypes", [ElementRef])
    ], HeaderComponent.prototype, "mega", null);
    __decorate([
        HostBinding('class.cds-header--dark'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], HeaderComponent.prototype, "dark", null);
    HeaderComponent = __decorate([ __metadata("design:paramtypes", [NgZone,
            Renderer2,
            ElementRef,
            DropdownService,
            MatchMediaService,
            ChangeDetectorRef,
            DynamicTranslations])
    ], HeaderComponent);
HeaderComponent.ɵfac = function HeaderComponent_Factory(t) { return new (t || HeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(DropdownService), ɵngcc0.ɵɵdirectiveInject(MatchMediaService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations)); };
HeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: HeaderComponent, selectors: [["cds-header"]], contentQueries: function HeaderComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, _c35, true, TemplateRef);
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, _c36, true, TemplateRef);
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, _c37, true, TemplateRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.brandRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.extraRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.footerRef = _t.first);
    } }, viewQuery: function HeaderComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c38, true);
        ɵngcc0.ɵɵstaticViewQuery(_c39, true);
        ɵngcc0.ɵɵstaticViewQuery(_c40, true);
        ɵngcc0.ɵɵviewQuery(_c41, true);
        ɵngcc0.ɵɵviewQuery(_c42, true);
        ɵngcc0.ɵɵviewQuery(_c43, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.mega = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.containerRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.wrapperElement = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.beforeElement = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.navElement = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.afterElement = _t.first);
    } }, hostVars: 2, hostBindings: function HeaderComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("cds-header--dark", ctx.dark);
    } }, inputs: { schema: "schema", navigation: "navigation", containerClass: "containerClass", autoGridSidenav: "autoGridSidenav", overlay: "overlay", hamburgerButton: "hamburgerButton", accessibleFocus: "accessibleFocus" }, outputs: { openSidenav: "openSidenav" }, features: [ɵngcc0.ɵɵProvidersFeature([AUTO_GRID_PROVIDER, DynamicTranslations]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c49, decls: 20, vars: 22, consts: [["after", ""], [1, "cds-header__background", "cds-header-top-menu-z-index"], [3, "ngClass"], ["container", ""], [1, "cds-header__wrapper"], ["wrapperElement", ""], ["class", "cds-header__hamburger", 4, "ngIf"], [1, "cds-header__before"], ["beforeElement", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["afterRef", ""], ["navRef", ""], [4, "ngFor", "ngForOf"], ["class", "cds-header__mega cds-header-mega-menu-z-index", 4, "ngIf"], ["class", "cds-header__float-overlay cds-header-overlay-z-index", 3, "click", 4, "ngIf"], ["class", "cds-header__float-menu cds-header-side-menu-z-index", 4, "ngIf"], [1, "cds-header__hamburger"], ["cdsButton", "", "aria-haspopup", "menu", 3, "ngClass", "click"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 24 24", "focusable", "false"], ["d", "M4 18h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-5h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 7c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z"], [1, "cds-header__after"], ["afterElement", ""], [1, "cds-header__nav-wrapper"], ["class", "cds-header__nav", 4, "ngIf"], [1, "cds-header__nav"], ["navElement", ""], [3, "ngTemplateOutlet"], [1, "cds-header__mega", "cds-header-mega-menu-z-index"], ["mega", ""], [1, "cds-header__float-overlay", "cds-header-overlay-z-index", 3, "click"], [1, "cds-header__float-menu", "cds-header-side-menu-z-index"], [1, "cds-header__float-header"], ["class", "cds-header__float-close", 4, "ngIf"], [1, "cds-header__float-after"], [1, "cds-nav-columns"], [1, "cds-nav-columns__column"], [1, "cds-nav-columns__items", "cds-nav-columns__items--no-icons"], ["class", "cds-nav-columns__column", 4, "ngFor", "ngForOf"], ["class", "cds-nav-footer", 4, "ngIf"], [1, "cds-header__float-close"], ["cdsButton", "", "aria-expanded", "true", "aria-haspopup", "menu", 1, "cds-button-icon", 3, "click"], [1, "cds-icon-close-big", "cds-icon--size-24"], [1, "cds-nav-columns__header"], ["cdsRipple", "", "aria-expanded", "true", "aria-haspopup", "menu", 1, "cds-nav-columns__back", 3, "click"], ["viewBox", "0 0 32 32", "focusable", "false"], ["d", "M7.7 15h20.255c.577 0 1.045.448 1.045 1s-.468 1-1.045 1H7.7l4.97 5.049c.44.446.44 1.17 0 1.616a1.113 1.113 0 0 1-1.59 0l-6.75-6.857a1.156 1.156 0 0 1 0-1.616l6.75-6.857a1.113 1.113 0 0 1 1.59 0c.44.446.44 1.17 0 1.616L7.7 15z"], [1, "cds-nav-columns__items", "cds-nav-columns__items--no-icons", "cds-nav-columns__items--sub"], [1, "cds-nav-footer"]], template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c47);
        ɵngcc0.ɵɵtemplate(0, HeaderComponent_ng_template_0_Template, 1, 0, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "div", 2, 3);
        ɵngcc0.ɵɵelementStart(5, "div", 4, 5);
        ɵngcc0.ɵɵtemplate(7, HeaderComponent_div_7_Template, 4, 4, "div", 6);
        ɵngcc0.ɵɵelementStart(8, "div", 7, 8);
        ɵngcc0.ɵɵelementContainer(10, 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, HeaderComponent_ng_template_11_Template, 3, 4, "ng-template", null, 10, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(13, HeaderComponent_ng_template_13_Template, 2, 1, "ng-template", null, 11, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(15, HeaderComponent_ng_container_15_Template, 2, 1, "ng-container", 12);
        ɵngcc0.ɵɵpipe(16, "cdsReverseElements");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(17, HeaderComponent_div_17_Template, 3, 6, "div", 13);
        ɵngcc0.ɵɵtemplate(18, HeaderComponent_cds_nav_overlay_18_Template, 1, 0, "cds-nav-overlay", 14);
        ɵngcc0.ɵɵtemplate(19, HeaderComponent_div_19_Template, 11, 14, "div", 15);
    } if (rf & 2) {
        var _r6 = ɵngcc0.ɵɵreference(12);
        var _r8 = ɵngcc0.ɵɵreference(14);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ctx.containerClasses);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("cds-header__wrapper--float", ctx.float)("cds-header__wrapper--detect", ctx.detectWrap)("cds-header__wrapper--reverse", ctx.reverseElements);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.float && ctx.hamburgerButton);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.brandRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(17, _c44, ctx.device));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind2(16, 14, ɵngcc0.ɵɵpureFunction2(19, _c48, _r8, _r6), ctx.reverseElements));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.megaContext);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.overlay && ctx.float && ctx.toggle);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.float && ctx.toggle);
    } }, directives: function () { return [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgForOf, ButtonRippleDirective, NavOverlayComponent, RippleDirective]; }, pipes: function () { return [ReverseElementsPipe]; }, encapsulation: 2, data: { animation: [
            trigger('column', NAV_COLUMN_ANIMATIONS),
            trigger('float', [
                state('void', style({
                    transform: 'translate(-100%, 0)'
                })),
                state('hidden', style({
                    transform: 'translate(-100%, 0)'
                })),
                state('visible', style({
                    transform: 'translate(0, 0)'
                })),
                transition('* => *', [
                    animate('0.3s ease-out'),
                ]),
            ]),
            trigger('mega', [
                state('void', style({
                    opacity: 0,
                    transform: 'translate(0, -30%)'
                })),
                state('visible', style({
                    opacity: 1,
                    transform: 'translate(0, 0)'
                })),
                transition('* => *', [
                    animate('0.2s ease-out'),
                ]),
            ]),
        ] }, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{
                selector: 'cds-header',
                template: "<ng-template #after><ng-content select=\"after\"></ng-content></ng-template>\n<div class=\"cds-header__background cds-header-top-menu-z-index\">\n\t<div #container [ngClass]=\"containerClasses\">\n\t\t<div class=\"cds-header__wrapper\"\n\t\t     #wrapperElement\n\t\t     [class.cds-header__wrapper--float]=\"float\"\n\t\t     [class.cds-header__wrapper--detect]=\"detectWrap\"\n\t\t     [class.cds-header__wrapper--reverse]=\"reverseElements\">\n\t\t\t<div *ngIf=\"float && hamburgerButton\" class=\"cds-header__hamburger\">\n\t\t\t\t<button cdsButton [ngClass]=\"schema === 'dark' ? 'cds-button-icon-dark' : 'cds-button-icon'\" (click)=\"toggleHamburger()\"\n\t\t\t\t        [attr.aria-expanded]=\"float && toggle\" [attr.aria-controls]=\"sideId\" [attr.aria-label]=\"translations.openMenu\" aria-haspopup=\"menu\">\n\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" focusable=\"false\">\n\t\t\t\t\t\t<path d=\"M4 18h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-5h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 7c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z\" />\n\t\t\t\t\t</svg>\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t\t<div class=\"cds-header__before\" #beforeElement><ng-container [ngTemplateOutlet]=\"brandRef\" [ngTemplateOutletContext]=\"{ position: 'top', device: device }\"></ng-container></div>\n\t\t\t<ng-template #afterRef>\n\t\t\t\t<div class=\"cds-header__after\" #afterElement><ng-container [ngTemplateOutlet]=\"extraRef\" [ngTemplateOutletContext]=\"{ position: 'top', device: device }\"></ng-container></div>\n\t\t\t</ng-template>\n\t\t\t<ng-template #navRef>\n\t\t\t\t<div class=\"cds-header__nav-wrapper\">\n\t\t\t\t\t<nav class=\"cds-header__nav\" #navElement *ngIf=\"!float\"><ng-container [ngTemplateOutlet]=\"navigation\" [ngTemplateOutletContext]=\"{ $implicit: topContext }\"></ng-container></nav>\n\t\t\t\t</div>\n\t\t\t</ng-template>\n\t\t\t<ng-container *ngFor=\"let template of [navRef, afterRef] | cdsReverseElements:reverseElements\">\n\t\t\t\t<ng-container [ngTemplateOutlet]=\"template\"></ng-container>\n\t\t\t</ng-container>\n\t\t</div>\n\t</div>\n</div>\n<div [attr.id]=\"megaContext.id\" class=\"cds-header__mega cds-header-mega-menu-z-index\" #mega  *ngIf=\"megaContext\" [@mega]=\"'visible'\">\n\t<ng-container [ngTemplateOutlet]=\"megaContext.template\" [ngTemplateOutletContext]=\"{ $implicit: megaContext }\"></ng-container>\n</div>\n<cds-nav-overlay class=\"cds-header__float-overlay cds-header-overlay-z-index\" *ngIf=\"overlay && float && toggle\" (click)=\"toggleHamburger()\"></cds-nav-overlay>\n<div [attr.id]=\"sideId\" class=\"cds-header__float-menu cds-header-side-menu-z-index\" *ngIf=\"float && toggle\" [@float]=\"'visible'\" (@float.done)=\"onFloatAnimation($event)\">\n\t<div class=\"cds-header__float-header\">\n\t\t<div class=\"cds-header__float-close\" *ngIf=\"navigation\">\n\t\t\t<button cdsButton class=\"cds-button-icon\" (click)=\"toggleHamburger()\"\n\t\t\t        aria-expanded=\"true\" [attr.aria-controls]=\"sideId\" [attr.aria-label]=\"translations.closeMenu\" aria-haspopup=\"menu\">\n\t\t\t\t<i class=\"cds-icon-close-big cds-icon--size-24\"></i>\n\t\t\t</button>\n\t\t</div>\n\t\t<div class=\"cds-header__float-after\"><ng-container [ngTemplateOutlet]=\"extraRef\" [ngTemplateOutletContext]=\"{ position: 'side', device: device }\"></ng-container></div>\n\t</div>\n\t<div class=\"cds-nav-columns\">\n\t\t<div class=\"cds-nav-columns__column\" [@column]=\"columns.length === 0 ? 'visible-main' : 'hidden'\" (@column.done)=\"onColumnAnimation($event)\">\n\t\t\t<div class=\"cds-nav-columns__items cds-nav-columns__items--no-icons\">\n\t\t\t\t<ng-container [ngTemplateOutlet]=\"navigation\" [ngTemplateOutletContext]=\"{ $implicit: sideContext }\"></ng-container>\n\t\t\t</div>\n\t\t</div>\n\t\t<div *ngFor=\"let column of columns; let last=last\"\n\t\t     [attr.id]=\"column.id\" class=\"cds-nav-columns__column\"\n\t\t     [@column]=\"last ? 'visible' : 'hidden'\"\n\t\t     (@column.done)=\"onColumnAnimation($event)\">\n\t\t\t<div class=\"cds-nav-columns__header\">\n\t\t\t\t<button cdsRipple class=\"cds-nav-columns__back\" (click)=\"back()\" aria-expanded=\"true\" aria-haspopup=\"menu\" [attr.aria-controls]=\"column.id\">\n\t\t\t\t\t<svg viewBox=\"0 0 32 32\" focusable=\"false\">\n\t\t\t\t\t\t<path d=\"M7.7 15h20.255c.577 0 1.045.448 1.045 1s-.468 1-1.045 1H7.7l4.97 5.049c.44.446.44 1.17 0 1.616a1.113 1.113 0 0 1-1.59 0l-6.75-6.857a1.156 1.156 0 0 1 0-1.616l6.75-6.857a1.113 1.113 0 0 1 1.59 0c.44.446.44 1.17 0 1.616L7.7 15z\"></path>\n\t\t\t\t\t</svg>\n\t\t\t\t\t{{translations.back}}\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t\t<div class=\"cds-nav-columns__items cds-nav-columns__items--no-icons cds-nav-columns__items--sub\">\n\t\t\t\t<ng-container [ngTemplateOutlet]=\"column.template\" [ngTemplateOutletContext]=\"{ $implicit: column }\"></ng-container>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div *ngIf=\"footerRef\" class=\"cds-nav-footer\">\n\t\t<ng-container [ngTemplateOutlet]=\"footerRef\" [ngTemplateOutletContext]=\"{ position: 'side', device: device }\"></ng-container>\n\t</div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                providers: [AUTO_GRID_PROVIDER, DynamicTranslations],
                animations: [
                    trigger('column', NAV_COLUMN_ANIMATIONS),
                    trigger('float', [
                        state('void', style({
                            transform: 'translate(-100%, 0)'
                        })),
                        state('hidden', style({
                            transform: 'translate(-100%, 0)'
                        })),
                        state('visible', style({
                            transform: 'translate(0, 0)'
                        })),
                        transition('* => *', [
                            animate('0.3s ease-out'),
                        ]),
                    ]),
                    trigger('mega', [
                        state('void', style({
                            opacity: 0,
                            transform: 'translate(0, -30%)'
                        })),
                        state('visible', style({
                            opacity: 1,
                            transform: 'translate(0, 0)'
                        })),
                        transition('* => *', [
                            animate('0.2s ease-out'),
                        ]),
                    ]),
                ]
            }]
    }], function () { return [{ type: ɵngcc0.NgZone }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: DropdownService }, { type: MatchMediaService }, { type: ɵngcc0.ChangeDetectorRef }, { type: DynamicTranslations }]; }, { mega: [{
            type: ViewChild,
            args: ['mega']
        }], dark: [{
            type: HostBinding,
            args: ['class.cds-header--dark']
        }], schema: [{
            type: Input
        }], navigation: [{
            type: Input
        }], containerClass: [{
            type: Input
        }], autoGridSidenav: [{
            type: Input
        }], overlay: [{
            type: Input
        }], hamburgerButton: [{
            type: Input
        }], accessibleFocus: [{
            type: Input
        }], openSidenav: [{
            type: Output
        }], containerRef: [{
            type: ViewChild,
            args: ['container', { static: true }]
        }], brandRef: [{
            type: ContentChild,
            args: ['brand', { static: true, read: TemplateRef }]
        }], extraRef: [{
            type: ContentChild,
            args: ['extra', { static: true, read: TemplateRef }]
        }], footerRef: [{
            type: ContentChild,
            args: ['footer', { static: true, read: TemplateRef }]
        }], wrapperElement: [{
            type: ViewChild,
            args: ['wrapperElement', { static: true }]
        }], beforeElement: [{
            type: ViewChild,
            args: ['beforeElement']
        }], navElement: [{
            type: ViewChild,
            args: ['navElement']
        }], afterElement: [{
            type: ViewChild,
            args: ['afterElement']
        }] }); })();
    return HeaderComponent;
}(DeviceAwareComponent));

var ReverseElementsPipe = /** @class */ (function () {
    function ReverseElementsPipe() {
    }
    ReverseElementsPipe.prototype.transform = function (value, reverse) {
        if (reverse) {
            return [value[1], value[0]];
        }
        else {
            return value;
        }
    };
ReverseElementsPipe.ɵfac = function ReverseElementsPipe_Factory(t) { return new (t || ReverseElementsPipe)(); };
ReverseElementsPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "cdsReverseElements", type: ReverseElementsPipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ReverseElementsPipe, [{
        type: Pipe,
        args: [{
                name: 'cdsReverseElements'
            }]
    }], function () { return []; }, null); })();
    return ReverseElementsPipe;
}());

var HeaderModule = /** @class */ (function () {
    function HeaderModule() {
    }
HeaderModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: HeaderModule });
HeaderModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function HeaderModule_Factory(t) { return new (t || HeaderModule)(); }, imports: [[
            CommonModule,
            NavModule,
            PortalModule,
            RippleModule,
            ButtonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(HeaderModule, { declarations: function () { return [HeaderComponent, ReverseElementsPipe]; }, imports: function () { return [CommonModule, NavModule, PortalModule, RippleModule, ButtonModule]; }, exports: function () { return [HeaderComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HeaderModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    NavModule,
                    PortalModule,
                    RippleModule,
                    ButtonModule,
                ],
                declarations: [
                    HeaderComponent,
                    ReverseElementsPipe,
                ],
                exports: [
                    HeaderComponent,
                ]
            }]
    }], function () { return []; }, null); })();
    return HeaderModule;
}());

var StatusIndicatorDirective = /** @class */ (function () {
    function StatusIndicatorDirective(elementRef, renderer) {
        renderer.addClass(elementRef.nativeElement, 'cds-status-indicator');
    }
    Object.defineProperty(StatusIndicatorDirective.prototype, "classSuccess", {
        get: function () {
            return this.status === 'success';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StatusIndicatorDirective.prototype, "classDanger", {
        get: function () {
            return this.status === 'danger';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StatusIndicatorDirective.prototype, "classWarning", {
        get: function () {
            return this.status === 'warning';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StatusIndicatorDirective.prototype, "classInfo", {
        get: function () {
            return this.status === 'info';
        },
        enumerable: true,
        configurable: true
    });
    StatusIndicatorDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
    __decorate([
        HostBinding('class.cds-status-indicator--success'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], StatusIndicatorDirective.prototype, "classSuccess", null);
    __decorate([
        HostBinding('class.cds-status-indicator--danger'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], StatusIndicatorDirective.prototype, "classDanger", null);
    __decorate([
        HostBinding('class.cds-status-indicator--warning'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], StatusIndicatorDirective.prototype, "classWarning", null);
    __decorate([
        HostBinding('class.cds-status-indicator--info'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], StatusIndicatorDirective.prototype, "classInfo", null);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], StatusIndicatorDirective.prototype, "status", void 0);
    StatusIndicatorDirective = __decorate([ __metadata("design:paramtypes", [ElementRef, Renderer2])
    ], StatusIndicatorDirective);
StatusIndicatorDirective.ɵfac = function StatusIndicatorDirective_Factory(t) { return new (t || StatusIndicatorDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
StatusIndicatorDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: StatusIndicatorDirective, selectors: [["cds-status-indicator"]], hostVars: 8, hostBindings: function StatusIndicatorDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("cds-status-indicator--success", ctx.classSuccess)("cds-status-indicator--danger", ctx.classDanger)("cds-status-indicator--warning", ctx.classWarning)("cds-status-indicator--info", ctx.classInfo);
    } }, inputs: { status: "status" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StatusIndicatorDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'cds-status-indicator'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { classSuccess: [{
            type: HostBinding,
            args: ['class.cds-status-indicator--success']
        }], classDanger: [{
            type: HostBinding,
            args: ['class.cds-status-indicator--danger']
        }], classWarning: [{
            type: HostBinding,
            args: ['class.cds-status-indicator--warning']
        }], classInfo: [{
            type: HostBinding,
            args: ['class.cds-status-indicator--info']
        }], status: [{
            type: Input
        }] }); })();
    return StatusIndicatorDirective;
}());

var TrendIndicatorComponent = /** @class */ (function () {
    function TrendIndicatorComponent(renderer, element) {
        this.trend = 'stable';
        this.trends = {
            growing: 'cds-icon-arrow-up',
            falling: 'cds-icon-arrow-down',
            stable: '',
        };
        renderer.addClass(element.nativeElement, 'cds-trend-indicator');
    }
    Object.defineProperty(TrendIndicatorComponent.prototype, "classFalling", {
        get: function () {
            return this.trend === 'falling';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TrendIndicatorComponent.prototype, "classGrowing", {
        get: function () {
            return this.trend === 'growing';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TrendIndicatorComponent.prototype, "classStable", {
        get: function () {
            return this.trend === 'stable';
        },
        enumerable: true,
        configurable: true
    });
    TrendIndicatorComponent.prototype.getTrendIconClass = function () {
        return this.trends["" + this.trend];
    };
    TrendIndicatorComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef }
    ]; };
    __decorate([
        HostBinding('class.cds-trend--falling'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], TrendIndicatorComponent.prototype, "classFalling", null);
    __decorate([
        HostBinding('class.cds-trend--growing'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], TrendIndicatorComponent.prototype, "classGrowing", null);
    __decorate([
        HostBinding('class.cds-trend--stable'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], TrendIndicatorComponent.prototype, "classStable", null);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TrendIndicatorComponent.prototype, "trend", void 0);
    TrendIndicatorComponent = __decorate([ __metadata("design:paramtypes", [Renderer2, ElementRef])
    ], TrendIndicatorComponent);
TrendIndicatorComponent.ɵfac = function TrendIndicatorComponent_Factory(t) { return new (t || TrendIndicatorComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
TrendIndicatorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TrendIndicatorComponent, selectors: [["cds-trend-indicator"]], hostVars: 6, hostBindings: function TrendIndicatorComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("cds-trend--falling", ctx.classFalling)("cds-trend--growing", ctx.classGrowing)("cds-trend--stable", ctx.classStable);
    } }, inputs: { trend: "trend" }, ngContentSelectors: _c2, decls: 2, vars: 1, consts: [["aria-hidden", "true", 1, "cds-trend-indicator__icon", 3, "ngClass"]], template: function TrendIndicatorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelement(0, "i", 0);
        ɵngcc0.ɵɵprojection(1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.getTrendIconClass());
    } }, directives: [ɵngcc1.NgClass], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TrendIndicatorComponent, [{
        type: Component,
        args: [{
                selector: 'cds-trend-indicator',
                template: "<i aria-hidden=\"true\" class=\"cds-trend-indicator__icon\" [ngClass]=\"getTrendIconClass()\"></i>\n<ng-content></ng-content>",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { trend: [{
            type: Input
        }], classFalling: [{
            type: HostBinding,
            args: ['class.cds-trend--falling']
        }], classGrowing: [{
            type: HostBinding,
            args: ['class.cds-trend--growing']
        }], classStable: [{
            type: HostBinding,
            args: ['class.cds-trend--stable']
        }] }); })();
    return TrendIndicatorComponent;
}());

var ProgressBarComponent = /** @class */ (function () {
    function ProgressBarComponent(elementRef, renderer) {
        this.progress = 0;
        renderer.addClass(elementRef.nativeElement, 'cds-progress-bar');
        renderer.setAttribute(elementRef.nativeElement, 'role', 'progressbar');
        renderer.setAttribute(elementRef.nativeElement, 'aria-valuemin', '0');
        renderer.setAttribute(elementRef.nativeElement, 'aria-valuemax', '100');
    }
    ProgressBarComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
    __decorate([
        Input(),
        HostBinding('attr.aria-valuenow'),
        __metadata("design:type", Number)
    ], ProgressBarComponent.prototype, "progress", void 0);
    ProgressBarComponent = __decorate([ __metadata("design:paramtypes", [ElementRef, Renderer2])
    ], ProgressBarComponent);
ProgressBarComponent.ɵfac = function ProgressBarComponent_Factory(t) { return new (t || ProgressBarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
ProgressBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ProgressBarComponent, selectors: [["cds-progress-bar"]], hostVars: 1, hostBindings: function ProgressBarComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-valuenow", ctx.progress);
    } }, inputs: { progress: "progress" }, decls: 1, vars: 2, consts: [[1, "cds-progress-bar__progress"]], template: function ProgressBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "span", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("width", ctx.progress, "%");
    } }, encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ProgressBarComponent, [{
        type: Component,
        args: [{
                selector: 'cds-progress-bar',
                template: "<span class=\"cds-progress-bar__progress\" [style.width.%]=\"progress\"></span>",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { progress: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.aria-valuenow']
        }] }); })();
    return ProgressBarComponent;
}());

var ProgressSpinnerComponent = /** @class */ (function () {
    function ProgressSpinnerComponent(elementRef, renderer) {
        this.progress = 0;
        this.radius = 0.45;
        this.maxDashArray = this.radius * 2 * Math.PI;
        renderer.addClass(elementRef.nativeElement, 'cds-progress-spinner');
        renderer.setAttribute(elementRef.nativeElement, 'role', 'progressbar');
        renderer.setAttribute(elementRef.nativeElement, 'aria-valuemin', '0');
        renderer.setAttribute(elementRef.nativeElement, 'aria-valuemax', '100');
    }
    ProgressSpinnerComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
    __decorate([
        Input(),
        HostBinding('attr.aria-valuenow'),
        __metadata("design:type", Number)
    ], ProgressSpinnerComponent.prototype, "progress", void 0);
    ProgressSpinnerComponent = __decorate([ __metadata("design:paramtypes", [ElementRef, Renderer2])
    ], ProgressSpinnerComponent);
ProgressSpinnerComponent.ɵfac = function ProgressSpinnerComponent_Factory(t) { return new (t || ProgressSpinnerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
ProgressSpinnerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ProgressSpinnerComponent, selectors: [["cds-progress-spinner"]], hostVars: 1, hostBindings: function ProgressSpinnerComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-valuenow", ctx.progress);
    } }, inputs: { progress: "progress" }, decls: 3, vars: 5, consts: [["viewBox", "0 0 1 1", "focusable", "false"], ["cx", "50%", "cy", "50%", 1, "cds-progress-spinner__circle", "cds-progress-spinner__background"], ["cx", "50%", "cy", "50%", 1, "cds-progress-spinner__circle", "cds-progress-spinner__progress"]], template: function ProgressSpinnerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "circle", 1);
        ɵngcc0.ɵɵelement(2, "circle", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("stroke-dasharray", ctx.maxDashArray)("r", ctx.radius);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("stroke-dasharray", ctx.maxDashArray)("r", ctx.radius)("stroke-dashoffset", ctx.maxDashArray - ctx.maxDashArray * ctx.progress / 100 || undefined);
    } }, encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ProgressSpinnerComponent, [{
        type: Component,
        args: [{
                selector: 'cds-progress-spinner',
                template: "<svg viewBox=\"0 0 1 1\" focusable=\"false\">\n\t<circle [attr.stroke-dasharray]=\"maxDashArray\" [attr.r]=\"radius\" cx=\"50%\" cy=\"50%\"\n\t        class=\"cds-progress-spinner__circle cds-progress-spinner__background\"></circle>\n\t<circle [attr.stroke-dasharray]=\"maxDashArray\" [attr.r]=\"radius\" cx=\"50%\" cy=\"50%\"\n\t\t\t[attr.stroke-dashoffset]=\"maxDashArray - (maxDashArray * progress / 100) || undefined\"\n\t\t\tclass=\"cds-progress-spinner__circle cds-progress-spinner__progress\"></circle>\n</svg>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { progress: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.aria-valuenow']
        }] }); })();
    return ProgressSpinnerComponent;
}());

var IndicatorModule = /** @class */ (function () {
    function IndicatorModule() {
    }
IndicatorModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: IndicatorModule });
IndicatorModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function IndicatorModule_Factory(t) { return new (t || IndicatorModule)(); }, imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(IndicatorModule, { declarations: function () { return [StatusIndicatorDirective, ProgressBarComponent, ProgressSpinnerComponent, TrendIndicatorComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [StatusIndicatorDirective, ProgressBarComponent, ProgressSpinnerComponent, TrendIndicatorComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(IndicatorModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                ],
                declarations: [
                    StatusIndicatorDirective,
                    ProgressBarComponent,
                    ProgressSpinnerComponent,
                    TrendIndicatorComponent,
                ],
                exports: [
                    StatusIndicatorDirective,
                    ProgressBarComponent,
                    ProgressSpinnerComponent,
                    TrendIndicatorComponent,
                ]
            }]
    }], function () { return []; }, null); })();
    return IndicatorModule;
}());

var CDS_SIDENAV_EXPANDED_TEMPLATE = new InjectionToken('CDS_SIDENAV_EXPANDED_TEMPLATE');
var SidenavExpandedComponent = /** @class */ (function () {
    function SidenavExpandedComponent(template, context) {
        this.template = template;
        this.context = context;
    }
    SidenavExpandedComponent.ctorParameters = function () { return [
        { type: TemplateRef, decorators: [{ type: Inject, args: [CDS_SIDENAV_EXPANDED_TEMPLATE,] }] },
        { type: NavContext }
    ]; };
    SidenavExpandedComponent = __decorate([ __param(0, Inject(CDS_SIDENAV_EXPANDED_TEMPLATE)),
        __metadata("design:paramtypes", [TemplateRef, NavContext])
    ], SidenavExpandedComponent);
SidenavExpandedComponent.ɵfac = function SidenavExpandedComponent_Factory(t) { return new (t || SidenavExpandedComponent)(ɵngcc0.ɵɵdirectiveInject(CDS_SIDENAV_EXPANDED_TEMPLATE), ɵngcc0.ɵɵdirectiveInject(NavContext)); };
SidenavExpandedComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SidenavExpandedComponent, selectors: [["cds-sidenav-expanded"]], hostAttrs: [1, "cds-nav-columns__items", "cds-nav-columns__items--sub"], hostVars: 1, hostBindings: function SidenavExpandedComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵsyntheticHostProperty("@expanded", "expanded");
    } }, decls: 1, vars: 4, consts: [[3, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function SidenavExpandedComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainer(0, 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c45, ctx.context));
    } }, directives: [ɵngcc1.NgTemplateOutlet], encapsulation: 2, data: { animation: [
            trigger('expanded', [
                transition(':enter', [
                    style({ height: 0 }),
                    animate('0.15s ease-out', style({ height: '*' })),
                ]),
                transition(':leave', [
                    style({ height: '*' }),
                    animate('0.15s ease-out', style({ height: 0 })),
                ]),
            ]),
        ] } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SidenavExpandedComponent, [{
        type: Component,
        args: [{
                selector: 'cds-sidenav-expanded',
                template: '<ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{ $implicit: context }"></ng-container>',
                host: {
                    'class': 'cds-nav-columns__items cds-nav-columns__items--sub',
                    '[@expanded]': '"expanded"'
                },
                animations: [
                    trigger('expanded', [
                        transition(':enter', [
                            style({ height: 0 }),
                            animate('0.15s ease-out', style({ height: '*' })),
                        ]),
                        transition(':leave', [
                            style({ height: '*' }),
                            animate('0.15s ease-out', style({ height: 0 })),
                        ]),
                    ]),
                ]
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef, decorators: [{
                type: Inject,
                args: [CDS_SIDENAV_EXPANDED_TEMPLATE]
            }] }, { type: NavContext }]; }, null); })();
    return SidenavExpandedComponent;
}());

var SIDENAV_TRANSLATIONS_EN = {
    back: 'Back',
    closeMenu: 'Close menu',
    openMenu: 'Open menu',
};
function sidenavTranslationsFactory() {
    return SIDENAV_TRANSLATIONS_EN;
}
var CDS_SIDENAV_TRANSLATIONS = new InjectionToken('CDS_SIDENAV_TRANSLATIONS', { factory: sidenavTranslationsFactory });

var SidenavComponent = /** @class */ (function (_super) {
    __extends(SidenavComponent, _super);
    function SidenavComponent(renderer, element, matchMedia, cdRef, cfResolver, vcRef, injector, dropdownService, zone, componentTranslations) {
        var _this = _super.call(this, matchMedia) || this;
        _this.renderer = renderer;
        _this.element = element;
        _this.cdRef = cdRef;
        _this.vcRef = vcRef;
        _this.injector = injector;
        _this.dropdownService = dropdownService;
        _this.zone = zone;
        _this.expandType = 'accordion';
        _this.toggle = false;
        _this.toggleChange = new EventEmitter();
        _this.overlayVisible = new EventEmitter();
        _this.isOverlayVisible = false;
        _this.columns = [];
        _this.device = 'desktop';
        _this.firstAnimation = true;
        _this.forceExpand = false;
        _this.accordionChanges = new Map();
        _this.visibleSubject$ = new BehaviorSubject(false);
        _this.navigationId = Unique.next('cds-sidenav-');
        _this.columnsId = Unique.next('cds-sidenav-columns-');
        renderer.addClass(element.nativeElement, 'cds-sidenav');
        _this.factory = cfResolver.resolveComponentFactory(SidenavExpandedComponent);
        _this.overlayFactory = cfResolver.resolveComponentFactory(NavOverlayComponent);
        _this.visible$ = _this.visibleSubject$.asObservable();
        componentTranslations.use(CDS_SIDENAV_TRANSLATIONS, sidenavTranslationsFactory, function (translations) {
            _this.translations = translations;
        });
        return _this;
    }
    Object.defineProperty(SidenavComponent.prototype, "float", {
        get: function () {
            return !this.forceExpand && ((this.device === 'tablet' && !this.toggle) || (this.device === 'desktop' && this.toggle));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SidenavComponent.prototype, "narrow", {
        get: function () {
            return this.device === 'tablet' || (this.device === 'desktop' && this.toggle);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SidenavComponent.prototype, "expand", {
        get: function () {
            return this.forceExpand || (this.device === 'tablet' && this.toggle) || (this.device === 'mobile' && this.toggle);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SidenavComponent.prototype, "hidden", {
        get: function () {
            return this.device === 'mobile';
        },
        enumerable: true,
        configurable: true
    });
    SidenavComponent.prototype.back = function () {
        this.columns = this.columns.slice(0, -1);
    };
    SidenavComponent.prototype.ngDoCheck = function () {
        var _this = this;
        this.toggleHostClass('cds-sidenav--float', this.float);
        this.toggleHostClass('cds-sidenav--narrow', this.narrow);
        this.toggleHostClass('cds-sidenav--expand', this.expand);
        this.toggleHostClass('cds-sidenav--hidden', this.hidden);
        this.accordionChanges.forEach(function (changes, key) {
            var context = changes.context, vcRef = changes.vcRef, elementRef = changes.elementRef;
            var visibility = context.getVisibility();
            if (visibility !== 'visible' && vcRef.length) {
                _this.setNavItemExpanded(elementRef.nativeElement, false);
                vcRef.clear();
                _this.accordionChanges.delete(key);
            }
        });
        if (this.overlay) {
            var overlay = this.float ? this.columns.length !== 0 : this.expand;
            if (overlay !== this.isOverlayVisible) {
                this.isOverlayVisible = overlay;
                this.overlayVisible.emit(overlay);
            }
        }
    };
    SidenavComponent.prototype.setNavItemExpanded = function (element, expanded) {
        if (expanded) {
            this.renderer.addClass(element, 'cds-nav-item--expanded');
        }
        else {
            this.renderer.removeClass(element, 'cds-nav-item--expanded');
        }
        this.renderer.setAttribute(element, 'aria-expanded', "" + expanded);
    };
    SidenavComponent.prototype.toggleHostClass = function (className, value) {
        if (value) {
            this.renderer.addClass(this.element.nativeElement, className);
        }
        else {
            this.renderer.removeClass(this.element.nativeElement, className);
        }
    };
    SidenavComponent.prototype.ngOnChanges = function (changes) {
        if ('navigation' in changes) {
            this.main = this.createNavContext(this.navigation, this.navigationId);
        }
        if ('toggle' in changes) {
            this.columns = [];
        }
        this.forceExpand = false;
    };
    SidenavComponent.prototype.toggleHamburger = function () {
        if (this.forceExpand) {
            this.forceExpand = false;
            this.columns = [];
        }
        else {
            var columnsCount = this.columns.length;
            this.columns = [];
            if (columnsCount === 0 || !this.float) {
                this.toggle = !this.toggle;
                this.toggleChange.emit(this.toggle);
                this.dropdownService.closeAll();
            }
        }
        this.cdRef.markForCheck();
    };
    SidenavComponent.prototype.onColumnAnimation = function (event) {
        if (event.triggerName === 'column' && (event.toState === 'visible' || event.toState === 'visible-main')) {
            if (this.firstAnimation) {
                this.firstAnimation = false;
            }
            else if (isHTMLElement(event.element)) {
                var element_1 = event.element.querySelector('a[tabindex]:not([tabindex|="-"]),a[href]:not([tabindex|="-"]),button:not([tabindex|="-"])');
                if (element_1) {
                    element_1.focus();
                    element_1.classList.add('cds-nav-columns__no-focus');
                    var destroy_1 = listen(element_1, 'blur', function () {
                        element_1.classList.remove('cds-nav-columns__no-focus');
                        destroy_1();
                    });
                }
            }
        }
    };
    SidenavComponent.prototype.onDeviceChange = function (device, subscription) {
        var _this = this;
        /**
         * MatchMediaService may not necessarily run onDeviceChange() callback in Angular zone.
         * Should you require it running in the zone, use NgZone.run() explicitly.
         */
        this.zone.run(function () {
            _this.device = device;
            _this.visibleSubject$.next(device !== 'mobile');
            if (_this.toggle) {
                _this.toggle = false;
                _this.toggleChange.emit(false);
            }
            _this.columns = [];
            if (subscription) {
                _this.ngDoCheck();
                _this.cdRef.markForCheck();
                _this.cdRef.detectChanges();
            }
        });
    };
    SidenavComponent.prototype.createNavContext = function (template, id) {
        var _this = this;
        var self = this;
        var context = {
            id: id,
            template: template,
            position: 'side',
            ripple: true,
            componentRefs: new Set(),
            get rotateIcon() {
                return self.expandType === 'accordion';
            },
            expandNavigation: function (nextTemplate, id, elementRef, vcRef) {
                if (_this.expandType === 'slide') {
                    var index = _this.columns.findIndex(function (context) { return context.template === nextTemplate; });
                    if (index !== -1) {
                        return;
                    }
                    if (template === _this.navigation) {
                        _this.columns = [_this.createNavContext(nextTemplate, id)];
                    }
                    else {
                        _this.columns = __spread(_this.columns, [_this.createNavContext(nextTemplate, id)]);
                    }
                }
                else if (_this.expandType === 'accordion') {
                    if (vcRef.length) {
                        _this.setNavItemExpanded(elementRef.nativeElement, false);
                        vcRef.clear();
                        _this.accordionChanges.delete(vcRef);
                    }
                    else if (context.requestVisibilityChange('visible')) {
                        _this.setNavItemExpanded(elementRef.nativeElement, true);
                        var injector = Injector.create({
                            parent: _this.injector,
                            providers: [
                                { provide: CDS_SIDENAV_EXPANDED_TEMPLATE, useValue: nextTemplate },
                                { provide: NavContext, useValue: context },
                            ],
                        });
                        vcRef.createComponent(_this.factory, 0, injector);
                        _this.accordionChanges.set(vcRef, { vcRef: vcRef, elementRef: elementRef, context: context });
                    }
                }
            },
            hideDrawer: function () {
                _this.forceExpand = false;
                if (_this.float || _this.expand) {
                    _this.columns = [];
                    //newToggle is required because sidenav in desktop mode has this.toggle === true, while in narrow mode
                    var newToggle = _this.device === 'desktop';
                    if (_this.toggle !== newToggle) {
                        _this.toggle = newToggle;
                        _this.toggleChange.emit(newToggle);
                    }
                }
                _this.cdRef.detectChanges();
            },
            getVisibility: function () {
                if (template === _this.navigation) {
                    return _this.float ? 'partial' : _this.columns.length === 0 ? 'visible' : 'hidden';
                }
                else {
                    var index = _this.columns.findIndex(function (context) { return context.template === template; });
                    return index === _this.columns.length - 1 ? 'visible' : 'hidden';
                }
            },
            requestVisibilityChange: function (visibility) {
                var old = context.getVisibility();
                if (old === visibility) {
                    return true;
                }
                else if (old === 'partial' && visibility === 'visible') {
                    _this.forceExpand = true;
                    return true;
                }
                return false;
            },
        };
        return context;
    };
    SidenavComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef },
        { type: MatchMediaService },
        { type: ChangeDetectorRef },
        { type: ComponentFactoryResolver },
        { type: ViewContainerRef },
        { type: Injector },
        { type: DropdownService },
        { type: NgZone },
        { type: DynamicTranslations }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SidenavComponent.prototype, "expandType", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], SidenavComponent.prototype, "toggle", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], SidenavComponent.prototype, "toggleChange", void 0);
    __decorate([
        Input(),
        __metadata("design:type", TemplateRef)
    ], SidenavComponent.prototype, "navigation", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], SidenavComponent.prototype, "overlay", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], SidenavComponent.prototype, "overlayVisible", void 0);
    __decorate([
        ContentChild('brand', { static: true, read: TemplateRef }),
        __metadata("design:type", TemplateRef)
    ], SidenavComponent.prototype, "brandRef", void 0);
    __decorate([
        ContentChild('footer', { static: true, read: TemplateRef }),
        __metadata("design:type", TemplateRef)
    ], SidenavComponent.prototype, "footerRef", void 0);
    SidenavComponent = __decorate([ __metadata("design:paramtypes", [Renderer2,
            ElementRef,
            MatchMediaService,
            ChangeDetectorRef,
            ComponentFactoryResolver,
            ViewContainerRef,
            Injector,
            DropdownService,
            NgZone,
            DynamicTranslations])
    ], SidenavComponent);
SidenavComponent.ɵfac = function SidenavComponent_Factory(t) { return new (t || SidenavComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(MatchMediaService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(DropdownService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations)); };
SidenavComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SidenavComponent, selectors: [["cds-sidenav"]], contentQueries: function SidenavComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, _c35, true, TemplateRef);
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, _c37, true, TemplateRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.brandRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.footerRef = _t.first);
    } }, inputs: { toggle: "toggle", expandType: "expandType", navigation: "navigation", overlay: "overlay" }, outputs: { toggleChange: "toggleChange", overlayVisible: "overlayVisible" }, features: [ɵngcc0.ɵɵProvidersFeature([
            DynamicTranslations,
        ]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 11, vars: 11, consts: [[1, "cds-sidenav__static"], [1, "cds-sidenav__header"], [1, "cds-sidenav__hamburger"], ["cdsButton", "", "aria-haspopup", "menu", 1, "cds-button-icon", 3, "click"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 24 24", "focusable", "false"], ["d", "M4 18h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-5h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 7c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z"], [1, "cds-sidenav__logo"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "cds-nav-columns", 4, "ngIf"], ["class", "cds-nav-footer", 4, "ngIf"], ["class", "cds-sidenav__float-menu", 4, "ngIf"], [1, "cds-nav-columns"], [1, "cds-nav-columns__column"], [1, "cds-nav-columns__items"], [4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "cds-nav-columns__header"], ["cdsRipple", "", "aria-expanded", "true", "aria-haspopup", "menu", 1, "cds-nav-columns__back", 3, "click"], ["viewBox", "0 0 32 32", "focusable", "false"], ["d", "M7.7 15h20.255c.577 0 1.045.448 1.045 1s-.468 1-1.045 1H7.7l4.97 5.049c.44.446.44 1.17 0 1.616a1.113 1.113 0 0 1-1.59 0l-6.75-6.857a1.156 1.156 0 0 1 0-1.616l6.75-6.857a1.113 1.113 0 0 1 1.59 0c.44.446.44 1.17 0 1.616L7.7 15z"], [1, "cds-nav-columns__items", "cds-nav-columns__items--sub"], [1, "cds-nav-footer"], [1, "cds-sidenav__float-menu"], ["class", "cds-nav-columns__column", 4, "ngFor", "ngForOf"]], template: function SidenavComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "button", 3);
        ɵngcc0.ɵɵlistener("click", function SidenavComponent_Template_button_click_3_listener() { return ctx.toggleHamburger(); });
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(4, "svg", 4);
        ɵngcc0.ɵɵelement(5, "path", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵelementContainer(7, 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, SidenavComponent_div_8_Template, 5, 10, "div", 8);
        ɵngcc0.ɵɵtemplate(9, SidenavComponent_div_9_Template, 2, 4, "div", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, SidenavComponent_div_10_Template, 3, 2, "div", 10);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵattribute("aria-expanded", ctx.hidden ? ctx.expand : !ctx.narrow || ctx.expand)("aria-label", (ctx.hidden ? ctx.expand : !ctx.narrow || ctx.expand) ? ctx.translations.closeMenu : ctx.translations.openMenu)("aria-controls", ctx.columnsId);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵattribute("aria-hidden", (ctx.narrow || ctx.hidden) && !ctx.expand);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.brandRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(9, _c46, ctx.device));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.main);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.footerRef);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.float && ctx.columns.length !== 0);
    } }, directives: [ButtonRippleDirective, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgIf, ɵngcc1.NgForOf, RippleDirective], encapsulation: 2, data: { animation: [
            trigger('column', NAV_COLUMN_ANIMATIONS),
            trigger('float', [
                state('void', style({
                    maxWidth: '0'
                })),
                state('hidden', style({
                    maxWidth: '0'
                })),
                state('visible', style({
                    maxWidth: '*'
                })),
                transition('* => *', [
                    animate('0.3s ease-out'),
                ]),
            ]),
        ] }, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SidenavComponent, [{
        type: Component,
        args: [{
                selector: 'cds-sidenav',
                template: "<div class=\"cds-sidenav__static\">\n\t<div class=\"cds-sidenav__header\">\n\t\t<div class=\"cds-sidenav__hamburger\">\n\t\t\t<button cdsButton class=\"cds-button-icon\" (click)=\"toggleHamburger()\"\n\t\t\t        [attr.aria-expanded]=\"hidden ? expand : (!narrow || expand)\"\n\t\t\t        [attr.aria-label]=\"(hidden ? expand : (!narrow || expand)) ? translations.closeMenu : translations.openMenu\"\n\t\t\t\t\t[attr.aria-controls]=\"columnsId\"\n\t\t\t\t\taria-haspopup=\"menu\">\n\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" focusable=\"false\">\n\t\t\t\t\t<path d=\"M4 18h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-5h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 7c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z\" />\n\t\t\t\t</svg>\n\t\t\t</button>\n\t\t</div>\n\t\t<div class=\"cds-sidenav__logo\" [attr.aria-hidden]=\"(narrow || hidden) && !expand\">\n\t\t\t<ng-container [ngTemplateOutlet]=\"brandRef\" [ngTemplateOutletContext]=\"{ position: 'side', device: device }\"></ng-container>\n\t\t</div>\n\t</div>\n\t<div class=\"cds-nav-columns\" *ngIf=\"main\" [attr.id]=\"columnsId\">\n\t\t<div class=\"cds-nav-columns__column\" [attr.id]=\"main.id\" [class.cds-nav-columns__column--active]=\"columns.length === 0\"\n\t\t     [@column]=\"columns.length === 0 || float ? 'visible-main' : 'hidden'\" (@column.done)=\"onColumnAnimation($event)\">\n\t\t\t<div class=\"cds-nav-columns__items\">\n\t\t\t\t<ng-container [ngTemplateOutlet]=\"navigation\" [ngTemplateOutletContext]=\"{ $implicit: main }\"></ng-container>\n\t\t\t</div>\n\t\t</div>\n\t\t<ng-container *ngIf=\"!float\">\n\t\t\t<ng-container *ngFor=\"let column of columns; let last=last\">\n\t\t\t\t<div class=\"cds-nav-columns__column\" [class.cds-nav-columns__column--active]=\"last\" [@column]=\"last ? 'visible' : 'hidden'\" (@column.done)=\"onColumnAnimation($event)\">\n\t\t\t\t\t<div class=\"cds-nav-columns__header\">\n\t\t\t\t\t\t<button cdsRipple class=\"cds-nav-columns__back\" (click)=\"back()\" aria-expanded=\"true\" aria-haspopup=\"menu\" [attr.aria-controls]=\"column.id\">\n\t\t\t\t\t\t\t<svg viewBox=\"0 0 32 32\" focusable=\"false\">\n\t\t\t\t\t\t\t\t<path d=\"M7.7 15h20.255c.577 0 1.045.448 1.045 1s-.468 1-1.045 1H7.7l4.97 5.049c.44.446.44 1.17 0 1.616a1.113 1.113 0 0 1-1.59 0l-6.75-6.857a1.156 1.156 0 0 1 0-1.616l6.75-6.857a1.113 1.113 0 0 1 1.59 0c.44.446.44 1.17 0 1.616L7.7 15z\"></path>\n\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t{{translations.back}}\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"cds-nav-columns__items cds-nav-columns__items--sub\">\n\t\t\t\t\t\t<ng-container [ngTemplateOutlet]=\"column.template\" [ngTemplateOutletContext]=\"{ $implicit: column }\"></ng-container>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</ng-container>\n\t\t</ng-container>\n\t</div>\n\t<div *ngIf=\"footerRef\" class=\"cds-nav-footer\">\n\t\t<ng-container [ngTemplateOutlet]=\"footerRef\" [ngTemplateOutletContext]=\"{ position: 'side', device: device }\"></ng-container>\n\t</div>\n</div>\n<div class=\"cds-sidenav__float-menu\" *ngIf=\"float && columns.length !== 0\" [@float]=\"'visible'\">\n\t<div class=\"cds-nav-columns\">\n\t\t<div *ngFor=\"let column of columns; let last=last\"\n\t\t     class=\"cds-nav-columns__column\" [attr.id]=\"column.id\"\n\t\t     [@column]=\"last ? 'visible' : 'hidden'\" (@column.done)=\"onColumnAnimation($event)\">\n\t\t\t<div class=\"cds-nav-columns__header\">\n\t\t\t\t<button cdsRipple class=\"cds-nav-columns__back\" (click)=\"back()\"\n\t\t\t\t        aria-expanded=\"true\" aria-haspopup=\"menu\" [attr.aria-controls]=\"column.id\">\n\t\t\t\t\t<svg viewBox=\"0 0 32 32\" focusable=\"false\">\n\t\t\t\t\t\t<path d=\"M7.7 15h20.255c.577 0 1.045.448 1.045 1s-.468 1-1.045 1H7.7l4.97 5.049c.44.446.44 1.17 0 1.616a1.113 1.113 0 0 1-1.59 0l-6.75-6.857a1.156 1.156 0 0 1 0-1.616l6.75-6.857a1.113 1.113 0 0 1 1.59 0c.44.446.44 1.17 0 1.616L7.7 15z\"></path>\n\t\t\t\t\t</svg>\n\t\t\t\t\t{{translations.back}}\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t\t<div class=\"cds-nav-columns__items cds-nav-columns__items--sub\">\n\t\t\t\t<ng-container [ngTemplateOutlet]=\"column.template\" [ngTemplateOutletContext]=\"{ $implicit: column }\"></ng-container>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                animations: [
                    trigger('column', NAV_COLUMN_ANIMATIONS),
                    trigger('float', [
                        state('void', style({
                            maxWidth: '0'
                        })),
                        state('hidden', style({
                            maxWidth: '0'
                        })),
                        state('visible', style({
                            maxWidth: '*'
                        })),
                        transition('* => *', [
                            animate('0.3s ease-out'),
                        ]),
                    ]),
                ],
                providers: [
                    DynamicTranslations,
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: MatchMediaService }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.Injector }, { type: DropdownService }, { type: ɵngcc0.NgZone }, { type: DynamicTranslations }]; }, { toggle: [{
            type: Input
        }], expandType: [{
            type: Input
        }], toggleChange: [{
            type: Output
        }], navigation: [{
            type: Input
        }], overlay: [{
            type: Input
        }], overlayVisible: [{
            type: Output
        }], brandRef: [{
            type: ContentChild,
            args: ['brand', { static: true, read: TemplateRef }]
        }], footerRef: [{
            type: ContentChild,
            args: ['footer', { static: true, read: TemplateRef }]
        }] }); })();
    return SidenavComponent;
}(DeviceAwareComponent));

var AppLayoutComponent = /** @class */ (function () {
    function AppLayoutComponent(renderer, element, cdRef) {
        this.cdRef = cdRef;
        this.showOverlay = false;
        renderer.addClass(element.nativeElement, 'cds-app-layout');
    }
    AppLayoutComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.sidenav) {
            this.sidenav.overlayVisible.subscribe(function (visible) {
                _this.showOverlay = visible;
                _this.cdRef.detectChanges();
            });
        }
    };
    AppLayoutComponent.prototype.overlayClick = function () {
        this.sidenav.toggleHamburger();
    };
    AppLayoutComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef },
        { type: ChangeDetectorRef }
    ]; };
    __decorate([
        ViewChild('scrollable', { static: true, read: ElementRef }),
        __metadata("design:type", ElementRef)
    ], AppLayoutComponent.prototype, "scrollable", void 0);
    __decorate([
        ContentChild(forwardRef(function () { return SidenavComponent; }), { static: true, read: SidenavComponent }),
        __metadata("design:type", SidenavComponent)
    ], AppLayoutComponent.prototype, "sidenav", void 0);
    AppLayoutComponent = __decorate([ __metadata("design:paramtypes", [Renderer2, ElementRef, ChangeDetectorRef])
    ], AppLayoutComponent);
AppLayoutComponent.ɵfac = function AppLayoutComponent_Factory(t) { return new (t || AppLayoutComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
AppLayoutComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AppLayoutComponent, selectors: [["cds-app-layout"]], contentQueries: function AppLayoutComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, SidenavComponent, true, SidenavComponent);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.sidenav = _t.first);
    } }, viewQuery: function AppLayoutComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c50, true, ElementRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.scrollable = _t.first);
    } }, ngContentSelectors: _c52, decls: 12, vars: 1, consts: [[1, "cds-app-layout__aside", "cds-app-layout-aside-z-index"], [1, "cds-app-layout__middle"], ["class", "cds-app-layout-overlay-z-index", 3, "click", 4, "ngIf"], [1, "cds-app-layout__header", "cds-app-layout-header-z-index"], [1, "cds-app-layout__scrollable"], ["scrollable", ""], [1, "cds-app-layout__main"], [1, "cds-app-layout__footer"], [1, "cds-app-layout-overlay-z-index", 3, "click"]], template: function AppLayoutComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c51);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, AppLayoutComponent_cds_nav_overlay_3_Template, 1, 0, "cds-nav-overlay", 2);
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵprojection(5, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 4, 5);
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵprojection(9, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 7);
        ɵngcc0.ɵɵprojection(11, 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showOverlay);
    } }, directives: [ɵngcc1.NgIf, NavOverlayComponent], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AppLayoutComponent, [{
        type: Component,
        args: [{
                selector: 'cds-app-layout',
                template: "<div class=\"cds-app-layout__aside cds-app-layout-aside-z-index\"><ng-content select=\"aside,cds-sidenav\"></ng-content></div>\n<div class=\"cds-app-layout__middle\">\n\t<cds-nav-overlay *ngIf=\"showOverlay\" class=\"cds-app-layout-overlay-z-index\" (click)=\"overlayClick()\"></cds-nav-overlay>\n\t<div class=\"cds-app-layout__header cds-app-layout-header-z-index\"><ng-content select=\"header,cds-header\"></ng-content></div>\n\t<div class=\"cds-app-layout__scrollable\" #scrollable>\n\t\t<div class=\"cds-app-layout__main\"><ng-content select=\"main\"></ng-content></div>\n\t\t<div class=\"cds-app-layout__footer\"><ng-content select=\"footer\"></ng-content></div>\n\t</div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { scrollable: [{
            type: ViewChild,
            args: ['scrollable', { static: true, read: ElementRef }]
        }], sidenav: [{
            type: ContentChild,
            args: [forwardRef(function () { return SidenavComponent; }), { static: true, read: SidenavComponent }]
        }] }); })();
    return AppLayoutComponent;
}());

var LayoutModule = /** @class */ (function () {
    function LayoutModule() {
    }
    LayoutModule_1 = LayoutModule;
    LayoutModule.forRoot = function (options) {
        if (options === void 0) { options = {}; }
        return {
            ngModule: LayoutModule_1,
            providers: [
                options.deviceBreakpoints ? { provide: CDS_DEVICE_BREAKPOINTS, useValue: options.deviceBreakpoints } : null,
            ],
        };
    };
    var LayoutModule_1;
LayoutModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: LayoutModule });
LayoutModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function LayoutModule_Factory(t) { return new (t || LayoutModule)(); }, imports: [[
            NavModule,
            CommonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LayoutModule, { declarations: function () { return [AppLayoutComponent]; }, imports: function () { return [NavModule, CommonModule]; }, exports: function () { return [AppLayoutComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LayoutModule, [{
        type: NgModule,
        args: [{
                imports: [
                    NavModule,
                    CommonModule,
                ],
                declarations: [
                    AppLayoutComponent,
                ],
                exports: [
                    AppLayoutComponent,
                ]
            }]
    }], function () { return []; }, null); })();
    return LayoutModule;
}());

var ListSortByDirective = /** @class */ (function () {
    function ListSortByDirective() {
        this.changes$ = new ReplaySubject(1);
        this.sortByChange = new EventEmitter();
    }
    Object.defineProperty(ListSortByDirective.prototype, "sortBy", {
        set: function (sortBy) {
            this._sortBy = sortBy;
            this.changes$.next(sortBy);
        },
        enumerable: true,
        configurable: true
    });
    ListSortByDirective.prototype.ngAfterContentInit = function () {
        this.changes$.next(this._sortBy);
    };
    __decorate([
        Input('cdsListSortBy'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], ListSortByDirective.prototype, "sortBy", null);
    __decorate([
        Output('cdsListSortByChange'),
        __metadata("design:type", EventEmitter)
    ], ListSortByDirective.prototype, "sortByChange", void 0);
ListSortByDirective.ɵfac = function ListSortByDirective_Factory(t) { return new (t || ListSortByDirective)(); };
ListSortByDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ListSortByDirective, selectors: [["", "cdsListSortBy", ""]], inputs: { sortBy: ["cdsListSortBy", "sortBy"] }, outputs: { sortByChange: "cdsListSortByChange" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ListSortByDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsListSortBy]'
            }]
    }], function () { return []; }, { sortByChange: [{
            type: Output,
            args: ['cdsListSortByChange']
        }], sortBy: [{
            type: Input,
            args: ['cdsListSortBy']
        }] }); })();
    return ListSortByDirective;
}());

var ListColumnComponent = /** @class */ (function () {
    function ListColumnComponent(renderer, element, cdRef, role, sorter) {
        this.renderer = renderer;
        this.element = element;
        this.cdRef = cdRef;
        this.sorter = sorter;
        this.uncheckable = false;
        renderer.addClass(element.nativeElement, 'cds-list-column');
        this.columnHeader = role === 'columnheader';
    }
    Object.defineProperty(ListColumnComponent.prototype, "attrTabindex", {
        get: function () {
            return this.tabindex != null
                ? "" + this.tabindex
                : (this.useSorter ? '0' : null);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListColumnComponent.prototype, "useSorter", {
        get: function () {
            return !!(this.name && this.sorter);
        },
        enumerable: true,
        configurable: true
    });
    ListColumnComponent.prototype.ngOnChanges = function (changes) {
        if (this.sorter && 'name' in changes) {
            if (this.subscription) {
                this.subscription.unsubscribe();
            }
            this.setupChangesSubscription();
        }
        if ('tabindex' in changes) {
            this.renderer.removeAttribute(this.element.nativeElement, 'tabindex');
        }
    };
    ListColumnComponent.prototype.ngOnInit = function () {
        if (this.sorter && !this.subscription) {
            this.setupChangesSubscription();
        }
    };
    ListColumnComponent.prototype.setupChangesSubscription = function () {
        var _this = this;
        this.subscription = this.sorter.changes$.subscribe(function (sortBy) {
            var columnAsc = '+' + _this.name;
            var columnDesc = '-' + _this.name;
            if (sortBy) {
                _this.sortBy = sortBy.split(',')[0];
            }
            else {
                _this.sortBy = null;
            }
            if (_this.sortBy === _this.name || _this.sortBy === columnAsc) {
                _this.sortAsc = true;
                _this.sortDesc = false;
            }
            else if (_this.sortBy === columnDesc) {
                _this.sortAsc = false;
                _this.sortDesc = true;
            }
            else {
                _this.sortAsc = false;
                _this.sortDesc = false;
            }
            var nativeElement = _this.element.nativeElement;
            if (_this.sortAsc) {
                _this.renderer.addClass(nativeElement, 'cds-list-column--asc');
            }
            else {
                _this.renderer.removeClass(nativeElement, 'cds-list-column--asc');
            }
            if (_this.sortDesc) {
                _this.renderer.addClass(nativeElement, 'cds-list-column--desc');
            }
            else {
                _this.renderer.removeClass(nativeElement, 'cds-list-column--desc');
            }
            if (_this.columnHeader) {
                var sort = _this.sortAsc
                    ? 'ascending'
                    : _this.sortDesc
                        ? 'descending'
                        : 'none';
                if (sort !== 'none') {
                    _this.renderer.setAttribute(nativeElement, 'aria-sort', sort);
                }
                else {
                    _this.renderer.removeAttribute(nativeElement, 'aria-sort');
                }
            }
            _this.cdRef.markForCheck();
            _this.cdRef.detectChanges();
        });
    };
    ListColumnComponent.prototype.onClick = function () {
        if (this.useSorter) {
            var columnAsc = '+' + this.name;
            var columnDesc = '-' + this.name;
            if (this.sortBy === this.name || this.sortBy === columnAsc) {
                this.sorter.sortByChange.emit(columnDesc);
            }
            else if (this.sortBy === columnDesc && this.uncheckable) {
                this.sorter.sortByChange.emit(null);
            }
            else {
                this.sorter.sortByChange.emit(this.name);
            }
        }
    };
    ListColumnComponent.prototype.onKeyDown = function (event) {
        if (this.useSorter) {
            switch (event.code) {
                case 'Enter':
                case 'Space':
                case 'Spacebar':
                    this.onClick();
                    event.preventDefault();
            }
        }
    };
    ListColumnComponent.prototype.ngOnDestroy = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    };
    ListColumnComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef },
        { type: ChangeDetectorRef },
        { type: String, decorators: [{ type: Attribute, args: ['role',] }] },
        { type: ListSortByDirective, decorators: [{ type: Optional }] }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ListColumnComponent.prototype, "name", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], ListColumnComponent.prototype, "uncheckable", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ListColumnComponent.prototype, "tabindex", void 0);
    ListColumnComponent = __decorate([ __param(3, Attribute('role')),
        __param(4, Optional()),
        __metadata("design:paramtypes", [Renderer2,
            ElementRef,
            ChangeDetectorRef, String, ListSortByDirective])
    ], ListColumnComponent);
ListColumnComponent.ɵfac = function ListColumnComponent_Factory(t) { return new (t || ListColumnComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵinjectAttribute('role'), ɵngcc0.ɵɵdirectiveInject(ListSortByDirective, 8)); };
ListColumnComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ListColumnComponent, selectors: [["cds-list-column"]], inputs: { uncheckable: "uncheckable", name: "name", tabindex: "tabindex" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c2, decls: 5, vars: 3, consts: [["role", "button", 1, "cds-list-column__button", 3, "click", "keydown"], [1, "cds-list-column__icon"], [1, "cds-list-column__up", "cds-icon-sort-asc", "cds-icon--size-24"], [1, "cds-list-column__down", "cds-icon-sort-desc", "cds-icon--size-24"]], template: function ListColumnComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵlistener("click", function ListColumnComponent_Template_span_click_0_listener() { return ctx.onClick(); })("keydown", function ListColumnComponent_Template_span_keydown_0_listener($event) { return ctx.onKeyDown($event); });
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementStart(2, "span", 1);
        ɵngcc0.ɵɵelement(3, "i", 2);
        ɵngcc0.ɵɵelement(4, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("cds-list-column__button--clickable", ctx.useSorter);
        ɵngcc0.ɵɵattribute("tabindex", ctx.attrTabindex);
    } }, encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ListColumnComponent, [{
        type: Component,
        args: [{
                selector: 'cds-list-column',
                template: "<span role=\"button\" [attr.tabindex]=\"attrTabindex\"\n      class=\"cds-list-column__button\"\n      [class.cds-list-column__button--clickable]=\"useSorter\"\n      (click)=\"onClick()\" (keydown)=\"onKeyDown($event)\">\n\t<ng-content></ng-content>\n\t<span class=\"cds-list-column__icon\">\n\t\t<i class=\"cds-list-column__up cds-icon-sort-asc cds-icon--size-24\"></i>\n\t\t<i class=\"cds-list-column__down cds-icon-sort-desc cds-icon--size-24\"></i>\n\t</span>\n</span>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }, { type: String, decorators: [{
                type: Attribute,
                args: ['role']
            }] }, { type: ListSortByDirective, decorators: [{
                type: Optional
            }] }]; }, { uncheckable: [{
            type: Input
        }], name: [{
            type: Input
        }], tabindex: [{
            type: Input
        }] }); })();
    return ListColumnComponent;
}());

var ListExpandableDirective = /** @class */ (function () {
    function ListExpandableDirective() {
        this.expandMultiple = false;
        this.expandedRow = null;
    }
    ListExpandableDirective.prototype.toggleExpand = function (expandRow) {
        if (this.expandMultiple) {
            expandRow.toggle();
        }
        else {
            if (this.expandedRow !== null) {
                this.expandedRow.close();
            }
            if (this.expandedRow === expandRow) {
                this.expandedRow = null;
            }
            else {
                this.expandedRow = expandRow;
                this.expandedRow.toggle();
            }
        }
    };
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], ListExpandableDirective.prototype, "expandMultiple", void 0);
ListExpandableDirective.ɵfac = function ListExpandableDirective_Factory(t) { return new (t || ListExpandableDirective)(); };
ListExpandableDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ListExpandableDirective, selectors: [["", "cdsListExpandable", ""]], inputs: { expandMultiple: "expandMultiple" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ListExpandableDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsListExpandable]'
            }]
    }], function () { return []; }, { expandMultiple: [{
            type: Input
        }] }); })();
    return ListExpandableDirective;
}());

var ListRowExpandComponent = /** @class */ (function () {
    function ListRowExpandComponent(renderer, elementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.controls = null;
        this.expanded = false;
        renderer.setAttribute(elementRef.nativeElement, 'role', 'row');
        renderer.addClass(elementRef.nativeElement, 'cds-list-group');
    }
    ListRowExpandComponent.prototype.ngOnChanges = function (changes) {
        if ('expand' in changes) {
            this.updateHostBinding();
        }
        if ('expandedId' in changes) {
            if (this.expandedId === true) {
                this.controls = Unique.next('cds-row-expand-');
            }
            else if (this.expandedId) {
                this.controls = this.expandedId;
            }
            else {
                this.controls = null;
            }
        }
    };
    ListRowExpandComponent.prototype.toggle = function () {
        if (!this.expanded) {
            this.expanded = true;
            this.updateHostBinding();
            var view = this.viewContainerRef.createEmbeddedView(this.expand, {
                $implicit: this.expandedContext,
                expandedId: this.controls,
            });
            view.detectChanges();
        }
        else {
            this.close();
        }
    };
    ListRowExpandComponent.prototype.close = function () {
        this.expanded = false;
        this.updateHostBinding();
        this.viewContainerRef.clear();
    };
    ListRowExpandComponent.prototype.updateHostBinding = function () {
        var nativeElement = this.elementRef.nativeElement;
        if (this.expanded) {
            this.renderer.addClass(nativeElement, 'cds-list-group--expanded');
        }
        else {
            this.renderer.removeClass(nativeElement, 'cds-list-group--expanded');
        }
    };
    ListRowExpandComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef }
    ]; };
    __decorate([
        ViewChild('expandRow', { read: ViewContainerRef, static: true }),
        __metadata("design:type", ViewContainerRef)
    ], ListRowExpandComponent.prototype, "viewContainerRef", void 0);
    __decorate([
        Input(),
        __metadata("design:type", TemplateRef)
    ], ListRowExpandComponent.prototype, "expand", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ListRowExpandComponent.prototype, "expandedContext", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ListRowExpandComponent.prototype, "expandedId", void 0);
    ListRowExpandComponent = __decorate([ __metadata("design:paramtypes", [Renderer2,
            ElementRef])
    ], ListRowExpandComponent);
ListRowExpandComponent.ɵfac = function ListRowExpandComponent_Factory(t) { return new (t || ListRowExpandComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ListRowExpandComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ListRowExpandComponent, selectors: [["cds-list-row", "expand", ""]], viewQuery: function ListRowExpandComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c53, true, ViewContainerRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.viewContainerRef = _t.first);
    } }, inputs: { expand: "expand", expandedContext: "expandedContext", expandedId: "expandedId" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], attrs: _c54, ngContentSelectors: _c2, decls: 4, vars: 0, consts: [["role", "none", 1, "cds-list-row"], ["expandRow", ""]], template: function ListRowExpandComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, ListRowExpandComponent_ng_template_2_Template, 0, 0, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } }, encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ListRowExpandComponent, [{
        type: Component,
        args: [{
                selector: 'cds-list-row[expand]',
                template: "<div class=\"cds-list-row\" role=\"none\">\n\t<ng-content></ng-content>\n</div>\n<ng-template #expandRow></ng-template>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { viewContainerRef: [{
            type: ViewChild,
            args: ['expandRow', { read: ViewContainerRef, static: true }]
        }], expand: [{
            type: Input
        }], expandedContext: [{
            type: Input
        }], expandedId: [{
            type: Input
        }] }); })();
    return ListRowExpandComponent;
}());

var ListExpandDirective = /** @class */ (function () {
    function ListExpandDirective(listExpand, listRowComponent, cdRef, elementRef, renderer) {
        this.listExpand = listExpand;
        this.listRowComponent = listRowComponent;
        this.cdRef = cdRef;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.enabled = true;
    }
    Object.defineProperty(ListExpandDirective.prototype, "attrAriaExpanded", {
        get: function () {
            return this.listRowComponent.expanded;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListExpandDirective.prototype, "attrAriaControls", {
        get: function () {
            return this.listRowComponent.controls;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListExpandDirective.prototype, "cdsListExpand", {
        set: function (value) {
            if (typeof value === 'boolean') {
                this.enabled = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    ListExpandDirective.prototype.ngOnChanges = function (changes) {
        if (this.enabled && !!this.listRowComponent.expand) {
            if (!this.removeListener) {
                this.enableExpandRow();
            }
        }
        else {
            this.disableExpandRow();
        }
    };
    ListExpandDirective.prototype.enableExpandRow = function () {
        var _this = this;
        this.renderer.addClass(this.elementRef.nativeElement, 'cds-list-expand--enabled');
        var onClick = function () {
            _this.listExpand.toggleExpand(_this.listRowComponent);
            _this.cdRef.markForCheck();
        };
        var onKeyDown = function (event) {
            event.preventDefault();
            onClick();
        };
        this.removeListener = concatRunnableFunctions([
            this.renderer.listen(this.elementRef.nativeElement, 'click', onClick),
            this.renderer.listen(this.elementRef.nativeElement, 'keydown.spacebar', onKeyDown),
            this.renderer.listen(this.elementRef.nativeElement, 'keydown.space', onKeyDown),
            this.renderer.listen(this.elementRef.nativeElement, 'keydown.enter', onKeyDown),
        ]);
    };
    ListExpandDirective.prototype.disableExpandRow = function () {
        if (this.removeListener) {
            this.removeListener();
            this.removeListener = null;
        }
        this.renderer.removeClass(this.elementRef.nativeElement, 'cds-list-expand--enabled');
    };
    ListExpandDirective.prototype.ngOnDestroy = function () {
        this.disableExpandRow();
    };
    ListExpandDirective.ctorParameters = function () { return [
        { type: ListExpandableDirective, decorators: [{ type: Host }] },
        { type: ListRowExpandComponent, decorators: [{ type: Host }] },
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
    __decorate([
        HostBinding('attr.aria-expanded'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ListExpandDirective.prototype, "attrAriaExpanded", null);
    __decorate([
        HostBinding('attr.aria-controls'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ListExpandDirective.prototype, "attrAriaControls", null);
    __decorate([
        Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], ListExpandDirective.prototype, "cdsListExpand", null);
    ListExpandDirective = __decorate([ __param(0, Host()),
        __param(1, Host()),
        __metadata("design:paramtypes", [ListExpandableDirective,
            ListRowExpandComponent,
            ChangeDetectorRef,
            ElementRef,
            Renderer2])
    ], ListExpandDirective);
ListExpandDirective.ɵfac = function ListExpandDirective_Factory(t) { return new (t || ListExpandDirective)(ɵngcc0.ɵɵdirectiveInject(ListExpandableDirective, 1), ɵngcc0.ɵɵdirectiveInject(ListRowExpandComponent, 1), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
ListExpandDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ListExpandDirective, selectors: [["", "cdsListExpand", ""]], hostVars: 2, hostBindings: function ListExpandDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-expanded", ctx.attrAriaExpanded)("aria-controls", ctx.attrAriaControls);
    } }, inputs: { cdsListExpand: "cdsListExpand" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ListExpandDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsListExpand]'
            }]
    }], function () { return [{ type: ListExpandableDirective, decorators: [{
                type: Host
            }] }, { type: ListRowExpandComponent, decorators: [{
                type: Host
            }] }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { attrAriaExpanded: [{
            type: HostBinding,
            args: ['attr.aria-expanded']
        }], attrAriaControls: [{
            type: HostBinding,
            args: ['attr.aria-controls']
        }], cdsListExpand: [{
            type: Input
        }] }); })();
    return ListExpandDirective;
}());

var ListRowDirective = /** @class */ (function () {
    function ListRowDirective(renderer, elementRef) {
        renderer.setAttribute(elementRef.nativeElement, 'role', 'row');
        renderer.addClass(elementRef.nativeElement, 'cds-list-row');
    }
    ListRowDirective.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef }
    ]; };
    ListRowDirective = __decorate([ __metadata("design:paramtypes", [Renderer2,
            ElementRef])
    ], ListRowDirective);
ListRowDirective.ɵfac = function ListRowDirective_Factory(t) { return new (t || ListRowDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ListRowDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ListRowDirective, selectors: [["cds-list-row", 3, "expand", ""]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ListRowDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'cds-list-row:not([expand])'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, null); })();
    return ListRowDirective;
}());

var ListToolbarComponent = /** @class */ (function () {
    function ListToolbarComponent(elementRef, renderer) {
        renderer.addClass(elementRef.nativeElement, 'cds-list-toolbar');
    }
    ListToolbarComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
    ListToolbarComponent = __decorate([ __metadata("design:paramtypes", [ElementRef, Renderer2])
    ], ListToolbarComponent);
ListToolbarComponent.ɵfac = function ListToolbarComponent_Factory(t) { return new (t || ListToolbarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
ListToolbarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ListToolbarComponent, selectors: [["cds-list-toolbar"]], ngContentSelectors: _c56, decls: 3, vars: 0, consts: [[1, "cds-list-toolbar__actions"]], template: function ListToolbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c55);
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵprojection(2, 1);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ListToolbarComponent, [{
        type: Component,
        args: [{
                selector: 'cds-list-toolbar',
                template: "<ng-content select=\"cds-slot-title,header\"></ng-content>\n<div class=\"cds-list-toolbar__actions\">\n\t<ng-content select=\":not(cds-slot-title):not(header)\"></ng-content>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, null); })();
    return ListToolbarComponent;
}());

var LIST_DEFAULT_OPTIONS = {
    appearance: 'flat',
};
function listDefaultOptions() {
    return LIST_DEFAULT_OPTIONS;
}
var CDS_LIST_DEFAULT_OPTIONS = new InjectionToken('CDS_LIST_DEFAULT_OPTIONS', { factory: listDefaultOptions });

var ListComponent = /** @class */ (function () {
    function ListComponent(elementRef, renderer, options) {
        this.options = options;
        renderer.addClass(elementRef.nativeElement, 'cds-list');
        renderer.setAttribute(elementRef.nativeElement, 'role', 'table');
    }
    Object.defineProperty(ListComponent.prototype, "classFlat", {
        get: function () {
            return (this.appearance || this.options.appearance) === 'flat';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListComponent.prototype, "classElevated", {
        get: function () {
            return (this.appearance || this.options.appearance) === 'elevated';
        },
        enumerable: true,
        configurable: true
    });
    ListComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: undefined, decorators: [{ type: Inject, args: [CDS_LIST_DEFAULT_OPTIONS,] }] }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ListComponent.prototype, "appearance", void 0);
    __decorate([
        HostBinding('class.cds-list--flat'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ListComponent.prototype, "classFlat", null);
    __decorate([
        HostBinding('class.cds-list--elevated'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ListComponent.prototype, "classElevated", null);
    ListComponent = __decorate([ __param(2, Inject(CDS_LIST_DEFAULT_OPTIONS)),
        __metadata("design:paramtypes", [ElementRef, Renderer2, Object])
    ], ListComponent);
ListComponent.ɵfac = function ListComponent_Factory(t) { return new (t || ListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(CDS_LIST_DEFAULT_OPTIONS)); };
ListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ListComponent, selectors: [["cds-list"]], hostVars: 4, hostBindings: function ListComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("cds-list--flat", ctx.classFlat)("cds-list--elevated", ctx.classElevated);
    } }, inputs: { appearance: "appearance" }, ngContentSelectors: _c58, decls: 4, vars: 0, consts: [["role", "rowgroup", 1, "cds-list-head"], ["role", "rowgroup", 1, "cds-list-body"]], template: function ListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c57);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵprojection(3, 1);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ListComponent, [{
        type: Component,
        args: [{
                selector: 'cds-list',
                template: "<div class=\"cds-list-head\" role=\"rowgroup\">\n\t<ng-content select=\"[head]\"></ng-content>\n</div>\n<div class=\"cds-list-body\" role=\"rowgroup\">\n\t<ng-content select=\":not([head])\"></ng-content>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: undefined, decorators: [{
                type: Inject,
                args: [CDS_LIST_DEFAULT_OPTIONS]
            }] }]; }, { classFlat: [{
            type: HostBinding,
            args: ['class.cds-list--flat']
        }], classElevated: [{
            type: HostBinding,
            args: ['class.cds-list--elevated']
        }], appearance: [{
            type: Input
        }] }); })();
    return ListComponent;
}());

var ListModule = /** @class */ (function () {
    function ListModule() {
    }
ListModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ListModule });
ListModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ListModule_Factory(t) { return new (t || ListModule)(); }, imports: [[
            CommonModule,
            SlotsModule,
        ], SlotsModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ListModule, { declarations: function () { return [ListColumnComponent, ListComponent, ListExpandableDirective, ListExpandDirective, ListRowDirective, ListRowExpandComponent, ListSortByDirective, ListToolbarComponent]; }, imports: function () { return [CommonModule, SlotsModule]; }, exports: function () { return [ListColumnComponent, ListComponent, ListExpandableDirective, ListExpandDirective, ListRowDirective, ListRowExpandComponent, ListSortByDirective, ListToolbarComponent, SlotsModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ListModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    SlotsModule,
                ],
                declarations: [
                    ListColumnComponent,
                    ListComponent,
                    ListExpandableDirective,
                    ListExpandDirective,
                    ListRowDirective,
                    ListRowExpandComponent,
                    ListSortByDirective,
                    ListToolbarComponent,
                ],
                exports: [
                    ListColumnComponent,
                    ListComponent,
                    ListExpandableDirective,
                    ListExpandDirective,
                    ListRowDirective,
                    ListRowExpandComponent,
                    ListSortByDirective,
                    ListToolbarComponent,
                    // modules
                    SlotsModule,
                ]
            }]
    }], function () { return []; }, null); })();
    return ListModule;
}());

var NOTIFICATION_TRANSLATIONS_EN = {
    alert: 'Alert',
};
function notificationTranslationsFactory() {
    return NOTIFICATION_TRANSLATIONS_EN;
}
var CDS_NOTIFICATION_TRANSLATIONS = new InjectionToken('CDS_NOTIFICATION_TRANSLATIONS', { factory: notificationTranslationsFactory });

var NotificationComponent = /** @class */ (function () {
    function NotificationComponent(elementRef, renderer, componentTranslations, cdRef) {
        var _this = this;
        this.status = 'normal';
        this.toRead = false;
        this.initialized = false;
        renderer.addClass(elementRef.nativeElement, 'cds-notification');
        componentTranslations.use(CDS_NOTIFICATION_TRANSLATIONS, notificationTranslationsFactory, function (translations) {
            _this.translations = translations;
            if (_this.initialized) {
                cdRef.detectChanges();
            }
        });
    }
    Object.defineProperty(NotificationComponent.prototype, "normal", {
        get: function () {
            return this.status === 'normal' && !this.toRead;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationComponent.prototype, "danger", {
        get: function () {
            return this.status === 'danger' && !this.toRead;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationComponent.prototype, "dangerUnread", {
        get: function () {
            return this.status === 'danger' && this.toRead;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationComponent.prototype, "normalUnread", {
        get: function () {
            if (this.status === 'info') {
                // deprecated
                return true;
            }
            return this.status === 'normal' && this.toRead;
        },
        enumerable: true,
        configurable: true
    });
    NotificationComponent.prototype.ngOnInit = function () {
        this.initialized = true;
        if (isDevMode() && this.status === 'info') {
            console.warn('Use of \'info\' status is deprecated. Please use \'toRead\' input instead');
        }
    };
    NotificationComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: DynamicTranslations },
        { type: ChangeDetectorRef }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], NotificationComponent.prototype, "status", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], NotificationComponent.prototype, "toRead", void 0);
    __decorate([
        HostBinding('class.cds-notification--normal'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], NotificationComponent.prototype, "normal", null);
    __decorate([
        HostBinding('class.cds-notification--danger'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], NotificationComponent.prototype, "danger", null);
    __decorate([
        HostBinding('class.cds-notification--danger-unread'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], NotificationComponent.prototype, "dangerUnread", null);
    __decorate([
        HostBinding('class.cds-notification--normal-unread'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], NotificationComponent.prototype, "normalUnread", null);
    NotificationComponent = __decorate([ __metadata("design:paramtypes", [ElementRef, Renderer2, DynamicTranslations, ChangeDetectorRef])
    ], NotificationComponent);
NotificationComponent.ɵfac = function NotificationComponent_Factory(t) { return new (t || NotificationComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
NotificationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NotificationComponent, selectors: [["cds-notification"]], hostVars: 8, hostBindings: function NotificationComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("cds-notification--normal", ctx.normal)("cds-notification--danger", ctx.danger)("cds-notification--danger-unread", ctx.dangerUnread)("cds-notification--normal-unread", ctx.normalUnread);
    } }, inputs: { status: "status", toRead: "toRead" }, features: [ɵngcc0.ɵɵProvidersFeature([DynamicTranslations])], ngContentSelectors: _c60, decls: 15, vars: 2, consts: [["class", "cds-notification__indicator", 4, "ngIf"], [1, "cds-notification__header"], ["class", "cds-notification__alert-badge", 4, "ngIf"], [1, "cds-notification__section"], [1, "cds-notification__content-container"], [1, "cds-notification__image"], [1, "cds-notification__title"], [1, "cds-notification__content"], [1, "cds-notification__actions"], [1, "cds-notification__indicator"], [1, "cds-notification__alert-badge"]], template: function NotificationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c59);
        ɵngcc0.ɵɵtemplate(0, NotificationComponent_div_0_Template, 1, 0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, NotificationComponent_span_2_Template, 2, 1, "span", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵprojection(7, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div");
        ɵngcc0.ɵɵelementStart(9, "div", 6);
        ɵngcc0.ɵɵprojection(10, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 7);
        ɵngcc0.ɵɵprojection(12, 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 8);
        ɵngcc0.ɵɵprojection(14, 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.toRead || ctx.status === "info");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.status === "danger");
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NotificationComponent, [{
        type: Component,
        args: [{
                selector: 'cds-notification',
                template: "<div *ngIf=\"toRead || status==='info'\" class=\"cds-notification__indicator\"></div>\n<div class=\"cds-notification__header\">\n\t<span *ngIf=\"status === 'danger'\" class=\"cds-notification__alert-badge\">{{translations.alert}}</span>\n\t<ng-content select=\"meta\"></ng-content>\n</div>\n<div class=\"cds-notification__section\">\n\t<div class=\"cds-notification__content-container\">\n\t\t<div class=\"cds-notification__image\">\n\t\t\t<ng-content select=\"picture,img\"></ng-content>\n\t\t</div>\n\t\t<div>\n\t\t\t<div class=\"cds-notification__title\"><ng-content select=\"cds-slot-title,header\"></ng-content></div>\n\t\t\t<div class=\"cds-notification__content\"><ng-content select=\"cds-slot-content,section\"></ng-content></div>\n\t\t</div>\n\t</div>\n\t<div class=\"cds-notification__actions\">\n\t\t<ng-content select=\"action\"></ng-content>\n\t</div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                providers: [DynamicTranslations]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: DynamicTranslations }, { type: ɵngcc0.ChangeDetectorRef }]; }, { status: [{
            type: Input
        }], toRead: [{
            type: Input
        }], normal: [{
            type: HostBinding,
            args: ['class.cds-notification--normal']
        }], danger: [{
            type: HostBinding,
            args: ['class.cds-notification--danger']
        }], dangerUnread: [{
            type: HostBinding,
            args: ['class.cds-notification--danger-unread']
        }], normalUnread: [{
            type: HostBinding,
            args: ['class.cds-notification--normal-unread']
        }] }); })();
    return NotificationComponent;
}());

var NotificationModule = /** @class */ (function () {
    function NotificationModule() {
    }
NotificationModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NotificationModule });
NotificationModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NotificationModule_Factory(t) { return new (t || NotificationModule)(); }, imports: [[
            CommonModule,
            SlotsModule,
        ], SlotsModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NotificationModule, { declarations: function () { return [NotificationComponent]; }, imports: function () { return [CommonModule, SlotsModule]; }, exports: function () { return [NotificationComponent, SlotsModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NotificationModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    SlotsModule,
                ],
                declarations: [
                    NotificationComponent,
                ],
                exports: [
                    NotificationComponent,
                    // modules
                    SlotsModule,
                ]
            }]
    }], function () { return []; }, null); })();
    return NotificationModule;
}());

var GeneratePagesPipe = /** @class */ (function () {
    function GeneratePagesPipe() {
    }
    GeneratePagesPipe.prototype.transform = function (totalPages, currentPage) {
        if (totalPages <= 4) {
            return new Array(totalPages).fill(0).map(function (_, i) { return i + 1; });
        }
        else if (totalPages <= 7) {
            if (currentPage == Math.ceil(totalPages / 2) || currentPage == totalPages / 2 + 1 || (totalPages === 5 && (currentPage === 2 || currentPage === 4))) {
                return new Array(totalPages).fill(0).map(function (_, i) { return i + 1; });
            }
            else if (currentPage < 4) {
                return __spread(Array(Math.max(2, currentPage + 1)).fill(0).map(function (_, index) { return index + 1; }), [null, totalPages]);
            }
            else {
                return __spread([1, null], Array(Math.max(2, totalPages - currentPage + 2)).fill(0).map(function (_, index) { return totalPages - index; }).reverse());
            }
        }
        else {
            if (currentPage < 5) {
                return __spread(Array(Math.max(3, currentPage + 1)).fill(0).map(function (_, index) { return index + 1; }), [null, totalPages]);
            }
            if (currentPage > totalPages - 4) {
                return __spread([1, null], Array(Math.max(3, totalPages - currentPage + 2)).fill(0).map(function (_, index) { return totalPages - index; }).reverse());
            }
            else {
                return [1, null, currentPage - 1, currentPage, currentPage + 1, null, totalPages];
            }
        }
    };
GeneratePagesPipe.ɵfac = function GeneratePagesPipe_Factory(t) { return new (t || GeneratePagesPipe)(); };
GeneratePagesPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "cdsGeneratePages", type: GeneratePagesPipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(GeneratePagesPipe, [{
        type: Pipe,
        args: [{
                name: 'cdsGeneratePages'
            }]
    }], function () { return []; }, null); })();
    return GeneratePagesPipe;
}());

var PagerHiddenDirective = /** @class */ (function () {
    function PagerHiddenDirective() {
    }
    Object.defineProperty(PagerHiddenDirective.prototype, "attrTabindex", {
        get: function () {
            return this.cdsPagerHidden ? '-1' : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PagerHiddenDirective.prototype, "attrAriaHidden", {
        get: function () {
            return this.cdsPagerHidden ? 'true' : null;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Input(),
        HostBinding('class.cds-sr-only'),
        __metadata("design:type", Boolean)
    ], PagerHiddenDirective.prototype, "cdsPagerHidden", void 0);
    __decorate([
        HostBinding('attr.tabindex'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], PagerHiddenDirective.prototype, "attrTabindex", null);
    __decorate([
        HostBinding('attr.aria-hidden'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], PagerHiddenDirective.prototype, "attrAriaHidden", null);
PagerHiddenDirective.ɵfac = function PagerHiddenDirective_Factory(t) { return new (t || PagerHiddenDirective)(); };
PagerHiddenDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: PagerHiddenDirective, selectors: [["", "cdsPagerHidden", ""]], hostVars: 4, hostBindings: function PagerHiddenDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("tabindex", ctx.attrTabindex)("aria-hidden", ctx.attrAriaHidden);
        ɵngcc0.ɵɵclassProp("cds-sr-only", ctx.cdsPagerHidden);
    } }, inputs: { cdsPagerHidden: "cdsPagerHidden" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PagerHiddenDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsPagerHidden]'
            }]
    }], function () { return []; }, { attrTabindex: [{
            type: HostBinding,
            args: ['attr.tabindex']
        }], attrAriaHidden: [{
            type: HostBinding,
            args: ['attr.aria-hidden']
        }], cdsPagerHidden: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.cds-sr-only']
        }] }); })();
    return PagerHiddenDirective;
}());

var PagerInterpolatePipe = /** @class */ (function () {
    function PagerInterpolatePipe() {
    }
    PagerInterpolatePipe.prototype.transform = function (value) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!value) {
            return value;
        }
        var newValue = value.replace(/\{\{\s*(\d+)\s*}}/g, function (match, param) {
            var index = +param;
            return args[index - 1] || '';
        });
        return newValue;
    };
PagerInterpolatePipe.ɵfac = function PagerInterpolatePipe_Factory(t) { return new (t || PagerInterpolatePipe)(); };
PagerInterpolatePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "cdsPagerInterpolate", type: PagerInterpolatePipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PagerInterpolatePipe, [{
        type: Pipe,
        args: [{
                name: 'cdsPagerInterpolate'
            }]
    }], function () { return []; }, null); })();
    return PagerInterpolatePipe;
}());

var PagerSizesPipe = /** @class */ (function () {
    function PagerSizesPipe() {
    }
    PagerSizesPipe.prototype.transform = function (array, size) {
        if (!size) {
            return array;
        }
        var index = 0;
        while (index <= array.length && size >= array[index]) {
            if (size == array[index++]) {
                return array;
            }
        }
        var returnArray = array.slice();
        returnArray.splice(index, 0, size);
        return returnArray;
    };
PagerSizesPipe.ɵfac = function PagerSizesPipe_Factory(t) { return new (t || PagerSizesPipe)(); };
PagerSizesPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "cdsPagerSizes", type: PagerSizesPipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PagerSizesPipe, [{
        type: Pipe,
        args: [{
                name: 'cdsPagerSizes'
            }]
    }], function () { return []; }, null); })();
    return PagerSizesPipe;
}());

var PAGER_TRANSLATIONS_EN = {
    visibleItems: '{{1}} - {{2}} of {{3}} items',
    srVisibleItems: 'Items from {{1}} to {{2}} of {{3}} items',
    itemsPerPage: 'Items per page',
    next: 'Next',
    previous: 'Previous',
    firstPage: 'First page',
    previousPage: 'Previous page',
    currentPage: 'Current page',
    nextPage: 'Next page',
    lastPage: 'Last page',
    pageNumber: 'Page {{1}}',
    of: 'of',
};
function pagerTranslationsFactory() {
    return PAGER_TRANSLATIONS_EN;
}
var CDS_PAGER_TRANSLATIONS = new InjectionToken('CDS_PAGER_TRANSLATIONS', { factory: pagerTranslationsFactory });

var PagerComponent = /** @class */ (function () {
    function PagerComponent(elementRef, renderer, componentTranslations) {
        var _this = this;
        this.elementRef = elementRef;
        this.enablePageSizeChange = true;
        this.pageSizes = [10, 20, 40];
        this.pageSizeChange = new EventEmitter();
        this.currentPageChange = new EventEmitter();
        renderer.addClass(elementRef.nativeElement, 'cds-pager');
        componentTranslations.use(CDS_PAGER_TRANSLATIONS, pagerTranslationsFactory, function (translations) {
            _this.translations = translations;
        });
    }
    Object.defineProperty(PagerComponent.prototype, "fromElement", {
        get: function () {
            return this.pageSize * (this.currentPage - 1) + 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PagerComponent.prototype, "toElement", {
        get: function () {
            return Math.min(this.totalElements, this.pageSize * this.currentPage);
        },
        enumerable: true,
        configurable: true
    });
    PagerComponent.prototype.pageSizeChanged = function () {
        this.pageSizeChange.emit(this.pageSize);
        this.currentPage = 1;
        this.currentPageChange.emit(1);
    };
    PagerComponent.prototype.ngOnChanges = function (changes) {
        if ('totalElements' in changes) {
            if (this.totalElements <= 0) {
                this.totalElements = 1;
                this.currentPage = null;
            }
        }
        if ('pageSize' in changes) {
            if (this.pageSize <= 0) {
                this.pageSize = 1;
                this.pageSizeChange.emit(this.pageSize);
                this.currentPage = null;
            }
        }
        if ('currentPage' in changes) {
            this.currentPage = +changes.currentPage.currentValue;
        }
        this.calculateTotalPages();
    };
    PagerComponent.prototype.ngOnInit = function () {
        this.calculateTotalPages();
    };
    PagerComponent.prototype.next = function (event) {
        if (this.currentPage <= this.totalPages) {
            this.currentPageChange.emit(++this.currentPage);
            if (this.currentPage === this.totalPages) {
                event.preventDefault();
                this.focusCurrent(true);
            }
        }
    };
    PagerComponent.prototype.prev = function (event) {
        if (this.currentPage > 0) {
            this.currentPageChange.emit(--this.currentPage);
            if (this.currentPage === 1) {
                event.preventDefault();
                this.focusCurrent(false);
            }
        }
    };
    PagerComponent.prototype.first = function (event) {
        this.currentPage = 1;
        this.currentPageChange.emit(this.currentPage);
        event.preventDefault();
        this.focusCurrent(false);
    };
    PagerComponent.prototype.last = function (event) {
        this.currentPage = this.totalPages;
        this.currentPageChange.emit(this.currentPage);
        event.preventDefault();
        this.focusCurrent(true);
    };
    PagerComponent.prototype.changePage = function (page) {
        this.currentPage = page;
        this.currentPageChange.emit(this.currentPage);
        if (this.currentPage === 1) {
            this.focusCurrent(false);
        }
        else if (this.currentPage === this.totalPages) {
            this.focusCurrent(true);
        }
    };
    PagerComponent.prototype.isFirst = function () {
        return this.currentPage == 1;
    };
    PagerComponent.prototype.isLast = function () {
        return this.currentPage == this.totalPages;
    };
    PagerComponent.prototype.calculateTotalPages = function () {
        this.totalPages = Math.ceil(this.totalElements / this.pageSize);
        if (!this.currentPage || this.currentPage < 1) {
            this.currentPage = 1;
            this.currentPageChange.emit(this.currentPage);
        }
        else if (this.currentPage > this.totalPages) {
            this.currentPage = this.totalPages;
            this.currentPageChange.emit(this.currentPage);
        }
    };
    PagerComponent.prototype.focusCurrent = function (last) {
        var element = this.elementRef.nativeElement;
        var selector = element.querySelector('.cds-pager__page-selector');
        var isVisible = selector && window.getComputedStyle(selector).display !== 'none';
        if (isVisible) {
            var focus_1 = (last ? selector.lastElementChild : selector.firstElementChild);
            if (focus_1) {
                focus_1.focus();
            }
        }
        else {
            var focus_2 = last
                ? element.querySelector('.cds-pager__prev')
                : element.querySelector('.cds-pager__next');
            if (focus_2) {
                focus_2.focus();
            }
        }
    };
    PagerComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: DynamicTranslations }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], PagerComponent.prototype, "short", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], PagerComponent.prototype, "arrows", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], PagerComponent.prototype, "enablePageSizeChange", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], PagerComponent.prototype, "pageSizes", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], PagerComponent.prototype, "totalElements", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], PagerComponent.prototype, "pageSize", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], PagerComponent.prototype, "pageSizeChange", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], PagerComponent.prototype, "currentPage", void 0);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], PagerComponent.prototype, "currentPageChange", void 0);
    PagerComponent = __decorate([ __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            DynamicTranslations])
    ], PagerComponent);
PagerComponent.ɵfac = function PagerComponent_Factory(t) { return new (t || PagerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations)); };
PagerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PagerComponent, selectors: [["cds-pager"]], inputs: { enablePageSizeChange: "enablePageSizeChange", pageSizes: "pageSizes", currentPage: "currentPage", totalElements: "totalElements", pageSize: "pageSize", short: "short", arrows: "arrows" }, outputs: { pageSizeChange: "pageSizeChange", currentPageChange: "currentPageChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            DynamicTranslations,
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 26, vars: 27, consts: [["class", "cds-pager__page-size-selector", 4, "ngIf"], ["role", "status", "aria-live", "polite", 1, "cds-sr-only"], ["role", "navigation", 1, "cds-pager__pages"], ["cdsButton", "", 1, "cds-button-icon", "cds-button-small", 3, "cdsPagerHidden", "click"], [1, "cds-icon-double-angle-left"], ["cdsButton", "", 1, "cds-pager__prev", 3, "cdsPagerHidden", "ngClass", "click"], ["class", "cds-icon-angle-left", 4, "ngIf", "ngIfElse"], ["prevNotArrowsRef", ""], ["class", "cds-pager__page-selector", 4, "ngIf"], [1, "cds-pager__page-selector-short"], [1, "cds-pager__page", "cds-pager__current-page"], [1, "cds-pager__page"], ["class", "cds-icon-angle-right", 4, "ngIf", "ngIfElse"], ["nextNotArrowsRef", ""], [1, "cds-icon-double-angle-right"], [1, "cds-pager__clear"], [1, "cds-pager__page-size-selector"], ["aria-hidden", "true"], [3, "appearance", "ngModel", "ngModelChange"], ["tabindex", "-1", 3, "cdsComboItem", 4, "ngFor", "ngForOf"], ["aria-hidden", "true", 1, "cds-pager__pager-info"], ["tabindex", "-1", 3, "cdsComboItem"], [1, "cds-icon-angle-left"], [1, "cds-pager__page-selector"], [4, "ngFor", "ngForOf"], ["cdsButton", "", "class", "cds-button-icon cds-button-small", 3, "cds-pager__current-number", "cds-pager__number", "click", 4, "ngIf"], ["class", "cds-pager__page", "aria-hidden", "true", 4, "ngIf"], ["cdsButton", "", 1, "cds-button-icon", "cds-button-small", 3, "click"], ["aria-hidden", "true", 1, "cds-pager__page"], [1, "cds-icon-angle-right"]], template: function PagerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, PagerComponent_div_0_Template, 13, 15, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "span", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵpipe(3, "cdsPagerInterpolate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "button", 3);
        ɵngcc0.ɵɵlistener("click", function PagerComponent_Template_button_click_5_listener($event) { return ctx.first($event); });
        ɵngcc0.ɵɵelement(6, "i", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "button", 5);
        ɵngcc0.ɵɵlistener("click", function PagerComponent_Template_button_click_7_listener($event) { return ctx.prev($event); });
        ɵngcc0.ɵɵtemplate(8, PagerComponent_i_8_Template, 1, 0, "i", 6);
        ɵngcc0.ɵɵtemplate(9, PagerComponent_ng_template_9_Template, 1, 1, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, PagerComponent_div_11_Template, 3, 4, "div", 8);
        ɵngcc0.ɵɵelementStart(12, "div", 9);
        ɵngcc0.ɵɵelementStart(13, "span", 10);
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "span", 11);
        ɵngcc0.ɵɵtext(16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "span", 11);
        ɵngcc0.ɵɵtext(18);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "button", 5);
        ɵngcc0.ɵɵlistener("click", function PagerComponent_Template_button_click_19_listener($event) { return ctx.next($event); });
        ɵngcc0.ɵɵtemplate(20, PagerComponent_i_20_Template, 1, 0, "i", 12);
        ɵngcc0.ɵɵtemplate(21, PagerComponent_ng_template_21_Template, 1, 1, "ng-template", null, 13, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "button", 3);
        ɵngcc0.ɵɵlistener("click", function PagerComponent_Template_button_click_23_listener($event) { return ctx.last($event); });
        ɵngcc0.ɵɵelement(24, "i", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(25, "span", 15);
    } if (rf & 2) {
        var _r2 = ɵngcc0.ɵɵreference(10);
        var _r6 = ɵngcc0.ɵɵreference(22);
        ɵngcc0.ɵɵproperty("ngIf", ctx.enablePageSizeChange);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind4(3, 22, ctx.translations.srVisibleItems, ctx.fromElement, ctx.toElement, ctx.totalElements));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("cdsPagerHidden", ctx.isFirst() || !ctx.arrows);
        ɵngcc0.ɵɵattribute("aria-label", ctx.translations.firstPage);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("cdsPagerHidden", ctx.isFirst())("ngClass", ctx.arrows ? "cds-button-icon cds-button-small" : "cds-button-text cds-pager__link");
        ɵngcc0.ɵɵattribute("aria-label", ctx.translations.previousPage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.arrows)("ngIfElse", _r2);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.short);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("cds-pager__page-selector-short-dynamic", !ctx.short);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.currentPage);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.translations.of);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.totalPages);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("cdsPagerHidden", ctx.isLast())("ngClass", ctx.arrows ? "cds-button-icon cds-button-small" : "cds-button-text cds-pager__link");
        ɵngcc0.ɵɵattribute("aria-label", ctx.translations.nextPage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.arrows)("ngIfElse", _r6);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("cdsPagerHidden", ctx.isLast() || !ctx.arrows);
        ɵngcc0.ɵɵattribute("aria-label", ctx.translations.lastPage);
    } }, directives: [ɵngcc1.NgIf, ButtonRippleDirective, PagerHiddenDirective, ɵngcc1.NgClass, ComboComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc1.NgForOf, ComboItemDirective], pipes: [PagerInterpolatePipe, PagerSizesPipe, GeneratePagesPipe], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PagerComponent, [{
        type: Component,
        args: [{
                selector: 'cds-pager',
                template: "<div *ngIf=\"enablePageSizeChange\" class=\"cds-pager__page-size-selector\">\n\t<span aria-hidden=\"true\">{{translations.itemsPerPage}}:</span>\n\t<cds-combo [appearance]=\"'inline'\"\n\t           [attr.aria-label]=\"translations.itemsPerPage + ': ' + pageSize\"\n\t           [(ngModel)]=\"pageSize\"\n\t           (ngModelChange)=\"pageSizeChanged()\">\n\t\t<label>{{pageSize}}</label>\n\t\t<ul>\n\t\t\t<li [cdsComboItem]=\"item\" tabindex=\"-1\" *ngFor=\"let item of pageSizes | cdsPagerSizes:pageSize\">{{item}}</li>\n\t\t</ul>\n\t</cds-combo>\n\t| <span class=\"cds-pager__pager-info\" aria-hidden=\"true\">{{translations.visibleItems | cdsPagerInterpolate:fromElement:toElement:totalElements}}</span>\n</div>\n<span class=\"cds-sr-only\" role=\"status\" aria-live=\"polite\">{{translations.srVisibleItems | cdsPagerInterpolate:fromElement:toElement:totalElements}}</span>\n<div class=\"cds-pager__pages\" role=\"navigation\">\n\t<button cdsButton class=\"cds-button-icon cds-button-small\"\n\t        [cdsPagerHidden]=\"isFirst() || !arrows\"\n\t        (click)=\"first($event)\"\n\t        [attr.aria-label]=\"translations.firstPage\">\n\t\t<i class=\"cds-icon-double-angle-left\"></i>\n\t</button>\n\t<button cdsButton class=\"cds-pager__prev\"\n\t        [cdsPagerHidden]=\"isFirst()\"\n\t        [ngClass]=\"arrows ? 'cds-button-icon cds-button-small' : 'cds-button-text cds-pager__link'\"\n\t        (click)=\"prev($event)\"\n\t        [attr.aria-label]=\"translations.previousPage\">\n\t\t<i *ngIf=\"arrows; else prevNotArrowsRef\" class=\"cds-icon-angle-left\"></i>\n\t\t<ng-template #prevNotArrowsRef>{{translations.previous}}</ng-template>\n\t</button>\n\t<div class=\"cds-pager__page-selector\" *ngIf=\"!short\">\n\t\t<ng-container *ngFor=\"let page of (totalPages | cdsGeneratePages:currentPage)\">\n\t\t\t<button *ngIf=\"page\" cdsButton\n\t\t\t        class=\"cds-button-icon cds-button-small\"\n\t\t\t        [attr.aria-current]=\"page === currentPage ? 'page' : null\"\n\t\t\t        [class.cds-pager__current-number]=\"page === currentPage\"\n\t\t\t        [class.cds-pager__number]=\"page !== currentPage\"\n\t\t\t        [attr.aria-label]=\"(translations.pageNumber | cdsPagerInterpolate:page) + (page === currentPage ? ', ' + translations.currentPage : '')\"\n\t\t\t        (click)=\"changePage(page)\">{{page}}</button>\n\t\t\t<div *ngIf=\"!page\" class=\"cds-pager__page\" aria-hidden=\"true\">...</div>\n\t\t</ng-container>\n\t</div>\n\t<div class=\"cds-pager__page-selector-short\" [class.cds-pager__page-selector-short-dynamic]=\"!short\">\n\t\t<span class=\"cds-pager__page cds-pager__current-page\">{{currentPage}}</span>\n\t\t<span class=\"cds-pager__page\">{{translations.of}}</span>\n\t\t<span class=\"cds-pager__page\">{{totalPages}}</span>\n\t</div>\n\t<button cdsButton class=\"cds-pager__prev\"\n\t        [cdsPagerHidden]=\"isLast()\"\n\t        [ngClass]=\"arrows ? 'cds-button-icon cds-button-small' : 'cds-button-text cds-pager__link'\"\n\t        (click)=\"next($event)\"\n\t        [attr.aria-label]=\"translations.nextPage\">\n\t\t<i *ngIf=\"arrows; else nextNotArrowsRef\" class=\"cds-icon-angle-right\"></i>\n\t\t<ng-template #nextNotArrowsRef>{{translations.next}}</ng-template>\n\t</button>\n\t<button cdsButton class=\"cds-button-icon cds-button-small\"\n\t        [cdsPagerHidden]=\"isLast() || !arrows\"\n\t        (click)=\"last($event)\"\n\t        [attr.aria-label]=\"translations.lastPage\">\n\t\t<i class=\"cds-icon-double-angle-right\"></i>\n\t</button>\n</div>\n<span class=\"cds-pager__clear\"></span>\n",
                providers: [
                    DynamicTranslations,
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: DynamicTranslations }]; }, { enablePageSizeChange: [{
            type: Input
        }], pageSizes: [{
            type: Input
        }], pageSizeChange: [{
            type: Output
        }], currentPageChange: [{
            type: Output
        }], currentPage: [{
            type: Input
        }], totalElements: [{
            type: Input
        }], pageSize: [{
            type: Input
        }], short: [{
            type: Input
        }], arrows: [{
            type: Input
        }] }); })();
    return PagerComponent;
}());

var PagerModule = /** @class */ (function () {
    function PagerModule() {
    }
PagerModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: PagerModule });
PagerModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function PagerModule_Factory(t) { return new (t || PagerModule)(); }, imports: [[
            ComboModule,
            CommonModule,
            FormsModule,
            ButtonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PagerModule, { declarations: function () { return [GeneratePagesPipe, PagerComponent, PagerHiddenDirective, PagerInterpolatePipe, PagerSizesPipe]; }, imports: function () { return [ComboModule, CommonModule,
        FormsModule, ButtonModule]; }, exports: function () { return [PagerComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PagerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    ComboModule,
                    CommonModule,
                    FormsModule,
                    ButtonModule,
                ],
                declarations: [
                    GeneratePagesPipe,
                    PagerComponent,
                    PagerHiddenDirective,
                    PagerInterpolatePipe,
                    PagerSizesPipe,
                ],
                exports: [
                    PagerComponent,
                ]
            }]
    }], function () { return []; }, null); })();
    return PagerModule;
}());

var PopoverToolbarComponent = /** @class */ (function () {
    function PopoverToolbarComponent(elementRef, renderer, cdRef) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.cdRef = cdRef;
        this.transition = false;
        renderer.addClass(elementRef.nativeElement, 'cds-popover-toolbar');
    }
    PopoverToolbarComponent.prototype.isOpened = function (template, vcRef) {
        return this.template === template && this.vcRef === vcRef;
    };
    PopoverToolbarComponent.prototype.open = function (template, context, anchor, vcRef) {
        var _this = this;
        if (this.template === template && this.vcRef === vcRef) {
            this.close();
            return false;
        }
        if (this.template) {
            this.transition = true;
        }
        this.template = template;
        this.context = context;
        if (!this.viewRef) {
            this.viewRef = this.dropdownTemplate.createEmbeddedView();
        }
        if (this.vcRef && this.vcRef !== vcRef) {
            var index = this.vcRef.indexOf(this.viewRef);
            if (index !== -1) {
                this.vcRef.detach(index);
                this.cdRef.detectChanges();
            }
        }
        if (this.vcRef !== vcRef) {
            vcRef.insert(this.viewRef);
            this.vcRef = vcRef;
        }
        this.cdRef.detectChanges();
        setTimeout(function () {
            if (_this.dropdown) {
                _this.dropdown.scheduleUpdate();
                _this.calculatePosition(anchor);
            }
        });
        return true;
    };
    /** @deprecated */
    PopoverToolbarComponent.prototype.toggle = function (template, anchor) {
        if (this.viewRef) {
            this.viewRef.destroy();
            this.viewRef = null;
            this.vcRef = null;
        }
        if (this.template) {
            this.transition = true;
        }
        this.anchor = anchor;
        this.template = template;
        this.context = null;
        this.cdRef.detectChanges();
        this.dropdown.scheduleUpdate();
        this.calculatePosition(anchor);
    };
    PopoverToolbarComponent.prototype.calculatePosition = function (anchor) {
        var _this = this;
        requestAnimationFrame(function () {
            _this.position = _this.dropdown.calculatePosition();
            _this.cdRef.detectChanges();
            var toolbarElement = anchor.parentElement;
            var horizontalPosition = anchor.offsetLeft - toolbarElement.offsetLeft + anchor.offsetWidth / 2;
            _this.renderer.setStyle(_this.arrow.nativeElement, 'transform', "translate(" + horizontalPosition + "px, 0)");
            if (_this.position === 'bottom') {
                _this.renderer.addClass(_this.arrow.nativeElement, 'cds-popover-toolbar__arrow--bottom');
                _this.renderer.removeClass(_this.arrow.nativeElement, 'cds-popover-toolbar__arrow--top');
            }
            else if (_this.position === 'top') {
                _this.renderer.removeClass(_this.arrow.nativeElement, 'cds-popover-toolbar__arrow--bottom');
                _this.renderer.addClass(_this.arrow.nativeElement, 'cds-popover-toolbar__arrow--top');
            }
        });
    };
    /** @deprecated */
    PopoverToolbarComponent.prototype.isOpen = function (anchor) {
        return this.anchor === anchor;
    };
    PopoverToolbarComponent.prototype.close = function () {
        this.template = null;
        this.context = null;
        this.anchor = null;
        this.transition = false;
        this.position = null;
        if (this.viewRef) {
            this.viewRef.destroy();
            this.viewRef = null;
            this.vcRef = null;
        }
        this.cdRef.detectChanges();
    };
    PopoverToolbarComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ChangeDetectorRef }
    ]; };
    __decorate([
        ViewChild('dropdownTemplate', { static: true }),
        __metadata("design:type", TemplateRef)
    ], PopoverToolbarComponent.prototype, "dropdownTemplate", void 0);
    __decorate([
        ViewChild('dropdown', { read: DropdownComponent }),
        __metadata("design:type", DropdownComponent)
    ], PopoverToolbarComponent.prototype, "dropdown", void 0);
    __decorate([
        ViewChild('arrow', { read: ElementRef }),
        __metadata("design:type", ElementRef)
    ], PopoverToolbarComponent.prototype, "arrow", void 0);
    PopoverToolbarComponent = __decorate([ __metadata("design:paramtypes", [ElementRef, Renderer2, ChangeDetectorRef])
    ], PopoverToolbarComponent);
PopoverToolbarComponent.ɵfac = function PopoverToolbarComponent_Factory(t) { return new (t || PopoverToolbarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
PopoverToolbarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PopoverToolbarComponent, selectors: [["cds-popover-toolbar"]], viewQuery: function PopoverToolbarComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c61, true);
        ɵngcc0.ɵɵviewQuery(_c14, true, DropdownComponent);
        ɵngcc0.ɵɵviewQuery(_c62, true, ElementRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdownTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.arrow = _t.first);
    } }, ngContentSelectors: _c2, decls: 7, vars: 2, consts: [[1, "cds-popover-toolbar__toolbar"], ["toolbar", ""], ["class", "cds-popover-toolbar__dropdown", 3, "ngClass", "anchor", "dismiss", 4, "ngIf"], ["dropdownTemplate", ""], ["class", "cds-popover-toolbar__arrow", 3, "cds-popover-toolbar__arrow-transition", 4, "ngIf"], [1, "cds-popover-toolbar__dropdown", 3, "ngClass", "anchor", "dismiss"], ["dropdown", ""], [1, "dropdown-menu", "dropdown-menu--auto-height"], [4, "ngTemplateOutlet"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "cds-popover-toolbar__arrow"], ["arrow", ""], [1, "cds-popover-toolbar__arrow-svg"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 16 8", "focusable", "false"], ["d", "M3 0h10l-5 5z"]], template: function PopoverToolbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, PopoverToolbarComponent_cds_dropdown_3_Template, 4, 4, "cds-dropdown", 2);
        ɵngcc0.ɵɵtemplate(4, PopoverToolbarComponent_ng_template_4_Template, 4, 5, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(6, PopoverToolbarComponent_div_6_Template, 5, 3, "div", 4);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.template && !ctx.viewRef);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.template && ctx.position);
    } }, directives: [ɵngcc1.NgIf, DropdownComponent, ɵngcc1.NgClass, ɵngcc1.NgTemplateOutlet], encapsulation: 2, data: { animation: [
            trigger('arrow', __spread([
                transition(':leave', [style({ opacity: 0 })])
            ], dropdownAnimation)),
        ] }, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PopoverToolbarComponent, [{
        type: Component,
        args: [{
                selector: 'cds-popover-toolbar',
                template: "<div class=\"cds-popover-toolbar__toolbar\" #toolbar>\n\t<ng-content></ng-content>\n</div>\n<cds-dropdown #dropdown [ngClass]=\"{'cds-dropdown--menu': false}\" class=\"cds-popover-toolbar__dropdown\" *ngIf=\"template && !viewRef\" [anchor]=\"toolbar\" (dismiss)=\"close()\">\n\t<div class=\"dropdown-menu dropdown-menu--auto-height\">\n\t\t<ng-container *ngTemplateOutlet=\"template\"></ng-container>\n\t</div>\n</cds-dropdown>\n<ng-template #dropdownTemplate>\n\t<cds-dropdown #dropdown [ngClass]=\"{'cds-dropdown--menu': false}\" class=\"cds-popover-toolbar__dropdown\" [anchor]=\"toolbar\" (dismiss)=\"close()\">\n\t\t<div class=\"dropdown-menu dropdown-menu--auto-height\">\n\t\t\t<ng-container *ngTemplateOutlet=\"template; context: context\"></ng-container>\n\t\t</div>\n\t</cds-dropdown>\n</ng-template>\n<div *ngIf=\"template && position\"\n     class=\"cds-popover-toolbar__arrow\"\n     [class.cds-popover-toolbar__arrow-transition]=\"transition\"\n     #arrow\n     [@arrow]=\"1\">\n\t<div class=\"cds-popover-toolbar__arrow-svg\">\n\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 8\" focusable=\"false\">\n\t\t\t<path d=\"M3 0h10l-5 5z\"/>\n\t\t</svg>\n\t</div>\n</div>\n",
                animations: [
                    trigger('arrow', __spread([
                        transition(':leave', [style({ opacity: 0 })])
                    ], dropdownAnimation)),
                ],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }]; }, { dropdownTemplate: [{
            type: ViewChild,
            args: ['dropdownTemplate', { static: true }]
        }], dropdown: [{
            type: ViewChild,
            args: ['dropdown', { read: DropdownComponent }]
        }], arrow: [{
            type: ViewChild,
            args: ['arrow', { read: ElementRef }]
        }] }); })();
    return PopoverToolbarComponent;
}());

var PopoverToggleDirective = /** @class */ (function () {
    function PopoverToggleDirective(toolbar, elementRef, vcRef, renderer) {
        this.toolbar = toolbar;
        this.elementRef = elementRef;
        this.vcRef = vcRef;
        renderer.setAttribute(elementRef.nativeElement, 'aria-haspopup', 'true');
    }
    Object.defineProperty(PopoverToggleDirective.prototype, "attrAriaExpanded", {
        get: function () {
            return this.toolbar.isOpened(this.cdsPopoverToggle, this.vcRef);
        },
        enumerable: true,
        configurable: true
    });
    PopoverToggleDirective.prototype.ngOnChanges = function (changes) {
        if ('popoverId' in changes) {
            if (this.popoverId === true) {
                this.controls = Unique.next('cds-popover-');
            }
            else if (this.popoverId) {
                this.controls = this.popoverId;
            }
            else {
                this.controls = null;
            }
        }
    };
    PopoverToggleDirective.prototype.onClick = function () {
        this.toolbar.open(this.cdsPopoverToggle, {
            popoverId: this.controls,
        }, this.elementRef.nativeElement, this.vcRef);
    };
    PopoverToggleDirective.ctorParameters = function () { return [
        { type: PopoverToolbarComponent, decorators: [{ type: Host }] },
        { type: ElementRef },
        { type: ViewContainerRef },
        { type: Renderer2 }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", TemplateRef)
    ], PopoverToggleDirective.prototype, "cdsPopoverToggle", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], PopoverToggleDirective.prototype, "popoverId", void 0);
    __decorate([
        HostBinding('attr.aria-expanded'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], PopoverToggleDirective.prototype, "attrAriaExpanded", null);
    __decorate([
        HostBinding('attr.aria-controls'),
        __metadata("design:type", String)
    ], PopoverToggleDirective.prototype, "controls", void 0);
    __decorate([
        HostListener('click'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PopoverToggleDirective.prototype, "onClick", null);
    PopoverToggleDirective = __decorate([ __param(0, Host()),
        __metadata("design:paramtypes", [PopoverToolbarComponent,
            ElementRef,
            ViewContainerRef,
            Renderer2])
    ], PopoverToggleDirective);
PopoverToggleDirective.ɵfac = function PopoverToggleDirective_Factory(t) { return new (t || PopoverToggleDirective)(ɵngcc0.ɵɵdirectiveInject(PopoverToolbarComponent, 1), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
PopoverToggleDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: PopoverToggleDirective, selectors: [["", "cdsPopoverToggle", ""]], hostVars: 2, hostBindings: function PopoverToggleDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function PopoverToggleDirective_click_HostBindingHandler() { return ctx.onClick(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-expanded", ctx.attrAriaExpanded)("aria-controls", ctx.controls);
    } }, inputs: { cdsPopoverToggle: "cdsPopoverToggle", popoverId: "popoverId" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PopoverToggleDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsPopoverToggle]'
            }]
    }], function () { return [{ type: PopoverToolbarComponent, decorators: [{
                type: Host
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.Renderer2 }]; }, { attrAriaExpanded: [{
            type: HostBinding,
            args: ['attr.aria-expanded']
        }], controls: [{
            type: HostBinding,
            args: ['attr.aria-controls']
        }], onClick: [{
            type: HostListener,
            args: ['click']
        }], cdsPopoverToggle: [{
            type: Input
        }], popoverId: [{
            type: Input
        }] }); })();
    return PopoverToggleDirective;
}());

var PopoverComponent = /** @class */ (function () {
    function PopoverComponent(elementRef, renderer) {
        renderer.addClass(elementRef.nativeElement, 'cds-popover');
    }
    PopoverComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
    PopoverComponent = __decorate([ __metadata("design:paramtypes", [ElementRef, Renderer2])
    ], PopoverComponent);
PopoverComponent.ɵfac = function PopoverComponent_Factory(t) { return new (t || PopoverComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
PopoverComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: PopoverComponent, selectors: [["cds-popover"]], ngContentSelectors: _c65, decls: 9, vars: 0, consts: [[1, "cds-popover__header"], [1, "cds-popover__title"], [1, "cds-popover__header-action"], [1, "cds-popover__section"], [1, "cds-popover__footer"]], template: function PopoverComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c64);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵprojection(4, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵprojection(6, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵprojection(8, 3);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PopoverComponent, [{
        type: Component,
        args: [{
                selector: 'cds-popover',
                template: "<div class=\"cds-popover__header\">\n\t<div class=\"cds-popover__title\">\n\t\t<ng-content select=\"cds-slot-title,header\"></ng-content>\n\t</div>\n\t<div class=\"cds-popover__header-action\">\n\t\t<ng-content select=\"header-action\"></ng-content>\n\t</div>\n</div>\n<div class=\"cds-popover__section\">\n\t<ng-content select=\"cds-slot-content,section\"></ng-content>\n</div>\n<div class=\"cds-popover__footer\">\n\t<ng-content select=\"cds-slot-footer,footer\"></ng-content>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, null); })();
    return PopoverComponent;
}());

var PopoverModule = /** @class */ (function () {
    function PopoverModule() {
    }
PopoverModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: PopoverModule });
PopoverModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function PopoverModule_Factory(t) { return new (t || PopoverModule)(); }, imports: [[
            CommonModule,
            DropdownModule,
            SlotsModule,
        ], SlotsModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PopoverModule, { declarations: function () { return [PopoverComponent, PopoverToggleDirective, PopoverToolbarComponent]; }, imports: function () { return [CommonModule, DropdownModule, SlotsModule]; }, exports: function () { return [PopoverComponent, PopoverToggleDirective, PopoverToolbarComponent, SlotsModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PopoverModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    DropdownModule,
                    SlotsModule,
                ],
                declarations: [
                    PopoverComponent,
                    PopoverToggleDirective,
                    PopoverToolbarComponent,
                ],
                exports: [
                    PopoverComponent,
                    PopoverToggleDirective,
                    PopoverToolbarComponent,
                    // modules
                    SlotsModule,
                ]
            }]
    }], function () { return []; }, null); })();
    return PopoverModule;
}());

var AbstractFocusGroupDirective = /** @class */ (function () {
    function AbstractFocusGroupDirective(renderer, elementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.removeListenersMap = new Map();
    }
    AbstractFocusGroupDirective.prototype.ngDoCheck = function () {
        this.updatePrimaryItem();
    };
    AbstractFocusGroupDirective.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.updatePrimaryItem();
        this.focusableItems.changes.subscribe(function () {
            var oldMap = _this.removeListenersMap;
            _this.removeListenersMap = new Map();
            _this.focusableItems.forEach(function (item) {
                if (oldMap.has(item)) {
                    oldMap.delete(item);
                }
                else {
                    _this.addFocusEventListeners(item);
                }
            });
            oldMap.forEach(function (removeListeners) {
                removeListeners();
            });
        });
        this.focusableItems.notifyOnChanges();
    };
    AbstractFocusGroupDirective.prototype.ngOnDestroy = function () {
        this.removeListenersMap.forEach(function (removeListeners) {
            removeListeners();
        });
    };
    AbstractFocusGroupDirective.prototype.updatePrimaryItem = function () {
        var _this = this;
        if (!this.focusWithin && this.focusableItems) {
            var focusableItem_1 = this.findFirstFocusableItem();
            this.focusableItems.forEach(function (item) {
                _this.setPrimaryItem(item, item === focusableItem_1);
            });
        }
    };
    AbstractFocusGroupDirective.prototype.findFirstFocusableItem = function () {
        var _this = this;
        if (this.focusableItems.length) {
            var firstItem = this.focusableItems.find(function (item) { return _this.isInitialFocus(item); })
                || this.focusableItems.first;
            if (firstItem) {
                return firstItem;
            }
        }
        return null;
    };
    AbstractFocusGroupDirective.prototype.addFocusEventListeners = function (item) {
        var _this = this;
        var element = this.getFocusNativeElement(item);
        var removeFocus = listen(element, 'focus', function (event) {
            _this.focusWithin = true;
            _this.setPrimaryItem(item, true);
        }, { capture: true });
        var removeBlur = listen(element, 'blur', function (event) {
            _this.focusWithin = false;
            if (!_this.elementRef.nativeElement.contains(event.relatedTarget)) {
                var firstItem = _this.findFirstFocusableItem();
                if (firstItem !== item) {
                    _this.setPrimaryItem(item, false);
                    _this.setPrimaryItem(firstItem, true);
                }
            }
            else {
                _this.setPrimaryItem(item, false);
            }
        }, { capture: true });
        var removeKeyDown = listen(element, 'keydown', function (event) {
            _this.onKeyDown(event, item);
        }, { capture: true });
        this.removeListenersMap.set(item, function () {
            removeFocus();
            removeBlur();
            removeKeyDown();
        });
    };
    AbstractFocusGroupDirective.prototype.onKeyDown = function (event, item) {
        var _this = this;
        var options = this.focusGroupOptions;
        var action;
        switch (event.key) {
            case 'ArrowLeft':
            case 'Left':
                if (options.useHorizontalArrowKeys) {
                    action = 'prev';
                }
                break;
            case 'ArrowUp':
            case 'Up':
                if (options.useVerticalArrowKeys) {
                    action = 'prev';
                }
                break;
            case 'ArrowRight':
            case 'Right':
                if (options.useHorizontalArrowKeys) {
                    action = 'next';
                }
                break;
            case 'ArrowDown':
            case 'Down':
                if (options.useVerticalArrowKeys) {
                    action = 'next';
                }
                break;
            case 'Home':
                if (options.useHomeEndKeys) {
                    action = 'start';
                }
                break;
            case 'End':
                if (options.useHomeEndKeys) {
                    action = 'end';
                }
                break;
        }
        if (action) {
            var items = this.focusableItems.toArray();
            var length_1 = this.focusableItems.length;
            var index = this.findItemIndex(item);
            var focusItem = void 0;
            switch (action) {
                case 'next':
                    if (index != null) {
                        for (var i = index + 1; i < (index + length_1); ++i) {
                            var currentItem = items[i % length_1];
                            if (this.canBeFocused(currentItem)) {
                                focusItem = currentItem;
                                break;
                            }
                        }
                    }
                    break;
                case 'prev':
                    if (index != null) {
                        for (var i = index + length_1 - 1; i > index; --i) {
                            var currentItem = items[i % length_1];
                            if (this.canBeFocused(currentItem)) {
                                focusItem = currentItem;
                                break;
                            }
                        }
                    }
                    break;
                case 'start':
                    focusItem = items.find(function (item) { return _this.canBeFocused(item); });
                    break;
                case 'end':
                    focusItem = items.reduceRight(function (element, item) { return element || (_this.canBeFocused(item) ? item : null); }, null);
                    break;
            }
            if (focusItem) {
                var element = this.getFocusNativeElement(focusItem);
                event.preventDefault();
                element.focus();
                if (this.automaticActivation) {
                    element.click();
                }
            }
        }
        return false;
    };
    AbstractFocusGroupDirective.prototype.findItemIndex = function (searchForItem) {
        var foundIndex = null;
        this.focusableItems.some(function (item, index) {
            if (item === searchForItem) {
                foundIndex = index;
                return true;
            }
            else {
                return false;
            }
        });
        return foundIndex;
    };
    AbstractFocusGroupDirective.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], AbstractFocusGroupDirective.prototype, "automaticActivation", void 0);
    AbstractFocusGroupDirective = __decorate([ __metadata("design:paramtypes", [Renderer2, ElementRef])
    ], AbstractFocusGroupDirective);
AbstractFocusGroupDirective.ɵfac = function AbstractFocusGroupDirective_Factory(t) { return new (t || AbstractFocusGroupDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
AbstractFocusGroupDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AbstractFocusGroupDirective, inputs: { automaticActivation: "automaticActivation" } });
AbstractFocusGroupDirective.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AbstractFocusGroupDirective, factory: function (t) { return AbstractFocusGroupDirective.ɵfac(t); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbstractFocusGroupDirective, [{
        type: Directive
    }, {
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { automaticActivation: [{
            type: Input
        }] }); })();
    return AbstractFocusGroupDirective;
}());

var RADIO_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return RadioComponent; }),
    multi: true,
};
var RadioComponent = /** @class */ (function (_super) {
    __extends(RadioComponent, _super);
    function RadioComponent(cdRef, toggleGroupDirective, platform, renderer, elementRef, zone, rippleService) {
        var _this = _super.call(this, cdRef) || this;
        _this.toggleGroupDirective = toggleGroupDirective;
        _this.platform = platform;
        _this.renderer = renderer;
        _this.elementRef = elementRef;
        _this.zone = zone;
        _this.rippleService = rippleService;
        _this.labelId = Unique.next('cds-radio__label-');
        _this.uncheckable = false;
        renderer.addClass(elementRef.nativeElement, 'cds-radio');
        renderer.setAttribute(elementRef.nativeElement, 'role', 'radio');
        if (toggleGroupDirective) {
            toggleGroupDirective.registerComponent(_this);
        }
        return _this;
    }
    Object.defineProperty(RadioComponent.prototype, "ariaLabelledBy", {
        get: function () {
            return this.label ? this.labelId : null;
        },
        enumerable: true,
        configurable: true
    });
    RadioComponent.prototype.ngAfterViewInit = function () {
        this.rippleService.createForToggle(this.elementRef.nativeElement);
    };
    RadioComponent.prototype.ngOnDestroy = function () {
        if (this.toggleGroupDirective) {
            this.toggleGroupDirective.unregisterComponent(this);
        }
    };
    RadioComponent.prototype.onClick = function (event) {
        event.preventDefault();
        if (this.isBlocked) {
            return;
        }
        this.setChecked(!this.isChecked);
    };
    RadioComponent.prototype.getNativeElement = function () {
        return this.elementRef.nativeElement;
    };
    RadioComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ToggleGroupDirective, decorators: [{ type: Host }, { type: Optional }] },
        { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
        { type: Renderer2 },
        { type: ElementRef },
        { type: NgZone },
        { type: RippleService }
    ]; };
    __decorate([
        HostBinding('attr.aria-labelledby'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], RadioComponent.prototype, "ariaLabelledBy", null);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], RadioComponent.prototype, "label", void 0);
    __decorate([
        HostListener('click', ['$event']),
        HostListener('keydown.enter', ['$event']),
        HostListener('keydown.space', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Event]),
        __metadata("design:returntype", void 0)
    ], RadioComponent.prototype, "onClick", null);
    RadioComponent = __decorate([ __param(1, Host()), __param(1, Optional()),
        __param(2, Inject(PLATFORM_ID)),
        __metadata("design:paramtypes", [ChangeDetectorRef,
            ToggleGroupDirective, Object, Renderer2,
            ElementRef,
            NgZone,
            RippleService])
    ], RadioComponent);
RadioComponent.ɵfac = function RadioComponent_Factory(t) { return new (t || RadioComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ToggleGroupDirective, 9), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(RippleService)); };
RadioComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: RadioComponent, selectors: [["cds-radio"]], hostVars: 8, hostBindings: function RadioComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function RadioComponent_click_HostBindingHandler($event) { return ctx.onClick($event); })("keydown.enter", function RadioComponent_keydown_enter_HostBindingHandler($event) { return ctx.onClick($event); })("keydown.space", function RadioComponent_keydown_space_HostBindingHandler($event) { return ctx.onClick($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-checked", ctx.ariaChecked)("aria-disabled", ctx.ariaDisabled)("tabindex", ctx.attrTabindex)("aria-labelledby", ctx.ariaLabelledBy);
        ɵngcc0.ɵɵclassProp("checked", ctx.isChecked)("disabled", ctx.isDisabled);
    } }, inputs: { tabindex: "tabindex", value: "value", uncheckable: "uncheckable", label: "label" }, features: [ɵngcc0.ɵɵProvidersFeature([RADIO_CONTROL_VALUE_ACCESSOR]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 5, vars: 1, consts: [["tabindex", "-1", 1, "toggle-wrapper"], [1, "cds-zero-width-space"], [1, "radio", "cds-ripple", "cds-ripple--toggle-fade-delay"], [1, "radio__background"], [4, "ngIf"]], template: function RadioComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "span", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵelement(3, "span", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, RadioComponent_label_4_Template, 2, 2, "label", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RadioComponent, [{
        type: Component,
        args: [{
                selector: 'cds-radio',
                template: "<div class=\"toggle-wrapper\" tabindex=\"-1\">\n\t<span class=\"cds-zero-width-space\"></span>\n\t<span class=\"radio cds-ripple cds-ripple--toggle-fade-delay\">\n\t\t<span class=\"radio__background\"></span>\n\t</span>\n\t<label *ngIf=\"label\" [attr.id]=\"labelId\">{{label}}</label>\n</div>",
                providers: [RADIO_CONTROL_VALUE_ACCESSOR],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                inputs: ABSTRACT_TOGGLE_COMPONENT_INPUTS,
                host: ABSTRACT_TOGGLE_COMPONENT_HOST
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ToggleGroupDirective, decorators: [{
                type: Host
            }, {
                type: Optional
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }, { type: RippleService }]; }, { ariaLabelledBy: [{
            type: HostBinding,
            args: ['attr.aria-labelledby']
        }], onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }, {
            type: HostListener,
            args: ['keydown.enter', ['$event']]
        }, {
            type: HostListener,
            args: ['keydown.space', ['$event']]
        }], label: [{
            type: Input
        }] }); })();
    return RadioComponent;
}(AbstractToggleComponent));

var RadioGroupDirective = /** @class */ (function (_super) {
    __extends(RadioGroupDirective, _super);
    function RadioGroupDirective(renderer, elementRef, cdRef) {
        var _this = _super.call(this, renderer, elementRef) || this;
        _this.cdRef = cdRef;
        _this.focusGroupOptions = {
            useVerticalArrowKeys: true,
            useHorizontalArrowKeys: true,
        };
        renderer.setAttribute(elementRef.nativeElement, 'role', 'radiogroup');
        return _this;
    }
    RadioGroupDirective.prototype.getFocusNativeElement = function (item) {
        return item.getNativeElement();
    };
    RadioGroupDirective.prototype.isInitialFocus = function (item) {
        return item.isChecked && !item.isDisabled;
    };
    RadioGroupDirective.prototype.canBeFocused = function (item) {
        return !item.isDisabled;
    };
    RadioGroupDirective.prototype.setPrimaryItem = function (item, primary) {
        var _this = this;
        var overrideTabindex = !primary;
        if (item.overrideTabindex !== overrideTabindex) {
            // Delay for change detection cycle to avoid ExpressionChangedAfterItHasBeenCheckedError
            Promise.resolve().then(function () {
                item.overrideTabindex = overrideTabindex;
                _this.cdRef.markForCheck();
            });
        }
    };
    RadioGroupDirective.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef },
        { type: ChangeDetectorRef }
    ]; };
    __decorate([
        ContentChildren(RadioComponent, { descendants: true }),
        __metadata("design:type", QueryList)
    ], RadioGroupDirective.prototype, "focusableItems", void 0);
    RadioGroupDirective = __decorate([ __metadata("design:paramtypes", [Renderer2, ElementRef, ChangeDetectorRef])
    ], RadioGroupDirective);
RadioGroupDirective.ɵfac = function RadioGroupDirective_Factory(t) { return new (t || RadioGroupDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
RadioGroupDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: RadioGroupDirective, selectors: [["", "cdsRadioGroup", ""]], contentQueries: function RadioGroupDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, RadioComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.focusableItems = _t);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RadioGroupDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsRadioGroup]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { focusableItems: [{
            type: ContentChildren,
            args: [RadioComponent, { descendants: true }]
        }] }); })();
    return RadioGroupDirective;
}(AbstractFocusGroupDirective));

var RadioModule = /** @class */ (function () {
    function RadioModule() {
    }
RadioModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: RadioModule });
RadioModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function RadioModule_Factory(t) { return new (t || RadioModule)(); }, imports: [[
            CommonModule,
            RippleModule,
            ToggleModule,
        ], ToggleModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(RadioModule, { declarations: function () { return [RadioComponent, RadioGroupDirective]; }, imports: function () { return [CommonModule, RippleModule, ToggleModule]; }, exports: function () { return [RadioComponent, RadioGroupDirective, ToggleModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(RadioModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    RippleModule,
                    ToggleModule,
                ],
                declarations: [
                    RadioComponent,
                    RadioGroupDirective,
                ],
                exports: [
                    RadioComponent,
                    RadioGroupDirective,
                    // modules
                    ToggleModule,
                ]
            }]
    }], function () { return []; }, null); })();
    return RadioModule;
}());

var AutoGridSidenavDirective = /** @class */ (function () {
    function AutoGridSidenavDirective(renderer, elementRef, customElementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.customElementRef = customElementRef;
        this.sidenav$ = new ReplaySubject(1);
    }
    Object.defineProperty(AutoGridSidenavDirective.prototype, "cdsAutoGridSidenav", {
        set: function (sidenav) {
            this.sidenav$.next(sidenav);
        },
        enumerable: true,
        configurable: true
    });
    AutoGridSidenavDirective.prototype.ngOnInit = function () {
        var _this = this;
        var element = this.customElementRef ? this.customElementRef().nativeElement : this.elementRef.nativeElement;
        this.sidenav$.asObservable().pipe(switchMap(function (sidenav) { return sidenav.visible$; })).subscribe(function (visible) {
            if (visible) {
                _this.renderer.addClass(element, 'cds-grid-visible-sidenav');
            }
            else {
                _this.renderer.removeClass(element, 'cds-grid-visible-sidenav');
            }
        });
    };
    AutoGridSidenavDirective.prototype.ngOnDestroy = function () {
        this.sidenav$.complete();
    };
    AutoGridSidenavDirective.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef },
        { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [AUTO_GRID_SIDENAV_ELEMENT,] }] }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", SidenavComponent),
        __metadata("design:paramtypes", [SidenavComponent])
    ], AutoGridSidenavDirective.prototype, "cdsAutoGridSidenav", null);
    AutoGridSidenavDirective = __decorate([ __param(2, Optional()), __param(2, Inject(AUTO_GRID_SIDENAV_ELEMENT)),
        __metadata("design:paramtypes", [Renderer2,
            ElementRef, Object])
    ], AutoGridSidenavDirective);
AutoGridSidenavDirective.ɵfac = function AutoGridSidenavDirective_Factory(t) { return new (t || AutoGridSidenavDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(AUTO_GRID_SIDENAV_ELEMENT, 8)); };
AutoGridSidenavDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AutoGridSidenavDirective, selectors: [["", "cdsAutoGridSidenav", ""]], inputs: { cdsAutoGridSidenav: "cdsAutoGridSidenav" } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AutoGridSidenavDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsAutoGridSidenav]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [AUTO_GRID_SIDENAV_ELEMENT]
            }] }]; }, { cdsAutoGridSidenav: [{
            type: Input
        }] }); })();
    return AutoGridSidenavDirective;
}());

var SidenavModule = /** @class */ (function () {
    function SidenavModule() {
    }
SidenavModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SidenavModule });
SidenavModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SidenavModule_Factory(t) { return new (t || SidenavModule)(); }, imports: [[
            CommonModule,
            PortalModule,
            RippleModule,
            ButtonModule,
        ], NavModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SidenavModule, { declarations: function () { return [AutoGridSidenavDirective, SidenavComponent, SidenavExpandedComponent]; }, imports: function () { return [CommonModule, PortalModule, RippleModule, ButtonModule]; }, exports: function () { return [AutoGridSidenavDirective, SidenavComponent, NavModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SidenavModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    PortalModule,
                    RippleModule,
                    ButtonModule,
                ],
                declarations: [
                    AutoGridSidenavDirective,
                    SidenavComponent,
                    SidenavExpandedComponent,
                ],
                exports: [
                    AutoGridSidenavDirective,
                    SidenavComponent,
                    // modules
                    NavModule,
                ],
                entryComponents: [
                    SidenavExpandedComponent,
                ]
            }]
    }], function () { return []; }, null); })();
    return SidenavModule;
}());

var SpinnerComponent = /** @class */ (function () {
    function SpinnerComponent(renderer, elementRef) {
        renderer.addClass(elementRef.nativeElement, 'cds-spinner');
    }
    SpinnerComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef }
    ]; };
    SpinnerComponent = __decorate([ __metadata("design:paramtypes", [Renderer2, ElementRef])
    ], SpinnerComponent);
SpinnerComponent.ɵfac = function SpinnerComponent_Factory(t) { return new (t || SpinnerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SpinnerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SpinnerComponent, selectors: [["cds-spinner"]], decls: 3, vars: 0, consts: [["viewBox", "0 0 100 100", "focusable", "false"], ["cx", "50%", "cy", "50%", "r", "44", 1, "cds-spinner__circle", "cds-spinner__background"], ["cx", "50%", "cy", "50%", "r", "44", 1, "cds-spinner__circle", "cds-spinner__progress"]], template: function SpinnerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "circle", 1);
        ɵngcc0.ɵɵelement(2, "circle", 2);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SpinnerComponent, [{
        type: Component,
        args: [{
                selector: 'cds-spinner',
                template: "<svg viewBox=\"0 0 100 100\" focusable=\"false\">\n\t<circle class=\"cds-spinner__circle cds-spinner__background\"\n\t        cx=\"50%\" cy=\"50%\" r=\"44\"></circle>\n\t<circle class=\"cds-spinner__circle cds-spinner__progress\"\n\t        cx=\"50%\" cy=\"50%\" r=\"44\"></circle>\n</svg>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, null); })();
    return SpinnerComponent;
}());

var SpinnerWrapperComponent = /** @class */ (function () {
    function SpinnerWrapperComponent(renderer, elementRef) {
        this.animation = true;
        this.overlay = false;
        renderer.addClass(elementRef.nativeElement, 'cds-spinner-wrapper');
    }
    Object.defineProperty(SpinnerWrapperComponent.prototype, "fullscreen", {
        get: function () {
            return this.mode === 'fullscreen';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpinnerWrapperComponent.prototype, "partial", {
        get: function () {
            return this.mode === 'partial';
        },
        enumerable: true,
        configurable: true
    });
    SpinnerWrapperComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef }
    ]; };
    __decorate([
        HostBinding('@fadeInOut'),
        __metadata("design:type", Object)
    ], SpinnerWrapperComponent.prototype, "animation", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SpinnerWrapperComponent.prototype, "mode", void 0);
    __decorate([
        Input(),
        HostBinding('class.cds-spinner-overlay'),
        __metadata("design:type", Boolean)
    ], SpinnerWrapperComponent.prototype, "overlay", void 0);
    __decorate([
        HostBinding('class.cds-spinner-wrapper-fullscreen'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], SpinnerWrapperComponent.prototype, "fullscreen", null);
    __decorate([
        HostBinding('class.cds-spinner-wrapper-partial'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], SpinnerWrapperComponent.prototype, "partial", null);
    SpinnerWrapperComponent = __decorate([ __metadata("design:paramtypes", [Renderer2, ElementRef])
    ], SpinnerWrapperComponent);
SpinnerWrapperComponent.ɵfac = function SpinnerWrapperComponent_Factory(t) { return new (t || SpinnerWrapperComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SpinnerWrapperComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SpinnerWrapperComponent, selectors: [["cds-spinner-wrapper"]], hostVars: 7, hostBindings: function SpinnerWrapperComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵsyntheticHostProperty("@fadeInOut", ctx.animation);
        ɵngcc0.ɵɵclassProp("cds-spinner-overlay", ctx.overlay)("cds-spinner-wrapper-fullscreen", ctx.fullscreen)("cds-spinner-wrapper-partial", ctx.partial);
    } }, inputs: { overlay: "overlay", mode: "mode" }, ngContentSelectors: _c2, decls: 1, vars: 0, template: function SpinnerWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, data: { animation: [
            trigger('fadeInOut', [
                transition(':enter', [
                    style({ opacity: 0 }),
                    animate(300, style({ opacity: 1 })),
                ]),
                transition(':leave', [animate(300, style({ opacity: 0 }))]),
            ]),
        ] }, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SpinnerWrapperComponent, [{
        type: Component,
        args: [{
                selector: 'cds-spinner-wrapper',
                template: "<ng-content></ng-content>",
                animations: [
                    trigger('fadeInOut', [
                        transition(':enter', [
                            style({ opacity: 0 }),
                            animate(300, style({ opacity: 1 })),
                        ]),
                        transition(':leave', [animate(300, style({ opacity: 0 }))]),
                    ]),
                ],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { animation: [{
            type: HostBinding,
            args: ['@fadeInOut']
        }], overlay: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['class.cds-spinner-overlay']
        }], fullscreen: [{
            type: HostBinding,
            args: ['class.cds-spinner-wrapper-fullscreen']
        }], partial: [{
            type: HostBinding,
            args: ['class.cds-spinner-wrapper-partial']
        }], mode: [{
            type: Input
        }] }); })();
    return SpinnerWrapperComponent;
}());

var SpinnerModule = /** @class */ (function () {
    function SpinnerModule() {
    }
SpinnerModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SpinnerModule });
SpinnerModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SpinnerModule_Factory(t) { return new (t || SpinnerModule)(); }, imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SpinnerModule, { declarations: function () { return [SpinnerComponent, SpinnerWrapperComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [SpinnerComponent, SpinnerWrapperComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SpinnerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                ],
                declarations: [
                    SpinnerComponent,
                    SpinnerWrapperComponent,
                ],
                exports: [
                    SpinnerComponent,
                    SpinnerWrapperComponent,
                ]
            }]
    }], function () { return []; }, null); })();
    return SpinnerModule;
}());

var STEPPER_TRANSLATIONS_EN = {
    complete: 'Complete',
    longProgress: 'Step {{1}} of {{2}}',
};
function stepperTranslationsFactory() {
    return STEPPER_TRANSLATIONS_EN;
}
var CDS_STEPPER_TRANSLATIONS = new InjectionToken('CDS_STEPPER_TRANSLATIONS', { factory: stepperTranslationsFactory });

var LINE_OFFSET = 48;
var StepperComponent = /** @class */ (function (_super) {
    __extends(StepperComponent, _super);
    function StepperComponent(renderer, elementRef, matchMediaService, cdRef, zone, componentTranslations) {
        var _this = _super.call(this, matchMediaService) || this;
        _this.elementRef = elementRef;
        _this.matchMediaService = matchMediaService;
        _this.cdRef = cdRef;
        _this.zone = zone;
        _this.clickableRange = 'none';
        _this.activeStepChange = new EventEmitter();
        _this.labels = [];
        _this.showStepNumber = true;
        _this.lineOffset = LINE_OFFSET;
        _this.longStepperLabel = null;
        renderer.addClass(elementRef.nativeElement, 'cds-stepper');
        renderer.setAttribute(elementRef.nativeElement, 'role', 'progressbar');
        renderer.setAttribute(elementRef.nativeElement, 'aria-valuemin', '0');
        componentTranslations.use(CDS_STEPPER_TRANSLATIONS, stepperTranslationsFactory, function (translations) {
            _this.translations = translations;
            _this.updateAriaLabels();
        });
        return _this;
    }
    StepperComponent.prototype.updateAriaLabels = function () {
        this.shortStepperLabel = this.activeIndex >= this.labels.length
            ? this.translations.complete
            : this.activeIndex + 1 + "/" + this.labels.length + " " + this.labels[this.activeIndex];
        this.longStepperLabel = this.activeIndex >= this.labels.length
            ? this.translations.complete
            : this.translations.longProgress
                .replace('{{1}}', "" + (this.activeIndex + 1))
                .replace('{{2}}', "" + this.labels.length) + ', ' + this.labels[this.activeIndex];
    };
    StepperComponent.prototype.ngOnChanges = function (changes) {
        if (changes.activeStep || changes.labels) {
            if (this.activeStep < 1) {
                this.activeIndex = 0;
            }
            else if (this.activeStep > this.labels.length) {
                this.activeIndex = this.labels.length;
            }
            else {
                this.activeIndex = this.activeStep - 1;
            }
            if (!this.filledIndex || this.activeIndex > this.filledIndex) {
                this.filledIndex = this.activeIndex;
            }
            this.activeStepChange.emit(this.activeStep);
            this.attrAriaValueMax = "" + this.labels.length;
            this.attrAriaValueNow = "" + Math.min(this.activeIndex, this.labels.length);
            this.updateAriaLabels();
        }
    };
    StepperComponent.prototype.onStepSelect = function (index) {
        if (this.isClickable(index)) {
            this.activeStep = index + 1;
            this.activeStepChange.emit(index + 1);
        }
    };
    StepperComponent.prototype.isPending = function (index) {
        return index > this.filledIndex;
    };
    StepperComponent.prototype.isFilledPending = function (index) {
        return index <= this.filledIndex && index > this.activeIndex;
    };
    StepperComponent.prototype.isFilled = function (index) {
        return index < this.activeIndex;
    };
    StepperComponent.prototype.isFilledActive = function (index) {
        return this.clickableRange !== 'none' && index < this.filledIndex && index === this.activeIndex;
    };
    StepperComponent.prototype.isActive = function (index) {
        return this.clickableRange === 'none' ? index === this.activeIndex : index === this.filledIndex;
    };
    StepperComponent.prototype.isClickable = function (index) {
        return this.clickableRange === 'full' && index !== this.activeIndex || this.clickableRange === 'restricted' && index <= this.filledIndex && index !== this.activeIndex;
    };
    StepperComponent.prototype.isHover = function (index) {
        return this.hoverIndex === index;
    };
    StepperComponent.prototype.isFocused = function (index) {
        return this.focusIndex === index;
    };
    StepperComponent.prototype.getLabelVisibility = function (index) {
        return this.device === 'desktop' || index === this.activeIndex ? 'visible' : 'hidden';
    };
    StepperComponent.prototype.onDeviceChange = function (device, subscription) {
        var _this = this;
        /**
         * MatchMediaService may not necessarily run onDeviceChange() callback in Angular zone.
         * Should you require it running in the zone, use NgZone.run() explicitly.
         */
        this.zone.run(function () {
            _this.device = device;
            _this.containerPadding = _this.device === 'desktop' ? LINE_OFFSET / 4 : null;
            if (subscription) {
                _this.cdRef.markForCheck();
                _this.cdRef.detectChanges();
            }
        });
    };
    StepperComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef },
        { type: MatchMediaService },
        { type: ChangeDetectorRef },
        { type: NgZone },
        { type: DynamicTranslations }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], StepperComponent.prototype, "activeStep", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], StepperComponent.prototype, "clickableRange", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], StepperComponent.prototype, "activeStepChange", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], StepperComponent.prototype, "labels", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], StepperComponent.prototype, "showStepNumber", void 0);
    __decorate([
        HostBinding('attr.aria-valuenow'),
        __metadata("design:type", String)
    ], StepperComponent.prototype, "attrAriaValueNow", void 0);
    __decorate([
        HostBinding('attr.aria-valuemax'),
        __metadata("design:type", String)
    ], StepperComponent.prototype, "attrAriaValueMax", void 0);
    __decorate([
        HostBinding('attr.aria-valuetext'),
        __metadata("design:type", String)
    ], StepperComponent.prototype, "longStepperLabel", void 0);
    StepperComponent = __decorate([ __metadata("design:paramtypes", [Renderer2,
            ElementRef,
            MatchMediaService,
            ChangeDetectorRef,
            NgZone,
            DynamicTranslations])
    ], StepperComponent);
StepperComponent.ɵfac = function StepperComponent_Factory(t) { return new (t || StepperComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(MatchMediaService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations)); };
StepperComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: StepperComponent, selectors: [["cds-stepper"]], hostVars: 3, hostBindings: function StepperComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-valuetext", ctx.longStepperLabel)("aria-valuemax", ctx.attrAriaValueMax)("aria-valuenow", ctx.attrAriaValueNow);
    } }, inputs: { activeStep: "activeStep", clickableRange: "clickableRange", labels: "labels", showStepNumber: "showStepNumber" }, outputs: { activeStepChange: "activeStepChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            DynamicTranslations,
        ]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 10, vars: 17, consts: [["aria-hidden", "true", 1, "cds-stepper__step-line-container"], [1, "cds-stepper__line-wrapper"], [1, "cds-stepper__line"], [1, "cds-stepper__filled-line"], ["class", "cds-stepper__step-container-wrapper", 4, "ngIf"], ["class", "cds-stepper__mouse-surface-container", 4, "ngIf"], ["class", "cds-stepper__labels-container", "aria-hidden", "true", 4, "ngIf"], ["class", "cds-stepper__mobile-label", "aria-hidden", "true", 4, "ngIf"], [1, "cds-stepper__step-container-wrapper"], [1, "cds-stepper__step-container"], [4, "ngFor", "ngForOf"], [1, "cds-stepper__step-wrapper"], [1, "cds-stepper__step"], ["class", "cds-stepper__tick", 4, "ngIf"], [1, "cds-stepper__tick"], [1, "cds-stepper__mouse-surface-container"], [1, "cds-stepper__mouse-surface", 3, "cdsTooltipHover", "tabindex", "mouseenter", "mouseleave", "focus", "blur", "keydown.Enter", "click"], ["aria-hidden", "true", 1, "cds-stepper__labels-container"], [1, "cds-stepper__label", 3, "tabindex", "mouseenter", "mouseleave", "focus", "blur", "click", "keydown.Enter"], [1, "cds-stepper__label-text"], ["aria-hidden", "true", 1, "cds-stepper__mobile-label"]], template: function StepperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵpipe(1, "cdsStepperLineWidth");
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵpipe(5, "cdsStepperFillWidth");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, StepperComponent_div_6_Template, 3, 7, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, StepperComponent_div_7_Template, 2, 1, "div", 5);
        ɵngcc0.ɵɵtemplate(8, StepperComponent_div_8_Template, 2, 1, "div", 6);
        ɵngcc0.ɵɵtemplate(9, StepperComponent_div_9_Template, 3, 1, "div", 7);
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("width", ɵngcc0.ɵɵpipeBind3(1, 8, ctx.device, ctx.labels.length, ctx.lineOffset));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵstyleProp("width", ɵngcc0.ɵɵpipeBind4(5, 12, ctx.device, ctx.labels.length, ctx.lineOffset, ctx.clickableRange === "none" ? ctx.activeIndex : ctx.filledIndex));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.device !== "mobile");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.device !== "mobile" && ctx.clickableRange !== "none");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.device !== "mobile");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.device === "mobile");
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc1.NgForOf, TooltipHoverDirective]; }, pipes: function () { return [StepperLineWidthPipe, StepperFillWidthPipe]; }, encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StepperComponent, [{
        type: Component,
        args: [{
                selector: 'cds-stepper',
                template: "<div class=\"cds-stepper__step-line-container\" [style.width]=\"device | cdsStepperLineWidth : labels.length : lineOffset\" aria-hidden=\"true\">\n\t<div class=\"cds-stepper__line-wrapper\">\n\t\t<div class=\"cds-stepper__line\">\n\t\t\t<div class=\"cds-stepper__filled-line\" [style.width]=\"device | cdsStepperFillWidth : labels.length : lineOffset : clickableRange === 'none' ? activeIndex : filledIndex \"></div>\n\t\t</div>\n\t</div>\n\t<div *ngIf=\"device !== 'mobile'\" class=\"cds-stepper__step-container-wrapper\">\n\t\t<div class=\"cds-stepper__step-container\" [class.cds-stepper__desktop-container]=\"device === 'desktop'\" [style.padding-left.px]=\"containerPadding\" [style.padding-right.px]=\"containerPadding\">\n\t\t\t<ng-container *ngFor=\"let label of labels; let i = index\">\n\t\t\t\t<div class=\"cds-stepper__step-wrapper\">\n\t\t\t\t\t<div class=\"cds-stepper__step\"\n\t\t\t\t\t     [class.cds-stepper__step--hover]=\"isHover(i) && i !== activeIndex\"\n\t\t\t\t\t     [class.cds-stepper__step--focus]=\"isFocused(i) && i !== activeIndex\"\n\t\t\t\t\t     [class.cds-stepper__step--pending]=\"isPending(i)\"\n\t\t\t\t\t     [class.cds-stepper__step--filled]=\"isFilled(i)\"\n\t\t\t\t\t     [class.cds-stepper__step--filled-active]=\"isFilledActive(i)\"\n\t\t\t\t\t     [class.cds-stepper__step--filled-pending]=\"isFilledPending(i)\"\n\t\t\t\t\t     [class.cds-stepper__step--active]=\"isActive(i)\"\n\t\t\t\t\t     [class.cds-stepper__step--clickable]=\"isClickable(i)\">\n\t\t\t\t\t\t<div *ngIf=\"isFilled(i) || isFilledActive(i)\" class=\"cds-stepper__tick\"></div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</ng-container>\n\t\t</div>\n\t</div>\n</div>\n<div *ngIf=\"device !== 'mobile' && clickableRange !== 'none'\" class=\"cds-stepper__mouse-surface-container\">\n\t<ng-container *ngFor=\"let label of labels; let i = index\">\n\t\t<div class=\"cds-stepper__mouse-surface\"\n\t\t     [cdsTooltipHover]=\"(i !== activeIndex) && device === 'tablet' ? {message: label, placement: 'bottom'} : null\"\n\t\t     [tabindex]=\"isClickable(i) && device !== 'desktop' ? 0 : -1\"\n\t\t     [style.cursor]=\"isClickable(i) ? 'pointer': 'auto'\"\n\t\t     (mouseenter)=\"hoverIndex = i\"\n\t\t     (mouseleave)=\"hoverIndex = null\"\n\t\t     (focus)=\"focusIndex = i\"\n\t\t     (blur)=\"focusIndex = null\"\n\t\t     (keydown.Enter)=\"device !== 'desktop' && onStepSelect(i)\"\n\t\t     (click)=\"onStepSelect(i)\">\n\t\t</div>\n\t</ng-container>\n</div>\n<div *ngIf=\"device !== 'mobile'\" class=\"cds-stepper__labels-container\" aria-hidden=\"true\">\n\t<ng-container *ngFor=\"let label of labels; let i = index\">\n\t\t<div class=\"cds-stepper__label\"\n\t\t     [tabindex]=\"isClickable(i) && device === 'desktop' ? 0 : -1\"\n\t\t     (mouseenter)=\"hoverIndex = i\"\n\t\t     (mouseleave)=\"hoverIndex = null\"\n\t\t     (focus)=\"focusIndex = i\"\n\t\t     (blur)=\"focusIndex = null\"\n\t\t     (click)=\"onStepSelect(i)\"\n\t\t     (keydown.Enter)=\"device === 'desktop' && onStepSelect(i)\"\n\t\t     [style.visibility]=\"getLabelVisibility(i)\"\n\t\t     [class.cds-stepper__label--hover]=\"isHover(i) && i !== activeIndex\"\n\t\t     [class.cds-stepper__label--active]=\"isActive(i) && i === activeIndex || isFilledActive(i)\"\n\t\t     [class.cds-stepper__label--clickable]=\"isClickable(i)\"\n\t\t     [class.cds-stepper__label-no-wrap]=\"device === 'tablet'\">\n\t\t\t<span class=\"cds-stepper__label-text\">{{showStepNumber ? ((i + 1) + '. ' + label) : label}}</span>\n\t\t</div>\n\t</ng-container>\n</div>\n<div *ngIf=\"device === 'mobile'\" class=\"cds-stepper__mobile-label\" aria-hidden=\"true\">\n\t<div class=\"cds-stepper__label-text\">\n\t\t{{shortStepperLabel}}\n\t</div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                providers: [
                    DynamicTranslations,
                ]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: MatchMediaService }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.NgZone }, { type: DynamicTranslations }]; }, { longStepperLabel: [{
            type: HostBinding,
            args: ['attr.aria-valuetext']
        }], attrAriaValueMax: [{
            type: HostBinding,
            args: ['attr.aria-valuemax']
        }], attrAriaValueNow: [{
            type: HostBinding,
            args: ['attr.aria-valuenow']
        }], activeStep: [{
            type: Input
        }], clickableRange: [{
            type: Input
        }], activeStepChange: [{
            type: Output
        }], labels: [{
            type: Input
        }], showStepNumber: [{
            type: Input
        }] }); })();
    return StepperComponent;
}(DeviceAwareComponent));

var StepperFillWidthPipe = /** @class */ (function () {
    function StepperFillWidthPipe(sanitization) {
        this.sanitization = sanitization;
    }
    StepperFillWidthPipe.prototype.transform = function (device, length, offset, activeIndex) {
        if (device === 'desktop') {
            return this.sanitization.bypassSecurityTrustStyle("calc(" + activeIndex + " * ((100% - " + offset + "px) / " + (length - 1) + ") + " + offset / 2 + "px)");
        }
        else {
            return this.sanitization.bypassSecurityTrustStyle("calc(" + (activeIndex + 0.5) + " * (100% / " + length + "))");
        }
    };
    StepperFillWidthPipe.ctorParameters = function () { return [
        { type: DomSanitizer }
    ]; };
    StepperFillWidthPipe = __decorate([ __metadata("design:paramtypes", [DomSanitizer])
    ], StepperFillWidthPipe);
StepperFillWidthPipe.ɵfac = function StepperFillWidthPipe_Factory(t) { return new (t || StepperFillWidthPipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.DomSanitizer)); };
StepperFillWidthPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "cdsStepperFillWidth", type: StepperFillWidthPipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StepperFillWidthPipe, [{
        type: Pipe,
        args: [{
                name: 'cdsStepperFillWidth'
            }]
    }], function () { return [{ type: ɵngcc4.DomSanitizer }]; }, null); })();
    return StepperFillWidthPipe;
}());

var StepperLineWidthPipe = /** @class */ (function () {
    function StepperLineWidthPipe(sanitization) {
        this.sanitization = sanitization;
    }
    StepperLineWidthPipe.prototype.transform = function (device, length, offset) {
        return this.sanitization.bypassSecurityTrustStyle(device === 'desktop'
            ? "calc(100% - (100% / " + length + ") + " + offset + "px)"
            : '100%');
    };
    StepperLineWidthPipe.ctorParameters = function () { return [
        { type: DomSanitizer }
    ]; };
    StepperLineWidthPipe = __decorate([ __metadata("design:paramtypes", [DomSanitizer])
    ], StepperLineWidthPipe);
StepperLineWidthPipe.ɵfac = function StepperLineWidthPipe_Factory(t) { return new (t || StepperLineWidthPipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.DomSanitizer)); };
StepperLineWidthPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "cdsStepperLineWidth", type: StepperLineWidthPipe, pure: true });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StepperLineWidthPipe, [{
        type: Pipe,
        args: [{
                name: 'cdsStepperLineWidth'
            }]
    }], function () { return [{ type: ɵngcc4.DomSanitizer }]; }, null); })();
    return StepperLineWidthPipe;
}());

var StepperModule = /** @class */ (function () {
    function StepperModule() {
    }
StepperModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: StepperModule });
StepperModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function StepperModule_Factory(t) { return new (t || StepperModule)(); }, imports: [[
            CommonModule,
            TooltipModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(StepperModule, { declarations: function () { return [StepperComponent, StepperFillWidthPipe, StepperLineWidthPipe]; }, imports: function () { return [CommonModule, TooltipModule]; }, exports: function () { return [StepperComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StepperModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TooltipModule,
                ],
                declarations: [
                    StepperComponent,
                    StepperFillWidthPipe,
                    StepperLineWidthPipe,
                ],
                exports: [
                    StepperComponent,
                ]
            }]
    }], function () { return []; }, null); })();
    return StepperModule;
}());

var SWITCH_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return SwitchComponent; }),
    multi: true,
};
var SwitchComponent = /** @class */ (function (_super) {
    __extends(SwitchComponent, _super);
    function SwitchComponent(cdRef, toggleGroupDirective, renderer, element) {
        var _this = _super.call(this, cdRef) || this;
        _this.toggleGroupDirective = toggleGroupDirective;
        _this.renderer = renderer;
        _this.labelId = Unique.next('cds-switch__label-');
        renderer.addClass(element.nativeElement, 'cds-switch');
        renderer.setAttribute(element.nativeElement, 'role', 'switch');
        if (toggleGroupDirective) {
            toggleGroupDirective.registerComponent(_this);
        }
        return _this;
    }
    Object.defineProperty(SwitchComponent.prototype, "ariaLabelledBy", {
        get: function () {
            return this.label ? this.labelId : null;
        },
        enumerable: true,
        configurable: true
    });
    SwitchComponent.prototype.ngOnDestroy = function () {
        if (this.toggleGroupDirective) {
            this.toggleGroupDirective.unregisterComponent(this);
        }
    };
    SwitchComponent.prototype.onClick = function (event) {
        event.preventDefault();
        if (this.isBlocked) {
            return;
        }
        this.setChecked(!this.isChecked);
    };
    SwitchComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: ToggleGroupDirective, decorators: [{ type: Host }, { type: Optional }] },
        { type: Renderer2 },
        { type: ElementRef }
    ]; };
    __decorate([
        HostBinding('attr.aria-labelledby'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], SwitchComponent.prototype, "ariaLabelledBy", null);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SwitchComponent.prototype, "label", void 0);
    __decorate([
        HostListener('click', ['$event']),
        HostListener('keydown.enter', ['$event']),
        HostListener('keydown.space', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Event]),
        __metadata("design:returntype", void 0)
    ], SwitchComponent.prototype, "onClick", null);
    SwitchComponent = __decorate([ __param(1, Host()), __param(1, Optional()),
        __metadata("design:paramtypes", [ChangeDetectorRef,
            ToggleGroupDirective,
            Renderer2,
            ElementRef])
    ], SwitchComponent);
SwitchComponent.ɵfac = function SwitchComponent_Factory(t) { return new (t || SwitchComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ToggleGroupDirective, 9), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SwitchComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SwitchComponent, selectors: [["cds-switch"]], hostVars: 8, hostBindings: function SwitchComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function SwitchComponent_click_HostBindingHandler($event) { return ctx.onClick($event); })("keydown.enter", function SwitchComponent_keydown_enter_HostBindingHandler($event) { return ctx.onClick($event); })("keydown.space", function SwitchComponent_keydown_space_HostBindingHandler($event) { return ctx.onClick($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-checked", ctx.ariaChecked)("aria-disabled", ctx.ariaDisabled)("tabindex", ctx.attrTabindex)("aria-labelledby", ctx.ariaLabelledBy);
        ɵngcc0.ɵɵclassProp("checked", ctx.isChecked)("disabled", ctx.isDisabled);
    } }, inputs: { tabindex: "tabindex", value: "value", uncheckable: "uncheckable", label: "label" }, features: [ɵngcc0.ɵɵProvidersFeature([SWITCH_CONTROL_VALUE_ACCESSOR]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 1, consts: [["tabindex", "-1", 1, "toggle-wrapper"], [1, "switch"], [1, "knob"], [4, "ngIf"]], template: function SwitchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, SwitchComponent_label_3_Template, 2, 2, "label", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SwitchComponent, [{
        type: Component,
        args: [{
                selector: 'cds-switch',
                template: "<div class=\"toggle-wrapper\" tabindex=\"-1\">\n\t<div class=\"switch\">\n\t\t<div class=\"knob\"></div>\n\t</div>\n\t<label *ngIf=\"label\" [attr.id]=\"labelId\">{{label}}</label>\n</div>\n",
                providers: [SWITCH_CONTROL_VALUE_ACCESSOR],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                inputs: ABSTRACT_TOGGLE_COMPONENT_INPUTS,
                host: ABSTRACT_TOGGLE_COMPONENT_HOST
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ToggleGroupDirective, decorators: [{
                type: Host
            }, {
                type: Optional
            }] }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { ariaLabelledBy: [{
            type: HostBinding,
            args: ['attr.aria-labelledby']
        }], onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }, {
            type: HostListener,
            args: ['keydown.enter', ['$event']]
        }, {
            type: HostListener,
            args: ['keydown.space', ['$event']]
        }], label: [{
            type: Input
        }] }); })();
    return SwitchComponent;
}(AbstractToggleComponent));

var SwitchModule = /** @class */ (function () {
    function SwitchModule() {
    }
SwitchModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SwitchModule });
SwitchModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SwitchModule_Factory(t) { return new (t || SwitchModule)(); }, imports: [[
            CommonModule,
            ToggleModule,
        ], ToggleModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SwitchModule, { declarations: function () { return [SwitchComponent]; }, imports: function () { return [CommonModule, ToggleModule]; }, exports: function () { return [SwitchComponent, ToggleModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SwitchModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ToggleModule,
                ],
                declarations: [
                    SwitchComponent,
                ],
                exports: [
                    SwitchComponent,
                    // modules
                    ToggleModule,
                ]
            }]
    }], function () { return []; }, null); })();
    return SwitchModule;
}());

var CDS_TAB_LIST_HOST = new InjectionToken('CDS_TAB_LIST_HOST');

var TAB_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return TabComponent; }),
    multi: true,
};
var TabComponent = /** @class */ (function (_super) {
    __extends(TabComponent, _super);
    function TabComponent(toggleGroupDirective, tabList, cdRef, elementRef, renderer) {
        var _this = _super.call(this, cdRef) || this;
        _this.toggleGroupDirective = toggleGroupDirective;
        _this.tabList = tabList;
        _this.elementRef = elementRef;
        _this.renderer = renderer;
        _this.removable = false;
        _this.readonly = false;
        _this.appearance = 'default';
        _this.remove = new EventEmitter();
        renderer.addClass(elementRef.nativeElement, 'cds-tab');
        renderer.setAttribute(elementRef.nativeElement, 'role', 'tab');
        _this.uncheckable = false;
        if (toggleGroupDirective) {
            toggleGroupDirective.registerComponent(_this);
        }
        return _this;
    }
    TabComponent.prototype.onClick = function (event) {
        event.preventDefault();
        if (this.isBlocked || this.readonly) {
            return;
        }
        this.setChecked(!this.isChecked);
    };
    TabComponent.prototype.onEnter = function (event) {
        event.preventDefault();
        this.elementRef.nativeElement.click();
    };
    TabComponent.prototype.onRemove = function (event, hasFocus) {
        var _a;
        event.preventDefault();
        var element = this.getNativeElement();
        var clickElement;
        var focusElement;
        var focusTab;
        if (this.tabList) {
            (_a = this.tabList.onTabRemove(this, hasFocus || element === document.activeElement || element.contains(document.activeElement)), clickElement = _a.clickElement, focusElement = _a.focusElement, focusTab = _a.focusTab);
        }
        var detail = {
            focusTab: focusTab,
            focusValue: focusTab && focusTab.value,
        };
        var removeEvent = createCustomEvent('remove', { cancelable: true, bubbles: false, detail: detail });
        this.remove.emit(removeEvent);
        if (!removeEvent.defaultPrevented) {
            if (focusElement) {
                focusElement.focus();
            }
            if (clickElement) {
                clickElement.click();
            }
        }
    };
    TabComponent.prototype.onKeyDown = function (event) {
        switch (event.key) {
            case 'Delete':
            case 'Del':
                if (this.removable) {
                    this.onRemove(event, false);
                }
                break;
        }
    };
    TabComponent.prototype.writeValue = function (modelValue) {
        _super.prototype.writeValue.call(this, modelValue);
        if (this.isChecked && this.tabList) {
            this.tabList.scrollIntoView(this.elementRef.nativeElement);
        }
    };
    TabComponent.prototype.focus = function () {
        this.elementRef.nativeElement.focus();
    };
    TabComponent.prototype.blur = function () {
        this.elementRef.nativeElement.blur();
    };
    TabComponent.prototype.getNativeElement = function () {
        return this.elementRef.nativeElement;
    };
    TabComponent.prototype.setOverrideTabindex = function (override) {
        this.overrideTabindex = override;
        this.renderer.setAttribute(this.elementRef.nativeElement, 'tabindex', this.attrTabindex);
    };
    TabComponent.prototype.ngDoCheck = function () {
        this.renderer.setAttribute(this.elementRef.nativeElement, 'tabindex', this.attrTabindex);
    };
    TabComponent.prototype.ngOnDestroy = function () {
        if (this.toggleGroupDirective) {
            this.toggleGroupDirective.unregisterComponent(this);
        }
    };
    TabComponent.prototype.setAppearance = function (appearance) {
        this.renderer.setAttribute(this.elementRef.nativeElement, 'cds-tab-appearance', appearance || 'default');
    };
    TabComponent.ctorParameters = function () { return [
        { type: ToggleGroupDirective, decorators: [{ type: Host }, { type: Optional }] },
        { type: undefined, decorators: [{ type: Inject, args: [CDS_TAB_LIST_HOST,] }, { type: Host }, { type: Optional }] },
        { type: ChangeDetectorRef },
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], TabComponent.prototype, "removable", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], TabComponent.prototype, "readonly", void 0);
    __decorate([
        Input(),
        HostBinding('attr.cds-tab-appearance'),
        __metadata("design:type", String)
    ], TabComponent.prototype, "appearance", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], TabComponent.prototype, "remove", void 0);
    __decorate([
        HostListener('click', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Event]),
        __metadata("design:returntype", void 0)
    ], TabComponent.prototype, "onClick", null);
    __decorate([
        HostListener('keydown.enter', ['$event']),
        HostListener('keydown.space', ['$event']),
        HostListener('keydown.spacebar', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Event]),
        __metadata("design:returntype", void 0)
    ], TabComponent.prototype, "onEnter", null);
    __decorate([
        HostListener('keydown', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [KeyboardEvent]),
        __metadata("design:returntype", void 0)
    ], TabComponent.prototype, "onKeyDown", null);
    TabComponent = __decorate([ __param(0, Host()), __param(0, Optional()),
        __param(1, Inject(CDS_TAB_LIST_HOST)), __param(1, Host()), __param(1, Optional()),
        __metadata("design:paramtypes", [ToggleGroupDirective, Object, ChangeDetectorRef,
            ElementRef,
            Renderer2])
    ], TabComponent);
TabComponent.ɵfac = function TabComponent_Factory(t) { return new (t || TabComponent)(ɵngcc0.ɵɵdirectiveInject(ToggleGroupDirective, 9), ɵngcc0.ɵɵdirectiveInject(CDS_TAB_LIST_HOST, 9), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
TabComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TabComponent, selectors: [["cds-tab"]], hostVars: 7, hostBindings: function TabComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function TabComponent_click_HostBindingHandler($event) { return ctx.onClick($event); })("keydown.enter", function TabComponent_keydown_enter_HostBindingHandler($event) { return ctx.onEnter($event); })("keydown.space", function TabComponent_keydown_space_HostBindingHandler($event) { return ctx.onEnter($event); })("keydown.spacebar", function TabComponent_keydown_spacebar_HostBindingHandler($event) { return ctx.onEnter($event); })("keydown", function TabComponent_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-selected", ctx.ariaChecked)("aria-disabled", ctx.ariaDisabled)("cds-tab-appearance", ctx.appearance);
        ɵngcc0.ɵɵclassProp("selected", ctx.isChecked)("disabled", ctx.isDisabled);
    } }, inputs: { tabindex: "tabindex", value: "value", removable: "removable", readonly: "readonly", appearance: "appearance" }, outputs: { remove: "remove" }, features: [ɵngcc0.ɵɵProvidersFeature([
            TAB_CONTROL_VALUE_ACCESSOR,
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c2, decls: 7, vars: 1, consts: [["tabindex", "-1", 1, "cds-tab__wrapper"], ["cdsRipple", "", 1, "cds-tab__label"], [1, "cds-tab__content"], ["class", "cds-tab__remove cds-icon-close", "aria-hidden", "true", "tabindex", "-1", 3, "mousedown", "click", 4, "ngIf"], [1, "cds-tab__bar-inactive"], [1, "cds-tab__bar"], ["aria-hidden", "true", "tabindex", "-1", 1, "cds-tab__remove", "cds-icon-close", 3, "mousedown", "click"]], template: function TabComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "span", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, TabComponent_i_4_Template, 1, 0, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelement(6, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.removable);
    } }, directives: [RippleDirective, ɵngcc1.NgIf], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TabComponent, [{
        type: Component,
        args: [{
                selector: 'cds-tab',
                template: "<div class=\"cds-tab__wrapper\" tabindex=\"-1\">\n\t<span cdsRipple class=\"cds-tab__label\">\n\t\t<span class=\"cds-tab__content\"><ng-content></ng-content></span>\n\t\t<i class=\"cds-tab__remove cds-icon-close\" *ngIf=\"removable\" aria-hidden=\"true\" tabindex=\"-1\" (mousedown)=\"$event.preventDefault()\" (click)=\"onRemove($event, true)\"></i>\n\t</span>\n\t<div class=\"cds-tab__bar-inactive\">\n\t\t<div class=\"cds-tab__bar\"></div>\n\t</div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                providers: [
                    TAB_CONTROL_VALUE_ACCESSOR,
                ],
                inputs: [
                    'tabindex',
                    'value',
                ],
                host: {
                    '[class.selected]': 'isChecked',
                    '[class.disabled]': 'isDisabled',
                    '[attr.aria-selected]': 'ariaChecked',
                    '[attr.aria-disabled]': 'ariaDisabled'
                }
            }]
    }], function () { return [{ type: ToggleGroupDirective, decorators: [{
                type: Host
            }, {
                type: Optional
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [CDS_TAB_LIST_HOST]
            }, {
                type: Host
            }, {
                type: Optional
            }] }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], onEnter: [{
            type: HostListener,
            args: ['keydown.enter', ['$event']]
        }, {
            type: HostListener,
            args: ['keydown.space', ['$event']]
        }, {
            type: HostListener,
            args: ['keydown.spacebar', ['$event']]
        }], onKeyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], removable: [{
            type: Input
        }], readonly: [{
            type: Input
        }], appearance: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.cds-tab-appearance']
        }], remove: [{
            type: Output
        }] }); })();
    return TabComponent;
}(AbstractToggleComponent));

var INTERSECTION_THRESHOLD = 0.001;
var TAB_LIST_HOST_PROVIDER = {
    provide: CDS_TAB_LIST_HOST,
    useExisting: forwardRef(function () { return TabListComponent; }),
};
var TabListComponent = /** @class */ (function (_super) {
    __extends(TabListComponent, _super);
    function TabListComponent(elementRef, renderer, cdRef, zone) {
        var _this = _super.call(this, renderer, elementRef) || this;
        _this.cdRef = cdRef;
        _this.zone = zone;
        _this.appearance = 'default';
        _this.multiline = false;
        _this.arrowLeft = false;
        _this.arrowRight = false;
        renderer.addClass(elementRef.nativeElement, 'cds-tab-list');
        renderer.addClass(elementRef.nativeElement, 'cds-tab-group-wrapper');
        renderer.setAttribute(elementRef.nativeElement, 'role', 'tablist');
        return _this;
    }
    Object.defineProperty(TabListComponent.prototype, "noWrap", {
        get: function () {
            return !(!this.intersectionObserver || this.multiline);
        },
        enumerable: true,
        configurable: true
    });
    TabListComponent.prototype.onTabRemove = function (tab, hasFocus) {
        var focusElement;
        var element = tab.getNativeElement();
        if (hasFocus) {
            if (isHTMLElement(element.previousElementSibling)) {
                focusElement = element.previousElementSibling;
            }
            else if (isHTMLElement(element.nextElementSibling)) {
                focusElement = element.nextElementSibling;
            }
            else {
                focusElement = this.elementRef.nativeElement;
                return {
                    focusElement: focusElement,
                };
            }
        }
        var focusTab = focusElement && this.focusableItems.find(function (tab) { return tab.getNativeElement() === focusElement; });
        var clickElement;
        if (this.automaticActivation) {
            clickElement = focusElement;
        }
        return {
            focusTab: focusTab,
            focusElement: focusElement,
            clickElement: clickElement,
        };
    };
    TabListComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
        }
        if (this.focusableItemsChanges) {
            this.focusableItemsChanges.unsubscribe();
        }
    };
    TabListComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.focusGroupOptions = {
            useHorizontalArrowKeys: this.appearance !== 'vertical',
            useVerticalArrowKeys: this.appearance === 'vertical',
            useHomeEndKeys: true,
        };
        if (window['IntersectionObserver'] && !this.multiline) {
            this.intersectionObserver = new IntersectionObserver(function (entries) {
                var e_1, _a;
                var changes = false;
                try {
                    for (var entries_1 = __values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
                        var entry = entries_1_1.value;
                        var hidden = entry.intersectionRatio < INTERSECTION_THRESHOLD;
                        if (entry.target === _this.intersectionLeft.nativeElement) {
                            _this.arrowLeft = hidden;
                            changes = true;
                        }
                        else if (entry.target === _this.intersectionRight.nativeElement) {
                            _this.arrowRight = hidden;
                            changes = true;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                if (changes) {
                    _this.cdRef.detectChanges();
                }
            }, {
                root: this.scrollable.nativeElement,
                threshold: INTERSECTION_THRESHOLD,
            });
            this.intersectionObserver.observe(this.intersectionLeft.nativeElement);
            this.intersectionObserver.observe(this.intersectionRight.nativeElement);
        }
        this.refreshTabListAppeareance();
        if (this.focusableItems != null) {
            if (this.focusableItemsChanges) {
                this.focusableItemsChanges.unsubscribe();
            }
            this.focusableItemsChanges = this.focusableItems.changes.subscribe(function () { return _this.refreshTabListAppeareance(); });
        }
    };
    TabListComponent.prototype.refreshTabListAppeareance = function () {
        var _this = this;
        this.focusableItems.forEach(function (child) {
            child.setAppearance(_this.appearance);
        });
    };
    TabListComponent.prototype.scrollTabs = function (event, forward) {
        event.preventDefault();
        var element = this.scrollable.nativeElement;
        var from;
        var scrollSize;
        var clientSize;
        var moveBy;
        if (this.appearance === 'vertical') {
            from = element.scrollTop;
            moveBy = element.parentElement.clientHeight * 0.6;
            scrollSize = element.scrollHeight;
            clientSize = element.clientHeight;
        }
        else {
            from = element.scrollLeft;
            moveBy = element.parentElement.clientWidth * 0.6;
            scrollSize = element.scrollWidth;
            clientSize = element.clientWidth;
        }
        var to = forward
            ? Math.min(scrollSize - clientSize, from + moveBy)
            : Math.max(0, from - moveBy);
        this.scrollTransition(element, to);
    };
    TabListComponent.prototype.scrollIntoView = function (element) {
        var scrollable = this.scrollable.nativeElement;
        var offset = getOffset(scrollable, element, this.appearance === 'vertical');
        var elementSize;
        var scrollableSize;
        if (this.appearance === 'vertical') {
            elementSize = element.clientHeight;
            scrollableSize = scrollable.clientHeight;
        }
        else {
            elementSize = element.clientWidth;
            scrollableSize = scrollable.clientWidth;
        }
        var to = offset + 0.5 * elementSize - 0.5 * scrollableSize;
        this.scrollTransition(scrollable, to);
    };
    TabListComponent.prototype.scrollTransition = function (scrollable, to) {
        var _this = this;
        this.zone.runOutsideAngular(function () {
            if (_this.cancelTransition) {
                _this.cancelTransition();
                _this.cancelTransition = null;
            }
            var from = _this.appearance === 'vertical' ? scrollable.scrollTop : scrollable.scrollLeft;
            _this.cancelTransition = valueTransition(Math.max(200, Math.abs(from - to)), from, to, function (position) {
                if (_this.appearance === 'vertical') {
                    scrollable.scrollTop = position;
                }
                else {
                    scrollable.scrollLeft = position;
                }
            }, easeOut);
        });
    };
    TabListComponent.prototype.getFocusNativeElement = function (item) {
        return item.getNativeElement();
    };
    TabListComponent.prototype.isInitialFocus = function (item) {
        return item.isChecked && !item.isDisabled;
    };
    TabListComponent.prototype.canBeFocused = function (item) {
        return !item.isDisabled;
    };
    TabListComponent.prototype.setPrimaryItem = function (item, primary) {
        item.setOverrideTabindex(!primary);
        this.cdRef.markForCheck();
    };
    TabListComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ChangeDetectorRef },
        { type: NgZone }
    ]; };
    __decorate([
        Input(),
        HostBinding('attr.cds-tab-list-appearance'),
        __metadata("design:type", String)
    ], TabListComponent.prototype, "appearance", void 0);
    __decorate([
        ContentChildren(TabComponent, { read: TabComponent }),
        __metadata("design:type", QueryList)
    ], TabListComponent.prototype, "focusableItems", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], TabListComponent.prototype, "multiline", void 0);
    __decorate([
        ViewChild('intersectionRight', { read: ElementRef, static: true }),
        __metadata("design:type", ElementRef)
    ], TabListComponent.prototype, "intersectionRight", void 0);
    __decorate([
        ViewChild('intersectionLeft', { read: ElementRef, static: true }),
        __metadata("design:type", ElementRef)
    ], TabListComponent.prototype, "intersectionLeft", void 0);
    __decorate([
        ViewChild('scrollable', { read: ElementRef, static: true }),
        __metadata("design:type", ElementRef)
    ], TabListComponent.prototype, "scrollable", void 0);
    TabListComponent = __decorate([ __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            ChangeDetectorRef,
            NgZone])
    ], TabListComponent);
TabListComponent.ɵfac = function TabListComponent_Factory(t) { return new (t || TabListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
TabListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TabListComponent, selectors: [["cds-tab-list"]], contentQueries: function TabListComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TabComponent, false, TabComponent);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.focusableItems = _t);
    } }, viewQuery: function TabListComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c24, true, ElementRef);
        ɵngcc0.ɵɵstaticViewQuery(_c23, true, ElementRef);
        ɵngcc0.ɵɵstaticViewQuery(_c50, true, ElementRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.intersectionRight = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.intersectionLeft = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.scrollable = _t.first);
    } }, hostVars: 1, hostBindings: function TabListComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("cds-tab-list-appearance", ctx.appearance);
    } }, inputs: { appearance: "appearance", multiline: "multiline" }, features: [ɵngcc0.ɵɵProvidersFeature([
            TAB_LIST_HOST_PROVIDER,
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c2, decls: 17, vars: 26, consts: [[1, "cds-tab-list__container"], ["tabindex", "-1", 1, "cds-tab-list__scroll"], ["scrollable", ""], [1, "cds-tab-list__intersection"], ["intersectionLeft", ""], [1, "cds-tab-list__tabs", "cds-tab-group"], ["intersectionRight", ""], [1, "cds-tab-list__arrow"], ["cdsButton", "", 1, "cds-button-icon", "cds-button-small", 3, "mousedown", "touchstart"], [1, "cds-icon--size-24"]], template: function TabListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1, 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelement(4, "div", null, 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵprojection(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 3);
        ɵngcc0.ɵɵelement(9, "div", null, 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 7);
        ɵngcc0.ɵɵelementStart(12, "div", 8);
        ɵngcc0.ɵɵlistener("mousedown", function TabListComponent_Template_div_mousedown_12_listener($event) { return ctx.scrollTabs($event, false); })("touchstart", function TabListComponent_Template_div_touchstart_12_listener($event) { return ctx.scrollTabs($event, false); });
        ɵngcc0.ɵɵelement(13, "i", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 7);
        ɵngcc0.ɵɵelementStart(15, "div", 8);
        ɵngcc0.ɵɵlistener("mousedown", function TabListComponent_Template_div_mousedown_15_listener($event) { return ctx.scrollTabs($event, true); })("touchstart", function TabListComponent_Template_div_touchstart_15_listener($event) { return ctx.scrollTabs($event, true); });
        ɵngcc0.ɵɵelement(16, "i", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("cds-tab-list__scroll--no-wrap", ctx.noWrap)("cds-tab-list__scroll--arrow-left", ctx.arrowLeft && ctx.appearance !== "vertical")("cds-tab-list__scroll--arrow-right", ctx.arrowRight && ctx.appearance !== "vertical");
        ɵngcc0.ɵɵadvance(10);
        ɵngcc0.ɵɵclassProp("cds-tab-list__arrow--left", ctx.appearance !== "vertical")("cds-tab-list__arrow--up", ctx.appearance === "vertical")("cds-tab-list__arrow--hidden", !ctx.arrowLeft);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("cds-icon-angle-left", ctx.appearance !== "vertical")("cds-icon-angle-up", ctx.appearance === "vertical");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("cds-tab-list__arrow--right", ctx.appearance !== "vertical")("cds-tab-list__arrow--down", ctx.appearance === "vertical")("cds-tab-list__arrow--hidden", !ctx.arrowRight);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("cds-icon-angle-right", ctx.appearance !== "vertical")("cds-icon-angle-down", ctx.appearance === "vertical");
    } }, directives: [ButtonRippleDirective], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TabListComponent, [{
        type: Component,
        args: [{
                selector: 'cds-tab-list',
                template: "<div class=\"cds-tab-list__container\">\n\t<div class=\"cds-tab-list__scroll\"\n\t     [class.cds-tab-list__scroll--no-wrap]=\"noWrap\"\n\t     [class.cds-tab-list__scroll--arrow-left]=\"arrowLeft && appearance !== 'vertical'\"\n\t     [class.cds-tab-list__scroll--arrow-right]=\"arrowRight && appearance !== 'vertical'\"\n\t     tabindex=\"-1\"\n\t     #scrollable>\n\t\t<div class=\"cds-tab-list__intersection\">\n\t\t\t<div #intersectionLeft></div>\n\t\t</div>\n\t\t<div class=\"cds-tab-list__tabs cds-tab-group\">\n\t\t\t<ng-content></ng-content>\n\t\t</div>\n\t\t<div class=\"cds-tab-list__intersection\">\n\t\t\t<div #intersectionRight></div>\n\t\t</div>\n\t</div>\n\t<div class=\"cds-tab-list__arrow\"\n\t     [class.cds-tab-list__arrow--left]=\"appearance !== 'vertical'\"\n\t     [class.cds-tab-list__arrow--up]=\"appearance === 'vertical'\"\n\t     [class.cds-tab-list__arrow--hidden]=\"!arrowLeft\">\n\t\t<div cdsButton class=\"cds-button-icon cds-button-small\"\n\t\t     (mousedown)=\"scrollTabs($event, false)\"\n\t\t     (touchstart)=\"scrollTabs($event, false)\">\n\t\t\t<i class=\"cds-icon--size-24\"\n\t\t\t   [class.cds-icon-angle-left]=\"appearance !== 'vertical'\"\n\t\t\t   [class.cds-icon-angle-up]=\"appearance === 'vertical'\"></i>\n\t\t</div>\n\t</div>\n\t<div class=\"cds-tab-list__arrow\"\n\t     [class.cds-tab-list__arrow--right]=\"appearance !== 'vertical'\"\n\t     [class.cds-tab-list__arrow--down]=\"appearance === 'vertical'\"\n\t     [class.cds-tab-list__arrow--hidden]=\"!arrowRight\">\n\t\t<div cdsButton class=\"cds-button-icon cds-button-small\"\n\t\t     (mousedown)=\"scrollTabs($event, true)\"\n\t\t     (touchstart)=\"scrollTabs($event, true)\">\n\t\t\t<i class=\"cds-icon--size-24\"\n\t\t\t   [class.cds-icon-angle-right]=\"appearance !== 'vertical'\"\n\t\t\t   [class.cds-icon-angle-down]=\"appearance === 'vertical'\"></i>\n\t\t</div>\n\t</div>\n</div>\n\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                providers: [
                    TAB_LIST_HOST_PROVIDER,
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.NgZone }]; }, { appearance: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.cds-tab-list-appearance']
        }], focusableItems: [{
            type: ContentChildren,
            args: [TabComponent, { read: TabComponent }]
        }], multiline: [{
            type: Input
        }], intersectionRight: [{
            type: ViewChild,
            args: ['intersectionRight', { read: ElementRef, static: true }]
        }], intersectionLeft: [{
            type: ViewChild,
            args: ['intersectionLeft', { read: ElementRef, static: true }]
        }], scrollable: [{
            type: ViewChild,
            args: ['scrollable', { read: ElementRef, static: true }]
        }] }); })();
    return TabListComponent;
}(AbstractFocusGroupDirective));
function getOffset(scrollable, element, isVertical) {
    if (element.offsetParent === scrollable) {
        return isVertical ? element.offsetTop : element.offsetLeft;
    }
    else {
        return isVertical ?
            element.offsetTop - scrollable.offsetTop :
            element.offsetLeft - scrollable.offsetLeft;
    }
}

var TabModule = /** @class */ (function () {
    function TabModule() {
    }
TabModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TabModule });
TabModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TabModule_Factory(t) { return new (t || TabModule)(); }, imports: [[
            CommonModule,
            ButtonModule,
            RippleModule,
            ToggleModule,
        ], ToggleModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TabModule, { declarations: function () { return [TabComponent, TabListComponent]; }, imports: function () { return [CommonModule, ButtonModule, RippleModule, ToggleModule]; }, exports: function () { return [TabComponent, TabListComponent, ToggleModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TabModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ButtonModule,
                    RippleModule,
                    ToggleModule,
                ],
                declarations: [
                    TabComponent,
                    TabListComponent,
                ],
                exports: [
                    TabComponent,
                    TabListComponent,
                    // modules
                    ToggleModule,
                ]
            }]
    }], function () { return []; }, null); })();
    return TabModule;
}());

var ResizeDirective = /** @class */ (function () {
    function ResizeDirective(elementRef, zone) {
        this.elementRef = elementRef;
        this.zone = zone;
        this.resize = 'vertical';
        this.mousePressed = false;
        this.destroy$ = new Subject();
        this.subscription = Subscription.EMPTY;
    }
    ResizeDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.resizeHandle = this.elementRef.nativeElement;
        this.initialHeight = this.resizeVerticalElement.clientHeight;
        this.initialWidth = this.resizeHorizontalElement.clientWidth;
        this.destroy$.subscribe(listen(this.resizeHandle, 'mousedown', function (event) {
            if (event.button === 0 || event.button === 1) {
                _this.onMouseDown(event);
                _this.destroy$.subscribe(listen(window, 'mouseup', function (event) { return _this.onMouseUp(event); }, { once: true }));
            }
        }));
        this.destroy$.subscribe(listen(this.resizeHandle, 'touchstart', function (event) {
            _this.onMouseDown(event);
            _this.destroy$.subscribe(listen(window, 'touchend', function (event) { return _this.onMouseUp(event); }, { once: true }));
        }));
    };
    ResizeDirective.prototype.ngOnChanges = function () {
        if (!this.resize || this.resize === 'none') {
            this.resizeVerticalElement.style.height = null;
            this.resizeHorizontalElement.style.width = null;
            this.resizeHorizontalElement.style.maxWidth = null;
        }
    };
    ResizeDirective.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    ResizeDirective.prototype.onMouseDown = function (e) {
        var _this = this;
        e.stopPropagation();
        e.preventDefault();
        this.height = this.resizeVerticalElement.clientHeight;
        this.width = this.resizeHorizontalElement.clientWidth;
        this.mouseY = e instanceof MouseEvent ? e.clientY : e.touches.item(0).clientY;
        this.mouseX = e instanceof MouseEvent ? e.clientX : e.touches.item(0).clientX;
        this.mousePressed = true;
        this.zone.runOutsideAngular(function () {
            if (e instanceof MouseEvent) {
                _this.subscription = fromEvent(document, 'mousemove').subscribe(function (event) {
                    event.preventDefault();
                    _this.adjust(event);
                });
            }
            else {
                _this.subscription = fromEvent(document, 'touchmove').subscribe(function (event) {
                    var touch = event.touches.item(0);
                    event.preventDefault();
                    _this.adjust(touch);
                });
            }
        });
    };
    ResizeDirective.prototype.adjust = function (event) {
        switch (this.resize) {
            case 'vertical':
                this.adjustHeight(event);
                break;
            case 'horizontal':
                this.adjustWidth(event);
                break;
            case 'both':
                this.adjustHeight(event);
                this.adjustWidth(event);
        }
    };
    ResizeDirective.prototype.adjustHeight = function (event) {
        var newHeight = this.height + event.clientY - this.mouseY;
        this.resizeVerticalElement.style.height = Math.max(newHeight, this.initialHeight) + 'px';
    };
    ResizeDirective.prototype.adjustWidth = function (event) {
        var newWidth = this.width + event.clientX - this.mouseX;
        this.resizeHorizontalElement.style.maxWidth = '100%';
        this.resizeHorizontalElement.style.width = Math.max(newWidth, this.initialWidth) + 'px';
    };
    ResizeDirective.prototype.onMouseUp = function (e) {
        if (this.mousePressed) {
            e.stopPropagation();
            e.preventDefault();
            this.subscription.unsubscribe();
            this.mousePressed = false;
        }
    };
    ResizeDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: NgZone }
    ]; };
    __decorate([
        Input('cdsResize'),
        __metadata("design:type", String)
    ], ResizeDirective.prototype, "resize", void 0);
    __decorate([
        Input(),
        __metadata("design:type", HTMLElement)
    ], ResizeDirective.prototype, "resizeVerticalElement", void 0);
    __decorate([
        Input(),
        __metadata("design:type", HTMLElement)
    ], ResizeDirective.prototype, "resizeHorizontalElement", void 0);
    ResizeDirective = __decorate([ __metadata("design:paramtypes", [ElementRef, NgZone])
    ], ResizeDirective);
ResizeDirective.ɵfac = function ResizeDirective_Factory(t) { return new (t || ResizeDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
ResizeDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ResizeDirective, selectors: [["", "cdsResize", ""]], inputs: { resize: ["cdsResize", "resize"], resizeVerticalElement: "resizeVerticalElement", resizeHorizontalElement: "resizeHorizontalElement" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ResizeDirective, [{
        type: Directive,
        args: [{
                selector: '[cdsResize]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, { resize: [{
            type: Input,
            args: ['cdsResize']
        }], resizeVerticalElement: [{
            type: Input
        }], resizeHorizontalElement: [{
            type: Input
        }] }); })();
    return ResizeDirective;
}());

var ResizeModule = /** @class */ (function () {
    function ResizeModule() {
    }
ResizeModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ResizeModule });
ResizeModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ResizeModule_Factory(t) { return new (t || ResizeModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ResizeModule, { declarations: [ResizeDirective], exports: [ResizeDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ResizeModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ResizeDirective,
                ],
                exports: [
                    ResizeDirective,
                ]
            }]
    }], function () { return []; }, null); })();
    return ResizeModule;
}());

/* Directive was copied from @angular/cdk and adjusted */
var MEASURING_STYLES = 'height: auto !important; overflow: hidden !important; padding: 2px 0 !important; box-sizing: content-box !important;';
var AutogrowDirective = /** @class */ (function () {
    function AutogrowDirective(_elementRef, _platform, _ngZone) {
        this._elementRef = _elementRef;
        this._platform = _platform;
        this._ngZone = _ngZone;
        this._destroyed = new Subject();
        this._enabled = true;
        /**
         * Value of minRows as of last resize. If the minRows has decreased, the
         * height of the textarea needs to be recomputed to reflect the new minimum. The maxHeight
         * does not have the same problem because it does not affect the textarea's scrollHeight.
         */
        this._previousMinRows = -1;
        this._textareaElement = this._elementRef.nativeElement;
        if (isPlatformBrowser(this._platform)) {
            this._textareaElement.style.resize = 'none';
            this._textareaElement.rows = 1;
        }
    }
    Object.defineProperty(AutogrowDirective.prototype, "styleOverflow", {
        /** Hides scrollbar in IE */
        get: function () {
            return this._enabled && !this._maxRows ? 'hidden' : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutogrowDirective.prototype, "minRows", {
        /** Minimum amount of rows in the textarea. */
        get: function () { return this._minRows; },
        set: function (value) {
            this._minRows = value;
            if (isPlatformBrowser(this._platform)) {
                this._textareaElement.rows = value;
            }
            this._setMinHeight();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutogrowDirective.prototype, "maxRows", {
        /** Maximum amount of rows in the textarea. */
        get: function () { return this._maxRows; },
        set: function (value) {
            this._maxRows = value;
            this._setMaxHeight();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutogrowDirective.prototype, "enabled", {
        /** Whether autosizing is enabled or not */
        get: function () { return this._enabled; },
        set: function (value) {
            value = coerceBooleanProperty(value);
            // Only act if the actual value changed. This specifically helps to not run
            // resizeToFitContent too early (i.e. before ngAfterViewInit)
            if (this._enabled !== value) {
                this._enabled = value;
                this._enabled ? this.resizeToFitContent(true) : this.reset();
            }
            if (isPlatformBrowser(this._platform)) {
                if (value) {
                    this._textareaElement.rows = 1;
                }
                else {
                    delete this._textareaElement.rows;
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    /** Sets the minimum height of the textarea as determined by minRows. */
    AutogrowDirective.prototype._setMinHeight = function () {
        var minHeight = this.minRows && this._cachedLineHeight ?
            this.minRows * this._cachedLineHeight + "px" : null;
        if (minHeight) {
            this._textareaElement.style.minHeight = minHeight;
        }
    };
    /** Sets the maximum height of the textarea as determined by maxRows. */
    AutogrowDirective.prototype._setMaxHeight = function () {
        var maxHeight = this.maxRows && this._cachedLineHeight ?
            this.maxRows * this._cachedLineHeight + "px" : null;
        if (maxHeight) {
            this._textareaElement.style.maxHeight = maxHeight;
        }
    };
    AutogrowDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (isPlatformBrowser(this._platform)) {
            // Remember the height which we started with in case autosizing is disabled
            this._initialHeight = this._textareaElement.style.height;
            this.resizeToFitContent();
            this._ngZone.runOutsideAngular(function () {
                fromEvent(window, 'resize')
                    .pipe(auditTime(16), takeUntil(_this._destroyed))
                    .subscribe(function () { return _this.resizeToFitContent(true); });
            });
        }
    };
    AutogrowDirective.prototype.ngOnDestroy = function () {
        this._destroyed.next();
        this._destroyed.complete();
    };
    /**
     * Cache the height of a single-row textarea if it has not already been cached.
     *
     * We need to know how large a single "row" of a textarea is in order to apply minRows and
     * maxRows. For the initial version, we will assume that the height of a single line in the
     * textarea does not ever change.
     */
    AutogrowDirective.prototype._cacheTextareaLineHeight = function () {
        if (this._cachedLineHeight) {
            return;
        }
        // Use a clone element because we have to override some styles.
        var textareaClone = this._textareaElement.cloneNode(false);
        textareaClone.rows = 1;
        // Use `position: absolute` so that this doesn't cause a browser layout and use
        // `visibility: hidden` so that nothing is rendered. Clear any other styles that
        // would affect the height.
        textareaClone.style.position = 'absolute';
        textareaClone.style.visibility = 'hidden';
        textareaClone.style.border = 'none';
        textareaClone.style.padding = '0';
        textareaClone.style.height = '';
        textareaClone.style.minHeight = '';
        textareaClone.style.maxHeight = '';
        // In Firefox it happens that textarea elements are always bigger than the specified amount
        // of rows. This is because Firefox tries to add extra space for the horizontal scrollbar.
        // As a workaround that removes the extra space for the scrollbar, we can just set overflow
        // to hidden. This ensures that there is no invalid calculation of the line height.
        // See Firefox bug report: https://bugzilla.mozilla.org/show_bug.cgi?id=33654
        textareaClone.style.overflow = 'hidden';
        this._textareaElement.parentNode.appendChild(textareaClone);
        this._cachedLineHeight = textareaClone.clientHeight;
        this._textareaElement.parentNode.removeChild(textareaClone);
        // Min and max heights have to be re-calculated if the cached line height changes
        this._setMinHeight();
        this._setMaxHeight();
    };
    AutogrowDirective.prototype.ngDoCheck = function () {
        if (isPlatformBrowser(this._platform)) {
            this.resizeToFitContent();
        }
    };
    /**
     * Resize the textarea to fit its content.
     * @param force Whether to force a height recalculation. By default the height will be
     *    recalculated only if the value changed since the last call.
     */
    AutogrowDirective.prototype.resizeToFitContent = function (force) {
        var _this = this;
        if (force === void 0) { force = false; }
        // If autosizing is disabled, just skip everything else
        if (!this._enabled) {
            return;
        }
        this._cacheTextareaLineHeight();
        // If we haven't determined the line-height yet, we know we're still hidden and there's no point
        // in checking the height of the textarea.
        if (!this._cachedLineHeight) {
            return;
        }
        var textarea = this._elementRef.nativeElement;
        var value = textarea.value;
        // Only resize if the value or minRows have changed since these calculations can be expensive.
        if (!force && this._minRows === this._previousMinRows && value === this._previousValue) {
            return;
        }
        var appendedToValue = value.startsWith(this._previousValue);
        var placeholderText = textarea.placeholder;
        // Reset the textarea height to auto in order to shrink back to its default size.
        // Also temporarily force overflow:hidden, so scroll bars do not interfere with calculations.
        // Long placeholders that are wider than the textarea width may lead to a bigger scrollHeight
        // value. To ensure that the scrollHeight is not bigger than the content, the placeholders
        // need to be removed temporarily.
        var styles = textarea.style.cssText;
        if (!appendedToValue) {
            textarea.style.cssText = styles ? MEASURING_STYLES + " " + styles : MEASURING_STYLES;
        }
        textarea.placeholder = '';
        // Seems redundant, but fixes issue in IE when you enter only new lines
        textarea.style.height = 'auto';
        var height = textarea.scrollHeight;
        // Use the scrollHeight to know how large the textarea *would* be if fit its entire value.
        if (!appendedToValue) {
            // The cdk-textarea-autosize-measuring class includes a 2px padding to workaround an issue with
            // Chrome, so we account for that extra space here by subtracting 4 (2px top + 2px bottom).
            height -= 4;
            textarea.style.cssText = styles;
        }
        textarea.style.height = height + "px";
        textarea.placeholder = placeholderText;
        this._ngZone.runOutsideAngular(function () {
            if (typeof requestAnimationFrame !== 'undefined') {
                requestAnimationFrame(function () { return _this._scrollToCaretPosition(textarea); });
            }
            else {
                setTimeout(function () { return _this._scrollToCaretPosition(textarea); });
            }
        });
        this._previousValue = value;
        this._previousMinRows = this._minRows;
    };
    /**
     * Resets the textarea to it's original size
     */
    AutogrowDirective.prototype.reset = function () {
        // Do not try to change the textarea, if the initialHeight has not been determined yet
        // This might potentially remove styles when reset() is called before ngAfterViewInit
        if (this._initialHeight === undefined) {
            return;
        }
        this._textareaElement.style.height = this._initialHeight;
    };
    AutogrowDirective.prototype._noopInputHandler = function () {
        // no-op handler that ensures we're running change detection on input events.
    };
    /**
     * Scrolls a textarea to the caret position. On Firefox resizing the textarea will
     * prevent it from scrolling to the caret position. We need to re-set the selection
     * in order for it to scroll to the proper position.
     */
    AutogrowDirective.prototype._scrollToCaretPosition = function (textarea) {
        var selectionStart = textarea.selectionStart, selectionEnd = textarea.selectionEnd;
        // IE will throw an "Unspecified error" if we try to set the selection range after the
        // element has been removed from the DOM. Assert that the directive hasn't been destroyed
        // between the time we requested the animation frame and when it was executed.
        // Also note that we have to assert that the textarea is focused before we set the
        // selection range. Setting the selection range on a non-focused textarea will cause
        // it to receive focus on IE and Edge.
        if (!this._destroyed.isStopped && document.activeElement === textarea) {
            // textarea.setSelectionRange(selectionStart, selectionEnd);
        }
    };
    AutogrowDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
        { type: NgZone }
    ]; };
    __decorate([
        HostBinding('style.overflow'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], AutogrowDirective.prototype, "styleOverflow", null);
    __decorate([
        Input('rows'),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], AutogrowDirective.prototype, "minRows", null);
    __decorate([
        Input('maxRows'),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], AutogrowDirective.prototype, "maxRows", null);
    __decorate([
        Input('cdsAutogrow'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], AutogrowDirective.prototype, "enabled", null);
    __decorate([
        HostListener('input'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AutogrowDirective.prototype, "_noopInputHandler", null);
    AutogrowDirective = __decorate([ __param(1, Inject(PLATFORM_ID)),
        __metadata("design:paramtypes", [ElementRef, Object, NgZone])
    ], AutogrowDirective);
AutogrowDirective.ɵfac = function AutogrowDirective_Factory(t) { return new (t || AutogrowDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
AutogrowDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: AutogrowDirective, selectors: [["textarea", "cdsAutogrow", ""]], hostVars: 2, hostBindings: function AutogrowDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("input", function AutogrowDirective_input_HostBindingHandler() { return ctx._noopInputHandler(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("overflow", ctx.styleOverflow);
    } }, inputs: { minRows: ["rows", "minRows"], maxRows: "maxRows", enabled: ["cdsAutogrow", "enabled"] } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AutogrowDirective, [{
        type: Directive,
        args: [{
                selector: 'textarea[cdsAutogrow]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: ɵngcc0.NgZone }]; }, { styleOverflow: [{
            type: HostBinding,
            args: ['style.overflow']
        }], minRows: [{
            type: Input,
            args: ['rows']
        }], maxRows: [{
            type: Input,
            args: ['maxRows']
        }], enabled: [{
            type: Input,
            args: ['cdsAutogrow']
        }], _noopInputHandler: [{
            type: HostListener,
            args: ['input']
        }] }); })();
    return AutogrowDirective;
}());
function coerceBooleanProperty(value) {
    return !!value;
}

var AutogrowModule = /** @class */ (function () {
    function AutogrowModule() {
    }
AutogrowModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AutogrowModule });
AutogrowModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AutogrowModule_Factory(t) { return new (t || AutogrowModule)(); } });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AutogrowModule, { declarations: [AutogrowDirective], exports: [AutogrowDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AutogrowModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    AutogrowDirective,
                ],
                exports: [
                    AutogrowDirective,
                ]
            }]
    }], function () { return []; }, null); })();
    return AutogrowModule;
}());

var TEXTAREA_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return TextareaComponent; }),
    multi: true,
};
var INPUT_COMPONENT = {
    provide: InputComponent,
    useExisting: forwardRef(function () { return TextareaComponent; }),
};
var TextareaComponent = /** @class */ (function (_super) {
    __extends(TextareaComponent, _super);
    function TextareaComponent(elementRef, renderer, cdRef, transformer, zone) {
        var _this = _super.call(this, elementRef, renderer, cdRef, transformer) || this;
        _this.zone = zone;
        _this.autogrow = false;
        _this.rows = 2;
        _this.resize = 'none';
        renderer.addClass(elementRef.nativeElement, 'cds-textarea');
        return _this;
    }
    TextareaComponent.prototype.ngOnChanges = function (changes) {
        if ('length' in changes || 'maxlength' in changes) {
            this.limit = toNumber(this.length != null ? this.length : this.maxlength);
        }
        if ('autogrow' in changes || 'resize' in changes) {
            this.resize = this.autogrow ? 'none' : this.resize;
        }
    };
    TextareaComponent.prototype.writeValue = function (modelValue) {
        var _this = this;
        _super.prototype.writeValue.call(this, modelValue);
        if (this.autogrow && this.autogrowDirective) {
            this.zone.runOutsideAngular(function () {
                requestAnimationFrame(function () {
                    _this.zone.run(function () {
                        /* Wait for setting value on native element in case of changed value in same detection cycle */
                        _this.cdRef.markForCheck();
                        // this.autogrowElement.check();
                    });
                });
            });
        }
    };
    TextareaComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ChangeDetectorRef },
        { type: undefined, decorators: [{ type: Host }, { type: Optional }, { type: Inject, args: [CDS_INPUT_MODEL_TRANSFORMER,] }] },
        { type: NgZone }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], TextareaComponent.prototype, "autogrow", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], TextareaComponent.prototype, "rows", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], TextareaComponent.prototype, "resize", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], TextareaComponent.prototype, "maxRows", void 0);
    __decorate([
        ViewChild('input', { read: AutogrowDirective, static: true }),
        __metadata("design:type", AutogrowDirective)
    ], TextareaComponent.prototype, "autogrowDirective", void 0);
    TextareaComponent = __decorate([ __param(3, Host()), __param(3, Optional()), __param(3, Inject(CDS_INPUT_MODEL_TRANSFORMER)),
        __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            ChangeDetectorRef, Object, NgZone])
    ], TextareaComponent);
TextareaComponent.ɵfac = function TextareaComponent_Factory(t) { return new (t || TextareaComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(CDS_INPUT_MODEL_TRANSFORMER, 9), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
TextareaComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TextareaComponent, selectors: [["cds-textarea"]], viewQuery: function TextareaComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c5, true, AutogrowDirective);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.autogrowDirective = _t.first);
    } }, inputs: { resize: "resize", autogrow: "autogrow", rows: "rows", maxRows: "maxRows" }, features: [ɵngcc0.ɵɵProvidersFeature([TEXTAREA_CONTROL_VALUE_ACCESSOR, INPUT_COMPONENT]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 8, vars: 13, consts: [[1, "cds-control__container", "cds-zero-width-space"], [1, "cds-control__content"], ["class", "cds-control__label", 4, "ngIf"], ["autocomplete", "off", 1, "cds-control__value", "cds-control__value--textarea", 3, "id", "name", "rows", "maxRows", "placeholder", "autofocus", "ngModel", "disabled", "maxlength", "cdsAutogrow", "ngModelChange", "blur", "focus"], ["textarea", "", "input", ""], ["class", "cds-control__status", 3, "cds-control__status--shift", 4, "ngIf"], ["class", "cds-textarea__resize-handle", 3, "cdsResize", "resizeVerticalElement", "resizeHorizontalElement", 4, "ngIf"], [1, "cds-control__label"], [1, "cds-control__label-text"], [1, "cds-control__status"], [1, "cds-textarea__resize-handle", 3, "cdsResize", "resizeVerticalElement", "resizeHorizontalElement"]], template: function TextareaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, TextareaComponent_div_2_Template, 3, 1, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "textarea", 3, 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function TextareaComponent_Template_textarea_ngModelChange_3_listener($event) { return ctx.value = $event; })("blur", function TextareaComponent_Template_textarea_blur_3_listener($event) { return ctx.onBlur($event); })("focus", function TextareaComponent_Template_textarea_focus_3_listener($event) { return ctx.onFocus($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, TextareaComponent_div_6_Template, 3, 4, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, TextareaComponent_div_7_Template, 1, 3, "div", 6);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.labelValue);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("id", ctx.name);
        ɵngcc0.ɵɵpropertyInterpolate1("name", "cds-input-", ctx.name, "");
        ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx.placeholder);
        ɵngcc0.ɵɵpropertyInterpolate("maxlength", ctx.length != null ? ctx.length : ctx.maxlength);
        ɵngcc0.ɵɵproperty("rows", ctx.rows)("maxRows", ctx.maxRows)("autofocus", ctx.autofocus)("ngModel", ctx.value)("disabled", ctx.disabled)("cdsAutogrow", ctx.autogrow);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.limit != null);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.resize !== "none");
    } }, directives: [ɵngcc1.NgIf, ɵngcc3.DefaultValueAccessor, AutogrowDirective, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.MaxLengthValidator, ResizeDirective], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TextareaComponent, [{
        type: Component,
        args: [{
                selector: 'cds-textarea',
                template: "<div class=\"cds-control__container cds-zero-width-space\"></div>\n<div class=\"cds-control__content\">\n\t<div class=\"cds-control__label\" *ngIf=\"labelValue\">\n\t\t<div class=\"cds-control__label-text\">{{labelValue}}</div>\n\t</div>\n\t<textarea id=\"{{name}}\" #textarea name=\"cds-input-{{name}}\" class=\"cds-control__value cds-control__value--textarea\"\n\t          autocomplete=\"off\" [rows]=\"rows\" [maxRows]=\"maxRows\" placeholder=\"{{placeholder}}\" [autofocus]=\"autofocus\"\n\t          [(ngModel)]=\"value\" (blur)=\"onBlur($event)\" (focus)=\"onFocus($event)\" [disabled]=\"disabled\" maxlength=\"{{length != null ? length : maxlength}}\"\n\t          [cdsAutogrow]=\"autogrow\" #input></textarea>\n\t<div *ngIf=\"limit != null\" class=\"cds-control__status\" [class.cds-control__status--shift]=\"resize && resize !== 'none'\">\n\t\t<span>{{value ? value.length : '0'}} / {{limit}}</span>\n\t</div>\n</div>\n<div *ngIf=\"resize !== 'none'\" [cdsResize]=\"resize\" [resizeVerticalElement]=\"textarea\" [resizeHorizontalElement]=\"elementRef.nativeElement\" class=\"cds-textarea__resize-handle\"></div>\n",
                providers: [TEXTAREA_CONTROL_VALUE_ACCESSOR, INPUT_COMPONENT],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: undefined, decorators: [{
                type: Host
            }, {
                type: Optional
            }, {
                type: Inject,
                args: [CDS_INPUT_MODEL_TRANSFORMER]
            }] }, { type: ɵngcc0.NgZone }]; }, { resize: [{
            type: Input
        }], autogrow: [{
            type: Input
        }], rows: [{
            type: Input
        }], maxRows: [{
            type: Input
        }], autogrowDirective: [{
            type: ViewChild,
            args: ['input', { read: AutogrowDirective, static: true }]
        }] }); })();
    return TextareaComponent;
}(InputComponent));
function toNumber(value) {
    if (value != null) {
        return +value;
    }
    else {
        return null;
    }
}

var TextareaModule = /** @class */ (function () {
    function TextareaModule() {
    }
TextareaModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TextareaModule });
TextareaModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TextareaModule_Factory(t) { return new (t || TextareaModule)(); }, imports: [[
            AutogrowModule,
            CommonModule,
            FormsModule,
            ResizeModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TextareaModule, { declarations: function () { return [TextareaComponent]; }, imports: function () { return [AutogrowModule, CommonModule,
        FormsModule, ResizeModule]; }, exports: function () { return [TextareaComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TextareaModule, [{
        type: NgModule,
        args: [{
                imports: [
                    AutogrowModule,
                    CommonModule,
                    FormsModule,
                    ResizeModule,
                ],
                declarations: [
                    TextareaComponent,
                ],
                exports: [
                    TextareaComponent,
                ]
            }]
    }], function () { return []; }, null); })();
    return TextareaModule;
}());

var ANIMATION_TIMING = '0.3s cubic-bezier(0.165, 0.84, 0.44, 1)';
var ToastWrapperComponent = /** @class */ (function () {
    function ToastWrapperComponent(elementRef, renderer) {
        this.animation = true;
        renderer.addClass(elementRef.nativeElement, 'cds-toast-wrapper');
    }
    ToastWrapperComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 }
    ]; };
    __decorate([
        HostBinding('@slide'),
        __metadata("design:type", Object)
    ], ToastWrapperComponent.prototype, "animation", void 0);
    __decorate([
        ViewChild('container', { read: ViewContainerRef, static: true }),
        __metadata("design:type", ViewContainerRef)
    ], ToastWrapperComponent.prototype, "container", void 0);
    ToastWrapperComponent = __decorate([ __metadata("design:paramtypes", [ElementRef, Renderer2])
    ], ToastWrapperComponent);
ToastWrapperComponent.ɵfac = function ToastWrapperComponent_Factory(t) { return new (t || ToastWrapperComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
ToastWrapperComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ToastWrapperComponent, selectors: [["cds-toast-wrapper"]], viewQuery: function ToastWrapperComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c39, true, ViewContainerRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.container = _t.first);
    } }, hostVars: 1, hostBindings: function ToastWrapperComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵsyntheticHostProperty("@slide", ctx.animation);
    } }, decls: 2, vars: 0, consts: [["container", ""]], template: function ToastWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ToastWrapperComponent_ng_template_0_Template, 0, 0, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
    } }, encapsulation: 2, data: { animation: [
            trigger('slide', [
                transition(':enter', [
                    style({ opacity: 0 }),
                    query('.cds-toast', style({ height: 0, marginTop: 0, marginBottom: 0 }), { optional: true }),
                    query('.cds-upload-toast', style({ height: 0, marginTop: 0, marginBottom: 0 }), { optional: true }),
                    group([
                        animate(ANIMATION_TIMING, style({ opacity: 1 })),
                        query('.cds-toast', animate(ANIMATION_TIMING, style({ height: '*', marginTop: '*', marginBottom: '*' })), { optional: true }),
                        query('.cds-upload-toast', animate(ANIMATION_TIMING, style({ height: '*', marginTop: '*', marginBottom: '*' })), { optional: true }),
                    ]),
                ]),
                transition(':leave', [
                    style({ opacity: 1 }),
                    query('.cds-toast', style({ height: '*', marginTop: '*', marginBottom: '*' }), { optional: true }),
                    query('.cds-upload-toast', style({ height: '*', marginTop: '*', marginBottom: '*' }), { optional: true }),
                    group([
                        animate(ANIMATION_TIMING, style({ opacity: 0 })),
                        query('.cds-toast', animate(ANIMATION_TIMING, style({ height: 0, marginTop: 0, marginBottom: 0 })), { optional: true }),
                        query('.cds-upload-toast', animate(ANIMATION_TIMING, style({ height: 0, marginTop: 0, marginBottom: 0 })), { optional: true }),
                    ]),
                ]),
            ]),
        ] }, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ToastWrapperComponent, [{
        type: Component,
        args: [{
                selector: 'cds-toast-wrapper',
                template: '<ng-template #container></ng-template>',
                animations: [
                    trigger('slide', [
                        transition(':enter', [
                            style({ opacity: 0 }),
                            query('.cds-toast', style({ height: 0, marginTop: 0, marginBottom: 0 }), { optional: true }),
                            query('.cds-upload-toast', style({ height: 0, marginTop: 0, marginBottom: 0 }), { optional: true }),
                            group([
                                animate(ANIMATION_TIMING, style({ opacity: 1 })),
                                query('.cds-toast', animate(ANIMATION_TIMING, style({ height: '*', marginTop: '*', marginBottom: '*' })), { optional: true }),
                                query('.cds-upload-toast', animate(ANIMATION_TIMING, style({ height: '*', marginTop: '*', marginBottom: '*' })), { optional: true }),
                            ]),
                        ]),
                        transition(':leave', [
                            style({ opacity: 1 }),
                            query('.cds-toast', style({ height: '*', marginTop: '*', marginBottom: '*' }), { optional: true }),
                            query('.cds-upload-toast', style({ height: '*', marginTop: '*', marginBottom: '*' }), { optional: true }),
                            group([
                                animate(ANIMATION_TIMING, style({ opacity: 0 })),
                                query('.cds-toast', animate(ANIMATION_TIMING, style({ height: 0, marginTop: 0, marginBottom: 0 })), { optional: true }),
                                query('.cds-upload-toast', animate(ANIMATION_TIMING, style({ height: 0, marginTop: 0, marginBottom: 0 })), { optional: true }),
                            ]),
                        ]),
                    ]),
                ],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { animation: [{
            type: HostBinding,
            args: ['@slide']
        }], container: [{
            type: ViewChild,
            args: ['container', { read: ViewContainerRef, static: true }]
        }] }); })();
    return ToastWrapperComponent;
}());

var TOAST_TRANSLATIONS_EN = {
    close: 'Close',
};
function toastTranslationsFactory() {
    return TOAST_TRANSLATIONS_EN;
}
var CDS_TOAST_TRANSLATIONS = new InjectionToken('CDS_TOAST_TRANSLATIONS', { factory: toastTranslationsFactory });

var ToastComponent = /** @class */ (function () {
    function ToastComponent(elementRef, renderer, componentTranslations) {
        var _this = this;
        this.isCloseButtonFocused = false;
        this.statusIcon = false;
        this.toastClose = new EventEmitter();
        renderer.addClass(elementRef.nativeElement, 'cds-toast');
        componentTranslations.use(CDS_TOAST_TRANSLATIONS, toastTranslationsFactory, function (translations) {
            _this.translations = translations;
        });
    }
    Object.defineProperty(ToastComponent.prototype, "success", {
        get: function () {
            return this.status === 'success';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ToastComponent.prototype, "danger", {
        get: function () {
            return this.status === 'danger';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ToastComponent.prototype, "warning", {
        get: function () {
            return this.status === 'warning';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ToastComponent.prototype, "info", {
        get: function () {
            return this.status === 'info';
        },
        enumerable: true,
        configurable: true
    });
    ToastComponent.prototype.onCloseButtonFocus = function () {
        this.isCloseButtonFocused = true;
    };
    ToastComponent.prototype.onCloseButtonBlur = function () {
        this.isCloseButtonFocused = false;
    };
    ToastComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: DynamicTranslations }
    ]; };
    __decorate([
        HostBinding('class.cds-toast--success'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ToastComponent.prototype, "success", null);
    __decorate([
        HostBinding('class.cds-toast--danger'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ToastComponent.prototype, "danger", null);
    __decorate([
        HostBinding('class.cds-toast--warning'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ToastComponent.prototype, "warning", null);
    __decorate([
        HostBinding('class.cds-toast--info'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ToastComponent.prototype, "info", null);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], ToastComponent.prototype, "status", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], ToastComponent.prototype, "statusIcon", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], ToastComponent.prototype, "toastClose", void 0);
    ToastComponent = __decorate([ __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            DynamicTranslations])
    ], ToastComponent);
ToastComponent.ɵfac = function ToastComponent_Factory(t) { return new (t || ToastComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations)); };
ToastComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ToastComponent, selectors: [["cds-toast"]], hostVars: 8, hostBindings: function ToastComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("cds-toast--success", ctx.success)("cds-toast--danger", ctx.danger)("cds-toast--warning", ctx.warning)("cds-toast--info", ctx.info);
    } }, inputs: { statusIcon: "statusIcon", status: "status" }, outputs: { toastClose: "toastClose" }, features: [ɵngcc0.ɵɵProvidersFeature([
            DynamicTranslations,
        ])], ngContentSelectors: _c68, decls: 8, vars: 2, consts: [[1, "cds-toast__sidebar"], [1, "cds-toast__container"], [1, "cds-toast__header"], ["aria-hidden", "true", 3, "class", 4, "ngIf"], ["role", "button", "tabindex", "0", "class", "cds-icon-close cds-icon--size-24 cds-toast__close-icon", 3, "focus", "blur", "click", 4, "ngIf"], [1, "cds-toast__content"], ["aria-hidden", "true"], ["role", "button", "tabindex", "0", 1, "cds-icon-close", "cds-icon--size-24", "cds-toast__close-icon", 3, "focus", "blur", "click"]], template: function ToastComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c67);
        ɵngcc0.ɵɵelement(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, ToastComponent_i_3_Template, 1, 3, "i", 3);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵtemplate(5, ToastComponent_i_5_Template, 1, 2, "i", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵprojection(7, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.statusIcon);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.toastClose.observers.length !== 0);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ToastComponent, [{
        type: Component,
        args: [{
                selector: 'cds-toast',
                template: "<div class=\"cds-toast__sidebar\"></div>\n<div class=\"cds-toast__container\">\n\t<div class=\"cds-toast__header\">\n\t\t<i *ngIf=\"statusIcon\" aria-hidden=\"true\" class=\"cds-icon-status-{{status}} cds-icon--size-24 cds-toast__status-icon\"></i>\n\t\t<ng-content select=\"cds-slot-title,header\"></ng-content>\n\t\t<i *ngIf=\"toastClose.observers.length !== 0\"\n\t\t   (focus)=\"onCloseButtonFocus()\"\n\t\t   (blur)=\"onCloseButtonBlur()\"\n\t\t   (click)=\"toastClose.emit()\"\n\t\t   [attr.aria-hidden]=\"!isCloseButtonFocused ? 'true' : null\"\n\t\t   [attr.aria-label]=\"translations.close\"\n\t\t   role=\"button\" tabindex=\"0\" class=\"cds-icon-close cds-icon--size-24 cds-toast__close-icon\"></i>\n\t</div>\n\t<div class=\"cds-toast__content\">\n\t\t<ng-content select=\"cds-slot-content,section,cds-slot-footer,footer\"></ng-content>\n\t</div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                providers: [
                    DynamicTranslations,
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: DynamicTranslations }]; }, { statusIcon: [{
            type: Input
        }], toastClose: [{
            type: Output
        }], success: [{
            type: HostBinding,
            args: ['class.cds-toast--success']
        }], danger: [{
            type: HostBinding,
            args: ['class.cds-toast--danger']
        }], warning: [{
            type: HostBinding,
            args: ['class.cds-toast--warning']
        }], info: [{
            type: HostBinding,
            args: ['class.cds-toast--info']
        }], status: [{
            type: Input
        }] }); })();
    return ToastComponent;
}());

var ToastModule = /** @class */ (function () {
    function ToastModule() {
    }
ToastModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ToastModule });
ToastModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ToastModule_Factory(t) { return new (t || ToastModule)(); }, imports: [[
            CommonModule,
            SlotsModule,
        ], SlotsModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ToastModule, { declarations: function () { return [ToastComponent, ToastWrapperComponent]; }, imports: function () { return [CommonModule, SlotsModule]; }, exports: function () { return [ToastComponent, SlotsModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ToastModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    SlotsModule,
                ],
                declarations: [
                    ToastComponent,
                    ToastWrapperComponent,
                ],
                exports: [
                    ToastComponent,
                    // modules
                    SlotsModule,
                ],
                entryComponents: [
                    ToastWrapperComponent,
                ]
            }]
    }], function () { return []; }, null); })();
    return ToastModule;
}());

var UploadFile = /** @class */ (function () {
    function UploadFile(file, meta) {
        this.file = file;
        this.meta = meta;
        this.status$ = new Subject();
        this._status = {
            state: 'PENDING',
        };
    }
    Object.defineProperty(UploadFile.prototype, "status", {
        get: function () {
            return this._status;
        },
        enumerable: true,
        configurable: true
    });
    UploadFile.prototype.setProgress = function (progress) {
        this.setStatus({
            state: 'IN_PROGRESS',
            progress: progress,
        });
        return this;
    };
    UploadFile.prototype.setError = function (message) {
        if (this.status.state === 'IN_PROGRESS' || this.status.state === 'ERROR') {
            this.setStatus({
                state: 'ERROR',
                progress: this.status.progress,
                message: message,
            });
        }
        else {
            this.setStatus({
                state: 'ERROR',
                message: message,
            });
        }
        return this;
    };
    UploadFile.prototype.markAsCompleted = function () {
        this.setStatus({
            state: 'COMPLETED',
        });
    };
    UploadFile.prototype.destroy = function () {
        this.status$.complete();
    };
    UploadFile.prototype.setStatus = function (status) {
        this._status = status;
        this.status$.next(this.status);
    };
    return UploadFile;
}());

var UPLOAD_TRANSLATIONS_EN = {
    dragAndDrop: 'Drag & Drop',
    browse: 'or Browse',
    remove: 'Remove file',
    add: 'Add file',
    pending: 'Pending',
    loading: 'Loading',
    completed: 'Completed',
    error: 'Error',
    srFileName: 'File name',
    srUploadStatus: 'Upload status',
    srActions: 'Actions',
    close: 'Close',
    minimize: 'Minimize',
    maximize: 'Maximize',
};
function uploadTranslationsFactory() {
    return UPLOAD_TRANSLATIONS_EN;
}
var CDS_UPLOAD_TRANSLATIONS = new InjectionToken('CDS_UPLOAD_TRANSLATIONS', { factory: uploadTranslationsFactory });

var VISIBLE_STYLES = style({
    overflowY: 'hidden',
    height: '*',
    paddingTop: '*',
    paddingBottom: '*',
});
var HIDDEN_STYLES = style({
    overflowY: 'hidden',
    height: '0',
    paddingTop: '0',
    paddingBottom: '0',
});
var UploadComponent = /** @class */ (function () {
    function UploadComponent(elementRef, renderer, cdRef, componentTranslations, platform) {
        var _this = this;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.cdRef = cdRef;
        this.platform = platform;
        this.__disableDragAndDropSupport = false; // do not use this input, it is only for internal purposes and may be removed or changed
        this.destroyOnRemove = true;
        this.uploadIcon = true;
        this.size = 'normal';
        this.filesChange = new EventEmitter();
        this.filesAdd = new EventEmitter();
        this.filesRemove = new EventEmitter();
        this.filesSubject$ = new Subject();
        this.isScrollbarHidden = true;
        this.withAnimation = false;
        this.descriptionId = Unique.next('cds-upload-');
        renderer.addClass(elementRef.nativeElement, 'cds-upload');
        componentTranslations.use(CDS_UPLOAD_TRANSLATIONS, uploadTranslationsFactory, function (translations) {
            _this.translations = translations;
            _this.fileStates = {
                COMPLETED: translations.completed,
                ERROR: translations.error,
                IN_PROGRESS: translations.loading,
                PENDING: translations.pending,
            };
        });
        this.filesSubject$
            .asObservable()
            .pipe(switchMap(function (files) { return files ? merge.apply(void 0, __spread(files.map(function (file) { return file.status$; }))) : EMPTY$1; }))
            .subscribe(function () {
            cdRef.detectChanges();
        });
        if (isPlatformBrowser(platform)) {
            this.hasDragAndDropSupport = 'draggable' in document.createElement('span');
        }
    }
    UploadComponent.prototype.onDragOver = function (event) {
        if (this.dragAndDropSupport) {
            event.preventDefault();
            this.renderer.addClass(this.elementRef.nativeElement, 'cds-upload--dragover');
        }
    };
    UploadComponent.prototype.onDrop = function (event) {
        var _a;
        if (this.dragAndDropSupport) {
            event.preventDefault();
            this.renderer.removeClass(this.elementRef.nativeElement, 'cds-upload--dragover');
            if (event.type === 'drop' && ((_a = event.dataTransfer.files) === null || _a === void 0 ? void 0 : _a.length)) {
                var files = Array.from(event.dataTransfer.files).map(function (file) { return new UploadFile(file); });
                this.addFiles(files);
            }
        }
    };
    Object.defineProperty(UploadComponent.prototype, "isSmallSize", {
        get: function () {
            return this.size === 'small';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UploadComponent.prototype, "dragAndDropSupport", {
        get: function () {
            return this.hasDragAndDropSupport && !this.__disableDragAndDropSupport;
        },
        enumerable: true,
        configurable: true
    });
    UploadComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if ('files' in changes) {
            var _a = changes.files, previousValue = _a.previousValue, currentValue = _a.currentValue;
            var prevCount = (previousValue && previousValue.length) || 0;
            var nextCount = (currentValue && currentValue.length) || 0;
            var withAnimation = prevCount !== nextCount;
            if (withAnimation !== this.withAnimation) {
                Promise.resolve().then(function () {
                    _this.filesList = _this.files;
                    _this.cdRef.detectChanges();
                });
            }
            else {
                this.filesList = this.files;
            }
            this.withAnimation = withAnimation;
            this.updateIsScrollbarHidden();
            this.filesSubject$.next(this.files);
        }
    };
    UploadComponent.prototype.ngAfterViewInit = function () {
        this.updateIsScrollbarHidden();
    };
    UploadComponent.prototype.ngOnDestroy = function () {
        this.filesSubject$.complete();
    };
    UploadComponent.prototype.changeFiles = function (event, input) {
        var target = event.target;
        if (target.files.length > 0) {
            this.addFiles(Array.from(target.files).map(function (file) { return new UploadFile(file); }));
        }
        input.value = '';
    };
    UploadComponent.prototype.removeFile = function (file, index) {
        if (this.destroyOnRemove) {
            file.destroy();
        }
        if (this.files) {
            var newFilesList = this.files.filter(function (file, idx) { return idx !== index; });
            this.filesChange.emit(newFilesList);
        }
        this.filesRemove.emit([file]);
    };
    UploadComponent.prototype.updateIsScrollbarHidden = function () {
        if (isPlatformBrowser(this.platform) && this.filesWrapper) {
            var _a = this.filesWrapper.nativeElement, clientHeight = _a.clientHeight, scrollHeight = _a.scrollHeight;
            this.isScrollbarHidden = scrollHeight <= clientHeight;
        }
    };
    UploadComponent.prototype.addFiles = function (files) {
        var newFilesList = this.multiple ? (this.files ? this.files.concat(files) : files) : files.slice(0, 1);
        this.filesChange.emit(newFilesList);
        this.filesAdd.emit(files);
    };
    UploadComponent.prototype.onAnimation = function (event, element) {
        if (isPlatformBrowser(this.platform)) {
            if (event.phaseName === 'start') {
                if (this.isScrollbarHidden) {
                    element.style.overflowY = 'hidden';
                }
            }
            else {
                // workaround for ie11
                element.style.overflowY = '';
                element.style.overflowY = null;
            }
        }
    };
    UploadComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ChangeDetectorRef },
        { type: DynamicTranslations },
        { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
    ]; };
    __decorate([
        HostListener('dragover', ['$event']),
        HostListener('dragenter', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], UploadComponent.prototype, "onDragOver", null);
    __decorate([
        HostListener('dragleave', ['$event']),
        HostListener('dragend', ['$event']),
        HostListener('drop', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], UploadComponent.prototype, "onDrop", null);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], UploadComponent.prototype, "__disableDragAndDropSupport", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], UploadComponent.prototype, "multiple", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UploadComponent.prototype, "accept", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], UploadComponent.prototype, "destroyOnRemove", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UploadComponent.prototype, "ariaLabel", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], UploadComponent.prototype, "uploadIcon", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UploadComponent.prototype, "size", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], UploadComponent.prototype, "files", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], UploadComponent.prototype, "filesChange", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], UploadComponent.prototype, "filesAdd", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], UploadComponent.prototype, "filesRemove", void 0);
    __decorate([
        ViewChild('filesWrapper'),
        __metadata("design:type", ElementRef)
    ], UploadComponent.prototype, "filesWrapper", void 0);
    __decorate([
        ContentChild('fileInfo', { read: TemplateRef }),
        __metadata("design:type", TemplateRef)
    ], UploadComponent.prototype, "fileInfo", void 0);
    __decorate([
        HostBinding('class.cds-upload--small'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], UploadComponent.prototype, "isSmallSize", null);
    UploadComponent = __decorate([ __param(4, Inject(PLATFORM_ID)),
        __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            ChangeDetectorRef,
            DynamicTranslations, Object])
    ], UploadComponent);
UploadComponent.ɵfac = function UploadComponent_Factory(t) { return new (t || UploadComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID)); };
UploadComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: UploadComponent, selectors: [["cds-upload"]], contentQueries: function UploadComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c69, true, TemplateRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fileInfo = _t.first);
    } }, viewQuery: function UploadComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c70, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.filesWrapper = _t.first);
    } }, hostVars: 2, hostBindings: function UploadComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("dragover", function UploadComponent_dragover_HostBindingHandler($event) { return ctx.onDragOver($event); })("dragenter", function UploadComponent_dragenter_HostBindingHandler($event) { return ctx.onDragOver($event); })("dragleave", function UploadComponent_dragleave_HostBindingHandler($event) { return ctx.onDrop($event); })("dragend", function UploadComponent_dragend_HostBindingHandler($event) { return ctx.onDrop($event); })("drop", function UploadComponent_drop_HostBindingHandler($event) { return ctx.onDrop($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("cds-upload--small", ctx.isSmallSize);
    } }, inputs: { destroyOnRemove: "destroyOnRemove", uploadIcon: "uploadIcon", size: "size", __disableDragAndDropSupport: "__disableDragAndDropSupport", multiple: "multiple", accept: "accept", ariaLabel: "ariaLabel", files: "files" }, outputs: { filesChange: "filesChange", filesAdd: "filesAdd", filesRemove: "filesRemove" }, features: [ɵngcc0.ɵɵProvidersFeature([
            DynamicTranslations,
        ]), ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c2, decls: 14, vars: 9, consts: [["fileInfoDefault", ""], [1, "cds-upload__box"], ["type", "file", 3, "change"], ["fileInput", ""], ["role", "table", 4, "ngIf"], ["aria-hidden", "true", "class", "cds-upload__icon-wrapper", 4, "ngIf"], [1, "cds-upload__title-box"], [1, "cds-upload__title"], ["withAddButton", ""], [4, "ngIf", "ngIfElse"], [1, "cds-upload__description"], [1, "cds-upload__file-name"], ["role", "table"], ["filesWrapper", ""], ["role", "row", 1, "cds-sr-only"], ["role", "columnheader"], ["class", "cds-upload__file", "role", "row", 3, "cds-upload__file--completed", "cds-upload__file--error", 4, "ngFor", "ngForOf"], ["role", "row", 1, "cds-upload__file"], ["role", "cell"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["role", "none", 1, "cds-upload__file-info"], ["role", "cell", 1, "cds-upload__file-status"], ["aria-hidden", "true"], [3, "ngSwitch"], [3, "progress", 4, "ngSwitchCase"], ["class", "cds-icon--size-32 cds-icon-tick-circle", "role", "progressbar", "aria-valuenow", "100", "aria-valuemax", "100", "aria-valuemin", "0", 4, "ngSwitchCase"], ["class", "cds-icon--size-32 cds-icon-exclamation-circle", 4, "ngSwitchCase"], ["role", "cell", 1, "cds-upload__file-actions"], ["cdsButton", "", "type", "button", 1, "cds-button-icon", "cds-button-small", 3, "click"], [1, "cds-icon--size-24", "cds-icon-close-big"], [3, "progress"], ["role", "progressbar", "aria-valuenow", "100", "aria-valuemax", "100", "aria-valuemin", "0", 1, "cds-icon--size-32", "cds-icon-tick-circle"], [1, "cds-icon--size-32", "cds-icon-exclamation-circle"], ["aria-hidden", "true", 1, "cds-upload__icon-wrapper"], ["secondIcon", ""], ["class", "cds-upload__icon", "xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 115 108", "focusable", "false", 4, "ngIf", "ngIfElse"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 155 84", "focusable", "false", 1, "cds-upload__icon", "cds-upload__icon--simple"], ["transform", "translate(-1)"], ["transform", "rotate(-25 80.497 17.48)"], ["width", "35.964", "height", "35.654", "x", "1.438", "y", ".901", "stroke-width", "1.5", "rx", "3", 1, "cds-upload__icon-fill--background", "cds-upload__icon-stroke--secondary"], ["d", "M14.956 17.334c.056-.002.111-.003.167-.003v.004c1.1-.053 2.232.375 3.393 1.286 1.896 1.486.042.033 8.883 7.813 1.399-1.255 1.15-1.06 1.975-1.707.768-.602 1.515-.886 2.243-.85a.89.89 0 0 1 .11-.001c.037-.002.074-.002.11-.002.728-.033 1.476.25 2.244.853 1.014.796.404.317 3.239 2.837l.579 4.558c.284 2.242-1.352 4.285-3.656 4.563-.446.053-.9.037-1.34-.05h-2.35l-6.53-.298-.016-.034-7.273.333h-3.556l-9.876-.452c-.636-1.361-1-2.444-1.093-3.247-.15-1.304-.15-3.383 0-6.235 9.187-8.081 7.27-6.578 9.187-8.081 1.161-.911 2.292-1.34 3.393-1.286v-.004c.055 0 .111 0 .167.003z", 1, "cds-upload__icon-fill--secondary"], ["cx", "26.503", "cy", "11.309", "rx", "4.072", "ry", "4.038", 1, "cds-upload__icon-fill--secondary"], ["width", "27.691", "height", "27.462", "rx", "3", "transform", "rotate(19 -12.779 400.525)", 1, "cds-upload__icon-fill--secondary"], ["width", "82.95", "height", "53.813", "x", "39.029", "y", "10.803", "rx", "3", 1, "cds-upload__icon-fill--background"], ["cx", "150.306", "cy", "37.492", "rx", "1.321", "ry", "1.313", "transform", "rotate(19 150.306 37.492)", 1, "cds-upload__icon-fill--background"], ["cx", "148.883", "cy", "41.59", "rx", "1.321", "ry", "1.313", "transform", "rotate(19 148.883 41.59)", 1, "cds-upload__icon-fill--background"], ["cx", "79.75", "cy", "77.538", "rx", "1.629", "ry", "1.615", 1, "cds-upload__icon-fill--tertiary"], ["cx", "79.75", "cy", "82.385", "rx", "1.629", "ry", "1.615", 1, "cds-upload__icon-fill--tertiary"], ["d", "M79.75 50.077c.568 0 .936.134 1.284.486l4.832 4.888c.533.54.533 1.415 0 1.955-.534.54-1.4.54-1.933 0l-2.816-2.848V71.31c0 .763-.612 1.382-1.367 1.382a1.375 1.375 0 0 1-1.366-1.382l-.001-16.752-2.815 2.848c-.534.54-1.4.54-1.933 0a1.394 1.394 0 0 1 0-1.955l4.832-4.888c.348-.352.726-.486 1.283-.486z", 1, "cds-upload__icon-fill--tertiary"], ["d", "M56.043 0c1.588 0 3.077.75 3.992 2.013l1.39 1.916a2 2 0 0 0 1.62.826h46.025c2.699 0 4.887 2.128 4.887 4.754l-.001.792H40.4a3 3 0 0 0-2.995 2.825l-.005.176V4.755C37.4 2.129 39.588 0 42.286 0h13.757z", 1, "cds-upload__icon-fill--primary"], ["fill-rule", "nonzero", "stroke-width", ".5", "d", "M118.843 9.692c2.699 0 4.887 2.17 4.887 4.846V59.77c0 2.677-2.188 4.846-4.887 4.846H84.631V63l34.212.001c1.8 0 3.258-1.446 3.258-3.23V14.537c0-1.784-1.459-3.23-3.258-3.23H42.286c-1.799 0-3.257 1.446-3.257 3.23V59.77c0 1.785 1.458 3.231 3.257 3.231h32.587v1.615H42.286c-2.698 0-4.886-2.17-4.886-4.846V14.54c0-2.677 2.188-4.847 4.886-4.847h76.557z", 1, "cds-upload__icon-fill--primary", "cds-upload__icon-stroke--primary"], ["cx", "116.4", "cy", "16.962", "rx", "2.443", "ry", "2.423", 1, "cds-upload__icon-fill--primary"], ["cx", "109.884", "cy", "16.962", "rx", "2.443", "ry", "2.423", 1, "cds-upload__icon-fill--primary"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 115 108", "focusable", "false", 1, "cds-upload__icon"], ["d", "M112.09 7.629L86.306.769a3 3 0 0 0-3.668 2.117L73.784 35.69a3 3 0 0 0 2.125 3.681l25.786 6.86a3 3 0 0 0 3.668-2.117l8.853-32.804a3 3 0 0 0-2.125-3.681z", 1, "cds-upload__icon-fill--secondary"], ["width", "47.5", "height", "48.5", "x", "42.75", "y", "18.75", "stroke-width", "1.5", "rx", "3", 1, "cds-upload__icon-stroke--secondary", "cds-upload__icon-fill--background"], ["stroke-dasharray", "4", "stroke-linecap", "round", "stroke-width", "1.5", "d", "M66.5 51c4.694 0 8.5-3.582 8.5-8s-3.806-8-8.5-8-8.5 3.582-8.5 8 3.806 8 8.5 8zM15 87c11.278-20.982 25.611-34.315 43-40", 1, "cds-upload__icon-stroke--primary"], ["cx", "9.5", "cy", "98.5", "r", "9.5", 1, "cds-upload__icon-fill--primary"], [1, "cds-upload__icon-fill--background", "cds-upload__icon-stroke--tertiary"], ["d", "M51.684 88.649l1.178 1.177a2 2 0 0 1 0 2.829l-4.95 4.95a2 2 0 0 1-2.828 0l-6.523-6.523a2 2 0 0 1-.283-2.471l3.056-4.62a1 1 0 0 0-.127-1.259l-1.94-1.94c-.78-.78-.992-1.709-.211-2.49.78-.78 1.711-.57 2.492.21l5.385 5.386a.78.78 0 0 0 1.303-.34c.81-2.751 1.809-3.663 2.996-2.735a1 1 0 0 1 .385.779l.067 7.047z"], ["d", "M43.67 96.19l4.749-4.7 3.173-3.141"], ["cdsButton", "", "type", "button", 1, "cds-button-primary", 3, "click"], ["cdsButton", "", "type", "button", 1, "cds-button-text", 3, "click"]], template: function UploadComponent_Template(rf, ctx) { if (rf & 1) {
        var _r32 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, UploadComponent_ng_template_0_Template, 2, 1, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "input", 2, 3);
        ɵngcc0.ɵɵlistener("change", function UploadComponent_Template_input_change_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r32); var _r2 = ɵngcc0.ɵɵreference(4); return ctx.changeFiles($event, _r2); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, UploadComponent_ul_5_Template, 10, 5, "ul", 4);
        ɵngcc0.ɵɵtemplate(6, UploadComponent_div_6_Template, 4, 3, "div", 5);
        ɵngcc0.ɵɵelementStart(7, "span", 6);
        ɵngcc0.ɵɵelementStart(8, "span", 7);
        ɵngcc0.ɵɵtemplate(9, UploadComponent_ng_template_9_Template, 2, 2, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(11, UploadComponent_ng_container_11_Template, 5, 4, "ng-container", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 10);
        ɵngcc0.ɵɵprojection(13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        var _r5 = ɵngcc0.ɵɵreference(10);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("cds-upload__box--no-files", !(ctx.files && ctx.files.length));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("accept", ctx.accept)("multiple", ctx.multiple);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.size !== "small");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.uploadIcon && (!(ctx.files && ctx.files.length) || ctx.size === "small"));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.dragAndDropSupport)("ngIfElse", _r5);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("id", ctx.descriptionId);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, ButtonRippleDirective, ProgressSpinnerComponent], encapsulation: 2, data: { animation: [
            trigger('animation', [
                transition('void => true', [HIDDEN_STYLES, animate(200, VISIBLE_STYLES)]),
                transition('true => void', [VISIBLE_STYLES, animate(200, HIDDEN_STYLES)]),
            ]),
        ] }, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UploadComponent, [{
        type: Component,
        args: [{
                selector: 'cds-upload',
                template: "<ng-template #fileInfoDefault let-file=\"file\">\n\t<span class=\"cds-upload__file-name\">\n\t\t{{file.file.name}}\n\t</span>\n</ng-template>\n<div class=\"cds-upload__box\" [class.cds-upload__box--no-files]=\"!(files && files.length)\">\n\t<input (change)=\"changeFiles($event, fileInput)\" #fileInput type=\"file\" [attr.accept]=\"accept\" [attr.multiple]=\"multiple\" />\n\t<ul *ngIf=\"size !== 'small'\" [attr.aria-label]=\"ariaLabel\" role=\"table\" #filesWrapper>\n\t\t<li role=\"row\" class=\"cds-sr-only\">\n\t\t\t<span role=\"columnheader\">{{translations.srFileName}}</span>\n\t\t\t<span role=\"columnheader\">{{translations.srUploadStatus}}</span>\n\t\t\t<span role=\"columnheader\">{{translations.srActions}}</span>\n\t\t</li>\n\t\t<li *ngFor=\"let file of filesList; let index=index\"\n\t\t    [@animation]=\"withAnimation\"\n\t\t    (@animation.start)=\"onAnimation($event, filesWrapper)\"\n\t\t    (@animation.done)=\"onAnimation($event, filesWrapper)\"\n\t\t\tclass=\"cds-upload__file\"\n\t\t\trole=\"row\"\n\t\t    [class.cds-upload__file--completed]=\"file.status.state === 'COMPLETED'\"\n\t\t    [class.cds-upload__file--error]=\"file.status.state === 'ERROR'\">\n\t\t\t<span role=\"cell\">\n\t\t\t\t<ng-container [ngTemplateOutlet]=\"fileInfo || fileInfoDefault\" [ngTemplateOutletContext]=\"{ file: file }\"></ng-container>\n\t\t\t</span>\n\t\t\t<span role=\"none\" class=\"cds-upload__file-info\">\n\t\t\t\t<span class=\"cds-upload__file-status\" role=\"cell\">\n\t\t\t\t\t<span aria-hidden=\"true\">{{file.status.state === 'ERROR' && $any(file.status).message ? $any(file.status).message : fileStates[file.status.state]}}</span>\n\t\t\t\t\t<ng-container [ngSwitch]=\"file.status.state\">\n\t\t\t\t\t\t<cds-progress-spinner *ngSwitchCase=\"'IN_PROGRESS'\" [progress]=\"$any(file.status).progress\"></cds-progress-spinner>\n\t\t\t\t\t\t<cds-progress-spinner *ngSwitchCase=\"'PENDING'\" [progress]=\"0\" [attr.aria-label]=\"fileStates[file.status.state]\"></cds-progress-spinner>\n\t\t\t\t\t\t<i *ngSwitchCase=\"'COMPLETED'\" class=\"cds-icon--size-32 cds-icon-tick-circle\" [attr.aria-label]=\"fileStates[file.status.state]\" role=\"progressbar\" aria-valuenow=\"100\" aria-valuemax=\"100\" aria-valuemin=\"0\" ></i>\n\t\t\t\t\t\t<i *ngSwitchCase=\"'ERROR'\" class=\"cds-icon--size-32 cds-icon-exclamation-circle\" [attr.aria-label]=\"$any(file.status).message ? $any(file.status).message : fileStates[file.status.state]\"></i>\n\t\t\t\t\t</ng-container>\n\t\t\t\t</span>\n\n\t\t\t\t<span class=\"cds-upload__file-actions\" role=\"cell\">\n\t\t\t\t\t<button [attr.aria-label]=\"translations.remove\" (click)=\"removeFile(file, index)\" cdsButton class=\"cds-button-icon cds-button-small\" type=\"button\">\n\t\t\t\t\t\t<i class=\"cds-icon--size-24 cds-icon-close-big\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t</span>\n\t\t\t</span>\n\t\t</li>\n\t</ul>\n\t<div aria-hidden=\"true\" class=\"cds-upload__icon-wrapper\" *ngIf=\"uploadIcon && (!(files && files.length) || size === 'small')\" [@animation]=\"withAnimation\">\n\t\t<ng-template #secondIcon>\n\t\t\t<svg class=\"cds-upload__icon cds-upload__icon--simple\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 155 84\" focusable=\"false\">\n\t\t\t\t<g transform=\"translate(-1)\">\n\t\t\t\t\t<g transform=\"rotate(-25 80.497 17.48)\">\n\t\t\t\t\t\t<rect class=\"cds-upload__icon-fill--background cds-upload__icon-stroke--secondary\" width=\"35.964\" height=\"35.654\" x=\"1.438\" y=\".901\" stroke-width=\"1.5\" rx=\"3\"/>\n\t\t\t\t\t\t<path class=\"cds-upload__icon-fill--secondary\" d=\"M14.956 17.334c.056-.002.111-.003.167-.003v.004c1.1-.053 2.232.375 3.393 1.286 1.896 1.486.042.033 8.883 7.813 1.399-1.255 1.15-1.06 1.975-1.707.768-.602 1.515-.886 2.243-.85a.89.89 0 0 1 .11-.001c.037-.002.074-.002.11-.002.728-.033 1.476.25 2.244.853 1.014.796.404.317 3.239 2.837l.579 4.558c.284 2.242-1.352 4.285-3.656 4.563-.446.053-.9.037-1.34-.05h-2.35l-6.53-.298-.016-.034-7.273.333h-3.556l-9.876-.452c-.636-1.361-1-2.444-1.093-3.247-.15-1.304-.15-3.383 0-6.235 9.187-8.081 7.27-6.578 9.187-8.081 1.161-.911 2.292-1.34 3.393-1.286v-.004c.055 0 .111 0 .167.003z\"/>\n\t\t\t\t\t\t<ellipse class=\"cds-upload__icon-fill--secondary\" cx=\"26.503\" cy=\"11.309\" rx=\"4.072\" ry=\"4.038\"/>\n\t\t\t\t\t</g>\n\t\t\t\t\t<rect class=\"cds-upload__icon-fill--secondary\" width=\"27.691\" height=\"27.462\" rx=\"3\" transform=\"rotate(19 -12.779 400.525)\"/>\n\t\t\t\t\t<rect class=\"cds-upload__icon-fill--background\" width=\"82.95\" height=\"53.813\" x=\"39.029\" y=\"10.803\" rx=\"3\"/>\n\t\t\t\t\t<ellipse class=\"cds-upload__icon-fill--background\" cx=\"150.306\" cy=\"37.492\" rx=\"1.321\" ry=\"1.313\" transform=\"rotate(19 150.306 37.492)\"/>\n\t\t\t\t\t<ellipse class=\"cds-upload__icon-fill--background\" cx=\"148.883\" cy=\"41.59\" rx=\"1.321\" ry=\"1.313\" transform=\"rotate(19 148.883 41.59)\"/>\n\t\t\t\t\t<ellipse class=\"cds-upload__icon-fill--tertiary\" cx=\"79.75\" cy=\"77.538\" rx=\"1.629\" ry=\"1.615\"/>\n\t\t\t\t\t<ellipse class=\"cds-upload__icon-fill--tertiary\" cx=\"79.75\" cy=\"82.385\" rx=\"1.629\" ry=\"1.615\"/>\n\t\t\t\t\t<path class=\"cds-upload__icon-fill--tertiary\" d=\"M79.75 50.077c.568 0 .936.134 1.284.486l4.832 4.888c.533.54.533 1.415 0 1.955-.534.54-1.4.54-1.933 0l-2.816-2.848V71.31c0 .763-.612 1.382-1.367 1.382a1.375 1.375 0 0 1-1.366-1.382l-.001-16.752-2.815 2.848c-.534.54-1.4.54-1.933 0a1.394 1.394 0 0 1 0-1.955l4.832-4.888c.348-.352.726-.486 1.283-.486z\"/>\n\t\t\t\t\t<path class=\"cds-upload__icon-fill--primary\" d=\"M56.043 0c1.588 0 3.077.75 3.992 2.013l1.39 1.916a2 2 0 0 0 1.62.826h46.025c2.699 0 4.887 2.128 4.887 4.754l-.001.792H40.4a3 3 0 0 0-2.995 2.825l-.005.176V4.755C37.4 2.129 39.588 0 42.286 0h13.757z\"/>\n\t\t\t\t\t<path class=\"cds-upload__icon-fill--primary cds-upload__icon-stroke--primary\" fill-rule=\"nonzero\" stroke-width=\".5\" d=\"M118.843 9.692c2.699 0 4.887 2.17 4.887 4.846V59.77c0 2.677-2.188 4.846-4.887 4.846H84.631V63l34.212.001c1.8 0 3.258-1.446 3.258-3.23V14.537c0-1.784-1.459-3.23-3.258-3.23H42.286c-1.799 0-3.257 1.446-3.257 3.23V59.77c0 1.785 1.458 3.231 3.257 3.231h32.587v1.615H42.286c-2.698 0-4.886-2.17-4.886-4.846V14.54c0-2.677 2.188-4.847 4.886-4.847h76.557z\"/>\n\t\t\t\t\t<ellipse class=\"cds-upload__icon-fill--primary\" cx=\"116.4\" cy=\"16.962\" rx=\"2.443\" ry=\"2.423\"/>\n\t\t\t\t\t<ellipse class=\"cds-upload__icon-fill--primary\" cx=\"109.884\" cy=\"16.962\" rx=\"2.443\" ry=\"2.423\"/>\n\t\t\t\t</g>\n\t\t\t</svg>\n\t\t</ng-template>\n\t\t<svg *ngIf=\"dragAndDropSupport; else secondIcon\" class=\"cds-upload__icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 115 108\" focusable=\"false\">\n\t\t\t<path class=\"cds-upload__icon-fill--secondary\" d=\"M112.09 7.629L86.306.769a3 3 0 0 0-3.668 2.117L73.784 35.69a3 3 0 0 0 2.125 3.681l25.786 6.86a3 3 0 0 0 3.668-2.117l8.853-32.804a3 3 0 0 0-2.125-3.681z\"/>\n\t\t\t<rect class=\"cds-upload__icon-stroke--secondary cds-upload__icon-fill--background\" width=\"47.5\" height=\"48.5\" x=\"42.75\" y=\"18.75\" stroke-width=\"1.5\" rx=\"3\"/>\n\t\t\t<path class=\"cds-upload__icon-stroke--primary\" stroke-dasharray=\"4\" stroke-linecap=\"round\" stroke-width=\"1.5\" d=\"M66.5 51c4.694 0 8.5-3.582 8.5-8s-3.806-8-8.5-8-8.5 3.582-8.5 8 3.806 8 8.5 8zM15 87c11.278-20.982 25.611-34.315 43-40\"/>\n\t\t\t<circle class=\"cds-upload__icon-fill--primary\" cx=\"9.5\" cy=\"98.5\" r=\"9.5\" />\n\t\t\t<g class=\"cds-upload__icon-fill--background cds-upload__icon-stroke--tertiary\">\n\t\t\t\t<path d=\"M51.684 88.649l1.178 1.177a2 2 0 0 1 0 2.829l-4.95 4.95a2 2 0 0 1-2.828 0l-6.523-6.523a2 2 0 0 1-.283-2.471l3.056-4.62a1 1 0 0 0-.127-1.259l-1.94-1.94c-.78-.78-.992-1.709-.211-2.49.78-.78 1.711-.57 2.492.21l5.385 5.386a.78.78 0 0 0 1.303-.34c.81-2.751 1.809-3.663 2.996-2.735a1 1 0 0 1 .385.779l.067 7.047z\"/>\n\t\t\t\t<path d=\"M43.67 96.19l4.749-4.7 3.173-3.141\"/>\n\t\t\t</g>\n\t\t</svg>\n\t</div>\n\t<span class=\"cds-upload__title-box\">\n\t\t<span class=\"cds-upload__title\">\n\t\t\t<ng-template #withAddButton>\n\t\t\t\t<button [attr.aria-describedby]=\"descriptionId\" (click)=\"fileInput.click()\" cdsButton class=\"cds-button-primary\" type=\"button\">{{translations.add}}</button>\n\t\t\t</ng-template>\n\t\t\t<ng-container *ngIf=\"dragAndDropSupport; else withAddButton\">\n\t\t\t\t<span aria-hidden=\"true\">{{translations.dragAndDrop}}</span>\n\t\t\t\t<button [attr.aria-describedby]=\"descriptionId\" [attr.aria-label]=\"translations.add\" (click)=\"fileInput.click()\" cdsButton class=\"cds-button-text\" type=\"button\">{{translations.browse}}</button>\n\t\t\t</ng-container>\n\t\t</span>\n\t</span>\n\t<div class=\"cds-upload__description\" [attr.id]=\"descriptionId\">\n\t\t<ng-content></ng-content>\n\t</div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                animations: [
                    trigger('animation', [
                        transition('void => true', [HIDDEN_STYLES, animate(200, VISIBLE_STYLES)]),
                        transition('true => void', [VISIBLE_STYLES, animate(200, HIDDEN_STYLES)]),
                    ]),
                ],
                providers: [
                    DynamicTranslations,
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: DynamicTranslations }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, { destroyOnRemove: [{
            type: Input
        }], uploadIcon: [{
            type: Input
        }], size: [{
            type: Input
        }], filesChange: [{
            type: Output
        }], filesAdd: [{
            type: Output
        }], filesRemove: [{
            type: Output
        }], onDragOver: [{
            type: HostListener,
            args: ['dragover', ['$event']]
        }, {
            type: HostListener,
            args: ['dragenter', ['$event']]
        }], onDrop: [{
            type: HostListener,
            args: ['dragleave', ['$event']]
        }, {
            type: HostListener,
            args: ['dragend', ['$event']]
        }, {
            type: HostListener,
            args: ['drop', ['$event']]
        }], isSmallSize: [{
            type: HostBinding,
            args: ['class.cds-upload--small']
        }], __disableDragAndDropSupport: [{
            type: Input
        }], multiple: [{
            type: Input
        }], accept: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], files: [{
            type: Input
        }], filesWrapper: [{
            type: ViewChild,
            args: ['filesWrapper']
        }], fileInfo: [{
            type: ContentChild,
            args: ['fileInfo', { read: TemplateRef }]
        }] }); })();
    return UploadComponent;
}());

var VISIBLE_STYLES$1 = style({
    height: '*',
});
var HIDDEN_STYLES$1 = style({
    height: 0,
});
var NO_OVERFLOW_STYLES = style({
    overflowY: 'hidden',
});
var VISIBLE_STYLES_FILE = style({
    overflowY: 'hidden',
    height: '*',
    paddingTop: '*',
    paddingBottom: '*',
});
var HIDDEN_STYLES_FILE = style({
    overflowY: 'hidden',
    height: '0',
    paddingTop: '0',
    paddingBottom: '0',
});
var ANIMATION_TIME = 200;
var ANIMATION_TIMING$1 = ANIMATION_TIME + "ms cubic-bezier(0.165, 0.84, 0.44, 1)";
var UploadToastComponent = /** @class */ (function () {
    function UploadToastComponent(elementRef, renderer, cdRef, componentTranslations, platform) {
        var _this = this;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.platform = platform;
        this.destroyOnRemove = true;
        this.filesChange = new EventEmitter();
        this.filesRemove = new EventEmitter();
        this.toastClose = new EventEmitter();
        this.isMinimized = false;
        this.withAnimation = false;
        this.filesSubject$ = new Subject();
        this.isScrollbarHidden = true;
        renderer.addClass(elementRef.nativeElement, 'cds-upload-toast');
        componentTranslations.use(CDS_UPLOAD_TRANSLATIONS, uploadTranslationsFactory, function (translations) {
            _this.translations = translations;
            _this.fileStates = {
                COMPLETED: translations.completed,
                ERROR: translations.error,
                IN_PROGRESS: translations.loading,
                PENDING: translations.pending,
            };
        });
        this.filesSubject$
            .asObservable()
            .pipe(switchMap(function (files) { return files ? merge.apply(void 0, __spread(files.map(function (file) { return file.status$; }))) : EMPTY$1; }))
            .subscribe(function () {
            cdRef.detectChanges();
        });
    }
    Object.defineProperty(UploadToastComponent.prototype, "minimized", {
        get: function () {
            return this.isMinimized;
        },
        enumerable: true,
        configurable: true
    });
    UploadToastComponent.prototype.ngAfterViewInit = function () {
        this.withAnimation = true;
        this.updateIsScrollbarHidden();
    };
    UploadToastComponent.prototype.ngOnChanges = function (changes) {
        if ('files' in changes) {
            this.updateIsScrollbarHidden();
            this.filesSubject$.next(this.files);
        }
    };
    UploadToastComponent.prototype.ngOnDestroy = function () {
        this.filesSubject$.complete();
    };
    UploadToastComponent.prototype.removeFile = function (file, index) {
        if (this.destroyOnRemove) {
            file.destroy();
        }
        if (this.files) {
            var newFilesList = this.files.filter(function (file, idx) { return idx !== index; });
            this.filesChange.emit(newFilesList);
        }
        this.filesRemove.emit([file]);
    };
    UploadToastComponent.prototype.minimizeToast = function () {
        this.isMinimized = !this.isMinimized;
    };
    UploadToastComponent.prototype.updateIsScrollbarHidden = function () {
        if (isPlatformBrowser(this.platform) && this.filesWrapper) {
            var _a = this.filesWrapper.nativeElement, clientHeight = _a.clientHeight, scrollHeight = _a.scrollHeight;
            this.isScrollbarHidden = scrollHeight <= clientHeight;
        }
    };
    UploadToastComponent.prototype.onAnimation = function (event, element) {
        if (isPlatformBrowser(this.platform)) {
            if (event.phaseName === 'start') {
                if (this.isScrollbarHidden) {
                    element.style.overflowY = 'hidden';
                }
            }
            else {
                // workaround for ie11
                element.style.overflowY = '';
                element.style.overflowY = null;
            }
        }
    };
    UploadToastComponent.prototype.closeToast = function () {
        this.toastClose.emit(null);
    };
    UploadToastComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: Renderer2 },
        { type: ChangeDetectorRef },
        { type: DynamicTranslations },
        { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], UploadToastComponent.prototype, "files", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UploadToastComponent.prototype, "ariaLabel", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UploadToastComponent.prototype, "title", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], UploadToastComponent.prototype, "destroyOnRemove", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], UploadToastComponent.prototype, "filesChange", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], UploadToastComponent.prototype, "filesRemove", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], UploadToastComponent.prototype, "toastClose", void 0);
    __decorate([
        ViewChild('filesWrapper'),
        __metadata("design:type", ElementRef)
    ], UploadToastComponent.prototype, "filesWrapper", void 0);
    __decorate([
        HostBinding('class.cds-upload-toast--minimized'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], UploadToastComponent.prototype, "minimized", null);
    UploadToastComponent = __decorate([ __param(4, Inject(PLATFORM_ID)),
        __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            ChangeDetectorRef,
            DynamicTranslations, Object])
    ], UploadToastComponent);
UploadToastComponent.ɵfac = function UploadToastComponent_Factory(t) { return new (t || UploadToastComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DynamicTranslations), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID)); };
UploadToastComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: UploadToastComponent, selectors: [["cds-upload-toast"]], viewQuery: function UploadToastComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c70, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.filesWrapper = _t.first);
    } }, hostVars: 2, hostBindings: function UploadToastComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("cds-upload-toast--minimized", ctx.minimized);
    } }, inputs: { destroyOnRemove: "destroyOnRemove", files: "files", ariaLabel: "ariaLabel", title: "title" }, outputs: { filesChange: "filesChange", filesRemove: "filesRemove", toastClose: "toastClose" }, features: [ɵngcc0.ɵɵProvidersFeature([
            DynamicTranslations,
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 19, vars: 10, consts: [[1, "cds-upload-toast__header"], ["cdsButton", "", 1, "cds-button-icon-dark", "cds-button-small", 3, "click"], [1, "cds-icon-angle-down"], [1, "cds-icon-size-24", "cds-icon-close-big"], [1, "cds-upload-toast__content"], ["filesWrapper", ""], ["role", "table"], ["role", "row", 1, "cds-sr-only"], ["role", "columnheader"], ["class", "cds-upload-toast__file", "role", "row", 3, "cds-upload-toast__file--completed", "cds-upload-toast__file--error", 4, "ngFor", "ngForOf"], ["role", "row", 1, "cds-upload-toast__file"], ["role", "cell", 1, "cds-upload-toast__file-name"], ["role", "none", 1, "cds-upload-toast__file-info"], ["role", "cell", 1, "cds-upload-toast__file-status"], ["aria-hidden", "true"], [3, "ngSwitch"], [3, "progress", 4, "ngSwitchCase"], ["class", "cds-icon--size-32 cds-icon-tick-circle", "role", "progressbar", "aria-valuenow", "100", "aria-valuemax", "100", "aria-valuemin", "0", 4, "ngSwitchCase"], ["class", "cds-icon--size-32 cds-icon-exclamation-circle", 4, "ngSwitchCase"], ["role", "cell", 1, "cds-upload-toast__file-actions"], ["cdsButton", "", "type", "button", 1, "cds-button-icon", "cds-button-small", 3, "click"], [1, "cds-icon--size-24", "cds-icon-close-big"], [3, "progress"], ["role", "progressbar", "aria-valuenow", "100", "aria-valuemax", "100", "aria-valuemin", "0", 1, "cds-icon--size-32", "cds-icon-tick-circle"], [1, "cds-icon--size-32", "cds-icon-exclamation-circle"]], template: function UploadToastComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "span");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "span");
        ɵngcc0.ɵɵelementStart(4, "button", 1);
        ɵngcc0.ɵɵlistener("click", function UploadToastComponent_Template_button_click_4_listener() { return ctx.minimizeToast(); });
        ɵngcc0.ɵɵelement(5, "i", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "button", 1);
        ɵngcc0.ɵɵlistener("click", function UploadToastComponent_Template_button_click_6_listener() { return ctx.closeToast(); });
        ɵngcc0.ɵɵelement(7, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 4, 5);
        ɵngcc0.ɵɵelementStart(10, "ul", 6);
        ɵngcc0.ɵɵelementStart(11, "li", 7);
        ɵngcc0.ɵɵelementStart(12, "span", 8);
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "span", 8);
        ɵngcc0.ɵɵtext(15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "span", 8);
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(18, UploadToastComponent_li_18_Template, 15, 13, "li", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("aria-label", ctx.isMinimized ? ctx.translations.minimize : ctx.translations.maximize)("aria-expanded", ctx.isMinimized ? "false" : "true");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("aria-label", ctx.translations.close);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("@animation", !ctx.isMinimized || !ctx.withAnimation ? "maximized" : "minimized");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("aria-label", ctx.ariaLabel);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.translations.srFileName);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.translations.srUploadStatus);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.translations.srActions);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.files);
    } }, directives: [ButtonRippleDirective, ɵngcc1.NgForOf, ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, ProgressSpinnerComponent], encapsulation: 2, data: { animation: [
            trigger('animation', [
                state('minimized', HIDDEN_STYLES$1),
                state('maximized', VISIBLE_STYLES$1),
                /* On enter set animation as @animation time + @animationFile time to avoid showing scrollbar */
                transition('void => *', animate(2 * ANIMATION_TIME, keyframes([NO_OVERFLOW_STYLES, NO_OVERFLOW_STYLES]))),
                transition('minimized => maximized', group([
                    animate(ANIMATION_TIMING$1, VISIBLE_STYLES$1),
                    animate(ANIMATION_TIMING$1, keyframes([NO_OVERFLOW_STYLES, NO_OVERFLOW_STYLES])),
                ])),
                transition('maximized => minimized', group([
                    animate(ANIMATION_TIMING$1, HIDDEN_STYLES$1),
                    animate(ANIMATION_TIMING$1, keyframes([NO_OVERFLOW_STYLES, NO_OVERFLOW_STYLES])),
                ])),
            ]),
            trigger('animationFile', [
                transition('void => true', [HIDDEN_STYLES_FILE, animate(ANIMATION_TIME, VISIBLE_STYLES_FILE)]),
                transition('true => void', [VISIBLE_STYLES_FILE, animate(ANIMATION_TIME, HIDDEN_STYLES_FILE)]),
            ]),
        ] }, changeDetection: 0 });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UploadToastComponent, [{
        type: Component,
        args: [{
                selector: 'cds-upload-toast',
                template: "<div class=\"cds-upload-toast__header\">\n    <span>{{title}}</span>\n    <span>\n        <button cdsButton class=\"cds-button-icon-dark cds-button-small\" (click)=\"minimizeToast()\" [attr.aria-label]=\"isMinimized ? translations.minimize : translations.maximize\" [attr.aria-expanded]=\"isMinimized ? 'false' : 'true'\"><i class=\"cds-icon-angle-down\"></i></button>\n        <button cdsButton class=\"cds-button-icon-dark cds-button-small\" (click)=\"closeToast()\" [attr.aria-label]=\"translations.close\"><i class=\"cds-icon-size-24 cds-icon-close-big\"></i></button>\n    </span>\n</div>\n\n<div class=\"cds-upload-toast__content\" #filesWrapper [@animation]=\"!isMinimized || !withAnimation ? 'maximized' : 'minimized'\">\n    <ul [attr.aria-label]=\"ariaLabel\" role=\"table\">\n        <li role=\"row\" class=\"cds-sr-only\">\n            <span role=\"columnheader\">{{translations.srFileName}}</span>\n            <span role=\"columnheader\">{{translations.srUploadStatus}}</span>\n            <span role=\"columnheader\">{{translations.srActions}}</span>\n        </li>\n        <li *ngFor=\"let file of files; let index=index\"\n            [@animationFile]=\"withAnimation\"\n            (@animationFile.start)=\"onAnimation($event, filesWrapper)\"\n            (@animationFile.done)=\"onAnimation($event, filesWrapper)\"\n            class=\"cds-upload-toast__file\"\n            [class.cds-upload-toast__file--completed]=\"file.status.state === 'COMPLETED'\"\n            [class.cds-upload-toast__file--error]=\"file.status.state === 'ERROR'\"\n            role=\"row\">\n            <span role=\"cell\" class=\"cds-upload-toast__file-name\">{{file.file.name}}</span>\n            <span role=\"none\" class=\"cds-upload-toast__file-info\">\n                <span class=\"cds-upload-toast__file-status\" role=\"cell\">\n                    <span aria-hidden=\"true\">{{file.status.state === 'ERROR' && $any(file.status).message ? $any(file.status).message : fileStates[file.status.state]}}</span>\n                    <ng-container [ngSwitch]=\"file.status.state\">\n                        <cds-progress-spinner *ngSwitchCase=\"'IN_PROGRESS'\" [progress]=\"$any(file.status).progress\"></cds-progress-spinner>\n                        <cds-progress-spinner *ngSwitchCase=\"'PENDING'\" [progress]=\"0\" [attr.aria-label]=\"fileStates[file.status.state]\"></cds-progress-spinner>\n                        <i *ngSwitchCase=\"'COMPLETED'\" class=\"cds-icon--size-32 cds-icon-tick-circle\" [attr.aria-label]=\"fileStates[file.status.state]\" role=\"progressbar\" aria-valuenow=\"100\" aria-valuemax=\"100\" aria-valuemin=\"0\" ></i>\n                        <i *ngSwitchCase=\"'ERROR'\" class=\"cds-icon--size-32 cds-icon-exclamation-circle\" [attr.aria-label]=\"$any(file.status).message ? $any(file.status).message : fileStates[file.status.state]\"></i>\n                    </ng-container>\n                </span>\n                <span class=\"cds-upload-toast__file-actions\" role=\"cell\">\n                    <button (click)=\"removeFile(file, index)\" cdsButton class=\"cds-button-icon cds-button-small\" type=\"button\" [attr.aria-label]=\"translations.remove\">\n                        <i class=\"cds-icon--size-24 cds-icon-close-big\"></i>\n                    </button>\n                </span>\n            </span>\n        </li>\n    </ul>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                animations: [
                    trigger('animation', [
                        state('minimized', HIDDEN_STYLES$1),
                        state('maximized', VISIBLE_STYLES$1),
                        /* On enter set animation as @animation time + @animationFile time to avoid showing scrollbar */
                        transition('void => *', animate(2 * ANIMATION_TIME, keyframes([NO_OVERFLOW_STYLES, NO_OVERFLOW_STYLES]))),
                        transition('minimized => maximized', group([
                            animate(ANIMATION_TIMING$1, VISIBLE_STYLES$1),
                            animate(ANIMATION_TIMING$1, keyframes([NO_OVERFLOW_STYLES, NO_OVERFLOW_STYLES])),
                        ])),
                        transition('maximized => minimized', group([
                            animate(ANIMATION_TIMING$1, HIDDEN_STYLES$1),
                            animate(ANIMATION_TIMING$1, keyframes([NO_OVERFLOW_STYLES, NO_OVERFLOW_STYLES])),
                        ])),
                    ]),
                    trigger('animationFile', [
                        transition('void => true', [HIDDEN_STYLES_FILE, animate(ANIMATION_TIME, VISIBLE_STYLES_FILE)]),
                        transition('true => void', [VISIBLE_STYLES_FILE, animate(ANIMATION_TIME, HIDDEN_STYLES_FILE)]),
                    ]),
                ],
                providers: [
                    DynamicTranslations,
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: DynamicTranslations }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, { destroyOnRemove: [{
            type: Input
        }], filesChange: [{
            type: Output
        }], filesRemove: [{
            type: Output
        }], toastClose: [{
            type: Output
        }], minimized: [{
            type: HostBinding,
            args: ['class.cds-upload-toast--minimized']
        }], files: [{
            type: Input
        }], ariaLabel: [{
            type: Input
        }], title: [{
            type: Input
        }], filesWrapper: [{
            type: ViewChild,
            args: ['filesWrapper']
        }] }); })();
    return UploadToastComponent;
}());

var UploadModule = /** @class */ (function () {
    function UploadModule() {
    }
UploadModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: UploadModule });
UploadModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function UploadModule_Factory(t) { return new (t || UploadModule)(); }, providers: [], imports: [[ButtonModule, CommonModule, IndicatorModule, ToastModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UploadModule, { declarations: function () { return [UploadComponent, UploadToastComponent]; }, imports: function () { return [ButtonModule, CommonModule, IndicatorModule, ToastModule]; }, exports: function () { return [UploadComponent, UploadToastComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UploadModule, [{
        type: NgModule,
        args: [{
                imports: [ButtonModule, CommonModule, IndicatorModule, ToastModule],
                exports: [UploadComponent, UploadToastComponent],
                declarations: [UploadComponent, UploadToastComponent],
                providers: []
            }]
    }], function () { return []; }, null); })();
    return UploadModule;
}());

var MODULES = [
    BadgeModule,
    BreadcrumbsModule,
    ButtonModule,
    CalendarModule,
    CheckboxModule,
    ChipModule,
    ComboModule,
    DateTimeModule,
    DialogModule,
    DisabledModule,
    DropdownModule,
    ErrorsModule,
    HeaderModule,
    IndicatorModule,
    InputModule,
    LayoutModule,
    ListModule,
    NavModule,
    NotificationModule,
    OnEscapeModule,
    PagerModule,
    PopoverModule,
    PortalModule,
    RadioModule,
    RippleModule,
    SidenavModule,
    SpinnerModule,
    StepperModule,
    SwitchModule,
    TabModule,
    TextareaModule,
    TimePickerModule,
    ToastModule,
    ToggleModule,
    TooltipModule,
    UploadModule,
    ValidationModule,
];
var ComponentsModule = /** @class */ (function () {
    function ComponentsModule() {
    }
ComponentsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ComponentsModule });
ComponentsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function ComponentsModule_Factory(t) { return new (t || ComponentsModule)(); }, imports: [MODULES, BadgeModule, BreadcrumbsModule, ButtonModule, CalendarModule, CheckboxModule, ChipModule, ComboModule, DateTimeModule, DialogModule, DisabledModule, DropdownModule, ErrorsModule, HeaderModule, IndicatorModule, InputModule, LayoutModule, ListModule, NavModule, NotificationModule, OnEscapeModule, PagerModule, PopoverModule, PortalModule, RadioModule, RippleModule, SidenavModule, SpinnerModule, StepperModule, SwitchModule, TabModule, TextareaModule, TimePickerModule, ToastModule, ToggleModule, TooltipModule, UploadModule, ValidationModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ComponentsModule, { imports: [BadgeModule, BreadcrumbsModule, ButtonModule, CalendarModule, CheckboxModule, ChipModule, ComboModule, DateTimeModule, DialogModule, DisabledModule, DropdownModule, ErrorsModule, HeaderModule, IndicatorModule, InputModule, LayoutModule, ListModule, NavModule, NotificationModule, OnEscapeModule, PagerModule, PopoverModule, PortalModule, RadioModule, RippleModule, SidenavModule, SpinnerModule, StepperModule, SwitchModule, TabModule, TextareaModule, TimePickerModule, ToastModule, ToggleModule, TooltipModule, UploadModule, ValidationModule], exports: [BadgeModule, BreadcrumbsModule, ButtonModule, CalendarModule, CheckboxModule, ChipModule, ComboModule, DateTimeModule, DialogModule, DisabledModule, DropdownModule, ErrorsModule, HeaderModule, IndicatorModule, InputModule, LayoutModule, ListModule, NavModule, NotificationModule, OnEscapeModule, PagerModule, PopoverModule, PortalModule, RadioModule, RippleModule, SidenavModule, SpinnerModule, StepperModule, SwitchModule, TabModule, TextareaModule, TimePickerModule, ToastModule, ToggleModule, TooltipModule, UploadModule, ValidationModule] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ComponentsModule, [{
        type: NgModule,
        args: [{
                imports: MODULES,
                exports: MODULES
            }]
    }], function () { return []; }, null); })();
    return ComponentsModule;
}());

var CDS_DIALOG_TRANSITIONS = [
    transition(':leave', query('cds-dialog', animateChild())),
];

var FocusTrapModule = /** @class */ (function () {
    function FocusTrapModule() {
    }
    FocusTrapModule_1 = FocusTrapModule;
    FocusTrapModule.forRoot = function (focusTrapFn) {
        return {
            ngModule: FocusTrapModule_1,
            providers: [
                { provide: CDS_FOCUS_TRAP, useValue: focusTrapFn },
            ],
        };
    };
    var FocusTrapModule_1;
FocusTrapModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: FocusTrapModule });
FocusTrapModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function FocusTrapModule_Factory(t) { return new (t || FocusTrapModule)(); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FocusTrapModule, [{
        type: NgModule,
        args: [{}]
    }], function () { return []; }, null); })();
    return FocusTrapModule;
}());

var MAX_TOASTS = 3;
var ToastMode;
(function (ToastMode) {
    ToastMode["SIMPLE"] = "TOAST";
    ToastMode["UPLOAD"] = "UPLOAD";
})(ToastMode || (ToastMode = {}));
var ToastContainer = /** @class */ (function () {
    function ToastContainer(position, body, appRef, zone, injector, wrapperFactory) {
        this.position = position;
        this.body = body;
        this.appRef = appRef;
        this.zone = zone;
        this.injector = injector;
        this.wrapperFactory = wrapperFactory;
        this.pending = new Set();
    }
    ToastContainer.prototype.add = function (toast, mode) {
        var pending = this.pending;
        var state = {
            toast: toast,
            destroy: function (error) {
                if (pending.has(this)) {
                    pending.delete(this);
                }
            },
        };
        if ((mode === ToastMode.UPLOAD && !this.hasToastInMode(mode)) || (this.getContainerElement(mode).childNodes.length < MAX_TOASTS && mode === ToastMode.SIMPLE)) {
            this.createToast(state, mode);
        }
        else if (mode === ToastMode.SIMPLE) {
            this.pending.add(state);
        }
        return state;
    };
    ToastContainer.prototype.hasToastInMode = function (mode) {
        return this.getContainerElement(mode).childNodes.length > 0;
    };
    ToastContainer.prototype.createToast = function (state, mode) {
        var _this = this;
        var toast = state.toast;
        try {
            var componentRef_1 = this.wrapperFactory.create(this.injector);
            var viewRef = componentRef_1.instance.container.createEmbeddedView(toast.templateRef, __assign(__assign({}, toast.context), { $implicit: {
                    resolve: function (value) {
                        componentRef_1.destroy();
                        toast.resolve(value);
                    },
                    reject: function (error) {
                        componentRef_1.destroy();
                        toast.reject(error);
                    },
                } }));
            this.appRef.attachView(componentRef_1.hostView);
            componentRef_1.onDestroy(function () {
                if (_this.pending.size && mode === ToastMode.SIMPLE) {
                    var it = _this.pending.values();
                    var state_1 = it.next().value;
                    _this.pending.delete(state_1);
                    _this.createToast(state_1, mode);
                }
            });
            state.destroy = function () {
                componentRef_1.destroy();
            };
            var mainContainer = this.attachMainContainerElement();
            var container = this.attachContainerElement(mode);
            this.setupTimeout(componentRef_1, toast.config.duration, function () {
                componentRef_1.destroy();
                toast.reject();
            });
            container.appendChild(componentRef_1.location.nativeElement);
            mainContainer.appendChild(container);
        }
        catch (e) {
            console.error(e);
        }
    };
    ToastContainer.prototype.attachMainContainerElement = function () {
        var _this = this;
        var mainContainer = this.getMainContainerElement();
        if (!mainContainer.parentElement) {
            this.body.appendChild(mainContainer);
            var removeContainer_1 = function () {
                if (mainContainer.childNodes.length === 0) {
                    if (mainContainer.remove) {
                        mainContainer.remove();
                    }
                    else {
                        mainContainer.parentNode.removeChild(mainContainer);
                    }
                    return true;
                }
                return false;
            };
            this.zone.runOutsideAngular(function () {
                var observer = new MutationObserver(function (mutationsList, observer) {
                    var e_1, _a;
                    try {
                        for (var mutationsList_1 = __values(mutationsList), mutationsList_1_1 = mutationsList_1.next(); !mutationsList_1_1.done; mutationsList_1_1 = mutationsList_1.next()) {
                            var mutation = mutationsList_1_1.value;
                            if (mutation.type == 'childList') {
                                if (!_this.pending.size) {
                                    if (removeContainer_1()) {
                                        observer.disconnect();
                                    }
                                }
                                return;
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (mutationsList_1_1 && !mutationsList_1_1.done && (_a = mutationsList_1.return)) _a.call(mutationsList_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                });
                observer.observe(mainContainer, { childList: true });
            });
        }
        return mainContainer;
    };
    ToastContainer.prototype.attachContainerElement = function (mode) {
        var _this = this;
        var container = this.getContainerElement(mode);
        var mainContainer = this.getMainContainerElement();
        if (!container.parentElement) {
            mainContainer.appendChild(container);
            var removeContainer_2 = function () {
                if (container.childNodes.length === 0) {
                    if (container.remove) {
                        container.remove();
                    }
                    else {
                        container.parentNode.removeChild(container);
                    }
                    return true;
                }
                return false;
            };
            this.zone.runOutsideAngular(function () {
                var observer = new MutationObserver(function (mutationsList, observer) {
                    var e_2, _a;
                    try {
                        for (var mutationsList_2 = __values(mutationsList), mutationsList_2_1 = mutationsList_2.next(); !mutationsList_2_1.done; mutationsList_2_1 = mutationsList_2.next()) {
                            var mutation = mutationsList_2_1.value;
                            if (mutation.type == 'childList') {
                                if (!_this.pending.size) {
                                    if (removeContainer_2()) {
                                        observer.disconnect();
                                    }
                                }
                                return;
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (mutationsList_2_1 && !mutationsList_2_1.done && (_a = mutationsList_2.return)) _a.call(mutationsList_2);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                });
                observer.observe(container, { childList: true });
            });
        }
        return container;
    };
    ToastContainer.prototype.setupTimeout = function (componentRef, duration, callback) {
        if (duration > 0 && callback) {
            var timeout_1;
            var makeTimeout_1 = function () {
                timeout_1 = setTimeout(callback, duration);
            };
            var nativeElement = componentRef.location.nativeElement;
            nativeElement.addEventListener('mouseover', function () {
                clearTimeout(timeout_1);
            });
            nativeElement.addEventListener('mouseout', function () {
                makeTimeout_1();
            });
            makeTimeout_1();
        }
    };
    ToastContainer.prototype.getContainerElement = function (mode) {
        var element = this._containerToastsElement;
        var elementUpload = this._containerUploadElement;
        if (!element && mode === ToastMode.SIMPLE) {
            element = document.createElement('div');
            element.classList.add('cds-toast-container__toasts');
            element.classList.add('cds-toast-z-index');
            this._containerToastsElement = element;
        }
        else if (!elementUpload && mode === ToastMode.UPLOAD) {
            elementUpload = document.createElement('div');
            elementUpload.classList.add('cds-toast-container__upload');
            elementUpload.classList.add('cds-toast-z-index');
            this._containerUploadElement = elementUpload;
        }
        return mode === ToastMode.UPLOAD ? elementUpload : element;
    };
    ToastContainer.prototype.getMainContainerElement = function () {
        var element = this._containerElement;
        if (!element) {
            element = document.createElement('div');
            element.classList.add('cds-toast-container');
            element.classList.add("cds-toast-container--" + this.position);
            element.classList.add('cds-toast-z-index');
            this._containerElement = element;
        }
        return element;
    };
    return ToastContainer;
}());

var ToastContainerService = /** @class */ (function () {
    function ToastContainerService(appRef, zone, injector) {
        this.appRef = appRef;
        this.zone = zone;
        this.injector = injector;
        this.containers = {};
    }
    ToastContainerService.prototype.getContainer = function (position, cfResolver) {
        var container = this.containers[position];
        if (!container) {
            var wrapperFactory = cfResolver.resolveComponentFactory(ToastWrapperComponent);
            container = new ToastContainer(position, document.body, this.appRef, this.zone, this.injector, wrapperFactory);
            this.containers[position] = container;
        }
        return container;
    };
    ToastContainerService.ctorParameters = function () { return [
        { type: ApplicationRef },
        { type: NgZone },
        { type: Injector }
    ]; };
    ToastContainerService.ɵprov = ɵɵdefineInjectable({ factory: function ToastContainerService_Factory() { return new ToastContainerService(ɵɵinject(ApplicationRef), ɵɵinject(NgZone), ɵɵinject(INJECTOR)); }, token: ToastContainerService, providedIn: "root" });
    ToastContainerService = __decorate([ __metadata("design:paramtypes", [ApplicationRef,
            NgZone,
            Injector])
    ], ToastContainerService);
ToastContainerService.ɵfac = function ToastContainerService_Factory(t) { return new (t || ToastContainerService)(ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(ɵngcc0.NgZone), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ToastContainerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.ApplicationRef }, { type: ɵngcc0.NgZone }, { type: ɵngcc0.Injector }]; }, null); })();
    return ToastContainerService;
}());

var defaultToastConfig = {
    position: 'bottom-right',
    duration: 3000,
};
var ToastService = /** @class */ (function () {
    function ToastService(cfResolver, container) {
        this.cfResolver = cfResolver;
        this.container = container;
        this.states = new WeakMap();
        this.mode = ToastMode.SIMPLE;
    }
    ToastService.prototype.open = function (templateRef, config, context) {
        var _this = this;
        if (config === void 0) { config = {}; }
        var resolvedConfig = __assign(__assign({}, defaultToastConfig), config);
        var container = this.container.getContainer(resolvedConfig.position, this.cfResolver);
        var state;
        var toastPromise = new Promise(function (resolve, reject) {
            var toast = {
                templateRef: templateRef,
                config: resolvedConfig,
                context: context,
                resolve: resolve,
                reject: reject,
            };
            state = container.add(toast, _this.mode);
        });
        this.states.set(toastPromise, state);
        return toastPromise;
    };
    ToastService.prototype.getInstance = function (toastPromise) {
        var _this = this;
        var state = this.states.get(toastPromise);
        if (state) {
            return {
                resolve: function (value) {
                    state.destroy();
                    _this.states.delete(toastPromise);
                    state.toast.resolve(value);
                },
                reject: function (error) {
                    state.destroy();
                    _this.states.delete(toastPromise);
                    state.toast.reject(error);
                },
            };
        }
    };
    ToastService.ctorParameters = function () { return [
        { type: ComponentFactoryResolver },
        { type: ToastContainerService }
    ]; };
    ToastService.ɵprov = ɵɵdefineInjectable({ factory: function ToastService_Factory() { return new ToastService(ɵɵinject(ComponentFactoryResolver), ɵɵinject(ToastContainerService)); }, token: ToastService, providedIn: ToastModule });
    ToastService = __decorate([ __metadata("design:paramtypes", [ComponentFactoryResolver,
            ToastContainerService])
    ], ToastService);
ToastService.ɵfac = function ToastService_Factory(t) { return new (t || ToastService)(ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ToastContainerService)); };
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ToastService, [{
        type: Injectable,
        args: [{
                providedIn: ToastModule
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ToastContainerService }]; }, null); })();
    return ToastService;
}());

var defaultToastConfig$1 = {
    position: 'bottom-right',
    duration: 0,
};
var UploadToastService = /** @class */ (function (_super) {
    __extends(UploadToastService, _super);
    function UploadToastService(cfResolver, container) {
        var _this = _super.call(this, cfResolver, container) || this;
        _this.mode = ToastMode.UPLOAD;
        return _this;
    }
    UploadToastService.prototype.open = function (templateRef, config, context) {
        if (config === void 0) { config = {}; }
        var resolvedConfig = __assign(__assign({}, defaultToastConfig$1), config);
        var container = this.container.getContainer(resolvedConfig.position, this.cfResolver);
        if (container.hasToastInMode(this.mode)) {
            throw new Error('Cannot open multiple upload toast component');
        }
        return _super.prototype.open.call(this, templateRef, resolvedConfig, context);
    };
    UploadToastService.ctorParameters = function () { return [
        { type: ComponentFactoryResolver },
        { type: ToastContainerService }
    ]; };
    UploadToastService.ɵprov = ɵɵdefineInjectable({ factory: function UploadToastService_Factory() { return new UploadToastService(ɵɵinject(ComponentFactoryResolver), ɵɵinject(ToastContainerService)); }, token: UploadToastService, providedIn: UploadModule });
    UploadToastService = __decorate([ __metadata("design:paramtypes", [ComponentFactoryResolver,
            ToastContainerService])
    ], UploadToastService);
UploadToastService.ɵfac = function UploadToastService_Factory(t) { return new (t || UploadToastService)(ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ToastContainerService)); };
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UploadToastService, [{
        type: Injectable,
        args: [{
                providedIn: UploadModule
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ToastContainerService }]; }, null); })();
    return UploadToastService;
}(ToastService));

/*
 * Public API Surface of components
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ABSTRACT_TOGGLE_COMPONENT_HOST, ABSTRACT_TOGGLE_COMPONENT_INPUTS, AUTO_GRID_PROVIDER, AbstractCombo, AbstractToggleComponent, AppLayoutComponent, AutoGridSidenavDirective, BadgeDirective, BadgeModule, BreadcrumbDirective, BreadcrumbsComponent, BreadcrumbsModule, ButtonModule, ButtonRippleDirective, CDS_BREADCRUMBS_TRANSLATIONS, CDS_CALENDAR_TRANSLATIONS, CDS_COMBO_TRANSLATIONS, CDS_DATE_TIME_NOW, CDS_DATE_TIME_TRANSLATIONS, CDS_DEVICE_BREAKPOINTS, CDS_DIALOG_CONTEXT, CDS_DIALOG_INSTANCE, CDS_DIALOG_TRANSITIONS, CDS_DIALOG_TRANSLATIONS, CDS_DROPDOWN_CONFIG, CDS_DROPDOWN_POPPER_OPTIONS_FACTORY, CDS_ERRORS_TRANSLATIONS, CDS_FOCUS_TRAP, CDS_HEADER_TRANSLATIONS, CDS_INPUT_MODEL_TRANSFORMER, CDS_LIST_DEFAULT_OPTIONS, CDS_NOTIFICATION_TRANSLATIONS, CDS_PAGER_TRANSLATIONS, CDS_SIDENAV_TRANSLATIONS, CDS_STEPPER_TRANSLATIONS, CDS_TIME_PICKER_TRANSLATIONS, CDS_TOAST_TRANSLATIONS, CDS_UPLOAD_TRANSLATIONS, COMBO_ITEM_ALL_HOST, COMBO_ITEM_HOST, CalendarComponent, CalendarModule, CheckboxComponent, CheckboxModule, ChipComponent, ChipModule, ChipRippleDirective, ComboButtonComponent, ComboCheckboxItemAllComponent, ComboCheckboxItemComponent, ComboComponent, ComboItemAllComponent, ComboItemDirective, ComboItemModalDirective, ComboModule, ComboMultiComponent, ComboMultiSelectedLabelComponent, ComboSearchDirective, ComboSearchHighlightDirective, ComboSearchMatchAnyPipe, ComboSearchMatchPipe, ComponentsModule, DateControlComponent, DateDialogComponent, DateFormComponent, DateInputDirective, DateRangeControlComponent, DateRangeDialogComponent, DateRangeFormComponent, DateRangeInputDirective, DateTimeConstraints, DateTimeConstraintsOptions, DateTimeModule, DateTimeParser, DateTimeService, DateTimeValidatorService, DialogComponent, DialogModule, DialogService, DisabledDirective, DisabledModule, DropdownComponent, DropdownDirective, DropdownDisableKeydownDirective, DropdownModule, DropdownService, EqualDirective, ErrorDirective, ErrorInterpolatePipe, ErrorsComponent, ErrorsDirective, ErrorsModule, FocusTrapModule, HeaderComponent, HeaderModule, INVALID_VALIDATOR, IndicatorModule, InputComponent, InputModule, InvalidDirective, LayoutModule, LengthDirective, ListColumnComponent, ListComponent, ListExpandDirective, ListExpandableDirective, ListModule, ListRowDirective, ListRowExpandComponent, ListSortByDirective, ListToolbarComponent, MatchMediaService, NavContext, NavItemComponent, NavModule, NotEqualDirective, NotificationComponent, NotificationModule, OnEscapeDirective, OnEscapeModule, OnEscapeService, PagerComponent, PagerModule, PopoverComponent, PopoverModule, PopoverToolbarComponent, ProgressBarComponent, ProgressSpinnerComponent, RadioComponent, RadioModule, RippleDirective, RippleModule, RippleService, SelectedLabelModelImpl, SidenavComponent, SidenavModule, SpinnerComponent, SpinnerModule, SpinnerWrapperComponent, StatusIndicatorDirective, StepperComponent, StepperModule, SwitchComponent, SwitchModule, TabComponent, TabListComponent, TabModule, TextareaComponent, TextareaModule, TimeControlComponent, TimeDialogComponent, TimeFormComponent, TimePickerColumnDirective, TimePickerComponent, TimePickerModule, TimePickerPipe, TimezoneControlComponent, TimezoneDirective, TimezonesService, ToastComponent, ToastModule, ToastService, ToastWrapperComponent, ToggleGroupDirective, ToggleLinkDirective, ToggleModule, TooltipClickDirective, TooltipComponent, TooltipFocusDirective, TooltipHoverDirective, TooltipModule, TrendIndicatorComponent, UniqueDirective, UploadComponent, UploadFile, UploadModule, UploadToastComponent, UploadToastService, ValidationModule, ValidatorFnDirective, autoGridFactory, breadcrumbsTranslationsFactory, calendarTranslationsFactory, comboTranslationsFactory, dateTimeNowFactory, dateTimeTranslationsFactory, defaultDropdownPopperOptionsFactory, deviceBreakpointsFactory, dialogTranslationsFactory, dropdownAnimation, errorsTranslationsFactory, getDefaultDate, headerTranslationsFactory, listDefaultOptions, notificationTranslationsFactory, pagerTranslationsFactory, sidenavTranslationsFactory, stepperTranslationsFactory, timePickerTranslationsFactory, toastTranslationsFactory, uploadTranslationsFactory, DynamicTranslations as ɵa, PortalModule as ɵb, DateDropdownComponent as ɵba, DateKeyboardNavigationDirective as ɵbb, DateRangeDropdownComponent as ɵbc, DateRangeAbstractControlComponent as ɵbd, TimeService as ɵbe, TimeControlDisplayHourPipe as ɵbf, TimeControlListPipe as ɵbg, TimeAbstractControlComponent as ɵbh, TimeDropdownComponent as ɵbi, NavOverlayComponent as ɵbj, DeviceAwareComponent as ɵbk, AUTO_GRID_SIDENAV_ELEMENT as ɵbl, NAV_COLUMN_ANIMATIONS as ɵbm, ReverseElementsPipe as ɵbn, GeneratePagesPipe as ɵbo, PagerHiddenDirective as ɵbp, PagerInterpolatePipe as ɵbq, PagerSizesPipe as ɵbr, PopoverToggleDirective as ɵbs, RadioGroupDirective as ɵbt, AbstractFocusGroupDirective as ɵbu, CDS_SIDENAV_EXPANDED_TEMPLATE as ɵbv, SidenavExpandedComponent as ɵbw, StepperFillWidthPipe as ɵbx, StepperLineWidthPipe as ɵby, PortalComponent as ɵc, CDS_TAB_LIST_HOST as ɵca, AutogrowModule as ɵcb, AutogrowDirective as ɵcc, ResizeModule as ɵcd, ResizeDirective as ɵce, ToastContainerService as ɵcf, DROPDOWN_EXPAND_HOST as ɵd, DropdownExpandableDirective as ɵe, BreadcrumbObserveDirective as ɵf, ButtonGroupComponent as ɵg, BaseDateTimeComponent as ɵh, BaseTimeComponent as ɵi, CalendarRangeComponent as ɵj, AccessibilityModule as ɵk, AriaControlSkipSelfDirective as ɵl, A11yClickDirective as ɵm, ViewRefDirective as ɵn, SlotsModule as ɵo, SlotsDirective as ɵp, TooltipDirective as ɵq, TooltipService as ɵr, TimePickerDisplayHourPipe as ɵs, AdjustTimeConstraintsPipe as ɵt, rootPortalServiceStateFactory as ɵu, ROOT_PORTAL_SERVICE_STATE as ɵv, RootPortalService as ɵw, PortalServiceState as ɵx, BasePortalService as ɵy, DateAbstractControlComponent as ɵz };

//# sourceMappingURL=cds-components-angular.js.map